/* eslint-disable */
import { gql } from '@apollo/client/core';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: Date | number | string;
  JSON: { [key: string]: any };
};

export type Abbreviated = {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type AcceptOutOfServiceTicket = {
  alternatePOC: InputMaybe<Scalars['String']>;
  assignedBaseId: InputMaybe<Scalars['ID']>;
  businessUnitCompanyId: InputMaybe<Scalars['ID']>;
  ertsDateTime: Scalars['DateTime'];
  humanErrorDamageType: InputMaybe<HumanErrorDamageType>;
  id: Scalars['ID'];
  isAMTAvailable: InputMaybe<Scalars['Boolean']>;
  isBirdStrike: Scalars['Boolean'];
  isFAR135415Reportable: InputMaybe<Scalars['Boolean']>;
  isFAR135417Reportable: InputMaybe<Scalars['Boolean']>;
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  isPatientOnboard: Scalars['Boolean'];
  isPlanned: Scalars['Boolean'];
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  maintenanceLocation: InputMaybe<Scalars['String']>;
  maintenanceTypes: Array<OosTicketMaintenanceType>;
  mxDuringPeakTimeReason: InputMaybe<Scalars['String']>;
  opportunityMXTypes: InputMaybe<Array<InputMaybe<OpportunityMXType>>>;
  outOfServiceTime: Scalars['DateTime'];
  outOfServiceType: InputMaybe<OutOfServiceType>;
  pointOfContactId: InputMaybe<Scalars['ID']>;
  primaryReasonId: InputMaybe<Scalars['ID']>;
  qarReasons: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  rtsDelayReasonTypes: InputMaybe<Array<InputMaybe<RtsDelayReasonType>>>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  spareVehicleId: InputMaybe<Scalars['ID']>;
  ticketDescription: Scalars['String'];
  vehicleId: Scalars['ID'];
  waitingForParts: Scalars['Boolean'];
  waitingForTooling: Scalars['Boolean'];
};

export type AcceptReceivingFacilityRequest = {
  id: Scalars['ID'];
  medicalFacilityUnitId: InputMaybe<Scalars['ID']>;
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  physicianId: InputMaybe<Scalars['ID']>;
  roomNumber: InputMaybe<Scalars['String']>;
  time: Scalars['DateTime'];
};

export type AcceptTransportOffer = {
  id: Scalars['ID'];
  manifestConfirmed: InputMaybe<Scalars['Boolean']>;
};

export enum AccessControlAction {
  Allow = 'Allow',
  Deny = 'Deny',
}

export type AccessibleItem = Entity &
  Evented & {
    __typename: 'AccessibleItem';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Scalars['ID'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    person: Person;
    personId: Scalars['ID'];
    type: EntityType;
    userRoles: Maybe<Array<Maybe<UserRole>>>;
  };

export type AccessibleItem_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AccessibleItemCollection = {
  __typename: 'AccessibleItemCollection';
  items: Array<AccessibleItem>;
  meta: AccessibleItemCollectionMetadata;
};

export type AccessibleItemCollectionMetadata = CollectionMetadata & {
  __typename: 'AccessibleItemCollectionMetadata';
  total: Scalars['Int'];
};

export type AcknowledgeAlert = {
  acknowledgedById: InputMaybe<Scalars['ID']>;
  activeAlertId: Scalars['ID'];
};

export type AcknowledgeExternalRequest = {
  id: Scalars['ID'];
};

export type AcknowledgeOutOfServiceEvent = {
  outOfServiceEventId: Scalars['ID'];
};

export type AcknowledgeOutOfServiceTicket = {
  outOfServiceTicketId: Scalars['ID'];
};

export type AcknowledgePassdownLog = {
  acknowledgedById: InputMaybe<Scalars['ID']>;
  passdownLogId: Scalars['ID'];
};

export type AcknowledgeWebOrderLog = {
  webOrderLogId: Scalars['ID'];
};

export type ActivateUnit = {
  operationId: Scalars['ID'];
  standbyActivationType: InputMaybe<StandbyActivationType>;
};

export type ActivationRule = Entity &
  Evented & {
    __typename: 'ActivationRule';
    _events: MessageEnvelopeCollection;
    address: Maybe<Address>;
    ageInMinutes: Maybe<Scalars['Int']>;
    alerts: Array<Alert>;
    automatedAlertAlgorithmType: Maybe<AutomatedAlertAlgorithmType>;
    base: Maybe<Base>;
    baseId: Maybe<Scalars['ID']>;
    communicationCenters: Maybe<Array<Maybe<IdListItem>>>;
    companies: Maybe<Array<Maybe<IdListItem>>>;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    declineReasons: Maybe<Array<Maybe<IdListItem>>>;
    id: Scalars['ID'];
    isShared: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    medicalFacility: Maybe<MedicalFacility>;
    medicalFacilityId: Maybe<Scalars['ID']>;
    missionRoleTypes: Maybe<Array<Maybe<MissionRoleType>>>;
    name: Maybe<Scalars['String']>;
    notificationTemplates: Maybe<Array<Maybe<NotificationTemplate>>>;
    offerAlgorithms: Array<OfferAlgorithm>;
    operationTypes: Maybe<Array<Maybe<OperationType>>>;
    outOfServiceReasonId: Maybe<Scalars['ID']>;
    outOfServiceType: Maybe<OutOfServiceType>;
    paipReasonId: Maybe<Scalars['ID']>;
    questionnaireSectionQuestions: Maybe<Array<Maybe<QuestionnaireSectionQuestion>>>;
    region: Maybe<Region>;
    regionId: Maybe<Scalars['ID']>;
    specialtyTeam: Maybe<SpecialtyTeam>;
    specialtyTeamId: Maybe<Scalars['ID']>;
    systemTimestampType: Maybe<SystemTimestampType>;
    timelines: Maybe<Array<Maybe<Timeline>>>;
    timestampTypeId: Maybe<Scalars['ID']>;
    unit: Maybe<Unit>;
    unitId: Maybe<Scalars['ID']>;
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
    vehicleTypes: Maybe<Array<Maybe<VehicleType>>>;
    waypointTypes: Maybe<Array<Maybe<WaypointType>>>;
  };

export type ActivationRule_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActivationRuleCollection = {
  __typename: 'ActivationRuleCollection';
  items: Array<ActivationRule>;
  meta: ActivationRuleCollectionMetadata;
};

export type ActivationRuleCollectionMetadata = CollectionMetadata & {
  __typename: 'ActivationRuleCollectionMetadata';
  total: Scalars['Int'];
};

export type ActivationRuleFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type ActivationRuleQueries = {
  __typename: 'ActivationRuleQueries';
  all: ActivationRuleCollection;
  byId: Maybe<ActivationRule>;
};

export type ActivationRuleQueriesallArgs = {
  filter: InputMaybe<ActivationRuleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActivationRuleQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type ActiveAlert = Entity &
  Evented & {
    __typename: 'ActiveAlert';
    _events: MessageEnvelopeCollection;
    acknowledgedBy: Maybe<Person>;
    acknowledgedById: Maybe<Scalars['ID']>;
    activationTime: Maybe<Scalars['DateTime']>;
    activeAlertAcknowledgements: Array<ActiveAlertAcknowledgement>;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    communicationCenter: Maybe<CommunicationCenter>;
    communicationCenterId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    content: Scalars['String'];
    dateAcknowledged: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    definition: Maybe<Alert>;
    definitionId: Maybe<Scalars['ID']>;
    entityId: Maybe<Scalars['ID']>;
    entityType: Maybe<EntityType>;
    escalationDurationInSeconds: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    isAcknowledgementRepeatable: Scalars['Boolean'];
    isActive: Scalars['Boolean'];
    isAudible: Scalars['Boolean'];
    isGpsAlert: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    lifecycleStage: AlertLifecycleStage;
    lookupHash: Maybe<Scalars['String']>;
    matchType: RuleMatchType;
    parentEntityId: Maybe<Scalars['ID']>;
    parentEntityType: Maybe<EntityType>;
    referenceEntityId: Maybe<Scalars['ID']>;
    referenceEntityType: Maybe<EntityType>;
    region: Maybe<Region>;
    regionId: Maybe<Scalars['ID']>;
    requiresAcknowledgement: Scalars['Boolean'];
    snoozeMaxInSeconds: Maybe<Scalars['Int']>;
    target: Maybe<AlertTarget>;
    targetId: Maybe<Scalars['ID']>;
    title: Maybe<Scalars['String']>;
    urgency: AlertUrgency;
    visibilityType: VisibilityType;
  };

export type ActiveAlert_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActiveAlertAcknowledgement = Entity &
  Evented & {
    __typename: 'ActiveAlertAcknowledgement';
    _events: MessageEnvelopeCollection;
    acknowledgedBy: Person;
    acknowledgedById: Scalars['ID'];
    activeAlert: ActiveAlert;
    activeAlertId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateAcknowledged: Scalars['DateTime'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
  };

export type ActiveAlertAcknowledgement_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActiveAlertAcknowledgementCollection = {
  __typename: 'ActiveAlertAcknowledgementCollection';
  items: Array<ActiveAlertAcknowledgement>;
  meta: ActiveAlertAcknowledgementCollectionMetadata;
};

export type ActiveAlertAcknowledgementCollectionMetadata = CollectionMetadata & {
  __typename: 'ActiveAlertAcknowledgementCollectionMetadata';
  total: Scalars['Int'];
};

export type ActiveAlertCollection = {
  __typename: 'ActiveAlertCollection';
  items: Array<ActiveAlert>;
  meta: ActiveAlertCollectionMetadata;
};

export type ActiveAlertCollectionMetadata = CollectionMetadata & {
  __typename: 'ActiveAlertCollectionMetadata';
  total: Scalars['Int'];
};

export enum ActiveAlertContextType {
  Card = 'Card',
  Region = 'Region',
}

export type ActiveAlertFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  contextType: InputMaybe<ActiveAlertContextType>;
  excludeEntityOnlyVisibilityType: InputMaybe<Scalars['Boolean']>;
  personId: InputMaybe<Scalars['ID']>;
  regionId: InputMaybe<Scalars['String']>;
  titleLike: InputMaybe<Scalars['String']>;
  unacknowledgedOnly: InputMaybe<Scalars['Boolean']>;
  visibilityType: InputMaybe<VisibilityType>;
};

export type ActiveAlertQueries = {
  __typename: 'ActiveAlertQueries';
  all: ActiveAlertCollection;
};

export type ActiveAlertQueriesallArgs = {
  filter: InputMaybe<ActiveAlertFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActiveCardUnitOffering = Entity &
  Evented & {
    __typename: 'ActiveCardUnitOffering';
    _events: MessageEnvelopeCollection;
    card: Card;
    cardId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type ActiveCardUnitOffering_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActiveCardUnitOfferingCollection = {
  __typename: 'ActiveCardUnitOfferingCollection';
  items: Array<ActiveCardUnitOffering>;
  meta: ActiveCardUnitOfferingCollectionMetadata;
};

export type ActiveCardUnitOfferingCollectionMetadata = CollectionMetadata & {
  __typename: 'ActiveCardUnitOfferingCollectionMetadata';
  total: Scalars['Int'];
};

export type ActiveTimeline = Entity &
  Evented & {
    __typename: 'ActiveTimeline';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Scalars['ID'];
    entityType: EntityType;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    matchType: RuleMatchType;
    timeline: Timeline;
    timelineId: Scalars['ID'];
  };

export type ActiveTimeline_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ActiveTimelineCollection = {
  __typename: 'ActiveTimelineCollection';
  items: Array<ActiveTimeline>;
  meta: ActiveTimelineCollectionMetadata;
};

export type ActiveTimelineCollectionMetadata = CollectionMetadata & {
  __typename: 'ActiveTimelineCollectionMetadata';
  total: Scalars['Int'];
};

export type ActiveTimelineQueries = {
  __typename: 'ActiveTimelineQueries';
  byCardId: ActiveTimelineCollection;
};

export type ActiveTimelineQueriesbyCardIdArgs = {
  cardId: Scalars['ID'];
};

export type AddAccessibleItem = {
  entityId: Scalars['ID'];
  personId: Scalars['ID'];
  type: EntityType;
  userRoles: InputMaybe<Array<InputMaybe<UserRole>>>;
};

export type AddActivationRule = {
  address: InputMaybe<AddressInput>;
  ageInMinutes: InputMaybe<Scalars['Int']>;
  automatedAlertAlgorithmType: InputMaybe<AutomatedAlertAlgorithmType>;
  baseId: InputMaybe<Scalars['ID']>;
  communicationCenterIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companyId: InputMaybe<Scalars['ID']>;
  companyIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  declineReasonIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isShared: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  missionRoleTypes: InputMaybe<Array<InputMaybe<MissionRoleType>>>;
  name: InputMaybe<Scalars['String']>;
  operationTypes: InputMaybe<Array<InputMaybe<OperationType>>>;
  outOfServiceReasonId: InputMaybe<Scalars['ID']>;
  outOfServiceType: InputMaybe<OutOfServiceType>;
  paipReasonId: InputMaybe<Scalars['ID']>;
  regionId: InputMaybe<Scalars['ID']>;
  specialtyTeamId: InputMaybe<Scalars['ID']>;
  systemTimestampType: InputMaybe<SystemTimestampType>;
  timestampTypeId: InputMaybe<Scalars['ID']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
  vehicleTypes: InputMaybe<Array<InputMaybe<VehicleType>>>;
  waypointTypes: InputMaybe<Array<InputMaybe<WaypointType>>>;
};

export type AddActiveAlert = {
  activationTime: InputMaybe<Scalars['DateTime']>;
  authorId: InputMaybe<Scalars['ID']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
  definitionId: InputMaybe<Scalars['ID']>;
  entityId: InputMaybe<Scalars['ID']>;
  entityType: InputMaybe<EntityType>;
  escalationDurationInSeconds: InputMaybe<Scalars['Int']>;
  isAcknowledgementRepeatable: Scalars['Boolean'];
  isAudible: Scalars['Boolean'];
  isGpsAlert: Scalars['Boolean'];
  lifecycleStage: AlertLifecycleStage;
  lookupHash: InputMaybe<Scalars['String']>;
  matchType: RuleMatchType;
  parentEntityId: InputMaybe<Scalars['ID']>;
  parentEntityType: InputMaybe<EntityType>;
  referenceEntityId: InputMaybe<Scalars['ID']>;
  referenceEntityType: InputMaybe<EntityType>;
  regionId: InputMaybe<Scalars['ID']>;
  requiresAcknowledgement: Scalars['Boolean'];
  snoozeMaxInSeconds: InputMaybe<Scalars['Int']>;
  title: InputMaybe<Scalars['String']>;
  urgency: AlertUrgency;
  visibilityType: VisibilityType;
};

export type AddAgency = {
  abbreviation: Scalars['String'];
  isCompetitor: Scalars['Boolean'];
  isInternallyOwned: Scalars['Boolean'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  parentCompanyId: InputMaybe<Scalars['ID']>;
  type: AgencyType;
};

export type AddAgencyLocation = {
  address: AddressInput;
  agencyId: Scalars['ID'];
  emailAddress: InputMaybe<Scalars['String']>;
  estimatedDepartureTimeInMinutes: InputMaybe<Scalars['Int']>;
  faxPhoneNumber: InputMaybe<Scalars['String']>;
  isInTransportNet: Scalars['Boolean'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  secondaryPhoneNumber: InputMaybe<Scalars['String']>;
  smsPhoneNumber: InputMaybe<Scalars['String']>;
  vehicleType: InputMaybe<VehicleType>;
};

export type AddAirport = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  airportCodeType: AirportCodeType;
  airportType: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  preferredFboId: InputMaybe<Scalars['ID']>;
  sourceSystemId: InputMaybe<Scalars['Int']>;
};

export type AddAlert = {
  activationRuleId: Scalars['ID'];
  content: Scalars['String'];
  effectiveDate: InputMaybe<Scalars['DateTime']>;
  entityType: EntityType;
  expirationDate: InputMaybe<Scalars['DateTime']>;
  isAudible: Scalars['Boolean'];
  lifecycleStage: AlertLifecycleStage;
  paused: InputMaybe<Scalars['Boolean']>;
  requiresAcknowledgement: Scalars['Boolean'];
  target: InputMaybe<AlertTarget>;
  title: InputMaybe<Scalars['String']>;
  urgency: AlertUrgency;
};

export type AddApplicationNotification = {
  companyId: InputMaybe<Scalars['ID']>;
  dismissable: Scalars['Boolean'];
  displayOnBanner: Scalars['Boolean'];
  effectiveDate: InputMaybe<Scalars['DateTime']>;
  expirationDate: InputMaybe<Scalars['DateTime']>;
  notification: Scalars['String'];
  regionId: InputMaybe<Scalars['ID']>;
  title: InputMaybe<Scalars['String']>;
  urgency: ApplicationNotificationUrgency;
};

export type AddAssignmentDelayedReason = {
  name: Scalars['String'];
};

export type AddBase = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  brandName: InputMaybe<Scalars['String']>;
  businessModel: BusinessModel;
  communicationCenterCustomIdentifiers: InputMaybe<Array<InputMaybe<IdNameListItemInput>>>;
  companyId: Scalars['ID'];
  crewPhoneNumber1: InputMaybe<Scalars['String']>;
  crewPhoneNumber2: InputMaybe<Scalars['String']>;
  dateLastUpdatedFromGMRWorkday: InputMaybe<Scalars['DateTime']>;
  dateOfMaturity: InputMaybe<Scalars['DateTime']>;
  dispatchBaseId: InputMaybe<Scalars['ID']>;
  enableFlightLogDutyLog: InputMaybe<Scalars['Boolean']>;
  estimatedLiftoffTime: InputMaybe<Scalars['Int']>;
  gmrWorkdayLocationId: InputMaybe<Scalars['String']>;
  hoursOfOperation: HoursOfOperationInput;
  licenseNumber: InputMaybe<Scalars['String']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  operationsStarted: InputMaybe<Scalars['DateTime']>;
  operationsTerminated: InputMaybe<Scalars['DateTime']>;
  pilotPhoneNumber: InputMaybe<Scalars['String']>;
  plannedOperationsStart: InputMaybe<Scalars['DateTime']>;
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  reportBaseId: InputMaybe<Scalars['ID']>;
  timezoneCd: InputMaybe<Scalars['String']>;
};

export type AddBaseAdditionalCompany = {
  baseId: Scalars['ID'];
  companyId: Scalars['ID'];
};

export type AddBaseControlZone = {
  baseId: Scalars['ID'];
  companyId: Scalars['ID'];
  controlZoneId: Scalars['ID'];
};

export type AddBaseMedicalControlContact = {
  baseId: Scalars['ID'];
  id: InputMaybe<Scalars['ID']>;
  licensedStates: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  personId: Scalars['ID'];
  rank: Scalars['Int'];
  specialty: InputMaybe<Scalars['String']>;
};

export type AddCancellation = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  crewNotified: InputMaybe<Scalars['DateTime']>;
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  requestId: Scalars['ID'];
  responseReceived: InputMaybe<Scalars['DateTime']>;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitId: Scalars['ID'];
};

export type AddCancellationCategory = {
  defaultCancellationReasonId: InputMaybe<Scalars['ID']>;
  isVisibleInOps: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AddCancellationReason = {
  abbreviation: Scalars['String'];
  canBeUnitCancellationReason: InputMaybe<Scalars['Boolean']>;
  cancellationCategoryId: InputMaybe<Scalars['ID']>;
  isTransferCenterReason: Scalars['Boolean'];
  name: Scalars['String'];
  secondaryReasonRequired: Scalars['Boolean'];
};

export type AddCancellationSecondaryReason = {
  cancellationReasonId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddCapability = {
  abbreviation: Scalars['String'];
  description: Scalars['String'];
  entityType: EntityType;
  name: Scalars['String'];
};

export type AddCard = {
  apiWebhookSubscriptionId: InputMaybe<Scalars['ID']>;
  cardNumber: Scalars['String'];
  closeComment: InputMaybe<Scalars['String']>;
  crewWillTransportWithReplacementGroundUnit: InputMaybe<Scalars['Boolean']>;
  dateCardClosed: InputMaybe<Scalars['DateTime']>;
  diversionType: InputMaybe<DiversionType>;
  gmrCADNumber: InputMaybe<Scalars['String']>;
  gmrUtilizationStatus: InputMaybe<AmrUtilizationStatus>;
  isBillable: InputMaybe<Scalars['Boolean']>;
  isLocked: InputMaybe<Scalars['Boolean']>;
  lastOperationId: InputMaybe<Scalars['ID']>;
  linkedCardId: InputMaybe<Scalars['ID']>;
  notBillableComment: InputMaybe<Scalars['String']>;
  notBillableType: InputMaybe<NotBillableType>;
  operationId: InputMaybe<Scalars['ID']>;
  plannedCompletionTime: InputMaybe<Scalars['DateTime']>;
  postTransportDebriefCompleted: InputMaybe<Scalars['Boolean']>;
  reOpenComment: InputMaybe<Scalars['String']>;
  reOpenReasonId: InputMaybe<Scalars['ID']>;
  requestId: InputMaybe<Scalars['ID']>;
  status: CardStatus;
  transferredFromCardId: InputMaybe<Scalars['ID']>;
  transferredToCardId: InputMaybe<Scalars['ID']>;
};

export type AddCardLink = {
  fromCardId: Scalars['ID'];
  rendezvousRequestId: InputMaybe<Scalars['ID']>;
  toCardId: Scalars['ID'];
  toCardNumber: Scalars['String'];
  type: CardLinkType;
};

export type AddCardNote = {
  cardId: Scalars['ID'];
  content: Scalars['String'];
  isInternal: Scalars['Boolean'];
};

export type AddCardNoteArchive = {
  cardId: Scalars['ID'];
  content: Scalars['String'];
  isInternal: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  noteCategory: InputMaybe<Scalars['String']>;
  noteMetadataJson: InputMaybe<Scalars['String']>;
  noteTime: Scalars['DateTime'];
  receivedFromCardId: InputMaybe<Scalars['ID']>;
  sentToCards: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
};

export type AddCardReOpenReason = {
  affectsTrip: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AddCommunicationCenter = {
  alertFrequencyForGroundVehicles: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  displayContactTimeline: Scalars['Boolean'];
  emailAddress: InputMaybe<Scalars['String']>;
  enableRAAlert: Scalars['Boolean'];
  includeCompetitors: Scalars['Boolean'];
  name: Scalars['String'];
  playAlertForManualPositionReports: Scalars['Boolean'];
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  showReferToGmrWarning: InputMaybe<Scalars['Boolean']>;
  states: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timezoneCd: InputMaybe<Scalars['String']>;
  useCrewPhoneNumber: Scalars['Boolean'];
};

export type AddCommunicationCenterTransportOfferOption = {
  communicationCenterId: InputMaybe<Scalars['ID']>;
  includeAbortedUnit: Scalars['Boolean'];
  includeCompetitors: InputMaybe<Scalars['Boolean']>;
  minimumFlightRule: InputMaybe<FlightRule>;
  requestedVehicleType: InputMaybe<VehicleType>;
  requiredCapabilities: Array<RequiredCapabilityIdListInput>;
  transportOfferAlgorithm: InputMaybe<TransportOfferAlgorithm>;
};

export type AddCompany = {
  abbreviation: Scalars['String'];
  callNumberPrefix: InputMaybe<Scalars['String']>;
  companyCode: Scalars['String'];
  crewPatientInfoPageNotificationTemplateId: InputMaybe<Scalars['ID']>;
  enableNotificationGroupTypes: Scalars['Boolean'];
  flightFollowingFields: InputMaybe<Array<InputMaybe<FlightFollowingField>>>;
  gLCode: InputMaybe<Scalars['String']>;
  gpsFeedResetsPositionReportTime: Scalars['Boolean'];
  hasPrivateUnits: Scalars['Boolean'];
  imageUri: InputMaybe<Scalars['String']>;
  includeCompetitors: Scalars['Boolean'];
  isOemCompany: Scalars['Boolean'];
  name: Scalars['String'];
  requireSkipReasonsForNonCompanyTransportOffers: InputMaybe<Scalars['Boolean']>;
  restrictRiskAnalysisAcknowledgementToOCCRole: Scalars['Boolean'];
  timezoneCd: InputMaybe<Scalars['String']>;
  transportCheckTimerDurationInMinutes: InputMaybe<Scalars['Int']>;
  unitRemainsInServiceWithNoVehicle: Scalars['Boolean'];
};

export type AddCompleteFlightInstance = {
  apiKey: Scalars['String'];
  completeFlightInstanceName: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type AddConfigurationSetting = {
  assetReassignedDeclineReasonId: InputMaybe<Scalars['ID']>;
  bugRequestEmail: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  crewGoingByGroundOutOfServiceReasonId: InputMaybe<Scalars['ID']>;
  defaultUnitCommittedDeclineReasonId: InputMaybe<Scalars['ID']>;
  defaultUnitOutOfServiceDeclineReasonId: InputMaybe<Scalars['ID']>;
  externallyCancelledCancellationReasonId: InputMaybe<Scalars['ID']>;
  featureRequestEmail: InputMaybe<Scalars['String']>;
  pilotReportGracePeriodInMinutes: InputMaybe<Scalars['Int']>;
  proximityAlertDistanceInNauticalMiles: InputMaybe<Scalars['Float']>;
  requestReferredExternallyCancellationReasonId: InputMaybe<Scalars['ID']>;
  requestReferredInternallyCancellationReasonId: InputMaybe<Scalars['ID']>;
  sameDestinationWarningThresholdInMinutes: InputMaybe<Scalars['Int']>;
};

export type AddControlZone = {
  companyId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddConversationToCardWithParticipant = {
  cardId: Scalars['ID'];
  participantName: Scalars['String'];
  smsAddress: Scalars['String'];
};

export type AddCrewOutOfServiceEvent = {
  address: InputMaybe<AddressInput>;
  alertTimeInMinutes: InputMaybe<Scalars['Int']>;
  alertWhenEventEnds: Scalars['Boolean'];
  crewPersonIds: Array<Scalars['ID']>;
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  isAcknowledgementRequired: Scalars['Boolean'];
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  notes: InputMaybe<Scalars['String']>;
  oosRequestType: InputMaybe<OosRequestType>;
  paipEventId: InputMaybe<Scalars['ID']>;
  reasonId: Scalars['ID'];
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  type: OutOfServiceType;
  unitId: Scalars['ID'];
};

export type AddDecline = {
  crewNotified: InputMaybe<Scalars['DateTime']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  notes: InputMaybe<Scalars['String']>;
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  requestId: Scalars['ID'];
  responseReceived: InputMaybe<Scalars['DateTime']>;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitId: Scalars['ID'];
};

export type AddDeclineCategory = {
  defaultDeclineReasonId: InputMaybe<Scalars['ID']>;
  isVisibleInOps: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AddDeclineReason = {
  abbreviation: Scalars['String'];
  canBeAbortReason: Scalars['Boolean'];
  canBeBulkSkipReason: Scalars['Boolean'];
  canBeOneCallSkipReason: Scalars['Boolean'];
  canBeSkipReason: Scalars['Boolean'];
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  controllable: Scalars['Boolean'];
  declineCategoryId: Scalars['ID'];
  isUnitAvailableAfterAbort: Scalars['Boolean'];
  name: Scalars['String'];
  secondaryReasonRequired: Scalars['Boolean'];
};

export type AddDeclineSecondaryReason = {
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  declineReasonId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddDepartment = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type AddDiversionReason = {
  name: Scalars['String'];
};

export type AddEmsReport = {
  cardId: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  rendezvousRequestId: Scalars['ID'];
  time: Scalars['DateTime'];
  transportUnitNumber: InputMaybe<Scalars['String']>;
};

export type AddEntityCapability = {
  capabilityId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: EntityType;
};

export type AddEscortRequest = {
  escortName: Scalars['String'];
  escortWeightInKg: Scalars['Float'];
  relationship: PatientRelationshipType;
  requestApprovalTime: Scalars['DateTime'];
  requestId: Scalars['ID'];
};

export type AddExistingSpecialtyTeamMember = {
  personId: Scalars['ID'];
  specialtyTeamId: Scalars['ID'];
  weightInKg: Scalars['Float'];
};

export type AddExternalAction = {
  actionBodyJson: Scalars['String'];
  actionTypeId: Scalars['ID'];
  completedById: InputMaybe<Scalars['ID']>;
  dateCompleted: InputMaybe<Scalars['DateTime']>;
  entityId: Scalars['ID'];
  entityType: EntityType;
  notes: InputMaybe<Scalars['String']>;
  status: ExternalActionStatus;
};

export type AddExternalActionType = {
  actionTypeDescription: Scalars['String'];
  actionTypeName: Scalars['String'];
  priority: Scalars['Int'];
};

export type AddExternalReference = {
  entityId: Scalars['ID'];
  entityType: EntityType;
  externalKey: Scalars['String'];
  externalSystem: ExternalSystem;
};

export type AddFacilityNonAcceptanceReason = {
  facilityNonAcceptanceReasonType: NonAcceptanceType;
  name: Scalars['String'];
};

export type AddFbo = {
  address: AddressInput;
  airportId: Scalars['ID'];
  fboType: FboType;
  fuelBrand: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sourceSystemId: InputMaybe<Scalars['Int']>;
};

export type AddFirewallRule = {
  action: AccessControlAction;
  companyId: InputMaybe<Scalars['ID']>;
  enabled: Scalars['Boolean'];
  ipRange: Scalars['String'];
  name: Scalars['String'];
};

export type AddFlightFollowingReport = {
  centerOfGravity: InputMaybe<Scalars['Float']>;
  confirmedFboId: InputMaybe<Scalars['ID']>;
  cruisingAltitude: InputMaybe<Scalars['Int']>;
  departureTime: InputMaybe<Scalars['DateTime']>;
  destination: InputMaybe<Scalars['String']>;
  estimatedTimeEnrouteMinutes: InputMaybe<Scalars['Int']>;
  flightRule: InputMaybe<FlightRule>;
  flightType: InputMaybe<FlightType>;
  fuel: InputMaybe<Scalars['String']>;
  highestFeatureEnroute: InputMaybe<Scalars['Int']>;
  licenseRequiredToFlyAcknowledged: InputMaybe<Scalars['Boolean']>;
  medicalCrewRA: InputMaybe<Scalars['Int']>;
  operationId: InputMaybe<Scalars['ID']>;
  placeUnitEnRoute: InputMaybe<Scalars['Boolean']>;
  riskAnalysis: InputMaybe<Scalars['String']>;
  riskAnalysisAcknowledged: InputMaybe<Scalars['Boolean']>;
  riskAnalysisNumber: InputMaybe<Scalars['String']>;
  soulsOnBoard: InputMaybe<Scalars['Int']>;
  summary: InputMaybe<Scalars['String']>;
  takeOffWeight: InputMaybe<Scalars['Float']>;
  trackingViaGps: InputMaybe<Scalars['Boolean']>;
  tripId: Scalars['ID'];
  tripLegId: InputMaybe<Scalars['ID']>;
};

export type AddFuelBurn = {
  waypointId: Scalars['ID'];
};

export type AddFuelTank = {
  address: AddressInput;
  baseId: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  companyId: Scalars['ID'];
  locationName: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  operationsEnded: InputMaybe<Scalars['DateTime']>;
  operationsStarted: InputMaybe<Scalars['DateTime']>;
  sourceSystemId: InputMaybe<Scalars['Int']>;
};

export type AddLocation = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  closedDate: InputMaybe<Scalars['DateTime']>;
  duplicateOfId: InputMaybe<Scalars['ID']>;
  isLandingZoneOutOfService: InputMaybe<Scalars['Boolean']>;
  isPreferred: Scalars['Boolean'];
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  landingZoneOutOfServiceExpirationDate: InputMaybe<Scalars['DateTime']>;
  landingZoneOutOfServiceNotes: InputMaybe<Scalars['String']>;
  landingZoneOutOfServiceReasonId: InputMaybe<Scalars['ID']>;
  locationType: LocationType;
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  sourceSystemId: InputMaybe<Scalars['String']>;
  timezoneCd: InputMaybe<Scalars['String']>;
};

export type AddLocationHazard = {
  effectiveDate: InputMaybe<Scalars['DateTime']>;
  expirationDate: InputMaybe<Scalars['DateTime']>;
  hazard: Scalars['String'];
  locationId: Scalars['ID'];
};

export type AddMaintenanceFacility = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  isPreferred: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AddManifestEntry = {
  confirmedAt: InputMaybe<Scalars['DateTime']>;
  confirmedById: InputMaybe<Scalars['ID']>;
  passengerId: Scalars['ID'];
  tripLegId: Scalars['ID'];
};

export type AddMedicalControlContactLogEntry = {
  cardId: Scalars['ID'];
  isSuccessful: Scalars['Boolean'];
  notes: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  time: Scalars['DateTime'];
};

export type AddMedicalFacility = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  closedDate: InputMaybe<Scalars['DateTime']>;
  defaultFixedWingLandingZoneId: InputMaybe<Scalars['ID']>;
  defaultLandingZoneId: InputMaybe<Scalars['ID']>;
  firmType: InputMaybe<Scalars['String']>;
  hospitalSpecialization: InputMaybe<Scalars['String']>;
  hospitalType: InputMaybe<Scalars['String']>;
  isPreferred: Scalars['Boolean'];
  masterDataSetId: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nemsisCode: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  npi: Scalars['String'];
  providerNumber: InputMaybe<Scalars['String']>;
  sourceSystemId: InputMaybe<Scalars['Int']>;
  stateFacilityName: InputMaybe<Scalars['String']>;
  stateSourceSystemId: InputMaybe<Scalars['ID']>;
  status: InputMaybe<MedicalFacilityStatus>;
  website: InputMaybe<Scalars['String']>;
};

export type AddMedicalFacilityContact = {
  emailAddress: InputMaybe<Scalars['String']>;
  faxPhoneNumber: InputMaybe<Scalars['String']>;
  medicalFacilityId: Scalars['ID'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  secondaryPhoneNumber: InputMaybe<Scalars['String']>;
  smsPhoneNumber: InputMaybe<Scalars['String']>;
};

export type AddMedicalFacilityPhysician = {
  medicalFacilityId: Scalars['ID'];
  physicianId: Scalars['ID'];
};

export type AddMedicalFacilityUnit = {
  medicalFacilityId: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: InputMaybe<Scalars['String']>;
};

export type AddMessageStatusUpdate = {
  error: InputMaybe<Scalars['String']>;
  metadataJson: InputMaybe<Scalars['String']>;
  status: MessageStatus;
  trackedMessageId: Scalars['ID'];
  vendorMessage: InputMaybe<Scalars['String']>;
};

export type AddNewAgencyLocationRequest = {
  entityId: InputMaybe<Scalars['ID']>;
  entityType: EntityType;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  requestedByPersonId: Scalars['ID'];
  type: NewAgencyLocationRequestOriginType;
};

export type AddNextDueType = {
  dataType: Scalars['String'];
  name: Scalars['String'];
};

export type AddNonReferralReason = {
  associatedCancellationReasonId: InputMaybe<Scalars['ID']>;
  associatedCancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type AddNotification = {
  body: Scalars['String'];
  cardId: InputMaybe<Scalars['ID']>;
  entityId: InputMaybe<Scalars['ID']>;
  entityType: InputMaybe<EntityType>;
  isDraft: InputMaybe<Scalars['Boolean']>;
  recipients: Array<RecipientInput>;
  sourceTemplateId: InputMaybe<Scalars['ID']>;
  subject: InputMaybe<Scalars['String']>;
};

export type AddNotificationGroup = {
  companyId: Scalars['ID'];
  isEmailNotificationPreferred: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  regionId: InputMaybe<Scalars['ID']>;
  type: InputMaybe<NotificationGroupType>;
  types: InputMaybe<Array<InputMaybe<NotificationGroupType>>>;
  unitId: InputMaybe<Scalars['ID']>;
};

export type AddNotificationGroupMember = {
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  notificationGroupId: Scalars['ID'];
  userId: InputMaybe<Scalars['ID']>;
};

export type AddNotificationRecipient = {
  messageId: InputMaybe<Scalars['ID']>;
  messageStatus: InputMaybe<MessageStatus>;
  name: InputMaybe<Scalars['String']>;
  notificationAddress: InputMaybe<Scalars['String']>;
  notificationId: Scalars['ID'];
  userId: InputMaybe<Scalars['ID']>;
};

export type AddNotificationRecipients = {
  notificationId: Scalars['ID'];
  recipients: Array<RecipientInput>;
};

export type AddNotificationSubscription = {
  name: Scalars['String'];
  notificationGroupId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type AddNotificationTemplate = {
  activationRuleId: InputMaybe<Scalars['ID']>;
  bodyTemplate: Scalars['String'];
  canBeManualTrigger: Scalars['Boolean'];
  companyId: InputMaybe<Scalars['ID']>;
  contextType: EntityType;
  groupTypes: InputMaybe<Array<InputMaybe<NotificationGroupType>>>;
  name: Scalars['String'];
  notificationType: InputMaybe<NotificationType>;
  recipientTypes: InputMaybe<Array<InputMaybe<NotificationRecipientType>>>;
  requiresApproval: InputMaybe<Scalars['Boolean']>;
  subjectTemplate: InputMaybe<Scalars['String']>;
  triggerType: InputMaybe<NotificationTriggerType>;
  triggerValue: InputMaybe<Scalars['String']>;
  viewModelType: InputMaybe<Scalars['String']>;
};

export type AddOemActivity = {
  activityType: OemActivityType;
  authorId: InputMaybe<Scalars['ID']>;
  content: InputMaybe<Scalars['String']>;
  currentStatus: InputMaybe<Scalars['String']>;
  oemPlanChangeRequestId: InputMaybe<Scalars['ID']>;
  oemPlanId: Scalars['ID'];
  priorStatus: InputMaybe<Scalars['String']>;
  time: InputMaybe<Scalars['DateTime']>;
};

export type AddOemAsset = {
  assetDispatchCompanyId: InputMaybe<Scalars['ID']>;
  assetId: Scalars['ID'];
  assetType: OemAssetType;
  oemPlanId: Scalars['ID'];
  oemUnitId: InputMaybe<Scalars['ID']>;
  originalUnitId: InputMaybe<Scalars['ID']>;
  requestedBaseId: InputMaybe<Scalars['ID']>;
  requestedPlacardNumber: InputMaybe<Scalars['String']>;
  requestedUnitAbbreviation: InputMaybe<Scalars['String']>;
  requestedUnitName: InputMaybe<Scalars['String']>;
  status: OemAssetStatus;
};

export type AddOemPlan = {
  companyId: Scalars['ID'];
  defaultBaseId: Scalars['ID'];
  description: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  oemCompanyId: Scalars['ID'];
  outOfServiceReasonId: Scalars['ID'];
  planStatus: OemPlanStatus;
  planYear: Scalars['Int'];
};

export type AddOemPlanChangeRequest = {
  dateCancelled: InputMaybe<Scalars['DateTime']>;
  dateCompleted: InputMaybe<Scalars['DateTime']>;
  dateRequested: InputMaybe<Scalars['DateTime']>;
  notes: InputMaybe<Scalars['String']>;
  oemAssetId: Scalars['ID'];
  oemPlanId: Scalars['ID'];
  originalAssetStatus: OemAssetStatus;
  requestedAssetStatus: OemAssetStatus;
  requestedById: InputMaybe<Scalars['ID']>;
  status: OemPlanChangeRequestStatus;
};

export type AddOfferAlgorithm = {
  activationRuleId: Scalars['ID'];
  companyId: Scalars['ID'];
  companyIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  distanceCalculation: DistanceCalculation;
  includeCompetitors: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  minimumFlightRule: InputMaybe<FlightRule>;
  name: Scalars['String'];
  oneCallAgreement: Scalars['Boolean'];
  preferredUnits: Array<PreferredUnitInput>;
  rank: Scalars['Int'];
  transportOfferAlgorithm: TransportOfferAlgorithm;
};

export type AddOperation = {
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  dateOperationEnded: InputMaybe<Scalars['DateTime']>;
  dateOperationStarted: Scalars['DateTime'];
  riskAnalysisAcknowledged: Scalars['Boolean'];
  riskAnalysisNumber: InputMaybe<Scalars['String']>;
  standbyActivationType: InputMaybe<StandbyActivationType>;
  status: OperationStatus;
  type: OperationType;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: Scalars['ID'];
};

export type AddOutOfComplianceCrewMember = {
  comment: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type AddOutOfServiceEvent = {
  address: InputMaybe<AddressInput>;
  alternatePOC: InputMaybe<Scalars['String']>;
  amtPointOfContactId: InputMaybe<Scalars['ID']>;
  assignedBaseId: InputMaybe<Scalars['ID']>;
  businessUnitCompanyId: InputMaybe<Scalars['ID']>;
  createdById: InputMaybe<Scalars['ID']>;
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  humanErrorDamageType: InputMaybe<HumanErrorDamageType>;
  isAMTAvailable: InputMaybe<Scalars['Boolean']>;
  isAcknowledgementRequired: Scalars['Boolean'];
  isBirdStrike: Scalars['Boolean'];
  isFAR135415Reportable: InputMaybe<Scalars['Boolean']>;
  isFAR135417Reportable: InputMaybe<Scalars['Boolean']>;
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  isPatientOnboard: Scalars['Boolean'];
  isPlanned: Scalars['Boolean'];
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceLocation: InputMaybe<Scalars['String']>;
  maintenanceTypes: InputMaybe<Array<InputMaybe<OosTicketMaintenanceType>>>;
  mxDuringPeakTimeReason: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  oosRequestType: InputMaybe<OosRequestType>;
  opportunityMXTypes: InputMaybe<Array<InputMaybe<OpportunityMXType>>>;
  outOfServiceTicketId: InputMaybe<Scalars['ID']>;
  paipEventId: InputMaybe<Scalars['ID']>;
  parentOutOfServiceEventId: InputMaybe<Scalars['ID']>;
  qarReasons: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  reasonId: Scalars['ID'];
  rtsDelayReasonTypes: InputMaybe<Array<InputMaybe<RtsDelayReasonType>>>;
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  spareVehicleId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  ticketDescription: InputMaybe<Scalars['String']>;
  type: OutOfServiceType;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
  waitingForParts: Scalars['Boolean'];
  waitingForTooling: Scalars['Boolean'];
};

export type AddOutOfServiceEventNote = {
  content: Scalars['String'];
  outOfServiceEventId: Scalars['ID'];
};

export type AddOutOfServiceQARReason = {
  name: Scalars['String'];
};

export type AddOutOfServiceReason = {
  controllable: Scalars['Boolean'];
  description: InputMaybe<Scalars['String']>;
  isVehicleReason: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AddOutOfServiceSecondaryReason = {
  name: Scalars['String'];
  outOfServiceReasonId: Scalars['ID'];
};

export type AddPaipEvent = {
  endTime: InputMaybe<Scalars['DateTime']>;
  notes: InputMaybe<Scalars['String']>;
  reasonId: Scalars['ID'];
  regionId: InputMaybe<Scalars['ID']>;
  startTime: Scalars['DateTime'];
  unitIds: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
};

export type AddPaipReason = {
  name: Scalars['String'];
  outOfServiceReasonId: InputMaybe<Scalars['ID']>;
};

export type AddPassdownLog = {
  acknowledgedById: InputMaybe<Scalars['ID']>;
  authorId: InputMaybe<Scalars['ID']>;
  body: Scalars['String'];
  dateAcknowledged: InputMaybe<Scalars['DateTime']>;
  logDate: Scalars['DateTime'];
  name: Scalars['String'];
  regionId: Scalars['ID'];
  regionIdList: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requiresAcknowledgement: Scalars['Boolean'];
};

export type AddPerson = {
  activateOktaAccount: Scalars['Boolean'];
  activeDirectoryId: InputMaybe<Scalars['String']>;
  allBasesAccessible: InputMaybe<Scalars['Boolean']>;
  allCommunicationCentersAccessible: InputMaybe<Scalars['Boolean']>;
  allCompaniesAccessible: InputMaybe<Scalars['Boolean']>;
  allTrmProgramsAccessible: InputMaybe<Scalars['Boolean']>;
  applyToActiveDirectory: InputMaybe<Scalars['Boolean']>;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  baseId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  dateLastUpdatedFromGMRWorkday: InputMaybe<Scalars['DateTime']>;
  departmentId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  employeeId: InputMaybe<Scalars['String']>;
  employeeType: EmployeeType;
  faaCompanyId: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  grantTcsAccess: Scalars['Boolean'];
  hireDate: InputMaybe<Scalars['DateTime']>;
  isAviationSupervisor: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationId: InputMaybe<Scalars['ID']>;
  notificationAddress: InputMaybe<Scalars['String']>;
  primaryCommunicationCenterId: InputMaybe<Scalars['ID']>;
  programId: InputMaybe<Scalars['ID']>;
  reportsToPersonId: InputMaybe<Scalars['ID']>;
  terminationDate: InputMaybe<Scalars['DateTime']>;
  timeType: TimeType;
  title: InputMaybe<Scalars['String']>;
};

export type AddPersonAdditionalCompany = {
  companyId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type AddPhysician = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type AddPositionReport = {
  altitude: InputMaybe<Scalars['Float']>;
  coordinates: InputMaybe<CoordinatesInput>;
  dateConfirmed: InputMaybe<Scalars['DateTime']>;
  estimatedMinutesEnRoute: InputMaybe<Scalars['Int']>;
  fuelRemaining: InputMaybe<Scalars['String']>;
  gpsProvider: InputMaybe<GpsProvider>;
  heading: InputMaybe<Scalars['Float']>;
  positionTime: Scalars['DateTime'];
  source: PositionReportSource;
  speedInKnots: InputMaybe<Scalars['Float']>;
  timezoneCd: InputMaybe<Scalars['String']>;
  tripId: Scalars['ID'];
};

export type AddPositionReportAlert = {
  hasReceivedQualifyingReport: Scalars['Boolean'];
  vehicleId: Scalars['ID'];
};

export type AddPreApprovedTrmUser = {
  additionalProgramIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  agencyIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId: Scalars['ID'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  medicalFacilityIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  personId: InputMaybe<Scalars['ID']>;
  phoneNumber: Scalars['String'];
  preferredProgramId: Scalars['ID'];
};

export type AddProgram = {
  abbreviation: Scalars['String'];
  adminId: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  companyId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddProgramBase = {
  baseId: Scalars['ID'];
  endTime: InputMaybe<Scalars['DateTime']>;
  programId: Scalars['ID'];
  startTime: InputMaybe<Scalars['DateTime']>;
};

export type AddQuestion = {
  choices: InputMaybe<Array<InputMaybe<UpsertQuestionChoice>>>;
  dataType: InputMaybe<QuestionDataType>;
  name: Scalars['String'];
  question: Scalars['String'];
  questionType: QuestionType;
};

export type AddQuestionnaire = {
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  name: Scalars['String'];
  sections: InputMaybe<Array<InputMaybe<UpsertQuestionnaireSection>>>;
  type: QuestionnaireType;
};

export type AddQuestionnaireQuestionResponse = {
  explanation: InputMaybe<Scalars['String']>;
  matchType: RuleMatchType;
  questionnaireResponseId: Scalars['ID'];
  questionnaireSectionQuestionId: Scalars['ID'];
  responseValue: InputMaybe<Scalars['String']>;
  reviewRequired: Scalars['Boolean'];
};

export type AddQuestionnaireQuestionResponseNote = {
  authorId: Scalars['ID'];
  dateAuthored: Scalars['DateTime'];
  note: Scalars['String'];
  questionnaireQuestionResponseId: Scalars['ID'];
};

export type AddQuestionnaireResponse = {
  cardId: Scalars['ID'];
  communicationsReviewById: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  completedById: InputMaybe<Scalars['ID']>;
  currentReviewLevel: InputMaybe<UserRole>;
  dateCommunicationsReviewed: InputMaybe<Scalars['DateTime']>;
  dateCompleted: InputMaybe<Scalars['DateTime']>;
  dateManagerReviewed: InputMaybe<Scalars['DateTime']>;
  dateSupervisorReviewed: InputMaybe<Scalars['DateTime']>;
  managerReviewById: InputMaybe<Scalars['ID']>;
  questionnaireId: Scalars['ID'];
  status: QuestionnaireResponseStatus;
  supervisorReviewById: InputMaybe<Scalars['ID']>;
};

export type AddReceivingFacilityRequestDeclineHistory = {
  nonAcceptanceReasonId: Scalars['ID'];
  nonAcceptanceType: NonAcceptanceType;
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  referredToFacilityId: InputMaybe<Scalars['ID']>;
  requestLocationId: Scalars['ID'];
  time: Scalars['DateTime'];
};

export type AddRegion = {
  abbreviation: Scalars['String'];
  communicationCenterId: Scalars['ID'];
  dispatchNumber: InputMaybe<Scalars['String']>;
  emSystemDivisionName: InputMaybe<Scalars['String']>;
  etcInMinutes: InputMaybe<Scalars['Int']>;
  fixedWingPreferredThresholdInNauticalMiles: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  regionGroupId: Scalars['ID'];
  timezoneCd: InputMaybe<Scalars['String']>;
};

export type AddRegionBase = {
  baseId: Scalars['ID'];
  regionId: Scalars['ID'];
};

export type AddRegionGroup = {
  abbreviation: Scalars['String'];
  companyId: Scalars['ID'];
  departmentId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddReleaseNote = {
  description: Scalars['String'];
  releaseDate: InputMaybe<Scalars['DateTime']>;
  releaseNumber: Scalars['String'];
};

export type AddRendezvousRequest = {
  agencyEta: InputMaybe<Scalars['DateTime']>;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  arrivedDestAt: InputMaybe<Scalars['DateTime']>;
  arrivedLzAt: InputMaybe<Scalars['DateTime']>;
  cancelledAt: InputMaybe<Scalars['DateTime']>;
  cardIdToLink: InputMaybe<Scalars['ID']>;
  confirmedAt: InputMaybe<Scalars['DateTime']>;
  contactInformation: InputMaybe<Scalars['String']>;
  departedDestAt: InputMaybe<Scalars['DateTime']>;
  departedLzAt: InputMaybe<Scalars['DateTime']>;
  latestStatus: InputMaybe<Scalars['String']>;
  latestStatusTimestamp: InputMaybe<Scalars['DateTime']>;
  newAgencyLocationName: InputMaybe<Scalars['String']>;
  newAgencyLocationPhoneNumber: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  rendezvousLocationDescription: InputMaybe<Scalars['String']>;
  requestLocationId: Scalars['ID'];
  transportUnitNumber: InputMaybe<Scalars['String']>;
  type: SupplementalLegType;
  utilizationStatus: AmrUtilizationStatus;
};

export type AddRequestPatient = {
  bpDiastolic: InputMaybe<Scalars['Int']>;
  bpSystolic: InputMaybe<Scalars['Int']>;
  chiefComplaintNotes: InputMaybe<Scalars['String']>;
  dateOfBirth: InputMaybe<Scalars['DateTime']>;
  estimatedAgeInHours: InputMaybe<Scalars['Float']>;
  firstName: InputMaybe<Scalars['String']>;
  gcs: InputMaybe<Scalars['Int']>;
  gender: Gender;
  heartRate: InputMaybe<Scalars['Int']>;
  isIntubated: InputMaybe<Scalars['Boolean']>;
  isIsolette: Scalars['Boolean'];
  isoletteNotes: InputMaybe<Scalars['String']>;
  isoletteType: InputMaybe<IsoletteType>;
  lastName: InputMaybe<Scalars['String']>;
  medicalRecordNumber: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  numberOfDrips: InputMaybe<Scalars['Int']>;
  oxygenSaturation: InputMaybe<Scalars['Float']>;
  patientId: InputMaybe<Scalars['ID']>;
  requestId: Scalars['ID'];
  respiratoryRate: InputMaybe<Scalars['Float']>;
  rideAlongDateOfBirth: InputMaybe<Scalars['DateTime']>;
  rideAlongName: InputMaybe<Scalars['String']>;
  rideAlongRequested: InputMaybe<YesNoType>;
  rideAlongWeightInKg: InputMaybe<Scalars['Float']>;
  specialtyEquipment: InputMaybe<Scalars['String']>;
  temperatureInCelsius: InputMaybe<Scalars['Float']>;
  transferReasonId: InputMaybe<Scalars['ID']>;
  transportReasonCategory: InputMaybe<TransportReasonCategory>;
  transportReasonId: InputMaybe<Scalars['ID']>;
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type AddRequesterRole = {
  name: Scalars['String'];
};

export type AddSpecialtyTeam = {
  affiliationId: Scalars['ID'];
  companyId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddSpecialtyTeamMember = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  specialtyTeamId: Scalars['ID'];
  title: InputMaybe<Scalars['String']>;
  weightInKg: Scalars['Float'];
};

export type AddState = {
  code: Scalars['String'];
  isLicenseRequiredToFly: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type AddSupportRequest = {
  companyId: Scalars['ID'];
  content: InputMaybe<Scalars['String']>;
  isEmailSent: Scalars['Boolean'];
  notes: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  subject: InputMaybe<Scalars['String']>;
  supportRequestStatus: SupportRequestStatus;
  supportRequestType: SupportRequestType;
};

export type AddTimeline = {
  activationRuleId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  items: InputMaybe<Array<InputMaybe<UpsertTimelineItem>>>;
  name: Scalars['String'];
  timelineType: InputMaybe<TimelineTypes>;
};

export type AddTimelineItem = {
  required: Scalars['Boolean'];
  sequence: Scalars['Int'];
  timelineId: Scalars['ID'];
  timestampTypeId: Scalars['ID'];
};

export type AddTimestamp = {
  cardId: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  operationId: InputMaybe<Scalars['ID']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  requestId: InputMaybe<Scalars['ID']>;
  time: Scalars['DateTime'];
  typeId: Scalars['ID'];
};

export type AddTimestampType = {
  companies: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  description: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  systemTimestampType: InputMaybe<SystemTimestampType>;
};

export type AddTimezone = {
  abbreviation: Scalars['String'];
  code: Scalars['String'];
  isDst: Scalars['Boolean'];
  name: Scalars['String'];
  utcOffset: Scalars['Int'];
};

export type AddTransferCenter = {
  communicationCenterId: Scalars['ID'];
  description: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AddTransferCenterRegion = {
  communicationCenterId: Scalars['ID'];
};

export type AddTransferReason = {
  name: Scalars['String'];
};

export type AddTransportOffer = {
  agencyLocationId: InputMaybe<Scalars['ID']>;
  baseId: InputMaybe<Scalars['ID']>;
  bearingInDegrees: InputMaybe<Scalars['Float']>;
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  crew: InputMaybe<Array<InputMaybe<UnitPositionSnapshotInput>>>;
  crewMustFlyToArriveAtSending: InputMaybe<Scalars['Boolean']>;
  crewNotified: InputMaybe<Scalars['DateTime']>;
  dateDeclinedOrAborted: InputMaybe<Scalars['DateTime']>;
  declineReasonId: InputMaybe<Scalars['ID']>;
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  declinedOrAbortedById: InputMaybe<Scalars['ID']>;
  distanceInMiles: InputMaybe<Scalars['Float']>;
  estimatedDepartureTimeInMinutes: InputMaybe<Scalars['Int']>;
  estimatedTimeEnRouteInMinutes: InputMaybe<Scalars['Int']>;
  etc: InputMaybe<Scalars['Float']>;
  homeBaseDistanceInMiles: InputMaybe<Scalars['Float']>;
  isInternalAgency: Scalars['Boolean'];
  isOnDelay: Scalars['Boolean'];
  isOneCallAgreement: Scalars['Boolean'];
  isReferral: InputMaybe<Scalars['Boolean']>;
  nonReferralReasonId: InputMaybe<Scalars['ID']>;
  nonReferralReasonNotes: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  onBaseETAInMinutes: InputMaybe<Scalars['Int']>;
  outOfServiceEventId: InputMaybe<Scalars['ID']>;
  patientOriginatesAtUnit: InputMaybe<Scalars['Boolean']>;
  preferredRank: InputMaybe<Scalars['Int']>;
  rank: Scalars['Int'];
  requestId: Scalars['ID'];
  response: TransportOfferResponse;
  responseReceived: InputMaybe<Scalars['DateTime']>;
  specialtyTeamETEInMinutes: InputMaybe<Scalars['Int']>;
  specialtyTeamETLOInMinutes: InputMaybe<Scalars['Int']>;
  status: TransportOfferStatus;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitDescription: InputMaybe<Scalars['String']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleCoordinates: InputMaybe<CoordinatesInput>;
  vehicleId: InputMaybe<Scalars['ID']>;
  vehicleType: InputMaybe<VehicleType>;
  wasBulkSkip: Scalars['Boolean'];
};

export type AddTransportReason = {
  name: Scalars['String'];
  operationType: InputMaybe<OperationType>;
};

export type AddTrip = {
  agencyId: InputMaybe<Scalars['ID']>;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  calculatedLoadedMiles: InputMaybe<Scalars['Float']>;
  gpsLoadedMiles: InputMaybe<Scalars['Float']>;
  operationId: Scalars['ID'];
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type AddTripLegManifestEntry = {
  abbreviation: Scalars['String'];
  addToFutureLegs: InputMaybe<Scalars['Boolean']>;
  crewMemberId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  passengerId: InputMaybe<Scalars['ID']>;
  personId: InputMaybe<Scalars['ID']>;
  positionName: InputMaybe<Scalars['String']>;
  positionType: InputMaybe<UnitPositionType>;
  tripLegId: Scalars['ID'];
  type: PassengerType;
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type AddTripPassenger = {
  abbreviation: Scalars['String'];
  crewMemberId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  personId: InputMaybe<Scalars['ID']>;
  positionName: InputMaybe<Scalars['String']>;
  positionType: InputMaybe<UnitPositionType>;
  tripId: Scalars['ID'];
  type: PassengerType;
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type AddUnit = {
  abbreviation: Scalars['String'];
  baseId: Scalars['ID'];
  completeFlightInstanceId: InputMaybe<Scalars['ID']>;
  emSystemResourceId: InputMaybe<Scalars['String']>;
  etloInMinutes: InputMaybe<Scalars['Int']>;
  excludeStates: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  integrations: Array<IntegrationSystem>;
  isAdministrative: InputMaybe<Scalars['Boolean']>;
  isExternallyManaged: Scalars['Boolean'];
  isSpare: Scalars['Boolean'];
  lastPilotUpdateById: InputMaybe<Scalars['ID']>;
  lastPilotUpdateTime: InputMaybe<Scalars['DateTime']>;
  maximumFlightRule: FlightRule;
  name: Scalars['String'];
  oemPlacardNumber: InputMaybe<Scalars['String']>;
  onBaseETAInMinutes: InputMaybe<Scalars['Int']>;
  pilotNotes: InputMaybe<Scalars['String']>;
  primaryOutOfServiceEventId: InputMaybe<Scalars['ID']>;
  regionId: Scalars['ID'];
  status: UnitStatus;
  updatePhoneNumbersFromExternal: Scalars['Boolean'];
  weatherStatus: WeatherStatus;
};

export type AddUnitActivationRule = {
  companyId: Scalars['ID'];
  maximumDistanceInMiles: InputMaybe<Scalars['Int']>;
  missionRoleTypes: Array<MissionRoleType>;
  operationTypes: Array<OperationType>;
  unitId: Scalars['ID'];
};

export type AddUnitEMSystemMapping = {
  divisionName: InputMaybe<Scalars['String']>;
  resourceId: Scalars['String'];
  sendGps: Scalars['Boolean'];
  unitId: Scalars['ID'];
};

export type AddUnitNote = {
  content: Scalars['String'];
  unitId: Scalars['ID'];
};

export type AddUnitOutOfServiceEvent = {
  address: InputMaybe<AddressInput>;
  alertTimeInMinutes: InputMaybe<Scalars['Int']>;
  alertWhenEventEnds: Scalars['Boolean'];
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  isAcknowledgementRequired: Scalars['Boolean'];
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  notes: InputMaybe<Scalars['String']>;
  oosRequestType: InputMaybe<OosRequestType>;
  paipEventId: InputMaybe<Scalars['ID']>;
  reasonId: Scalars['ID'];
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  type: OutOfServiceType;
  unitId: Scalars['ID'];
};

export type AddUnitPosition = {
  firstName: InputMaybe<Scalars['String']>;
  isFlightCrew: Scalars['Boolean'];
  isNonEmployee: Scalars['Boolean'];
  lastName: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  teamMemberId: InputMaybe<Scalars['ID']>;
  type: UnitPositionType;
  unitId: Scalars['ID'];
};

export type AddUnitShift = {
  endTimeInMinutes: Scalars['Int'];
  name: Scalars['String'];
  startTimeInMinutes: Scalars['Int'];
  unitId: Scalars['ID'];
};

export type AddVehicle = {
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  completeFlightId: InputMaybe<Scalars['ID']>;
  configurationClassId: InputMaybe<Scalars['ID']>;
  cruiseSpeed: InputMaybe<Scalars['Int']>;
  dateAcquired: InputMaybe<Scalars['DateTime']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  faaCompanyId: InputMaybe<Scalars['ID']>;
  flightLogProcess: FlightLogProcess;
  hideFromOOSRUM: Scalars['Boolean'];
  isPlaceholder: Scalars['Boolean'];
  isPositionTrackingEnabled: Scalars['Boolean'];
  isRetired: Scalars['Boolean'];
  isUnderLease: Scalars['Boolean'];
  makeId: InputMaybe<Scalars['ID']>;
  modelId: InputMaybe<Scalars['ID']>;
  phoneNumber: InputMaybe<Scalars['String']>;
  regionId: InputMaybe<Scalars['ID']>;
  registrationNumber: Scalars['String'];
  role: VehicleRole;
  serialNumber: InputMaybe<Scalars['String']>;
  skytracIMEI: InputMaybe<Scalars['String']>;
  stateInspectionRequired: Scalars['Boolean'];
  type: VehicleType;
  vehicleDescription: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['Int']>;
};

export type AddVehicleConfigurationClass = {
  engineCount: Scalars['Int'];
  engineParameters: Array<Scalars['String']>;
  legacyName: Scalars['String'];
  maintenanceSystemId: Scalars['String'];
  name: Scalars['String'];
};

export type AddVehicleControlZone = {
  companyId: Scalars['ID'];
  controlZoneId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type AddVehicleDisposition = {
  currentAgencyLocationId: InputMaybe<Scalars['ID']>;
  currentTripId: InputMaybe<Scalars['ID']>;
  currentTripLegId: InputMaybe<Scalars['ID']>;
  currentWaypointId: InputMaybe<Scalars['ID']>;
  latestPositionReportId: InputMaybe<Scalars['ID']>;
  status: VehicleStatus;
  vehicleId: Scalars['ID'];
  vehiclePositionSummaryId: InputMaybe<Scalars['ID']>;
};

export type AddVehicleMaintenance = {
  deferralDueDates: Array<DeferralDueDateWithOptionalIdInput>;
  id: InputMaybe<Scalars['ID']>;
  isReleasedFromOCF: InputMaybe<Scalars['Boolean']>;
  nextDues: Array<NextDueWithOptionalIdInput>;
  notes: InputMaybe<Scalars['String']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type AddVehicleMake = {
  name: Scalars['String'];
};

export type AddVehicleModel = {
  cruiseSpeedInMph: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AddVehicleNotificationGroup = {
  notificationGroupId: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type AddVehicleOutOfServiceEvent = {
  address: InputMaybe<AddressInput>;
  alertTimeInMinutes: InputMaybe<Scalars['Int']>;
  alertWhenEventEnds: Scalars['Boolean'];
  alternatePOC: InputMaybe<Scalars['String']>;
  amtPointOfContactId: InputMaybe<Scalars['ID']>;
  assignedBaseId: InputMaybe<Scalars['ID']>;
  businessUnitCompanyId: InputMaybe<Scalars['ID']>;
  crew: InputMaybe<Array<InputMaybe<OutOfServiceCrewInput>>>;
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  humanErrorDamageType: InputMaybe<HumanErrorDamageType>;
  isAMTAvailable: InputMaybe<Scalars['Boolean']>;
  isAcknowledgementRequired: Scalars['Boolean'];
  isAirworthy: Scalars['Boolean'];
  isBirdStrike: Scalars['Boolean'];
  isEventAlreadyClosed: InputMaybe<Scalars['Boolean']>;
  isFAR135415Reportable: InputMaybe<Scalars['Boolean']>;
  isFAR135417Reportable: InputMaybe<Scalars['Boolean']>;
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  isPatientOnboard: Scalars['Boolean'];
  isPlanned: Scalars['Boolean'];
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  maintenanceLocation: InputMaybe<Scalars['String']>;
  maintenanceTypes: InputMaybe<Array<InputMaybe<OosTicketMaintenanceType>>>;
  mxDuringPeakTimeReason: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  oosRequestType: InputMaybe<OosRequestType>;
  opportunityMXTypes: InputMaybe<Array<InputMaybe<OpportunityMXType>>>;
  outOfServiceTicketId: InputMaybe<Scalars['ID']>;
  paipEventId: InputMaybe<Scalars['ID']>;
  parentOutOfServiceEventId: InputMaybe<Scalars['ID']>;
  qarReasons: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  reasonId: Scalars['ID'];
  rtsDelayReasonTypes: InputMaybe<Array<InputMaybe<RtsDelayReasonType>>>;
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  spareVehicleId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  ticketDescription: InputMaybe<Scalars['String']>;
  type: OutOfServiceType;
  vehicleId: Scalars['ID'];
  waitingForParts: Scalars['Boolean'];
  waitingForTooling: Scalars['Boolean'];
};

export type AddVehicleStateInspection = {
  inspectionDate: Scalars['DateTime'];
  stateAbbrevation: Scalars['String'];
  vehicleId: Scalars['ID'];
};

export type AddWaypoint = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  arrivalTime: InputMaybe<Scalars['DateTime']>;
  arrivingType: InputMaybe<WaypointType>;
  currentEtaId: InputMaybe<Scalars['ID']>;
  departureTime: InputMaybe<Scalars['DateTime']>;
  estimatedDurationId: InputMaybe<Scalars['ID']>;
  isPatientDropoff: InputMaybe<Scalars['Boolean']>;
  isPatientPickup: InputMaybe<Scalars['Boolean']>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  timezoneCd: InputMaybe<Scalars['String']>;
  type: WaypointType;
};

export type AddWebOrderLog = {
  acknowledgedById: InputMaybe<Scalars['ID']>;
  changes: InputMaybe<Array<InputMaybe<WebOrderLogEntityChangesInput>>>;
  dateAcknowledged: InputMaybe<Scalars['DateTime']>;
  entityId: InputMaybe<Scalars['ID']>;
  entityType: InputMaybe<EntityType>;
  errors: InputMaybe<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
  name: Scalars['String'];
  requestJson: Scalars['String'];
};

export type Address = {
  __typename: 'Address';
  city: Maybe<Scalars['String']>;
  coordinates: Maybe<Coordinates>;
  country: Maybe<Scalars['String']>;
  county: Maybe<Scalars['String']>;
  gpsId: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city: InputMaybe<Scalars['String']>;
  coordinates: InputMaybe<CoordinatesInput>;
  country: InputMaybe<Scalars['String']>;
  county: InputMaybe<Scalars['String']>;
  gpsId: InputMaybe<Scalars['String']>;
  postalCode: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
  streetAddress: InputMaybe<Scalars['String']>;
};

export type AddressResult = {
  __typename: 'AddressResult';
  address: Address;
  hasSpecificMatch: Scalars['Boolean'];
  quality: GeocodeResultQuality;
};

export enum AffiliationType {
  Agency = 'Agency',
  Competitor = 'Competitor',
  Internal = 'Internal',
  Other = 'Other',
  Psap = 'Psap',
  ReceivingFacility = 'ReceivingFacility',
  SendingFacility = 'SendingFacility',
  SisterCompany = 'SisterCompany',
  Unspecified = 'Unspecified',
}

export type Agency = Entity &
  Evented & {
    __typename: 'Agency';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isCompetitor: Scalars['Boolean'];
    isInternallyOwned: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    locations: Array<AgencyLocation>;
    name: Scalars['String'];
    notes: Maybe<Scalars['String']>;
    parentCompany: Maybe<Company>;
    parentCompanyId: Maybe<Scalars['ID']>;
    trips: Maybe<Array<Maybe<Trip>>>;
    trmUserAgencies: Array<TrmUserAgency>;
    type: AgencyType;
  };

export type Agency_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AgencyCollection = {
  __typename: 'AgencyCollection';
  items: Array<Agency>;
  meta: AgencyCollectionMetadata;
};

export type AgencyCollectionMetadata = CollectionMetadata & {
  __typename: 'AgencyCollectionMetadata';
  total: Scalars['Int'];
};

export type AgencyFilter = {
  agencyId: InputMaybe<Scalars['ID']>;
  agencyLocationNameLike: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type AgencyLocation = Entity &
  Evented & {
    __typename: 'AgencyLocation';
    _events: MessageEnvelopeCollection;
    agency: Agency;
    agencyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    emailAddress: Maybe<Scalars['String']>;
    estimatedDepartureTimeInMinutes: Maybe<Scalars['Int']>;
    faxPhoneNumber: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isInTransportNet: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    notes: Maybe<Scalars['String']>;
    primaryPhoneNumber: Maybe<Scalars['String']>;
    rendezvousRequests: Maybe<Array<Maybe<RendezvousRequest>>>;
    requesters: Maybe<Array<Maybe<Requester>>>;
    secondaryPhoneNumber: Maybe<Scalars['String']>;
    smsPhoneNumber: Maybe<Scalars['String']>;
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
    trips: Maybe<Array<Maybe<Trip>>>;
    vehicleDispositions: Maybe<Array<Maybe<VehicleDisposition>>>;
    vehicleType: Maybe<VehicleType>;
  };

export type AgencyLocation_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AgencyLocationCollection = {
  __typename: 'AgencyLocationCollection';
  items: Array<AgencyLocation>;
  meta: AgencyLocationCollectionMetadata;
};

export type AgencyLocationCollectionMetadata = CollectionMetadata & {
  __typename: 'AgencyLocationCollectionMetadata';
  total: Scalars['Int'];
};

export type AgencyLocationFilter = {
  agencyId: InputMaybe<Scalars['ID']>;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  locationId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type AgencyLocationQueries = {
  __typename: 'AgencyLocationQueries';
  all: AgencyLocationCollection;
  byId: Maybe<AgencyLocation>;
  byLocationId: Maybe<AgencyLocation>;
};

export type AgencyLocationQueriesallArgs = {
  filter: InputMaybe<AgencyLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AgencyLocationQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type AgencyLocationQueriesbyLocationIdArgs = {
  id: Scalars['ID'];
};

export type AgencyQueries = {
  __typename: 'AgencyQueries';
  all: AgencyCollection;
  byId: Maybe<Agency>;
};

export type AgencyQueriesallArgs = {
  filter: InputMaybe<AgencyFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AgencyQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum AgencyType {
  AirAmbulance = 'AirAmbulance',
  FireService = 'FireService',
  GroundAmbulance = 'GroundAmbulance',
  Other = 'Other',
  Psap = 'Psap',
  Unspecified = 'Unspecified',
}

export type Airport = Entity &
  Evented & {
    __typename: 'Airport';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    airportCodeType: AirportCodeType;
    airportType: Scalars['String'];
    code: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    fbos: Array<Fbo>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    preferredFbo: Maybe<Fbo>;
    preferredFboId: Maybe<Scalars['ID']>;
    sourceSystemId: Maybe<Scalars['Int']>;
  };

export type Airport_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AirportByIdOptions = {
  includeDeleted: InputMaybe<Scalars['Boolean']>;
};

export enum AirportCodeType {
  FAA = 'FAA',
  IATA = 'IATA',
  ICAO = 'ICAO',
}

export type AirportCollection = {
  __typename: 'AirportCollection';
  items: Array<Airport>;
  meta: AirportCollectionMetadata;
};

export type AirportCollectionMetadata = CollectionMetadata & {
  __typename: 'AirportCollectionMetadata';
  total: Scalars['Int'];
};

export type AirportFilter = {
  airportId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type AirportQueries = {
  __typename: 'AirportQueries';
  all: AirportCollection;
  byId: Maybe<Airport>;
};

export type AirportQueriesallArgs = {
  filter: InputMaybe<AirportFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AirportQueriesbyIdArgs = {
  id: Scalars['ID'];
  options: InputMaybe<AirportByIdOptions>;
};

export type Alert = Entity &
  Evented & {
    __typename: 'Alert';
    _events: MessageEnvelopeCollection;
    activationRule: ActivationRule;
    activationRuleId: Scalars['ID'];
    activeAlerts: Maybe<Array<Maybe<ActiveAlert>>>;
    content: Scalars['String'];
    createdBy: Maybe<Person>;
    createdById: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    effectiveDate: Maybe<Scalars['DateTime']>;
    entityType: EntityType;
    expirationDate: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    isAudible: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    lifecycleStage: AlertLifecycleStage;
    paused: Maybe<Scalars['Boolean']>;
    requiresAcknowledgement: Scalars['Boolean'];
    /** @deprecated Use definitions/entityType */
    target: Maybe<AlertTarget>;
    title: Maybe<Scalars['String']>;
    urgency: AlertUrgency;
  };

export type Alert_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AlertCollection = {
  __typename: 'AlertCollection';
  items: Array<Alert>;
  meta: AlertCollectionMetadata;
};

export type AlertCollectionMetadata = CollectionMetadata & {
  __typename: 'AlertCollectionMetadata';
  total: Scalars['Int'];
};

export type AlertFilter = {
  activationRuleNameLike: InputMaybe<Scalars['String']>;
  countyLike: InputMaybe<Scalars['String']>;
  locationId: InputMaybe<Scalars['String']>;
  medicalFacilityId: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export enum AlertLifecycleStage {
  PreAssignment = 'PreAssignment',
  Unspecified = 'Unspecified',
}

export type AlertQueries = {
  __typename: 'AlertQueries';
  all: AlertCollection;
  byActivationRuleId: Maybe<Alert>;
  byId: Maybe<Alert>;
};

export type AlertQueriesallArgs = {
  filter: InputMaybe<AlertFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AlertQueriesbyActivationRuleIdArgs = {
  activationRuleId: Scalars['ID'];
};

export type AlertQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum AlertTarget {
  Card = 'Card',
  Company = 'Company',
  FleetStatusViewer = 'FleetStatusViewer',
  Region = 'Region',
}

export enum AlertUrgency {
  Critical = 'Critical',
  Information = 'Information',
  Warning = 'Warning',
}

export enum AmrUtilizationStatus {
  NoResourcesAvailable = 'NoResourcesAvailable',
  NoServiceAvailable = 'NoServiceAvailable',
  NotConsidered = 'NotConsidered',
  UnsatisfactoryEta = 'UnsatisfactoryEta',
  Unspecified = 'Unspecified',
  Utilized = 'Utilized',
}

export type ApplicationNotification = Entity &
  Evented & {
    __typename: 'ApplicationNotification';
    _events: MessageEnvelopeCollection;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']>;
    createdBy: Maybe<Person>;
    createdById: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dismissable: Scalars['Boolean'];
    displayOnBanner: Scalars['Boolean'];
    effectiveDate: Maybe<Scalars['DateTime']>;
    expirationDate: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notification: Scalars['String'];
    region: Maybe<Region>;
    regionId: Maybe<Scalars['ID']>;
    title: Maybe<Scalars['String']>;
    urgency: ApplicationNotificationUrgency;
  };

export type ApplicationNotification_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ApplicationNotificationCollection = {
  __typename: 'ApplicationNotificationCollection';
  items: Array<ApplicationNotification>;
  meta: ApplicationNotificationCollectionMetadata;
};

export type ApplicationNotificationCollectionMetadata = CollectionMetadata & {
  __typename: 'ApplicationNotificationCollectionMetadata';
  total: Scalars['Int'];
};

export type ApplicationNotificationFilter = {
  applicationNotificationId: InputMaybe<Scalars['ID']>;
};

export type ApplicationNotificationQueries = {
  __typename: 'ApplicationNotificationQueries';
  all: ApplicationNotificationCollection;
  byId: Maybe<ApplicationNotification>;
};

export type ApplicationNotificationQueriesallArgs = {
  filter: InputMaybe<ApplicationNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ApplicationNotificationQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum ApplicationNotificationUrgency {
  Critical = 'Critical',
  Information = 'Information',
  Warning = 'Warning',
}

export type ApproveMedicalFacility = {
  medicalFacilityId: Scalars['ID'];
};

export type ApproveTrmUser = {
  id: Scalars['ID'];
};

export enum ArchiveEntityType {
  CardNote = 'CardNote',
  Eta = 'Eta',
  PositionReport = 'PositionReport',
  Timestamp = 'Timestamp',
  TransportOffer = 'TransportOffer',
  WebhookEventBody = 'WebhookEventBody',
  WebhookSubscription = 'WebhookSubscription',
  WebhookSubscriptionEvent = 'WebhookSubscriptionEvent',
}

export type ArchiveLog = Entity &
  Evented & {
    __typename: 'ArchiveLog';
    _events: MessageEnvelopeCollection;
    archiveEntityType: ArchiveEntityType;
    archivedUntilDate: Scalars['DateTime'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isError: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notes: Maybe<Scalars['String']>;
  };

export type ArchiveLog_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ArchiveLogCollection = {
  __typename: 'ArchiveLogCollection';
  items: Array<ArchiveLog>;
  meta: ArchiveLogCollectionMetadata;
};

export type ArchiveLogCollectionMetadata = CollectionMetadata & {
  __typename: 'ArchiveLogCollectionMetadata';
  total: Scalars['Int'];
};

export type ArchiveLogLatestByType = {
  __typename: 'ArchiveLogLatestByType';
  archiveEntityType: ArchiveEntityType;
  archivedUntilDate: Scalars['DateTime'];
};

export type ArchiveLogQueries = {
  __typename: 'ArchiveLogQueries';
  latest: Maybe<ArchiveLog>;
  latestAll: ArchiveLogCollection;
};

export type ArchiveLogQuerieslatestArgs = {
  type: ArchiveEntityType;
};

export type ArchiveMedicalFacility = {
  archiveNotes: InputMaybe<Scalars['String']>;
  medicalFacilityId: Scalars['ID'];
};

export type ArchivePassdownLog = {
  archivedById: Scalars['ID'];
  passdownLogId: Scalars['ID'];
};

export type ArriveVehicle = {
  note: InputMaybe<Scalars['String']>;
  odometerReading: InputMaybe<Scalars['Float']>;
  vehicleId: Scalars['ID'];
};

export type AssignVehicle = {
  unitId: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type AssignmentDelayedReason = Entity &
  Evented & {
    __typename: 'AssignmentDelayedReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requests: Maybe<Array<Maybe<Request>>>;
  };

export type AssignmentDelayedReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AssignmentDelayedReasonCollection = {
  __typename: 'AssignmentDelayedReasonCollection';
  items: Array<AssignmentDelayedReason>;
  meta: AssignmentDelayedReasonCollectionMetadata;
};

export type AssignmentDelayedReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'AssignmentDelayedReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type Attachment = Entity &
  Evented & {
    __typename: 'Attachment';
    _events: MessageEnvelopeCollection;
    attachmentEntityType: AttachmentEntityType;
    contentType: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Maybe<Scalars['ID']>;
    fileName: Scalars['String'];
    fileSizeInBytes: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
  };

export type Attachment_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AttachmentCollection = {
  __typename: 'AttachmentCollection';
  items: Array<Attachment>;
  meta: AttachmentCollectionMetadata;
};

export type AttachmentCollectionMetadata = CollectionMetadata & {
  __typename: 'AttachmentCollectionMetadata';
  total: Scalars['Int'];
};

export enum AttachmentEntityType {
  Card = 'Card',
  ReleaseNote = 'ReleaseNote',
  SupportRequest = 'SupportRequest',
  Unspecified = 'Unspecified',
  Vehicle = 'Vehicle',
}

export type AttachmentFilter = {
  entityId: InputMaybe<Scalars['ID']>;
  entityType: InputMaybe<AttachmentEntityType>;
};

export type AttachmentQueries = {
  __typename: 'AttachmentQueries';
  all: AttachmentCollection;
  byId: Maybe<Attachment>;
};

export type AttachmentQueriesallArgs = {
  filter: InputMaybe<AttachmentFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AttachmentQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type AuditEntityChange = {
  __typename: 'AuditEntityChange';
  changeType: Scalars['String'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id: Scalars['ID'];
  properties: Array<AuditPropertyChange>;
};

export type AuditEntityChangeInput = {
  changeType: Scalars['String'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  id: Scalars['ID'];
  properties: Array<AuditPropertyChangeInput>;
};

export type AuditLog = Entity &
  Evented & {
    __typename: 'AuditLog';
    _events: MessageEnvelopeCollection;
    activityId: Maybe<Scalars['String']>;
    apiKeyId: Maybe<Scalars['ID']>;
    commandName: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityChanges: Maybe<Array<Maybe<AuditEntityChange>>>;
    errorMessage: Maybe<Scalars['String']>;
    eventCategory: Scalars['String'];
    id: Scalars['ID'];
    impersonatedBy: Maybe<Scalars['String']>;
    ipAddress: Maybe<Scalars['String']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    occurredAt: Scalars['DateTime'];
    sourceSystem: Maybe<Scalars['String']>;
    success: Scalars['Boolean'];
    userEmail: Maybe<Scalars['String']>;
    userId: Maybe<Scalars['ID']>;
  };

export type AuditLog_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type AuditLogCollection = {
  __typename: 'AuditLogCollection';
  items: Array<AuditLog>;
  meta: AuditLogCollectionMetadata;
};

export type AuditLogCollectionMetadata = CollectionMetadata & {
  __typename: 'AuditLogCollectionMetadata';
  total: Scalars['Int'];
};

export type AuditPropertyChange = {
  __typename: 'AuditPropertyChange';
  current: Scalars['String'];
  dataTypeName: Scalars['String'];
  name: Scalars['String'];
  previous: Scalars['String'];
};

export type AuditPropertyChangeInput = {
  current: Scalars['String'];
  dataTypeName: Scalars['String'];
  name: Scalars['String'];
  previous: Scalars['String'];
};

export type AuthorizeClientSyncAccess = {
  optionalEmail: InputMaybe<Scalars['String']>;
};

export enum AutomatedAlertAlgorithmType {
  TimeElapsedFromTimestamp = 'TimeElapsedFromTimestamp',
}

export type Base = Entity &
  Evented & {
    __typename: 'Base';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    additionalCompanies: Maybe<Array<Maybe<IdListItem>>>;
    aviationCompanyId: Maybe<Scalars['ID']>;
    baseControlZones: Array<BaseControlZone>;
    brandName: Maybe<Scalars['String']>;
    businessModel: BusinessModel;
    communicationCenterCustomIdentifiers: Maybe<Array<Maybe<IdNameListItem>>>;
    company: Company;
    companyId: Scalars['ID'];
    crewPhoneNumber1: Maybe<Scalars['String']>;
    crewPhoneNumber2: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateLastUpdatedFromGMRWorkday: Maybe<Scalars['DateTime']>;
    dateOfMaturity: Maybe<Scalars['DateTime']>;
    dispatchBaseId: Maybe<Scalars['ID']>;
    enableFlightLogDutyLog: Maybe<Scalars['Boolean']>;
    estimatedLiftoffTime: Maybe<Scalars['Int']>;
    fuelTanks: Maybe<Array<Maybe<FuelTank>>>;
    gmrWorkdayLocationId: Maybe<Scalars['String']>;
    hoursOfOperation: HoursOfOperation;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    licenseNumber: Maybe<Scalars['String']>;
    location: Location;
    locationId: Scalars['ID'];
    medicalControlContacts: Array<BaseMedicalControlContact>;
    medicalFacilityId: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    oemAssets: Maybe<Array<Maybe<OemAsset>>>;
    oemPlans: Array<OemPlan>;
    operationsStarted: Maybe<Scalars['DateTime']>;
    operationsTerminated: Maybe<Scalars['DateTime']>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceTickets: Maybe<Array<Maybe<OutOfServiceTicket>>>;
    people: Maybe<Array<Maybe<Person>>>;
    pilotPhoneNumber: Maybe<Scalars['String']>;
    plannedOperationsStart: Maybe<Scalars['DateTime']>;
    primaryPhoneNumber: Maybe<Scalars['String']>;
    programs: Array<ProgramBase>;
    regions: Array<RegionBase>;
    reportBaseId: Maybe<Scalars['ID']>;
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
    unitSummaries: Array<UnitSummary>;
    units: Array<Unit>;
    workdayBaseId: Maybe<Scalars['ID']>;
  };

export type Base_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type BaseCollection = {
  __typename: 'BaseCollection';
  items: Array<Base>;
  meta: BaseCollectionMetadata;
};

export type BaseCollectionMetadata = CollectionMetadata & {
  __typename: 'BaseCollectionMetadata';
  total: Scalars['Int'];
};

export type BaseControlZone = Entity &
  Evented & {
    __typename: 'BaseControlZone';
    _events: MessageEnvelopeCollection;
    base: Base;
    baseId: Scalars['ID'];
    company: Company;
    companyId: Scalars['ID'];
    controlZone: ControlZone;
    controlZoneId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
  };

export type BaseControlZone_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type BaseControlZoneCollection = {
  __typename: 'BaseControlZoneCollection';
  items: Array<BaseControlZone>;
  meta: BaseControlZoneCollectionMetadata;
};

export type BaseControlZoneCollectionMetadata = CollectionMetadata & {
  __typename: 'BaseControlZoneCollectionMetadata';
  total: Scalars['Int'];
};

export type BaseControlZoneFilter = {
  baseId: InputMaybe<Scalars['ID']>;
  controlZoneId: InputMaybe<Scalars['ID']>;
};

export type BaseControlZoneQueries = {
  __typename: 'BaseControlZoneQueries';
  all: BaseControlZoneCollection;
  byId: Maybe<VehicleControlZone>;
};

export type BaseControlZoneQueriesallArgs = {
  filter: InputMaybe<BaseControlZoneFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type BaseControlZoneQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type BaseFilter = {
  allExceptCompanyId: InputMaybe<Scalars['ID']>;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  baseId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  companyIdList: InputMaybe<Array<Scalars['ID']>>;
  customDispatchBaseId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
  showAll: InputMaybe<Scalars['Boolean']>;
};

export type BaseMedicalControlContact = Entity &
  Evented & {
    __typename: 'BaseMedicalControlContact';
    _events: MessageEnvelopeCollection;
    base: Base;
    baseId: Scalars['ID'];
    baseMedicalControlContactStates: Maybe<Array<Maybe<BaseMedicalControlContactState>>>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    person: Person;
    personId: Scalars['ID'];
    rank: Scalars['Int'];
    specialty: Maybe<Scalars['String']>;
  };

export type BaseMedicalControlContact_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type BaseMedicalControlContactCollection = {
  __typename: 'BaseMedicalControlContactCollection';
  items: Array<BaseMedicalControlContact>;
  meta: BaseMedicalControlContactCollectionMetadata;
};

export type BaseMedicalControlContactCollectionMetadata = CollectionMetadata & {
  __typename: 'BaseMedicalControlContactCollectionMetadata';
  total: Scalars['Int'];
};

export type BaseMedicalControlContactQueries = {
  __typename: 'BaseMedicalControlContactQueries';
  byBaseId: BaseMedicalControlContactCollection;
  byId: Maybe<BaseMedicalControlContact>;
  byPersonId: BaseMedicalControlContactCollection;
};

export type BaseMedicalControlContactQueriesbyBaseIdArgs = {
  id: Scalars['ID'];
};

export type BaseMedicalControlContactQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type BaseMedicalControlContactQueriesbyPersonIdArgs = {
  id: Scalars['ID'];
};

export type BaseMedicalControlContactState = Entity &
  Evented & {
    __typename: 'BaseMedicalControlContactState';
    _events: MessageEnvelopeCollection;
    baseMedicalControlContact: Maybe<BaseMedicalControlContact>;
    baseMedicalControlContactId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    stateAbbrevation: Scalars['String'];
  };

export type BaseMedicalControlContactState_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type BaseMedicalControlContactStateCollection = {
  __typename: 'BaseMedicalControlContactStateCollection';
  items: Array<BaseMedicalControlContactState>;
  meta: BaseMedicalControlContactStateCollectionMetadata;
};

export type BaseMedicalControlContactStateCollectionMetadata = CollectionMetadata & {
  __typename: 'BaseMedicalControlContactStateCollectionMetadata';
  total: Scalars['Int'];
};

export type BaseQueries = {
  __typename: 'BaseQueries';
  all: BaseCollection;
};

export type BaseQueriesallArgs = {
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type BeginAssignment = {
  requestId: Scalars['ID'];
};

export type BeginOutOfServiceEvent = {
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  id: Scalars['ID'];
  isAcknowledgementRequired: Scalars['Boolean'];
  isAirworthy: Scalars['Boolean'];
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  notes: InputMaybe<Scalars['String']>;
  oosRequestType: InputMaybe<OosRequestType>;
  reasonId: Scalars['ID'];
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  type: OutOfServiceType;
};

export type BeginTransportOffer = {
  crewMustFlyToArriveAtSending: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export enum BusinessModel {
  Community = 'Community',
  Ground = 'Ground',
  Traditional = 'Traditional',
  Unspecified = 'Unspecified',
}

export type CalculateEtas = {
  id: Scalars['ID'];
};

export type CancelOperation = {
  cancelRequest: Scalars['Boolean'];
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  externalActionId: InputMaybe<Scalars['ID']>;
  operationId: Scalars['ID'];
};

export type CancelReceivingFacilityRequest = {
  id: Scalars['ID'];
};

export type CancelRequest = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  declineReasonId: InputMaybe<Scalars['ID']>;
  declineReasonNotes: InputMaybe<Scalars['String']>;
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  externalActionId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  nonReferralReasonId: InputMaybe<Scalars['ID']>;
  nonReferralReasonNotes: InputMaybe<Scalars['String']>;
  transportOfferToDeclineId: InputMaybe<Scalars['ID']>;
};

export type CancelRequestFromTransferCenter = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CancelTransportOffer = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type CancellationCategory = Entity &
  Evented & {
    __typename: 'CancellationCategory';
    _events: MessageEnvelopeCollection;
    cancellationReasons: Maybe<Array<Maybe<CancellationReason>>>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    defaultCancellationReason: Maybe<CancellationReason>;
    defaultCancellationReasonId: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    isVisibleInOps: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type CancellationCategory_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CancellationCategoryCollection = {
  __typename: 'CancellationCategoryCollection';
  items: Array<CancellationCategory>;
  meta: CancellationCategoryCollectionMetadata;
};

export type CancellationCategoryCollectionMetadata = CollectionMetadata & {
  __typename: 'CancellationCategoryCollectionMetadata';
  total: Scalars['Int'];
};

export type CancellationCategoryFilter = {
  first: InputMaybe<Scalars['Int']>;
  nameLike: InputMaybe<Scalars['String']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CancellationCategoryQueries = {
  __typename: 'CancellationCategoryQueries';
  all: CancellationCategoryCollection;
  byId: Maybe<CancellationCategory>;
};

export type CancellationCategoryQueriesallArgs = {
  filter: InputMaybe<CancellationCategoryFilter>;
};

export type CancellationCategoryQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CancellationReason = Entity &
  Evented & {
    __typename: 'CancellationReason';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    canBeUnitCancellationReason: Maybe<Scalars['Boolean']>;
    cancellationCategories: Maybe<Array<Maybe<CancellationCategory>>>;
    cancellationCategory: Maybe<CancellationCategory>;
    cancellationCategoryId: Maybe<Scalars['ID']>;
    cancellationSecondaryReasons: Array<CancellationSecondaryReason>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isTransferCenterReason: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    nonReferralReasons: Maybe<Array<Maybe<NonReferralReason>>>;
    requests: Maybe<Array<Maybe<Request>>>;
    secondaryReasonRequired: Scalars['Boolean'];
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
  };

export type CancellationReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CancellationReasonCollection = {
  __typename: 'CancellationReasonCollection';
  items: Array<CancellationReason>;
  meta: CancellationReasonCollectionMetadata;
};

export type CancellationReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'CancellationReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type CancellationReasonFilter = {
  cancellationCategoryId: InputMaybe<Scalars['ID']>;
  excludeReasonsWithSecondary: InputMaybe<Scalars['Boolean']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type CancellationReasonQueries = {
  __typename: 'CancellationReasonQueries';
  all: CancellationReasonCollection;
  byCategoryId: CancellationReasonCollection;
  byId: Maybe<CancellationReason>;
};

export type CancellationReasonQueriesallArgs = {
  filter: InputMaybe<CancellationReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CancellationReasonQueriesbyCategoryIdArgs = {
  id: Scalars['ID'];
};

export type CancellationReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CancellationSecondaryReason = Entity &
  Evented & {
    __typename: 'CancellationSecondaryReason';
    _events: MessageEnvelopeCollection;
    cancellationReason: CancellationReason;
    cancellationReasonId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    nonReferralReasons: Maybe<Array<Maybe<NonReferralReason>>>;
    requests: Maybe<Array<Maybe<Request>>>;
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
  };

export type CancellationSecondaryReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CancellationSecondaryReasonCollection = {
  __typename: 'CancellationSecondaryReasonCollection';
  items: Array<CancellationSecondaryReason>;
  meta: CancellationSecondaryReasonCollectionMetadata;
};

export type CancellationSecondaryReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'CancellationSecondaryReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type CancellationSecondaryReasonFilter = {
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type CancellationSecondaryReasonQueries = {
  __typename: 'CancellationSecondaryReasonQueries';
  all: CancellationSecondaryReasonCollection;
  byId: Maybe<CancellationSecondaryReason>;
};

export type CancellationSecondaryReasonQueriesallArgs = {
  filter: InputMaybe<CancellationSecondaryReasonFilter>;
};

export type CancellationSecondaryReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type Capability = Entity &
  Evented & {
    __typename: 'Capability';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    description: Scalars['String'];
    entityCapabilities: Array<EntityCapability>;
    entityType: EntityType;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type Capability_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CapabilityCollection = {
  __typename: 'CapabilityCollection';
  items: Array<Capability>;
  meta: CapabilityCollectionMetadata;
};

export type CapabilityCollectionMetadata = CollectionMetadata & {
  __typename: 'CapabilityCollectionMetadata';
  total: Scalars['Int'];
};

export type CapabilityFilter = {
  entityType: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type CapabilityQueries = {
  __typename: 'CapabilityQueries';
  all: CapabilityCollection;
  byId: Maybe<Capability>;
};

export type CapabilityQueriesallArgs = {
  filter: InputMaybe<CapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CapabilityQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type Card = Entity &
  Evented & {
    __typename: 'Card';
    _events: MessageEnvelopeCollection;
    activeAlerts: Array<ActiveAlert>;
    activeCardUnitOfferings: Array<ActiveCardUnitOffering>;
    activeTimelines: Array<ActiveTimeline>;
    apiWebhookSubscriptionId: Maybe<Scalars['ID']>;
    attachments: Array<Attachment>;
    cardNumber: Scalars['String'];
    closeComment: Maybe<Scalars['String']>;
    companyId: Scalars['ID'];
    createdById: Maybe<Scalars['ID']>;
    crewWillTransportWithReplacementGroundUnit: Maybe<Scalars['Boolean']>;
    dateCardClosed: Maybe<Scalars['DateTime']>;
    dateContactCompleted: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    diversionType: Maybe<DiversionType>;
    gmrCADNumber: Maybe<Scalars['String']>;
    gmrUtilizationStatus: Maybe<AmrUtilizationStatus>;
    id: Scalars['ID'];
    isBillable: Maybe<Scalars['Boolean']>;
    isLocked: Maybe<Scalars['Boolean']>;
    lastOperationId: Maybe<Scalars['ID']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    linkedCardId: Maybe<Scalars['ID']>;
    medicalControlContactLogEntries: Array<MedicalControlContactLogEntry>;
    notBillableComment: Maybe<Scalars['String']>;
    notBillableType: Maybe<NotBillableType>;
    notes: Array<CardNote>;
    notifications: Maybe<Array<Maybe<Notification>>>;
    operation: Maybe<Operation>;
    operationId: Maybe<Scalars['ID']>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    plannedCompletionTime: Maybe<Scalars['DateTime']>;
    postTransportDebriefCompleted: Maybe<Scalars['Boolean']>;
    questionnaireResponses: Array<QuestionnaireResponse>;
    reOpenComment: Maybe<Scalars['String']>;
    reOpenReason: Maybe<CardReOpenReason>;
    reOpenReasonId: Maybe<Scalars['ID']>;
    receivingFacilityRequests: Array<ReceivingFacilityRequest>;
    request: Maybe<Request>;
    requestId: Maybe<Scalars['ID']>;
    status: CardStatus;
    timestamps: Array<Timestamp>;
    transferredFromCardId: Maybe<Scalars['ID']>;
    transferredToCardId: Maybe<Scalars['ID']>;
    vehicleSummaries: Maybe<Array<Maybe<VehicleSummary>>>;
  };

export type Card_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum CardActivityType {
  CardClosed = 'CardClosed',
  StandbyActivated = 'StandbyActivated',
}

export enum CardCallStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

export type CardCollection = {
  __typename: 'CardCollection';
  items: Array<Card>;
  meta: CardCollectionMetadata;
};

export type CardCollectionMetadata = CollectionMetadata & {
  __typename: 'CardCollectionMetadata';
  total: Scalars['Int'];
};

export type CardCrewPosition = {
  __typename: 'CardCrewPosition';
  employeeId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  personId: Maybe<Scalars['ID']>;
  positionId: Scalars['ID'];
  role: Scalars['String'];
};

export type CardCrewPositionInput = {
  employeeId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  personId: InputMaybe<Scalars['ID']>;
  positionId: Scalars['ID'];
  role: Scalars['String'];
};

export type CardFilter = {
  cardNumberLike: InputMaybe<Scalars['String']>;
  cardStatus: InputMaybe<CardStatus>;
  companyId: InputMaybe<Scalars['ID']>;
  excludeBasesExcept: InputMaybe<Array<Scalars['ID']>>;
  fromLocationId: InputMaybe<Scalars['ID']>;
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  operationStatus: InputMaybe<OperationStatus>;
  operationType: InputMaybe<OperationType>;
  patientNameLike: InputMaybe<Scalars['String']>;
  requestRegionId: InputMaybe<Scalars['ID']>;
  serviceDateRange: InputMaybe<DateRangeFilter>;
  toLocationId: InputMaybe<Scalars['ID']>;
  unitAbbreviationLike: InputMaybe<Scalars['String']>;
  unitNameLike: InputMaybe<Scalars['String']>;
  withStatuses: InputMaybe<Array<CardStatus>>;
  withoutRequestStatuses: InputMaybe<Array<RequestStatus>>;
  withoutStatuses: InputMaybe<Array<CardStatus>>;
};

export type CardLink = Entity &
  Evented & {
    __typename: 'CardLink';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    fromCardId: Scalars['ID'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    rendezvousRequest: Maybe<RendezvousRequest>;
    rendezvousRequestId: Maybe<Scalars['ID']>;
    toCardId: Scalars['ID'];
    toCardNumber: Scalars['String'];
    type: CardLinkType;
  };

export type CardLink_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardLinkCollection = {
  __typename: 'CardLinkCollection';
  items: Array<CardLink>;
  meta: CardLinkCollectionMetadata;
};

export type CardLinkCollectionMetadata = CollectionMetadata & {
  __typename: 'CardLinkCollectionMetadata';
  total: Scalars['Int'];
};

export type CardLinkFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  fromCardId: InputMaybe<Scalars['ID']>;
  fromOrToCardId: InputMaybe<Scalars['ID']>;
  toCardId: InputMaybe<Scalars['ID']>;
  type: InputMaybe<CardLinkType>;
};

export type CardLinkQueries = {
  __typename: 'CardLinkQueries';
  all: CardLinkCollection;
};

export type CardLinkQueriesallArgs = {
  filter: InputMaybe<CardLinkFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum CardLinkType {
  Referral = 'Referral',
  SupportLeg = 'SupportLeg',
}

export type CardManualPositionReport = {
  __typename: 'CardManualPositionReport';
  altitude: Maybe<Scalars['Float']>;
  heading: Maybe<Scalars['Float']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  positionReportId: Scalars['ID'];
  positionTime: Scalars['DateTime'];
  speedInKnots: Maybe<Scalars['Float']>;
};

export type CardManualPositionReportInput = {
  altitude: InputMaybe<Scalars['Float']>;
  heading: InputMaybe<Scalars['Float']>;
  latitude: InputMaybe<Scalars['Float']>;
  longitude: InputMaybe<Scalars['Float']>;
  positionReportId: Scalars['ID'];
  positionTime: Scalars['DateTime'];
  speedInKnots: InputMaybe<Scalars['Float']>;
};

export type CardNote = Entity &
  Evented & {
    __typename: 'CardNote';
    _events: MessageEnvelopeCollection;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    card: Card;
    cardId: Scalars['ID'];
    companyId: Scalars['ID'];
    content: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isInternal: Scalars['Boolean'];
    isSystem: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    noteCategory: Maybe<Scalars['String']>;
    noteMetadataJson: Maybe<Scalars['String']>;
    noteTime: Scalars['DateTime'];
    receivedFromCardId: Maybe<Scalars['ID']>;
    sentToCards: Maybe<Array<Maybe<IdListItem>>>;
  };

export type CardNote_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardNoteArchive = Entity &
  Evented & {
    __typename: 'CardNoteArchive';
    _events: MessageEnvelopeCollection;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    cardId: Scalars['ID'];
    companyId: Scalars['ID'];
    content: Scalars['String'];
    dateArchived: Scalars['DateTime'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isInternal: Scalars['Boolean'];
    isSystem: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    noteCategory: Maybe<Scalars['String']>;
    noteMetadataJson: Maybe<Scalars['String']>;
    noteTime: Scalars['DateTime'];
    receivedFromCardId: Maybe<Scalars['ID']>;
    sentToCards: Maybe<Array<Maybe<IdListItem>>>;
  };

export type CardNoteArchive_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardNoteArchiveCollection = {
  __typename: 'CardNoteArchiveCollection';
  items: Array<CardNoteArchive>;
  meta: CardNoteArchiveCollectionMetadata;
};

export type CardNoteArchiveCollectionMetadata = CollectionMetadata & {
  __typename: 'CardNoteArchiveCollectionMetadata';
  total: Scalars['Int'];
};

export type CardNoteArchiveQueries = {
  __typename: 'CardNoteArchiveQueries';
  byCardId: CardNoteArchiveCollection;
  byId: Maybe<CardNoteArchive>;
};

export type CardNoteArchiveQueriesbyCardIdArgs = {
  cardId: Scalars['ID'];
};

export type CardNoteArchiveQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CardNoteCollection = {
  __typename: 'CardNoteCollection';
  items: Array<CardNote>;
  meta: CardNoteCollectionMetadata;
};

export type CardNoteCollectionMetadata = CollectionMetadata & {
  __typename: 'CardNoteCollectionMetadata';
  total: Scalars['Int'];
};

export type CardNoteQueries = {
  __typename: 'CardNoteQueries';
  byId: Maybe<CardNote>;
  devNotes: DevNoteCollection;
};

export type CardNoteQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CardNoteQueriesdevNotesArgs = {
  filter: InputMaybe<DevNoteFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardOperation = {
  __typename: 'CardOperation';
  dateOperationStarted: Scalars['DateTime'];
  operationId: Scalars['ID'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type CardOperationInput = {
  dateOperationStarted: Scalars['DateTime'];
  operationId: Scalars['ID'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type CardQueries = {
  __typename: 'CardQueries';
  all: CardCollection;
  byCardNumber: Maybe<Card>;
  byId: Maybe<Card>;
  /** @deprecated Use cards.byId or cards.byCardNumber instead */
  cardById: Maybe<Card>;
  report: Maybe<Scalars['String']>;
  reportApiUrl: Maybe<Scalars['String']>;
  search: CardSearchResultCollection;
  searchv2: CardSearchResultCollection;
  summaries: CardSummaryCollection;
  summaryByCardNumber: Maybe<CardSummary>;
  summaryById: Maybe<CardSummary>;
};

export type CardQueriesallArgs = {
  filter: InputMaybe<CardFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardQueriesbyCardNumberArgs = {
  cardNumber: Scalars['ID'];
};

export type CardQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CardQueriescardByIdArgs = {
  id: Scalars['ID'];
};

export type CardQueriesreportArgs = {
  cardNumber: Scalars['ID'];
};

export type CardQueriesreportApiUrlArgs = {
  id: Scalars['ID'];
};

export type CardQueriessearchArgs = {
  filter: InputMaybe<CardSearchFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardQueriessearchv2Args = {
  filter: InputMaybe<CardSearchFilterV2>;
  first?: Scalars['Int'];
  skip?: Scalars['Int'];
};

export type CardQueriessummariesArgs = {
  fetchpolicy: InputMaybe<FetchPolicy>;
  filter: InputMaybe<CardSummaryFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardQueriessummaryByCardNumberArgs = {
  cardNumber: Scalars['ID'];
};

export type CardQueriessummaryByIdArgs = {
  id: Scalars['ID'];
};

export type CardReOpenReason = Entity &
  Evented & {
    __typename: 'CardReOpenReason';
    _events: MessageEnvelopeCollection;
    affectsTrip: Scalars['Boolean'];
    cards: Maybe<Array<Maybe<Card>>>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type CardReOpenReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardReOpenReasonCollection = {
  __typename: 'CardReOpenReasonCollection';
  items: Array<CardReOpenReason>;
  meta: CardReOpenReasonCollectionMetadata;
};

export type CardReOpenReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'CardReOpenReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type CardReopenReasonFilter = {
  affectsTrip: InputMaybe<Scalars['Boolean']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type CardReopenReasonQueries = {
  __typename: 'CardReopenReasonQueries';
  all: CardReOpenReasonCollection;
  byId: Maybe<CardReOpenReason>;
};

export type CardReopenReasonQueriesallArgs = {
  filter: InputMaybe<CardReopenReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CardReopenReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CardRequest = {
  __typename: 'CardRequest';
  cancellationReasonId: Maybe<Scalars['ID']>;
  cancellationReasonName: Maybe<Scalars['String']>;
  cancellationSecondaryReasonId: Maybe<Scalars['ID']>;
  cancellationSecondaryReasonName: Maybe<Scalars['String']>;
  cardSafetyQuestions: CardSafetyQuestions;
  isStandby: Scalars['Boolean'];
  requestId: Scalars['ID'];
  requestedOperationType: OperationType;
  status: Scalars['String'];
};

export type CardRequestInput = {
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationReasonName: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  cancellationSecondaryReasonName: InputMaybe<Scalars['String']>;
  cardSafetyQuestions: CardSafetyQuestionsInput;
  isStandby: Scalars['Boolean'];
  requestId: Scalars['ID'];
  requestedOperationType: OperationType;
  status: Scalars['String'];
};

export type CardSafetyQuestions = {
  __typename: 'CardSafetyQuestions';
  otherServiceDeclined: Maybe<Scalars['Boolean']>;
  otherServiceDescription: Maybe<Scalars['String']>;
  otherServiceResponseDescription: Maybe<Scalars['String']>;
  otherServicesAreRespondingToTransferring: Maybe<Scalars['Boolean']>;
};

export type CardSafetyQuestionsInput = {
  otherServiceDeclined: InputMaybe<Scalars['Boolean']>;
  otherServiceDescription: InputMaybe<Scalars['String']>;
  otherServiceResponseDescription: InputMaybe<Scalars['String']>;
  otherServicesAreRespondingToTransferring: InputMaybe<Scalars['Boolean']>;
};

export type CardSearchFilter = {
  cardNumberLike: InputMaybe<Scalars['String']>;
  cardStatus: InputMaybe<CardStatus>;
  companyId: InputMaybe<Scalars['ID']>;
  fromLocationId: InputMaybe<Scalars['ID']>;
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  operationStatus: InputMaybe<OperationStatus>;
  operationType: InputMaybe<OperationType>;
  requestStatus: InputMaybe<RequestStatus>;
  serviceDateRange: InputMaybe<DateRangeFilter>;
  toLocationId: InputMaybe<Scalars['ID']>;
  unitNameLike: InputMaybe<Scalars['String']>;
};

export type CardSearchFilterV2 = {
  agencyLocationId: InputMaybe<Scalars['String']>;
  cardNumberLike: InputMaybe<Scalars['String']>;
  cardStatus: InputMaybe<CardStatus>;
  cityNameLike: InputMaybe<Scalars['String']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  countyNameLike: InputMaybe<Scalars['String']>;
  createdBy: InputMaybe<Scalars['String']>;
  createdById: InputMaybe<Scalars['ID']>;
  dropoffLocationId: InputMaybe<Scalars['ID']>;
  fromMedicalFacilityNameLike: InputMaybe<Scalars['String']>;
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  manifest: InputMaybe<PassengerFilter>;
  operationStatus: InputMaybe<OperationStatus>;
  operationType: InputMaybe<OperationType>;
  pickupLocationId: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
  requestStatus: InputMaybe<RequestStatus>;
  serviceDateRange: InputMaybe<DateRangeFilter>;
  stateNameLike: InputMaybe<Scalars['String']>;
  toMedicalFacilityNameLike: InputMaybe<Scalars['String']>;
  unitNameLike: InputMaybe<Scalars['String']>;
};

export type CardSearchResult = {
  __typename: 'CardSearchResult';
  callStatus: Maybe<CardCallStatus>;
  cardNumber: Scalars['ID'];
  companyCode: Scalars['ID'];
  companyId: Scalars['ID'];
  createdBy: Maybe<Scalars['String']>;
  createdById: Maybe<Scalars['ID']>;
  dateCreated: Scalars['DateTime'];
  dateDeleted: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isBillable: Scalars['Boolean'];
  isLocked: Maybe<Scalars['Boolean']>;
  lastOfferedUnit: Maybe<CardSearchResultUnit>;
  lastOfferedVehicle: Maybe<CardSearchResultVehicle>;
  operation: Maybe<CardSearchResultOperation>;
  region: Maybe<CardSearchResultRegion>;
  request: Maybe<CardSearchResultRequest>;
  status: Maybe<CardStatus>;
};

export type CardSearchResultCollection = {
  __typename: 'CardSearchResultCollection';
  items: Array<CardSearchResult>;
  meta: CardCollectionMetadata;
};

export type CardSearchResultCollectionMetadata = CollectionMetadata & {
  __typename: 'CardSearchResultCollectionMetadata';
  total: Scalars['Int'];
};

export type CardSearchResultCommunicationCenter = {
  __typename: 'CardSearchResultCommunicationCenter';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CardSearchResultOperation = {
  __typename: 'CardSearchResultOperation';
  id: Scalars['ID'];
  status: OperationStatus;
  type: OperationType;
  unit: Maybe<CardSearchResultUnit>;
  vehicle: Maybe<CardSearchResultVehicle>;
};

export type CardSearchResultRegion = {
  __typename: 'CardSearchResultRegion';
  communicationCenter: Maybe<CardSearchResultCommunicationCenter>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CardSearchResultRequest = {
  __typename: 'CardSearchResultRequest';
  dropoffLocation: Maybe<CardSearchResultRequestLocation>;
  id: Scalars['ID'];
  pickupLocation: Maybe<CardSearchResultRequestLocation>;
  requestedOperationType: OperationType;
  status: RequestStatus;
};

export type CardSearchResultRequestLocation = {
  __typename: 'CardSearchResultRequestLocation';
  id: Scalars['ID'];
  locationId: Maybe<Scalars['ID']>;
  medicalFacilityAbbreviation: Maybe<Scalars['String']>;
  medicalFacilityId: Maybe<Scalars['ID']>;
  medicalFacilityName: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: WaypointType;
};

export type CardSearchResultUnit = {
  __typename: 'CardSearchResultUnit';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CardSearchResultVehicle = {
  __typename: 'CardSearchResultVehicle';
  id: Scalars['ID'];
  registrationNumber: Scalars['String'];
};

export enum CardStatus {
  AwaitingAssignment = 'AwaitingAssignment',
  AwaitingLaunch = 'AwaitingLaunch',
  Closed = 'Closed',
  Completed = 'Completed',
  Underway = 'Underway',
}

export type CardSummary = Entity &
  Evented & {
    __typename: 'CardSummary';
    _events: MessageEnvelopeCollection;
    apiWebhookSubscriptionId: Maybe<Scalars['ID']>;
    cardNumber: Scalars['String'];
    communicationCenter: Maybe<CommunicationCenter>;
    communicationCenterId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    dateContactCompleted: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    diversionType: Maybe<DiversionType>;
    gmrCADNumber: Maybe<Scalars['String']>;
    gmrUtilizationStatus: Maybe<AmrUtilizationStatus>;
    id: Scalars['ID'];
    operation: Maybe<OperationSummary>;
    operationType: OperationType;
    patients: Maybe<Array<Maybe<RequestPatientSummary>>>;
    region: Region;
    regionId: Scalars['ID'];
    request: Maybe<RequestSummary>;
    status: CardStatus;
    unit: Maybe<Unit>;
    unitId: Maybe<Scalars['ID']>;
    unitSummary: Maybe<UnitSummary>;
    unitSummaryId: Maybe<Scalars['ID']>;
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
    vehicleSummary: Maybe<VehicleSummary>;
    vehicleSummaryId: Maybe<Scalars['ID']>;
    webOrderAcknowledgedTime: Maybe<Scalars['DateTime']>;
  };

export type CardSummary_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum CardSummaryActivityType {
  Acknowledged = 'Acknowledged',
  Cancelled = 'Cancelled',
  Created = 'Created',
  OperationTypeChanged = 'OperationTypeChanged',
  RequestAssignmentDelayed = 'RequestAssignmentDelayed',
  RequestLocationChanged = 'RequestLocationChanged',
  RequestStandbyActivated = 'RequestStandbyActivated',
  RequestStandbyChanged = 'RequestStandbyChanged',
  RequesterChanged = 'RequesterChanged',
}

export type CardSummaryCollection = {
  __typename: 'CardSummaryCollection';
  items: Array<CardSummary>;
  meta: CardSummaryCollectionMetadata;
};

export type CardSummaryCollectionMetadata = CollectionMetadata & {
  __typename: 'CardSummaryCollectionMetadata';
  total: Scalars['Int'];
};

export type CardSummaryFilter = {
  afterDate: InputMaybe<Scalars['DateTime']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  controlZoneCompanyId: InputMaybe<Scalars['ID']>;
  controlZoneId: InputMaybe<Scalars['ID']>;
  fromMedicalFacilityNameLike: InputMaybe<Scalars['String']>;
  regionId: InputMaybe<Scalars['ID']>;
  toMedicalFacilityNameLike: InputMaybe<Scalars['String']>;
  weatherDeclinedCardsOnly: InputMaybe<Scalars['Boolean']>;
  weatherDelayedCardsOnly: InputMaybe<Scalars['Boolean']>;
};

export type CardTimestamp = {
  __typename: 'CardTimestamp';
  description: Maybe<Scalars['String']>;
  time: Scalars['DateTime'];
  timestampId: Scalars['ID'];
  type: Scalars['String'];
};

export type CardTimestampInput = {
  description: InputMaybe<Scalars['String']>;
  time: Scalars['DateTime'];
  timestampId: Scalars['ID'];
  type: Scalars['String'];
};

export type CardUnit = {
  __typename: 'CardUnit';
  abbreviation: Scalars['String'];
  cardVehicle: Maybe<CardVehicle>;
  completeFlightInstanceId: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  unitId: Scalars['ID'];
};

export type CardUnitInput = {
  abbreviation: Scalars['String'];
  cardVehicle: InputMaybe<CardVehicleInput>;
  completeFlightInstanceId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  unitId: Scalars['ID'];
};

export type CardVehicle = {
  __typename: 'CardVehicle';
  registrationNumber: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  vehicleId: Maybe<Scalars['ID']>;
};

export type CardVehicleInput = {
  registrationNumber: InputMaybe<Scalars['String']>;
  type: InputMaybe<Scalars['String']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type CardWaypoint = {
  __typename: 'CardWaypoint';
  abbreviation: Scalars['String'];
  address: Address;
  name: Scalars['String'];
  type: WaypointType;
  waypointId: Scalars['ID'];
};

export type CardWaypointInput = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  name: Scalars['String'];
  type: WaypointType;
  waypointId: Scalars['ID'];
};

export type CardWaypointV2 = {
  __typename: 'CardWaypointV2';
  abbreviation: Scalars['String'];
  address: Address;
  arrivalTime: Maybe<Scalars['DateTime']>;
  departureTime: Maybe<Scalars['DateTime']>;
  eta: Maybe<Scalars['DateTime']>;
  eteInMinutes: Maybe<Scalars['Int']>;
  etlo: Maybe<Scalars['DateTime']>;
  etloInMinutes: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  type: WaypointType;
  waypointId: Scalars['ID'];
};

export type CardWaypointV2Input = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  arrivalTime: InputMaybe<Scalars['DateTime']>;
  departureTime: InputMaybe<Scalars['DateTime']>;
  eta: InputMaybe<Scalars['DateTime']>;
  eteInMinutes: InputMaybe<Scalars['Int']>;
  etlo: InputMaybe<Scalars['DateTime']>;
  etloInMinutes: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  type: WaypointType;
  waypointId: Scalars['ID'];
};

export type CardsForSameDestination = {
  __typename: 'CardsForSameDestination';
  cardId: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CardsForSameDestinationInput = {
  cardId: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum CareLevel {
  ALS = 'ALS',
  BLS = 'BLS',
  CCT = 'CCT',
}

export type ChangeCallType = {
  requestId: Scalars['ID'];
  requestedOperationType: OperationType;
};

export type ChangeCardCallStatus = {
  id: Scalars['ID'];
  status: CardCallStatus;
};

export type ChangeRequestCancellationReason = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  requestId: Scalars['ID'];
};

export type ChangeRequestType = {
  requestId: Scalars['ID'];
  requestedOperationType: OperationType;
};

export type ChangeUnit = {
  cardId: Scalars['ID'];
  newUnitId: Scalars['ID'];
};

export type ChangeVehicle = {
  operationId: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type ChangeVehicleFlightLogProcess = {
  flightLogProcess: FlightLogProcess;
  id: Scalars['ID'];
};

export type CheckForFlightFollowingDestinationConflict = {
  cardId: Scalars['ID'];
};

export type CleanupActiveAlerts = {
  companyCodes: Array<Scalars['String']>;
};

export type CleanupCardActiveAlerts = {
  cardId: Scalars['ID'];
};

export type CleanupCards = {
  cardNumberFilter: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCode: InputMaybe<Scalars['String']>;
  excludeCardNumberFilter: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeOnlyWebOrders: InputMaybe<Scalars['Boolean']>;
};

export type CleanupPendingExternalActions = {
  entityId: Scalars['ID'];
};

export type ClearPendingArchiveMedicalFacility = {
  medicalFacilityId: Scalars['ID'];
};

export type CloseCard = {
  cardId: Scalars['ID'];
  closeComment: InputMaybe<Scalars['String']>;
  confirmPatient: InputMaybe<Scalars['Boolean']>;
  overrideMissingAMRCADNumberValidation: InputMaybe<Scalars['Boolean']>;
  overrideMissingTimestampsValidation: InputMaybe<Scalars['Boolean']>;
  overrideMissingVetNumber: InputMaybe<Scalars['Boolean']>;
  postTransportDebriefCompleted: InputMaybe<Scalars['Boolean']>;
};

export type CloseConversation = {
  id: Scalars['ID'];
};

export type CloseTicketsForOOSEvent = {
  outOfServiceEventId: Scalars['ID'];
};

export type CollectionMetadata = {
  total: Scalars['Int'];
};

export type CommandExecutionOptions = {
  includeEntities: Scalars['Boolean'];
  includeEvents: Scalars['Boolean'];
  includeViews: Scalars['Boolean'];
};

export type CommandResult = {
  __typename: 'CommandResult';
  command: Maybe<Scalars['JSON']>;
  data: Scalars['JSON'];
  emittedEvents: Array<Scalars['JSON']>;
  entities: Maybe<Scalars['JSON']>;
  errors: Array<Error>;
  status: CommandResultStatus;
};

export enum CommandResultStatus {
  Failed = 'Failed',
  PartiallySucceeded = 'PartiallySucceeded',
  Succeeded = 'Succeeded',
}

export type CommunicationCenter = Entity &
  Evented & {
    __typename: 'CommunicationCenter';
    _events: MessageEnvelopeCollection;
    activeAlerts: Maybe<Array<Maybe<ActiveAlert>>>;
    alertFrequencyForGroundVehicles: Maybe<Scalars['Int']>;
    cardSummaries: Maybe<Array<Maybe<CardSummary>>>;
    communicationCenterTransportOfferOption: CommunicationCenterTransportOfferOption;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    displayContactTimeline: Scalars['Boolean'];
    emailAddress: Maybe<Scalars['String']>;
    enableRAAlert: Scalars['Boolean'];
    id: Scalars['ID'];
    includeCompetitors: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    people: Maybe<Array<Maybe<Person>>>;
    playAlertForManualPositionReports: Scalars['Boolean'];
    primaryPhoneNumber: Maybe<Scalars['String']>;
    regions: Array<Region>;
    showReferToGmrWarning: Maybe<Scalars['Boolean']>;
    states: Maybe<Array<Maybe<Scalars['String']>>>;
    timezoneCd: Maybe<Scalars['String']>;
    transferCenterRegion: Maybe<Region>;
    transferCenters: Array<TransferCenter>;
    unitSummaries: Maybe<Array<Maybe<UnitSummary>>>;
    useCrewPhoneNumber: Scalars['Boolean'];
    vehicleSummaries: Maybe<Array<Maybe<VehicleSummary>>>;
    vehicles: Maybe<Array<Maybe<Vehicle>>>;
  };

export type CommunicationCenter_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CommunicationCenterCollection = {
  __typename: 'CommunicationCenterCollection';
  items: Array<CommunicationCenter>;
  meta: CommunicationCenterCollectionMetadata;
};

export type CommunicationCenterCollectionMetadata = CollectionMetadata & {
  __typename: 'CommunicationCenterCollectionMetadata';
  total: Scalars['Int'];
};

export type CommunicationCenterFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  companyIdList: InputMaybe<Array<Scalars['ID']>>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type CommunicationCenterQueries = {
  __typename: 'CommunicationCenterQueries';
  all: CommunicationCenterCollection;
  byId: Maybe<CommunicationCenter>;
};

export type CommunicationCenterQueriesallArgs = {
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CommunicationCenterQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CommunicationCenterTransportOfferOption = Entity &
  Evented & {
    __typename: 'CommunicationCenterTransportOfferOption';
    _events: MessageEnvelopeCollection;
    communicationCenter: Maybe<CommunicationCenter>;
    communicationCenterId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    includeAbortedUnit: Scalars['Boolean'];
    includeCompetitors: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    minimumFlightRule: Maybe<FlightRule>;
    requestedVehicleType: Maybe<VehicleType>;
    requiredCapabilities: Array<RequiredCapabilityIdList>;
    transportOfferAlgorithm: Maybe<TransportOfferAlgorithm>;
  };

export type CommunicationCenterTransportOfferOption_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CommunicationCenterTransportOfferOptionCollection = {
  __typename: 'CommunicationCenterTransportOfferOptionCollection';
  items: Array<CommunicationCenterTransportOfferOption>;
  meta: CommunicationCenterTransportOfferOptionCollectionMetadata;
};

export type CommunicationCenterTransportOfferOptionCollectionMetadata = CollectionMetadata & {
  __typename: 'CommunicationCenterTransportOfferOptionCollectionMetadata';
  total: Scalars['Int'];
};

export type Company = Entity &
  Evented & {
    __typename: 'Company';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    activeTimelines: Array<ActiveTimeline>;
    agencies: Maybe<Array<Maybe<Agency>>>;
    applicationNotifications: Maybe<Array<Maybe<ApplicationNotification>>>;
    baseControlZones: Array<BaseControlZone>;
    bases: Array<Base>;
    callNumberPrefix: Maybe<Scalars['String']>;
    communicationCenters: Array<CommunicationCenter>;
    companyCode: Scalars['String'];
    configurationSettings: Maybe<Array<Maybe<ConfigurationSetting>>>;
    controlZones: Array<ControlZone>;
    crewPatientInfoPageNotificationTemplateId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    enableNotificationGroupTypes: Scalars['Boolean'];
    externalActions: Array<ExternalAction>;
    flightFollowingFields: Maybe<Array<Maybe<FlightFollowingField>>>;
    fuelTanks: Array<FuelTank>;
    gLCode: Maybe<Scalars['String']>;
    gpsFeedResetsPositionReportTime: Scalars['Boolean'];
    hasPrivateUnits: Scalars['Boolean'];
    id: Scalars['ID'];
    imageUri: Maybe<Scalars['String']>;
    includeCompetitors: Scalars['Boolean'];
    isOemCompany: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    notificationGroups: Array<NotificationGroup>;
    notificationTemplates: Maybe<Array<Maybe<NotificationTemplate>>>;
    oemAssets: Maybe<Array<Maybe<OemAsset>>>;
    oemPlans: Array<OemPlan>;
    offerAlgorithms: Array<OfferAlgorithm>;
    people: Array<Person>;
    programs: Array<Program>;
    questionnaireResponses: Array<QuestionnaireResponse>;
    questionnaires: Array<Questionnaire>;
    regionGroups: Array<RegionGroup>;
    requesters: Maybe<Array<Maybe<Requester>>>;
    requireSkipReasonsForNonCompanyTransportOffers: Maybe<Scalars['Boolean']>;
    restrictRiskAnalysisAcknowledgementToOCCRole: Scalars['Boolean'];
    specialtyTeamMembers: Array<SpecialtyTeamMember>;
    specialtyTeams: Array<SpecialtyTeam>;
    timelines: Maybe<Array<Maybe<Timeline>>>;
    timezoneCd: Maybe<Scalars['String']>;
    transferCenters: Array<TransferCenter>;
    transportCheckTimerDurationInMinutes: Maybe<Scalars['Int']>;
    trmUserAgencies: Array<TrmUserAgency>;
    trmUserMedicalFacilities: Array<TrmUserMedicalFacility>;
    trmUserPrograms: Array<TrmUserProgram>;
    trmUsers: Array<TrmUser>;
    unitActivationRules: Array<UnitActivationRule>;
    unitRemainsInServiceWithNoVehicle: Scalars['Boolean'];
    vehicleControlZones: Array<VehicleControlZone>;
    vehicles: Array<Vehicle>;
  };

export type Company_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CompanyCollection = {
  __typename: 'CompanyCollection';
  items: Array<Company>;
  meta: CompanyCollectionMetadata;
};

export type CompanyCollectionMetadata = CollectionMetadata & {
  __typename: 'CompanyCollectionMetadata';
  total: Scalars['Int'];
};

export type CompanyFilter = {
  name: InputMaybe<Scalars['String']>;
};

export type CompanyQueries = {
  __typename: 'CompanyQueries';
  all: CompanyCollection;
  byCompanyCode: Maybe<Company>;
  byId: Maybe<Company>;
};

export type CompanyQueriesallArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CompanyQueriesbyCompanyCodeArgs = {
  companyCode: Scalars['ID'];
};

export type CompanyQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type CompleteFlightInstance = Entity &
  Evented & {
    __typename: 'CompleteFlightInstance';
    _events: MessageEnvelopeCollection;
    apiKey: Scalars['String'];
    completeFlightInstanceName: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isPrimary: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    units: Maybe<Array<Maybe<Unit>>>;
    url: Scalars['String'];
    username: Scalars['String'];
  };

export type CompleteFlightInstance_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type CompleteFlightInstanceCollection = {
  __typename: 'CompleteFlightInstanceCollection';
  items: Array<CompleteFlightInstance>;
  meta: CompleteFlightInstanceCollectionMetadata;
};

export type CompleteFlightInstanceCollectionMetadata = CollectionMetadata & {
  __typename: 'CompleteFlightInstanceCollectionMetadata';
  total: Scalars['Int'];
};

export type CompleteFlightInstanceQueries = {
  __typename: 'CompleteFlightInstanceQueries';
  all: CompleteFlightInstanceCollection;
};

export type CompleteFlightInstanceQueriesallArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ConfigurationSetting = Entity &
  Evented & {
    __typename: 'ConfigurationSetting';
    _events: MessageEnvelopeCollection;
    assetReassignedDeclineReasonId: Maybe<Scalars['ID']>;
    bugRequestEmail: Maybe<Scalars['String']>;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']>;
    crewGoingByGroundOutOfServiceReason: Maybe<OutOfServiceReason>;
    crewGoingByGroundOutOfServiceReasonId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    defaultUnitCommittedDeclineReason: Maybe<DeclineReason>;
    defaultUnitCommittedDeclineReasonId: Maybe<Scalars['ID']>;
    defaultUnitOutOfServiceDeclineReasonId: Maybe<Scalars['ID']>;
    externallyCancelledCancellationReasonId: Maybe<Scalars['ID']>;
    featureRequestEmail: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    pilotReportGracePeriodInMinutes: Maybe<Scalars['Int']>;
    proximityAlertDistanceInNauticalMiles: Maybe<Scalars['Float']>;
    requestReferredExternallyCancellationReasonId: Maybe<Scalars['ID']>;
    requestReferredInternallyCancellationReasonId: Maybe<Scalars['ID']>;
    sameDestinationWarningThresholdInMinutes: Maybe<Scalars['Int']>;
  };

export type ConfigurationSetting_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ConfigurationSettingCollection = {
  __typename: 'ConfigurationSettingCollection';
  items: Array<ConfigurationSetting>;
  meta: ConfigurationSettingCollectionMetadata;
};

export type ConfigurationSettingCollectionMetadata = CollectionMetadata & {
  __typename: 'ConfigurationSettingCollectionMetadata';
  total: Scalars['Int'];
};

export type ConfigurationSettingQueries = {
  __typename: 'ConfigurationSettingQueries';
  global: Maybe<ConfigurationSetting>;
};

export type ConfirmManifest = {
  tripLegId: Scalars['ID'];
};

export type ConfirmPositionReport = {
  id: Scalars['ID'];
};

export type ControlZone = Entity &
  Evented & {
    __typename: 'ControlZone';
    _events: MessageEnvelopeCollection;
    baseControlZones: Array<BaseControlZone>;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    vehicleControlZones: Maybe<Array<Maybe<VehicleControlZone>>>;
    vehicles: Maybe<Array<Maybe<Vehicle>>>;
  };

export type ControlZone_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ControlZoneCollection = {
  __typename: 'ControlZoneCollection';
  items: Array<ControlZone>;
  meta: ControlZoneCollectionMetadata;
};

export type ControlZoneCollectionMetadata = CollectionMetadata & {
  __typename: 'ControlZoneCollectionMetadata';
  total: Scalars['Int'];
};

export type ControlZoneFilter = {
  companyId: Scalars['ID'];
  nameLike: InputMaybe<Scalars['String']>;
};

export type ControlZoneQueries = {
  __typename: 'ControlZoneQueries';
  all: ControlZoneCollection;
  byId: Maybe<ControlZone>;
};

export type ControlZoneQueriesallArgs = {
  filter: InputMaybe<ControlZoneFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ControlZoneQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type Conversation = Entity &
  Evented & {
    __typename: 'Conversation';
    _events: MessageEnvelopeCollection;
    conversationParticipants: Array<ConversationParticipant>;
    conversationState: ConversationState;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Maybe<Scalars['ID']>;
    entityType: Maybe<EntityType>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    metadata: Maybe<ConversationMetadata>;
    name: Scalars['String'];
    uniqueName: Scalars['String'];
    vendorConversationId: Scalars['String'];
  };

export type Conversation_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ConversationCollection = {
  __typename: 'ConversationCollection';
  items: Array<Conversation>;
  meta: ConversationCollectionMetadata;
};

export type ConversationCollectionMetadata = CollectionMetadata & {
  __typename: 'ConversationCollectionMetadata';
  total: Scalars['Int'];
};

export type ConversationMetadata = {
  __typename: 'ConversationMetadata';
  name: Maybe<Scalars['String']>;
};

export type ConversationMetadataInput = {
  name: InputMaybe<Scalars['String']>;
};

export type ConversationParticipant = Entity &
  Evented & {
    __typename: 'ConversationParticipant';
    _events: MessageEnvelopeCollection;
    conversation: Conversation;
    conversationId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    messagingAddress: Scalars['String'];
    metadata: Maybe<ParticipantMetadata>;
    name: Scalars['String'];
    vendorParticipantId: Scalars['String'];
  };

export type ConversationParticipant_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ConversationParticipantCollection = {
  __typename: 'ConversationParticipantCollection';
  items: Array<ConversationParticipant>;
  meta: ConversationParticipantCollectionMetadata;
};

export type ConversationParticipantCollectionMetadata = CollectionMetadata & {
  __typename: 'ConversationParticipantCollectionMetadata';
  total: Scalars['Int'];
};

export enum ConversationState {
  Active = 'Active',
  Closed = 'Closed',
  Inactive = 'Inactive',
  Initializing = 'Initializing',
}

export type Coordinates = {
  __typename: 'Coordinates';
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
};

export type CoordinatesInput = {
  latitude: InputMaybe<Scalars['Float']>;
  longitude: InputMaybe<Scalars['Float']>;
};

export type CopyAlert = {
  alertId: Scalars['ID'];
  newName: Scalars['String'];
};

export type CopyNotificationTemplate = {
  newName: Scalars['String'];
  notificationTemplateId: Scalars['ID'];
};

export type CopyOfferAlgorithm = {
  id: Scalars['ID'];
  newName: Scalars['String'];
};

export type CreateGroundRun = {
  unitId: Scalars['ID'];
};

export type CreateMaintenanceOperation = {
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  destinationAddress: AddressInput;
  destinationLocationId: InputMaybe<Scalars['ID']>;
  destinationTimezoneCd: InputMaybe<Scalars['String']>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  returnUnitToPost: InputMaybe<Scalars['Boolean']>;
  unitId: Scalars['ID'];
};

export type CreatePrecautionaryLanding = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  arriveVehicle: InputMaybe<Scalars['Boolean']>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  note: InputMaybe<Scalars['String']>;
  timezoneCd: InputMaybe<Scalars['String']>;
  tripId: Scalars['ID'];
  type: WaypointType;
};

export type CreatePrecautionaryLandingV2 = {
  abbreviation: Scalars['String'];
  abortReasonId: InputMaybe<Scalars['ID']>;
  abortSecondaryReasonId: InputMaybe<Scalars['ID']>;
  address: AddressInput;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  completeTransportWithThirdParty: Scalars['Boolean'];
  crewWillReturnToAircraft: InputMaybe<Scalars['Boolean']>;
  gmrCADNumber: InputMaybe<Scalars['String']>;
  gmrUtilizationStatus: InputMaybe<AmrUtilizationStatus>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  newAgencyLocationName: InputMaybe<Scalars['String']>;
  newAgencyLocationPhoneNumber: InputMaybe<Scalars['String']>;
  note: InputMaybe<Scalars['String']>;
  replacementUnitId: InputMaybe<Scalars['ID']>;
  timezoneCd: InputMaybe<Scalars['String']>;
  tripId: Scalars['ID'];
  type: WaypointType;
};

export type CreateRequest = {
  atloInMinutes: InputMaybe<Scalars['Int']>;
  commitUnitToStandby: InputMaybe<Scalars['Boolean']>;
  etloInMinutes: InputMaybe<Scalars['Int']>;
  initiationType: InputMaybe<RequestInitiationType>;
  isStandbyRequest: Scalars['Boolean'];
  regionId: InputMaybe<Scalars['ID']>;
  requestedOperationType: OperationType;
  requestedVehicleType: InputMaybe<VehicleType>;
  transportOfferAlgorithm: InputMaybe<TransportOfferAlgorithm>;
  transportTrackingLink: InputMaybe<Scalars['String']>;
  webOrderCallType: InputMaybe<WebOrderCallType>;
};

export type CreateSystemCrewNotification = {
  cardId: Scalars['ID'];
  notificationType: NotificationType;
};

export type CreateTicketFromOutOfServiceEvent = {
  oosEventId: Scalars['ID'];
};

export type CreateTrainingOperation = {
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  destinationAddress: AddressInput;
  destinationLocationId: InputMaybe<Scalars['ID']>;
  destinationTimezoneCd: InputMaybe<Scalars['String']>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  returnUnitToPost: InputMaybe<Scalars['Boolean']>;
  unitId: Scalars['ID'];
};

export type CrewSourcedUnit = {
  __typename: 'CrewSourcedUnit';
  id: Scalars['ID'];
  unitPositions: Array<IdListItem>;
};

export type CrewSourcedUnitInput = {
  id: Scalars['ID'];
  unitPositions: Array<IdListItemInput>;
};

export type DateRangeFilter = {
  begin: InputMaybe<Scalars['DateTime']>;
  end: InputMaybe<Scalars['DateTime']>;
};

export type DeactivateTrmUser = {
  id: Scalars['ID'];
};

export type DeclineAndAssignNewTransportOffer = {
  declineReasonId: InputMaybe<Scalars['ID']>;
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  newId: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
};

export type DeclineCategory = Entity &
  Evented & {
    __typename: 'DeclineCategory';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    declineReasons: Array<DeclineReason>;
    defaultDeclineReason: Maybe<DeclineReason>;
    defaultDeclineReasonId: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    isVisibleInOps: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type DeclineCategory_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DeclineCategoryCollection = {
  __typename: 'DeclineCategoryCollection';
  items: Array<DeclineCategory>;
  meta: DeclineCategoryCollectionMetadata;
};

export type DeclineCategoryCollectionMetadata = CollectionMetadata & {
  __typename: 'DeclineCategoryCollectionMetadata';
  total: Scalars['Int'];
};

export type DeclineCategoryFilter = {
  first: InputMaybe<Scalars['Int']>;
  nameLike: InputMaybe<Scalars['String']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DeclineCategoryQueries = {
  __typename: 'DeclineCategoryQueries';
  all: DeclineCategoryCollection;
  byId: Maybe<DeclineCategory>;
};

export type DeclineCategoryQueriesallArgs = {
  filter: InputMaybe<DeclineCategoryFilter>;
};

export type DeclineCategoryQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type DeclineOrAbortOperation = {
  agencyLocationId: InputMaybe<Scalars['ID']>;
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  completeTransportWithThirdParty: InputMaybe<Scalars['Boolean']>;
  crewWillReturnToAircraft: InputMaybe<Scalars['Boolean']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  duplicateRequest: InputMaybe<Scalars['Boolean']>;
  gmrCADNumber: InputMaybe<Scalars['String']>;
  gmrUtilizationStatus: InputMaybe<AmrUtilizationStatus>;
  isCancel: InputMaybe<Scalars['Boolean']>;
  newAgencyLocationName: InputMaybe<Scalars['String']>;
  newAgencyLocationPhoneNumber: InputMaybe<Scalars['String']>;
  nonReferralReasonId: InputMaybe<Scalars['ID']>;
  nonReferralReasonNotes: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  operationId: Scalars['ID'];
  replacementUnitId: InputMaybe<Scalars['ID']>;
};

export type DeclineReason = Entity &
  Evented & {
    __typename: 'DeclineReason';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    canBeAbortReason: Scalars['Boolean'];
    canBeBulkSkipReason: Scalars['Boolean'];
    canBeOneCallSkipReason: Scalars['Boolean'];
    canBeSkipReason: Scalars['Boolean'];
    cancellationReasonId: Maybe<Scalars['ID']>;
    cancellationSecondaryReasonId: Maybe<Scalars['ID']>;
    configurationSettings: Maybe<Array<Maybe<ConfigurationSetting>>>;
    controllable: Scalars['Boolean'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    declineCategories: Maybe<Array<Maybe<DeclineCategory>>>;
    declineCategory: DeclineCategory;
    declineCategoryId: Scalars['ID'];
    declineSecondaryReasons: Array<DeclineSecondaryReason>;
    id: Scalars['ID'];
    isUnitAvailableAfterAbort: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    secondaryReasonRequired: Scalars['Boolean'];
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
  };

export type DeclineReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DeclineReasonCollection = {
  __typename: 'DeclineReasonCollection';
  items: Array<DeclineReason>;
  meta: DeclineReasonCollectionMetadata;
};

export type DeclineReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'DeclineReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type DeclineReasonFilter = {
  abortReasonsOnly: InputMaybe<Scalars['Boolean']>;
  bulkSkipReasonsOnly: InputMaybe<Scalars['Boolean']>;
  declineCategoryId: InputMaybe<Scalars['ID']>;
  excludeReasonsWithSecondary: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  nameLike: InputMaybe<Scalars['String']>;
  oneCallSkipReasonsOnly: InputMaybe<Scalars['Boolean']>;
  skip: InputMaybe<Scalars['Int']>;
  skipReasonsOnly: InputMaybe<Scalars['Boolean']>;
};

export type DeclineReasonQueries = {
  __typename: 'DeclineReasonQueries';
  all: DeclineReasonCollection;
  byId: Maybe<DeclineReason>;
};

export type DeclineReasonQueriesallArgs = {
  filter: InputMaybe<DeclineReasonFilter>;
};

export type DeclineReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type DeclineSecondaryReason = Entity &
  Evented & {
    __typename: 'DeclineSecondaryReason';
    _events: MessageEnvelopeCollection;
    cancellationReasonId: Maybe<Scalars['ID']>;
    cancellationSecondaryReasonId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    declineReason: DeclineReason;
    declineReasonId: Scalars['ID'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
  };

export type DeclineSecondaryReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DeclineSecondaryReasonCollection = {
  __typename: 'DeclineSecondaryReasonCollection';
  items: Array<DeclineSecondaryReason>;
  meta: DeclineSecondaryReasonCollectionMetadata;
};

export type DeclineSecondaryReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'DeclineSecondaryReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type DeclineSecondaryReasonFilter = {
  declineReasonId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type DeclineSecondaryReasonQueries = {
  __typename: 'DeclineSecondaryReasonQueries';
  all: DeclineSecondaryReasonCollection;
  byId: Maybe<DeclineSecondaryReason>;
};

export type DeclineSecondaryReasonQueriesallArgs = {
  filter: InputMaybe<DeclineSecondaryReasonFilter>;
};

export type DeclineSecondaryReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type DeclineTransportOffer = {
  agencyLocationId: InputMaybe<Scalars['ID']>;
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  gmrCADNumber: InputMaybe<Scalars['String']>;
  gmrUtilizationStatus: InputMaybe<AmrUtilizationStatus>;
  id: Scalars['ID'];
  isCancel: InputMaybe<Scalars['Boolean']>;
  newAgencyLocationName: InputMaybe<Scalars['String']>;
  newAgencyLocationPhoneNumber: InputMaybe<Scalars['String']>;
  nonReferralReasonId: InputMaybe<Scalars['ID']>;
  nonReferralReasonNotes: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  replacementUnitId: InputMaybe<Scalars['ID']>;
  useThirdPartyUnit: InputMaybe<Scalars['Boolean']>;
};

export type DeclineTransportOfferAndDelayAssignment = {
  alertTimeInMinutesFromNow: InputMaybe<Scalars['Int']>;
  assignmentDelayedReasonId: Scalars['ID'];
  declineNotes: InputMaybe<Scalars['String']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  delayNotes: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  newAgencyLocationName: InputMaybe<Scalars['String']>;
  newAgencyLocationPhoneNumber: InputMaybe<Scalars['String']>;
};

export type DeferralDueDate = {
  __typename: 'DeferralDueDate';
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  notes: Maybe<Scalars['String']>;
  triggerValue: Maybe<Scalars['Int']>;
};

export type DeferralDueDateInput = {
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  triggerValue: InputMaybe<Scalars['Int']>;
};

export type DeferralDueDateWithOptionalId = {
  __typename: 'DeferralDueDateWithOptionalId';
  deferralDueDateId: Maybe<Scalars['ID']>;
  dueDate: Scalars['DateTime'];
  notes: Maybe<Scalars['String']>;
  triggerValue: Maybe<Scalars['Int']>;
};

export type DeferralDueDateWithOptionalIdInput = {
  deferralDueDateId: InputMaybe<Scalars['ID']>;
  dueDate: Scalars['DateTime'];
  notes: InputMaybe<Scalars['String']>;
  triggerValue: InputMaybe<Scalars['Int']>;
};

export type DelayAssignment = {
  alertTimeInMinutesFromNow: InputMaybe<Scalars['Int']>;
  assignmentDelayedReasonId: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  requestId: Scalars['ID'];
};

export type DelayUnit = {
  id: Scalars['ID'];
  plannedAvailableNotes: Scalars['String'];
  plannedAvailableTime: Scalars['DateTime'];
};

export type DeleteAccessibleItem = {
  id: Scalars['ID'];
};

export type DeleteActivationRule = {
  id: Scalars['ID'];
};

export type DeleteActiveAlert = {
  id: Scalars['ID'];
};

export type DeleteActiveTimeline = {
  id: Scalars['ID'];
};

export type DeleteAgency = {
  id: Scalars['ID'];
};

export type DeleteAgencyLocation = {
  id: Scalars['ID'];
};

export type DeleteAirport = {
  id: Scalars['ID'];
};

export type DeleteAlert = {
  id: Scalars['ID'];
};

export type DeleteApplicationNotification = {
  id: Scalars['ID'];
};

export type DeleteAssignmentDelayedReason = {
  id: Scalars['ID'];
};

export type DeleteAttachment = {
  id: Scalars['ID'];
};

export type DeleteBase = {
  id: Scalars['ID'];
};

export type DeleteBaseControlZone = {
  id: Scalars['ID'];
};

export type DeleteBaseMedicalControlContact = {
  id: Scalars['ID'];
};

export type DeleteCancellationCategory = {
  id: Scalars['ID'];
};

export type DeleteCancellationReason = {
  id: Scalars['ID'];
};

export type DeleteCancellationSecondaryReason = {
  id: Scalars['ID'];
};

export type DeleteCapability = {
  id: Scalars['ID'];
};

export type DeleteCard = {
  id: Scalars['ID'];
};

export type DeleteCardLink = {
  id: Scalars['ID'];
};

export type DeleteCardNote = {
  id: Scalars['ID'];
};

export type DeleteCardNoteArchive = {
  id: Scalars['ID'];
};

export type DeleteCardReOpenReason = {
  id: Scalars['ID'];
};

export type DeleteCommunicationCenter = {
  id: Scalars['ID'];
};

export type DeleteCommunicationCenterTransportOfferOption = {
  id: Scalars['ID'];
};

export type DeleteCompany = {
  id: Scalars['ID'];
};

export type DeleteCompleteFlightInstance = {
  id: Scalars['ID'];
};

export type DeleteControlZone = {
  id: Scalars['ID'];
};

export type DeleteDeclineCategory = {
  id: Scalars['ID'];
};

export type DeleteDeclineReason = {
  id: Scalars['ID'];
};

export type DeleteDeclineSecondaryReason = {
  id: Scalars['ID'];
};

export type DeleteDepartment = {
  id: Scalars['ID'];
};

export type DeleteDiversionReason = {
  id: Scalars['ID'];
};

export type DeleteEntityCapability = {
  id: Scalars['ID'];
};

export type DeleteEscortRequest = {
  id: Scalars['ID'];
};

export type DeleteExternalAction = {
  id: Scalars['ID'];
};

export type DeleteExternalActionType = {
  id: Scalars['ID'];
};

export type DeleteExternalReference = {
  id: Scalars['ID'];
};

export type DeleteFacilityNonAcceptanceReason = {
  id: Scalars['ID'];
};

export type DeleteFbo = {
  id: Scalars['ID'];
};

export type DeleteFirewallRule = {
  id: Scalars['ID'];
};

export type DeleteFlightFollowingReport = {
  id: Scalars['ID'];
};

export type DeleteFuelTank = {
  id: Scalars['ID'];
};

export type DeleteLocation = {
  id: Scalars['ID'];
};

export type DeleteLocationHazard = {
  id: Scalars['ID'];
};

export type DeleteLocationHazardAttachment = {
  id: Scalars['ID'];
};

export type DeleteMaintenanceFacility = {
  id: Scalars['ID'];
};

export type DeleteManifestEntry = {
  id: Scalars['ID'];
};

export type DeleteMedicalControlContactLogEntry = {
  id: Scalars['ID'];
};

export type DeleteMedicalFacility = {
  id: Scalars['ID'];
};

export type DeleteMedicalFacilityContact = {
  id: Scalars['ID'];
};

export type DeleteMedicalFacilityPhysician = {
  id: Scalars['ID'];
};

export type DeleteMedicalFacilityUnit = {
  id: Scalars['ID'];
};

export type DeleteNewAgencyLocationRequest = {
  id: Scalars['ID'];
};

export type DeleteNextDueType = {
  id: Scalars['ID'];
};

export type DeleteNonReferralReason = {
  id: Scalars['ID'];
};

export type DeleteNotification = {
  id: Scalars['ID'];
};

export type DeleteNotificationGroup = {
  id: Scalars['ID'];
};

export type DeleteNotificationGroupMember = {
  id: Scalars['ID'];
};

export type DeleteNotificationRecipient = {
  id: Scalars['ID'];
};

export type DeleteNotificationRecipients = {
  recipientIds: Array<Scalars['ID']>;
};

export type DeleteNotificationSubscription = {
  id: Scalars['ID'];
};

export type DeleteNotificationTemplate = {
  id: Scalars['ID'];
};

export type DeleteOemActivity = {
  id: Scalars['ID'];
};

export type DeleteOemAsset = {
  id: Scalars['ID'];
};

export type DeleteOemPlan = {
  id: Scalars['ID'];
};

export type DeleteOemPlanChangeRequest = {
  id: Scalars['ID'];
};

export type DeleteOfferAlgorithm = {
  id: Scalars['ID'];
};

export type DeleteOperation = {
  id: Scalars['ID'];
};

export type DeleteOutOfServiceEvent = {
  id: Scalars['ID'];
};

export type DeleteOutOfServiceEventNote = {
  id: Scalars['ID'];
};

export type DeleteOutOfServiceQARReason = {
  id: Scalars['ID'];
};

export type DeleteOutOfServiceReason = {
  id: Scalars['ID'];
};

export type DeleteOutOfServiceSecondaryReason = {
  id: Scalars['ID'];
};

export type DeleteOutOfServiceTicket = {
  id: Scalars['ID'];
};

export type DeletePaipEvent = {
  id: Scalars['ID'];
};

export type DeletePaipReason = {
  id: Scalars['ID'];
};

export type DeletePassdownLog = {
  id: Scalars['ID'];
};

export type DeletePerson = {
  id: Scalars['ID'];
};

export type DeletePhysician = {
  id: Scalars['ID'];
};

export type DeletePositionReport = {
  id: Scalars['ID'];
};

export type DeletePositionReportAlert = {
  id: Scalars['ID'];
};

export type DeleteProgram = {
  id: Scalars['ID'];
};

export type DeleteProgramBase = {
  id: Scalars['ID'];
};

export type DeleteQuestion = {
  id: Scalars['ID'];
};

export type DeleteQuestionnaire = {
  id: Scalars['ID'];
};

export type DeleteQuestionnaireQuestionResponse = {
  id: Scalars['ID'];
};

export type DeleteQuestionnaireQuestionResponseNote = {
  id: Scalars['ID'];
};

export type DeleteQuestionnaireResponse = {
  id: Scalars['ID'];
};

export type DeleteQuestionnaireSection = {
  id: Scalars['ID'];
};

export type DeleteQuestionnaireSectionQuestion = {
  id: Scalars['ID'];
};

export type DeleteReceivingFacilityRequest = {
  id: Scalars['ID'];
};

export type DeleteRegion = {
  id: Scalars['ID'];
};

export type DeleteRegionBase = {
  id: Scalars['ID'];
};

export type DeleteRegionGroup = {
  id: Scalars['ID'];
};

export type DeleteReleaseNote = {
  id: Scalars['ID'];
};

export type DeleteRendezvousRequest = {
  id: Scalars['ID'];
};

export type DeleteRequestPatient = {
  id: Scalars['ID'];
};

export type DeleteRequesterRole = {
  id: Scalars['ID'];
};

export type DeleteSpecialtyTeam = {
  id: Scalars['ID'];
};

export type DeleteSpecialtyTeamMember = {
  id: Scalars['ID'];
};

export type DeleteState = {
  id: Scalars['ID'];
};

export type DeleteSupportRequest = {
  id: Scalars['ID'];
};

export type DeleteTimeline = {
  id: Scalars['ID'];
};

export type DeleteTimelineItem = {
  id: Scalars['ID'];
};

export type DeleteTimestamp = {
  id: Scalars['ID'];
};

export type DeleteTimestampType = {
  id: Scalars['ID'];
};

export type DeleteTimezone = {
  id: Scalars['ID'];
};

export type DeleteTransferCenter = {
  id: Scalars['ID'];
};

export type DeleteTransferReason = {
  id: Scalars['ID'];
};

export type DeleteTransportOffer = {
  id: Scalars['ID'];
};

export type DeleteTransportReason = {
  id: Scalars['ID'];
};

export type DeleteTrip = {
  id: Scalars['ID'];
};

export type DeleteTripLegManifestEntry = {
  removeFromFutureLegs: InputMaybe<Scalars['Boolean']>;
  tripLegManifestEntryId: Scalars['ID'];
};

export type DeleteTripPassenger = {
  id: Scalars['ID'];
};

export type DeleteTrmUser = {
  id: Scalars['ID'];
};

export type DeleteUnit = {
  id: Scalars['ID'];
};

export type DeleteUnitActivationRule = {
  id: Scalars['ID'];
};

export type DeleteUnitEMSystemMapping = {
  id: Scalars['ID'];
};

export type DeleteUnitNote = {
  id: Scalars['ID'];
};

export type DeleteUnitPosition = {
  id: Scalars['ID'];
};

export type DeleteUnitShift = {
  id: Scalars['ID'];
};

export type DeleteVehicle = {
  id: Scalars['ID'];
};

export type DeleteVehicleConfigurationClass = {
  id: Scalars['ID'];
};

export type DeleteVehicleControlZone = {
  id: Scalars['ID'];
};

export type DeleteVehicleDisposition = {
  id: Scalars['ID'];
};

export type DeleteVehicleMaintenance = {
  id: Scalars['ID'];
};

export type DeleteVehicleMake = {
  id: Scalars['ID'];
};

export type DeleteVehicleModel = {
  id: Scalars['ID'];
};

export type DeleteVehicleNotificationGroup = {
  id: Scalars['ID'];
};

export type DeleteVehicleStateInspection = {
  id: Scalars['ID'];
};

export type DeleteWaypoint = {
  id: Scalars['ID'];
};

export type DeliverTrackedMessage = {
  trackedMessageId: Scalars['ID'];
};

export type DenyReceivingFacilityRequest = {
  id: Scalars['ID'];
  nonAcceptanceReasonId: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  time: Scalars['DateTime'];
};

export type DenyTrmUser = {
  id: Scalars['ID'];
};

export type DepartVehicle = {
  isEmergent: InputMaybe<Scalars['Boolean']>;
  note: InputMaybe<Scalars['String']>;
  odometerReading: InputMaybe<Scalars['Float']>;
  vehicleId: Scalars['ID'];
};

export type Department = Entity &
  Evented & {
    __typename: 'Department';
    _events: MessageEnvelopeCollection;
    code: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    people: Maybe<Array<Maybe<Person>>>;
    regionGroups: Array<RegionGroup>;
  };

export type Department_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DepartmentCollection = {
  __typename: 'DepartmentCollection';
  items: Array<Department>;
  meta: DepartmentCollectionMetadata;
};

export type DepartmentCollectionMetadata = CollectionMetadata & {
  __typename: 'DepartmentCollectionMetadata';
  total: Scalars['Int'];
};

export type DevNoteCollection = {
  __typename: 'DevNoteCollection';
  items: Array<DevNoteResult>;
  meta: DevNoteCollectionMetadata;
};

export type DevNoteCollectionMetadata = CollectionMetadata & {
  __typename: 'DevNoteCollectionMetadata';
  total: Scalars['Int'];
};

export type DevNoteFilter = {
  noteTimeFrom: InputMaybe<Scalars['DateTime']>;
};

export type DevNoteResult = {
  __typename: 'DevNoteResult';
  authorId: Scalars['ID'];
  cardNumber: Maybe<Scalars['ID']>;
  companyName: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  name: Maybe<Scalars['String']>;
  noteTime: Maybe<Scalars['DateTime']>;
};

export type DisableUnit = {
  id: Scalars['ID'];
};

export type DismissApplicationNotification = {
  applicationNotificationId: Scalars['ID'];
};

export type DisregardExternalAction = {
  id: Scalars['ID'];
};

export enum DistanceCalculation {
  FromAircraft = 'FromAircraft',
  FromBase = 'FromBase',
}

export type DiversionReason = Entity &
  Evented & {
    __typename: 'DiversionReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requests: Maybe<Array<Maybe<RequestLocation>>>;
  };

export type DiversionReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DiversionReasonCollection = {
  __typename: 'DiversionReasonCollection';
  items: Array<DiversionReason>;
  meta: DiversionReasonCollectionMetadata;
};

export type DiversionReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'DiversionReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type DiversionReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type DiversionReasonQueries = {
  __typename: 'DiversionReasonQueries';
  all: DiversionReasonCollection;
  byId: Maybe<DiversionReason>;
};

export type DiversionReasonQueriesallArgs = {
  filter: InputMaybe<DiversionReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type DiversionReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum DiversionType {
  Diversion = 'Diversion',
  FollowOn = 'FollowOn',
}

export type Divert = {
  cardId: Scalars['ID'];
  diversionReasonId: Scalars['ID'];
  medicalFacilityId: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
};

export type DivertReceivingFacilityRequest = {
  divertedToFacilityId: Scalars['ID'];
  nonAcceptanceReasonId: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  previousFacilityId: Scalars['ID'];
  requestId: Scalars['ID'];
  time: Scalars['DateTime'];
};

export type DuplicateRequest = {
  id: Scalars['ID'];
};

export enum EmployeeType {
  Contingent = 'Contingent',
  NonEmployee = 'NonEmployee',
  Prn = 'Prn',
  Regular = 'Regular',
  Temporary = 'Temporary',
  Unspecified = 'Unspecified',
}

export type EnableUnit = {
  id: Scalars['ID'];
};

export type EndCrewMemberOutOfServiceEvent = {
  outOfServiceEventId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type EndOutOfServiceEvent = {
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  id: Scalars['ID'];
  isAirworthy: Scalars['Boolean'];
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  notes: InputMaybe<Scalars['String']>;
  paipEventId: InputMaybe<Scalars['ID']>;
  reasonId: Scalars['ID'];
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  type: OutOfServiceType;
  unitRemainsOutOfServiceNotes: InputMaybe<Scalars['String']>;
  unitRemainsOutOfServiceReasonId: InputMaybe<Scalars['ID']>;
  unitRemainsOutOfServiceSecondaryReasonId: InputMaybe<Scalars['ID']>;
};

export type EndPaipEvent = {
  paipEventId: Scalars['ID'];
};

export type EngineParameters = {
  __typename: 'EngineParameters';
  starts: Maybe<Scalars['Float']>;
  time: Maybe<Scalars['Float']>;
};

export type EngineParametersInput = {
  starts: InputMaybe<Scalars['Float']>;
  time: InputMaybe<Scalars['Float']>;
};

export type EnsureThirdPartyUnit = {
  unitId: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type EnsureThirdPartyUnits = {
  companyId: InputMaybe<Scalars['ID']>;
  unitIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EnsureThirdPartyVehicleAndUnit = {
  companyId: Scalars['ID'];
  unitAbbreviation: Scalars['String'];
  unitId: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type Entity = {
  dateCreated: Scalars['DateTime'];
  dateDeleted: Maybe<Scalars['DateTime']>;
  dateLastUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type EntityCapability = Entity &
  Evented & {
    __typename: 'EntityCapability';
    _events: MessageEnvelopeCollection;
    capability: Capability;
    capabilityId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Scalars['ID'];
    entityType: EntityType;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
  };

export type EntityCapability_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type EntityCapabilityCollection = {
  __typename: 'EntityCapabilityCollection';
  items: Array<EntityCapability>;
  meta: EntityCapabilityCollectionMetadata;
};

export type EntityCapabilityCollectionMetadata = CollectionMetadata & {
  __typename: 'EntityCapabilityCollectionMetadata';
  total: Scalars['Int'];
};

export type EntityCapabilityFilter = {
  capabilityEntityType: InputMaybe<Scalars['String']>;
  entityId: InputMaybe<Scalars['String']>;
};

export type EntityCapabilityQueries = {
  __typename: 'EntityCapabilityQueries';
  all: EntityCapabilityCollection;
  byId: Maybe<EntityCapability>;
};

export type EntityCapabilityQueriesallArgs = {
  filter: InputMaybe<EntityCapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type EntityCapabilityQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type EntityQueries = {
  __typename: 'EntityQueries';
  byId: Maybe<TcsEntity>;
  byIds: Array<TcsEntity>;
};

export type EntityQueriesbyIdArgs = {
  id: Scalars['ID'];
  type: TcsEntityType;
};

export type EntityQueriesbyIdsArgs = {
  ids: Array<Scalars['ID']>;
  type: TcsEntityType;
};

export type EntityRef = {
  __typename: 'EntityRef';
  entityId: Scalars['ID'];
  entityType: EntityType;
};

export type EntityRefInput = {
  entityId: Scalars['ID'];
  entityType: EntityType;
};

export type EntityReference = {
  __typename: 'EntityReference';
  entityId: Scalars['ID'];
  entityPath: Scalars['String'];
};

export type EntityReferenceInput = {
  entityId: Scalars['ID'];
  entityPath: Scalars['String'];
};

export enum EntityType {
  Airport = 'Airport',
  Base = 'Base',
  Card = 'Card',
  CommunicationCenter = 'CommunicationCenter',
  Company = 'Company',
  ControlZone = 'ControlZone',
  Location = 'Location',
  MedicalFacility = 'MedicalFacility',
  OutOfServiceEvent = 'OutOfServiceEvent',
  PaipEvent = 'PaipEvent',
  Person = 'Person',
  Program = 'Program',
  Region = 'Region',
  Timer = 'Timer',
  Unit = 'Unit',
  Unspecified = 'Unspecified',
  Vehicle = 'Vehicle',
}

export type Error = {
  __typename: 'Error';
  code: Scalars['Int'];
  message: Scalars['String'];
};

export type EscortRequest = Entity &
  Evented & {
    __typename: 'EscortRequest';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    escortName: Scalars['String'];
    escortWeightInKg: Scalars['Float'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    relationship: PatientRelationshipType;
    request: Request;
    requestApprovalTime: Scalars['DateTime'];
    requestId: Scalars['ID'];
  };

export type EscortRequest_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type EscortRequestCollection = {
  __typename: 'EscortRequestCollection';
  items: Array<EscortRequest>;
  meta: EscortRequestCollectionMetadata;
};

export type EscortRequestCollectionMetadata = CollectionMetadata & {
  __typename: 'EscortRequestCollectionMetadata';
  total: Scalars['Int'];
};

export type EstimatedDuration = Entity &
  Evented & {
    __typename: 'EstimatedDuration';
    _events: MessageEnvelopeCollection;
    asOfTime: Scalars['DateTime'];
    calculatedTripLeg: Maybe<TripLeg>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    durationInMinutes: Scalars['Int'];
    durationType: EstimatedDurationType;
    estimateSource: EstimatedDurationSource;
    id: Scalars['ID'];
    isOfficial: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    ownerId: Scalars['ID'];
    positionReport: Maybe<PositionReport>;
    positionReportId: Maybe<Scalars['ID']>;
    trip: Trip;
    tripId: Scalars['ID'];
    tripLeg: Maybe<TripLeg>;
    waypoint: Maybe<Waypoint>;
  };

export type EstimatedDuration_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type EstimatedDurationCollection = {
  __typename: 'EstimatedDurationCollection';
  items: Array<EstimatedDuration>;
  meta: EstimatedDurationCollectionMetadata;
};

export type EstimatedDurationCollectionMetadata = CollectionMetadata & {
  __typename: 'EstimatedDurationCollectionMetadata';
  total: Scalars['Int'];
};

export enum EstimatedDurationSource {
  Gps = 'Gps',
  Pilot = 'Pilot',
}

export enum EstimatedDurationType {
  TripLeg = 'TripLeg',
  Waypoint = 'Waypoint',
}

export type Eta = Entity &
  Evented & {
    __typename: 'Eta';
    _events: MessageEnvelopeCollection;
    asOfTime: Scalars['DateTime'];
    calculatedArrivalTime: Scalars['DateTime'];
    companyId: Scalars['ID'];
    currentTrip: Trip;
    currentTripId: Scalars['ID'];
    currentWaypoint: Maybe<Waypoint>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    estimatedArrivalTime: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    waypoint: Waypoint;
    waypointId: Scalars['ID'];
  };

export type Eta_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type EtaCollection = {
  __typename: 'EtaCollection';
  items: Array<Eta>;
  meta: EtaCollectionMetadata;
};

export type EtaCollectionMetadata = CollectionMetadata & {
  __typename: 'EtaCollectionMetadata';
  total: Scalars['Int'];
};

export type Evented = {
  _events: MessageEnvelopeCollection;
};

export type Evented_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type EventedFilter = {
  userOnly: InputMaybe<Scalars['Boolean']>;
};

export type ExternalAction = Entity &
  Evented & {
    __typename: 'ExternalAction';
    _events: MessageEnvelopeCollection;
    actionBodyJson: Scalars['String'];
    actionType: ExternalActionType;
    actionTypeId: Scalars['ID'];
    companyId: Scalars['ID'];
    completedById: Maybe<Scalars['ID']>;
    dateCompleted: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Scalars['ID'];
    entityType: EntityType;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notes: Maybe<Scalars['String']>;
    status: ExternalActionStatus;
  };

export type ExternalAction_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ExternalActionAcceptReferralRequest = {
  __typename: 'ExternalActionAcceptReferralRequest';
  cardId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type ExternalActionAcceptReferralRequestInput = {
  cardId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type ExternalActionActivateUnit = {
  __typename: 'ExternalActionActivateUnit';
  unitId: Scalars['ID'];
};

export type ExternalActionActivateUnitInput = {
  unitId: Scalars['ID'];
};

export type ExternalActionCancelRequest = {
  __typename: 'ExternalActionCancelRequest';
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: Maybe<Scalars['String']>;
  cancellationSecondaryReasonId: Maybe<Scalars['ID']>;
};

export type ExternalActionCancelRequestInput = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
};

export type ExternalActionCollection = {
  __typename: 'ExternalActionCollection';
  items: Array<ExternalAction>;
  meta: ExternalActionCollectionMetadata;
};

export type ExternalActionCollectionMetadata = CollectionMetadata & {
  __typename: 'ExternalActionCollectionMetadata';
  total: Scalars['Int'];
};

export type ExternalActionDeclineReferralRequest = {
  __typename: 'ExternalActionDeclineReferralRequest';
  cardId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type ExternalActionDeclineReferralRequestInput = {
  cardId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type ExternalActionFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  includeCompleted: InputMaybe<Scalars['Boolean']>;
};

export type ExternalActionQueries = {
  __typename: 'ExternalActionQueries';
  all: ExternalActionCollection;
  byId: Maybe<ExternalAction>;
};

export type ExternalActionQueriesallArgs = {
  filter: InputMaybe<ExternalActionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ExternalActionQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type ExternalActionReferralRequestDeclined = {
  __typename: 'ExternalActionReferralRequestDeclined';
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: Maybe<Scalars['ID']>;
  unitId: Scalars['ID'];
};

export type ExternalActionReferralRequestDeclinedInput = {
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  unitId: Scalars['ID'];
};

export type ExternalActionRemoveStandby = {
  __typename: 'ExternalActionRemoveStandby';
  requestId: Scalars['ID'];
  unitId: Maybe<Scalars['ID']>;
};

export type ExternalActionRemoveStandbyInput = {
  requestId: Scalars['ID'];
  unitId: InputMaybe<Scalars['ID']>;
};

export type ExternalActionRequestSceneLocationChange = {
  __typename: 'ExternalActionRequestSceneLocationChange';
  address: Address;
  groundContact: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
};

export type ExternalActionRequestSceneLocationChangeInput = {
  address: AddressInput;
  groundContact: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
};

export enum ExternalActionStatus {
  Completed = 'Completed',
  Disregarded = 'Disregarded',
  Requested = 'Requested',
  Unknown = 'Unknown',
}

export type ExternalActionType = Entity &
  Evented & {
    __typename: 'ExternalActionType';
    _events: MessageEnvelopeCollection;
    actionTypeDescription: Scalars['String'];
    actionTypeName: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    externalActions: Array<ExternalAction>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    priority: Scalars['Int'];
  };

export type ExternalActionType_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ExternalActionTypeCollection = {
  __typename: 'ExternalActionTypeCollection';
  items: Array<ExternalActionType>;
  meta: ExternalActionTypeCollectionMetadata;
};

export type ExternalActionTypeCollectionMetadata = CollectionMetadata & {
  __typename: 'ExternalActionTypeCollectionMetadata';
  total: Scalars['Int'];
};

export type ExternalActionTypeQueries = {
  __typename: 'ExternalActionTypeQueries';
  all: ExternalActionTypeCollection;
};

export type ExternalReference = Entity &
  Evented & {
    __typename: 'ExternalReference';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Scalars['ID'];
    entityType: EntityType;
    externalKey: Scalars['String'];
    externalSystem: ExternalSystem;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
  };

export type ExternalReference_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ExternalReferenceCollection = {
  __typename: 'ExternalReferenceCollection';
  items: Array<ExternalReference>;
  meta: ExternalReferenceCollectionMetadata;
};

export type ExternalReferenceCollectionMetadata = CollectionMetadata & {
  __typename: 'ExternalReferenceCollectionMetadata';
  total: Scalars['Int'];
};

export type ExternalReferenceFilter = {
  entityId: InputMaybe<Scalars['ID']>;
};

export type ExternalReferenceQueries = {
  __typename: 'ExternalReferenceQueries';
  all: ExternalReferenceCollection;
  byId: Maybe<ExternalReference>;
};

export type ExternalReferenceQueriesallArgs = {
  filter: InputMaybe<ExternalReferenceFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ExternalReferenceQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum ExternalSystem {
  FlightVector = 'FlightVector',
  GoldenHour = 'GoldenHour',
  K2 = 'K2',
  SkyTrac = 'SkyTrac',
  Workday = 'Workday',
}

export type ExternalSystemUnit = Entity &
  Evented & {
    __typename: 'ExternalSystemUnit';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    baseId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    currentCardNumber: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastKnownCoordinates: Maybe<Coordinates>;
    lastKnownLocationName: Maybe<Scalars['String']>;
    lastQualifyingPositionReportTime: Maybe<Scalars['DateTime']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    modelName: Maybe<Scalars['String']>;
    name: Scalars['String'];
    outOfServiceEvents: Array<OutOfServiceEventSummary>;
    regionId: Scalars['ID'];
    registrationNumber: Scalars['String'];
    unitId: Scalars['ID'];
    unitStatus: UnitStatus;
    vehicleId: Scalars['ID'];
    vehicleStatus: VehicleStatus;
    vehicleStatusDescription: Scalars['String'];
    vehicleType: VehicleType;
  };

export type ExternalSystemUnit_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ExternalSystemUnitCollection = {
  __typename: 'ExternalSystemUnitCollection';
  items: Array<ExternalSystemUnit>;
  meta: ExternalSystemUnitCollectionMetadata;
};

export type ExternalSystemUnitCollectionMetadata = CollectionMetadata & {
  __typename: 'ExternalSystemUnitCollectionMetadata';
  total: Scalars['Int'];
};

export type FacilityNonAcceptanceReason = Entity &
  Evented & {
    __typename: 'FacilityNonAcceptanceReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    facilityNonAcceptanceReasonType: NonAcceptanceType;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    receivingFacilityRequests: Maybe<Array<Maybe<ReceivingFacilityRequest>>>;
  };

export type FacilityNonAcceptanceReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FacilityNonAcceptanceReasonCollection = {
  __typename: 'FacilityNonAcceptanceReasonCollection';
  items: Array<FacilityNonAcceptanceReason>;
  meta: FacilityNonAcceptanceReasonCollectionMetadata;
};

export type FacilityNonAcceptanceReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'FacilityNonAcceptanceReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type FacilityNonAcceptanceReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type FacilityNonAcceptanceReasonQueries = {
  __typename: 'FacilityNonAcceptanceReasonQueries';
  all: FacilityNonAcceptanceReasonCollection;
  byId: Maybe<FacilityNonAcceptanceReason>;
};

export type FacilityNonAcceptanceReasonQueriesallArgs = {
  filter: InputMaybe<FacilityNonAcceptanceReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FacilityNonAcceptanceReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type Fbo = Entity &
  Evented & {
    __typename: 'Fbo';
    _events: MessageEnvelopeCollection;
    airport: Airport;
    airportId: Scalars['ID'];
    airports: Maybe<Array<Maybe<Airport>>>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    fboType: FboType;
    flightFollowingReports: Maybe<Array<Maybe<FlightFollowingReport>>>;
    fuelBrand: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requests: Maybe<Array<Maybe<RequestLocation>>>;
    sourceSystemId: Maybe<Scalars['Int']>;
  };

export type Fbo_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FboCollection = {
  __typename: 'FboCollection';
  items: Array<Fbo>;
  meta: FboCollectionMetadata;
};

export type FboCollectionMetadata = CollectionMetadata & {
  __typename: 'FboCollectionMetadata';
  total: Scalars['Int'];
};

export type FboFilter = {
  airportId: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type FboQueries = {
  __typename: 'FboQueries';
  all: FboCollection;
  byId: Maybe<Fbo>;
};

export type FboQueriesallArgs = {
  filter: InputMaybe<FboFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FboQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum FboType {
  FBO = 'FBO',
  FlightSupportOrganisation = 'FlightSupportOrganisation',
  FuelOnly = 'FuelOnly',
  Handler = 'Handler',
  LineRampEngineering = 'LineRampEngineering',
  SupervisingAgent = 'SupervisingAgent',
}

export enum FetchPolicy {
  Cache = 'Cache',
  CacheThenDatabase = 'CacheThenDatabase',
  Database = 'Database',
}

export type FirewallRule = Entity &
  Evented & {
    __typename: 'FirewallRule';
    _events: MessageEnvelopeCollection;
    action: AccessControlAction;
    companyId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    enabled: Scalars['Boolean'];
    id: Scalars['ID'];
    ipRange: Scalars['String'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type FirewallRule_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FirewallRuleCollection = {
  __typename: 'FirewallRuleCollection';
  items: Array<FirewallRule>;
  meta: FirewallRuleCollectionMetadata;
};

export type FirewallRuleCollectionMetadata = CollectionMetadata & {
  __typename: 'FirewallRuleCollectionMetadata';
  total: Scalars['Int'];
};

export type FirewallRuleFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type FirewallRuleQueries = {
  __typename: 'FirewallRuleQueries';
  all: FirewallRuleCollection;
  byId: Maybe<FirewallRule>;
};

export type FirewallRuleQueriesallArgs = {
  filter: InputMaybe<FirewallRuleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FirewallRuleQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum FlightFollowingField {
  CenterOfGravity = 'CenterOfGravity',
  CruisingAltitude = 'CruisingAltitude',
  EstimatedTimeEnRouteMinutes = 'EstimatedTimeEnRouteMinutes',
  FlightRule = 'FlightRule',
  FlightType = 'FlightType',
  Fuel = 'Fuel',
  HighestFeatureEnRoute = 'HighestFeatureEnRoute',
  MedicalCrewRA = 'MedicalCrewRA',
  RiskAnalysis = 'RiskAnalysis',
  SoulsOnBoard = 'SoulsOnBoard',
  TakeOffWeight = 'TakeOffWeight',
  TrackingViaGps = 'TrackingViaGps',
}

export type FlightFollowingReport = Entity &
  Evented & {
    __typename: 'FlightFollowingReport';
    _events: MessageEnvelopeCollection;
    centerOfGravity: Maybe<Scalars['Float']>;
    companyId: Scalars['ID'];
    confirmedFbo: Maybe<Fbo>;
    confirmedFboId: Maybe<Scalars['ID']>;
    cruisingAltitude: Maybe<Scalars['Int']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    destination: Maybe<Scalars['String']>;
    estimatedTimeEnrouteMinutes: Maybe<Scalars['Int']>;
    flightRule: Maybe<FlightRule>;
    flightType: Maybe<FlightType>;
    fuel: Maybe<Scalars['String']>;
    highestFeatureEnroute: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalCrewRA: Maybe<Scalars['Int']>;
    riskAnalysis: Maybe<Scalars['String']>;
    soulsOnBoard: Maybe<Scalars['Int']>;
    summary: Maybe<Scalars['String']>;
    takeOffWeight: Maybe<Scalars['Float']>;
    trackingViaGps: Maybe<Scalars['Boolean']>;
    trip: Trip;
    tripId: Scalars['ID'];
    tripLeg: Maybe<TripLeg>;
    tripLegId: Maybe<Scalars['ID']>;
    vehicleDisposition: Maybe<VehicleDisposition>;
  };

export type FlightFollowingReport_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FlightFollowingReportCollection = {
  __typename: 'FlightFollowingReportCollection';
  items: Array<FlightFollowingReport>;
  meta: FlightFollowingReportCollectionMetadata;
};

export type FlightFollowingReportCollectionMetadata = CollectionMetadata & {
  __typename: 'FlightFollowingReportCollectionMetadata';
  total: Scalars['Int'];
};

export enum FlightLogProcess {
  External = 'External',
  FlightLogDynamic = 'FlightLogDynamic',
  FlightLogStatic = 'FlightLogStatic',
  PstStatic = 'PstStatic',
}

export enum FlightRule {
  Ifr = 'Ifr',
  None = 'None',
  Vfr = 'Vfr',
}

export enum FlightType {
  Pt91 = 'Pt91',
  Pt133 = 'Pt133',
  Pt135 = 'Pt135',
}

export type FuelTank = Entity &
  Evented & {
    __typename: 'FuelTank';
    _events: MessageEnvelopeCollection;
    base: Maybe<Base>;
    baseId: Maybe<Scalars['ID']>;
    code: Scalars['String'];
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Location;
    locationId: Scalars['ID'];
    locationName: Maybe<Scalars['String']>;
    name: Scalars['String'];
    operationsEnded: Maybe<Scalars['DateTime']>;
    operationsStarted: Maybe<Scalars['DateTime']>;
    sourceSystemId: Maybe<Scalars['Int']>;
  };

export type FuelTank_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FuelTankCollection = {
  __typename: 'FuelTankCollection';
  items: Array<FuelTank>;
  meta: FuelTankCollectionMetadata;
};

export type FuelTankCollectionMetadata = CollectionMetadata & {
  __typename: 'FuelTankCollectionMetadata';
  total: Scalars['Int'];
};

export type FuelTankFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type FuelTankQueries = {
  __typename: 'FuelTankQueries';
  all: FuelTankCollection;
  byId: Maybe<FuelTank>;
};

export type FuelTankQueriesallArgs = {
  filter: InputMaybe<FuelTankFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type FuelTankQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  Unspecified = 'Unspecified',
}

export type GenerateAttachmentUrl = {
  attachmentId: Scalars['ID'];
};

export type GenerateCardReport = {
  cardId: Scalars['ID'];
};

export type GenerateCardSummaryChange = {
  cardId: Scalars['ID'];
};

export type GenerateCardSummaryChangeV2 = {
  cardId: Scalars['ID'];
};

export type GenerateLocationHazardAttachmentUrl = {
  attachmentId: Scalars['ID'];
};

export type GeocodeResponse = {
  __typename: 'GeocodeResponse';
  candidates: Array<AddressResult>;
};

export type GeocodeResponseWithTimezone = {
  __typename: 'GeocodeResponseWithTimezone';
  candidates: Array<AddressResult>;
  timezoneResult: TimezoneResponse;
};

export enum GeocodeResultQuality {
  Address = 'Address',
  City = 'City',
  County = 'County',
  Intersection = 'Intersection',
  Neighborhood = 'Neighborhood',
  Point = 'Point',
  State = 'State',
  Street = 'Street',
  Unknown = 'Unknown',
  Zip = 'Zip',
}

export type GisQueries = {
  __typename: 'GisQueries';
  _allTimezonesMeta: QueryMeta;
  allTimezones: Array<Timezone>;
  geocodeByAddress: GeocodeResponse;
  reverseGeocode: GeocodeResponse;
  reverseGeocodeWithTimezone: GeocodeResponseWithTimezone;
  timezoneByCode: Maybe<Timezone>;
  timezoneByCoordinates: TimezoneResponse;
};

export type GisQueriesallTimezonesArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type GisQueriesgeocodeByAddressArgs = {
  address: AddressInput;
};

export type GisQueriesreverseGeocodeArgs = {
  coordinates: CoordinatesInput;
};

export type GisQueriesreverseGeocodeWithTimezoneArgs = {
  coordinates: CoordinatesInput;
};

export type GisQueriestimezoneByCodeArgs = {
  code: Scalars['String'];
};

export type GisQueriestimezoneByCoordinatesArgs = {
  coordinates: CoordinatesInput;
};

export enum GpsProvider {
  MediationService = 'MediationService',
  Skytrac = 'Skytrac',
}

export type GrantClientSyncAccess = {
  userId: Scalars['ID'];
};

export type HideUnit = {
  unitId: Scalars['ID'];
};

export type HideVehicle = {
  vehicleId: Scalars['ID'];
};

export type HoursOfOperation = {
  __typename: 'HoursOfOperation';
  endTime: Maybe<Scalars['DateTime']>;
  is24Hours: Maybe<Scalars['Boolean']>;
  startTime: Maybe<Scalars['DateTime']>;
};

export type HoursOfOperationInput = {
  endTime: InputMaybe<Scalars['DateTime']>;
  is24Hours: InputMaybe<Scalars['Boolean']>;
  startTime: InputMaybe<Scalars['DateTime']>;
};

export enum HumanErrorDamageType {
  Maintenance = 'Maintenance',
  MedicalCrew = 'MedicalCrew',
  Pilot = 'Pilot',
}

export type IdListItem = {
  __typename: 'IdListItem';
  id: Scalars['ID'];
};

export type IdListItemInput = {
  id: Scalars['ID'];
};

export type IdNameListItem = {
  __typename: 'IdNameListItem';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IdNameListItemInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ImageSize {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}

export type InitiateTransportCheck = {
  id: Scalars['ID'];
};

export type InsertWaypoint = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  insertAfterWaypointId: Scalars['ID'];
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  timezoneCd: InputMaybe<Scalars['String']>;
  tripId: Scalars['ID'];
  type: WaypointType;
};

export enum IntegrationSystem {
  EmSystem = 'EmSystem',
  Reddinet = 'Reddinet',
  STrac = 'STrac',
}

export enum IsoletteType {
  DraegerIsolette = 'DraegerIsolette',
  LifeportDeck = 'LifeportDeck',
  MetroPallet = 'MetroPallet',
  SpectrumSled = 'SpectrumSled',
  Unconfirmed = 'Unconfirmed',
  Unspecified = 'Unspecified',
  VoyagerIsolette = 'VoyagerIsolette',
  VoyagerIsolette1 = 'VoyagerIsolette1',
  VoyagerIsolette2 = 'VoyagerIsolette2',
  VoyagerIsolette4 = 'VoyagerIsolette4',
  VoyagerIsolette6 = 'VoyagerIsolette6',
}

export type LandingZoneOutOfServiceReason = Entity &
  Evented & {
    __typename: 'LandingZoneOutOfServiceReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    locations: Maybe<Array<Maybe<Location>>>;
    name: Scalars['String'];
  };

export type LandingZoneOutOfServiceReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type LandingZoneOutOfServiceReasonCollection = {
  __typename: 'LandingZoneOutOfServiceReasonCollection';
  items: Array<LandingZoneOutOfServiceReason>;
  meta: LandingZoneOutOfServiceReasonCollectionMetadata;
};

export type LandingZoneOutOfServiceReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'LandingZoneOutOfServiceReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type LandingZoneOutOfServiceReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type LandingZoneOutOfServiceReasonQueries = {
  __typename: 'LandingZoneOutOfServiceReasonQueries';
  all: LandingZoneOutOfServiceReasonCollection;
  byId: Maybe<LandingZoneOutOfServiceReason>;
};

export type LandingZoneOutOfServiceReasonQueriesallArgs = {
  filter: InputMaybe<LandingZoneOutOfServiceReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type LandingZoneOutOfServiceReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type LinkCards = {
  cardId1: Scalars['ID'];
  cardId2: Scalars['ID'];
};

export type LinkOutOfServiceEvent = {
  outOfServiceEventId: Scalars['ID'];
  outOfServiceTicketId: Scalars['ID'];
};

export type Location = Entity &
  Evented & {
    __typename: 'Location';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    address: Address;
    agencyLocation: Maybe<AgencyLocation>;
    airport: Maybe<Airport>;
    bases: Array<Base>;
    closedDate: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    distanceToReceiving: Maybe<Scalars['Float']>;
    distanceToReceivingMiles: Maybe<Scalars['Float']>;
    distanceToReceivingNauticaMiles: Maybe<Scalars['Float']>;
    duplicateOfId: Maybe<Scalars['ID']>;
    entityCapabilities: Array<EntityCapability>;
    fbo: Maybe<Fbo>;
    fuelTanks: Array<FuelTank>;
    id: Scalars['ID'];
    isLandingZoneOutOfService: Maybe<Scalars['Boolean']>;
    isPreferred: Scalars['Boolean'];
    isRotorWingLz: Maybe<Scalars['Boolean']>;
    landingZoneOutOfServiceExpirationDate: Maybe<Scalars['DateTime']>;
    landingZoneOutOfServiceNotes: Maybe<Scalars['String']>;
    landingZoneOutOfServiceReason: Maybe<LandingZoneOutOfServiceReason>;
    landingZoneOutOfServiceReasonId: Maybe<Scalars['ID']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    locationHazards: Array<LocationHazard>;
    locationType: LocationType;
    maintenanceFacility: Maybe<MaintenanceFacility>;
    medicalFacilities: Maybe<Array<Maybe<MedicalFacility>>>;
    medicalFacility: Maybe<MedicalFacility>;
    name: Scalars['String'];
    notes: Maybe<Scalars['String']>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceTickets: Maybe<Array<Maybe<OutOfServiceTicket>>>;
    people: Maybe<Array<Maybe<Person>>>;
    sourceSystemId: Maybe<Scalars['String']>;
    specialtyTeams: Array<SpecialtyTeam>;
    timezoneCd: Maybe<Scalars['String']>;
    waypoints: Maybe<Array<Maybe<Waypoint>>>;
  };

export type Location_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type LocationByIdOptions = {
  includeDeleted: InputMaybe<Scalars['Boolean']>;
};

export type LocationCollection = {
  __typename: 'LocationCollection';
  items: Array<Location>;
  meta: LocationCollectionMetadata;
};

export type LocationCollectionMetadata = CollectionMetadata & {
  __typename: 'LocationCollectionMetadata';
  total: Scalars['Int'];
};

export type LocationFilter = {
  locationId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type LocationHazard = Entity &
  Evented & {
    __typename: 'LocationHazard';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    effectiveDate: Maybe<Scalars['DateTime']>;
    expirationDate: Maybe<Scalars['DateTime']>;
    hazard: Scalars['String'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Location;
    locationHazardAttachments: Array<LocationHazardAttachment>;
    locationId: Scalars['ID'];
  };

export type LocationHazard_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type LocationHazardAttachment = Entity &
  Evented & {
    __typename: 'LocationHazardAttachment';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    contentType: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    fileName: Scalars['String'];
    fileSizeInBytes: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    locationHazard: LocationHazard;
    locationHazardId: Scalars['ID'];
  };

export type LocationHazardAttachment_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type LocationHazardAttachmentCollection = {
  __typename: 'LocationHazardAttachmentCollection';
  items: Array<LocationHazardAttachment>;
  meta: LocationHazardAttachmentCollectionMetadata;
};

export type LocationHazardAttachmentCollectionMetadata = CollectionMetadata & {
  __typename: 'LocationHazardAttachmentCollectionMetadata';
  total: Scalars['Int'];
};

export type LocationHazardCollection = {
  __typename: 'LocationHazardCollection';
  items: Array<LocationHazard>;
  meta: LocationHazardCollectionMetadata;
};

export type LocationHazardCollectionMetadata = CollectionMetadata & {
  __typename: 'LocationHazardCollectionMetadata';
  total: Scalars['Int'];
};

export type LocationHazardFilter = {
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
};

export type LocationHazardQueries = {
  __typename: 'LocationHazardQueries';
  all: LocationHazardCollection;
  byId: Maybe<LocationHazard>;
  byLocationId: LocationHazardCollection;
};

export type LocationHazardQueriesallArgs = {
  filter: InputMaybe<LocationHazardFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type LocationHazardQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type LocationHazardQueriesbyLocationIdArgs = {
  locationId: Scalars['ID'];
};

export type LocationQueries = {
  __typename: 'LocationQueries';
  all: LocationCollection;
  byId: Maybe<Location>;
  byIds: Array<Location>;
};

export type LocationQueriesallArgs = {
  filter: InputMaybe<LocationQueryFilter>;
};

export type LocationQueriesbyIdArgs = {
  id: Scalars['ID'];
  options: InputMaybe<LocationByIdOptions>;
};

export type LocationQueriesbyIdsArgs = {
  ids: Array<Scalars['ID']>;
  options: InputMaybe<LocationByIdOptions>;
};

export type LocationQueryFilter = {
  abbreviationLike: InputMaybe<Scalars['String']>;
  capabilityIds: InputMaybe<Array<Scalars['ID']>>;
  cityLike: InputMaybe<Scalars['String']>;
  coordinates: InputMaybe<CoordinatesInput>;
  countyLike: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  locationTypes: InputMaybe<Array<LocationType>>;
  maxDistanceInMiles: InputMaybe<Scalars['Int']>;
  nameLike: InputMaybe<Scalars['String']>;
  skip: InputMaybe<Scalars['Int']>;
  stateId: InputMaybe<Scalars['ID']>;
  stateLike: InputMaybe<Scalars['String']>;
};

export enum LocationType {
  Agency = 'Agency',
  Airport = 'Airport',
  Base = 'Base',
  CommunicationsCenter = 'CommunicationsCenter',
  CorporateOffice = 'CorporateOffice',
  Fbo = 'Fbo',
  FuelTank = 'FuelTank',
  Hangar = 'Hangar',
  LandingZone = 'LandingZone',
  MaintenanceFacility = 'MaintenanceFacility',
  MedicalFacility = 'MedicalFacility',
  RadioTower = 'RadioTower',
  RemoteMaintenanceFacility = 'RemoteMaintenanceFacility',
  Unspecified = 'Unspecified',
}

export type Lookup = {
  code: Scalars['String'];
};

export type LookupAgencyLocationByPhoneNumber = {
  phoneNumber: Scalars['String'];
};

export type MaintenanceFacility = Entity &
  Evented & {
    __typename: 'MaintenanceFacility';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceTickets: Maybe<Array<Maybe<OutOfServiceTicket>>>;
  };

export type MaintenanceFacility_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MaintenanceFacilityCollection = {
  __typename: 'MaintenanceFacilityCollection';
  items: Array<MaintenanceFacility>;
  meta: MaintenanceFacilityCollectionMetadata;
};

export type MaintenanceFacilityCollectionMetadata = CollectionMetadata & {
  __typename: 'MaintenanceFacilityCollectionMetadata';
  total: Scalars['Int'];
};

export type MaintenanceFacilityFilter = {
  cityLike: InputMaybe<Scalars['String']>;
  countyLike: InputMaybe<Scalars['String']>;
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
  stateLike: InputMaybe<Scalars['String']>;
  streetAddressLike: InputMaybe<Scalars['String']>;
};

export type MaintenanceFacilityQueries = {
  __typename: 'MaintenanceFacilityQueries';
  all: MaintenanceFacilityCollection;
  byId: Maybe<MaintenanceFacility>;
};

export type MaintenanceFacilityQueriesallArgs = {
  filter: InputMaybe<MaintenanceFacilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MaintenanceFacilityQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type MaintenanceParameters = {
  __typename: 'MaintenanceParameters';
  airframeTime: Maybe<Scalars['Float']>;
  endingHobbs: Maybe<Scalars['Float']>;
  engine1: Maybe<EngineParameters>;
  engine2: Maybe<EngineParameters>;
  totalLandings: Maybe<Scalars['Int']>;
};

export type MaintenanceParametersInput = {
  airframeTime: InputMaybe<Scalars['Float']>;
  endingHobbs: InputMaybe<Scalars['Float']>;
  engine1: InputMaybe<EngineParametersInput>;
  engine2: InputMaybe<EngineParametersInput>;
  totalLandings: InputMaybe<Scalars['Int']>;
};

export type MakeEstimatedDurationOfficial = {
  id: Scalars['ID'];
};

export type ManifestEntry = Entity &
  Evented & {
    __typename: 'ManifestEntry';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    confirmedAt: Maybe<Scalars['DateTime']>;
    confirmedBy: Maybe<Person>;
    confirmedById: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    passenger: TripPassenger;
    passengerId: Scalars['ID'];
    tripLeg: TripLeg;
    tripLegId: Scalars['ID'];
  };

export type ManifestEntry_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ManifestEntryCollection = {
  __typename: 'ManifestEntryCollection';
  items: Array<ManifestEntry>;
  meta: ManifestEntryCollectionMetadata;
};

export type ManifestEntryCollectionMetadata = CollectionMetadata & {
  __typename: 'ManifestEntryCollectionMetadata';
  total: Scalars['Int'];
};

export type MarkAsPilotUpdated = {
  id: Scalars['ID'];
};

export type MedicalControlContactLogEntry = Entity &
  Evented & {
    __typename: 'MedicalControlContactLogEntry';
    _events: MessageEnvelopeCollection;
    card: Card;
    cardId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isSuccessful: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    person: Person;
    personId: Scalars['ID'];
    timestamp: Timestamp;
    timestampId: Scalars['ID'];
  };

export type MedicalControlContactLogEntry_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalControlContactLogEntryCollection = {
  __typename: 'MedicalControlContactLogEntryCollection';
  items: Array<MedicalControlContactLogEntry>;
  meta: MedicalControlContactLogEntryCollectionMetadata;
};

export type MedicalControlContactLogEntryCollectionMetadata = CollectionMetadata & {
  __typename: 'MedicalControlContactLogEntryCollectionMetadata';
  total: Scalars['Int'];
};

export type MedicalFacility = Entity &
  Evented & {
    __typename: 'MedicalFacility';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    archiveClearedDate: Maybe<Scalars['DateTime']>;
    archiveNotes: Maybe<Scalars['String']>;
    associatedPhysicians: Array<MedicalFacilityPhysician>;
    communicationCenterCustomIdentifiers: Maybe<Array<Maybe<IdNameListItem>>>;
    contacts: Array<MedicalFacilityContact>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    defaultFixedWingLandingZone: Maybe<Location>;
    defaultFixedWingLandingZoneId: Maybe<Scalars['ID']>;
    defaultLandingZone: Maybe<Location>;
    defaultLandingZoneId: Maybe<Scalars['ID']>;
    firmType: Maybe<Scalars['String']>;
    hospitalSpecialization: Maybe<Scalars['String']>;
    hospitalType: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    masterDataSetId: Maybe<Scalars['Int']>;
    name: Scalars['String'];
    nemsisCode: Maybe<Scalars['String']>;
    notes: Maybe<Scalars['String']>;
    npi: Scalars['String'];
    providerNumber: Maybe<Scalars['String']>;
    receivingFacilityRequests: Array<ReceivingFacilityRequest>;
    requesters: Maybe<Array<Maybe<Requester>>>;
    requests: Maybe<Array<Maybe<RequestLocation>>>;
    sourceSystemId: Maybe<Scalars['Int']>;
    stateFacilityName: Maybe<Scalars['String']>;
    stateSourceSystemId: Maybe<Scalars['ID']>;
    status: Maybe<MedicalFacilityStatus>;
    trmUserMedicalFacilities: Array<TrmUserMedicalFacility>;
    units: Array<MedicalFacilityUnit>;
    website: Maybe<Scalars['String']>;
  };

export type MedicalFacility_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalFacilityCollection = {
  __typename: 'MedicalFacilityCollection';
  items: Array<MedicalFacility>;
  meta: MedicalFacilityCollectionMetadata;
};

export type MedicalFacilityCollectionMetadata = CollectionMetadata & {
  __typename: 'MedicalFacilityCollectionMetadata';
  total: Scalars['Int'];
};

export type MedicalFacilityContact = Entity &
  Evented & {
    __typename: 'MedicalFacilityContact';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    emailAddress: Maybe<Scalars['String']>;
    faxPhoneNumber: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalFacility: MedicalFacility;
    medicalFacilityId: Scalars['ID'];
    name: Scalars['String'];
    notes: Maybe<Scalars['String']>;
    primaryPhoneNumber: Maybe<Scalars['String']>;
    secondaryPhoneNumber: Maybe<Scalars['String']>;
    smsPhoneNumber: Maybe<Scalars['String']>;
  };

export type MedicalFacilityContact_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalFacilityContactCollection = {
  __typename: 'MedicalFacilityContactCollection';
  items: Array<MedicalFacilityContact>;
  meta: MedicalFacilityContactCollectionMetadata;
};

export type MedicalFacilityContactCollectionMetadata = CollectionMetadata & {
  __typename: 'MedicalFacilityContactCollectionMetadata';
  total: Scalars['Int'];
};

export type MedicalFacilityContactFilter = {
  medicalFacilityContactId: InputMaybe<Scalars['ID']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type MedicalFacilityContactQueries = {
  __typename: 'MedicalFacilityContactQueries';
  all: MedicalFacilityContactCollection;
  byId: Maybe<MedicalFacilityContact>;
};

export type MedicalFacilityContactQueriesallArgs = {
  filter: InputMaybe<MedicalFacilityContactFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalFacilityContactQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type MedicalFacilityFilter = {
  cityLike: InputMaybe<Scalars['String']>;
  countyLike: InputMaybe<Scalars['String']>;
  includeDeleted: InputMaybe<Scalars['Boolean']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
  stateLike: InputMaybe<Scalars['String']>;
  status: InputMaybe<MedicalFacilityStatus>;
  streetAddressLike: InputMaybe<Scalars['String']>;
};

export type MedicalFacilityPhysician = Entity &
  Evented & {
    __typename: 'MedicalFacilityPhysician';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalFacility: MedicalFacility;
    medicalFacilityId: Scalars['ID'];
    physician: Physician;
    physicianId: Scalars['ID'];
  };

export type MedicalFacilityPhysician_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalFacilityPhysicianCollection = {
  __typename: 'MedicalFacilityPhysicianCollection';
  items: Array<MedicalFacilityPhysician>;
  meta: MedicalFacilityPhysicianCollectionMetadata;
};

export type MedicalFacilityPhysicianCollectionMetadata = CollectionMetadata & {
  __typename: 'MedicalFacilityPhysicianCollectionMetadata';
  total: Scalars['Int'];
};

export type MedicalFacilityQueries = {
  __typename: 'MedicalFacilityQueries';
  all: MedicalFacilityCollection;
  byId: Maybe<MedicalFacility>;
};

export type MedicalFacilityQueriesallArgs = {
  filter: InputMaybe<MedicalFacilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalFacilityQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum MedicalFacilityStatus {
  Approved = 'Approved',
  Archived = 'Archived',
  Duplicate = 'Duplicate',
  PendingApproval = 'PendingApproval',
  PendingArchive = 'PendingArchive',
}

export type MedicalFacilityUnit = Entity &
  Evented & {
    __typename: 'MedicalFacilityUnit';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalFacility: MedicalFacility;
    medicalFacilityId: Scalars['ID'];
    name: Scalars['String'];
    phoneNumber: Maybe<Scalars['String']>;
    requests: Maybe<Array<Maybe<RequestLocation>>>;
  };

export type MedicalFacilityUnit_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalFacilityUnitCollection = {
  __typename: 'MedicalFacilityUnitCollection';
  items: Array<MedicalFacilityUnit>;
  meta: MedicalFacilityUnitCollectionMetadata;
};

export type MedicalFacilityUnitCollectionMetadata = CollectionMetadata & {
  __typename: 'MedicalFacilityUnitCollectionMetadata';
  total: Scalars['Int'];
};

export type MedicalUnit = Entity &
  Evented & {
    __typename: 'MedicalUnit';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requests: Maybe<Array<Maybe<RequestLocation>>>;
  };

export type MedicalUnit_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MedicalUnitCollection = {
  __typename: 'MedicalUnitCollection';
  items: Array<MedicalUnit>;
  meta: MedicalUnitCollectionMetadata;
};

export type MedicalUnitCollectionMetadata = CollectionMetadata & {
  __typename: 'MedicalUnitCollectionMetadata';
  total: Scalars['Int'];
};

export type MergeMedicalFacilities = {
  duplicateOfMedicalFacilityId: Scalars['ID'];
  medicalFacilityId: Scalars['ID'];
};

export type MergePostAndDropoffWaypoints = {
  tripId: Scalars['ID'];
};

export type MergeUnitOriginAndPickupWaypoints = {
  tripId: Scalars['ID'];
};

export type Message = {
  __typename: 'Message';
  messageData: Scalars['JSON'];
  messageType: Scalars['String'];
  messageVersion: Scalars['String'];
};

export type MessageEnvelope = {
  __typename: 'MessageEnvelope';
  correlationId: Maybe<Scalars['ID']>;
  headers: Scalars['JSON'];
  message: Message;
  messageId: Scalars['ID'];
  person: Maybe<Person>;
  personId: Maybe<Scalars['ID']>;
  timestamp: Scalars['DateTime'];
};

export type MessageEnvelopeCollection = {
  __typename: 'MessageEnvelopeCollection';
  items: Array<MessageEnvelope>;
  meta: MessageEnvelopeCollectionMetadata;
};

export type MessageEnvelopeCollectionMetadata = CollectionMetadata & {
  __typename: 'MessageEnvelopeCollectionMetadata';
  total: Scalars['Int'];
};

export enum MessageStatus {
  Created = 'Created',
  Failed = 'Failed',
  ReceivedByRecipient = 'ReceivedByRecipient',
  SentToProvider = 'SentToProvider',
  SentToRecipient = 'SentToRecipient',
}

export type MessageStatusUpdate = Entity &
  Evented & {
    __typename: 'MessageStatusUpdate';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    error: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    metadataJson: Maybe<Scalars['String']>;
    status: MessageStatus;
    trackedMessage: TrackedMessage;
    trackedMessageId: Scalars['ID'];
    vendorMessage: Maybe<Scalars['String']>;
  };

export type MessageStatusUpdate_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type MessageStatusUpdateCollection = {
  __typename: 'MessageStatusUpdateCollection';
  items: Array<MessageStatusUpdate>;
  meta: MessageStatusUpdateCollectionMetadata;
};

export type MessageStatusUpdateCollectionMetadata = CollectionMetadata & {
  __typename: 'MessageStatusUpdateCollectionMetadata';
  total: Scalars['Int'];
};

export enum MessageTransport {
  Email = 'Email',
  Sms = 'Sms',
}

export enum MissionConfiguration {
  CommunityRequest = 'CommunityRequest',
  ContractServices = 'ContractServices',
  GovernmentIncident = 'GovernmentIncident',
  Unspecified = 'Unspecified',
}

export enum MissionProfile {
  AerialOperation = 'AerialOperation',
  FireSuppression = 'FireSuppression',
  HoistRescue = 'HoistRescue',
  Unspecified = 'Unspecified',
}

export enum MissionRoleType {
  ANMC = 'ANMC',
  Charter = 'Charter',
  FlightFollowing = 'FlightFollowing',
  FullService = 'FullService',
  Hospice = 'Hospice',
  MassCasualty = 'MassCasualty',
  PrecautionaryEvacuation = 'PrecautionaryEvacuation',
  Quote = 'Quote',
  QuoteOrNonEmergent = 'QuoteOrNonEmergent',
  SEARHC = 'SEARHC',
  Supplemental = 'Supplemental',
  TeamFlight = 'TeamFlight',
  VetRide = 'VetRide',
}

export type ModifyWaypoint = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  id: Scalars['ID'];
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  timezoneCd: InputMaybe<Scalars['String']>;
  tripId: Scalars['ID'];
  type: WaypointType;
};

export type Mutation = {
  __typename: 'Mutation';
  acceptOutOfServiceTicket: CommandResult;
  acceptReceivingFacilityRequest: CommandResult;
  acceptTransportOffer: CommandResult;
  acknowledgeAlert: CommandResult;
  acknowledgeExternalRequest: CommandResult;
  acknowledgeOutOfServiceEvent: CommandResult;
  acknowledgeOutOfServiceTicket: CommandResult;
  acknowledgePassdownLog: CommandResult;
  acknowledgeWebOrderLog: CommandResult;
  activateUnit: CommandResult;
  addAccessibleItem: CommandResult;
  addActivationRule: CommandResult;
  addActiveAlert: CommandResult;
  addAgency: CommandResult;
  addAgencyLocation: CommandResult;
  addAirport: CommandResult;
  addAlert: CommandResult;
  addApplicationNotification: CommandResult;
  addAssignmentDelayedReason: CommandResult;
  addBase: CommandResult;
  addBaseAdditionalCompany: CommandResult;
  addBaseControlZone: CommandResult;
  addBaseMedicalControlContact: CommandResult;
  addCancellation: CommandResult;
  addCancellationCategory: CommandResult;
  addCancellationReason: CommandResult;
  addCancellationSecondaryReason: CommandResult;
  addCapability: CommandResult;
  addCard: CommandResult;
  addCardLink: CommandResult;
  addCardNote: CommandResult;
  addCardNoteArchive: CommandResult;
  addCardReOpenReason: CommandResult;
  addCommunicationCenter: CommandResult;
  addCommunicationCenterTransportOfferOption: CommandResult;
  addCompany: CommandResult;
  addCompleteFlightInstance: CommandResult;
  addConfigurationSetting: CommandResult;
  addControlZone: CommandResult;
  addConversationToCardWithParticipant: CommandResult;
  addCrewOutOfServiceEvent: CommandResult;
  addDecline: CommandResult;
  addDeclineCategory: CommandResult;
  addDeclineReason: CommandResult;
  addDeclineSecondaryReason: CommandResult;
  addDepartment: CommandResult;
  addDiversionReason: CommandResult;
  addEmsReport: CommandResult;
  addEntityCapability: CommandResult;
  addEscortRequest: CommandResult;
  addExistingSpecialtyTeamMember: CommandResult;
  addExternalAction: CommandResult;
  addExternalActionType: CommandResult;
  addExternalReference: CommandResult;
  addFacilityNonAcceptanceReason: CommandResult;
  addFbo: CommandResult;
  addFirewallRule: CommandResult;
  addFlightFollowingReport: CommandResult;
  addFuelBurn: CommandResult;
  addFuelTank: CommandResult;
  addLocation: CommandResult;
  addLocationHazard: CommandResult;
  addMaintenanceFacility: CommandResult;
  addManifestEntry: CommandResult;
  addMedicalControlContactLogEntry: CommandResult;
  addMedicalFacility: CommandResult;
  addMedicalFacilityContact: CommandResult;
  addMedicalFacilityPhysician: CommandResult;
  addMedicalFacilityUnit: CommandResult;
  addMessageStatusUpdate: CommandResult;
  addNewAgencyLocationRequest: CommandResult;
  addNextDueType: CommandResult;
  addNonReferralReason: CommandResult;
  addNotification: CommandResult;
  addNotificationGroup: CommandResult;
  addNotificationGroupMember: CommandResult;
  addNotificationRecipient: CommandResult;
  addNotificationRecipients: CommandResult;
  addNotificationSubscription: CommandResult;
  addNotificationTemplate: CommandResult;
  addOemActivity: CommandResult;
  addOemAsset: CommandResult;
  addOemPlan: CommandResult;
  addOemPlanChangeRequest: CommandResult;
  addOfferAlgorithm: CommandResult;
  addOperation: CommandResult;
  addOutOfComplianceCrewMember: CommandResult;
  addOutOfServiceEvent: CommandResult;
  addOutOfServiceEventNote: CommandResult;
  addOutOfServiceQARReason: CommandResult;
  addOutOfServiceReason: CommandResult;
  addOutOfServiceSecondaryReason: CommandResult;
  addPaipEvent: CommandResult;
  addPaipReason: CommandResult;
  addPassdownLog: CommandResult;
  addPerson: CommandResult;
  addPersonAdditionalCompany: CommandResult;
  addPhysician: CommandResult;
  addPositionReport: CommandResult;
  addPositionReportAlert: CommandResult;
  addPreApprovedTrmUser: CommandResult;
  addProgram: CommandResult;
  addProgramBase: CommandResult;
  addQuestion: CommandResult;
  addQuestionnaire: CommandResult;
  addQuestionnaireQuestionResponse: CommandResult;
  addQuestionnaireQuestionResponseNote: CommandResult;
  addQuestionnaireResponse: CommandResult;
  addReceivingFacilityRequestDeclineHistory: CommandResult;
  addRegion: CommandResult;
  addRegionBase: CommandResult;
  addRegionGroup: CommandResult;
  addReleaseNote: CommandResult;
  addRendezvousRequest: CommandResult;
  addRequestPatient: CommandResult;
  addRequesterRole: CommandResult;
  addSpecialtyTeam: CommandResult;
  addSpecialtyTeamMember: CommandResult;
  addState: CommandResult;
  addSupportRequest: CommandResult;
  addTimeline: CommandResult;
  addTimelineItem: CommandResult;
  addTimestamp: CommandResult;
  addTimestampType: CommandResult;
  addTimezone: CommandResult;
  addTransferCenter: CommandResult;
  addTransferCenterRegion: CommandResult;
  addTransferReason: CommandResult;
  addTransportOffer: CommandResult;
  addTransportReason: CommandResult;
  addTrip: CommandResult;
  addTripLegManifestEntry: CommandResult;
  addTripPassenger: CommandResult;
  addUnit: CommandResult;
  addUnitActivationRule: CommandResult;
  addUnitEMSystemMapping: CommandResult;
  addUnitNote: CommandResult;
  addUnitOutOfServiceEvent: CommandResult;
  addUnitPosition: CommandResult;
  addUnitShift: CommandResult;
  addVehicle: CommandResult;
  addVehicleConfigurationClass: CommandResult;
  addVehicleControlZone: CommandResult;
  addVehicleDisposition: CommandResult;
  addVehicleMaintenance: CommandResult;
  addVehicleMake: CommandResult;
  addVehicleModel: CommandResult;
  addVehicleNotificationGroup: CommandResult;
  addVehicleOutOfServiceEvent: CommandResult;
  addVehicleStateInspection: CommandResult;
  addWaypoint: CommandResult;
  addWebOrderLog: CommandResult;
  approveMedicalFacility: CommandResult;
  approveTrmUser: CommandResult;
  archiveMedicalFacility: CommandResult;
  archivePassdownLog: CommandResult;
  arriveVehicle: CommandResult;
  assignVehicle: CommandResult;
  authorizeClientSyncAccess: CommandResult;
  beginAssignment: CommandResult;
  beginOutOfServiceEvent: CommandResult;
  beginTransportOffer: CommandResult;
  calculateEtas: CommandResult;
  cancelOperation: CommandResult;
  cancelReceivingFacilityRequest: CommandResult;
  cancelRequest: CommandResult;
  cancelRequestFromTransferCenter: CommandResult;
  cancelTransportOffer: CommandResult;
  changeCallType: CommandResult;
  changeCardCallStatus: CommandResult;
  changeRequestCancellationReason: CommandResult;
  changeRequestType: CommandResult;
  changeUnit: CommandResult;
  changeVehicle: CommandResult;
  changeVehicleFlightLogProcess: CommandResult;
  checkForFlightFollowingDestinationConflict: CommandResult;
  cleanupActiveAlerts: CommandResult;
  cleanupCardActiveAlerts: CommandResult;
  cleanupCards: CommandResult;
  cleanupPendingExternalActions: CommandResult;
  clearPendingArchiveMedicalFacility: CommandResult;
  closeCard: CommandResult;
  closeConversation: CommandResult;
  closeTicketsForOOSEvent: CommandResult;
  confirmManifest: CommandResult;
  confirmPositionReport: CommandResult;
  copyAlert: CommandResult;
  copyNotificationTemplate: CommandResult;
  copyOfferAlgorithm: CommandResult;
  createGroundRun: CommandResult;
  createMaintenanceOperation: CommandResult;
  createPrecautionaryLanding: CommandResult;
  createPrecautionaryLandingV2: CommandResult;
  createRequest: CommandResult;
  createSystemCrewNotification: CommandResult;
  createTicketFromOutOfServiceEvent: CommandResult;
  createTrainingOperation: CommandResult;
  deactivateTrmUser: CommandResult;
  declineAndAssignNewTransportOffer: CommandResult;
  declineOrAbortOperation: CommandResult;
  declineTransportOffer: CommandResult;
  declineTransportOfferAndDelayAssignment: CommandResult;
  delayAssignment: CommandResult;
  delayUnit: CommandResult;
  deleteAccessibleItem: CommandResult;
  deleteActivationRule: CommandResult;
  deleteActiveAlert: CommandResult;
  deleteActiveTimeline: CommandResult;
  deleteAgency: CommandResult;
  deleteAgencyLocation: CommandResult;
  deleteAirport: CommandResult;
  deleteAlert: CommandResult;
  deleteApplicationNotification: CommandResult;
  deleteAssignmentDelayedReason: CommandResult;
  deleteAttachment: CommandResult;
  deleteBase: CommandResult;
  deleteBaseControlZone: CommandResult;
  deleteBaseMedicalControlContact: CommandResult;
  deleteCancellationCategory: CommandResult;
  deleteCancellationReason: CommandResult;
  deleteCancellationSecondaryReason: CommandResult;
  deleteCapability: CommandResult;
  deleteCard: CommandResult;
  deleteCardLink: CommandResult;
  deleteCardNote: CommandResult;
  deleteCardNoteArchive: CommandResult;
  deleteCardReOpenReason: CommandResult;
  deleteCommunicationCenter: CommandResult;
  deleteCommunicationCenterTransportOfferOption: CommandResult;
  deleteCompany: CommandResult;
  deleteCompleteFlightInstance: CommandResult;
  deleteControlZone: CommandResult;
  deleteDeclineCategory: CommandResult;
  deleteDeclineReason: CommandResult;
  deleteDeclineSecondaryReason: CommandResult;
  deleteDepartment: CommandResult;
  deleteDiversionReason: CommandResult;
  deleteEntityCapability: CommandResult;
  deleteEscortRequest: CommandResult;
  deleteExternalAction: CommandResult;
  deleteExternalActionType: CommandResult;
  deleteExternalReference: CommandResult;
  deleteFacilityNonAcceptanceReason: CommandResult;
  deleteFbo: CommandResult;
  deleteFirewallRule: CommandResult;
  deleteFlightFollowingReport: CommandResult;
  deleteFuelTank: CommandResult;
  deleteLocation: CommandResult;
  deleteLocationHazard: CommandResult;
  deleteLocationHazardAttachment: CommandResult;
  deleteMaintenanceFacility: CommandResult;
  deleteManifestEntry: CommandResult;
  deleteMedicalControlContactLogEntry: CommandResult;
  deleteMedicalFacility: CommandResult;
  deleteMedicalFacilityContact: CommandResult;
  deleteMedicalFacilityPhysician: CommandResult;
  deleteMedicalFacilityUnit: CommandResult;
  deleteNewAgencyLocationRequest: CommandResult;
  deleteNextDueType: CommandResult;
  deleteNonReferralReason: CommandResult;
  deleteNotification: CommandResult;
  deleteNotificationGroup: CommandResult;
  deleteNotificationGroupMember: CommandResult;
  deleteNotificationRecipient: CommandResult;
  deleteNotificationRecipients: CommandResult;
  deleteNotificationSubscription: CommandResult;
  deleteNotificationTemplate: CommandResult;
  deleteOemActivity: CommandResult;
  deleteOemAsset: CommandResult;
  deleteOemPlan: CommandResult;
  deleteOemPlanChangeRequest: CommandResult;
  deleteOfferAlgorithm: CommandResult;
  deleteOperation: CommandResult;
  deleteOutOfServiceEvent: CommandResult;
  deleteOutOfServiceEventNote: CommandResult;
  deleteOutOfServiceQARReason: CommandResult;
  deleteOutOfServiceReason: CommandResult;
  deleteOutOfServiceSecondaryReason: CommandResult;
  deleteOutOfServiceTicket: CommandResult;
  deletePaipEvent: CommandResult;
  deletePaipReason: CommandResult;
  deletePassdownLog: CommandResult;
  deletePerson: CommandResult;
  deletePhysician: CommandResult;
  deletePositionReport: CommandResult;
  deletePositionReportAlert: CommandResult;
  deleteProgram: CommandResult;
  deleteProgramBase: CommandResult;
  deleteQuestion: CommandResult;
  deleteQuestionnaire: CommandResult;
  deleteQuestionnaireQuestionResponse: CommandResult;
  deleteQuestionnaireQuestionResponseNote: CommandResult;
  deleteQuestionnaireResponse: CommandResult;
  deleteQuestionnaireSection: CommandResult;
  deleteQuestionnaireSectionQuestion: CommandResult;
  deleteReceivingFacilityRequest: CommandResult;
  deleteRegion: CommandResult;
  deleteRegionBase: CommandResult;
  deleteRegionGroup: CommandResult;
  deleteReleaseNote: CommandResult;
  deleteRendezvousRequest: CommandResult;
  deleteRequestPatient: CommandResult;
  deleteRequesterRole: CommandResult;
  deleteSpecialtyTeam: CommandResult;
  deleteSpecialtyTeamMember: CommandResult;
  deleteState: CommandResult;
  deleteSupportRequest: CommandResult;
  deleteTimeline: CommandResult;
  deleteTimelineItem: CommandResult;
  deleteTimestamp: CommandResult;
  deleteTimestampType: CommandResult;
  deleteTimezone: CommandResult;
  deleteTransferCenter: CommandResult;
  deleteTransferReason: CommandResult;
  deleteTransportOffer: CommandResult;
  deleteTransportReason: CommandResult;
  deleteTrip: CommandResult;
  deleteTripLegManifestEntry: CommandResult;
  deleteTripPassenger: CommandResult;
  deleteTrmUser: CommandResult;
  deleteUnit: CommandResult;
  deleteUnitActivationRule: CommandResult;
  deleteUnitEMSystemMapping: CommandResult;
  deleteUnitNote: CommandResult;
  deleteUnitPosition: CommandResult;
  deleteUnitShift: CommandResult;
  deleteVehicle: CommandResult;
  deleteVehicleConfigurationClass: CommandResult;
  deleteVehicleControlZone: CommandResult;
  deleteVehicleDisposition: CommandResult;
  deleteVehicleMaintenance: CommandResult;
  deleteVehicleMake: CommandResult;
  deleteVehicleModel: CommandResult;
  deleteVehicleNotificationGroup: CommandResult;
  deleteVehicleStateInspection: CommandResult;
  deleteWaypoint: CommandResult;
  deliverTrackedMessage: CommandResult;
  denyReceivingFacilityRequest: CommandResult;
  denyTrmUser: CommandResult;
  departVehicle: CommandResult;
  disableUnit: CommandResult;
  dismissApplicationNotification: CommandResult;
  disregardExternalAction: CommandResult;
  divert: CommandResult;
  divertReceivingFacilityRequest: CommandResult;
  duplicateRequest: CommandResult;
  enableUnit: CommandResult;
  endCrewMemberOutOfServiceEvent: CommandResult;
  endOutOfServiceEvent: CommandResult;
  endPaipEvent: CommandResult;
  ensureThirdPartyUnit: CommandResult;
  ensureThirdPartyUnits: CommandResult;
  ensureThirdPartyVehicleAndUnit: CommandResult;
  generateAttachmentUrl: CommandResult;
  generateCardReport: CommandResult;
  generateCardSummaryChange: CommandResult;
  generateCardSummaryChangeV2: CommandResult;
  generateLocationHazardAttachmentUrl: CommandResult;
  grantClientSyncAccess: CommandResult;
  hideUnit: CommandResult;
  hideVehicle: CommandResult;
  initiateTransportCheck: CommandResult;
  insertWaypoint: CommandResult;
  linkCards: CommandResult;
  linkOutOfServiceEvent: CommandResult;
  lookupAgencyLocationByPhoneNumber: CommandResult;
  makeEstimatedDurationOfficial: CommandResult;
  markAsPilotUpdated: CommandResult;
  mergeMedicalFacilities: CommandResult;
  mergePostAndDropoffWaypoints: CommandResult;
  mergeUnitOriginAndPickupWaypoints: CommandResult;
  modifyWaypoint: CommandResult;
  offerWithBulkSkip: CommandResult;
  placeUnitOnStandby: CommandResult;
  reOpenCard: CommandResult;
  reSendToDataWarehouse: CommandResult;
  reactivateRequest: CommandResult;
  reactivateRequestFromTransferCenter: CommandResult;
  reassignVehicle: CommandResult;
  recalculateCandidates: CommandResult;
  recalculateTripMileage: CommandResult;
  referReceivingFacilityRequest: CommandResult;
  referTransportOffer: CommandResult;
  refreshLocationsFromGMRWorkday: CommandResult;
  refreshPeopleFromGMRWorkdayV2: CommandResult;
  registerTrmUser: CommandResult;
  reloadSummaryViews: CommandResult;
  removeBaseAdditionalCompany: CommandResult;
  removeCrewMemberFromOutOfCompliance: CommandResult;
  removeDelayFromUnit: CommandResult;
  removePersonAdditionalCompany: CommandResult;
  removeTeamMemberFromUnitPosition: CommandResult;
  removeVehicleFromUnit: CommandResult;
  removeWaypoint: CommandResult;
  repositionUnit: CommandResult;
  requestAdditionalUnits: CommandResult;
  requestPublicRelationFromUnit: CommandResult;
  resetPassword: CommandResult;
  returnUnitToService: CommandResult;
  reviewSubmittedOutOfServiceTicket: CommandResult;
  scanForFlights: CommandResult;
  sendMessage: CommandResult;
  sendNoteToCard: CommandResult;
  sendNotification: CommandResult;
  sendPatientInfo: CommandResult;
  sendSupportRequestEmail: CommandResult;
  sendToImageTrend: CommandResult;
  setCardLockStatus: CommandResult;
  setRoleScope: CommandResult;
  setSupportRequestState: CommandResult;
  setVehicleControlZoneId: CommandResult;
  skipTransportOffer: CommandResult;
  snoozeAlert: CommandResult;
  sourceCrewFromOutOfServiceUnit: CommandResult;
  splitUnitOriginAndPickupWaypoints: CommandResult;
  splitUnitPostAndDropoffWaypoints: CommandResult;
  submitMedicalFacilityForApproval: CommandResult;
  submitOutOfServiceTicket: CommandResult;
  submitQuestionnaireResponse: CommandResult;
  submitSupportRequest: CommandResult;
  swapUnitVehicles: CommandResult;
  swapWaypoint: CommandResult;
  takeUnitOutOfService: CommandResult;
  teleportUnit: CommandResult;
  unDeleteCard: CommandResult;
  undeleteExternalReference: CommandResult;
  undeleteVehicle: CommandResult;
  undoAbortOperation: CommandResult;
  undoArriveVehicle: CommandResult;
  undoDepartVehicle: CommandResult;
  unhideUnit: CommandResult;
  unhideVehicle: CommandResult;
  unmarkMedicalFacilityAsDuplicate: CommandResult;
  updateAccessibleItem: CommandResult;
  updateActivationRule: CommandResult;
  updateActiveAlert: CommandResult;
  updateActiveTimeline: CommandResult;
  updateAgency: CommandResult;
  updateAgencyLocation: CommandResult;
  updateAirport: CommandResult;
  updateAlert: CommandResult;
  updateApplicationNotification: CommandResult;
  updateAssignmentDelayedReason: CommandResult;
  updateBase: CommandResult;
  updateBaseControlZone: CommandResult;
  updateBaseCustomIdentifiers: CommandResult;
  updateBaseMedicalControlContact: CommandResult;
  updateCancellation: CommandResult;
  updateCancellationCategory: CommandResult;
  updateCancellationReason: CommandResult;
  updateCancellationSecondaryReason: CommandResult;
  updateCapability: CommandResult;
  updateCard: CommandResult;
  updateCardBillable: CommandResult;
  updateCardContactCompleted: CommandResult;
  updateCardDiversionType: CommandResult;
  updateCardLink: CommandResult;
  updateCardNote: CommandResult;
  updateCardNoteArchive: CommandResult;
  updateCardReOpenReason: CommandResult;
  updateCardSearchIndex: CommandResult;
  updateChiefComplaint: CommandResult;
  updateCommunicationCenter: CommandResult;
  updateCommunicationCenterTransportOfferOption: CommandResult;
  updateCompany: CommandResult;
  updateCompleteFlightInstance: CommandResult;
  updateConfigurationSetting: CommandResult;
  updateControlZone: CommandResult;
  updateDecline: CommandResult;
  updateDeclineCategory: CommandResult;
  updateDeclineReason: CommandResult;
  updateDeclineSecondaryReason: CommandResult;
  updateDepartment: CommandResult;
  updateDiversionReason: CommandResult;
  updateEmsReport: CommandResult;
  updateEscortRequest: CommandResult;
  updateEstimatedDurations: CommandResult;
  updateExternalAction: CommandResult;
  updateExternalActionType: CommandResult;
  updateExternalReference: CommandResult;
  updateFacilityNonAcceptanceReason: CommandResult;
  updateFbo: CommandResult;
  updateFirewallRule: CommandResult;
  updateFlightFollowingReport: CommandResult;
  updateFuelTank: CommandResult;
  updateGmrCadNumber: CommandResult;
  updateLocation: CommandResult;
  updateLocationHazard: CommandResult;
  updateMaintenanceFacility: CommandResult;
  updateManifestEntry: CommandResult;
  updateMedicalControlContactLogEntry: CommandResult;
  updateMedicalFacility: CommandResult;
  updateMedicalFacilityContact: CommandResult;
  updateMedicalFacilityCustomIdentifiers: CommandResult;
  updateMedicalFacilityPhysician: CommandResult;
  updateMedicalFacilityUnit: CommandResult;
  updateNewAgencyLocationRequest: CommandResult;
  updateNextDueType: CommandResult;
  updateNonReferralReason: CommandResult;
  updateNotification: CommandResult;
  updateNotificationGroup: CommandResult;
  updateNotificationGroupMember: CommandResult;
  updateNotificationRecipient: CommandResult;
  updateNotificationSubscription: CommandResult;
  updateNotificationTemplate: CommandResult;
  updateOdometerReadings: CommandResult;
  updateOemActivity: CommandResult;
  updateOemAsset: CommandResult;
  updateOemPlan: CommandResult;
  updateOemPlanChangeRequest: CommandResult;
  updateOfferAlgorithm: CommandResult;
  updateOfferRank: CommandResult;
  updateOperation: CommandResult;
  updateOperationContactInfo: CommandResult;
  updateOutOfComplianceCrewMember: CommandResult;
  updateOutOfServiceEvent: CommandResult;
  updateOutOfServiceEventNote: CommandResult;
  updateOutOfServiceQARReason: CommandResult;
  updateOutOfServiceReason: CommandResult;
  updateOutOfServiceSecondaryReason: CommandResult;
  updatePaipEvent: CommandResult;
  updatePaipReason: CommandResult;
  updatePassdownLog: CommandResult;
  updatePatientClinicalInfo: CommandResult;
  updatePatientInfo: CommandResult;
  updatePerson: CommandResult;
  updatePhysician: CommandResult;
  updatePilotUnitConfiguration: CommandResult;
  updatePlannedCardCompletionTime: CommandResult;
  updatePositionReport: CommandResult;
  updatePositionReportAlert: CommandResult;
  updateProgram: CommandResult;
  updateProgramBase: CommandResult;
  updateQuestion: CommandResult;
  updateQuestionnaire: CommandResult;
  updateQuestionnaireQuestionResponse: CommandResult;
  updateQuestionnaireQuestionResponseDeep: CommandResult;
  updateQuestionnaireQuestionResponseNote: CommandResult;
  updateQuestionnaireResponse: CommandResult;
  updateQuestionnaireResponseDeep: CommandResult;
  updateReceivingFacilityAutoAcceptance: CommandResult;
  updateRecipientMessageStatus: CommandResult;
  updateRegion: CommandResult;
  updateRegionBase: CommandResult;
  updateRegionGroup: CommandResult;
  updateReleaseNote: CommandResult;
  updateRendezvousRequest: CommandResult;
  updateRequest: CommandResult;
  updateRequestAtlo: CommandResult;
  updateRequestLocation: CommandResult;
  updateRequestPatient: CommandResult;
  updateRequestPublicUtilityInfo: CommandResult;
  updateRequestRegion: CommandResult;
  updateRequestSafetyQuestions: CommandResult;
  updateRequestStandbyStatus: CommandResult;
  updateRequester: CommandResult;
  updateRequesterRole: CommandResult;
  updateRequesterSpecialtyTeam: CommandResult;
  updateRequestorAgencyLocation: CommandResult;
  updateRiskAnalysis: CommandResult;
  updateSkip: CommandResult;
  updateSpecialtyTeam: CommandResult;
  updateSpecialtyTeamMember: CommandResult;
  updateState: CommandResult;
  updateSupportRequest: CommandResult;
  updateSupportRequestEmailSent: CommandResult;
  updateTcsRealtimeTrackingTab: CommandResult;
  updateTimeline: CommandResult;
  updateTimelineItem: CommandResult;
  updateTimestamp: CommandResult;
  updateTimestampType: CommandResult;
  updateTimezone: CommandResult;
  updateTrackedMessage: CommandResult;
  updateTransferCenter: CommandResult;
  updateTransferCenterCallInfo: CommandResult;
  updateTransferReason: CommandResult;
  updateTransportOffer: CommandResult;
  updateTransportOfferEta: CommandResult;
  updateTransportOfferOption: CommandResult;
  updateTransportReason: CommandResult;
  updateTrip: CommandResult;
  updateTripLegDuration: CommandResult;
  updateTripLegOnFinal: CommandResult;
  updateTripPassenger: CommandResult;
  updateTrmUser: CommandResult;
  updateUnit: CommandResult;
  updateUnitActivationRule: CommandResult;
  updateUnitConfiguration: CommandResult;
  updateUnitEMSystemMapping: CommandResult;
  updateUnitNote: CommandResult;
  updateUnitPosition: CommandResult;
  updateUnitShift: CommandResult;
  updateVehicle: CommandResult;
  updateVehicleConfigurationClass: CommandResult;
  updateVehicleControlZone: CommandResult;
  updateVehicleDisposition: CommandResult;
  updateVehicleMaintenance: CommandResult;
  updateVehicleMake: CommandResult;
  updateVehicleModel: CommandResult;
  updateVehicleStateInspection: CommandResult;
  updateWaypoint: CommandResult;
  updateWaypointDuration: CommandResult;
  upsertPersonNotificationGroups: CommandResult;
  upsertQuestionChoice: CommandResult;
  upsertQuestionnaireQuestionResponseNote: CommandResult;
  upsertQuestionnaireSection: CommandResult;
  upsertQuestionnaireSectionQuestion: CommandResult;
  upsertTimelineItem: CommandResult;
  upsertUnitPosition: CommandResult;
  upsertVehicleMaintenanceParameters: CommandResult;
};

export type MutationacceptOutOfServiceTicketArgs = {
  command: AcceptOutOfServiceTicket;
  options?: CommandExecutionOptions;
};

export type MutationacceptReceivingFacilityRequestArgs = {
  command: AcceptReceivingFacilityRequest;
  options?: CommandExecutionOptions;
};

export type MutationacceptTransportOfferArgs = {
  command: AcceptTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationacknowledgeAlertArgs = {
  command: AcknowledgeAlert;
  options?: CommandExecutionOptions;
};

export type MutationacknowledgeExternalRequestArgs = {
  command: AcknowledgeExternalRequest;
  options?: CommandExecutionOptions;
};

export type MutationacknowledgeOutOfServiceEventArgs = {
  command: AcknowledgeOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationacknowledgeOutOfServiceTicketArgs = {
  command: AcknowledgeOutOfServiceTicket;
  options?: CommandExecutionOptions;
};

export type MutationacknowledgePassdownLogArgs = {
  command: AcknowledgePassdownLog;
  options?: CommandExecutionOptions;
};

export type MutationacknowledgeWebOrderLogArgs = {
  command: AcknowledgeWebOrderLog;
  options?: CommandExecutionOptions;
};

export type MutationactivateUnitArgs = {
  command: ActivateUnit;
  options?: CommandExecutionOptions;
};

export type MutationaddAccessibleItemArgs = {
  command: AddAccessibleItem;
  options?: CommandExecutionOptions;
};

export type MutationaddActivationRuleArgs = {
  command: AddActivationRule;
  options?: CommandExecutionOptions;
};

export type MutationaddActiveAlertArgs = {
  command: AddActiveAlert;
  options?: CommandExecutionOptions;
};

export type MutationaddAgencyArgs = {
  command: AddAgency;
  options?: CommandExecutionOptions;
};

export type MutationaddAgencyLocationArgs = {
  command: AddAgencyLocation;
  options?: CommandExecutionOptions;
};

export type MutationaddAirportArgs = {
  command: AddAirport;
  options?: CommandExecutionOptions;
};

export type MutationaddAlertArgs = {
  command: AddAlert;
  options?: CommandExecutionOptions;
};

export type MutationaddApplicationNotificationArgs = {
  command: AddApplicationNotification;
  options?: CommandExecutionOptions;
};

export type MutationaddAssignmentDelayedReasonArgs = {
  command: AddAssignmentDelayedReason;
  options?: CommandExecutionOptions;
};

export type MutationaddBaseArgs = {
  command: AddBase;
  options?: CommandExecutionOptions;
};

export type MutationaddBaseAdditionalCompanyArgs = {
  command: AddBaseAdditionalCompany;
  options?: CommandExecutionOptions;
};

export type MutationaddBaseControlZoneArgs = {
  command: AddBaseControlZone;
  options?: CommandExecutionOptions;
};

export type MutationaddBaseMedicalControlContactArgs = {
  command: AddBaseMedicalControlContact;
  options?: CommandExecutionOptions;
};

export type MutationaddCancellationArgs = {
  command: AddCancellation;
  options?: CommandExecutionOptions;
};

export type MutationaddCancellationCategoryArgs = {
  command: AddCancellationCategory;
  options?: CommandExecutionOptions;
};

export type MutationaddCancellationReasonArgs = {
  command: AddCancellationReason;
  options?: CommandExecutionOptions;
};

export type MutationaddCancellationSecondaryReasonArgs = {
  command: AddCancellationSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationaddCapabilityArgs = {
  command: AddCapability;
  options?: CommandExecutionOptions;
};

export type MutationaddCardArgs = {
  command: AddCard;
  options?: CommandExecutionOptions;
};

export type MutationaddCardLinkArgs = {
  command: AddCardLink;
  options?: CommandExecutionOptions;
};

export type MutationaddCardNoteArgs = {
  command: AddCardNote;
  options?: CommandExecutionOptions;
};

export type MutationaddCardNoteArchiveArgs = {
  command: AddCardNoteArchive;
  options?: CommandExecutionOptions;
};

export type MutationaddCardReOpenReasonArgs = {
  command: AddCardReOpenReason;
  options?: CommandExecutionOptions;
};

export type MutationaddCommunicationCenterArgs = {
  command: AddCommunicationCenter;
  options?: CommandExecutionOptions;
};

export type MutationaddCommunicationCenterTransportOfferOptionArgs = {
  command: AddCommunicationCenterTransportOfferOption;
  options?: CommandExecutionOptions;
};

export type MutationaddCompanyArgs = {
  command: AddCompany;
  options?: CommandExecutionOptions;
};

export type MutationaddCompleteFlightInstanceArgs = {
  command: AddCompleteFlightInstance;
  options?: CommandExecutionOptions;
};

export type MutationaddConfigurationSettingArgs = {
  command: AddConfigurationSetting;
  options?: CommandExecutionOptions;
};

export type MutationaddControlZoneArgs = {
  command: AddControlZone;
  options?: CommandExecutionOptions;
};

export type MutationaddConversationToCardWithParticipantArgs = {
  command: AddConversationToCardWithParticipant;
  options?: CommandExecutionOptions;
};

export type MutationaddCrewOutOfServiceEventArgs = {
  command: AddCrewOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationaddDeclineArgs = {
  command: AddDecline;
  options?: CommandExecutionOptions;
};

export type MutationaddDeclineCategoryArgs = {
  command: AddDeclineCategory;
  options?: CommandExecutionOptions;
};

export type MutationaddDeclineReasonArgs = {
  command: AddDeclineReason;
  options?: CommandExecutionOptions;
};

export type MutationaddDeclineSecondaryReasonArgs = {
  command: AddDeclineSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationaddDepartmentArgs = {
  command: AddDepartment;
  options?: CommandExecutionOptions;
};

export type MutationaddDiversionReasonArgs = {
  command: AddDiversionReason;
  options?: CommandExecutionOptions;
};

export type MutationaddEmsReportArgs = {
  command: AddEmsReport;
  options?: CommandExecutionOptions;
};

export type MutationaddEntityCapabilityArgs = {
  command: AddEntityCapability;
  options?: CommandExecutionOptions;
};

export type MutationaddEscortRequestArgs = {
  command: AddEscortRequest;
  options?: CommandExecutionOptions;
};

export type MutationaddExistingSpecialtyTeamMemberArgs = {
  command: AddExistingSpecialtyTeamMember;
  options?: CommandExecutionOptions;
};

export type MutationaddExternalActionArgs = {
  command: AddExternalAction;
  options?: CommandExecutionOptions;
};

export type MutationaddExternalActionTypeArgs = {
  command: AddExternalActionType;
  options?: CommandExecutionOptions;
};

export type MutationaddExternalReferenceArgs = {
  command: AddExternalReference;
  options?: CommandExecutionOptions;
};

export type MutationaddFacilityNonAcceptanceReasonArgs = {
  command: AddFacilityNonAcceptanceReason;
  options?: CommandExecutionOptions;
};

export type MutationaddFboArgs = {
  command: AddFbo;
  options?: CommandExecutionOptions;
};

export type MutationaddFirewallRuleArgs = {
  command: AddFirewallRule;
  options?: CommandExecutionOptions;
};

export type MutationaddFlightFollowingReportArgs = {
  command: AddFlightFollowingReport;
  options?: CommandExecutionOptions;
};

export type MutationaddFuelBurnArgs = {
  command: AddFuelBurn;
  options?: CommandExecutionOptions;
};

export type MutationaddFuelTankArgs = {
  command: AddFuelTank;
  options?: CommandExecutionOptions;
};

export type MutationaddLocationArgs = {
  command: AddLocation;
  options?: CommandExecutionOptions;
};

export type MutationaddLocationHazardArgs = {
  command: AddLocationHazard;
  options?: CommandExecutionOptions;
};

export type MutationaddMaintenanceFacilityArgs = {
  command: AddMaintenanceFacility;
  options?: CommandExecutionOptions;
};

export type MutationaddManifestEntryArgs = {
  command: AddManifestEntry;
  options?: CommandExecutionOptions;
};

export type MutationaddMedicalControlContactLogEntryArgs = {
  command: AddMedicalControlContactLogEntry;
  options?: CommandExecutionOptions;
};

export type MutationaddMedicalFacilityArgs = {
  command: AddMedicalFacility;
  options?: CommandExecutionOptions;
};

export type MutationaddMedicalFacilityContactArgs = {
  command: AddMedicalFacilityContact;
  options?: CommandExecutionOptions;
};

export type MutationaddMedicalFacilityPhysicianArgs = {
  command: AddMedicalFacilityPhysician;
  options?: CommandExecutionOptions;
};

export type MutationaddMedicalFacilityUnitArgs = {
  command: AddMedicalFacilityUnit;
  options?: CommandExecutionOptions;
};

export type MutationaddMessageStatusUpdateArgs = {
  command: AddMessageStatusUpdate;
  options?: CommandExecutionOptions;
};

export type MutationaddNewAgencyLocationRequestArgs = {
  command: AddNewAgencyLocationRequest;
  options?: CommandExecutionOptions;
};

export type MutationaddNextDueTypeArgs = {
  command: AddNextDueType;
  options?: CommandExecutionOptions;
};

export type MutationaddNonReferralReasonArgs = {
  command: AddNonReferralReason;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationArgs = {
  command: AddNotification;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationGroupArgs = {
  command: AddNotificationGroup;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationGroupMemberArgs = {
  command: AddNotificationGroupMember;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationRecipientArgs = {
  command: AddNotificationRecipient;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationRecipientsArgs = {
  command: AddNotificationRecipients;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationSubscriptionArgs = {
  command: AddNotificationSubscription;
  options?: CommandExecutionOptions;
};

export type MutationaddNotificationTemplateArgs = {
  command: AddNotificationTemplate;
  options?: CommandExecutionOptions;
};

export type MutationaddOemActivityArgs = {
  command: AddOemActivity;
  options?: CommandExecutionOptions;
};

export type MutationaddOemAssetArgs = {
  command: AddOemAsset;
  options?: CommandExecutionOptions;
};

export type MutationaddOemPlanArgs = {
  command: AddOemPlan;
  options?: CommandExecutionOptions;
};

export type MutationaddOemPlanChangeRequestArgs = {
  command: AddOemPlanChangeRequest;
  options?: CommandExecutionOptions;
};

export type MutationaddOfferAlgorithmArgs = {
  command: AddOfferAlgorithm;
  options?: CommandExecutionOptions;
};

export type MutationaddOperationArgs = {
  command: AddOperation;
  options?: CommandExecutionOptions;
};

export type MutationaddOutOfComplianceCrewMemberArgs = {
  command: AddOutOfComplianceCrewMember;
  options?: CommandExecutionOptions;
};

export type MutationaddOutOfServiceEventArgs = {
  command: AddOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationaddOutOfServiceEventNoteArgs = {
  command: AddOutOfServiceEventNote;
  options?: CommandExecutionOptions;
};

export type MutationaddOutOfServiceQARReasonArgs = {
  command: AddOutOfServiceQARReason;
  options?: CommandExecutionOptions;
};

export type MutationaddOutOfServiceReasonArgs = {
  command: AddOutOfServiceReason;
  options?: CommandExecutionOptions;
};

export type MutationaddOutOfServiceSecondaryReasonArgs = {
  command: AddOutOfServiceSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationaddPaipEventArgs = {
  command: AddPaipEvent;
  options?: CommandExecutionOptions;
};

export type MutationaddPaipReasonArgs = {
  command: AddPaipReason;
  options?: CommandExecutionOptions;
};

export type MutationaddPassdownLogArgs = {
  command: AddPassdownLog;
  options?: CommandExecutionOptions;
};

export type MutationaddPersonArgs = {
  command: AddPerson;
  options?: CommandExecutionOptions;
};

export type MutationaddPersonAdditionalCompanyArgs = {
  command: AddPersonAdditionalCompany;
  options?: CommandExecutionOptions;
};

export type MutationaddPhysicianArgs = {
  command: AddPhysician;
  options?: CommandExecutionOptions;
};

export type MutationaddPositionReportArgs = {
  command: AddPositionReport;
  options?: CommandExecutionOptions;
};

export type MutationaddPositionReportAlertArgs = {
  command: AddPositionReportAlert;
  options?: CommandExecutionOptions;
};

export type MutationaddPreApprovedTrmUserArgs = {
  command: AddPreApprovedTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationaddProgramArgs = {
  command: AddProgram;
  options?: CommandExecutionOptions;
};

export type MutationaddProgramBaseArgs = {
  command: AddProgramBase;
  options?: CommandExecutionOptions;
};

export type MutationaddQuestionArgs = {
  command: AddQuestion;
  options?: CommandExecutionOptions;
};

export type MutationaddQuestionnaireArgs = {
  command: AddQuestionnaire;
  options?: CommandExecutionOptions;
};

export type MutationaddQuestionnaireQuestionResponseArgs = {
  command: AddQuestionnaireQuestionResponse;
  options?: CommandExecutionOptions;
};

export type MutationaddQuestionnaireQuestionResponseNoteArgs = {
  command: AddQuestionnaireQuestionResponseNote;
  options?: CommandExecutionOptions;
};

export type MutationaddQuestionnaireResponseArgs = {
  command: AddQuestionnaireResponse;
  options?: CommandExecutionOptions;
};

export type MutationaddReceivingFacilityRequestDeclineHistoryArgs = {
  command: AddReceivingFacilityRequestDeclineHistory;
  options?: CommandExecutionOptions;
};

export type MutationaddRegionArgs = {
  command: AddRegion;
  options?: CommandExecutionOptions;
};

export type MutationaddRegionBaseArgs = {
  command: AddRegionBase;
  options?: CommandExecutionOptions;
};

export type MutationaddRegionGroupArgs = {
  command: AddRegionGroup;
  options?: CommandExecutionOptions;
};

export type MutationaddReleaseNoteArgs = {
  command: AddReleaseNote;
  options?: CommandExecutionOptions;
};

export type MutationaddRendezvousRequestArgs = {
  command: AddRendezvousRequest;
  options?: CommandExecutionOptions;
};

export type MutationaddRequestPatientArgs = {
  command: AddRequestPatient;
  options?: CommandExecutionOptions;
};

export type MutationaddRequesterRoleArgs = {
  command: AddRequesterRole;
  options?: CommandExecutionOptions;
};

export type MutationaddSpecialtyTeamArgs = {
  command: AddSpecialtyTeam;
  options?: CommandExecutionOptions;
};

export type MutationaddSpecialtyTeamMemberArgs = {
  command: AddSpecialtyTeamMember;
  options?: CommandExecutionOptions;
};

export type MutationaddStateArgs = {
  command: AddState;
  options?: CommandExecutionOptions;
};

export type MutationaddSupportRequestArgs = {
  command: AddSupportRequest;
  options?: CommandExecutionOptions;
};

export type MutationaddTimelineArgs = {
  command: AddTimeline;
  options?: CommandExecutionOptions;
};

export type MutationaddTimelineItemArgs = {
  command: AddTimelineItem;
  options?: CommandExecutionOptions;
};

export type MutationaddTimestampArgs = {
  command: AddTimestamp;
  options?: CommandExecutionOptions;
};

export type MutationaddTimestampTypeArgs = {
  command: AddTimestampType;
  options?: CommandExecutionOptions;
};

export type MutationaddTimezoneArgs = {
  command: AddTimezone;
  options?: CommandExecutionOptions;
};

export type MutationaddTransferCenterArgs = {
  command: AddTransferCenter;
  options?: CommandExecutionOptions;
};

export type MutationaddTransferCenterRegionArgs = {
  command: AddTransferCenterRegion;
  options?: CommandExecutionOptions;
};

export type MutationaddTransferReasonArgs = {
  command: AddTransferReason;
  options?: CommandExecutionOptions;
};

export type MutationaddTransportOfferArgs = {
  command: AddTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationaddTransportReasonArgs = {
  command: AddTransportReason;
  options?: CommandExecutionOptions;
};

export type MutationaddTripArgs = {
  command: AddTrip;
  options?: CommandExecutionOptions;
};

export type MutationaddTripLegManifestEntryArgs = {
  command: AddTripLegManifestEntry;
  options?: CommandExecutionOptions;
};

export type MutationaddTripPassengerArgs = {
  command: AddTripPassenger;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitArgs = {
  command: AddUnit;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitActivationRuleArgs = {
  command: AddUnitActivationRule;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitEMSystemMappingArgs = {
  command: AddUnitEMSystemMapping;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitNoteArgs = {
  command: AddUnitNote;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitOutOfServiceEventArgs = {
  command: AddUnitOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitPositionArgs = {
  command: AddUnitPosition;
  options?: CommandExecutionOptions;
};

export type MutationaddUnitShiftArgs = {
  command: AddUnitShift;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleArgs = {
  command: AddVehicle;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleConfigurationClassArgs = {
  command: AddVehicleConfigurationClass;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleControlZoneArgs = {
  command: AddVehicleControlZone;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleDispositionArgs = {
  command: AddVehicleDisposition;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleMaintenanceArgs = {
  command: AddVehicleMaintenance;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleMakeArgs = {
  command: AddVehicleMake;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleModelArgs = {
  command: AddVehicleModel;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleNotificationGroupArgs = {
  command: AddVehicleNotificationGroup;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleOutOfServiceEventArgs = {
  command: AddVehicleOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationaddVehicleStateInspectionArgs = {
  command: AddVehicleStateInspection;
  options?: CommandExecutionOptions;
};

export type MutationaddWaypointArgs = {
  command: AddWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationaddWebOrderLogArgs = {
  command: AddWebOrderLog;
  options?: CommandExecutionOptions;
};

export type MutationapproveMedicalFacilityArgs = {
  command: ApproveMedicalFacility;
  options?: CommandExecutionOptions;
};

export type MutationapproveTrmUserArgs = {
  command: ApproveTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationarchiveMedicalFacilityArgs = {
  command: ArchiveMedicalFacility;
  options?: CommandExecutionOptions;
};

export type MutationarchivePassdownLogArgs = {
  command: ArchivePassdownLog;
  options?: CommandExecutionOptions;
};

export type MutationarriveVehicleArgs = {
  command: ArriveVehicle;
  options?: CommandExecutionOptions;
};

export type MutationassignVehicleArgs = {
  command: AssignVehicle;
  options?: CommandExecutionOptions;
};

export type MutationauthorizeClientSyncAccessArgs = {
  command: AuthorizeClientSyncAccess;
  options?: CommandExecutionOptions;
};

export type MutationbeginAssignmentArgs = {
  command: BeginAssignment;
  options?: CommandExecutionOptions;
};

export type MutationbeginOutOfServiceEventArgs = {
  command: BeginOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationbeginTransportOfferArgs = {
  command: BeginTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationcalculateEtasArgs = {
  command: CalculateEtas;
  options?: CommandExecutionOptions;
};

export type MutationcancelOperationArgs = {
  command: CancelOperation;
  options?: CommandExecutionOptions;
};

export type MutationcancelReceivingFacilityRequestArgs = {
  command: CancelReceivingFacilityRequest;
  options?: CommandExecutionOptions;
};

export type MutationcancelRequestArgs = {
  command: CancelRequest;
  options?: CommandExecutionOptions;
};

export type MutationcancelRequestFromTransferCenterArgs = {
  command: CancelRequestFromTransferCenter;
  options?: CommandExecutionOptions;
};

export type MutationcancelTransportOfferArgs = {
  command: CancelTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationchangeCallTypeArgs = {
  command: ChangeCallType;
  options?: CommandExecutionOptions;
};

export type MutationchangeCardCallStatusArgs = {
  command: ChangeCardCallStatus;
  options?: CommandExecutionOptions;
};

export type MutationchangeRequestCancellationReasonArgs = {
  command: ChangeRequestCancellationReason;
  options?: CommandExecutionOptions;
};

export type MutationchangeRequestTypeArgs = {
  command: ChangeRequestType;
  options?: CommandExecutionOptions;
};

export type MutationchangeUnitArgs = {
  command: ChangeUnit;
  options?: CommandExecutionOptions;
};

export type MutationchangeVehicleArgs = {
  command: ChangeVehicle;
  options?: CommandExecutionOptions;
};

export type MutationchangeVehicleFlightLogProcessArgs = {
  command: ChangeVehicleFlightLogProcess;
  options?: CommandExecutionOptions;
};

export type MutationcheckForFlightFollowingDestinationConflictArgs = {
  command: CheckForFlightFollowingDestinationConflict;
  options?: CommandExecutionOptions;
};

export type MutationcleanupActiveAlertsArgs = {
  command: CleanupActiveAlerts;
  options?: CommandExecutionOptions;
};

export type MutationcleanupCardActiveAlertsArgs = {
  command: CleanupCardActiveAlerts;
  options?: CommandExecutionOptions;
};

export type MutationcleanupCardsArgs = {
  command: CleanupCards;
  options?: CommandExecutionOptions;
};

export type MutationcleanupPendingExternalActionsArgs = {
  command: CleanupPendingExternalActions;
  options?: CommandExecutionOptions;
};

export type MutationclearPendingArchiveMedicalFacilityArgs = {
  command: ClearPendingArchiveMedicalFacility;
  options?: CommandExecutionOptions;
};

export type MutationcloseCardArgs = {
  command: CloseCard;
  options?: CommandExecutionOptions;
};

export type MutationcloseConversationArgs = {
  command: CloseConversation;
  options?: CommandExecutionOptions;
};

export type MutationcloseTicketsForOOSEventArgs = {
  command: CloseTicketsForOOSEvent;
  options?: CommandExecutionOptions;
};

export type MutationconfirmManifestArgs = {
  command: ConfirmManifest;
  options?: CommandExecutionOptions;
};

export type MutationconfirmPositionReportArgs = {
  command: ConfirmPositionReport;
  options?: CommandExecutionOptions;
};

export type MutationcopyAlertArgs = {
  command: CopyAlert;
  options?: CommandExecutionOptions;
};

export type MutationcopyNotificationTemplateArgs = {
  command: CopyNotificationTemplate;
  options?: CommandExecutionOptions;
};

export type MutationcopyOfferAlgorithmArgs = {
  command: CopyOfferAlgorithm;
  options?: CommandExecutionOptions;
};

export type MutationcreateGroundRunArgs = {
  command: CreateGroundRun;
  options?: CommandExecutionOptions;
};

export type MutationcreateMaintenanceOperationArgs = {
  command: CreateMaintenanceOperation;
  options?: CommandExecutionOptions;
};

export type MutationcreatePrecautionaryLandingArgs = {
  command: CreatePrecautionaryLanding;
  options?: CommandExecutionOptions;
};

export type MutationcreatePrecautionaryLandingV2Args = {
  command: CreatePrecautionaryLandingV2;
  options?: CommandExecutionOptions;
};

export type MutationcreateRequestArgs = {
  command: CreateRequest;
  options?: CommandExecutionOptions;
};

export type MutationcreateSystemCrewNotificationArgs = {
  command: CreateSystemCrewNotification;
  options?: CommandExecutionOptions;
};

export type MutationcreateTicketFromOutOfServiceEventArgs = {
  command: CreateTicketFromOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationcreateTrainingOperationArgs = {
  command: CreateTrainingOperation;
  options?: CommandExecutionOptions;
};

export type MutationdeactivateTrmUserArgs = {
  command: DeactivateTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationdeclineAndAssignNewTransportOfferArgs = {
  command: DeclineAndAssignNewTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationdeclineOrAbortOperationArgs = {
  command: DeclineOrAbortOperation;
  options?: CommandExecutionOptions;
};

export type MutationdeclineTransportOfferArgs = {
  command: DeclineTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationdeclineTransportOfferAndDelayAssignmentArgs = {
  command: DeclineTransportOfferAndDelayAssignment;
  options?: CommandExecutionOptions;
};

export type MutationdelayAssignmentArgs = {
  command: DelayAssignment;
  options?: CommandExecutionOptions;
};

export type MutationdelayUnitArgs = {
  command: DelayUnit;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAccessibleItemArgs = {
  command: DeleteAccessibleItem;
  options?: CommandExecutionOptions;
};

export type MutationdeleteActivationRuleArgs = {
  command: DeleteActivationRule;
  options?: CommandExecutionOptions;
};

export type MutationdeleteActiveAlertArgs = {
  command: DeleteActiveAlert;
  options?: CommandExecutionOptions;
};

export type MutationdeleteActiveTimelineArgs = {
  command: DeleteActiveTimeline;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAgencyArgs = {
  command: DeleteAgency;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAgencyLocationArgs = {
  command: DeleteAgencyLocation;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAirportArgs = {
  command: DeleteAirport;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAlertArgs = {
  command: DeleteAlert;
  options?: CommandExecutionOptions;
};

export type MutationdeleteApplicationNotificationArgs = {
  command: DeleteApplicationNotification;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAssignmentDelayedReasonArgs = {
  command: DeleteAssignmentDelayedReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteAttachmentArgs = {
  command: DeleteAttachment;
  options?: CommandExecutionOptions;
};

export type MutationdeleteBaseArgs = {
  command: DeleteBase;
  options?: CommandExecutionOptions;
};

export type MutationdeleteBaseControlZoneArgs = {
  command: DeleteBaseControlZone;
  options?: CommandExecutionOptions;
};

export type MutationdeleteBaseMedicalControlContactArgs = {
  command: DeleteBaseMedicalControlContact;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCancellationCategoryArgs = {
  command: DeleteCancellationCategory;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCancellationReasonArgs = {
  command: DeleteCancellationReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCancellationSecondaryReasonArgs = {
  command: DeleteCancellationSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCapabilityArgs = {
  command: DeleteCapability;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCardArgs = {
  command: DeleteCard;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCardLinkArgs = {
  command: DeleteCardLink;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCardNoteArgs = {
  command: DeleteCardNote;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCardNoteArchiveArgs = {
  command: DeleteCardNoteArchive;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCardReOpenReasonArgs = {
  command: DeleteCardReOpenReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCommunicationCenterArgs = {
  command: DeleteCommunicationCenter;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCommunicationCenterTransportOfferOptionArgs = {
  command: DeleteCommunicationCenterTransportOfferOption;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCompanyArgs = {
  command: DeleteCompany;
  options?: CommandExecutionOptions;
};

export type MutationdeleteCompleteFlightInstanceArgs = {
  command: DeleteCompleteFlightInstance;
  options?: CommandExecutionOptions;
};

export type MutationdeleteControlZoneArgs = {
  command: DeleteControlZone;
  options?: CommandExecutionOptions;
};

export type MutationdeleteDeclineCategoryArgs = {
  command: DeleteDeclineCategory;
  options?: CommandExecutionOptions;
};

export type MutationdeleteDeclineReasonArgs = {
  command: DeleteDeclineReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteDeclineSecondaryReasonArgs = {
  command: DeleteDeclineSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteDepartmentArgs = {
  command: DeleteDepartment;
  options?: CommandExecutionOptions;
};

export type MutationdeleteDiversionReasonArgs = {
  command: DeleteDiversionReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteEntityCapabilityArgs = {
  command: DeleteEntityCapability;
  options?: CommandExecutionOptions;
};

export type MutationdeleteEscortRequestArgs = {
  command: DeleteEscortRequest;
  options?: CommandExecutionOptions;
};

export type MutationdeleteExternalActionArgs = {
  command: DeleteExternalAction;
  options?: CommandExecutionOptions;
};

export type MutationdeleteExternalActionTypeArgs = {
  command: DeleteExternalActionType;
  options?: CommandExecutionOptions;
};

export type MutationdeleteExternalReferenceArgs = {
  command: DeleteExternalReference;
  options?: CommandExecutionOptions;
};

export type MutationdeleteFacilityNonAcceptanceReasonArgs = {
  command: DeleteFacilityNonAcceptanceReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteFboArgs = {
  command: DeleteFbo;
  options?: CommandExecutionOptions;
};

export type MutationdeleteFirewallRuleArgs = {
  command: DeleteFirewallRule;
  options?: CommandExecutionOptions;
};

export type MutationdeleteFlightFollowingReportArgs = {
  command: DeleteFlightFollowingReport;
  options?: CommandExecutionOptions;
};

export type MutationdeleteFuelTankArgs = {
  command: DeleteFuelTank;
  options?: CommandExecutionOptions;
};

export type MutationdeleteLocationArgs = {
  command: DeleteLocation;
  options?: CommandExecutionOptions;
};

export type MutationdeleteLocationHazardArgs = {
  command: DeleteLocationHazard;
  options?: CommandExecutionOptions;
};

export type MutationdeleteLocationHazardAttachmentArgs = {
  command: DeleteLocationHazardAttachment;
  options?: CommandExecutionOptions;
};

export type MutationdeleteMaintenanceFacilityArgs = {
  command: DeleteMaintenanceFacility;
  options?: CommandExecutionOptions;
};

export type MutationdeleteManifestEntryArgs = {
  command: DeleteManifestEntry;
  options?: CommandExecutionOptions;
};

export type MutationdeleteMedicalControlContactLogEntryArgs = {
  command: DeleteMedicalControlContactLogEntry;
  options?: CommandExecutionOptions;
};

export type MutationdeleteMedicalFacilityArgs = {
  command: DeleteMedicalFacility;
  options?: CommandExecutionOptions;
};

export type MutationdeleteMedicalFacilityContactArgs = {
  command: DeleteMedicalFacilityContact;
  options?: CommandExecutionOptions;
};

export type MutationdeleteMedicalFacilityPhysicianArgs = {
  command: DeleteMedicalFacilityPhysician;
  options?: CommandExecutionOptions;
};

export type MutationdeleteMedicalFacilityUnitArgs = {
  command: DeleteMedicalFacilityUnit;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNewAgencyLocationRequestArgs = {
  command: DeleteNewAgencyLocationRequest;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNextDueTypeArgs = {
  command: DeleteNextDueType;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNonReferralReasonArgs = {
  command: DeleteNonReferralReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationArgs = {
  command: DeleteNotification;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationGroupArgs = {
  command: DeleteNotificationGroup;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationGroupMemberArgs = {
  command: DeleteNotificationGroupMember;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationRecipientArgs = {
  command: DeleteNotificationRecipient;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationRecipientsArgs = {
  command: DeleteNotificationRecipients;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationSubscriptionArgs = {
  command: DeleteNotificationSubscription;
  options?: CommandExecutionOptions;
};

export type MutationdeleteNotificationTemplateArgs = {
  command: DeleteNotificationTemplate;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOemActivityArgs = {
  command: DeleteOemActivity;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOemAssetArgs = {
  command: DeleteOemAsset;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOemPlanArgs = {
  command: DeleteOemPlan;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOemPlanChangeRequestArgs = {
  command: DeleteOemPlanChangeRequest;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOfferAlgorithmArgs = {
  command: DeleteOfferAlgorithm;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOperationArgs = {
  command: DeleteOperation;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOutOfServiceEventArgs = {
  command: DeleteOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOutOfServiceEventNoteArgs = {
  command: DeleteOutOfServiceEventNote;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOutOfServiceQARReasonArgs = {
  command: DeleteOutOfServiceQARReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOutOfServiceReasonArgs = {
  command: DeleteOutOfServiceReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOutOfServiceSecondaryReasonArgs = {
  command: DeleteOutOfServiceSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteOutOfServiceTicketArgs = {
  command: DeleteOutOfServiceTicket;
  options?: CommandExecutionOptions;
};

export type MutationdeletePaipEventArgs = {
  command: DeletePaipEvent;
  options?: CommandExecutionOptions;
};

export type MutationdeletePaipReasonArgs = {
  command: DeletePaipReason;
  options?: CommandExecutionOptions;
};

export type MutationdeletePassdownLogArgs = {
  command: DeletePassdownLog;
  options?: CommandExecutionOptions;
};

export type MutationdeletePersonArgs = {
  command: DeletePerson;
  options?: CommandExecutionOptions;
};

export type MutationdeletePhysicianArgs = {
  command: DeletePhysician;
  options?: CommandExecutionOptions;
};

export type MutationdeletePositionReportArgs = {
  command: DeletePositionReport;
  options?: CommandExecutionOptions;
};

export type MutationdeletePositionReportAlertArgs = {
  command: DeletePositionReportAlert;
  options?: CommandExecutionOptions;
};

export type MutationdeleteProgramArgs = {
  command: DeleteProgram;
  options?: CommandExecutionOptions;
};

export type MutationdeleteProgramBaseArgs = {
  command: DeleteProgramBase;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionArgs = {
  command: DeleteQuestion;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionnaireArgs = {
  command: DeleteQuestionnaire;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionnaireQuestionResponseArgs = {
  command: DeleteQuestionnaireQuestionResponse;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionnaireQuestionResponseNoteArgs = {
  command: DeleteQuestionnaireQuestionResponseNote;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionnaireResponseArgs = {
  command: DeleteQuestionnaireResponse;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionnaireSectionArgs = {
  command: DeleteQuestionnaireSection;
  options?: CommandExecutionOptions;
};

export type MutationdeleteQuestionnaireSectionQuestionArgs = {
  command: DeleteQuestionnaireSectionQuestion;
  options?: CommandExecutionOptions;
};

export type MutationdeleteReceivingFacilityRequestArgs = {
  command: DeleteReceivingFacilityRequest;
  options?: CommandExecutionOptions;
};

export type MutationdeleteRegionArgs = {
  command: DeleteRegion;
  options?: CommandExecutionOptions;
};

export type MutationdeleteRegionBaseArgs = {
  command: DeleteRegionBase;
  options?: CommandExecutionOptions;
};

export type MutationdeleteRegionGroupArgs = {
  command: DeleteRegionGroup;
  options?: CommandExecutionOptions;
};

export type MutationdeleteReleaseNoteArgs = {
  command: DeleteReleaseNote;
  options?: CommandExecutionOptions;
};

export type MutationdeleteRendezvousRequestArgs = {
  command: DeleteRendezvousRequest;
  options?: CommandExecutionOptions;
};

export type MutationdeleteRequestPatientArgs = {
  command: DeleteRequestPatient;
  options?: CommandExecutionOptions;
};

export type MutationdeleteRequesterRoleArgs = {
  command: DeleteRequesterRole;
  options?: CommandExecutionOptions;
};

export type MutationdeleteSpecialtyTeamArgs = {
  command: DeleteSpecialtyTeam;
  options?: CommandExecutionOptions;
};

export type MutationdeleteSpecialtyTeamMemberArgs = {
  command: DeleteSpecialtyTeamMember;
  options?: CommandExecutionOptions;
};

export type MutationdeleteStateArgs = {
  command: DeleteState;
  options?: CommandExecutionOptions;
};

export type MutationdeleteSupportRequestArgs = {
  command: DeleteSupportRequest;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTimelineArgs = {
  command: DeleteTimeline;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTimelineItemArgs = {
  command: DeleteTimelineItem;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTimestampArgs = {
  command: DeleteTimestamp;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTimestampTypeArgs = {
  command: DeleteTimestampType;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTimezoneArgs = {
  command: DeleteTimezone;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTransferCenterArgs = {
  command: DeleteTransferCenter;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTransferReasonArgs = {
  command: DeleteTransferReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTransportOfferArgs = {
  command: DeleteTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTransportReasonArgs = {
  command: DeleteTransportReason;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTripArgs = {
  command: DeleteTrip;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTripLegManifestEntryArgs = {
  command: DeleteTripLegManifestEntry;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTripPassengerArgs = {
  command: DeleteTripPassenger;
  options?: CommandExecutionOptions;
};

export type MutationdeleteTrmUserArgs = {
  command: DeleteTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationdeleteUnitArgs = {
  command: DeleteUnit;
  options?: CommandExecutionOptions;
};

export type MutationdeleteUnitActivationRuleArgs = {
  command: DeleteUnitActivationRule;
  options?: CommandExecutionOptions;
};

export type MutationdeleteUnitEMSystemMappingArgs = {
  command: DeleteUnitEMSystemMapping;
  options?: CommandExecutionOptions;
};

export type MutationdeleteUnitNoteArgs = {
  command: DeleteUnitNote;
  options?: CommandExecutionOptions;
};

export type MutationdeleteUnitPositionArgs = {
  command: DeleteUnitPosition;
  options?: CommandExecutionOptions;
};

export type MutationdeleteUnitShiftArgs = {
  command: DeleteUnitShift;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleArgs = {
  command: DeleteVehicle;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleConfigurationClassArgs = {
  command: DeleteVehicleConfigurationClass;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleControlZoneArgs = {
  command: DeleteVehicleControlZone;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleDispositionArgs = {
  command: DeleteVehicleDisposition;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleMaintenanceArgs = {
  command: DeleteVehicleMaintenance;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleMakeArgs = {
  command: DeleteVehicleMake;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleModelArgs = {
  command: DeleteVehicleModel;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleNotificationGroupArgs = {
  command: DeleteVehicleNotificationGroup;
  options?: CommandExecutionOptions;
};

export type MutationdeleteVehicleStateInspectionArgs = {
  command: DeleteVehicleStateInspection;
  options?: CommandExecutionOptions;
};

export type MutationdeleteWaypointArgs = {
  command: DeleteWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationdeliverTrackedMessageArgs = {
  command: DeliverTrackedMessage;
  options?: CommandExecutionOptions;
};

export type MutationdenyReceivingFacilityRequestArgs = {
  command: DenyReceivingFacilityRequest;
  options?: CommandExecutionOptions;
};

export type MutationdenyTrmUserArgs = {
  command: DenyTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationdepartVehicleArgs = {
  command: DepartVehicle;
  options?: CommandExecutionOptions;
};

export type MutationdisableUnitArgs = {
  command: DisableUnit;
  options?: CommandExecutionOptions;
};

export type MutationdismissApplicationNotificationArgs = {
  command: DismissApplicationNotification;
  options?: CommandExecutionOptions;
};

export type MutationdisregardExternalActionArgs = {
  command: DisregardExternalAction;
  options?: CommandExecutionOptions;
};

export type MutationdivertArgs = {
  command: Divert;
  options?: CommandExecutionOptions;
};

export type MutationdivertReceivingFacilityRequestArgs = {
  command: DivertReceivingFacilityRequest;
  options?: CommandExecutionOptions;
};

export type MutationduplicateRequestArgs = {
  command: DuplicateRequest;
  options?: CommandExecutionOptions;
};

export type MutationenableUnitArgs = {
  command: EnableUnit;
  options?: CommandExecutionOptions;
};

export type MutationendCrewMemberOutOfServiceEventArgs = {
  command: EndCrewMemberOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationendOutOfServiceEventArgs = {
  command: EndOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationendPaipEventArgs = {
  command: EndPaipEvent;
  options?: CommandExecutionOptions;
};

export type MutationensureThirdPartyUnitArgs = {
  command: EnsureThirdPartyUnit;
  options?: CommandExecutionOptions;
};

export type MutationensureThirdPartyUnitsArgs = {
  command: EnsureThirdPartyUnits;
  options?: CommandExecutionOptions;
};

export type MutationensureThirdPartyVehicleAndUnitArgs = {
  command: EnsureThirdPartyVehicleAndUnit;
  options?: CommandExecutionOptions;
};

export type MutationgenerateAttachmentUrlArgs = {
  command: GenerateAttachmentUrl;
  options?: CommandExecutionOptions;
};

export type MutationgenerateCardReportArgs = {
  command: GenerateCardReport;
  options?: CommandExecutionOptions;
};

export type MutationgenerateCardSummaryChangeArgs = {
  command: GenerateCardSummaryChange;
  options?: CommandExecutionOptions;
};

export type MutationgenerateCardSummaryChangeV2Args = {
  command: GenerateCardSummaryChangeV2;
  options?: CommandExecutionOptions;
};

export type MutationgenerateLocationHazardAttachmentUrlArgs = {
  command: GenerateLocationHazardAttachmentUrl;
  options?: CommandExecutionOptions;
};

export type MutationgrantClientSyncAccessArgs = {
  command: GrantClientSyncAccess;
  options?: CommandExecutionOptions;
};

export type MutationhideUnitArgs = {
  command: HideUnit;
  options?: CommandExecutionOptions;
};

export type MutationhideVehicleArgs = {
  command: HideVehicle;
  options?: CommandExecutionOptions;
};

export type MutationinitiateTransportCheckArgs = {
  command: InitiateTransportCheck;
  options?: CommandExecutionOptions;
};

export type MutationinsertWaypointArgs = {
  command: InsertWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationlinkCardsArgs = {
  command: LinkCards;
  options?: CommandExecutionOptions;
};

export type MutationlinkOutOfServiceEventArgs = {
  command: LinkOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationlookupAgencyLocationByPhoneNumberArgs = {
  command: LookupAgencyLocationByPhoneNumber;
  options?: CommandExecutionOptions;
};

export type MutationmakeEstimatedDurationOfficialArgs = {
  command: MakeEstimatedDurationOfficial;
  options?: CommandExecutionOptions;
};

export type MutationmarkAsPilotUpdatedArgs = {
  command: MarkAsPilotUpdated;
  options?: CommandExecutionOptions;
};

export type MutationmergeMedicalFacilitiesArgs = {
  command: MergeMedicalFacilities;
  options?: CommandExecutionOptions;
};

export type MutationmergePostAndDropoffWaypointsArgs = {
  command: MergePostAndDropoffWaypoints;
  options?: CommandExecutionOptions;
};

export type MutationmergeUnitOriginAndPickupWaypointsArgs = {
  command: MergeUnitOriginAndPickupWaypoints;
  options?: CommandExecutionOptions;
};

export type MutationmodifyWaypointArgs = {
  command: ModifyWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationofferWithBulkSkipArgs = {
  command: OfferWithBulkSkip;
  options?: CommandExecutionOptions;
};

export type MutationplaceUnitOnStandbyArgs = {
  command: PlaceUnitOnStandby;
  options?: CommandExecutionOptions;
};

export type MutationreOpenCardArgs = {
  command: ReOpenCard;
  options?: CommandExecutionOptions;
};

export type MutationreSendToDataWarehouseArgs = {
  command: ReSendToDataWarehouse;
  options?: CommandExecutionOptions;
};

export type MutationreactivateRequestArgs = {
  command: ReactivateRequest;
  options?: CommandExecutionOptions;
};

export type MutationreactivateRequestFromTransferCenterArgs = {
  command: ReactivateRequestFromTransferCenter;
  options?: CommandExecutionOptions;
};

export type MutationreassignVehicleArgs = {
  command: ReassignVehicle;
  options?: CommandExecutionOptions;
};

export type MutationrecalculateCandidatesArgs = {
  command: RecalculateCandidates;
  options?: CommandExecutionOptions;
};

export type MutationrecalculateTripMileageArgs = {
  command: RecalculateTripMileage;
  options?: CommandExecutionOptions;
};

export type MutationreferReceivingFacilityRequestArgs = {
  command: ReferReceivingFacilityRequest;
  options?: CommandExecutionOptions;
};

export type MutationreferTransportOfferArgs = {
  command: ReferTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationrefreshLocationsFromGMRWorkdayArgs = {
  command: RefreshLocationsFromGMRWorkday;
  options?: CommandExecutionOptions;
};

export type MutationrefreshPeopleFromGMRWorkdayV2Args = {
  command: RefreshPeopleFromGMRWorkdayV2;
  options?: CommandExecutionOptions;
};

export type MutationregisterTrmUserArgs = {
  command: RegisterTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationreloadSummaryViewsArgs = {
  command?: ReloadSummaryViews;
};

export type MutationremoveBaseAdditionalCompanyArgs = {
  command: RemoveBaseAdditionalCompany;
  options?: CommandExecutionOptions;
};

export type MutationremoveCrewMemberFromOutOfComplianceArgs = {
  command: RemoveCrewMemberFromOutOfCompliance;
  options?: CommandExecutionOptions;
};

export type MutationremoveDelayFromUnitArgs = {
  command: RemoveDelayFromUnit;
  options?: CommandExecutionOptions;
};

export type MutationremovePersonAdditionalCompanyArgs = {
  command: RemovePersonAdditionalCompany;
  options?: CommandExecutionOptions;
};

export type MutationremoveTeamMemberFromUnitPositionArgs = {
  command: RemoveTeamMemberFromUnitPosition;
  options?: CommandExecutionOptions;
};

export type MutationremoveVehicleFromUnitArgs = {
  command: RemoveVehicleFromUnit;
  options?: CommandExecutionOptions;
};

export type MutationremoveWaypointArgs = {
  command: RemoveWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationrepositionUnitArgs = {
  command: RepositionUnit;
  options?: CommandExecutionOptions;
};

export type MutationrequestAdditionalUnitsArgs = {
  command: RequestAdditionalUnits;
  options?: CommandExecutionOptions;
};

export type MutationrequestPublicRelationFromUnitArgs = {
  command: RequestPublicRelationFromUnit;
  options?: CommandExecutionOptions;
};

export type MutationresetPasswordArgs = {
  command: ResetPassword;
  options?: CommandExecutionOptions;
};

export type MutationreturnUnitToServiceArgs = {
  command: ReturnUnitToService;
  options?: CommandExecutionOptions;
};

export type MutationreviewSubmittedOutOfServiceTicketArgs = {
  command: ReviewSubmittedOutOfServiceTicket;
  options?: CommandExecutionOptions;
};

export type MutationscanForFlightsArgs = {
  command: ScanForFlights;
  options?: CommandExecutionOptions;
};

export type MutationsendMessageArgs = {
  command: SendMessage;
  options?: CommandExecutionOptions;
};

export type MutationsendNoteToCardArgs = {
  command: SendNoteToCard;
  options?: CommandExecutionOptions;
};

export type MutationsendNotificationArgs = {
  command: SendNotification;
  options?: CommandExecutionOptions;
};

export type MutationsendPatientInfoArgs = {
  command: SendPatientInfo;
  options?: CommandExecutionOptions;
};

export type MutationsendSupportRequestEmailArgs = {
  command: SendSupportRequestEmail;
  options?: CommandExecutionOptions;
};

export type MutationsendToImageTrendArgs = {
  command: SendToImageTrend;
  options?: CommandExecutionOptions;
};

export type MutationsetCardLockStatusArgs = {
  command: SetCardLockStatus;
  options?: CommandExecutionOptions;
};

export type MutationsetRoleScopeArgs = {
  command: SetRoleScope;
  options?: CommandExecutionOptions;
};

export type MutationsetSupportRequestStateArgs = {
  command: SetSupportRequestState;
  options?: CommandExecutionOptions;
};

export type MutationsetVehicleControlZoneIdArgs = {
  command: SetVehicleControlZoneId;
  options?: CommandExecutionOptions;
};

export type MutationskipTransportOfferArgs = {
  command: SkipTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationsnoozeAlertArgs = {
  command: SnoozeAlert;
  options?: CommandExecutionOptions;
};

export type MutationsourceCrewFromOutOfServiceUnitArgs = {
  command: SourceCrewFromOutOfServiceUnit;
  options?: CommandExecutionOptions;
};

export type MutationsplitUnitOriginAndPickupWaypointsArgs = {
  command: SplitUnitOriginAndPickupWaypoints;
  options?: CommandExecutionOptions;
};

export type MutationsplitUnitPostAndDropoffWaypointsArgs = {
  command: SplitUnitPostAndDropoffWaypoints;
  options?: CommandExecutionOptions;
};

export type MutationsubmitMedicalFacilityForApprovalArgs = {
  command: SubmitMedicalFacilityForApproval;
  options?: CommandExecutionOptions;
};

export type MutationsubmitOutOfServiceTicketArgs = {
  command: SubmitOutOfServiceTicket;
  options?: CommandExecutionOptions;
};

export type MutationsubmitQuestionnaireResponseArgs = {
  command: SubmitQuestionnaireResponse;
  options?: CommandExecutionOptions;
};

export type MutationsubmitSupportRequestArgs = {
  command: SubmitSupportRequest;
  options?: CommandExecutionOptions;
};

export type MutationswapUnitVehiclesArgs = {
  command: SwapUnitVehicles;
  options?: CommandExecutionOptions;
};

export type MutationswapWaypointArgs = {
  command: SwapWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationtakeUnitOutOfServiceArgs = {
  command: TakeUnitOutOfService;
  options?: CommandExecutionOptions;
};

export type MutationteleportUnitArgs = {
  command: TeleportUnit;
  options?: CommandExecutionOptions;
};

export type MutationunDeleteCardArgs = {
  command: UnDeleteCard;
  options?: CommandExecutionOptions;
};

export type MutationundeleteExternalReferenceArgs = {
  command: UndeleteExternalReference;
  options?: CommandExecutionOptions;
};

export type MutationundeleteVehicleArgs = {
  command: UndeleteVehicle;
  options?: CommandExecutionOptions;
};

export type MutationundoAbortOperationArgs = {
  command: UndoAbortOperation;
  options?: CommandExecutionOptions;
};

export type MutationundoArriveVehicleArgs = {
  command: UndoArriveVehicle;
  options?: CommandExecutionOptions;
};

export type MutationundoDepartVehicleArgs = {
  command: UndoDepartVehicle;
  options?: CommandExecutionOptions;
};

export type MutationunhideUnitArgs = {
  command: UnhideUnit;
  options?: CommandExecutionOptions;
};

export type MutationunhideVehicleArgs = {
  command: UnhideVehicle;
  options?: CommandExecutionOptions;
};

export type MutationunmarkMedicalFacilityAsDuplicateArgs = {
  command: UnmarkMedicalFacilityAsDuplicate;
  options?: CommandExecutionOptions;
};

export type MutationupdateAccessibleItemArgs = {
  command: UpdateAccessibleItem;
  options?: CommandExecutionOptions;
};

export type MutationupdateActivationRuleArgs = {
  command: UpdateActivationRule;
  options?: CommandExecutionOptions;
};

export type MutationupdateActiveAlertArgs = {
  command: UpdateActiveAlert;
  options?: CommandExecutionOptions;
};

export type MutationupdateActiveTimelineArgs = {
  command: UpdateActiveTimeline;
  options?: CommandExecutionOptions;
};

export type MutationupdateAgencyArgs = {
  command: UpdateAgency;
  options?: CommandExecutionOptions;
};

export type MutationupdateAgencyLocationArgs = {
  command: UpdateAgencyLocation;
  options?: CommandExecutionOptions;
};

export type MutationupdateAirportArgs = {
  command: UpdateAirport;
  options?: CommandExecutionOptions;
};

export type MutationupdateAlertArgs = {
  command: UpdateAlert;
  options?: CommandExecutionOptions;
};

export type MutationupdateApplicationNotificationArgs = {
  command: UpdateApplicationNotification;
  options?: CommandExecutionOptions;
};

export type MutationupdateAssignmentDelayedReasonArgs = {
  command: UpdateAssignmentDelayedReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateBaseArgs = {
  command: UpdateBase;
  options?: CommandExecutionOptions;
};

export type MutationupdateBaseControlZoneArgs = {
  command: UpdateBaseControlZone;
  options?: CommandExecutionOptions;
};

export type MutationupdateBaseCustomIdentifiersArgs = {
  command: UpdateBaseCustomIdentifiers;
  options?: CommandExecutionOptions;
};

export type MutationupdateBaseMedicalControlContactArgs = {
  command: UpdateBaseMedicalControlContact;
  options?: CommandExecutionOptions;
};

export type MutationupdateCancellationArgs = {
  command: UpdateCancellation;
  options?: CommandExecutionOptions;
};

export type MutationupdateCancellationCategoryArgs = {
  command: UpdateCancellationCategory;
  options?: CommandExecutionOptions;
};

export type MutationupdateCancellationReasonArgs = {
  command: UpdateCancellationReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateCancellationSecondaryReasonArgs = {
  command: UpdateCancellationSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateCapabilityArgs = {
  command: UpdateCapability;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardArgs = {
  command: UpdateCard;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardBillableArgs = {
  command: UpdateCardBillable;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardContactCompletedArgs = {
  command: UpdateCardContactCompleted;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardDiversionTypeArgs = {
  command: UpdateCardDiversionType;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardLinkArgs = {
  command: UpdateCardLink;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardNoteArgs = {
  command: UpdateCardNote;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardNoteArchiveArgs = {
  command: UpdateCardNoteArchive;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardReOpenReasonArgs = {
  command: UpdateCardReOpenReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateCardSearchIndexArgs = {
  command: UpdateCardSearchIndex;
  options?: CommandExecutionOptions;
};

export type MutationupdateChiefComplaintArgs = {
  command: UpdateChiefComplaint;
  options?: CommandExecutionOptions;
};

export type MutationupdateCommunicationCenterArgs = {
  command: UpdateCommunicationCenter;
  options?: CommandExecutionOptions;
};

export type MutationupdateCommunicationCenterTransportOfferOptionArgs = {
  command: UpdateCommunicationCenterTransportOfferOption;
  options?: CommandExecutionOptions;
};

export type MutationupdateCompanyArgs = {
  command: UpdateCompany;
  options?: CommandExecutionOptions;
};

export type MutationupdateCompleteFlightInstanceArgs = {
  command: UpdateCompleteFlightInstance;
  options?: CommandExecutionOptions;
};

export type MutationupdateConfigurationSettingArgs = {
  command: UpdateConfigurationSetting;
  options?: CommandExecutionOptions;
};

export type MutationupdateControlZoneArgs = {
  command: UpdateControlZone;
  options?: CommandExecutionOptions;
};

export type MutationupdateDeclineArgs = {
  command: UpdateDecline;
  options?: CommandExecutionOptions;
};

export type MutationupdateDeclineCategoryArgs = {
  command: UpdateDeclineCategory;
  options?: CommandExecutionOptions;
};

export type MutationupdateDeclineReasonArgs = {
  command: UpdateDeclineReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateDeclineSecondaryReasonArgs = {
  command: UpdateDeclineSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateDepartmentArgs = {
  command: UpdateDepartment;
  options?: CommandExecutionOptions;
};

export type MutationupdateDiversionReasonArgs = {
  command: UpdateDiversionReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateEmsReportArgs = {
  command: UpdateEmsReport;
  options?: CommandExecutionOptions;
};

export type MutationupdateEscortRequestArgs = {
  command: UpdateEscortRequest;
  options?: CommandExecutionOptions;
};

export type MutationupdateEstimatedDurationsArgs = {
  command: UpdateEstimatedDurations;
  options?: CommandExecutionOptions;
};

export type MutationupdateExternalActionArgs = {
  command: UpdateExternalAction;
  options?: CommandExecutionOptions;
};

export type MutationupdateExternalActionTypeArgs = {
  command: UpdateExternalActionType;
  options?: CommandExecutionOptions;
};

export type MutationupdateExternalReferenceArgs = {
  command: UpdateExternalReference;
  options?: CommandExecutionOptions;
};

export type MutationupdateFacilityNonAcceptanceReasonArgs = {
  command: UpdateFacilityNonAcceptanceReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateFboArgs = {
  command: UpdateFbo;
  options?: CommandExecutionOptions;
};

export type MutationupdateFirewallRuleArgs = {
  command: UpdateFirewallRule;
  options?: CommandExecutionOptions;
};

export type MutationupdateFlightFollowingReportArgs = {
  command: UpdateFlightFollowingReport;
  options?: CommandExecutionOptions;
};

export type MutationupdateFuelTankArgs = {
  command: UpdateFuelTank;
  options?: CommandExecutionOptions;
};

export type MutationupdateGmrCadNumberArgs = {
  command: UpdateGmrCadNumber;
  options?: CommandExecutionOptions;
};

export type MutationupdateLocationArgs = {
  command: UpdateLocation;
  options?: CommandExecutionOptions;
};

export type MutationupdateLocationHazardArgs = {
  command: UpdateLocationHazard;
  options?: CommandExecutionOptions;
};

export type MutationupdateMaintenanceFacilityArgs = {
  command: UpdateMaintenanceFacility;
  options?: CommandExecutionOptions;
};

export type MutationupdateManifestEntryArgs = {
  command: UpdateManifestEntry;
  options?: CommandExecutionOptions;
};

export type MutationupdateMedicalControlContactLogEntryArgs = {
  command: UpdateMedicalControlContactLogEntry;
  options?: CommandExecutionOptions;
};

export type MutationupdateMedicalFacilityArgs = {
  command: UpdateMedicalFacility;
  options?: CommandExecutionOptions;
};

export type MutationupdateMedicalFacilityContactArgs = {
  command: UpdateMedicalFacilityContact;
  options?: CommandExecutionOptions;
};

export type MutationupdateMedicalFacilityCustomIdentifiersArgs = {
  command: UpdateMedicalFacilityCustomIdentifiers;
  options?: CommandExecutionOptions;
};

export type MutationupdateMedicalFacilityPhysicianArgs = {
  command: UpdateMedicalFacilityPhysician;
  options?: CommandExecutionOptions;
};

export type MutationupdateMedicalFacilityUnitArgs = {
  command: UpdateMedicalFacilityUnit;
  options?: CommandExecutionOptions;
};

export type MutationupdateNewAgencyLocationRequestArgs = {
  command: UpdateNewAgencyLocationRequest;
  options?: CommandExecutionOptions;
};

export type MutationupdateNextDueTypeArgs = {
  command: UpdateNextDueType;
  options?: CommandExecutionOptions;
};

export type MutationupdateNonReferralReasonArgs = {
  command: UpdateNonReferralReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateNotificationArgs = {
  command: UpdateNotification;
  options?: CommandExecutionOptions;
};

export type MutationupdateNotificationGroupArgs = {
  command: UpdateNotificationGroup;
  options?: CommandExecutionOptions;
};

export type MutationupdateNotificationGroupMemberArgs = {
  command: UpdateNotificationGroupMember;
  options?: CommandExecutionOptions;
};

export type MutationupdateNotificationRecipientArgs = {
  command: UpdateNotificationRecipient;
  options?: CommandExecutionOptions;
};

export type MutationupdateNotificationSubscriptionArgs = {
  command: UpdateNotificationSubscription;
  options?: CommandExecutionOptions;
};

export type MutationupdateNotificationTemplateArgs = {
  command: UpdateNotificationTemplate;
  options?: CommandExecutionOptions;
};

export type MutationupdateOdometerReadingsArgs = {
  command: UpdateOdometerReadings;
  options?: CommandExecutionOptions;
};

export type MutationupdateOemActivityArgs = {
  command: UpdateOemActivity;
  options?: CommandExecutionOptions;
};

export type MutationupdateOemAssetArgs = {
  command: UpdateOemAsset;
  options?: CommandExecutionOptions;
};

export type MutationupdateOemPlanArgs = {
  command: UpdateOemPlan;
  options?: CommandExecutionOptions;
};

export type MutationupdateOemPlanChangeRequestArgs = {
  command: UpdateOemPlanChangeRequest;
  options?: CommandExecutionOptions;
};

export type MutationupdateOfferAlgorithmArgs = {
  command: UpdateOfferAlgorithm;
  options?: CommandExecutionOptions;
};

export type MutationupdateOfferRankArgs = {
  command: UpdateOfferRank;
  options?: CommandExecutionOptions;
};

export type MutationupdateOperationArgs = {
  command: UpdateOperation;
  options?: CommandExecutionOptions;
};

export type MutationupdateOperationContactInfoArgs = {
  command: UpdateOperationContactInfo;
  options?: CommandExecutionOptions;
};

export type MutationupdateOutOfComplianceCrewMemberArgs = {
  command: UpdateOutOfComplianceCrewMember;
  options?: CommandExecutionOptions;
};

export type MutationupdateOutOfServiceEventArgs = {
  command: UpdateOutOfServiceEvent;
  options?: CommandExecutionOptions;
};

export type MutationupdateOutOfServiceEventNoteArgs = {
  command: UpdateOutOfServiceEventNote;
  options?: CommandExecutionOptions;
};

export type MutationupdateOutOfServiceQARReasonArgs = {
  command: UpdateOutOfServiceQARReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateOutOfServiceReasonArgs = {
  command: UpdateOutOfServiceReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateOutOfServiceSecondaryReasonArgs = {
  command: UpdateOutOfServiceSecondaryReason;
  options?: CommandExecutionOptions;
};

export type MutationupdatePaipEventArgs = {
  command: UpdatePaipEvent;
  options?: CommandExecutionOptions;
};

export type MutationupdatePaipReasonArgs = {
  command: UpdatePaipReason;
  options?: CommandExecutionOptions;
};

export type MutationupdatePassdownLogArgs = {
  command: UpdatePassdownLog;
  options?: CommandExecutionOptions;
};

export type MutationupdatePatientClinicalInfoArgs = {
  command: UpdatePatientClinicalInfo;
  options?: CommandExecutionOptions;
};

export type MutationupdatePatientInfoArgs = {
  command: UpdatePatientInfo;
  options?: CommandExecutionOptions;
};

export type MutationupdatePersonArgs = {
  command: UpdatePerson;
  options?: CommandExecutionOptions;
};

export type MutationupdatePhysicianArgs = {
  command: UpdatePhysician;
  options?: CommandExecutionOptions;
};

export type MutationupdatePilotUnitConfigurationArgs = {
  command: UpdatePilotUnitConfiguration;
  options?: CommandExecutionOptions;
};

export type MutationupdatePlannedCardCompletionTimeArgs = {
  command: UpdatePlannedCardCompletionTime;
  options?: CommandExecutionOptions;
};

export type MutationupdatePositionReportArgs = {
  command: UpdatePositionReport;
  options?: CommandExecutionOptions;
};

export type MutationupdatePositionReportAlertArgs = {
  command: UpdatePositionReportAlert;
  options?: CommandExecutionOptions;
};

export type MutationupdateProgramArgs = {
  command: UpdateProgram;
  options?: CommandExecutionOptions;
};

export type MutationupdateProgramBaseArgs = {
  command: UpdateProgramBase;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionArgs = {
  command: UpdateQuestion;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionnaireArgs = {
  command: UpdateQuestionnaire;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionnaireQuestionResponseArgs = {
  command: UpdateQuestionnaireQuestionResponse;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionnaireQuestionResponseDeepArgs = {
  command: UpdateQuestionnaireQuestionResponseDeep;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionnaireQuestionResponseNoteArgs = {
  command: UpdateQuestionnaireQuestionResponseNote;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionnaireResponseArgs = {
  command: UpdateQuestionnaireResponse;
  options?: CommandExecutionOptions;
};

export type MutationupdateQuestionnaireResponseDeepArgs = {
  command: UpdateQuestionnaireResponseDeep;
  options?: CommandExecutionOptions;
};

export type MutationupdateReceivingFacilityAutoAcceptanceArgs = {
  command: UpdateReceivingFacilityAutoAcceptance;
  options?: CommandExecutionOptions;
};

export type MutationupdateRecipientMessageStatusArgs = {
  command: UpdateRecipientMessageStatus;
  options?: CommandExecutionOptions;
};

export type MutationupdateRegionArgs = {
  command: UpdateRegion;
  options?: CommandExecutionOptions;
};

export type MutationupdateRegionBaseArgs = {
  command: UpdateRegionBase;
  options?: CommandExecutionOptions;
};

export type MutationupdateRegionGroupArgs = {
  command: UpdateRegionGroup;
  options?: CommandExecutionOptions;
};

export type MutationupdateReleaseNoteArgs = {
  command: UpdateReleaseNote;
  options?: CommandExecutionOptions;
};

export type MutationupdateRendezvousRequestArgs = {
  command: UpdateRendezvousRequest;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestArgs = {
  command: UpdateRequest;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestAtloArgs = {
  command: UpdateRequestAtlo;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestLocationArgs = {
  command: UpdateRequestLocation;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestPatientArgs = {
  command: UpdateRequestPatient;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestPublicUtilityInfoArgs = {
  command: UpdateRequestPublicUtilityInfo;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestRegionArgs = {
  command: UpdateRequestRegion;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestSafetyQuestionsArgs = {
  command: UpdateRequestSafetyQuestions;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestStandbyStatusArgs = {
  command: UpdateRequestStandbyStatus;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequesterArgs = {
  command: UpdateRequester;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequesterRoleArgs = {
  command: UpdateRequesterRole;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequesterSpecialtyTeamArgs = {
  command: UpdateRequesterSpecialtyTeam;
  options?: CommandExecutionOptions;
};

export type MutationupdateRequestorAgencyLocationArgs = {
  command: UpdateRequestorAgencyLocation;
  options?: CommandExecutionOptions;
};

export type MutationupdateRiskAnalysisArgs = {
  command: UpdateRiskAnalysis;
  options?: CommandExecutionOptions;
};

export type MutationupdateSkipArgs = {
  command: UpdateSkip;
  options?: CommandExecutionOptions;
};

export type MutationupdateSpecialtyTeamArgs = {
  command: UpdateSpecialtyTeam;
  options?: CommandExecutionOptions;
};

export type MutationupdateSpecialtyTeamMemberArgs = {
  command: UpdateSpecialtyTeamMember;
  options?: CommandExecutionOptions;
};

export type MutationupdateStateArgs = {
  command: UpdateState;
  options?: CommandExecutionOptions;
};

export type MutationupdateSupportRequestArgs = {
  command: UpdateSupportRequest;
  options?: CommandExecutionOptions;
};

export type MutationupdateSupportRequestEmailSentArgs = {
  command: UpdateSupportRequestEmailSent;
  options?: CommandExecutionOptions;
};

export type MutationupdateTcsRealtimeTrackingTabArgs = {
  command: UpdateTcsRealtimeTrackingTab;
  options?: CommandExecutionOptions;
};

export type MutationupdateTimelineArgs = {
  command: UpdateTimeline;
  options?: CommandExecutionOptions;
};

export type MutationupdateTimelineItemArgs = {
  command: UpdateTimelineItem;
  options?: CommandExecutionOptions;
};

export type MutationupdateTimestampArgs = {
  command: UpdateTimestamp;
  options?: CommandExecutionOptions;
};

export type MutationupdateTimestampTypeArgs = {
  command: UpdateTimestampType;
  options?: CommandExecutionOptions;
};

export type MutationupdateTimezoneArgs = {
  command: UpdateTimezone;
  options?: CommandExecutionOptions;
};

export type MutationupdateTrackedMessageArgs = {
  command: UpdateTrackedMessage;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransferCenterArgs = {
  command: UpdateTransferCenter;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransferCenterCallInfoArgs = {
  command: UpdateTransferCenterCallInfo;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransferReasonArgs = {
  command: UpdateTransferReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransportOfferArgs = {
  command: UpdateTransportOffer;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransportOfferEtaArgs = {
  command: UpdateTransportOfferEta;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransportOfferOptionArgs = {
  command: UpdateTransportOfferOption;
  options?: CommandExecutionOptions;
};

export type MutationupdateTransportReasonArgs = {
  command: UpdateTransportReason;
  options?: CommandExecutionOptions;
};

export type MutationupdateTripArgs = {
  command: UpdateTrip;
  options?: CommandExecutionOptions;
};

export type MutationupdateTripLegDurationArgs = {
  command: UpdateTripLegDuration;
  options?: CommandExecutionOptions;
};

export type MutationupdateTripLegOnFinalArgs = {
  command: UpdateTripLegOnFinal;
  options?: CommandExecutionOptions;
};

export type MutationupdateTripPassengerArgs = {
  command: UpdateTripPassenger;
  options?: CommandExecutionOptions;
};

export type MutationupdateTrmUserArgs = {
  command: UpdateTrmUser;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitArgs = {
  command: UpdateUnit;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitActivationRuleArgs = {
  command: UpdateUnitActivationRule;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitConfigurationArgs = {
  command: UpdateUnitConfiguration;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitEMSystemMappingArgs = {
  command: UpdateUnitEMSystemMapping;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitNoteArgs = {
  command: UpdateUnitNote;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitPositionArgs = {
  command: UpdateUnitPosition;
  options?: CommandExecutionOptions;
};

export type MutationupdateUnitShiftArgs = {
  command: UpdateUnitShift;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleArgs = {
  command: UpdateVehicle;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleConfigurationClassArgs = {
  command: UpdateVehicleConfigurationClass;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleControlZoneArgs = {
  command: UpdateVehicleControlZone;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleDispositionArgs = {
  command: UpdateVehicleDisposition;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleMaintenanceArgs = {
  command: UpdateVehicleMaintenance;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleMakeArgs = {
  command: UpdateVehicleMake;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleModelArgs = {
  command: UpdateVehicleModel;
  options?: CommandExecutionOptions;
};

export type MutationupdateVehicleStateInspectionArgs = {
  command: UpdateVehicleStateInspection;
  options?: CommandExecutionOptions;
};

export type MutationupdateWaypointArgs = {
  command: UpdateWaypoint;
  options?: CommandExecutionOptions;
};

export type MutationupdateWaypointDurationArgs = {
  command: UpdateWaypointDuration;
  options?: CommandExecutionOptions;
};

export type MutationupsertPersonNotificationGroupsArgs = {
  command: UpsertPersonNotificationGroups;
  options?: CommandExecutionOptions;
};

export type MutationupsertQuestionChoiceArgs = {
  command: UpsertQuestionChoice;
  options?: CommandExecutionOptions;
};

export type MutationupsertQuestionnaireQuestionResponseNoteArgs = {
  command: UpsertQuestionnaireQuestionResponseNote;
  options?: CommandExecutionOptions;
};

export type MutationupsertQuestionnaireSectionArgs = {
  command: UpsertQuestionnaireSection;
  options?: CommandExecutionOptions;
};

export type MutationupsertQuestionnaireSectionQuestionArgs = {
  command: UpsertQuestionnaireSectionQuestion;
  options?: CommandExecutionOptions;
};

export type MutationupsertTimelineItemArgs = {
  command: UpsertTimelineItem;
  options?: CommandExecutionOptions;
};

export type MutationupsertUnitPositionArgs = {
  command: UpsertUnitPosition;
  options?: CommandExecutionOptions;
};

export type MutationupsertVehicleMaintenanceParametersArgs = {
  command: UpsertVehicleMaintenanceParameters;
  options?: CommandExecutionOptions;
};

export type NewAgencyLocationRequest = Entity &
  Evented & {
    __typename: 'NewAgencyLocationRequest';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Maybe<Scalars['ID']>;
    entityType: EntityType;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    phoneNumber: Scalars['String'];
    requestedByPerson: Person;
    requestedByPersonId: Scalars['ID'];
    type: NewAgencyLocationRequestOriginType;
  };

export type NewAgencyLocationRequest_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NewAgencyLocationRequestCollection = {
  __typename: 'NewAgencyLocationRequestCollection';
  items: Array<NewAgencyLocationRequest>;
  meta: NewAgencyLocationRequestCollectionMetadata;
};

export type NewAgencyLocationRequestCollectionMetadata = CollectionMetadata & {
  __typename: 'NewAgencyLocationRequestCollectionMetadata';
  total: Scalars['Int'];
};

export type NewAgencyLocationRequestFilter = {
  entityId: InputMaybe<Scalars['ID']>;
  type: InputMaybe<NewAgencyLocationRequestOriginType>;
};

export enum NewAgencyLocationRequestOriginType {
  Arrange = 'Arrange',
  DeclineOrAbort = 'DeclineOrAbort',
  Org = 'Org',
  PrecautionaryLanding = 'PrecautionaryLanding',
  Requester = 'Requester',
}

export type NewAgencyLocationRequestQueries = {
  __typename: 'NewAgencyLocationRequestQueries';
  all: Array<NewAgencyLocationRequest>;
  byId: Maybe<NewAgencyLocationRequest>;
};

export type NewAgencyLocationRequestQueriesallArgs = {
  filter: InputMaybe<NewAgencyLocationRequestFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NewAgencyLocationRequestQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NextDue = {
  __typename: 'NextDue';
  cycleType: NextDueCycleType;
  id: Scalars['ID'];
  inTolerance: Maybe<Scalars['Boolean']>;
  notes: Maybe<Scalars['String']>;
  triggerValue: Scalars['Int'];
  typeId: Scalars['ID'];
  value: Scalars['String'];
};

export enum NextDueCycleType {
  AF = 'AF',
  E1 = 'E1',
  E2 = 'E2',
}

export type NextDueInput = {
  cycleType: NextDueCycleType;
  id: Scalars['ID'];
  inTolerance: InputMaybe<Scalars['Boolean']>;
  notes: InputMaybe<Scalars['String']>;
  triggerValue: Scalars['Int'];
  typeId: Scalars['ID'];
  value: Scalars['String'];
};

export type NextDueType = Entity &
  Evented & {
    __typename: 'NextDueType';
    _events: MessageEnvelopeCollection;
    dataType: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type NextDueType_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NextDueTypeCollection = {
  __typename: 'NextDueTypeCollection';
  items: Array<NextDueType>;
  meta: NextDueTypeCollectionMetadata;
};

export type NextDueTypeCollectionMetadata = CollectionMetadata & {
  __typename: 'NextDueTypeCollectionMetadata';
  total: Scalars['Int'];
};

export type NextDueTypeFilter = {
  dataTypeLike: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type NextDueTypeQueries = {
  __typename: 'NextDueTypeQueries';
  all: NextDueTypeCollection;
  byId: Maybe<NextDueType>;
};

export type NextDueTypeQueriesallArgs = {
  filter: InputMaybe<NextDueTypeFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NextDueTypeQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NextDueWithOptionalId = {
  __typename: 'NextDueWithOptionalId';
  cycleType: NextDueCycleType;
  inTolerance: Maybe<Scalars['Boolean']>;
  nextDueId: Maybe<Scalars['ID']>;
  notes: Maybe<Scalars['String']>;
  triggerValue: Scalars['Int'];
  typeId: Scalars['ID'];
  value: Scalars['String'];
};

export type NextDueWithOptionalIdInput = {
  cycleType: NextDueCycleType;
  inTolerance: InputMaybe<Scalars['Boolean']>;
  nextDueId: InputMaybe<Scalars['ID']>;
  notes: InputMaybe<Scalars['String']>;
  triggerValue: Scalars['Int'];
  typeId: Scalars['ID'];
  value: Scalars['String'];
};

export enum NonAcceptanceType {
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Diverted = 'Diverted',
  Referred = 'Referred',
}

export type NonReferralReason = Entity &
  Evented & {
    __typename: 'NonReferralReason';
    _events: MessageEnvelopeCollection;
    associatedCancellationReason: Maybe<CancellationReason>;
    associatedCancellationReasonId: Maybe<Scalars['ID']>;
    associatedCancellationSecondaryReason: Maybe<CancellationSecondaryReason>;
    associatedCancellationSecondaryReasonId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
  };

export type NonReferralReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NonReferralReasonCollection = {
  __typename: 'NonReferralReasonCollection';
  items: Array<NonReferralReason>;
  meta: NonReferralReasonCollectionMetadata;
};

export type NonReferralReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'NonReferralReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type NonReferralReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type NonReferralReasonQueries = {
  __typename: 'NonReferralReasonQueries';
  all: NonReferralReasonCollection;
  byId: Maybe<NonReferralReason>;
};

export type NonReferralReasonQueriesallArgs = {
  filter: InputMaybe<NonReferralReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NonReferralReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum NotBillableType {
  MechanicalAbort = 'MechanicalAbort',
  Other = 'Other',
  PatientCondition = 'PatientCondition',
  PatientExpiredOrQL = 'PatientExpiredOrQL',
  PatientWentByGround = 'PatientWentByGround',
  WeatherAbort = 'WeatherAbort',
}

export type Notification = Entity &
  Evented & {
    __typename: 'Notification';
    _events: MessageEnvelopeCollection;
    body: Scalars['String'];
    card: Maybe<Card>;
    cardId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    createdById: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Maybe<Scalars['ID']>;
    entityType: Maybe<EntityType>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    recipients: Array<NotificationRecipient>;
    sourceTemplate: Maybe<NotificationTemplate>;
    sourceTemplateId: Maybe<Scalars['ID']>;
    status: NotificationStatus;
    subject: Maybe<Scalars['String']>;
  };

export type Notification_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationCollection = {
  __typename: 'NotificationCollection';
  items: Array<Notification>;
  meta: NotificationCollectionMetadata;
};

export type NotificationCollectionMetadata = CollectionMetadata & {
  __typename: 'NotificationCollectionMetadata';
  total: Scalars['Int'];
};

export type NotificationFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  entityId: InputMaybe<Scalars['ID']>;
  entityTypes: InputMaybe<Array<EntityType>>;
  exceptCardStatuses: InputMaybe<Array<CardStatus>>;
  excludeNotificationStatuses: InputMaybe<Array<NotificationStatus>>;
  notificationStatuses: InputMaybe<Array<NotificationStatus>>;
  personId: InputMaybe<Scalars['ID']>;
  regionId: InputMaybe<Scalars['ID']>;
  sourceTemplateId: InputMaybe<Scalars['ID']>;
};

export type NotificationGroup = Entity &
  Evented & {
    __typename: 'NotificationGroup';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isEmailNotificationPreferred: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    members: Array<NotificationGroupMember>;
    name: Scalars['String'];
    notificationSubscriptions: Array<NotificationSubscription>;
    region: Maybe<Region>;
    regionId: Maybe<Scalars['ID']>;
    type: Maybe<NotificationGroupType>;
    types: Maybe<Array<Maybe<NotificationGroupType>>>;
    unit: Maybe<Unit>;
    unitId: Maybe<Scalars['ID']>;
    vehicleNotificationGroups: Array<VehicleNotificationGroup>;
  };

export type NotificationGroup_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationGroupCollection = {
  __typename: 'NotificationGroupCollection';
  items: Array<NotificationGroup>;
  meta: NotificationGroupCollectionMetadata;
};

export type NotificationGroupCollectionMetadata = CollectionMetadata & {
  __typename: 'NotificationGroupCollectionMetadata';
  total: Scalars['Int'];
};

export type NotificationGroupFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  excludeRegionsExcept: InputMaybe<Array<Scalars['ID']>>;
  excludeUnitsExcept: InputMaybe<Array<Scalars['ID']>>;
  nameLike: InputMaybe<Scalars['String']>;
  regionId: InputMaybe<Scalars['ID']>;
  type: InputMaybe<NotificationGroupType>;
  unitId: InputMaybe<Scalars['ID']>;
};

export type NotificationGroupMember = Entity &
  Evented & {
    __typename: 'NotificationGroupMember';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    notificationAddress: Maybe<Scalars['String']>;
    notificationGroup: NotificationGroup;
    notificationGroupId: Scalars['ID'];
    user: Maybe<Person>;
    userId: Maybe<Scalars['ID']>;
  };

export type NotificationGroupMember_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationGroupMemberCollection = {
  __typename: 'NotificationGroupMemberCollection';
  items: Array<NotificationGroupMember>;
  meta: NotificationGroupMemberCollectionMetadata;
};

export type NotificationGroupMemberCollectionMetadata = CollectionMetadata & {
  __typename: 'NotificationGroupMemberCollectionMetadata';
  total: Scalars['Int'];
};

export type NotificationGroupMemberFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  notificationGroupId: InputMaybe<Scalars['String']>;
};

export type NotificationGroupMemberQueries = {
  __typename: 'NotificationGroupMemberQueries';
  all: NotificationGroupMemberCollection;
  byId: Maybe<NotificationGroupMember>;
};

export type NotificationGroupMemberQueriesallArgs = {
  filter: InputMaybe<NotificationGroupMemberFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationGroupMemberQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NotificationGroupQueries = {
  __typename: 'NotificationGroupQueries';
  all: NotificationGroupCollection;
  byId: Maybe<NotificationGroup>;
  byPerson: Array<NotificationGroup>;
};

export type NotificationGroupQueriesallArgs = {
  filter: InputMaybe<NotificationGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationGroupQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NotificationGroupQueriesbyPersonArgs = {
  personId: Scalars['ID'];
};

export enum NotificationGroupType {
  AviationGroup = 'AviationGroup',
  ClinicalGroup = 'ClinicalGroup',
  MaintenanceController = 'MaintenanceController',
  OccGroup = 'OccGroup',
  OnlyCrew = 'OnlyCrew',
  OnlyPilots = 'OnlyPilots',
  OperationsGroup = 'OperationsGroup',
  PaipGroup = 'PaipGroup',
  SpecialityGroup = 'SpecialityGroup',
}

export type NotificationQueries = {
  __typename: 'NotificationQueries';
  all: NotificationCollection;
  byId: Maybe<Notification>;
};

export type NotificationQueriesallArgs = {
  filter: InputMaybe<NotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NotificationRecipient = Entity &
  Evented & {
    __typename: 'NotificationRecipient';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    message: Maybe<TrackedMessage>;
    messageId: Maybe<Scalars['ID']>;
    messageStatus: Maybe<MessageStatus>;
    name: Maybe<Scalars['String']>;
    notification: Notification;
    notificationAddress: Maybe<Scalars['String']>;
    notificationId: Scalars['ID'];
    user: Maybe<Person>;
    userId: Maybe<Scalars['ID']>;
  };

export type NotificationRecipient_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationRecipientCollection = {
  __typename: 'NotificationRecipientCollection';
  items: Array<NotificationRecipient>;
  meta: NotificationRecipientCollectionMetadata;
};

export type NotificationRecipientCollectionMetadata = CollectionMetadata & {
  __typename: 'NotificationRecipientCollectionMetadata';
  total: Scalars['Int'];
};

export enum NotificationRecipientType {
  Groups = 'Groups',
  MedicalCrew = 'MedicalCrew',
  Pilot = 'Pilot',
}

export enum NotificationStatus {
  AwaitingApproval = 'AwaitingApproval',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Failed = 'Failed',
  PartiallyFailed = 'PartiallyFailed',
  Received = 'Received',
  Sending = 'Sending',
  Sent = 'Sent',
}

export type NotificationSubscription = Entity &
  Evented & {
    __typename: 'NotificationSubscription';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    notificationGroup: NotificationGroup;
    notificationGroupId: Scalars['ID'];
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type NotificationSubscription_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationSubscriptionCollection = {
  __typename: 'NotificationSubscriptionCollection';
  items: Array<NotificationSubscription>;
  meta: NotificationSubscriptionCollectionMetadata;
};

export type NotificationSubscriptionCollectionMetadata = CollectionMetadata & {
  __typename: 'NotificationSubscriptionCollectionMetadata';
  total: Scalars['Int'];
};

export type NotificationSubscriptionFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  unitId: InputMaybe<Scalars['String']>;
};

export type NotificationSubscriptionQueries = {
  __typename: 'NotificationSubscriptionQueries';
  all: NotificationSubscriptionCollection;
  byId: Maybe<NotificationSubscription>;
};

export type NotificationSubscriptionQueriesallArgs = {
  filter: InputMaybe<NotificationSubscriptionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationSubscriptionQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NotificationTemplate = Entity &
  Evented & {
    __typename: 'NotificationTemplate';
    _events: MessageEnvelopeCollection;
    activationRule: Maybe<ActivationRule>;
    activationRuleId: Maybe<Scalars['ID']>;
    bodyTemplate: Scalars['String'];
    canBeManualTrigger: Scalars['Boolean'];
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']>;
    contextType: EntityType;
    createdBy: Maybe<Person>;
    createdById: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    groupTypes: Maybe<Array<Maybe<NotificationGroupType>>>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    /** @deprecated use triggerType and triggerValue */
    notificationType: Maybe<NotificationType>;
    notifications: Maybe<Array<Maybe<Notification>>>;
    recipientTypes: Maybe<Array<Maybe<NotificationRecipientType>>>;
    requiresApproval: Maybe<Scalars['Boolean']>;
    subjectTemplate: Maybe<Scalars['String']>;
    triggerType: Maybe<NotificationTriggerType>;
    triggerValue: Maybe<Scalars['String']>;
    /** @deprecated use contextType */
    viewModelType: Maybe<Scalars['String']>;
  };

export type NotificationTemplate_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationTemplateCollection = {
  __typename: 'NotificationTemplateCollection';
  items: Array<NotificationTemplate>;
  meta: NotificationTemplateCollectionMetadata;
};

export type NotificationTemplateCollectionMetadata = CollectionMetadata & {
  __typename: 'NotificationTemplateCollectionMetadata';
  total: Scalars['Int'];
};

export type NotificationTemplateData = {
  __typename: 'NotificationTemplateData';
  body: Maybe<Scalars['String']>;
  recipients: Maybe<Array<Maybe<Recipient>>>;
  subject: Maybe<Scalars['String']>;
};

export type NotificationTemplateFilter = {
  allowAllCompanyAccess: InputMaybe<Scalars['Boolean']>;
  canBeManualTrigger: InputMaybe<Scalars['Boolean']>;
  companyId: InputMaybe<Scalars['ID']>;
  contextType: InputMaybe<EntityType>;
  excludeNonGlobalExceptCompanyId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type NotificationTemplateQueries = {
  __typename: 'NotificationTemplateQueries';
  all: NotificationTemplateCollection;
  byId: Maybe<NotificationTemplate>;
  deriveOOSTemplate: NotificationTemplateResponse;
  templateDetails: NotificationTemplateResponse;
};

export type NotificationTemplateQueriesallArgs = {
  filter: InputMaybe<NotificationTemplateFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type NotificationTemplateQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type NotificationTemplateQueriesderiveOOSTemplateArgs = {
  outOfServiceEventId: Scalars['ID'];
  templateId: Scalars['ID'];
};

export type NotificationTemplateQueriestemplateDetailsArgs = {
  notificationRequest: InputMaybe<NotificationTemplateRequest>;
};

export type NotificationTemplateRequest = {
  cardId: Scalars['ID'];
  offerId: InputMaybe<Scalars['ID']>;
  templateId: Scalars['ID'];
};

export type NotificationTemplateResponse = {
  __typename: 'NotificationTemplateResponse';
  activityId: Maybe<Scalars['String']>;
  data: Maybe<NotificationTemplateData>;
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  responseCode: Maybe<Scalars['String']>;
};

export enum NotificationTriggerType {
  Activity = 'Activity',
  Manual = 'Manual',
}

export enum NotificationType {
  Custom = 'Custom',
  UnitActivatedCrewPage = 'UnitActivatedCrewPage',
  UnitAssignedCrewPage = 'UnitAssignedCrewPage',
  UnitOfferedCrewPage = 'UnitOfferedCrewPage',
}

export type OemActivity = Entity &
  Evented & {
    __typename: 'OemActivity';
    _events: MessageEnvelopeCollection;
    activityType: OemActivityType;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    content: Maybe<Scalars['String']>;
    currentStatus: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    oemPlan: OemPlan;
    oemPlanChangeRequest: Maybe<OemPlanChangeRequest>;
    oemPlanChangeRequestId: Maybe<Scalars['ID']>;
    oemPlanId: Scalars['ID'];
    priorStatus: Maybe<Scalars['String']>;
    time: Maybe<Scalars['DateTime']>;
  };

export type OemActivity_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OemActivityCollection = {
  __typename: 'OemActivityCollection';
  items: Array<OemActivity>;
  meta: OemActivityCollectionMetadata;
};

export type OemActivityCollectionMetadata = CollectionMetadata & {
  __typename: 'OemActivityCollectionMetadata';
  total: Scalars['Int'];
};

export enum OemActivityType {
  AssetChangeNote = 'AssetChangeNote',
  PlanChangeNote = 'PlanChangeNote',
  UserNote = 'UserNote',
}

export type OemAsset = Entity &
  Evented & {
    __typename: 'OemAsset';
    _events: MessageEnvelopeCollection;
    assetDispatchCompany: Maybe<Company>;
    assetDispatchCompanyId: Maybe<Scalars['ID']>;
    assetId: Scalars['ID'];
    assetType: OemAssetType;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    oemPlan: OemPlan;
    oemPlanChangeRequests: Array<OemPlanChangeRequest>;
    oemPlanId: Scalars['ID'];
    oemUnitId: Maybe<Scalars['ID']>;
    originalUnit: Maybe<Unit>;
    originalUnitId: Maybe<Scalars['ID']>;
    requestedBase: Maybe<Base>;
    requestedBaseId: Maybe<Scalars['ID']>;
    requestedPlacardNumber: Maybe<Scalars['String']>;
    requestedUnitAbbreviation: Maybe<Scalars['String']>;
    requestedUnitName: Maybe<Scalars['String']>;
    status: OemAssetStatus;
  };

export type OemAsset_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OemAssetCollection = {
  __typename: 'OemAssetCollection';
  items: Array<OemAsset>;
  meta: OemAssetCollectionMetadata;
};

export type OemAssetCollectionMetadata = CollectionMetadata & {
  __typename: 'OemAssetCollectionMetadata';
  total: Scalars['Int'];
};

export enum OemAssetStatus {
  Activated = 'Activated',
  Demobilized = 'Demobilized',
  Standby = 'Standby',
}

export enum OemAssetType {
  Personal = 'Personal',
  Vehicle = 'Vehicle',
}

export type OemPlan = Entity &
  Evented & {
    __typename: 'OemPlan';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    defaultBase: Base;
    defaultBaseId: Scalars['ID'];
    description: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    oemActivities: Array<OemActivity>;
    oemAssets: Array<OemAsset>;
    oemCompany: Company;
    oemCompanyId: Scalars['ID'];
    oemPlanChangeRequests: Array<OemPlanChangeRequest>;
    outOfServiceReason: OutOfServiceReason;
    outOfServiceReasonId: Scalars['ID'];
    planStatus: OemPlanStatus;
    planYear: Scalars['Int'];
  };

export type OemPlan_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OemPlanChangeRequest = Entity &
  Evented & {
    __typename: 'OemPlanChangeRequest';
    _events: MessageEnvelopeCollection;
    dateCancelled: Maybe<Scalars['DateTime']>;
    dateCompleted: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateRequested: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notes: Maybe<Scalars['String']>;
    oemActivities: Maybe<Array<Maybe<OemActivity>>>;
    oemAsset: OemAsset;
    oemAssetId: Scalars['ID'];
    oemPlan: OemPlan;
    oemPlanId: Scalars['ID'];
    originalAssetStatus: OemAssetStatus;
    requestedAssetStatus: OemAssetStatus;
    requestedBy: Maybe<Person>;
    requestedById: Maybe<Scalars['ID']>;
    status: OemPlanChangeRequestStatus;
  };

export type OemPlanChangeRequest_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OemPlanChangeRequestCollection = {
  __typename: 'OemPlanChangeRequestCollection';
  items: Array<OemPlanChangeRequest>;
  meta: OemPlanChangeRequestCollectionMetadata;
};

export type OemPlanChangeRequestCollectionMetadata = CollectionMetadata & {
  __typename: 'OemPlanChangeRequestCollectionMetadata';
  total: Scalars['Int'];
};

export enum OemPlanChangeRequestStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Draft = 'Draft',
  Requested = 'Requested',
}

export type OemPlanCollection = {
  __typename: 'OemPlanCollection';
  items: Array<OemPlan>;
  meta: OemPlanCollectionMetadata;
};

export type OemPlanCollectionMetadata = CollectionMetadata & {
  __typename: 'OemPlanCollectionMetadata';
  total: Scalars['Int'];
};

export enum OemPlanStatus {
  Cancelled = 'Cancelled',
  Demobilized = 'Demobilized',
  Demobilizing = 'Demobilizing',
  Deployed = 'Deployed',
  Draft = 'Draft',
}

export type OfferAlgorithm = Entity &
  Evented & {
    __typename: 'OfferAlgorithm';
    _events: MessageEnvelopeCollection;
    activationRule: ActivationRule;
    activationRuleId: Scalars['ID'];
    companies: Maybe<Array<Maybe<IdListItem>>>;
    company: Company;
    companyId: Scalars['ID'];
    createdBy: Maybe<Person>;
    createdById: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    distanceCalculation: DistanceCalculation;
    id: Scalars['ID'];
    includeCompetitors: Scalars['Boolean'];
    isEnabled: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    minimumFlightRule: Maybe<FlightRule>;
    name: Scalars['String'];
    oneCallAgreement: Scalars['Boolean'];
    preferredUnits: Array<PreferredUnit>;
    rank: Scalars['Int'];
    transportOfferAlgorithm: TransportOfferAlgorithm;
  };

export type OfferAlgorithm_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OfferAlgorithmCollection = {
  __typename: 'OfferAlgorithmCollection';
  items: Array<OfferAlgorithm>;
  meta: OfferAlgorithmCollectionMetadata;
};

export type OfferAlgorithmCollectionMetadata = CollectionMetadata & {
  __typename: 'OfferAlgorithmCollectionMetadata';
  total: Scalars['Int'];
};

export type OfferAlgorithmFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type OfferAlgorithmQueries = {
  __typename: 'OfferAlgorithmQueries';
  all: OfferAlgorithmCollection;
  byId: Maybe<OfferAlgorithm>;
};

export type OfferAlgorithmQueriesallArgs = {
  filter: InputMaybe<OfferAlgorithmFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OfferAlgorithmQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OfferWithBulkSkip = {
  crewMustFlyToArriveAtSending: InputMaybe<Scalars['Boolean']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  skipOfferIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OktaQueries = {
  __typename: 'OktaQueries';
  allUsers: OktaUserCollection;
  user: Maybe<OktaUser>;
};

export type OktaQueriesallUsersArgs = {
  filter: InputMaybe<OktaUserFilter>;
  first: InputMaybe<Scalars['Int']>;
};

export type OktaQueriesuserArgs = {
  idOrLogin: Scalars['ID'];
};

export type OktaUser = {
  __typename: 'OktaUser';
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  lastUpdated: Scalars['DateTime'];
  profile: OktaUserProfile;
  status: Scalars['String'];
};

export type OktaUserCollection = {
  __typename: 'OktaUserCollection';
  items: Array<OktaUser>;
};

export type OktaUserFilter = {
  filter: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};

export type OktaUserProfile = {
  __typename: 'OktaUserProfile';
  email: Scalars['String'];
  employeeNumber: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  login: Scalars['String'];
};

export enum OosActivityType {
  Ended = 'Ended',
  Far134515Changed = 'Far134515Changed',
  Far134517Changed = 'Far134517Changed',
  HumanErrorDamagedChanged = 'HumanErrorDamagedChanged',
  Started = 'Started',
}

export enum OosRequestType {
  OosRum = 'OosRum',
  Ops = 'Ops',
}

export enum OosTicketMaintenanceType {
  Deferral = 'Deferral',
  Discrepancies = 'Discrepancies',
  Inspection = 'Inspection',
}

export enum OosTicketStatusType {
  Closed = 'Closed',
  Denied = 'Denied',
  Draft = 'Draft',
  Processed = 'Processed',
  UnderReview = 'UnderReview',
}

export type Operation = Entity &
  Evented & {
    __typename: 'Operation';
    _events: MessageEnvelopeCollection;
    callbackNumber: Maybe<Scalars['String']>;
    caller: Maybe<Scalars['String']>;
    card: Card;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateOperationEnded: Maybe<Scalars['DateTime']>;
    dateOperationStarted: Scalars['DateTime'];
    id: Scalars['ID'];
    initialOperationType: Maybe<OperationType>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    riskAnalysisAcknowledged: Scalars['Boolean'];
    riskAnalysisNumber: Maybe<Scalars['String']>;
    standbyActivationType: Maybe<StandbyActivationType>;
    status: OperationStatus;
    timestamps: Maybe<Array<Maybe<Timestamp>>>;
    trips: Array<Trip>;
    type: OperationType;
    unit: Maybe<Unit>;
    unitActivationTime: Maybe<Scalars['DateTime']>;
    unitId: Maybe<Scalars['ID']>;
    vehicle: Vehicle;
    vehicleId: Scalars['ID'];
  };

export type Operation_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OperationCollection = {
  __typename: 'OperationCollection';
  items: Array<Operation>;
  meta: OperationCollectionMetadata;
};

export type OperationCollectionMetadata = CollectionMetadata & {
  __typename: 'OperationCollectionMetadata';
  total: Scalars['Int'];
};

export enum OperationStatus {
  Aborted = 'Aborted',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  CrewAccepted = 'CrewAccepted',
  OnStandby = 'OnStandby',
  Scheduled = 'Scheduled',
  Underway = 'Underway',
  UnitActivated = 'UnitActivated',
}

export type OperationSummary = {
  __typename: 'OperationSummary';
  id: Scalars['ID'];
  riskAnalysisAcknowledged: Maybe<Scalars['Boolean']>;
  riskAnalysisNumber: Maybe<Scalars['String']>;
  status: OperationStatus;
  tripId: Maybe<Scalars['ID']>;
  unitId: Maybe<Scalars['ID']>;
  vehicleId: Maybe<Scalars['ID']>;
};

export type OperationSummaryInput = {
  id: Scalars['ID'];
  riskAnalysisAcknowledged: InputMaybe<Scalars['Boolean']>;
  riskAnalysisNumber: InputMaybe<Scalars['String']>;
  status: OperationStatus;
  tripId: InputMaybe<Scalars['ID']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export enum OperationType {
  GroundRun = 'GroundRun',
  Maintenance = 'Maintenance',
  NonPatientShuttle = 'NonPatientShuttle',
  PatientShuttle = 'PatientShuttle',
  PublicRelations = 'PublicRelations',
  PublicUtility = 'PublicUtility',
  Reposition = 'Reposition',
  Residence = 'Residence',
  SceneCall = 'SceneCall',
  SearchAndAssist = 'SearchAndAssist',
  Training = 'Training',
  Transfer = 'Transfer',
  TransferCenter = 'TransferCenter',
}

export enum OpportunityMXType {
  Crew = 'Crew',
  Pilot = 'Pilot',
  Weather = 'Weather',
}

export type OutOfServiceCrew = {
  __typename: 'OutOfServiceCrew';
  endDate: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isFlightCrew: Scalars['Boolean'];
  notificationAddress: Maybe<Scalars['String']>;
  personId: Scalars['ID'];
  positionType: Maybe<UnitPositionType>;
  unitPositionId: Scalars['ID'];
  unitPositionRole: Maybe<Scalars['String']>;
};

export type OutOfServiceCrewInput = {
  endDate: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isFlightCrew: Scalars['Boolean'];
  notificationAddress: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  positionType: InputMaybe<UnitPositionType>;
  unitPositionId: Scalars['ID'];
  unitPositionRole: InputMaybe<Scalars['String']>;
};

export type OutOfServiceEvent = Entity &
  Evented & {
    __typename: 'OutOfServiceEvent';
    _events: MessageEnvelopeCollection;
    acknowledgedById: Maybe<Scalars['ID']>;
    acknowledgementNotes: Maybe<Scalars['String']>;
    address: Maybe<Address>;
    alertTimeInMinutes: Maybe<Scalars['Int']>;
    alertWhenEventEnds: Scalars['Boolean'];
    alternatePOC: Maybe<Scalars['String']>;
    amtPointOfContact: Maybe<Person>;
    amtPointOfContactId: Maybe<Scalars['ID']>;
    assignedBase: Maybe<Base>;
    assignedBaseId: Maybe<Scalars['ID']>;
    businessUnitCompanyId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    copiedFromId: Maybe<Scalars['ID']>;
    createdById: Maybe<Scalars['ID']>;
    crew: Maybe<Array<Maybe<OutOfServiceCrew>>>;
    dateAcknowledged: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    endTime: Maybe<Scalars['DateTime']>;
    endedById: Maybe<Scalars['ID']>;
    estimatedEndTime: Scalars['DateTime'];
    eventNumber: Scalars['String'];
    humanErrorDamageType: Maybe<HumanErrorDamageType>;
    id: Scalars['ID'];
    initialEstimatedEndTime: Scalars['DateTime'];
    isAMTAvailable: Maybe<Scalars['Boolean']>;
    isAcknowledgementRequired: Scalars['Boolean'];
    isAirworthy: Scalars['Boolean'];
    isBirdStrike: Scalars['Boolean'];
    isEventAlreadyClosed: Maybe<Scalars['Boolean']>;
    isFAR135415Reportable: Maybe<Scalars['Boolean']>;
    isFAR135417Reportable: Maybe<Scalars['Boolean']>;
    isOpportunisticOOS: Maybe<Scalars['Boolean']>;
    isPatientOnboard: Scalars['Boolean'];
    isPlanned: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    linkedCard: Maybe<Card>;
    linkedCardId: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    maintenanceFacility: Maybe<MaintenanceFacility>;
    maintenanceFacilityId: Maybe<Scalars['ID']>;
    maintenanceLocation: Maybe<Scalars['String']>;
    maintenanceTypes: Maybe<Array<Maybe<OosTicketMaintenanceType>>>;
    mxDuringPeakTimeReason: Maybe<Scalars['String']>;
    notes: Maybe<Scalars['String']>;
    oosRequestType: Maybe<OosRequestType>;
    opportunityMXTypes: Maybe<Array<Maybe<OpportunityMXType>>>;
    outOfServiceEventNotes: Array<OutOfServiceEventNote>;
    outOfServiceTicket: Maybe<OutOfServiceTicket>;
    outOfServiceTicketId: Maybe<Scalars['ID']>;
    paipEventId: Maybe<Scalars['ID']>;
    parentOutOfServiceEventId: Maybe<Scalars['ID']>;
    qarReasons: Maybe<Array<Maybe<IdListItem>>>;
    reason: OutOfServiceReason;
    reasonId: Scalars['ID'];
    rtsDelayReasonTypes: Maybe<Array<Maybe<RtsDelayReasonType>>>;
    scheduledStartTime: Maybe<Scalars['DateTime']>;
    secondaryReason: Maybe<OutOfServiceSecondaryReason>;
    secondaryReasonComment: Maybe<Scalars['String']>;
    secondaryReasonId: Maybe<Scalars['ID']>;
    spareVehicle: Maybe<Vehicle>;
    spareVehicleId: Maybe<Scalars['ID']>;
    startTime: Maybe<Scalars['DateTime']>;
    ticketDescription: Maybe<Scalars['String']>;
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
    type: OutOfServiceType;
    unit: Maybe<Unit>;
    unitId: Maybe<Scalars['ID']>;
    units: Maybe<Array<Maybe<Unit>>>;
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
    waitingForParts: Scalars['Boolean'];
    waitingForTooling: Scalars['Boolean'];
  };

export type OutOfServiceEvent_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceEventCollection = {
  __typename: 'OutOfServiceEventCollection';
  items: Array<OutOfServiceEvent>;
  meta: OutOfServiceEventCollectionMetadata;
};

export type OutOfServiceEventCollectionMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceEventCollectionMetadata';
  total: Scalars['Int'];
};

export type OutOfServiceEventDashboardData = {
  __typename: 'OutOfServiceEventDashboardData';
  acknowledgedById: Maybe<Scalars['ID']>;
  acknowledgementNotes: Maybe<Scalars['String']>;
  baseName: Maybe<Scalars['String']>;
  communicationCenterId: Maybe<Scalars['ID']>;
  communicationCenterName: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  dateAcknowledged: Maybe<Scalars['DateTime']>;
  endTime: Maybe<Scalars['DateTime']>;
  entityType: Maybe<Scalars['String']>;
  estimatedEndTime: Scalars['DateTime'];
  eventNumber: Scalars['String'];
  id: Scalars['ID'];
  initialEstimatedEndTime: Scalars['DateTime'];
  isAcknowledgementRequired: Scalars['Boolean'];
  isAirworthy: Scalars['Boolean'];
  isOpportunisticOOS: Maybe<Scalars['Boolean']>;
  maintenanceFacilityId: Maybe<Scalars['ID']>;
  maintenanceFacilityName: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  reasonId: Scalars['ID'];
  reasonName: Scalars['String'];
  registrationNumber: Maybe<Scalars['String']>;
  scheduledStartTime: Maybe<Scalars['DateTime']>;
  secondaryReasonId: Maybe<Scalars['ID']>;
  secondaryReasonName: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['DateTime']>;
  subeventsCount: Maybe<Scalars['Int']>;
  typeCd: Scalars['String'];
  typeName: Scalars['String'];
  unitAbbreviation: Maybe<Scalars['String']>;
  unitId: Maybe<Scalars['ID']>;
  unitName: Maybe<Scalars['String']>;
  unitVehicleTailNumber: Maybe<Scalars['String']>;
  vehicleId: Maybe<Scalars['ID']>;
};

export type OutOfServiceEventDashboardDataCollection = {
  __typename: 'OutOfServiceEventDashboardDataCollection';
  items: Array<OutOfServiceEventDashboardData>;
  meta: OutOfServiceEventDashboardDataMetadata;
};

export type OutOfServiceEventDashboardDataFilter = {
  communicationCenters: Array<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  endDateEnd: InputMaybe<Scalars['DateTime']>;
  endDateStart: InputMaybe<Scalars['DateTime']>;
  includeInactive: InputMaybe<Scalars['Boolean']>;
  includeSubEvents: InputMaybe<Scalars['Boolean']>;
  oosEventNumberLike: InputMaybe<Scalars['String']>;
  registrationNumberLike: InputMaybe<Scalars['String']>;
  sortBy: InputMaybe<OutOfServiceEventDashboardDataSortBy>;
  sortOrder: InputMaybe<SortOrder>;
  type: InputMaybe<Scalars['String']>;
  unacknowledgedOnly: InputMaybe<Scalars['Boolean']>;
  unitNameLike: InputMaybe<Scalars['String']>;
  vehicleTypes: InputMaybe<Array<VehicleType>>;
};

export type OutOfServiceEventDashboardDataMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceEventDashboardDataMetadata';
  total: Scalars['Int'];
};

export enum OutOfServiceEventDashboardDataSortBy {
  BaseName = 'BaseName',
  EndTime = 'EndTime',
  EntityType = 'EntityType',
  EstimatedEndTime = 'EstimatedEndTime',
  EventNumber = 'EventNumber',
  MaintenanceFacilityName = 'MaintenanceFacilityName',
  ReasonName = 'ReasonName',
  RegistrationNumber = 'RegistrationNumber',
  SecondaryReasonName = 'SecondaryReasonName',
  StartTime = 'StartTime',
  UnitName = 'UnitName',
}

export type OutOfServiceEventFilter = {
  active: InputMaybe<Scalars['Boolean']>;
  afterDate: InputMaybe<Scalars['DateTime']>;
  companyId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  oosEventNumberLike: InputMaybe<Scalars['String']>;
  outOfServiceTicketId: InputMaybe<Scalars['ID']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type OutOfServiceEventNote = Entity &
  Evented & {
    __typename: 'OutOfServiceEventNote';
    _events: MessageEnvelopeCollection;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    content: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isSystem: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    noteCategory: Maybe<Scalars['String']>;
    noteMetadataJson: Maybe<Scalars['String']>;
    noteTime: Scalars['DateTime'];
    outOfServiceEvent: OutOfServiceEvent;
    outOfServiceEventId: Scalars['ID'];
  };

export type OutOfServiceEventNote_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceEventNoteCollection = {
  __typename: 'OutOfServiceEventNoteCollection';
  items: Array<OutOfServiceEventNote>;
  meta: OutOfServiceEventNoteCollectionMetadata;
};

export type OutOfServiceEventNoteCollectionMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceEventNoteCollectionMetadata';
  total: Scalars['Int'];
};

export type OutOfServiceEventNoteFilter = {
  authorId: InputMaybe<Scalars['ID']>;
  contentLike: InputMaybe<Scalars['String']>;
};

export type OutOfServiceEventNoteQueries = {
  __typename: 'OutOfServiceEventNoteQueries';
  byId: Maybe<OutOfServiceEventNote>;
  byOutOfServiceEventId: OutOfServiceEventNoteCollection;
};

export type OutOfServiceEventNoteQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceEventNoteQueriesbyOutOfServiceEventIdArgs = {
  filter: InputMaybe<OutOfServiceEventNoteFilter>;
  first: InputMaybe<Scalars['Int']>;
  outOfServiceEventId: Scalars['ID'];
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceEventQueries = {
  __typename: 'OutOfServiceEventQueries';
  all: OutOfServiceEventCollection;
  byId: Maybe<OutOfServiceEvent>;
  byParentId: OutOfServiceEventCollection;
  dashboard: OutOfServiceEventDashboardDataCollection;
};

export type OutOfServiceEventQueriesallArgs = {
  filter: InputMaybe<OutOfServiceEventFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceEventQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceEventQueriesbyParentIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceEventQueriesdashboardArgs = {
  filter: InputMaybe<OutOfServiceEventDashboardDataFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceEventSummary = {
  __typename: 'OutOfServiceEventSummary';
  estimatedEndTime: Scalars['DateTime'];
  eventNumber: Scalars['String'];
  id: Scalars['ID'];
  isOpportunisticOOS: Maybe<Scalars['Boolean']>;
  notes: Maybe<Scalars['String']>;
  reasonId: Scalars['ID'];
  reasonName: Scalars['String'];
  startTime: Maybe<Scalars['DateTime']>;
  type: OutOfServiceType;
};

export type OutOfServiceEventSummaryInput = {
  estimatedEndTime: Scalars['DateTime'];
  eventNumber: Scalars['String'];
  id: Scalars['ID'];
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  notes: InputMaybe<Scalars['String']>;
  reasonId: Scalars['ID'];
  reasonName: Scalars['String'];
  startTime: InputMaybe<Scalars['DateTime']>;
  type: OutOfServiceType;
};

export type OutOfServiceQARReason = Entity &
  Evented & {
    __typename: 'OutOfServiceQARReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type OutOfServiceQARReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceQARReasonCollection = {
  __typename: 'OutOfServiceQARReasonCollection';
  items: Array<OutOfServiceQARReason>;
  meta: OutOfServiceQARReasonCollectionMetadata;
};

export type OutOfServiceQARReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceQARReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type OutOfServiceQARReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type OutOfServiceQARReasonQueries = {
  __typename: 'OutOfServiceQARReasonQueries';
  all: OutOfServiceQARReasonCollection;
  byId: Maybe<OutOfServiceQARReason>;
};

export type OutOfServiceQARReasonQueriesallArgs = {
  filter: InputMaybe<OutOfServiceQARReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceQARReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceReason = Entity &
  Evented & {
    __typename: 'OutOfServiceReason';
    _events: MessageEnvelopeCollection;
    configurationSettings: Maybe<Array<Maybe<ConfigurationSetting>>>;
    controllable: Scalars['Boolean'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    description: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isVehicleReason: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    oemPlans: Array<OemPlan>;
    outOfServiceEvents: Array<OutOfServiceEvent>;
    outOfServiceSecondaryReasons: Array<OutOfServiceSecondaryReason>;
    outOfServiceTickets: Maybe<Array<Maybe<OutOfServiceTicket>>>;
    paipReasons: Maybe<Array<Maybe<PaipReason>>>;
  };

export type OutOfServiceReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceReasonCollection = {
  __typename: 'OutOfServiceReasonCollection';
  items: Array<OutOfServiceReason>;
  meta: OutOfServiceReasonCollectionMetadata;
};

export type OutOfServiceReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type OutOfServiceReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type OutOfServiceReasonQueries = {
  __typename: 'OutOfServiceReasonQueries';
  all: OutOfServiceReasonCollection;
  byId: Maybe<OutOfServiceReason>;
};

export type OutOfServiceReasonQueriesallArgs = {
  filter: InputMaybe<OutOfServiceReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceSecondaryReason = Entity &
  Evented & {
    __typename: 'OutOfServiceSecondaryReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceReason: OutOfServiceReason;
    outOfServiceReasonId: Scalars['ID'];
    outOfServiceTickets: Maybe<Array<Maybe<OutOfServiceTicket>>>;
  };

export type OutOfServiceSecondaryReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceSecondaryReasonCollection = {
  __typename: 'OutOfServiceSecondaryReasonCollection';
  items: Array<OutOfServiceSecondaryReason>;
  meta: OutOfServiceSecondaryReasonCollectionMetadata;
};

export type OutOfServiceSecondaryReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceSecondaryReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type OutOfServiceSecondaryReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  outOfServiceReasonId: InputMaybe<Scalars['String']>;
};

export type OutOfServiceSecondaryReasonQueries = {
  __typename: 'OutOfServiceSecondaryReasonQueries';
  all: OutOfServiceSecondaryReasonCollection;
  byId: Maybe<OutOfServiceSecondaryReason>;
};

export type OutOfServiceSecondaryReasonQueriesallArgs = {
  filter: InputMaybe<OutOfServiceSecondaryReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceSecondaryReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceTicket = Entity &
  Evented & {
    __typename: 'OutOfServiceTicket';
    _events: MessageEnvelopeCollection;
    acceptedBy: Maybe<Person>;
    acceptedById: Maybe<Scalars['ID']>;
    acknowledgedById: Maybe<Scalars['ID']>;
    acknowledgementNotes: Maybe<Scalars['String']>;
    address: Maybe<Address>;
    alternatePOC: Maybe<Scalars['String']>;
    assignedBase: Maybe<Base>;
    assignedBaseId: Maybe<Scalars['ID']>;
    businessUnitCompanyId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    dateAccepted: Maybe<Scalars['DateTime']>;
    dateAcknowledged: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    datePageoutCompleted: Maybe<Scalars['DateTime']>;
    dateSubmittedForReview: Maybe<Scalars['DateTime']>;
    ertsDateTime: Scalars['DateTime'];
    humanErrorDamageType: Maybe<HumanErrorDamageType>;
    id: Scalars['ID'];
    isAMTAvailable: Maybe<Scalars['Boolean']>;
    isBirdStrike: Scalars['Boolean'];
    isFAR135415Reportable: Maybe<Scalars['Boolean']>;
    isFAR135417Reportable: Maybe<Scalars['Boolean']>;
    isOpportunisticOOS: Maybe<Scalars['Boolean']>;
    isPatientOnboard: Scalars['Boolean'];
    isPlanned: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    maintenanceFacility: Maybe<MaintenanceFacility>;
    maintenanceFacilityId: Maybe<Scalars['ID']>;
    maintenanceLocation: Maybe<Scalars['String']>;
    maintenanceTypes: Array<OosTicketMaintenanceType>;
    mxDuringPeakTimeReason: Maybe<Scalars['String']>;
    opportunityMXTypes: Maybe<Array<Maybe<OpportunityMXType>>>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceTime: Scalars['DateTime'];
    outOfServiceType: Maybe<OutOfServiceType>;
    pageoutCompletedBy: Maybe<Person>;
    pageoutCompletedById: Maybe<Scalars['ID']>;
    pointOfContact: Maybe<Person>;
    pointOfContactId: Maybe<Scalars['ID']>;
    primaryReason: Maybe<OutOfServiceReason>;
    primaryReasonId: Maybe<Scalars['ID']>;
    qarReasons: Maybe<Array<Maybe<IdListItem>>>;
    rtsDelayReasonTypes: Maybe<Array<Maybe<RtsDelayReasonType>>>;
    secondaryReason: Maybe<OutOfServiceSecondaryReason>;
    secondaryReasonId: Maybe<Scalars['ID']>;
    spareVehicle: Maybe<Vehicle>;
    spareVehicleId: Maybe<Scalars['ID']>;
    status: OosTicketStatusType;
    submittedBy: Person;
    submittedById: Scalars['ID'];
    ticketDescription: Scalars['String'];
    ticketNumber: Maybe<Scalars['String']>;
    vehicle: Vehicle;
    vehicleId: Scalars['ID'];
    waitingForParts: Scalars['Boolean'];
    waitingForPartsTimestamp: Maybe<Scalars['DateTime']>;
    waitingForTooling: Scalars['Boolean'];
    waitingForToolingTimestamp: Maybe<Scalars['DateTime']>;
  };

export type OutOfServiceTicket_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceTicketCollection = {
  __typename: 'OutOfServiceTicketCollection';
  items: Array<OutOfServiceTicket>;
  meta: OutOfServiceTicketCollectionMetadata;
};

export type OutOfServiceTicketCollectionMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceTicketCollectionMetadata';
  total: Scalars['Int'];
};

export type OutOfServiceTicketDashboardData = {
  __typename: 'OutOfServiceTicketDashboardData';
  acceptedById: Maybe<Scalars['String']>;
  acceptedByName: Maybe<Scalars['String']>;
  acknowledgedById: Maybe<Scalars['ID']>;
  acknowledgementNotes: Maybe<Scalars['String']>;
  assignedBaseId: Maybe<Scalars['String']>;
  assignedBaseName: Maybe<Scalars['String']>;
  communicationCenterId: Maybe<Scalars['ID']>;
  communicationCenterName: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  dateAcknowledged: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  maintenanceFacilityId: Maybe<Scalars['ID']>;
  maintenanceFacilityName: Maybe<Scalars['String']>;
  maintenanceLocation: Maybe<Scalars['String']>;
  maintenanceTypes: Scalars['String'];
  outOfServiceTime: Maybe<Scalars['DateTime']>;
  pageoutCompletedById: Maybe<Scalars['String']>;
  pageoutCompletedByName: Maybe<Scalars['String']>;
  pointOfContactId: Maybe<Scalars['ID']>;
  pointOfContactName: Maybe<Scalars['String']>;
  registrationNumber: Scalars['String'];
  spareRegistrationNumber: Maybe<Scalars['String']>;
  spareVehicleId: Maybe<Scalars['ID']>;
  statusCd: Scalars['String'];
  statusName: Scalars['String'];
  submittedById: Scalars['ID'];
  submittedByName: Scalars['String'];
  ticketDescription: Scalars['String'];
  ticketNumber: Scalars['String'];
  unitAbbreviation: Maybe<Scalars['String']>;
  unitId: Maybe<Scalars['ID']>;
  unitName: Maybe<Scalars['String']>;
  vehicleId: Maybe<Scalars['ID']>;
};

export type OutOfServiceTicketDashboardDataCollection = {
  __typename: 'OutOfServiceTicketDashboardDataCollection';
  items: Array<OutOfServiceTicketDashboardData>;
  meta: OutOfServiceTicketDashboardDataMetadata;
};

export type OutOfServiceTicketDashboardDataFilter = {
  communicationCenters: InputMaybe<Array<Scalars['ID']>>;
  companyId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  endDateEnd: InputMaybe<Scalars['DateTime']>;
  endDateStart: InputMaybe<Scalars['DateTime']>;
  includeStatuses: InputMaybe<Array<OosTicketStatusType>>;
  registrationNumberLike: InputMaybe<Scalars['String']>;
  sortBy: InputMaybe<OutOfServiceTicketDashboardDataSortBy>;
  sortOrder: InputMaybe<SortOrder>;
  submittedById: InputMaybe<Scalars['ID']>;
  ticketNumberLike: InputMaybe<Scalars['String']>;
  unacknowledgedOnly: InputMaybe<Scalars['Boolean']>;
  unitNameLike: InputMaybe<Scalars['String']>;
  vehicleTypes: InputMaybe<Array<VehicleType>>;
};

export type OutOfServiceTicketDashboardDataMetadata = CollectionMetadata & {
  __typename: 'OutOfServiceTicketDashboardDataMetadata';
  total: Scalars['Int'];
};

export enum OutOfServiceTicketDashboardDataSortBy {
  AssignedBaseLocation = 'AssignedBaseLocation',
  MaintenanceFacility = 'MaintenanceFacility',
  MaintenanceType = 'MaintenanceType',
  OutOfServiceDate = 'OutOfServiceDate',
  PointOfContact = 'PointOfContact',
  RegistrationNumber = 'RegistrationNumber',
  SpareRegistrationNumber = 'SpareRegistrationNumber',
  Status = 'Status',
  Submitter = 'Submitter',
  TicketDescription = 'TicketDescription',
  TicketNumber = 'TicketNumber',
}

export type OutOfServiceTicketFilter = {
  active: InputMaybe<Scalars['Boolean']>;
  afterDate: InputMaybe<Scalars['DateTime']>;
  companyId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  ticketNumberLike: InputMaybe<Scalars['String']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type OutOfServiceTicketQueries = {
  __typename: 'OutOfServiceTicketQueries';
  all: OutOfServiceTicketCollection;
  byId: Maybe<OutOfServiceTicket>;
  dashboard: OutOfServiceTicketDashboardDataCollection;
};

export type OutOfServiceTicketQueriesallArgs = {
  filter: InputMaybe<OutOfServiceTicketFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type OutOfServiceTicketQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type OutOfServiceTicketQueriesdashboardArgs = {
  filter: InputMaybe<OutOfServiceTicketDashboardDataFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum OutOfServiceType {
  Opportunistic = 'Opportunistic',
  RefurbishmentOrRefresh = 'RefurbishmentOrRefresh',
  Scheduled = 'Scheduled',
  Unscheduled = 'Unscheduled',
}

export enum PaipActivityType {
  Ended = 'Ended',
  Started = 'Started',
}

export type PaipEvent = Entity &
  Evented & {
    __typename: 'PaipEvent';
    _events: MessageEnvelopeCollection;
    cardIds: Maybe<Array<Maybe<IdListItem>>>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    endTime: Maybe<Scalars['DateTime']>;
    eventNumber: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notes: Maybe<Scalars['String']>;
    reason: PaipReason;
    reasonId: Scalars['ID'];
    region: Maybe<Region>;
    regionId: Maybe<Scalars['ID']>;
    startTime: Scalars['DateTime'];
    unitIds: Maybe<Array<Maybe<IdListItem>>>;
  };

export type PaipEvent_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PaipEventCollection = {
  __typename: 'PaipEventCollection';
  items: Array<PaipEvent>;
  meta: PaipEventCollectionMetadata;
};

export type PaipEventCollectionMetadata = CollectionMetadata & {
  __typename: 'PaipEventCollectionMetadata';
  total: Scalars['Int'];
};

export type PaipEventFilter = {
  active: InputMaybe<Scalars['Boolean']>;
  companyId: InputMaybe<Scalars['ID']>;
  reasonId: InputMaybe<Scalars['ID']>;
  regionId: InputMaybe<Scalars['ID']>;
};

export type PaipEventQueries = {
  __typename: 'PaipEventQueries';
  all: PaipEventCollection;
  byId: Maybe<PaipEvent>;
};

export type PaipEventQueriesallArgs = {
  filter: InputMaybe<PaipEventFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PaipEventQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type PaipReason = Entity &
  Evented & {
    __typename: 'PaipReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    outOfServiceReason: Maybe<OutOfServiceReason>;
    outOfServiceReasonId: Maybe<Scalars['ID']>;
    paipEvents: Array<PaipEvent>;
  };

export type PaipReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PaipReasonCollection = {
  __typename: 'PaipReasonCollection';
  items: Array<PaipReason>;
  meta: PaipReasonCollectionMetadata;
};

export type PaipReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'PaipReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type PaipReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  outOfServiceReasonId: InputMaybe<Scalars['ID']>;
};

export type PaipReasonQueries = {
  __typename: 'PaipReasonQueries';
  all: PaipReasonCollection;
  byId: Maybe<PaipReason>;
};

export type PaipReasonQueriesallArgs = {
  filter: InputMaybe<PaipReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PaipReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type ParticipantMetadata = {
  __typename: 'ParticipantMetadata';
  role: Maybe<Scalars['String']>;
};

export type ParticipantMetadataInput = {
  role: InputMaybe<Scalars['String']>;
};

export type PassdownLog = Entity &
  Evented & {
    __typename: 'PassdownLog';
    _events: MessageEnvelopeCollection;
    acknowledgedBy: Maybe<Person>;
    acknowledgedById: Maybe<Scalars['ID']>;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    body: Scalars['String'];
    companyId: Scalars['ID'];
    dateAcknowledged: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    logDate: Scalars['DateTime'];
    name: Scalars['String'];
    passdownLogAcknowledgements: Array<PassdownLogAcknowledgement>;
    passdownLogArchivedLogs: Array<PassdownLogArchivedLog>;
    region: Region;
    regionId: Scalars['ID'];
    regionIdList: Maybe<Array<Maybe<Scalars['String']>>>;
    requiresAcknowledgement: Scalars['Boolean'];
  };

export type PassdownLog_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PassdownLogAcknowledgement = Entity &
  Evented & {
    __typename: 'PassdownLogAcknowledgement';
    _events: MessageEnvelopeCollection;
    acknowledgedBy: Person;
    acknowledgedById: Scalars['ID'];
    companyId: Scalars['ID'];
    dateAcknowledged: Scalars['DateTime'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    passdownLog: PassdownLog;
    passdownLogId: Scalars['ID'];
  };

export type PassdownLogAcknowledgement_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PassdownLogAcknowledgementCollection = {
  __typename: 'PassdownLogAcknowledgementCollection';
  items: Array<PassdownLogAcknowledgement>;
  meta: PassdownLogAcknowledgementCollectionMetadata;
};

export type PassdownLogAcknowledgementCollectionMetadata = CollectionMetadata & {
  __typename: 'PassdownLogAcknowledgementCollectionMetadata';
  total: Scalars['Int'];
};

export type PassdownLogArchivedLog = Entity &
  Evented & {
    __typename: 'PassdownLogArchivedLog';
    _events: MessageEnvelopeCollection;
    archivedBy: Person;
    archivedById: Scalars['ID'];
    companyId: Scalars['ID'];
    dateArchived: Scalars['DateTime'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    passdownLog: PassdownLog;
    passdownLogId: Scalars['ID'];
  };

export type PassdownLogArchivedLog_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PassdownLogArchivedLogCollection = {
  __typename: 'PassdownLogArchivedLogCollection';
  items: Array<PassdownLogArchivedLog>;
  meta: PassdownLogArchivedLogCollectionMetadata;
};

export type PassdownLogArchivedLogCollectionMetadata = CollectionMetadata & {
  __typename: 'PassdownLogArchivedLogCollectionMetadata';
  total: Scalars['Int'];
};

export type PassdownLogCollection = {
  __typename: 'PassdownLogCollection';
  items: Array<PassdownLog>;
  meta: PassdownLogCollectionMetadata;
};

export type PassdownLogCollectionMetadata = CollectionMetadata & {
  __typename: 'PassdownLogCollectionMetadata';
  total: Scalars['Int'];
};

export type PassdownLogFilter = {
  includeRegionIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  logDateRange: InputMaybe<DateRangeFilter>;
  nameLike: InputMaybe<Scalars['String']>;
  regionId: InputMaybe<Scalars['ID']>;
  unacknowledgedOnly: InputMaybe<Scalars['Boolean']>;
};

export type PassdownLogQueries = {
  __typename: 'PassdownLogQueries';
  all: PassdownLogCollection;
  byId: Maybe<PassdownLog>;
};

export type PassdownLogQueriesallArgs = {
  filter: InputMaybe<PassdownLogFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PassdownLogQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type PassengerFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  passengerType: InputMaybe<PassengerType>;
  personId: InputMaybe<Scalars['ID']>;
  positionType: InputMaybe<UnitPositionType>;
};

export enum PassengerType {
  CoPilot = 'CoPilot',
  CrewMember = 'CrewMember',
  Driver = 'Driver',
  Escort = 'Escort',
  Guard = 'Guard',
  Other = 'Other',
  Patient = 'Patient',
  PilotInCommand = 'PilotInCommand',
  RideAlong = 'RideAlong',
  SpecialtyTeamMember = 'SpecialtyTeamMember',
}

export type Patient = Entity &
  Evented & {
    __typename: 'Patient';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateOfBirth: Maybe<Scalars['DateTime']>;
    firstName: Maybe<Scalars['String']>;
    gender: Gender;
    id: Scalars['ID'];
    lastName: Maybe<Scalars['String']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requests: Maybe<Array<Maybe<RequestPatient>>>;
  };

export type Patient_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum PatientActivityType {
  Created = 'Created',
  Deleted = 'Deleted',
  Updated = 'Updated',
}

export type PatientCollection = {
  __typename: 'PatientCollection';
  items: Array<Patient>;
  meta: PatientCollectionMetadata;
};

export type PatientCollectionMetadata = CollectionMetadata & {
  __typename: 'PatientCollectionMetadata';
  total: Scalars['Int'];
};

export enum PatientRelationshipType {
  Other = 'Other',
  ParentOrGuardian = 'ParentOrGuardian',
  Spouse = 'Spouse',
  Unspecified = 'Unspecified',
}

export type Person = Entity &
  Evented & {
    __typename: 'Person';
    _events: MessageEnvelopeCollection;
    accessibleItems: Array<AccessibleItem>;
    activateOktaAccount: Scalars['Boolean'];
    activeAlertAcknowledgements: Array<ActiveAlertAcknowledgement>;
    activeAlerts: Maybe<Array<Maybe<ActiveAlert>>>;
    activeDirectoryId: Maybe<Scalars['String']>;
    additionalCompanies: Maybe<Array<Maybe<IdListItem>>>;
    alerts: Maybe<Array<Maybe<Alert>>>;
    allBasesAccessible: Maybe<Scalars['Boolean']>;
    allCommunicationCentersAccessible: Maybe<Scalars['Boolean']>;
    allCompaniesAccessible: Maybe<Scalars['Boolean']>;
    allTrmProgramsAccessible: Maybe<Scalars['Boolean']>;
    appSettings: Maybe<UserApplicationSettings>;
    applicationNotifications: Maybe<Array<Maybe<ApplicationNotification>>>;
    aviationCompanyId: Maybe<Scalars['ID']>;
    base: Maybe<Base>;
    baseId: Maybe<Scalars['ID']>;
    cardNoteArchives: Maybe<Array<Maybe<CardNoteArchive>>>;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateLastUpdatedFromGMRWorkday: Maybe<Scalars['DateTime']>;
    department: Maybe<Department>;
    departmentId: Maybe<Scalars['ID']>;
    dispatchCompanyId: Maybe<Scalars['ID']>;
    email: Scalars['String'];
    employeeId: Maybe<Scalars['String']>;
    employeeType: EmployeeType;
    faaCompanyId: Maybe<Scalars['ID']>;
    firstName: Scalars['String'];
    grantTcsAccess: Scalars['Boolean'];
    hireDate: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    isActive: Maybe<Scalars['Boolean']>;
    /** @deprecated This was a temporary fix for a lack of a permissions system and may be removed */
    isAviationSupervisor: Scalars['Boolean'];
    isOutOfFlightCompliance: Scalars['Boolean'];
    lastName: Scalars['String'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    manifestEntries: Maybe<Array<Maybe<ManifestEntry>>>;
    medicalControlContactLogEntries: Array<MedicalControlContactLogEntry>;
    medicalControlContacts: Array<BaseMedicalControlContact>;
    members: Maybe<Array<Maybe<NotificationGroupMember>>>;
    newAgencyLocationRequests: Array<NewAgencyLocationRequest>;
    notes: Maybe<Array<Maybe<UnitNote>>>;
    notificationAddress: Maybe<Scalars['String']>;
    notificationTemplates: Maybe<Array<Maybe<NotificationTemplate>>>;
    oemActivities: Maybe<Array<Maybe<OemActivity>>>;
    oemPlanChangeRequests: Maybe<Array<Maybe<OemPlanChangeRequest>>>;
    offerAlgorithms: Maybe<Array<Maybe<OfferAlgorithm>>>;
    outOfFlightComplianceComment: Maybe<Scalars['String']>;
    outOfServiceEventNotes: Maybe<Array<Maybe<OutOfServiceEventNote>>>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceTickets: Array<OutOfServiceTicket>;
    passdownLogAcknowledgements: Array<PassdownLogAcknowledgement>;
    passdownLogArchivedLogs: Array<PassdownLogArchivedLog>;
    passdownLogs: Maybe<Array<Maybe<PassdownLog>>>;
    primaryCommunicationCenter: Maybe<CommunicationCenter>;
    primaryCommunicationCenterId: Maybe<Scalars['ID']>;
    program: Maybe<Program>;
    programId: Maybe<Scalars['ID']>;
    programs: Maybe<Array<Maybe<Program>>>;
    recipients: Maybe<Array<Maybe<NotificationRecipient>>>;
    reportsToPersonId: Maybe<Scalars['ID']>;
    specialtyTeamMembers: Array<SpecialtyTeamMember>;
    terminationDate: Maybe<Scalars['DateTime']>;
    timeType: TimeType;
    timestamps: Maybe<Array<Maybe<Timestamp>>>;
    title: Maybe<Scalars['String']>;
    trips: Maybe<Array<Maybe<TripPassenger>>>;
    trmUsers: Maybe<Array<Maybe<TrmUser>>>;
    units: Maybe<Array<Maybe<UnitPosition>>>;
    userRoles: Maybe<Array<Maybe<UserRole>>>;
    webOrderLogs: Maybe<Array<Maybe<WebOrderLog>>>;
  };

export type Person_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PersonCollection = {
  __typename: 'PersonCollection';
  items: Array<Person>;
  meta: PersonCollectionMetadata;
};

export type PersonCollectionMetadata = CollectionMetadata & {
  __typename: 'PersonCollectionMetadata';
  total: Scalars['Int'];
};

export type PersonFilter = {
  allUserRoles: InputMaybe<Array<UserRole>>;
  anyUserRoles: InputMaybe<Array<UserRole>>;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  includeAllCompanies: InputMaybe<Scalars['Boolean']>;
  includeTerminated: InputMaybe<Scalars['Boolean']>;
  includeTerminatedAfter: InputMaybe<Scalars['DateTime']>;
  isOutOfFlightCompliance: InputMaybe<Scalars['Boolean']>;
  nameLike: InputMaybe<Scalars['String']>;
  personId: InputMaybe<Scalars['ID']>;
  withoutAllUserRoles: InputMaybe<Array<UserRole>>;
  withoutAnyUserRoles: InputMaybe<Array<UserRole>>;
};

export type PersonQueries = {
  __typename: 'PersonQueries';
  all: PersonCollection;
  byEmail: Maybe<Person>;
  byId: Maybe<Person>;
  current: Maybe<Person>;
};

export type PersonQueriesallArgs = {
  filter: InputMaybe<PersonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PersonQueriesbyEmailArgs = {
  email: Scalars['String'];
};

export type PersonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum PhoneNumberType {
  Home = 'Home',
  Mobile = 'Mobile',
  Other = 'Other',
  Work = 'Work',
}

export type Physician = Entity &
  Evented & {
    __typename: 'Physician';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    firstName: Scalars['String'];
    id: Scalars['ID'];
    lastName: Scalars['String'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalFacilities: Array<MedicalFacilityPhysician>;
    requests: Maybe<Array<Maybe<RequestLocation>>>;
  };

export type Physician_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PhysicianCollection = {
  __typename: 'PhysicianCollection';
  items: Array<Physician>;
  meta: PhysicianCollectionMetadata;
};

export type PhysicianCollectionMetadata = CollectionMetadata & {
  __typename: 'PhysicianCollectionMetadata';
  total: Scalars['Int'];
};

export type PhysicianFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type PhysicianQueries = {
  __typename: 'PhysicianQueries';
  all: PhysicianCollection;
  byId: Maybe<Physician>;
};

export type PhysicianQueriesallArgs = {
  filter: InputMaybe<PhysicianFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PhysicianQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type PlaceUnitOnStandby = {
  commitUnit: InputMaybe<Scalars['Boolean']>;
  operationId: Scalars['ID'];
};

export type PositionReport = Entity &
  Evented & {
    __typename: 'PositionReport';
    _events: MessageEnvelopeCollection;
    altitude: Maybe<Scalars['Float']>;
    companyId: Scalars['ID'];
    coordinates: Maybe<Coordinates>;
    dateConfirmed: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    estimatedDuration: Maybe<EstimatedDuration>;
    estimatedMinutesEnRoute: Maybe<Scalars['Int']>;
    fuelRemaining: Maybe<Scalars['String']>;
    gpsProvider: Maybe<GpsProvider>;
    heading: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    positionTime: Scalars['DateTime'];
    source: PositionReportSource;
    speedInKnots: Maybe<Scalars['Float']>;
    timezoneCd: Maybe<Scalars['String']>;
    trip: Trip;
    tripId: Scalars['ID'];
    vehicleDisposition: Maybe<VehicleDisposition>;
  };

export type PositionReport_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PositionReportAlert = Entity &
  Evented & {
    __typename: 'PositionReportAlert';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    hasReceivedQualifyingReport: Scalars['Boolean'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    vehicle: Vehicle;
    vehicleId: Scalars['ID'];
  };

export type PositionReportAlert_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PositionReportAlertCollection = {
  __typename: 'PositionReportAlertCollection';
  items: Array<PositionReportAlert>;
  meta: PositionReportAlertCollectionMetadata;
};

export type PositionReportAlertCollectionMetadata = CollectionMetadata & {
  __typename: 'PositionReportAlertCollectionMetadata';
  total: Scalars['Int'];
};

export type PositionReportAlertFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  includeOnlyNoQualifiedReportAlerts: InputMaybe<Scalars['Boolean']>;
};

export type PositionReportAlertQueries = {
  __typename: 'PositionReportAlertQueries';
  all: PositionReportAlertCollection;
  byId: Maybe<PositionReportAlert>;
  byVehicleId: Maybe<PositionReportAlert>;
};

export type PositionReportAlertQueriesallArgs = {
  filter: InputMaybe<PositionReportAlertFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PositionReportAlertQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type PositionReportAlertQueriesbyVehicleIdArgs = {
  vehicleId: Scalars['ID'];
};

export type PositionReportArchive = Entity &
  Evented & {
    __typename: 'PositionReportArchive';
    _events: MessageEnvelopeCollection;
    altitude: Maybe<Scalars['Float']>;
    companyId: Scalars['ID'];
    coordinates: Maybe<Coordinates>;
    dateArchived: Scalars['DateTime'];
    dateConfirmed: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    estimatedMinutesEnRoute: Maybe<Scalars['Int']>;
    fuelRemaining: Maybe<Scalars['String']>;
    heading: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    positionTime: Scalars['DateTime'];
    source: PositionReportSource;
    speedInKnots: Maybe<Scalars['Float']>;
    timezoneCd: Maybe<Scalars['String']>;
    tripId: Scalars['ID'];
  };

export type PositionReportArchive_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PositionReportArchiveCollection = {
  __typename: 'PositionReportArchiveCollection';
  items: Array<PositionReportArchive>;
  meta: PositionReportArchiveCollectionMetadata;
};

export type PositionReportArchiveCollectionMetadata = CollectionMetadata & {
  __typename: 'PositionReportArchiveCollectionMetadata';
  total: Scalars['Int'];
};

export type PositionReportArchiveQueries = {
  __typename: 'PositionReportArchiveQueries';
  byId: Maybe<PositionReportArchive>;
  byTripId: PositionReportArchiveCollection;
};

export type PositionReportArchiveQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type PositionReportArchiveQueriesbyTripIdArgs = {
  tripId: Scalars['ID'];
};

export type PositionReportCollection = {
  __typename: 'PositionReportCollection';
  items: Array<PositionReport>;
  meta: PositionReportCollectionMetadata;
};

export type PositionReportCollectionMetadata = CollectionMetadata & {
  __typename: 'PositionReportCollectionMetadata';
  total: Scalars['Int'];
};

export enum PositionReportSource {
  GpsAuto = 'GpsAuto',
  GpsAutoAdsb = 'GpsAutoAdsb',
  GpsManual = 'GpsManual',
  Pilot = 'Pilot',
  TCS = 'TCS',
}

export type PositionReportSummary = {
  __typename: 'PositionReportSummary';
  id: Scalars['ID'];
  positionTime: Scalars['DateTime'];
  source: PositionReportSource;
};

export type PositionReportSummaryInput = {
  id: Scalars['ID'];
  positionTime: Scalars['DateTime'];
  source: PositionReportSource;
};

export type PreferredUnit = {
  __typename: 'PreferredUnit';
  id: Scalars['ID'];
  rank: Scalars['Int'];
  type: PreferredUnitType;
  unitAbbreviation: Scalars['String'];
};

export type PreferredUnitInput = {
  id: Scalars['ID'];
  rank: Scalars['Int'];
  type: PreferredUnitType;
  unitAbbreviation: Scalars['String'];
};

export enum PreferredUnitType {
  AgencyLocation = 'AgencyLocation',
  Unit = 'Unit',
}

export type Program = Entity &
  Evented & {
    __typename: 'Program';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    admin: Maybe<Person>;
    adminId: Maybe<Scalars['ID']>;
    bases: Array<ProgramBase>;
    code: Scalars['String'];
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    people: Maybe<Array<Maybe<Person>>>;
    trmUserPrograms: Array<TrmUserProgram>;
  };

export type Program_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ProgramBase = Entity &
  Evented & {
    __typename: 'ProgramBase';
    _events: MessageEnvelopeCollection;
    base: Base;
    baseId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    endTime: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    program: Program;
    programId: Scalars['ID'];
    startTime: Maybe<Scalars['DateTime']>;
  };

export type ProgramBase_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ProgramBaseCollection = {
  __typename: 'ProgramBaseCollection';
  items: Array<ProgramBase>;
  meta: ProgramBaseCollectionMetadata;
};

export type ProgramBaseCollectionMetadata = CollectionMetadata & {
  __typename: 'ProgramBaseCollectionMetadata';
  total: Scalars['Int'];
};

export type ProgramBaseFilter = {
  baseId: InputMaybe<Scalars['ID']>;
  programId: InputMaybe<Scalars['ID']>;
};

export type ProgramCollection = {
  __typename: 'ProgramCollection';
  items: Array<Program>;
  meta: ProgramCollectionMetadata;
};

export type ProgramCollectionMetadata = CollectionMetadata & {
  __typename: 'ProgramCollectionMetadata';
  total: Scalars['Int'];
};

export type ProgramFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type ProgramQueries = {
  __typename: 'ProgramQueries';
  all: ProgramCollection;
};

export type ProgramQueriesallArgs = {
  filter: InputMaybe<ProgramFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type PublicConfiguration = {
  __typename: 'PublicConfiguration';
  okta: Maybe<PublicOktaConfiguration>;
};

export type PublicOktaConfiguration = {
  __typename: 'PublicOktaConfiguration';
  clientId: Scalars['String'];
  tenantUrl: Scalars['String'];
};

export type Query = {
  __typename: 'Query';
  /** @deprecated Use regionGroups.all.meta instead */
  _allRegionGroupsMeta: QueryMeta;
  /** @deprecated Use regions.all.meta instead */
  _allRegionsMeta: QueryMeta;
  activationRules: ActivationRuleQueries;
  activeAlerts: ActiveAlertQueries;
  activeTimelines: ActiveTimelineQueries;
  agencies: AgencyQueries;
  agencyLocations: AgencyLocationQueries;
  /** @deprecated Use airports.byId instead */
  airportById: Maybe<Airport>;
  airports: AirportQueries;
  alerts: AlertQueries;
  /** @deprecated Use bases.all.items instead */
  allBases: Array<Base>;
  /** @deprecated Use companies.all.items instead */
  allCompanies: Array<Company>;
  /** @deprecated Use departments.all instead */
  allDepartments: Array<Department>;
  /** @deprecated Use locations.all instead */
  allLocations: Array<Location>;
  /** @deprecated Use programBases.all instead */
  allProgramBases: Array<ProgramBase>;
  /** @deprecated Use regionGroups.all instead */
  allRegionGroups: Array<RegionGroup>;
  /** @deprecated Use regions.all instead */
  allRegions: Array<Region>;
  /** @deprecated Use vehicleMakes.all instead */
  allVehicleMakes: Array<VehicleMake>;
  applicationNotifications: ApplicationNotificationQueries;
  archiveLogs: ArchiveLogQueries;
  attachments: AttachmentQueries;
  authenticatedIdentity: Person;
  baseControlZones: BaseControlZoneQueries;
  baseMedicalControlContacts: BaseMedicalControlContactQueries;
  bases: BaseQueries;
  cancellationCategories: CancellationCategoryQueries;
  cancellationReasons: CancellationReasonQueries;
  cancellationSecondaryReasons: CancellationSecondaryReasonQueries;
  capabilities: CapabilityQueries;
  cardLinks: CardLinkQueries;
  cardNoteArchives: CardNoteArchiveQueries;
  cardNotes: CardNoteQueries;
  cardReopenReasons: CardReopenReasonQueries;
  cards: CardQueries;
  communicationCenters: CommunicationCenterQueries;
  companies: CompanyQueries;
  completeFlightInstances: CompleteFlightInstanceQueries;
  configuration: PublicConfiguration;
  configurationSettings: ConfigurationSettingQueries;
  controlZones: ControlZoneQueries;
  declineCategories: DeclineCategoryQueries;
  declineReasons: DeclineReasonQueries;
  declineSecondaryReasons: DeclineSecondaryReasonQueries;
  diversionReasons: DiversionReasonQueries;
  entities: EntityQueries;
  entityCapabilities: EntityCapabilityQueries;
  externalActionTypes: ExternalActionTypeQueries;
  externalActions: ExternalActionQueries;
  externalReferences: ExternalReferenceQueries;
  facilityNonAcceptanceReasons: FacilityNonAcceptanceReasonQueries;
  fbos: FboQueries;
  firewallRules: FirewallRuleQueries;
  fueltanks: FuelTankQueries;
  gis: GisQueries;
  landingZoneOutOfServiceReasons: LandingZoneOutOfServiceReasonQueries;
  locationHazards: LocationHazardQueries;
  locations: LocationQueries;
  maintenanceFacilities: MaintenanceFacilityQueries;
  medicalFacilities: MedicalFacilityQueries;
  medicalFacilityContacts: MedicalFacilityContactQueries;
  newAgencyLocationRequests: NewAgencyLocationRequestQueries;
  nextDueTypes: NextDueTypeQueries;
  nonReferralReasons: NonReferralReasonQueries;
  notificationGroupMembers: NotificationGroupMemberQueries;
  notificationGroups: NotificationGroupQueries;
  notificationSubscriptions: NotificationSubscriptionQueries;
  notificationTemplates: NotificationTemplateQueries;
  notifications: NotificationQueries;
  offerAlgorithms: OfferAlgorithmQueries;
  okta: OktaQueries;
  /** @deprecated Use regionGroups.all instead */
  operationsRegionGroupByCompany: Maybe<RegionGroup>;
  outOfServiceEventNotes: OutOfServiceEventNoteQueries;
  outOfServiceEvents: OutOfServiceEventQueries;
  outOfServiceQARReasons: OutOfServiceQARReasonQueries;
  outOfServiceReasons: OutOfServiceReasonQueries;
  outOfServiceSecondaryReasons: OutOfServiceSecondaryReasonQueries;
  outOfServiceTickets: OutOfServiceTicketQueries;
  paipEvents: PaipEventQueries;
  paipReasons: PaipReasonQueries;
  passdownLogs: PassdownLogQueries;
  people: PersonQueries;
  physicians: PhysicianQueries;
  positionReportAlerts: PositionReportAlertQueries;
  positionReportArchives: PositionReportArchiveQueries;
  /** @deprecated Use programs.byId instead */
  programById: Maybe<Program>;
  programs: ProgramQueries;
  questionnaireResponses: QuestionnaireResponseQueries;
  questionnaires: QuestionnaireQueries;
  questions: QuestionQueries;
  ramcoVehicleConfigurations: RamcoVehicleConfigurationQueries;
  /** @deprecated Use regions.byId instead */
  regionById: Maybe<Region>;
  /** @deprecated Use regionGroups.byId instead */
  regionGroupById: Maybe<RegionGroup>;
  regionGroups: RegionGroupQueries;
  regions: RegionQueries;
  releaseNotes: ReleaseNoteQueries;
  requestLocations: RequestLocationQueries;
  requesterReferralReasons: RequesterReferralReasonQueries;
  requests: RequestQueries;
  specialtyTeamMembers: SpectialtyTeamMemberQueries;
  specialtyTeams: SpecialtyTeamQueries;
  states: StateQueries;
  supportRequests: SupportRequestQueries;
  timelineItems: TimelineItemQueries;
  timelines: TimelineQueries;
  timestampTypes: TimestampTypeQueries;
  timestamps: TimestampQueries;
  transferCenters: TransferCenterQueries;
  transferReasons: TransferReasonQueries;
  transportReasons: TransportReasonQueries;
  trmUsers: TrmUserQueries;
  unitActivationRules: UnitActivationRuleQueries;
  unitEMSystemMappings: UnitEMSystemMappingQueries;
  unitNotes: UnitNoteQueries;
  unitPositions: UnitPositionQueries;
  unitShifts: UnitShiftQueries;
  units: UnitQueries;
  userIdentity: Person;
  /** @deprecated Use vehicles.byId instead */
  vehicleById: Maybe<Vehicle>;
  vehicleConfigurationClasses: VehicleConfigurationClassQueries;
  vehicleControlZones: VehicleControlZoneQueries;
  vehicleModels: VehicleModelQueries;
  vehiclePositionSummary: vehcilePositionSummaryQueries;
  vehicles: VehicleQueries;
  waypoints: WaypointQueries;
  webOrderLogs: webOrderLogQueries;
};

export type QueryairportByIdArgs = {
  id: Scalars['ID'];
};

export type QueryallBasesArgs = {
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallCompaniesArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallDepartmentsArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallLocationsArgs = {
  filter: InputMaybe<LocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallProgramBasesArgs = {
  filter: InputMaybe<ProgramBaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallRegionGroupsArgs = {
  filter: InputMaybe<RegionGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallRegionsArgs = {
  filter: InputMaybe<RegionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QueryallVehicleMakesArgs = {
  filter: InputMaybe<VehicleFilter>;
};

export type QueryoperationsRegionGroupByCompanyArgs = {
  companyId: Scalars['ID'];
};

export type QueryprogramByIdArgs = {
  id: Scalars['ID'];
};

export type QueryregionByIdArgs = {
  id: Scalars['ID'];
};

export type QueryregionGroupByIdArgs = {
  id: Scalars['ID'];
};

export type QueryvehicleByIdArgs = {
  id: Scalars['ID'];
};

export type QueryMeta = {
  __typename: 'QueryMeta';
  count: Scalars['Int'];
};

export type Question = Entity &
  Evented & {
    __typename: 'Question';
    _events: MessageEnvelopeCollection;
    choices: Array<QuestionChoice>;
    dataType: Maybe<QuestionDataType>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    question: Scalars['String'];
    questionType: QuestionType;
    questionnaireSectionQuestions: Array<QuestionnaireSectionQuestion>;
  };

export type Question_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionChoice = Entity &
  Evented & {
    __typename: 'QuestionChoice';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    label: Scalars['String'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    question: Question;
    questionId: Scalars['ID'];
    value: Scalars['String'];
  };

export type QuestionChoice_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionChoiceCollection = {
  __typename: 'QuestionChoiceCollection';
  items: Array<QuestionChoice>;
  meta: QuestionChoiceCollectionMetadata;
};

export type QuestionChoiceCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionChoiceCollectionMetadata';
  total: Scalars['Int'];
};

export type QuestionCollection = {
  __typename: 'QuestionCollection';
  items: Array<Question>;
  meta: QuestionCollectionMetadata;
};

export type QuestionCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionCollectionMetadata';
  total: Scalars['Int'];
};

export enum QuestionDataType {
  Boolean = 'Boolean',
  Decimal = 'Decimal',
  Integer = 'Integer',
  String = 'String',
}

export type QuestionFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  questionLike: InputMaybe<Scalars['String']>;
};

export type QuestionQueries = {
  __typename: 'QuestionQueries';
  all: QuestionCollection;
  byId: Maybe<Question>;
};

export type QuestionQueriesallArgs = {
  filter: InputMaybe<QuestionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type QuestionResponseValueContainer = {
  __typename: 'QuestionResponseValueContainer';
  type: QuestionDataType;
  value: Scalars['String'];
};

export type QuestionResponseValueContainerInput = {
  type: QuestionDataType;
  value: Scalars['String'];
};

export enum QuestionType {
  Choice = 'Choice',
  FreeText = 'FreeText',
  YesNo = 'YesNo',
}

export type Questionnaire = Entity &
  Evented & {
    __typename: 'Questionnaire';
    _events: MessageEnvelopeCollection;
    communicationCenterId: Maybe<Scalars['ID']>;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    questionnaireResponses: Array<QuestionnaireResponse>;
    questionnaireSections: Array<QuestionnaireSection>;
    type: QuestionnaireType;
  };

export type Questionnaire_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireCollection = {
  __typename: 'QuestionnaireCollection';
  items: Array<Questionnaire>;
  meta: QuestionnaireCollectionMetadata;
};

export type QuestionnaireCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionnaireCollectionMetadata';
  total: Scalars['Int'];
};

export type QuestionnaireFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type QuestionnaireQueries = {
  __typename: 'QuestionnaireQueries';
  all: QuestionnaireCollection;
  byId: Maybe<Questionnaire>;
};

export type QuestionnaireQueriesallArgs = {
  filter: InputMaybe<QuestionnaireFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type QuestionnaireQuestionResponse = Entity &
  Evented & {
    __typename: 'QuestionnaireQuestionResponse';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    explanation: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    matchType: RuleMatchType;
    questionnaireQuestionResponseNotes: Array<QuestionnaireQuestionResponseNote>;
    questionnaireResponse: QuestionnaireResponse;
    questionnaireResponseId: Scalars['ID'];
    questionnaireSectionQuestion: QuestionnaireSectionQuestion;
    questionnaireSectionQuestionId: Scalars['ID'];
    responseValue: Maybe<Scalars['String']>;
    reviewRequired: Scalars['Boolean'];
  };

export type QuestionnaireQuestionResponse_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireQuestionResponseCollection = {
  __typename: 'QuestionnaireQuestionResponseCollection';
  items: Array<QuestionnaireQuestionResponse>;
  meta: QuestionnaireQuestionResponseCollectionMetadata;
};

export type QuestionnaireQuestionResponseCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionnaireQuestionResponseCollectionMetadata';
  total: Scalars['Int'];
};

export type QuestionnaireQuestionResponseNote = Entity &
  Evented & {
    __typename: 'QuestionnaireQuestionResponseNote';
    _events: MessageEnvelopeCollection;
    authorId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateAuthored: Scalars['DateTime'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    note: Scalars['String'];
    questionnaireQuestionResponse: QuestionnaireQuestionResponse;
    questionnaireQuestionResponseId: Scalars['ID'];
  };

export type QuestionnaireQuestionResponseNote_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireQuestionResponseNoteCollection = {
  __typename: 'QuestionnaireQuestionResponseNoteCollection';
  items: Array<QuestionnaireQuestionResponseNote>;
  meta: QuestionnaireQuestionResponseNoteCollectionMetadata;
};

export type QuestionnaireQuestionResponseNoteCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionnaireQuestionResponseNoteCollectionMetadata';
  total: Scalars['Int'];
};

export type QuestionnaireResponse = Entity &
  Evented & {
    __typename: 'QuestionnaireResponse';
    _events: MessageEnvelopeCollection;
    card: Card;
    cardId: Scalars['ID'];
    communicationsReviewById: Maybe<Scalars['ID']>;
    company: Company;
    companyId: Scalars['ID'];
    completedById: Maybe<Scalars['ID']>;
    currentReviewLevel: Maybe<UserRole>;
    dateCommunicationsReviewed: Maybe<Scalars['DateTime']>;
    dateCompleted: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateManagerReviewed: Maybe<Scalars['DateTime']>;
    dateSupervisorReviewed: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    managerReviewById: Maybe<Scalars['ID']>;
    questionnaire: Questionnaire;
    questionnaireId: Scalars['ID'];
    questionnaireQuestionResponses: Array<QuestionnaireQuestionResponse>;
    status: QuestionnaireResponseStatus;
    supervisorReviewById: Maybe<Scalars['ID']>;
  };

export type QuestionnaireResponse_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireResponseCollection = {
  __typename: 'QuestionnaireResponseCollection';
  items: Array<QuestionnaireResponse>;
  meta: QuestionnaireResponseCollectionMetadata;
};

export type QuestionnaireResponseCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionnaireResponseCollectionMetadata';
  total: Scalars['Int'];
};

export type QuestionnaireResponseFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  questionnaireResponseStatuses: InputMaybe<Array<QuestionnaireResponseStatus>>;
  userRoles: InputMaybe<Array<UserRole>>;
};

export type QuestionnaireResponseQueries = {
  __typename: 'QuestionnaireResponseQueries';
  all: QuestionnaireResponseCollection;
  byId: Maybe<QuestionnaireResponse>;
};

export type QuestionnaireResponseQueriesallArgs = {
  filter: InputMaybe<QuestionnaireResponseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireResponseQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum QuestionnaireResponseStatus {
  AwaitingReview = 'AwaitingReview',
  Completed = 'Completed',
  Draft = 'Draft',
  NotStarted = 'NotStarted',
}

export type QuestionnaireSection = Entity &
  Evented & {
    __typename: 'QuestionnaireSection';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    questionnaire: Questionnaire;
    questionnaireId: Scalars['ID'];
    questionnaireSectionQuestions: Array<QuestionnaireSectionQuestion>;
    sequence: Scalars['Int'];
  };

export type QuestionnaireSection_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireSectionCollection = {
  __typename: 'QuestionnaireSectionCollection';
  items: Array<QuestionnaireSection>;
  meta: QuestionnaireSectionCollectionMetadata;
};

export type QuestionnaireSectionCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionnaireSectionCollectionMetadata';
  total: Scalars['Int'];
};

export type QuestionnaireSectionQuestion = Entity &
  Evented & {
    __typename: 'QuestionnaireSectionQuestion';
    _events: MessageEnvelopeCollection;
    activationRule: Maybe<ActivationRule>;
    activationRuleId: Maybe<Scalars['ID']>;
    activityType: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    explanationRequiredChoices: Maybe<Array<Maybe<IdListItem>>>;
    id: Scalars['ID'];
    isDisabled: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    question: Question;
    questionId: Scalars['ID'];
    questionnaireQuestionResponses: Array<QuestionnaireQuestionResponse>;
    questionnaireSection: QuestionnaireSection;
    questionnaireSectionId: Scalars['ID'];
    responsibleRole: UserRole;
    reviewRequiredChoices: Maybe<Array<Maybe<IdListItem>>>;
    sequence: Scalars['Int'];
  };

export type QuestionnaireSectionQuestion_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireSectionQuestionCollection = {
  __typename: 'QuestionnaireSectionQuestionCollection';
  items: Array<QuestionnaireSectionQuestion>;
  meta: QuestionnaireSectionQuestionCollectionMetadata;
};

export type QuestionnaireSectionQuestionCollectionMetadata = CollectionMetadata & {
  __typename: 'QuestionnaireSectionQuestionCollectionMetadata';
  total: Scalars['Int'];
};

export enum QuestionnaireType {
  QualityAssurance = 'QualityAssurance',
}

export type RamcoVehicleConfiguration = Entity &
  Evented & {
    __typename: 'RamcoVehicleConfiguration';
    _events: MessageEnvelopeCollection;
    companyCode: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    maintenanceSystemId: Scalars['String'];
    modelNumber: Scalars['String'];
    tailNumber: Scalars['String'];
  };

export type RamcoVehicleConfiguration_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RamcoVehicleConfigurationCollection = {
  __typename: 'RamcoVehicleConfigurationCollection';
  items: Array<RamcoVehicleConfiguration>;
  meta: RamcoVehicleConfigurationCollectionMetadata;
};

export type RamcoVehicleConfigurationCollectionMetadata = CollectionMetadata & {
  __typename: 'RamcoVehicleConfigurationCollectionMetadata';
  total: Scalars['Int'];
};

export type RamcoVehicleConfigurationQueries = {
  __typename: 'RamcoVehicleConfigurationQueries';
  byTailNumber: Maybe<RamcoVehicleConfiguration>;
};

export type RamcoVehicleConfigurationQueriesbyTailNumberArgs = {
  tailNumber: Scalars['String'];
};

export type ReOpenCard = {
  cardId: Scalars['ID'];
  reOpenComment: Scalars['String'];
  reOpenReasonId: InputMaybe<Scalars['ID']>;
};

export type ReSendToDataWarehouse = {
  cardId: Scalars['ID'];
};

export type ReactivateRequest = {
  id: Scalars['ID'];
};

export type ReactivateRequestFromTransferCenter = {
  id: Scalars['ID'];
};

export type ReassignVehicle = {
  newUnitId: Scalars['ID'];
  oldUnitId: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type RecalculateCandidates = {
  referralUnitId: InputMaybe<Scalars['ID']>;
  requestId: Scalars['ID'];
};

export type RecalculateTripMileage = {
  tripId: Scalars['ID'];
};

export type ReceivingFacilityRequest = Entity &
  Evented & {
    __typename: 'ReceivingFacilityRequest';
    _events: MessageEnvelopeCollection;
    card: Card;
    cardId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalFacility: MedicalFacility;
    medicalFacilityId: Scalars['ID'];
    nonAcceptanceReason: Maybe<FacilityNonAcceptanceReason>;
    nonAcceptanceReasonId: Maybe<Scalars['ID']>;
    nonAcceptanceType: Maybe<NonAcceptanceType>;
    referredToFacility: Maybe<MedicalFacility>;
    referredToFacilityId: Maybe<Scalars['ID']>;
    request: Request;
    requestId: Scalars['ID'];
    requestLocation: RequestLocation;
    requestLocationId: Scalars['ID'];
    status: ReceivingFacilityRequestStatus;
  };

export type ReceivingFacilityRequest_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ReceivingFacilityRequestCollection = {
  __typename: 'ReceivingFacilityRequestCollection';
  items: Array<ReceivingFacilityRequest>;
  meta: ReceivingFacilityRequestCollectionMetadata;
};

export type ReceivingFacilityRequestCollectionMetadata = CollectionMetadata & {
  __typename: 'ReceivingFacilityRequestCollectionMetadata';
  total: Scalars['Int'];
};

export enum ReceivingFacilityRequestStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Diverted = 'Diverted',
  Pending = 'Pending',
}

export type Recipient = {
  __typename: 'Recipient';
  address: Scalars['String'];
  groupTypes: Maybe<Array<Maybe<NotificationGroupType>>>;
  name: Maybe<Scalars['String']>;
  notificationRecipientId: Maybe<Scalars['ID']>;
  positionType: Maybe<UnitPositionType>;
  userId: Maybe<Scalars['ID']>;
};

export type RecipientInput = {
  address: Scalars['String'];
  groupTypes: InputMaybe<Array<InputMaybe<NotificationGroupType>>>;
  name: InputMaybe<Scalars['String']>;
  notificationRecipientId: InputMaybe<Scalars['ID']>;
  positionType: InputMaybe<UnitPositionType>;
  userId: InputMaybe<Scalars['ID']>;
};

export type ReferReceivingFacilityRequest = {
  id: Scalars['ID'];
  nonAcceptanceReasonId: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  referredToFacilityId: Scalars['ID'];
  time: Scalars['DateTime'];
};

export type ReferTransportOffer = {
  id: Scalars['ID'];
};

export type RefreshLocationsFromGMRWorkday = {
  changesOnly: InputMaybe<Scalars['Boolean']>;
  locationFilter: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RefreshPeopleFromGMRWorkdayV2 = {
  changesOnly: InputMaybe<Scalars['Boolean']>;
  employeeIdFilter: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeEmployeeIdFilter: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Region = Entity &
  Evented & {
    __typename: 'Region';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    activeAlerts: Maybe<Array<Maybe<ActiveAlert>>>;
    applicationNotifications: Maybe<Array<Maybe<ApplicationNotification>>>;
    bases: Array<RegionBase>;
    cardSummaries: Array<CardSummary>;
    communicationCenter: CommunicationCenter;
    communicationCenterId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dispatchNumber: Maybe<Scalars['String']>;
    emSystemDivisionName: Maybe<Scalars['String']>;
    etcInMinutes: Maybe<Scalars['Int']>;
    fixedWingPreferredThresholdInNauticalMiles: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    isTransferCenterRegion: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    notificationGroups: Maybe<Array<Maybe<NotificationGroup>>>;
    paipEvents: Maybe<Array<Maybe<PaipEvent>>>;
    passdownLogs: Array<PassdownLog>;
    regionGroup: RegionGroup;
    regionGroupId: Scalars['ID'];
    requests: Maybe<Array<Maybe<Request>>>;
    timezoneCd: Maybe<Scalars['String']>;
    unitSummaries: Array<UnitSummary>;
    units: Array<Unit>;
  };

export type Region_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RegionBase = Entity &
  Evented & {
    __typename: 'RegionBase';
    _events: MessageEnvelopeCollection;
    base: Base;
    baseId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    region: Region;
    regionId: Scalars['ID'];
  };

export type RegionBase_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RegionBaseCollection = {
  __typename: 'RegionBaseCollection';
  items: Array<RegionBase>;
  meta: RegionBaseCollectionMetadata;
};

export type RegionBaseCollectionMetadata = CollectionMetadata & {
  __typename: 'RegionBaseCollectionMetadata';
  total: Scalars['Int'];
};

export type RegionCollection = {
  __typename: 'RegionCollection';
  items: Array<Region>;
  meta: RegionCollectionMetadata;
};

export type RegionCollectionMetadata = CollectionMetadata & {
  __typename: 'RegionCollectionMetadata';
  total: Scalars['Int'];
};

export type RegionFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  companyIdList: InputMaybe<Array<Scalars['ID']>>;
  regionGroupId: InputMaybe<Scalars['ID']>;
};

export type RegionGroup = Entity &
  Evented & {
    __typename: 'RegionGroup';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    department: Department;
    departmentId: Scalars['ID'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    regions: Array<Region>;
  };

export type RegionGroup_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RegionGroupCollection = {
  __typename: 'RegionGroupCollection';
  items: Array<RegionGroup>;
  meta: RegionGroupCollectionMetadata;
};

export type RegionGroupCollectionMetadata = CollectionMetadata & {
  __typename: 'RegionGroupCollectionMetadata';
  total: Scalars['Int'];
};

export type RegionGroupFilter = {
  companyId: InputMaybe<Scalars['ID']>;
};

export type RegionGroupQueries = {
  __typename: 'RegionGroupQueries';
  all: RegionGroupCollection;
  byId: Maybe<RegionGroup>;
};

export type RegionGroupQueriesallArgs = {
  filter: InputMaybe<RegionGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RegionGroupQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type RegionQueries = {
  __typename: 'RegionQueries';
  all: RegionCollection;
  byId: Maybe<Region>;
};

export type RegionQueriesallArgs = {
  filter: InputMaybe<RegionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RegionQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type RegisterTrmUser = {
  additionalProgramIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  agencyIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId: Scalars['ID'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  medicalFacilityIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumber: Scalars['String'];
  preferredProgramId: Scalars['ID'];
};

export type ReleaseNote = Entity &
  Evented & {
    __typename: 'ReleaseNote';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    description: Scalars['String'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    releaseDate: Maybe<Scalars['DateTime']>;
    releaseNumber: Scalars['String'];
  };

export type ReleaseNote_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ReleaseNoteCollection = {
  __typename: 'ReleaseNoteCollection';
  items: Array<ReleaseNote>;
  meta: ReleaseNoteCollectionMetadata;
};

export type ReleaseNoteCollectionMetadata = CollectionMetadata & {
  __typename: 'ReleaseNoteCollectionMetadata';
  total: Scalars['Int'];
};

export type ReleaseNoteFilter = {
  id: InputMaybe<Scalars['ID']>;
  releaseNumber: InputMaybe<Scalars['String']>;
};

export type ReleaseNoteQueries = {
  __typename: 'ReleaseNoteQueries';
  all: ReleaseNoteCollection;
  byId: Maybe<ReleaseNote>;
};

export type ReleaseNoteQueriesallArgs = {
  filter: InputMaybe<ReleaseNoteFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type ReleaseNoteQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type ReloadSummaryViews = {
  view: SummaryView;
};

export type RemoveBaseAdditionalCompany = {
  baseId: Scalars['ID'];
  companyId: Scalars['ID'];
};

export type RemoveCrewMemberFromOutOfCompliance = {
  id: Scalars['ID'];
};

export type RemoveDelayFromUnit = {
  id: Scalars['ID'];
};

export type RemovePersonAdditionalCompany = {
  companyId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type RemoveTeamMemberFromUnitPosition = {
  id: Scalars['ID'];
};

export type RemoveVehicleFromUnit = {
  id: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type RemoveWaypoint = {
  tripId: Scalars['ID'];
  waypointId: Scalars['ID'];
};

export type RendezvousRequest = Entity &
  Evented & {
    __typename: 'RendezvousRequest';
    _events: MessageEnvelopeCollection;
    agencyEta: Maybe<Scalars['DateTime']>;
    agencyLocation: Maybe<AgencyLocation>;
    agencyLocationId: Maybe<Scalars['ID']>;
    arrivedDestAt: Maybe<Scalars['DateTime']>;
    arrivedLzAt: Maybe<Scalars['DateTime']>;
    cancelledAt: Maybe<Scalars['DateTime']>;
    cardLinks: Maybe<Array<Maybe<CardLink>>>;
    companyId: Scalars['ID'];
    confirmedAt: Maybe<Scalars['DateTime']>;
    contactInformation: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    departedDestAt: Maybe<Scalars['DateTime']>;
    departedLzAt: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    latestStatus: Maybe<Scalars['String']>;
    latestStatusTimestamp: Maybe<Scalars['DateTime']>;
    notes: Maybe<Scalars['String']>;
    rendezvousLocationDescription: Maybe<Scalars['String']>;
    requestLocation: RequestLocation;
    requestLocationId: Scalars['ID'];
    transportUnitNumber: Maybe<Scalars['String']>;
    type: SupplementalLegType;
    utilizationStatus: AmrUtilizationStatus;
  };

export type RendezvousRequest_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RendezvousRequestCollection = {
  __typename: 'RendezvousRequestCollection';
  items: Array<RendezvousRequest>;
  meta: RendezvousRequestCollectionMetadata;
};

export type RendezvousRequestCollectionMetadata = CollectionMetadata & {
  __typename: 'RendezvousRequestCollectionMetadata';
  total: Scalars['Int'];
};

export type RepositionUnit = {
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  destinationAddress: AddressInput;
  destinationLocationId: InputMaybe<Scalars['ID']>;
  destinationTimezoneCd: InputMaybe<Scalars['String']>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  returnUnitToPost: InputMaybe<Scalars['Boolean']>;
  unitId: Scalars['ID'];
};

export type Request = Entity &
  Evented & {
    __typename: 'Request';
    _events: MessageEnvelopeCollection;
    assignmentDelayedReason: Maybe<AssignmentDelayedReason>;
    assignmentDelayedReasonId: Maybe<Scalars['ID']>;
    assignmentDelayedTime: Maybe<Scalars['DateTime']>;
    atloInMinutes: Maybe<Scalars['Int']>;
    cancellationReason: Maybe<CancellationReason>;
    cancellationReasonId: Maybe<Scalars['ID']>;
    cancellationReasonNotes: Maybe<Scalars['String']>;
    cancellationSecondaryReason: Maybe<CancellationSecondaryReason>;
    cancellationSecondaryReasonId: Maybe<Scalars['ID']>;
    card: Card;
    commitUnitToStandby: Maybe<Scalars['Boolean']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    escortRequests: Array<EscortRequest>;
    etloInMinutes: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    includeCompetitors: Maybe<Scalars['Boolean']>;
    initiationType: Maybe<RequestInitiationType>;
    isStandbyRequest: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    latestWeatherDeclineReasonId: Maybe<Scalars['ID']>;
    latestWeatherDeclineSecondaryReasonId: Maybe<Scalars['ID']>;
    latestWeatherDeclineTime: Maybe<Scalars['DateTime']>;
    latestWeatherDeclineUnitId: Maybe<Scalars['ID']>;
    locations: Array<RequestLocation>;
    minimumFlightRule: Maybe<FlightRule>;
    missionConfiguration: MissionConfiguration;
    missionProfile: MissionProfile;
    patients: Array<RequestPatient>;
    primaryUnitServiceArea: Maybe<Unit>;
    primaryUnitServiceAreaId: Maybe<Scalars['ID']>;
    receivingFacilityRequests: Array<ReceivingFacilityRequest>;
    region: Maybe<Region>;
    regionId: Maybe<Scalars['ID']>;
    requestedOperationType: OperationType;
    requestedVehicleType: Maybe<VehicleType>;
    requester: Maybe<Requester>;
    requiredCapabilities: Array<RequiredCapability>;
    safetyQuestions: SafetyQuestions;
    standbyActivationRequested: Scalars['Boolean'];
    status: RequestStatus;
    timestamps: Maybe<Array<Maybe<Timestamp>>>;
    transportOfferAlgorithm: Maybe<TransportOfferAlgorithm>;
    transportOfferAlgorithmId: Maybe<Scalars['ID']>;
    transportOfferOptions: Array<TransportOfferOption>;
    transportOffers: Array<TransportOffer>;
    transportTrackingLink: Maybe<Scalars['String']>;
    webOrderCallType: Maybe<WebOrderCallType>;
  };

export type Request_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequestAdditionalUnits = {
  cardId: Scalars['ID'];
  unitCount: Scalars['Int'];
};

export type RequestCollection = {
  __typename: 'RequestCollection';
  items: Array<Request>;
  meta: RequestCollectionMetadata;
};

export type RequestCollectionMetadata = CollectionMetadata & {
  __typename: 'RequestCollectionMetadata';
  total: Scalars['Int'];
};

export enum RequestInitiationType {
  Phone = 'Phone',
  Rapid = 'Rapid',
  Standard = 'Standard',
  WebOrder = 'WebOrder',
}

export type RequestLocation = Entity &
  Evented & {
    __typename: 'RequestLocation';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    address: Address;
    /** @deprecated No longer used */
    bedNumber: Maybe<Scalars['String']>;
    companyId: Scalars['ID'];
    confirmedByUserId: Maybe<Scalars['ID']>;
    dateConfirmed: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    diversionReason: Maybe<DiversionReason>;
    diversionReasonId: Maybe<Scalars['ID']>;
    diversionReasonOtherNotes: Maybe<Scalars['String']>;
    estimatedGroundTimeInMinutes: Maybe<Scalars['Int']>;
    estimatedRendezvousTimeInMinutes: Maybe<Scalars['Int']>;
    fbo: Maybe<Fbo>;
    fboId: Maybe<Scalars['ID']>;
    groundContact: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isAutoAccepted: Maybe<Scalars['Boolean']>;
    isRotorWingLz: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    locationId: Maybe<Scalars['ID']>;
    medicalFacility: Maybe<MedicalFacility>;
    medicalFacilityId: Maybe<Scalars['ID']>;
    medicalFacilityUnit: Maybe<MedicalFacilityUnit>;
    medicalFacilityUnitId: Maybe<Scalars['ID']>;
    /** @deprecated Use medicalFacilityUnit */
    medicalUnit: Maybe<MedicalUnit>;
    /** @deprecated Use medicalFacilityUnit */
    medicalUnitId: Maybe<Scalars['ID']>;
    /** @deprecated Use medicalFacilityUnit */
    medicalUnitName: Maybe<Scalars['String']>;
    name: Scalars['String'];
    notes: Maybe<Scalars['String']>;
    physician: Maybe<Physician>;
    physicianId: Maybe<Scalars['ID']>;
    physicianName: Maybe<Scalars['String']>;
    receivingFacilityRequests: Array<ReceivingFacilityRequest>;
    rendezvousRequests: Array<RendezvousRequest>;
    request: Request;
    requestId: Scalars['ID'];
    roomNumber: Maybe<Scalars['String']>;
    timezoneCd: Maybe<Scalars['String']>;
    type: WaypointType;
    unConfirmed: Maybe<Scalars['Boolean']>;
  };

export type RequestLocation_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequestLocationCollection = {
  __typename: 'RequestLocationCollection';
  items: Array<RequestLocation>;
  meta: RequestLocationCollectionMetadata;
};

export type RequestLocationCollectionMetadata = CollectionMetadata & {
  __typename: 'RequestLocationCollectionMetadata';
  total: Scalars['Int'];
};

export type RequestLocationFilter = {
  companyId: InputMaybe<Scalars['String']>;
  requestId: InputMaybe<Scalars['String']>;
};

export type RequestLocationQueries = {
  __typename: 'RequestLocationQueries';
  all: RequestLocationCollection;
};

export type RequestLocationQueriesallArgs = {
  filter: InputMaybe<RequestLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequestLocationSummary = {
  __typename: 'RequestLocationSummary';
  abbreviation: Scalars['String'];
  address: Maybe<Address>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: WaypointType;
};

export type RequestLocationSummaryInput = {
  abbreviation: Scalars['String'];
  address: InputMaybe<AddressInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: WaypointType;
};

export type RequestPatient = Entity &
  Evented & {
    __typename: 'RequestPatient';
    _events: MessageEnvelopeCollection;
    bpDiastolic: Maybe<Scalars['Int']>;
    bpSystolic: Maybe<Scalars['Int']>;
    chiefComplaintNotes: Maybe<Scalars['String']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateOfBirth: Maybe<Scalars['DateTime']>;
    estimatedAgeInHours: Maybe<Scalars['Float']>;
    firstName: Maybe<Scalars['String']>;
    gcs: Maybe<Scalars['Int']>;
    gender: Gender;
    heartRate: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    isIntubated: Maybe<Scalars['Boolean']>;
    isIsolette: Scalars['Boolean'];
    isoletteNotes: Maybe<Scalars['String']>;
    isoletteType: Maybe<IsoletteType>;
    lastName: Maybe<Scalars['String']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalRecordNumber: Maybe<Scalars['String']>;
    notes: Maybe<Scalars['String']>;
    numberOfDrips: Maybe<Scalars['Int']>;
    oxygenSaturation: Maybe<Scalars['Float']>;
    patient: Maybe<Patient>;
    patientId: Maybe<Scalars['ID']>;
    request: Request;
    requestId: Scalars['ID'];
    respiratoryRate: Maybe<Scalars['Float']>;
    rideAlongDateOfBirth: Maybe<Scalars['DateTime']>;
    rideAlongName: Maybe<Scalars['String']>;
    rideAlongRequested: Maybe<YesNoType>;
    rideAlongWeightInKg: Maybe<Scalars['Float']>;
    specialtyEquipment: Maybe<Scalars['String']>;
    temperatureInCelsius: Maybe<Scalars['Float']>;
    transferReason: Maybe<TransferReason>;
    transferReasonId: Maybe<Scalars['ID']>;
    transportReason: Maybe<TransportReason>;
    transportReasonCategory: Maybe<TransportReasonCategory>;
    transportReasonId: Maybe<Scalars['ID']>;
    weightInKg: Maybe<Scalars['Float']>;
  };

export type RequestPatient_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequestPatientCollection = {
  __typename: 'RequestPatientCollection';
  items: Array<RequestPatient>;
  meta: RequestPatientCollectionMetadata;
};

export type RequestPatientCollectionMetadata = CollectionMetadata & {
  __typename: 'RequestPatientCollectionMetadata';
  total: Scalars['Int'];
};

export type RequestPatientSummary = {
  __typename: 'RequestPatientSummary';
  dateCreated: Maybe<Scalars['DateTime']>;
  dateOfBirth: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  weightInKg: Maybe<Scalars['Float']>;
};

export type RequestPatientSummaryInput = {
  dateCreated: InputMaybe<Scalars['DateTime']>;
  dateOfBirth: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type RequestPublicRelationFromUnit = {
  address: InputMaybe<AddressInput>;
  locationId: InputMaybe<Scalars['ID']>;
  requestedVehicleType: InputMaybe<VehicleType>;
  unitId: Scalars['ID'];
};

export type RequestQueries = {
  __typename: 'RequestQueries';
  allAssignmentDelayedReasons: Array<AssignmentDelayedReason>;
  /** @deprecated Use cancellationReasons.all.items instead */
  allCancellationReasons: Array<CancellationReason>;
  allUnitCancellationReasons: Array<CancellationReason>;
};

export type RequestQueriesallAssignmentDelayedReasonsArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequestQueriesallCancellationReasonsArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequestQueriesallUnitCancellationReasonsArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum RequestStatus {
  Assigned = 'Assigned',
  AssignmentDelayed = 'AssignmentDelayed',
  CallReceived = 'CallReceived',
  Cancelled = 'Cancelled',
  Offered = 'Offered',
  Offering = 'Offering',
}

export type RequestSummary = {
  __typename: 'RequestSummary';
  assignmentDelayedReason: Maybe<Scalars['String']>;
  assignmentDelayedTime: Maybe<Scalars['DateTime']>;
  from: Maybe<RequestLocationSummary>;
  id: Scalars['ID'];
  isSisterCompanyReferral: Scalars['Boolean'];
  isStandbyRequest: Scalars['Boolean'];
  latestWeatherDeclineReasonId: Maybe<Scalars['ID']>;
  latestWeatherDeclineSecondaryReasonId: Maybe<Scalars['ID']>;
  latestWeatherDeclineTime: Maybe<Scalars['DateTime']>;
  latestWeatherDeclineUnitId: Maybe<Scalars['ID']>;
  requester: Maybe<RequesterSummary>;
  standbyActivationRequested: Scalars['Boolean'];
  status: RequestStatus;
  to: Maybe<RequestLocationSummary>;
  transportTrackingLink: Maybe<Scalars['String']>;
};

export type RequestSummaryInput = {
  assignmentDelayedReason: InputMaybe<Scalars['String']>;
  assignmentDelayedTime: InputMaybe<Scalars['DateTime']>;
  from: InputMaybe<RequestLocationSummaryInput>;
  id: Scalars['ID'];
  isSisterCompanyReferral: Scalars['Boolean'];
  isStandbyRequest: Scalars['Boolean'];
  latestWeatherDeclineReasonId: InputMaybe<Scalars['ID']>;
  latestWeatherDeclineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  latestWeatherDeclineTime: InputMaybe<Scalars['DateTime']>;
  latestWeatherDeclineUnitId: InputMaybe<Scalars['ID']>;
  requester: InputMaybe<RequesterSummaryInput>;
  standbyActivationRequested: Scalars['Boolean'];
  status: RequestStatus;
  to: InputMaybe<RequestLocationSummaryInput>;
  transportTrackingLink: InputMaybe<Scalars['String']>;
};

export type Requester = Entity &
  Evented & {
    __typename: 'Requester';
    _events: MessageEnvelopeCollection;
    affiliationType: Maybe<AffiliationType>;
    agencyLocation: Maybe<AgencyLocation>;
    agencyLocationId: Maybe<Scalars['ID']>;
    agencyLocationName: Maybe<Scalars['String']>;
    callbackNumber: Maybe<Scalars['String']>;
    caller: Maybe<Scalars['String']>;
    careLevelRequested: Maybe<CareLevel>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    email: Maybe<Scalars['String']>;
    facility: Maybe<MedicalFacility>;
    facilityId: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    isDoublePatient: Maybe<Scalars['Boolean']>;
    isNewAgencyLocation: Maybe<Scalars['Boolean']>;
    isWingToWing: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    missionRole: Maybe<MissionRoleType>;
    referralReason: Maybe<RequesterReferralReason>;
    referralReasonId: Maybe<Scalars['ID']>;
    referringAgencyLocation: Maybe<AgencyLocation>;
    referringAgencyLocationId: Maybe<Scalars['ID']>;
    referringCompany: Maybe<Company>;
    referringCompanyId: Maybe<Scalars['ID']>;
    referringRecordNumber: Maybe<Scalars['String']>;
    request: Maybe<Request>;
    requestId: Maybe<Scalars['ID']>;
    role: Maybe<RequesterRole>;
    roleId: Maybe<Scalars['ID']>;
    specialtyTeam: Maybe<SpecialtyTeam>;
    specialtyTeamId: Maybe<Scalars['ID']>;
    specialtyTeamMembers: Array<IdListItem>;
    specialtyTeamNotes: Maybe<Scalars['String']>;
    transferCenter: Maybe<TransferCenter>;
    transferCenterId: Maybe<Scalars['ID']>;
    transferCenterNotes: Maybe<Scalars['String']>;
    transportingAgencyLocation: Maybe<AgencyLocation>;
    transportingAgencyLocationId: Maybe<Scalars['ID']>;
    vetNumber: Maybe<Scalars['String']>;
  };

export type Requester_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequesterCollection = {
  __typename: 'RequesterCollection';
  items: Array<Requester>;
  meta: RequesterCollectionMetadata;
};

export type RequesterCollectionMetadata = CollectionMetadata & {
  __typename: 'RequesterCollectionMetadata';
  total: Scalars['Int'];
};

export type RequesterReferralReason = Entity &
  Evented & {
    __typename: 'RequesterReferralReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requesters: Maybe<Array<Maybe<Requester>>>;
  };

export type RequesterReferralReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequesterReferralReasonCollection = {
  __typename: 'RequesterReferralReasonCollection';
  items: Array<RequesterReferralReason>;
  meta: RequesterReferralReasonCollectionMetadata;
};

export type RequesterReferralReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'RequesterReferralReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type RequesterReferralReasonQueries = {
  __typename: 'RequesterReferralReasonQueries';
  all: RequesterReferralReasonCollection;
};

export type RequesterRole = Entity &
  Evented & {
    __typename: 'RequesterRole';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requesters: Maybe<Array<Maybe<Requester>>>;
  };

export type RequesterRole_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type RequesterRoleCollection = {
  __typename: 'RequesterRoleCollection';
  items: Array<RequesterRole>;
  meta: RequesterRoleCollectionMetadata;
};

export type RequesterRoleCollectionMetadata = CollectionMetadata & {
  __typename: 'RequesterRoleCollectionMetadata';
  total: Scalars['Int'];
};

export type RequesterSummary = {
  __typename: 'RequesterSummary';
  id: Scalars['ID'];
  missionRole: MissionRoleType;
  vetNumber: Maybe<Scalars['String']>;
};

export type RequesterSummaryInput = {
  id: Scalars['ID'];
  missionRole: MissionRoleType;
  vetNumber: InputMaybe<Scalars['String']>;
};

export type RequiredCapability = {
  __typename: 'RequiredCapability';
  id: Scalars['ID'];
};

export type RequiredCapabilityIdList = {
  __typename: 'RequiredCapabilityIdList';
  id: Scalars['ID'];
};

export type RequiredCapabilityIdListInput = {
  id: Scalars['ID'];
};

export type RequiredCapabilityInput = {
  id: Scalars['ID'];
};

export type ResetPassword = {
  id: Scalars['ID'];
};

export type ReturnUnitToService = {
  unitId: Scalars['ID'];
};

export type ReviewSubmittedOutOfServiceTicket = {
  address: InputMaybe<AddressInput>;
  alternatePOC: InputMaybe<Scalars['String']>;
  assignedBaseId: InputMaybe<Scalars['ID']>;
  businessUnitCompanyId: InputMaybe<Scalars['ID']>;
  ertsDateTime: Scalars['DateTime'];
  humanErrorDamageType: InputMaybe<HumanErrorDamageType>;
  id: Scalars['ID'];
  isAMTAvailable: InputMaybe<Scalars['Boolean']>;
  isBirdStrike: Scalars['Boolean'];
  isFAR135415Reportable: InputMaybe<Scalars['Boolean']>;
  isFAR135417Reportable: InputMaybe<Scalars['Boolean']>;
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  isPatientOnboard: Scalars['Boolean'];
  isPlanned: Scalars['Boolean'];
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  maintenanceLocation: InputMaybe<Scalars['String']>;
  maintenanceTypes: Array<OosTicketMaintenanceType>;
  mxDuringPeakTimeReason: InputMaybe<Scalars['String']>;
  opportunityMXTypes: InputMaybe<Array<InputMaybe<OpportunityMXType>>>;
  outOfServiceTime: Scalars['DateTime'];
  outOfServiceType: InputMaybe<OutOfServiceType>;
  pointOfContactId: InputMaybe<Scalars['ID']>;
  primaryReasonId: InputMaybe<Scalars['ID']>;
  qarReasons: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  rtsDelayReasonTypes: InputMaybe<Array<InputMaybe<RtsDelayReasonType>>>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  spareVehicleId: InputMaybe<Scalars['ID']>;
  ticketDescription: Scalars['String'];
  vehicleId: Scalars['ID'];
  waitingForParts: Scalars['Boolean'];
  waitingForTooling: Scalars['Boolean'];
};

export enum RtsDelayReasonType {
  PilotAvailability = 'PilotAvailability',
  Weather = 'Weather',
}

export enum RuleMatchType {
  DropoffLocation = 'DropoffLocation',
  PickupLocation = 'PickupLocation',
  Unspecified = 'Unspecified',
}

export type SafetyQuestions = {
  __typename: 'SafetyQuestions';
  otherServiceDeclined: Maybe<Scalars['Boolean']>;
  otherServiceDescription: Maybe<Scalars['String']>;
  otherServiceResponseDescription: Maybe<Scalars['String']>;
  otherServicesAreRespondingToTransferring: Maybe<Scalars['Boolean']>;
};

export type SafetyQuestionsInput = {
  otherServiceDeclined: InputMaybe<Scalars['Boolean']>;
  otherServiceDescription: InputMaybe<Scalars['String']>;
  otherServiceResponseDescription: InputMaybe<Scalars['String']>;
  otherServicesAreRespondingToTransferring: InputMaybe<Scalars['Boolean']>;
};

export type ScanForFlights = {
  originLatitude: Scalars['Float'];
  originLongitude: Scalars['Float'];
  radiusInNauticalMiles: Scalars['Int'];
};

export type SendMessage = {
  body: Scalars['String'];
  doNotDivert: InputMaybe<Scalars['Boolean']>;
  fromAddress: InputMaybe<Scalars['String']>;
  fromName: InputMaybe<Scalars['String']>;
  medium: InputMaybe<MessageTransport>;
  recipientAddress: Scalars['String'];
  recipientName: InputMaybe<Scalars['String']>;
  referenceNumber: InputMaybe<Scalars['String']>;
  subject: InputMaybe<Scalars['String']>;
};

export type SendNoteToCard = {
  cardNoteId: Scalars['ID'];
  toCardId: Scalars['ID'];
};

export type SendNotification = {
  notificationId: Scalars['ID'];
};

export type SendPatientInfo = {
  cardId: Scalars['ID'];
};

export type SendSupportRequestEmail = {
  supportRequestId: Scalars['ID'];
};

export type SendToImageTrend = {
  cardId: Scalars['ID'];
};

export type SetCardLockStatus = {
  cardId: Scalars['ID'];
  isLocked: Scalars['Boolean'];
};

export type SetRoleScope = {
  entities: Array<EntityRefInput>;
  global: Scalars['Boolean'];
  personId: Scalars['ID'];
  userRole: UserRole;
};

export type SetSupportRequestState = {
  notes: InputMaybe<Scalars['String']>;
  status: SupportRequestStatus;
  supportRequestId: Scalars['ID'];
};

export type SetVehicleControlZoneId = {
  controlZoneId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type SkipTransportOffer = {
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  skipReasonId: InputMaybe<Scalars['ID']>;
  skipSecondaryReasonId: InputMaybe<Scalars['ID']>;
};

export type SnoozeAlert = {
  activeAlertId: Scalars['ID'];
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SourceCrewFromOutOfServiceUnit = {
  oosUnitId: Scalars['ID'];
  oosUnitPositionIds: Array<Scalars['ID']>;
  unitId: Scalars['ID'];
};

export type SpecialityTeam = {
  __typename: 'SpecialityTeam';
  specialityTeamId: Scalars['ID'];
  specialityTeamNotes: Maybe<Scalars['String']>;
};

export type SpecialityTeamInput = {
  specialityTeamId: Scalars['ID'];
  specialityTeamNotes: InputMaybe<Scalars['String']>;
};

export type SpecialtyTeam = Entity &
  Evented & {
    __typename: 'SpecialtyTeam';
    _events: MessageEnvelopeCollection;
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    affiliation: Location;
    affiliationId: Scalars['ID'];
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requesters: Maybe<Array<Maybe<Requester>>>;
    specialtyTeamMembers: Array<SpecialtyTeamMember>;
  };

export type SpecialtyTeam_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SpecialtyTeamCollection = {
  __typename: 'SpecialtyTeamCollection';
  items: Array<SpecialtyTeam>;
  meta: SpecialtyTeamCollectionMetadata;
};

export type SpecialtyTeamCollectionMetadata = CollectionMetadata & {
  __typename: 'SpecialtyTeamCollectionMetadata';
  total: Scalars['Int'];
};

export type SpecialtyTeamFilter = {
  companyId: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type SpecialtyTeamMember = Entity &
  Evented & {
    __typename: 'SpecialtyTeamMember';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    specialtyTeam: SpecialtyTeam;
    specialtyTeamId: Scalars['ID'];
    teamMember: Person;
    teamMemberId: Scalars['ID'];
    weightInKg: Maybe<Scalars['Float']>;
  };

export type SpecialtyTeamMember_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SpecialtyTeamMemberCollection = {
  __typename: 'SpecialtyTeamMemberCollection';
  items: Array<SpecialtyTeamMember>;
  meta: SpecialtyTeamMemberCollectionMetadata;
};

export type SpecialtyTeamMemberCollectionMetadata = CollectionMetadata & {
  __typename: 'SpecialtyTeamMemberCollectionMetadata';
  total: Scalars['Int'];
};

export type SpecialtyTeamMemberFilter = {
  companyId: InputMaybe<Scalars['String']>;
  emailLike: InputMaybe<Scalars['String']>;
  nameLike: InputMaybe<Scalars['String']>;
  specialtyTeamId: InputMaybe<Scalars['String']>;
};

export type SpecialtyTeamQueries = {
  __typename: 'SpecialtyTeamQueries';
  all: SpecialtyTeamCollection;
};

export type SpecialtyTeamQueriesallArgs = {
  filter: InputMaybe<SpecialtyTeamFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SpectialtyTeamMemberQueries = {
  __typename: 'SpectialtyTeamMemberQueries';
  all: SpecialtyTeamMemberCollection;
};

export type SpectialtyTeamMemberQueriesallArgs = {
  filter: InputMaybe<SpecialtyTeamMemberFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SplitUnitOriginAndPickupWaypoints = {
  tripId: Scalars['ID'];
};

export type SplitUnitPostAndDropoffWaypoints = {
  tripId: Scalars['ID'];
};

export enum StandbyActivationType {
  AutoLaunch = 'AutoLaunch',
  CustomerActivation = 'CustomerActivation',
}

export type State = Entity &
  Evented & {
    __typename: 'State';
    _events: MessageEnvelopeCollection;
    code: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isLicenseRequiredToFly: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
  };

export type State_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type StateCollection = {
  __typename: 'StateCollection';
  items: Array<State>;
  meta: StateCollectionMetadata;
};

export type StateCollectionMetadata = CollectionMetadata & {
  __typename: 'StateCollectionMetadata';
  total: Scalars['Int'];
};

export type StateQueries = {
  __typename: 'StateQueries';
  all: StateCollection;
};

export type SubmitMedicalFacilityForApproval = {
  medicalFacilityId: Scalars['ID'];
};

export type SubmitOutOfServiceTicket = {
  address: InputMaybe<AddressInput>;
  alternatePOC: InputMaybe<Scalars['String']>;
  assignedBaseId: InputMaybe<Scalars['ID']>;
  businessUnitCompanyId: InputMaybe<Scalars['ID']>;
  ertsDateTime: Scalars['DateTime'];
  id: InputMaybe<Scalars['ID']>;
  isBirdStrike: Scalars['Boolean'];
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  isPatientOnboard: Scalars['Boolean'];
  isPlanned: Scalars['Boolean'];
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  maintenanceLocation: InputMaybe<Scalars['String']>;
  maintenanceTypes: Array<OosTicketMaintenanceType>;
  mxDuringPeakTimeReason: InputMaybe<Scalars['String']>;
  opportunityMXTypes: InputMaybe<Array<InputMaybe<OpportunityMXType>>>;
  outOfServiceTime: Scalars['DateTime'];
  outOfServiceType: InputMaybe<OutOfServiceType>;
  pointOfContactId: InputMaybe<Scalars['ID']>;
  primaryReasonId: InputMaybe<Scalars['ID']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  spareVehicleId: InputMaybe<Scalars['ID']>;
  status: OosTicketStatusType;
  ticketDescription: Scalars['String'];
  vehicleId: Scalars['ID'];
  waitingForParts: Scalars['Boolean'];
  waitingForTooling: Scalars['Boolean'];
};

export type SubmitQuestionnaireResponse = {
  cardId: Scalars['ID'];
  companyId: Scalars['ID'];
  currentReviewLevel: InputMaybe<UserRole>;
  id: Scalars['ID'];
  questionResponses: Array<UpdateQuestionnaireQuestionResponseDeep>;
  questionnaireId: Scalars['ID'];
  status: QuestionnaireResponseStatus;
};

export type SubmitSupportRequest = {
  supportRequestId: Scalars['ID'];
};

export enum SummaryView {
  All = 'All',
  Card = 'Card',
  Unit = 'Unit',
  Vehicle = 'Vehicle',
}

export enum SupplementalLegType {
  CompanyUnit = 'CompanyUnit',
  ExternalAgency = 'ExternalAgency',
  SisterCompanyUnit = 'SisterCompanyUnit',
}

export type SupportRequest = Entity &
  Evented & {
    __typename: 'SupportRequest';
    _events: MessageEnvelopeCollection;
    attachments: Array<Attachment>;
    companyId: Scalars['ID'];
    content: Maybe<Scalars['String']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isEmailSent: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notes: Maybe<Scalars['String']>;
    personId: Scalars['ID'];
    subject: Maybe<Scalars['String']>;
    supportRequestStatus: SupportRequestStatus;
    supportRequestType: SupportRequestType;
  };

export type SupportRequest_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SupportRequestCollection = {
  __typename: 'SupportRequestCollection';
  items: Array<SupportRequest>;
  meta: SupportRequestCollectionMetadata;
};

export type SupportRequestCollectionMetadata = CollectionMetadata & {
  __typename: 'SupportRequestCollectionMetadata';
  total: Scalars['Int'];
};

export type SupportRequestFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  includeStatuses: InputMaybe<Array<SupportRequestStatus>>;
  subjectLike: InputMaybe<Scalars['String']>;
  supportRequestId: InputMaybe<Scalars['ID']>;
  supportRequestType: InputMaybe<SupportRequestType>;
};

export type SupportRequestQueries = {
  __typename: 'SupportRequestQueries';
  all: SupportRequestCollection;
  byId: Maybe<SupportRequest>;
};

export type SupportRequestQueriesallArgs = {
  filter: InputMaybe<SupportRequestFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SupportRequestQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum SupportRequestStatus {
  Accepted = 'Accepted',
  Completed = 'Completed',
  Created = 'Created',
  InProgress = 'InProgress',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
}

export enum SupportRequestType {
  Bug = 'Bug',
  Feature = 'Feature',
  Unspecified = 'Unspecified',
}

export type SwapUnitVehicles = {
  firstUnitId: Scalars['ID'];
  secondUnitId: Scalars['ID'];
};

export type SwapWaypoint = {
  insertAfterWaypointId: Scalars['ID'];
  swapWaypointId: Scalars['ID'];
  tripId: Scalars['ID'];
};

export type SystemTimer = Entity &
  Evented & {
    __typename: 'SystemTimer';
    _events: MessageEnvelopeCollection;
    commandName: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    description: Scalars['String'];
    hasRunCondition: Scalars['Boolean'];
    id: Scalars['ID'];
    isEnqueued: Scalars['Boolean'];
    lastRunDate: Maybe<Scalars['DateTime']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    runIntervalInSeconds: Scalars['Int'];
  };

export type SystemTimer_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type SystemTimerCollection = {
  __typename: 'SystemTimerCollection';
  items: Array<SystemTimer>;
  meta: SystemTimerCollectionMetadata;
};

export type SystemTimerCollectionMetadata = CollectionMetadata & {
  __typename: 'SystemTimerCollectionMetadata';
  total: Scalars['Int'];
};

export enum SystemTimestampType {
  ArriveBase = 'ArriveBase',
  ArriveBedsideReceiving = 'ArriveBedsideReceiving',
  ArriveDropoff = 'ArriveDropoff',
  ArriveDropoffLzViaGround = 'ArriveDropoffLzViaGround',
  ArrivePatient = 'ArrivePatient',
  ArrivePickup = 'ArrivePickup',
  ArrivePickupLzViaGround = 'ArrivePickupLzViaGround',
  ArriveReceivingViaGround = 'ArriveReceivingViaGround',
  ArriveSendingViaGround = 'ArriveSendingViaGround',
  ArriveWaypoint = 'ArriveWaypoint',
  AssignmentStarted = 'AssignmentStarted',
  CardClosed = 'CardClosed',
  ConfirmedDropoffGround = 'ConfirmedDropoffGround',
  ConfirmedPickupGround = 'ConfirmedPickupGround',
  CrewNotificationReceived = 'CrewNotificationReceived',
  CrewNotified = 'CrewNotified',
  Custom = 'Custom',
  DepartBase = 'DepartBase',
  DepartBedsideReceiving = 'DepartBedsideReceiving',
  DepartDropoff = 'DepartDropoff',
  DepartDropoffLzViaGround = 'DepartDropoffLzViaGround',
  DepartPickup = 'DepartPickup',
  DepartPickupLzViaGround = 'DepartPickupLzViaGround',
  DepartReceivingViaGround = 'DepartReceivingViaGround',
  DepartSendingViaGround = 'DepartSendingViaGround',
  DepartWaypoint = 'DepartWaypoint',
  DepartWithPatient = 'DepartWithPatient',
  EmsReport = 'EmsReport',
  EnRouteToPatient = 'EnRouteToPatient',
  EnRouteToPickup = 'EnRouteToPickup',
  EtaProvided = 'EtaProvided',
  ExternalActionCancellationRequested = 'ExternalActionCancellationRequested',
  ExternalActionRemoveStandby = 'ExternalActionRemoveStandby',
  ExternalRequestDisregarded = 'ExternalRequestDisregarded',
  FboConfirmed = 'FboConfirmed',
  FollowUpWeatherCheck = 'FollowUpWeatherCheck',
  InitialDeparture = 'InitialDeparture',
  ManifestConfirmed = 'ManifestConfirmed',
  MedicalControlContactAttempted = 'MedicalControlContactAttempted',
  OperationCancelled = 'OperationCancelled',
  OperationCompleted = 'OperationCompleted',
  OverheadDropoff = 'OverheadDropoff',
  OverheadPickup = 'OverheadPickup',
  PaipEvent = 'PaipEvent',
  PatientInfoMessageSent = 'PatientInfoMessageSent',
  PlacedOnStandby = 'PlacedOnStandby',
  ReceivingFacilityRequestAccepted = 'ReceivingFacilityRequestAccepted',
  ReceivingFacilityRequestCancelled = 'ReceivingFacilityRequestCancelled',
  ReceivingFacilityRequestDenied = 'ReceivingFacilityRequestDenied',
  ReceivingFacilityRequestDiverted = 'ReceivingFacilityRequestDiverted',
  ReceivingFacilityRequestReferred = 'ReceivingFacilityRequestReferred',
  ReferRequest = 'ReferRequest',
  RequestCancelled = 'RequestCancelled',
  RequestReactivated = 'RequestReactivated',
  RequestReceived = 'RequestReceived',
  ResendToDW = 'ResendToDW',
  SentToImageTrend = 'SentToImageTrend',
  StandbyRemoved = 'StandbyRemoved',
  TransportCheckInitiated = 'TransportCheckInitiated',
  UnitAborted = 'UnitAborted',
  UnitActivated = 'UnitActivated',
  UnitAssigned = 'UnitAssigned',
  UnitOffered = 'UnitOffered',
  WeatherDeclined = 'WeatherDeclined',
  WeatherDelayed = 'WeatherDelayed',
  WebOrderAcknowledged = 'WebOrderAcknowledged',
}

export type TakeUnitOutOfService = {
  primaryOosEventId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export enum TcsAuditEntityType {
  AuditLog = 'AuditLog',
}

export type TcsEntity =
  | AccessibleItem
  | ActivationRule
  | ActiveAlert
  | ActiveAlertAcknowledgement
  | ActiveCardUnitOffering
  | ActiveTimeline
  | Agency
  | AgencyLocation
  | Airport
  | Alert
  | ApplicationNotification
  | ArchiveLog
  | AssignmentDelayedReason
  | Attachment
  | AuditLog
  | Base
  | BaseControlZone
  | BaseMedicalControlContact
  | BaseMedicalControlContactState
  | CancellationCategory
  | CancellationReason
  | CancellationSecondaryReason
  | Capability
  | Card
  | CardLink
  | CardNote
  | CardNoteArchive
  | CardReOpenReason
  | CardSummary
  | CommunicationCenter
  | CommunicationCenterTransportOfferOption
  | Company
  | CompleteFlightInstance
  | ConfigurationSetting
  | ControlZone
  | Conversation
  | ConversationParticipant
  | DeclineCategory
  | DeclineReason
  | DeclineSecondaryReason
  | Department
  | DiversionReason
  | EntityCapability
  | EscortRequest
  | EstimatedDuration
  | Eta
  | ExternalAction
  | ExternalActionType
  | ExternalReference
  | ExternalSystemUnit
  | FacilityNonAcceptanceReason
  | Fbo
  | FirewallRule
  | FlightFollowingReport
  | FuelTank
  | LandingZoneOutOfServiceReason
  | Location
  | LocationHazard
  | LocationHazardAttachment
  | MaintenanceFacility
  | ManifestEntry
  | MedicalControlContactLogEntry
  | MedicalFacility
  | MedicalFacilityContact
  | MedicalFacilityPhysician
  | MedicalFacilityUnit
  | MedicalUnit
  | MessageStatusUpdate
  | NewAgencyLocationRequest
  | NextDueType
  | NonReferralReason
  | Notification
  | NotificationGroup
  | NotificationGroupMember
  | NotificationRecipient
  | NotificationSubscription
  | NotificationTemplate
  | OemActivity
  | OemAsset
  | OemPlan
  | OemPlanChangeRequest
  | OfferAlgorithm
  | Operation
  | OutOfServiceEvent
  | OutOfServiceEventNote
  | OutOfServiceQARReason
  | OutOfServiceReason
  | OutOfServiceSecondaryReason
  | OutOfServiceTicket
  | PaipEvent
  | PaipReason
  | PassdownLog
  | PassdownLogAcknowledgement
  | PassdownLogArchivedLog
  | Patient
  | Person
  | Physician
  | PositionReport
  | PositionReportAlert
  | PositionReportArchive
  | Program
  | ProgramBase
  | Question
  | QuestionChoice
  | Questionnaire
  | QuestionnaireQuestionResponse
  | QuestionnaireQuestionResponseNote
  | QuestionnaireResponse
  | QuestionnaireSection
  | QuestionnaireSectionQuestion
  | RamcoVehicleConfiguration
  | ReceivingFacilityRequest
  | Region
  | RegionBase
  | RegionGroup
  | ReleaseNote
  | RendezvousRequest
  | Request
  | RequestLocation
  | RequestPatient
  | Requester
  | RequesterReferralReason
  | RequesterRole
  | SpecialtyTeam
  | SpecialtyTeamMember
  | State
  | SupportRequest
  | SystemTimer
  | Timeline
  | TimelineItem
  | Timestamp
  | TimestampType
  | Timezone
  | TrackedMessage
  | TransferCenter
  | TransferReason
  | TransportOffer
  | TransportOfferOption
  | TransportReason
  | Trip
  | TripLeg
  | TripPassenger
  | TrmUser
  | TrmUserAgency
  | TrmUserMedicalFacility
  | TrmUserProgram
  | Unit
  | UnitActivationRule
  | UnitEMSystemMapping
  | UnitNote
  | UnitPosition
  | UnitShift
  | UnitStatusHistoryEntry
  | UnitSummary
  | Vehicle
  | VehicleConfigurationClass
  | VehicleControlZone
  | VehicleDisposition
  | VehicleMaintenance
  | VehicleMake
  | VehicleModel
  | VehicleNotificationGroup
  | VehiclePositionSummary
  | VehicleStateInspection
  | VehicleSummary
  | Waypoint
  | WebOrderLog;

export enum TcsEntityType {
  AccessibleItem = 'AccessibleItem',
  ActivationRule = 'ActivationRule',
  ActiveAlert = 'ActiveAlert',
  ActiveAlertAcknowledgement = 'ActiveAlertAcknowledgement',
  ActiveCardUnitOffering = 'ActiveCardUnitOffering',
  ActiveTimeline = 'ActiveTimeline',
  Agency = 'Agency',
  AgencyLocation = 'AgencyLocation',
  Airport = 'Airport',
  Alert = 'Alert',
  ApplicationNotification = 'ApplicationNotification',
  ArchiveLog = 'ArchiveLog',
  AssignmentDelayedReason = 'AssignmentDelayedReason',
  Attachment = 'Attachment',
  AuditLog = 'AuditLog',
  Base = 'Base',
  BaseControlZone = 'BaseControlZone',
  BaseMedicalControlContact = 'BaseMedicalControlContact',
  BaseMedicalControlContactState = 'BaseMedicalControlContactState',
  CancellationCategory = 'CancellationCategory',
  CancellationReason = 'CancellationReason',
  CancellationSecondaryReason = 'CancellationSecondaryReason',
  Capability = 'Capability',
  Card = 'Card',
  CardLink = 'CardLink',
  CardNote = 'CardNote',
  CardNoteArchive = 'CardNoteArchive',
  CardReOpenReason = 'CardReOpenReason',
  CardSummary = 'CardSummary',
  CommunicationCenter = 'CommunicationCenter',
  CommunicationCenterTransportOfferOption = 'CommunicationCenterTransportOfferOption',
  Company = 'Company',
  CompleteFlightInstance = 'CompleteFlightInstance',
  ConfigurationSetting = 'ConfigurationSetting',
  ControlZone = 'ControlZone',
  Conversation = 'Conversation',
  ConversationParticipant = 'ConversationParticipant',
  DeclineCategory = 'DeclineCategory',
  DeclineReason = 'DeclineReason',
  DeclineSecondaryReason = 'DeclineSecondaryReason',
  Department = 'Department',
  DiversionReason = 'DiversionReason',
  EntityCapability = 'EntityCapability',
  EscortRequest = 'EscortRequest',
  EstimatedDuration = 'EstimatedDuration',
  Eta = 'Eta',
  ExternalAction = 'ExternalAction',
  ExternalActionType = 'ExternalActionType',
  ExternalReference = 'ExternalReference',
  ExternalSystemUnit = 'ExternalSystemUnit',
  FacilityNonAcceptanceReason = 'FacilityNonAcceptanceReason',
  Fbo = 'Fbo',
  FirewallRule = 'FirewallRule',
  FlightFollowingReport = 'FlightFollowingReport',
  FuelTank = 'FuelTank',
  LandingZoneOutOfServiceReason = 'LandingZoneOutOfServiceReason',
  Location = 'Location',
  LocationHazard = 'LocationHazard',
  LocationHazardAttachment = 'LocationHazardAttachment',
  MaintenanceFacility = 'MaintenanceFacility',
  ManifestEntry = 'ManifestEntry',
  MedicalControlContactLogEntry = 'MedicalControlContactLogEntry',
  MedicalFacility = 'MedicalFacility',
  MedicalFacilityContact = 'MedicalFacilityContact',
  MedicalFacilityPhysician = 'MedicalFacilityPhysician',
  MedicalFacilityUnit = 'MedicalFacilityUnit',
  MedicalUnit = 'MedicalUnit',
  MessageStatusUpdate = 'MessageStatusUpdate',
  NewAgencyLocationRequest = 'NewAgencyLocationRequest',
  NextDueType = 'NextDueType',
  NonReferralReason = 'NonReferralReason',
  Notification = 'Notification',
  NotificationGroup = 'NotificationGroup',
  NotificationGroupMember = 'NotificationGroupMember',
  NotificationRecipient = 'NotificationRecipient',
  NotificationSubscription = 'NotificationSubscription',
  NotificationTemplate = 'NotificationTemplate',
  OemActivity = 'OemActivity',
  OemAsset = 'OemAsset',
  OemPlan = 'OemPlan',
  OemPlanChangeRequest = 'OemPlanChangeRequest',
  OfferAlgorithm = 'OfferAlgorithm',
  Operation = 'Operation',
  OutOfServiceEvent = 'OutOfServiceEvent',
  OutOfServiceEventNote = 'OutOfServiceEventNote',
  OutOfServiceQARReason = 'OutOfServiceQARReason',
  OutOfServiceReason = 'OutOfServiceReason',
  OutOfServiceSecondaryReason = 'OutOfServiceSecondaryReason',
  OutOfServiceTicket = 'OutOfServiceTicket',
  PaipEvent = 'PaipEvent',
  PaipReason = 'PaipReason',
  PassdownLog = 'PassdownLog',
  PassdownLogAcknowledgement = 'PassdownLogAcknowledgement',
  PassdownLogArchivedLog = 'PassdownLogArchivedLog',
  Patient = 'Patient',
  Person = 'Person',
  Physician = 'Physician',
  PositionReport = 'PositionReport',
  PositionReportAlert = 'PositionReportAlert',
  PositionReportArchive = 'PositionReportArchive',
  Program = 'Program',
  ProgramBase = 'ProgramBase',
  Question = 'Question',
  QuestionChoice = 'QuestionChoice',
  Questionnaire = 'Questionnaire',
  QuestionnaireQuestionResponse = 'QuestionnaireQuestionResponse',
  QuestionnaireQuestionResponseNote = 'QuestionnaireQuestionResponseNote',
  QuestionnaireResponse = 'QuestionnaireResponse',
  QuestionnaireSection = 'QuestionnaireSection',
  QuestionnaireSectionQuestion = 'QuestionnaireSectionQuestion',
  RamcoVehicleConfiguration = 'RamcoVehicleConfiguration',
  ReceivingFacilityRequest = 'ReceivingFacilityRequest',
  Region = 'Region',
  RegionBase = 'RegionBase',
  RegionGroup = 'RegionGroup',
  ReleaseNote = 'ReleaseNote',
  RendezvousRequest = 'RendezvousRequest',
  Request = 'Request',
  RequestLocation = 'RequestLocation',
  RequestPatient = 'RequestPatient',
  Requester = 'Requester',
  RequesterReferralReason = 'RequesterReferralReason',
  RequesterRole = 'RequesterRole',
  SpecialtyTeam = 'SpecialtyTeam',
  SpecialtyTeamMember = 'SpecialtyTeamMember',
  State = 'State',
  SupportRequest = 'SupportRequest',
  SystemTimer = 'SystemTimer',
  Timeline = 'Timeline',
  TimelineItem = 'TimelineItem',
  Timestamp = 'Timestamp',
  TimestampType = 'TimestampType',
  Timezone = 'Timezone',
  TrackedMessage = 'TrackedMessage',
  TransferCenter = 'TransferCenter',
  TransferReason = 'TransferReason',
  TransportOffer = 'TransportOffer',
  TransportOfferOption = 'TransportOfferOption',
  TransportReason = 'TransportReason',
  Trip = 'Trip',
  TripLeg = 'TripLeg',
  TripPassenger = 'TripPassenger',
  TrmUser = 'TrmUser',
  TrmUserAgency = 'TrmUserAgency',
  TrmUserMedicalFacility = 'TrmUserMedicalFacility',
  TrmUserProgram = 'TrmUserProgram',
  Unit = 'Unit',
  UnitActivationRule = 'UnitActivationRule',
  UnitEMSystemMapping = 'UnitEMSystemMapping',
  UnitNote = 'UnitNote',
  UnitPosition = 'UnitPosition',
  UnitShift = 'UnitShift',
  UnitStatusHistoryEntry = 'UnitStatusHistoryEntry',
  UnitSummary = 'UnitSummary',
  Vehicle = 'Vehicle',
  VehicleConfigurationClass = 'VehicleConfigurationClass',
  VehicleControlZone = 'VehicleControlZone',
  VehicleDisposition = 'VehicleDisposition',
  VehicleMaintenance = 'VehicleMaintenance',
  VehicleMake = 'VehicleMake',
  VehicleModel = 'VehicleModel',
  VehicleNotificationGroup = 'VehicleNotificationGroup',
  VehiclePositionSummary = 'VehiclePositionSummary',
  VehicleStateInspection = 'VehicleStateInspection',
  VehicleSummary = 'VehicleSummary',
  Waypoint = 'Waypoint',
  WebOrderLog = 'WebOrderLog',
}

export enum TcsOperationsEntityType {
  ActivationRule = 'ActivationRule',
  ActiveAlert = 'ActiveAlert',
  ActiveAlertAcknowledgement = 'ActiveAlertAcknowledgement',
  ActiveCardUnitOffering = 'ActiveCardUnitOffering',
  ActiveTimeline = 'ActiveTimeline',
  Alert = 'Alert',
  ApplicationNotification = 'ApplicationNotification',
  AssignmentDelayedReason = 'AssignmentDelayedReason',
  CancellationCategory = 'CancellationCategory',
  CancellationReason = 'CancellationReason',
  CancellationSecondaryReason = 'CancellationSecondaryReason',
  Card = 'Card',
  CardLink = 'CardLink',
  CardNote = 'CardNote',
  CardNoteArchive = 'CardNoteArchive',
  CardReOpenReason = 'CardReOpenReason',
  CardSummary = 'CardSummary',
  ConfigurationSetting = 'ConfigurationSetting',
  Conversation = 'Conversation',
  ConversationParticipant = 'ConversationParticipant',
  DeclineCategory = 'DeclineCategory',
  DeclineReason = 'DeclineReason',
  DeclineSecondaryReason = 'DeclineSecondaryReason',
  DiversionReason = 'DiversionReason',
  EscortRequest = 'EscortRequest',
  EstimatedDuration = 'EstimatedDuration',
  Eta = 'Eta',
  ExternalAction = 'ExternalAction',
  ExternalActionType = 'ExternalActionType',
  ExternalSystemUnit = 'ExternalSystemUnit',
  FacilityNonAcceptanceReason = 'FacilityNonAcceptanceReason',
  FirewallRule = 'FirewallRule',
  FlightFollowingReport = 'FlightFollowingReport',
  LandingZoneOutOfServiceReason = 'LandingZoneOutOfServiceReason',
  LocationHazard = 'LocationHazard',
  LocationHazardAttachment = 'LocationHazardAttachment',
  ManifestEntry = 'ManifestEntry',
  MedicalControlContactLogEntry = 'MedicalControlContactLogEntry',
  MessageStatusUpdate = 'MessageStatusUpdate',
  NewAgencyLocationRequest = 'NewAgencyLocationRequest',
  NextDueType = 'NextDueType',
  NonReferralReason = 'NonReferralReason',
  Notification = 'Notification',
  NotificationGroup = 'NotificationGroup',
  NotificationGroupMember = 'NotificationGroupMember',
  NotificationRecipient = 'NotificationRecipient',
  NotificationSubscription = 'NotificationSubscription',
  NotificationTemplate = 'NotificationTemplate',
  OemActivity = 'OemActivity',
  OemAsset = 'OemAsset',
  OemPlan = 'OemPlan',
  OemPlanChangeRequest = 'OemPlanChangeRequest',
  OfferAlgorithm = 'OfferAlgorithm',
  Operation = 'Operation',
  OutOfServiceEvent = 'OutOfServiceEvent',
  OutOfServiceEventNote = 'OutOfServiceEventNote',
  OutOfServiceReason = 'OutOfServiceReason',
  OutOfServiceSecondaryReason = 'OutOfServiceSecondaryReason',
  OutOfServiceTicket = 'OutOfServiceTicket',
  PaipEvent = 'PaipEvent',
  PaipReason = 'PaipReason',
  PassdownLog = 'PassdownLog',
  PassdownLogAcknowledgement = 'PassdownLogAcknowledgement',
  PassdownLogArchivedLog = 'PassdownLogArchivedLog',
  Patient = 'Patient',
  PositionReport = 'PositionReport',
  PositionReportAlert = 'PositionReportAlert',
  PositionReportArchive = 'PositionReportArchive',
  Question = 'Question',
  QuestionChoice = 'QuestionChoice',
  Questionnaire = 'Questionnaire',
  QuestionnaireQuestionResponse = 'QuestionnaireQuestionResponse',
  QuestionnaireQuestionResponseNote = 'QuestionnaireQuestionResponseNote',
  QuestionnaireResponse = 'QuestionnaireResponse',
  QuestionnaireSection = 'QuestionnaireSection',
  QuestionnaireSectionQuestion = 'QuestionnaireSectionQuestion',
  ReceivingFacilityRequest = 'ReceivingFacilityRequest',
  RendezvousRequest = 'RendezvousRequest',
  Request = 'Request',
  RequestLocation = 'RequestLocation',
  RequestPatient = 'RequestPatient',
  Requester = 'Requester',
  RequesterReferralReason = 'RequesterReferralReason',
  RequesterRole = 'RequesterRole',
  SystemTimer = 'SystemTimer',
  Timeline = 'Timeline',
  TimelineItem = 'TimelineItem',
  Timestamp = 'Timestamp',
  TimestampType = 'TimestampType',
  TrackedMessage = 'TrackedMessage',
  TransferReason = 'TransferReason',
  TransportOffer = 'TransportOffer',
  TransportOfferOption = 'TransportOfferOption',
  TransportReason = 'TransportReason',
  Trip = 'Trip',
  TripLeg = 'TripLeg',
  TripPassenger = 'TripPassenger',
  Unit = 'Unit',
  UnitActivationRule = 'UnitActivationRule',
  UnitEMSystemMapping = 'UnitEMSystemMapping',
  UnitNote = 'UnitNote',
  UnitPosition = 'UnitPosition',
  UnitShift = 'UnitShift',
  UnitStatusHistoryEntry = 'UnitStatusHistoryEntry',
  UnitSummary = 'UnitSummary',
  VehicleDisposition = 'VehicleDisposition',
  VehicleNotificationGroup = 'VehicleNotificationGroup',
  VehiclePositionSummary = 'VehiclePositionSummary',
  VehicleSummary = 'VehicleSummary',
  Waypoint = 'Waypoint',
  WebOrderLog = 'WebOrderLog',
}

export enum TcsOrganizationEntityType {
  AccessibleItem = 'AccessibleItem',
  Agency = 'Agency',
  AgencyLocation = 'AgencyLocation',
  Airport = 'Airport',
  ArchiveLog = 'ArchiveLog',
  Attachment = 'Attachment',
  Base = 'Base',
  BaseControlZone = 'BaseControlZone',
  BaseMedicalControlContact = 'BaseMedicalControlContact',
  BaseMedicalControlContactState = 'BaseMedicalControlContactState',
  Capability = 'Capability',
  CommunicationCenter = 'CommunicationCenter',
  CommunicationCenterTransportOfferOption = 'CommunicationCenterTransportOfferOption',
  Company = 'Company',
  CompleteFlightInstance = 'CompleteFlightInstance',
  ControlZone = 'ControlZone',
  Department = 'Department',
  EntityCapability = 'EntityCapability',
  ExternalReference = 'ExternalReference',
  Fbo = 'Fbo',
  FuelTank = 'FuelTank',
  Location = 'Location',
  MaintenanceFacility = 'MaintenanceFacility',
  MedicalFacility = 'MedicalFacility',
  MedicalFacilityContact = 'MedicalFacilityContact',
  MedicalFacilityPhysician = 'MedicalFacilityPhysician',
  MedicalFacilityUnit = 'MedicalFacilityUnit',
  MedicalUnit = 'MedicalUnit',
  OutOfServiceQARReason = 'OutOfServiceQARReason',
  Person = 'Person',
  Physician = 'Physician',
  Program = 'Program',
  ProgramBase = 'ProgramBase',
  RamcoVehicleConfiguration = 'RamcoVehicleConfiguration',
  Region = 'Region',
  RegionBase = 'RegionBase',
  RegionGroup = 'RegionGroup',
  ReleaseNote = 'ReleaseNote',
  SpecialtyTeam = 'SpecialtyTeam',
  SpecialtyTeamMember = 'SpecialtyTeamMember',
  State = 'State',
  SupportRequest = 'SupportRequest',
  Timezone = 'Timezone',
  TransferCenter = 'TransferCenter',
  TrmUser = 'TrmUser',
  TrmUserAgency = 'TrmUserAgency',
  TrmUserMedicalFacility = 'TrmUserMedicalFacility',
  TrmUserProgram = 'TrmUserProgram',
  Vehicle = 'Vehicle',
  VehicleConfigurationClass = 'VehicleConfigurationClass',
  VehicleControlZone = 'VehicleControlZone',
  VehicleMaintenance = 'VehicleMaintenance',
  VehicleMake = 'VehicleMake',
  VehicleModel = 'VehicleModel',
  VehicleStateInspection = 'VehicleStateInspection',
}

export type TcsRealtimeTracking = {
  __typename: 'TcsRealtimeTracking';
  tabDate: Maybe<Scalars['DateTime']>;
  tabId: Maybe<Scalars['String']>;
};

export type TcsRealtimeTrackingInput = {
  tabDate: InputMaybe<Scalars['DateTime']>;
  tabId: InputMaybe<Scalars['String']>;
};

export type TeleportUnit = {
  id: Scalars['ID'];
};

export enum TimeType {
  FullTime = 'FullTime',
  PartTime = 'PartTime',
  Unspecified = 'Unspecified',
}

export type Timeline = Entity &
  Evented & {
    __typename: 'Timeline';
    _events: MessageEnvelopeCollection;
    activationRule: Maybe<ActivationRule>;
    activationRuleId: Maybe<Scalars['ID']>;
    activeTimelines: Array<ActiveTimeline>;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    items: Array<TimelineItem>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    timelineType: Maybe<TimelineTypes>;
  };

export type Timeline_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimelineCollection = {
  __typename: 'TimelineCollection';
  items: Array<Timeline>;
  meta: TimelineCollectionMetadata;
};

export type TimelineCollectionMetadata = CollectionMetadata & {
  __typename: 'TimelineCollectionMetadata';
  total: Scalars['Int'];
};

export type TimelineFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type TimelineItem = Entity &
  Evented & {
    __typename: 'TimelineItem';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    required: Scalars['Boolean'];
    sequence: Scalars['Int'];
    timeline: Timeline;
    timelineId: Scalars['ID'];
    timestampType: TimestampType;
    timestampTypeId: Scalars['ID'];
  };

export type TimelineItem_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimelineItemCollection = {
  __typename: 'TimelineItemCollection';
  items: Array<TimelineItem>;
  meta: TimelineItemCollectionMetadata;
};

export type TimelineItemCollectionMetadata = CollectionMetadata & {
  __typename: 'TimelineItemCollectionMetadata';
  total: Scalars['Int'];
};

export type TimelineItemFilter = {
  cardId: InputMaybe<Scalars['String']>;
};

export type TimelineItemQueries = {
  __typename: 'TimelineItemQueries';
  all: TimelineItemCollection;
  byId: Maybe<Timeline>;
};

export type TimelineItemQueriesallArgs = {
  filter: InputMaybe<TimelineItemFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimelineItemQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type TimelineQueries = {
  __typename: 'TimelineQueries';
  all: TimelineCollection;
  byId: Maybe<Timeline>;
};

export type TimelineQueriesallArgs = {
  filter: InputMaybe<TimelineFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimelineQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export enum TimelineTypes {
  Contact = 'Contact',
}

export type Timestamp = Entity &
  Evented & {
    __typename: 'Timestamp';
    _events: MessageEnvelopeCollection;
    card: Card;
    cardId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalControlContactLogEntries: Array<MedicalControlContactLogEntry>;
    note: Maybe<Scalars['String']>;
    operation: Maybe<Operation>;
    operationId: Maybe<Scalars['ID']>;
    personsInvolved: Maybe<Scalars['String']>;
    request: Maybe<Request>;
    requestId: Maybe<Scalars['ID']>;
    time: Scalars['DateTime'];
    type: TimestampType;
    typeId: Scalars['ID'];
    user: Maybe<Person>;
    userId: Maybe<Scalars['ID']>;
  };

export type Timestamp_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimestampCollection = {
  __typename: 'TimestampCollection';
  items: Array<Timestamp>;
  meta: TimestampCollectionMetadata;
};

export type TimestampCollectionMetadata = CollectionMetadata & {
  __typename: 'TimestampCollectionMetadata';
  total: Scalars['Int'];
};

export type TimestampQueries = {
  __typename: 'TimestampQueries';
  byCardId: TimestampCollection;
  byId: Maybe<Timestamp>;
};

export type TimestampQueriesbyCardIdArgs = {
  cardId: Scalars['ID'];
  filter: InputMaybe<TimestampsByCardFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimestampQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type TimestampType = Entity &
  Evented & {
    __typename: 'TimestampType';
    _events: MessageEnvelopeCollection;
    companies: Maybe<Array<Maybe<IdListItem>>>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    description: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    order: Scalars['Int'];
    systemTimestampType: Maybe<SystemTimestampType>;
    timelines: Array<TimelineItem>;
    timestamps: Array<Timestamp>;
  };

export type TimestampType_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimestampTypeCollection = {
  __typename: 'TimestampTypeCollection';
  items: Array<TimestampType>;
  meta: TimestampTypeCollectionMetadata;
};

export type TimestampTypeCollectionMetadata = CollectionMetadata & {
  __typename: 'TimestampTypeCollectionMetadata';
  total: Scalars['Int'];
};

export type TimestampTypeFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type TimestampTypeQueries = {
  __typename: 'TimestampTypeQueries';
  all: TimestampTypeCollection;
  byId: Maybe<TimestampType>;
};

export type TimestampTypeQueriesallArgs = {
  filter: InputMaybe<TimestampTypeFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimestampTypeQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type TimestampsByCardFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  distinctFields: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeDistinct: InputMaybe<Scalars['Boolean']>;
  typeId: InputMaybe<Scalars['ID']>;
  userId: InputMaybe<Scalars['ID']>;
};

export type Timezone = Entity &
  Evented & {
    __typename: 'Timezone';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    code: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isDst: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    utcOffset: Scalars['Int'];
  };

export type Timezone_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TimezoneCollection = {
  __typename: 'TimezoneCollection';
  items: Array<Timezone>;
  meta: TimezoneCollectionMetadata;
};

export type TimezoneCollectionMetadata = CollectionMetadata & {
  __typename: 'TimezoneCollectionMetadata';
  total: Scalars['Int'];
};

export type TimezoneResponse = {
  __typename: 'TimezoneResponse';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type TrackedMessage = Entity &
  Evented & {
    __typename: 'TrackedMessage';
    _events: MessageEnvelopeCollection;
    body: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    doNotDivert: Maybe<Scalars['Boolean']>;
    fromAddress: Maybe<Scalars['String']>;
    fromName: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medium: Maybe<MessageTransport>;
    messageStatusUpdates: Array<MessageStatusUpdate>;
    recipientAddress: Scalars['String'];
    recipientName: Maybe<Scalars['String']>;
    recipients: Maybe<Array<Maybe<NotificationRecipient>>>;
    referenceNumber: Maybe<Scalars['String']>;
    status: MessageStatus;
    subject: Maybe<Scalars['String']>;
    vendorConversationId: Maybe<Scalars['String']>;
    vendorId: Maybe<Scalars['String']>;
    vendorMessageId: Maybe<Scalars['String']>;
  };

export type TrackedMessage_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TrackedMessageCollection = {
  __typename: 'TrackedMessageCollection';
  items: Array<TrackedMessage>;
  meta: TrackedMessageCollectionMetadata;
};

export type TrackedMessageCollectionMetadata = CollectionMetadata & {
  __typename: 'TrackedMessageCollectionMetadata';
  total: Scalars['Int'];
};

export type TransferCenter = Entity &
  Evented & {
    __typename: 'TransferCenter';
    _events: MessageEnvelopeCollection;
    communicationCenter: CommunicationCenter;
    communicationCenterId: Scalars['ID'];
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    description: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requesters: Maybe<Array<Maybe<Requester>>>;
  };

export type TransferCenter_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TransferCenterCollection = {
  __typename: 'TransferCenterCollection';
  items: Array<TransferCenter>;
  meta: TransferCenterCollectionMetadata;
};

export type TransferCenterCollectionMetadata = CollectionMetadata & {
  __typename: 'TransferCenterCollectionMetadata';
  total: Scalars['Int'];
};

export type TransferCenterFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type TransferCenterQueries = {
  __typename: 'TransferCenterQueries';
  all: TransferCenterCollection;
  byId: Maybe<TransferCenter>;
};

export type TransferCenterQueriesallArgs = {
  filter: InputMaybe<TransferCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TransferCenterQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type TransferReason = Entity &
  Evented & {
    __typename: 'TransferReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requests: Maybe<Array<Maybe<RequestPatient>>>;
  };

export type TransferReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TransferReasonCollection = {
  __typename: 'TransferReasonCollection';
  items: Array<TransferReason>;
  meta: TransferReasonCollectionMetadata;
};

export type TransferReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'TransferReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type TransferReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type TransferReasonQueries = {
  __typename: 'TransferReasonQueries';
  all: TransferReasonCollection;
  byId: Maybe<TransferReason>;
};

export type TransferReasonQueriesallArgs = {
  filter: InputMaybe<TransferReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TransferReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type TransportOffer = Entity &
  Evented & {
    __typename: 'TransportOffer';
    _events: MessageEnvelopeCollection;
    agencyLocation: Maybe<AgencyLocation>;
    agencyLocationId: Maybe<Scalars['ID']>;
    base: Maybe<Base>;
    baseId: Maybe<Scalars['ID']>;
    bearingInDegrees: Maybe<Scalars['Float']>;
    cancellationReason: Maybe<CancellationReason>;
    cancellationReasonId: Maybe<Scalars['ID']>;
    cancellationReasonNotes: Maybe<Scalars['String']>;
    cancellationSecondaryReason: Maybe<CancellationSecondaryReason>;
    cancellationSecondaryReasonId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    crew: Maybe<Array<Maybe<UnitPositionSnapshot>>>;
    crewMustFlyToArriveAtSending: Maybe<Scalars['Boolean']>;
    crewNotified: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeclinedOrAborted: Maybe<Scalars['DateTime']>;
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    declineReason: Maybe<DeclineReason>;
    declineReasonId: Maybe<Scalars['ID']>;
    declineSecondaryReason: Maybe<DeclineSecondaryReason>;
    declineSecondaryReasonId: Maybe<Scalars['ID']>;
    declinedOrAbortedById: Maybe<Scalars['ID']>;
    distanceInMiles: Maybe<Scalars['Float']>;
    estimatedDepartureTimeInMinutes: Maybe<Scalars['Int']>;
    estimatedTimeEnRouteInMinutes: Maybe<Scalars['Int']>;
    etc: Maybe<Scalars['Float']>;
    homeBaseDistanceInMiles: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    isInternalAgency: Scalars['Boolean'];
    isOnDelay: Scalars['Boolean'];
    isOneCallAgreement: Scalars['Boolean'];
    isReferral: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    nonReferralReason: Maybe<NonReferralReason>;
    nonReferralReasonId: Maybe<Scalars['ID']>;
    nonReferralReasonNotes: Maybe<Scalars['String']>;
    notes: Maybe<Scalars['String']>;
    notificationAcknowledged: Maybe<Scalars['DateTime']>;
    offerTime: Maybe<Scalars['DateTime']>;
    onBaseETAInMinutes: Maybe<Scalars['Int']>;
    outOfServiceEvent: Maybe<OutOfServiceEvent>;
    outOfServiceEventId: Maybe<Scalars['ID']>;
    patientOriginatesAtUnit: Maybe<Scalars['Boolean']>;
    preferredRank: Maybe<Scalars['Int']>;
    rank: Scalars['Int'];
    request: Request;
    requestId: Scalars['ID'];
    response: TransportOfferResponse;
    responseReceived: Maybe<Scalars['DateTime']>;
    specialtyTeamETEInMinutes: Maybe<Scalars['Int']>;
    specialtyTeamETLOInMinutes: Maybe<Scalars['Int']>;
    status: TransportOfferStatus;
    transportCheckInitiated: Maybe<Scalars['DateTime']>;
    unit: Maybe<Unit>;
    unitDescription: Maybe<Scalars['String']>;
    unitId: Maybe<Scalars['ID']>;
    vehicle: Maybe<Vehicle>;
    vehicleCoordinates: Maybe<Coordinates>;
    vehicleId: Maybe<Scalars['ID']>;
    vehicleType: Maybe<VehicleType>;
    wasBulkSkip: Scalars['Boolean'];
  };

export type TransportOffer_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum TransportOfferAlgorithm {
  ShortestDistance = 'ShortestDistance',
  ShortestEta = 'ShortestEta',
}

export type TransportOfferCollection = {
  __typename: 'TransportOfferCollection';
  items: Array<TransportOffer>;
  meta: TransportOfferCollectionMetadata;
};

export type TransportOfferCollectionMetadata = CollectionMetadata & {
  __typename: 'TransportOfferCollectionMetadata';
  total: Scalars['Int'];
};

export type TransportOfferOption = Entity &
  Evented & {
    __typename: 'TransportOfferOption';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    includeAbortedUnit: Scalars['Boolean'];
    includeCompetitors: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    minimumFlightRule: Maybe<FlightRule>;
    request: Request;
    requestId: Scalars['ID'];
    requestedVehicleType: Maybe<VehicleType>;
    requiredCapabilities: Array<RequiredCapability>;
    transportOfferAlgorithm: Maybe<TransportOfferAlgorithm>;
    type: TransportOfferOptionType;
  };

export type TransportOfferOption_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TransportOfferOptionCollection = {
  __typename: 'TransportOfferOptionCollection';
  items: Array<TransportOfferOption>;
  meta: TransportOfferOptionCollectionMetadata;
};

export type TransportOfferOptionCollectionMetadata = CollectionMetadata & {
  __typename: 'TransportOfferOptionCollectionMetadata';
  total: Scalars['Int'];
};

export enum TransportOfferOptionType {
  Applied = 'Applied',
  User = 'User',
}

export enum TransportOfferResponse {
  Aborted = 'Aborted',
  Accepted = 'Accepted',
  Declined = 'Declined',
  Pending = 'Pending',
}

export enum TransportOfferStatus {
  Cancelled = 'Cancelled',
  Candidate = 'Candidate',
  Offered = 'Offered',
  Responded = 'Responded',
  Skipped = 'Skipped',
}

export type TransportReason = Entity &
  Evented & {
    __typename: 'TransportReason';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    operationType: Maybe<OperationType>;
    requests: Maybe<Array<Maybe<RequestPatient>>>;
  };

export type TransportReason_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum TransportReasonCategory {
  Endocrine = 'Endocrine',
  OB = 'OB',
  Surgery = 'Surgery',
}

export type TransportReasonCollection = {
  __typename: 'TransportReasonCollection';
  items: Array<TransportReason>;
  meta: TransportReasonCollectionMetadata;
};

export type TransportReasonCollectionMetadata = CollectionMetadata & {
  __typename: 'TransportReasonCollectionMetadata';
  total: Scalars['Int'];
};

export type TransportReasonFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type TransportReasonQueries = {
  __typename: 'TransportReasonQueries';
  all: TransportReasonCollection;
  byId: Maybe<TransportReason>;
};

export type TransportReasonQueriesallArgs = {
  filter: InputMaybe<TransportReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TransportReasonQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type Trip = Entity &
  Evented & {
    __typename: 'Trip';
    _events: MessageEnvelopeCollection;
    agency: Maybe<Agency>;
    agencyId: Maybe<Scalars['ID']>;
    agencyLocation: Maybe<AgencyLocation>;
    agencyLocationId: Maybe<Scalars['ID']>;
    calculatedLoadedMiles: Maybe<Scalars['Float']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    estimatedDurations: Array<EstimatedDuration>;
    etas: Array<Eta>;
    flightFollowingReports: Array<FlightFollowingReport>;
    gpsLoadedMiles: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    legs: Array<TripLeg>;
    operation: Operation;
    operationId: Scalars['ID'];
    passengers: Array<TripPassenger>;
    positionReports: Array<PositionReport>;
    vehicle: Maybe<Vehicle>;
    vehicleDispositions: Maybe<Array<Maybe<VehicleDisposition>>>;
    vehicleId: Maybe<Scalars['ID']>;
  };

export type Trip_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TripCollection = {
  __typename: 'TripCollection';
  items: Array<Trip>;
  meta: TripCollectionMetadata;
};

export type TripCollectionMetadata = CollectionMetadata & {
  __typename: 'TripCollectionMetadata';
  total: Scalars['Int'];
};

export type TripLeg = Entity &
  Evented & {
    __typename: 'TripLeg';
    _events: MessageEnvelopeCollection;
    abortDate: Maybe<Scalars['DateTime']>;
    arrivingNote: Maybe<Scalars['String']>;
    arrivingOdometerReading: Maybe<Scalars['Float']>;
    calculatedEte: Maybe<EstimatedDuration>;
    calculatedEteId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateOnFinalMarked: Maybe<Scalars['DateTime']>;
    departingNote: Maybe<Scalars['String']>;
    departingOdometerReading: Maybe<Scalars['Float']>;
    encodedPolyline: Maybe<Scalars['String']>;
    endingWaypoint: Maybe<Waypoint>;
    endingWaypointId: Maybe<Scalars['ID']>;
    estimatedDistanceInMiles: Maybe<Scalars['Float']>;
    flightFollowingReports: Maybe<Array<Maybe<FlightFollowingReport>>>;
    id: Scalars['ID'];
    isEmergent: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    manifestEntries: Array<ManifestEntry>;
    officialEte: Maybe<EstimatedDuration>;
    officialEteId: Maybe<Scalars['ID']>;
    sequence: Scalars['Int'];
    startingWaypoint: Maybe<Waypoint>;
    startingWaypointId: Maybe<Scalars['ID']>;
    status: TripLegStatus;
    trip: Trip;
    tripId: Scalars['ID'];
    vehicleDispositions: Maybe<Array<Maybe<VehicleDisposition>>>;
  };

export type TripLeg_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TripLegCollection = {
  __typename: 'TripLegCollection';
  items: Array<TripLeg>;
  meta: TripLegCollectionMetadata;
};

export type TripLegCollectionMetadata = CollectionMetadata & {
  __typename: 'TripLegCollectionMetadata';
  total: Scalars['Int'];
};

export enum TripLegStatus {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  EnRoute = 'EnRoute',
  Planned = 'Planned',
}

export type TripPassenger = Entity &
  Evented & {
    __typename: 'TripPassenger';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    companyId: Scalars['ID'];
    crewMember: Maybe<UnitPosition>;
    crewMemberId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    manifestEntries: Array<ManifestEntry>;
    name: Scalars['String'];
    notificationAddress: Maybe<Scalars['String']>;
    person: Maybe<Person>;
    personId: Maybe<Scalars['ID']>;
    positionName: Maybe<Scalars['String']>;
    positionType: Maybe<UnitPositionType>;
    trip: Trip;
    tripId: Scalars['ID'];
    type: PassengerType;
    weightInKg: Maybe<Scalars['Float']>;
  };

export type TripPassenger_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TripPassengerCollection = {
  __typename: 'TripPassengerCollection';
  items: Array<TripPassenger>;
  meta: TripPassengerCollectionMetadata;
};

export type TripPassengerCollectionMetadata = CollectionMetadata & {
  __typename: 'TripPassengerCollectionMetadata';
  total: Scalars['Int'];
};

export type TrmUser = Entity &
  Evented & {
    __typename: 'TrmUser';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    emailAddress: Scalars['String'];
    firstName: Scalars['String'];
    id: Scalars['ID'];
    lastName: Scalars['String'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    person: Maybe<Person>;
    personId: Maybe<Scalars['ID']>;
    phoneNumber: Scalars['String'];
    trmUserAgencies: Array<TrmUserAgency>;
    trmUserMedicalFacilities: Array<TrmUserMedicalFacility>;
    trmUserPrograms: Array<TrmUserProgram>;
    userStatus: TrmUserStatus;
  };

export type TrmUser_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TrmUserAgency = Entity &
  Evented & {
    __typename: 'TrmUserAgency';
    _events: MessageEnvelopeCollection;
    agency: Agency;
    agencyId: Scalars['ID'];
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    trmUser: TrmUser;
    trmUserId: Scalars['ID'];
  };

export type TrmUserAgency_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TrmUserAgencyCollection = {
  __typename: 'TrmUserAgencyCollection';
  items: Array<TrmUserAgency>;
  meta: TrmUserAgencyCollectionMetadata;
};

export type TrmUserAgencyCollectionMetadata = CollectionMetadata & {
  __typename: 'TrmUserAgencyCollectionMetadata';
  total: Scalars['Int'];
};

export type TrmUserCollection = {
  __typename: 'TrmUserCollection';
  items: Array<TrmUser>;
  meta: TrmUserCollectionMetadata;
};

export type TrmUserCollectionMetadata = CollectionMetadata & {
  __typename: 'TrmUserCollectionMetadata';
  total: Scalars['Int'];
};

export type TrmUserFilter = {
  agencyId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  medicalfacilityId: InputMaybe<Scalars['ID']>;
  prefProgramId: InputMaybe<Scalars['ID']>;
  userStatus: InputMaybe<TrmUserStatus>;
  usernameLike: InputMaybe<Scalars['String']>;
};

export type TrmUserMedicalFacility = Entity &
  Evented & {
    __typename: 'TrmUserMedicalFacility';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    medicalFacility: MedicalFacility;
    medicalFacilityId: Scalars['ID'];
    trmUser: TrmUser;
    trmUserId: Scalars['ID'];
  };

export type TrmUserMedicalFacility_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TrmUserMedicalFacilityCollection = {
  __typename: 'TrmUserMedicalFacilityCollection';
  items: Array<TrmUserMedicalFacility>;
  meta: TrmUserMedicalFacilityCollectionMetadata;
};

export type TrmUserMedicalFacilityCollectionMetadata = CollectionMetadata & {
  __typename: 'TrmUserMedicalFacilityCollectionMetadata';
  total: Scalars['Int'];
};

export type TrmUserProgram = Entity &
  Evented & {
    __typename: 'TrmUserProgram';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    isPreferred: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    program: Program;
    programId: Scalars['ID'];
    trmUser: TrmUser;
    trmUserId: Scalars['ID'];
  };

export type TrmUserProgram_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type TrmUserProgramCollection = {
  __typename: 'TrmUserProgramCollection';
  items: Array<TrmUserProgram>;
  meta: TrmUserProgramCollectionMetadata;
};

export type TrmUserProgramCollectionMetadata = CollectionMetadata & {
  __typename: 'TrmUserProgramCollectionMetadata';
  total: Scalars['Int'];
};

export type TrmUserQueries = {
  __typename: 'TrmUserQueries';
  all: TrmUserCollection;
};

export type TrmUserQueriesallArgs = {
  filter: InputMaybe<TrmUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export enum TrmUserStatus {
  Approved = 'Approved',
  Deactivated = 'Deactivated',
  Denied = 'Denied',
  Pending = 'Pending',
  Unverified = 'Unverified',
}

export type UnDeleteCard = {
  cardId: Scalars['ID'];
};

export type UndeleteExternalReference = {
  id: Scalars['ID'];
};

export type UndeleteVehicle = {
  id: Scalars['ID'];
};

export type UndoAbortOperation = {
  cardId: Scalars['ID'];
};

export type UndoArriveVehicle = {
  vehicleId: Scalars['ID'];
};

export type UndoDepartVehicle = {
  vehicleId: Scalars['ID'];
};

export type UnhideUnit = {
  unitId: Scalars['ID'];
};

export type UnhideVehicle = {
  vehicleId: Scalars['ID'];
};

export type Unit = Entity &
  Evented & {
    __typename: 'Unit';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    activeCardUnitOfferings: Array<ActiveCardUnitOffering>;
    base: Base;
    baseId: Scalars['ID'];
    cardSummaries: Maybe<Array<Maybe<CardSummary>>>;
    companyId: Scalars['ID'];
    completeFlightInstance: Maybe<CompleteFlightInstance>;
    completeFlightInstanceId: Maybe<Scalars['ID']>;
    crewSourcedFromUnit: Maybe<Unit>;
    crewSourcedFromUnitId: Maybe<Scalars['ID']>;
    crewSourcedToUnits: Maybe<Array<Maybe<CrewSourcedUnit>>>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    emSystemMappings: Array<UnitEMSystemMapping>;
    emSystemResourceId: Maybe<Scalars['String']>;
    etloInMinutes: Maybe<Scalars['Int']>;
    excludeStates: Maybe<Array<Maybe<Scalars['String']>>>;
    id: Scalars['ID'];
    integrations: Array<IntegrationSystem>;
    isAdministrative: Maybe<Scalars['Boolean']>;
    isCrewAvailable: Scalars['Boolean'];
    isEnabled: Scalars['Boolean'];
    isExternallyManaged: Scalars['Boolean'];
    isHidden: Maybe<Scalars['Boolean']>;
    isOnDelay: Scalars['Boolean'];
    isSpare: Scalars['Boolean'];
    isThirdPartyUnit: Maybe<Scalars['Boolean']>;
    lastPilotUpdateById: Maybe<Scalars['ID']>;
    lastPilotUpdateTime: Maybe<Scalars['DateTime']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    maximumFlightRule: FlightRule;
    name: Scalars['String'];
    notes: Array<UnitNote>;
    notificationGroups: Maybe<Array<Maybe<NotificationGroup>>>;
    notificationSubscriptions: Array<NotificationSubscription>;
    oemAssets: Maybe<Array<Maybe<OemAsset>>>;
    oemPlacardNumber: Maybe<Scalars['String']>;
    onBaseETAInMinutes: Maybe<Scalars['Int']>;
    operations: Maybe<Array<Maybe<Operation>>>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    parentUnit: Maybe<Unit>;
    parentUnitId: Maybe<Scalars['ID']>;
    pilotNotes: Maybe<Scalars['String']>;
    plannedAvailableNotes: Maybe<Scalars['String']>;
    plannedAvailableTime: Maybe<Scalars['DateTime']>;
    positions: Array<UnitPosition>;
    primaryOutOfServiceEvent: Maybe<OutOfServiceEvent>;
    primaryOutOfServiceEventId: Maybe<Scalars['ID']>;
    region: Region;
    regionId: Scalars['ID'];
    requests: Maybe<Array<Maybe<Request>>>;
    shifts: Array<UnitShift>;
    status: UnitStatus;
    statusHistoryEntries: Array<UnitStatusHistoryEntry>;
    thirdPartyUnit: Maybe<Unit>;
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
    unitActivationRules: Array<UnitActivationRule>;
    units: Maybe<Array<Maybe<Unit>>>;
    updatePhoneNumbersFromExternal: Scalars['Boolean'];
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
    vehicleSummaries: Array<VehicleSummary>;
    weatherStatus: WeatherStatus;
  };

export type Unit_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitActivationRule = Entity &
  Evented & {
    __typename: 'UnitActivationRule';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    maximumDistanceInMiles: Maybe<Scalars['Int']>;
    missionRoleTypes: Array<MissionRoleType>;
    operationTypes: Array<OperationType>;
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type UnitActivationRule_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitActivationRuleCollection = {
  __typename: 'UnitActivationRuleCollection';
  items: Array<UnitActivationRule>;
  meta: UnitActivationRuleCollectionMetadata;
};

export type UnitActivationRuleCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitActivationRuleCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitActivationRuleFilter = {
  unitId: InputMaybe<Scalars['String']>;
};

export type UnitActivationRuleQueries = {
  __typename: 'UnitActivationRuleQueries';
  all: UnitActivationRuleCollection;
  byId: Maybe<UnitActivationRule>;
  byUnitId: Maybe<UnitActivationRule>;
};

export type UnitActivationRuleQueriesallArgs = {
  filter: InputMaybe<UnitActivationRuleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitActivationRuleQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type UnitActivationRuleQueriesbyUnitIdArgs = {
  id: Scalars['ID'];
};

export type UnitCollection = {
  __typename: 'UnitCollection';
  items: Array<Unit>;
  meta: UnitCollectionMetadata;
};

export type UnitCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitEMSystemMapping = Entity &
  Evented & {
    __typename: 'UnitEMSystemMapping';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    divisionName: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    resourceId: Scalars['String'];
    sendGps: Scalars['Boolean'];
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type UnitEMSystemMapping_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitEMSystemMappingCollection = {
  __typename: 'UnitEMSystemMappingCollection';
  items: Array<UnitEMSystemMapping>;
  meta: UnitEMSystemMappingCollectionMetadata;
};

export type UnitEMSystemMappingCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitEMSystemMappingCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitEMSystemMappingFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  unitId: InputMaybe<Scalars['String']>;
};

export type UnitEMSystemMappingQueries = {
  __typename: 'UnitEMSystemMappingQueries';
  all: UnitEMSystemMappingCollection;
  byId: Maybe<UnitEMSystemMapping>;
};

export type UnitEMSystemMappingQueriesallArgs = {
  filter: InputMaybe<UnitEMSystemMappingFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitEMSystemMappingQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type UnitFilter = {
  abbreviationLike: InputMaybe<Scalars['String']>;
  allCompanies: InputMaybe<Scalars['Boolean']>;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  baseId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  excludeDisabled: InputMaybe<Scalars['Boolean']>;
  includeHidden: InputMaybe<Scalars['Boolean']>;
  includeSpare: InputMaybe<Scalars['Boolean']>;
  nameLike: InputMaybe<Scalars['String']>;
  nameOrAbbreviationLike: InputMaybe<Scalars['String']>;
  regionId: InputMaybe<Scalars['ID']>;
};

export type UnitNote = Entity &
  Evented & {
    __typename: 'UnitNote';
    _events: MessageEnvelopeCollection;
    author: Maybe<Person>;
    authorId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    content: Scalars['String'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    noteCategory: Maybe<Scalars['String']>;
    noteMetadataJson: Maybe<Scalars['String']>;
    noteTime: Scalars['DateTime'];
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type UnitNote_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitNoteCollection = {
  __typename: 'UnitNoteCollection';
  items: Array<UnitNote>;
  meta: UnitNoteCollectionMetadata;
};

export type UnitNoteCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitNoteCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitNoteFilter = {
  categoryLike: InputMaybe<Scalars['String']>;
  contentLike: InputMaybe<Scalars['String']>;
  noteTimeFrom: InputMaybe<Scalars['DateTime']>;
  unitId: Scalars['String'];
};

export type UnitNoteQueries = {
  __typename: 'UnitNoteQueries';
  all: UnitNoteCollection;
  byId: Maybe<UnitNote>;
};

export type UnitNoteQueriesallArgs = {
  filter: InputMaybe<UnitNoteFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitNoteQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type UnitNoteResult = {
  __typename: 'UnitNoteResult';
  authorId: Scalars['ID'];
  companyId: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  noteTime: Maybe<Scalars['DateTime']>;
  unitId: Maybe<Scalars['ID']>;
};

export type UnitNoteResultCollection = {
  __typename: 'UnitNoteResultCollection';
  items: Array<UnitNoteResult>;
  meta: UnitNoteResultCollectionMetadata;
};

export type UnitNoteResultCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitNoteResultCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitPosition = Entity &
  Evented & {
    __typename: 'UnitPosition';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    firstName: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isFlightCrew: Scalars['Boolean'];
    isNonEmployee: Scalars['Boolean'];
    lastName: Maybe<Scalars['String']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    notificationAddress: Maybe<Scalars['String']>;
    teamMember: Maybe<Person>;
    teamMemberId: Maybe<Scalars['ID']>;
    trips: Maybe<Array<Maybe<TripPassenger>>>;
    type: UnitPositionType;
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type UnitPosition_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitPositionCollection = {
  __typename: 'UnitPositionCollection';
  items: Array<UnitPosition>;
  meta: UnitPositionCollectionMetadata;
};

export type UnitPositionCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitPositionCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitPositionFilter = {
  unitId: InputMaybe<Scalars['ID']>;
};

export type UnitPositionQueries = {
  __typename: 'UnitPositionQueries';
  all: Array<UnitPosition>;
};

export type UnitPositionQueriesallArgs = {
  filter: InputMaybe<UnitPositionFilter>;
};

export type UnitPositionSnapshot = {
  __typename: 'UnitPositionSnapshot';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  type: UnitPositionType;
};

export type UnitPositionSnapshotInput = {
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  type: UnitPositionType;
};

export type UnitPositionSummary = {
  __typename: 'UnitPositionSummary';
  id: Scalars['ID'];
  isFlightCrew: Scalars['Boolean'];
  isNonCompliant: Scalars['Boolean'];
  isNonEmployee: Scalars['Boolean'];
  name: Scalars['String'];
  nonComplianceReason: Maybe<Scalars['String']>;
  notificationAddress: Maybe<Scalars['String']>;
  teamMemberFirstName: Maybe<Scalars['String']>;
  teamMemberId: Maybe<Scalars['ID']>;
  teamMemberLastName: Maybe<Scalars['String']>;
  type: UnitPositionType;
};

export type UnitPositionSummaryInput = {
  id: Scalars['ID'];
  isFlightCrew: Scalars['Boolean'];
  isNonCompliant: Scalars['Boolean'];
  isNonEmployee: Scalars['Boolean'];
  name: Scalars['String'];
  nonComplianceReason: InputMaybe<Scalars['String']>;
  notificationAddress: InputMaybe<Scalars['String']>;
  teamMemberFirstName: InputMaybe<Scalars['String']>;
  teamMemberId: InputMaybe<Scalars['ID']>;
  teamMemberLastName: InputMaybe<Scalars['String']>;
  type: UnitPositionType;
};

export enum UnitPositionType {
  Clinician = 'Clinician',
  ClinicianTrainee = 'ClinicianTrainee',
  CoPilot = 'CoPilot',
  Driver = 'Driver',
  Mechanic = 'Mechanic',
  Nurse = 'Nurse',
  Observer = 'Observer',
  Other = 'Other',
  Paramedic = 'Paramedic',
  Pilot = 'Pilot',
  PilotTrainee = 'PilotTrainee',
}

export type UnitQueries = {
  __typename: 'UnitQueries';
  all: UnitCollection;
  byId: Maybe<Unit>;
  byVehicleId: Maybe<Unit>;
  summaries: UnitSummaryCollection;
  summaryById: Maybe<UnitSummary>;
};

export type UnitQueriesallArgs = {
  filter: InputMaybe<UnitFilter>;
};

export type UnitQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type UnitQueriesbyVehicleIdArgs = {
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type UnitQueriessummariesArgs = {
  fetchpolicy: InputMaybe<FetchPolicy>;
  filter: InputMaybe<UnitSummaryFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitQueriessummaryByIdArgs = {
  id: Scalars['ID'];
};

export enum UnitResponse {
  Aborted = 'Aborted',
  Assigned = 'Assigned',
  Declined = 'Declined',
  Offered = 'Offered',
  TransportCheckInitiated = 'TransportCheckInitiated',
}

export type UnitShift = Entity &
  Evented & {
    __typename: 'UnitShift';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    endTimeInMinutes: Scalars['Int'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    startTimeInMinutes: Scalars['Int'];
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type UnitShift_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitShiftCollection = {
  __typename: 'UnitShiftCollection';
  items: Array<UnitShift>;
  meta: UnitShiftCollectionMetadata;
};

export type UnitShiftCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitShiftCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitShiftFilter = {
  nameLike: InputMaybe<Scalars['String']>;
  unitId: InputMaybe<Scalars['String']>;
};

export type UnitShiftQueries = {
  __typename: 'UnitShiftQueries';
  all: UnitShiftCollection;
  byId: Maybe<UnitShift>;
};

export type UnitShiftQueriesallArgs = {
  filter: InputMaybe<UnitShiftFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitShiftQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type UnitShiftSummary = {
  __typename: 'UnitShiftSummary';
  endTimeInMinutes: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startTimeInMinutes: Scalars['Int'];
};

export type UnitShiftSummaryInput = {
  endTimeInMinutes: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startTimeInMinutes: Scalars['Int'];
};

export enum UnitStatus {
  Available = 'Available',
  Committed = 'Committed',
  OnStandby = 'OnStandby',
  OutOfService = 'OutOfService',
  PartiallyAvailable = 'PartiallyAvailable',
}

export type UnitStatusHistoryEntry = Entity &
  Evented & {
    __typename: 'UnitStatusHistoryEntry';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    endTime: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    startTime: Scalars['DateTime'];
    status: UnitStatus;
    unit: Unit;
    unitId: Scalars['ID'];
  };

export type UnitStatusHistoryEntry_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitStatusHistoryEntryCollection = {
  __typename: 'UnitStatusHistoryEntryCollection';
  items: Array<UnitStatusHistoryEntry>;
  meta: UnitStatusHistoryEntryCollectionMetadata;
};

export type UnitStatusHistoryEntryCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitStatusHistoryEntryCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitSummary = Entity &
  Evented & {
    __typename: 'UnitSummary';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    base: Base;
    baseId: Scalars['ID'];
    baseTimezoneCd: Maybe<Scalars['String']>;
    cardSummaries: Maybe<Array<Maybe<CardSummary>>>;
    communicationCenter: Maybe<CommunicationCenter>;
    communicationCenterId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    etloInMinutes: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    isAdministrative: Maybe<Scalars['Boolean']>;
    isCrewAvailable: Scalars['Boolean'];
    isEnabled: Scalars['Boolean'];
    isExternallyManaged: Scalars['Boolean'];
    isHidden: Maybe<Scalars['Boolean']>;
    isOnDelay: Scalars['Boolean'];
    isSpare: Scalars['Boolean'];
    isThirdPartyUnit: Maybe<Scalars['Boolean']>;
    lastPilotUpdateById: Maybe<Scalars['ID']>;
    lastPilotUpdateName: Maybe<Scalars['String']>;
    lastPilotUpdateTime: Maybe<Scalars['DateTime']>;
    maximumFlightRule: FlightRule;
    name: Scalars['String'];
    outOfServiceEvents: Array<OutOfServiceEventSummary>;
    paipEventIds: Maybe<Array<Maybe<IdListItem>>>;
    pilotNotes: Maybe<Scalars['String']>;
    plannedAvailableNotes: Maybe<Scalars['String']>;
    plannedAvailableTime: Maybe<Scalars['DateTime']>;
    positions: Array<UnitPositionSummary>;
    region: Region;
    regionId: Scalars['ID'];
    shifts: Array<UnitShiftSummary>;
    status: UnitStatus;
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
    vehicleSummary: Maybe<VehicleSummary>;
    vehicleSummaryId: Maybe<Scalars['ID']>;
    weatherStatus: WeatherStatus;
  };

export type UnitSummary_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type UnitSummaryCollection = {
  __typename: 'UnitSummaryCollection';
  items: Array<UnitSummary>;
  meta: UnitSummaryCollectionMetadata;
};

export type UnitSummaryCollectionMetadata = CollectionMetadata & {
  __typename: 'UnitSummaryCollectionMetadata';
  total: Scalars['Int'];
};

export type UnitSummaryFilter = {
  afterDate: InputMaybe<Scalars['DateTime']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  controlZoneCompanyId: InputMaybe<Scalars['ID']>;
  controlZoneId: InputMaybe<Scalars['ID']>;
  includeExternalSystem: InputMaybe<Scalars['Boolean']>;
  includeHidden: InputMaybe<Scalars['Boolean']>;
  includeSpare: InputMaybe<Scalars['Boolean']>;
  includeThirdParty: InputMaybe<Scalars['Boolean']>;
  regionId: InputMaybe<Scalars['ID']>;
  tcsManagedUnits: InputMaybe<Scalars['Boolean']>;
};

export type UnmarkMedicalFacilityAsDuplicate = {
  medicalFacilityId: Scalars['ID'];
};

export type UpdateAccessibleItem = {
  entityId: Scalars['ID'];
  id: Scalars['ID'];
  personId: Scalars['ID'];
  type: EntityType;
  userRoles: InputMaybe<Array<InputMaybe<UserRole>>>;
};

export type UpdateActivationRule = {
  address: InputMaybe<AddressInput>;
  ageInMinutes: InputMaybe<Scalars['Int']>;
  automatedAlertAlgorithmType: InputMaybe<AutomatedAlertAlgorithmType>;
  baseId: InputMaybe<Scalars['ID']>;
  communicationCenterIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companyId: InputMaybe<Scalars['ID']>;
  companyIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  declineReasonIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  isShared: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  missionRoleTypes: InputMaybe<Array<InputMaybe<MissionRoleType>>>;
  name: InputMaybe<Scalars['String']>;
  operationTypes: InputMaybe<Array<InputMaybe<OperationType>>>;
  outOfServiceReasonId: InputMaybe<Scalars['ID']>;
  outOfServiceType: InputMaybe<OutOfServiceType>;
  paipReasonId: InputMaybe<Scalars['ID']>;
  regionId: InputMaybe<Scalars['ID']>;
  specialtyTeamId: InputMaybe<Scalars['ID']>;
  systemTimestampType: InputMaybe<SystemTimestampType>;
  timestampTypeId: InputMaybe<Scalars['ID']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
  vehicleTypes: InputMaybe<Array<InputMaybe<VehicleType>>>;
  waypointTypes: InputMaybe<Array<InputMaybe<WaypointType>>>;
};

export type UpdateActiveAlert = {
  activationTime: InputMaybe<Scalars['DateTime']>;
  authorId: InputMaybe<Scalars['ID']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
  definitionId: InputMaybe<Scalars['ID']>;
  entityId: InputMaybe<Scalars['ID']>;
  entityType: InputMaybe<EntityType>;
  escalationDurationInSeconds: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  isAcknowledgementRepeatable: Scalars['Boolean'];
  isAudible: Scalars['Boolean'];
  isGpsAlert: Scalars['Boolean'];
  lifecycleStage: AlertLifecycleStage;
  lookupHash: InputMaybe<Scalars['String']>;
  matchType: RuleMatchType;
  regionId: InputMaybe<Scalars['ID']>;
  requiresAcknowledgement: Scalars['Boolean'];
  snoozeMaxInSeconds: InputMaybe<Scalars['Int']>;
  title: InputMaybe<Scalars['String']>;
  urgency: AlertUrgency;
  visibilityType: VisibilityType;
};

export type UpdateActiveTimeline = {
  companyId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: EntityType;
  id: Scalars['ID'];
  matchType: RuleMatchType;
  timelineId: Scalars['ID'];
};

export type UpdateAgency = {
  abbreviation: Scalars['String'];
  id: Scalars['ID'];
  isCompetitor: Scalars['Boolean'];
  isInternallyOwned: Scalars['Boolean'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  parentCompanyId: InputMaybe<Scalars['ID']>;
  type: AgencyType;
};

export type UpdateAgencyLocation = {
  address: AddressInput;
  agencyId: Scalars['ID'];
  emailAddress: InputMaybe<Scalars['String']>;
  estimatedDepartureTimeInMinutes: InputMaybe<Scalars['Int']>;
  faxPhoneNumber: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isInTransportNet: Scalars['Boolean'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  secondaryPhoneNumber: InputMaybe<Scalars['String']>;
  smsPhoneNumber: InputMaybe<Scalars['String']>;
  vehicleType: InputMaybe<VehicleType>;
};

export type UpdateAirport = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  airportCodeType: AirportCodeType;
  airportType: Scalars['String'];
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  preferredFboId: InputMaybe<Scalars['ID']>;
  sourceSystemId: InputMaybe<Scalars['Int']>;
};

export type UpdateAlert = {
  activationRuleId: Scalars['ID'];
  content: Scalars['String'];
  effectiveDate: InputMaybe<Scalars['DateTime']>;
  entityType: EntityType;
  expirationDate: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAudible: Scalars['Boolean'];
  lifecycleStage: AlertLifecycleStage;
  paused: InputMaybe<Scalars['Boolean']>;
  requiresAcknowledgement: Scalars['Boolean'];
  target: InputMaybe<AlertTarget>;
  title: InputMaybe<Scalars['String']>;
  urgency: AlertUrgency;
};

export type UpdateApplicationNotification = {
  companyId: InputMaybe<Scalars['ID']>;
  createdById: InputMaybe<Scalars['ID']>;
  dismissable: Scalars['Boolean'];
  displayOnBanner: Scalars['Boolean'];
  effectiveDate: InputMaybe<Scalars['DateTime']>;
  expirationDate: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notification: Scalars['String'];
  regionId: InputMaybe<Scalars['ID']>;
  title: InputMaybe<Scalars['String']>;
  urgency: ApplicationNotificationUrgency;
};

export type UpdateAssignmentDelayedReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateBase = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  brandName: InputMaybe<Scalars['String']>;
  businessModel: BusinessModel;
  communicationCenterCustomIdentifiers: InputMaybe<Array<InputMaybe<IdNameListItemInput>>>;
  companyId: Scalars['ID'];
  crewPhoneNumber1: InputMaybe<Scalars['String']>;
  crewPhoneNumber2: InputMaybe<Scalars['String']>;
  dateLastUpdatedFromGMRWorkday: InputMaybe<Scalars['DateTime']>;
  dateOfMaturity: InputMaybe<Scalars['DateTime']>;
  dispatchBaseId: InputMaybe<Scalars['ID']>;
  enableFlightLogDutyLog: InputMaybe<Scalars['Boolean']>;
  estimatedLiftoffTime: InputMaybe<Scalars['Int']>;
  gmrWorkdayLocationId: InputMaybe<Scalars['String']>;
  hoursOfOperation: HoursOfOperationInput;
  id: Scalars['ID'];
  licenseNumber: InputMaybe<Scalars['String']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  operationsStarted: InputMaybe<Scalars['DateTime']>;
  operationsTerminated: InputMaybe<Scalars['DateTime']>;
  pilotPhoneNumber: InputMaybe<Scalars['String']>;
  plannedOperationsStart: InputMaybe<Scalars['DateTime']>;
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  reportBaseId: InputMaybe<Scalars['ID']>;
  shouldUpdateLocation: InputMaybe<Scalars['Boolean']>;
  timezoneCd: InputMaybe<Scalars['String']>;
};

export type UpdateBaseControlZone = {
  baseId: Scalars['ID'];
  companyId: Scalars['ID'];
  controlZoneId: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateBaseCustomIdentifiers = {
  baseId: Scalars['ID'];
  identifiersWithCommCenterId: Array<IdNameListItemInput>;
};

export type UpdateBaseMedicalControlContact = {
  baseId: Scalars['ID'];
  id: Scalars['ID'];
  licensedStates: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  personId: Scalars['ID'];
  rank: Scalars['Int'];
  specialty: InputMaybe<Scalars['String']>;
};

export type UpdateCancellation = {
  cancellationReasonId: Scalars['ID'];
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  crewNotified: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  responseReceived: InputMaybe<Scalars['DateTime']>;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitId: Scalars['ID'];
};

export type UpdateCancellationCategory = {
  defaultCancellationReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isVisibleInOps: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateCancellationReason = {
  abbreviation: Scalars['String'];
  canBeUnitCancellationReason: InputMaybe<Scalars['Boolean']>;
  cancellationCategoryId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isTransferCenterReason: Scalars['Boolean'];
  name: Scalars['String'];
  secondaryReasonRequired: Scalars['Boolean'];
};

export type UpdateCancellationSecondaryReason = {
  cancellationReasonId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCapability = {
  abbreviation: Scalars['String'];
  description: Scalars['String'];
  entityType: EntityType;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCard = {
  apiWebhookSubscriptionId: InputMaybe<Scalars['ID']>;
  cardNumber: Scalars['String'];
  closeComment: InputMaybe<Scalars['String']>;
  crewWillTransportWithReplacementGroundUnit: InputMaybe<Scalars['Boolean']>;
  dateCardClosed: InputMaybe<Scalars['DateTime']>;
  dateContactCompleted: InputMaybe<Scalars['DateTime']>;
  diversionType: InputMaybe<DiversionType>;
  gmrCADNumber: InputMaybe<Scalars['String']>;
  gmrUtilizationStatus: InputMaybe<AmrUtilizationStatus>;
  id: Scalars['ID'];
  isBillable: InputMaybe<Scalars['Boolean']>;
  isLocked: InputMaybe<Scalars['Boolean']>;
  lastOperationId: InputMaybe<Scalars['ID']>;
  linkedCardId: InputMaybe<Scalars['ID']>;
  notBillableComment: InputMaybe<Scalars['String']>;
  notBillableType: InputMaybe<NotBillableType>;
  operationId: InputMaybe<Scalars['ID']>;
  plannedCompletionTime: InputMaybe<Scalars['DateTime']>;
  postTransportDebriefCompleted: InputMaybe<Scalars['Boolean']>;
  reOpenComment: InputMaybe<Scalars['String']>;
  reOpenReasonId: InputMaybe<Scalars['ID']>;
  requestId: InputMaybe<Scalars['ID']>;
  status: CardStatus;
  transferredFromCardId: InputMaybe<Scalars['ID']>;
  transferredToCardId: InputMaybe<Scalars['ID']>;
};

export type UpdateCardBillable = {
  cardId: Scalars['ID'];
  isBillable: Scalars['Boolean'];
  notBillableComment: InputMaybe<Scalars['String']>;
  notBillableType: InputMaybe<NotBillableType>;
};

export type UpdateCardContactCompleted = {
  id: Scalars['ID'];
};

export type UpdateCardDiversionType = {
  cardId: Scalars['ID'];
  diversionType: InputMaybe<DiversionType>;
};

export type UpdateCardLink = {
  fromCardId: Scalars['ID'];
  id: Scalars['ID'];
  rendezvousRequestId: InputMaybe<Scalars['ID']>;
  toCardId: Scalars['ID'];
  toCardNumber: Scalars['String'];
  type: CardLinkType;
};

export type UpdateCardNote = {
  content: Scalars['String'];
  id: Scalars['ID'];
  noteTime: Scalars['DateTime'];
};

export type UpdateCardNoteArchive = {
  cardId: Scalars['ID'];
  content: Scalars['String'];
  id: Scalars['ID'];
  isInternal: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  noteCategory: InputMaybe<Scalars['String']>;
  noteMetadataJson: InputMaybe<Scalars['String']>;
  noteTime: Scalars['DateTime'];
  receivedFromCardId: InputMaybe<Scalars['ID']>;
  sentToCards: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
};

export type UpdateCardReOpenReason = {
  affectsTrip: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCardSearchIndex = {
  cardId: Scalars['ID'];
  ifOlderThan: InputMaybe<Scalars['DateTime']>;
};

export type UpdateChiefComplaint = {
  notes: InputMaybe<Scalars['String']>;
  requestPatientId: Scalars['ID'];
  transportReasonCategory: InputMaybe<TransportReasonCategory>;
  transportReasonId: InputMaybe<Scalars['ID']>;
};

export type UpdateCommunicationCenter = {
  alertFrequencyForGroundVehicles: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  displayContactTimeline: Scalars['Boolean'];
  emailAddress: InputMaybe<Scalars['String']>;
  enableRAAlert: Scalars['Boolean'];
  id: Scalars['ID'];
  includeCompetitors: Scalars['Boolean'];
  name: Scalars['String'];
  playAlertForManualPositionReports: Scalars['Boolean'];
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  showReferToGmrWarning: InputMaybe<Scalars['Boolean']>;
  states: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timezoneCd: InputMaybe<Scalars['String']>;
  useCrewPhoneNumber: Scalars['Boolean'];
};

export type UpdateCommunicationCenterTransportOfferOption = {
  communicationCenterId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  includeAbortedUnit: Scalars['Boolean'];
  includeCompetitors: InputMaybe<Scalars['Boolean']>;
  minimumFlightRule: InputMaybe<FlightRule>;
  requestedVehicleType: InputMaybe<VehicleType>;
  requiredCapabilities: Array<RequiredCapabilityIdListInput>;
  transportOfferAlgorithm: InputMaybe<TransportOfferAlgorithm>;
};

export type UpdateCompany = {
  abbreviation: Scalars['String'];
  callNumberPrefix: InputMaybe<Scalars['String']>;
  companyCode: Scalars['String'];
  crewPatientInfoPageNotificationTemplateId: InputMaybe<Scalars['ID']>;
  enableNotificationGroupTypes: Scalars['Boolean'];
  flightFollowingFields: InputMaybe<Array<InputMaybe<FlightFollowingField>>>;
  gLCode: InputMaybe<Scalars['String']>;
  gpsFeedResetsPositionReportTime: Scalars['Boolean'];
  hasPrivateUnits: Scalars['Boolean'];
  id: Scalars['ID'];
  imageUri: InputMaybe<Scalars['String']>;
  includeCompetitors: Scalars['Boolean'];
  isOemCompany: Scalars['Boolean'];
  name: Scalars['String'];
  requireSkipReasonsForNonCompanyTransportOffers: InputMaybe<Scalars['Boolean']>;
  restrictRiskAnalysisAcknowledgementToOCCRole: Scalars['Boolean'];
  timezoneCd: InputMaybe<Scalars['String']>;
  transportCheckTimerDurationInMinutes: InputMaybe<Scalars['Int']>;
  unitRemainsInServiceWithNoVehicle: Scalars['Boolean'];
};

export type UpdateCompleteFlightInstance = {
  apiKey: Scalars['String'];
  completeFlightInstanceName: Scalars['String'];
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type UpdateConfigurationSetting = {
  assetReassignedDeclineReasonId: InputMaybe<Scalars['ID']>;
  bugRequestEmail: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  crewGoingByGroundOutOfServiceReasonId: InputMaybe<Scalars['ID']>;
  defaultUnitCommittedDeclineReasonId: InputMaybe<Scalars['ID']>;
  defaultUnitOutOfServiceDeclineReasonId: InputMaybe<Scalars['ID']>;
  externallyCancelledCancellationReasonId: InputMaybe<Scalars['ID']>;
  featureRequestEmail: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pilotReportGracePeriodInMinutes: InputMaybe<Scalars['Int']>;
  proximityAlertDistanceInNauticalMiles: InputMaybe<Scalars['Float']>;
  requestReferredExternallyCancellationReasonId: InputMaybe<Scalars['ID']>;
  requestReferredInternallyCancellationReasonId: InputMaybe<Scalars['ID']>;
  sameDestinationWarningThresholdInMinutes: InputMaybe<Scalars['Int']>;
};

export type UpdateControlZone = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDecline = {
  crewNotified: InputMaybe<Scalars['DateTime']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  responseReceived: InputMaybe<Scalars['DateTime']>;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitId: Scalars['ID'];
};

export type UpdateDeclineCategory = {
  defaultDeclineReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isVisibleInOps: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateDeclineReason = {
  abbreviation: Scalars['String'];
  canBeAbortReason: Scalars['Boolean'];
  canBeBulkSkipReason: Scalars['Boolean'];
  canBeOneCallSkipReason: Scalars['Boolean'];
  canBeSkipReason: Scalars['Boolean'];
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  controllable: Scalars['Boolean'];
  declineCategoryId: Scalars['ID'];
  id: Scalars['ID'];
  isUnitAvailableAfterAbort: Scalars['Boolean'];
  name: Scalars['String'];
  secondaryReasonRequired: Scalars['Boolean'];
};

export type UpdateDeclineSecondaryReason = {
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  declineReasonId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDepartment = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDiversionReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateEmsReport = {
  cardId: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  rendezvousRequestId: Scalars['ID'];
  time: Scalars['DateTime'];
  transportUnitNumber: InputMaybe<Scalars['String']>;
};

export type UpdateEscortRequest = {
  escortName: Scalars['String'];
  escortWeightInKg: Scalars['Float'];
  id: Scalars['ID'];
  relationship: PatientRelationshipType;
  requestApprovalTime: Scalars['DateTime'];
  requestId: Scalars['ID'];
};

export type UpdateEstimatedDurations = {
  asOfTime: Scalars['DateTime'];
  currentOrNextTripLegId: Scalars['ID'];
  estimateSource: EstimatedDurationSource;
  estimatedDepartureTimeInMinutes: InputMaybe<Scalars['Int']>;
  estimatedEnRouteTimeInMinutes: InputMaybe<Scalars['Int']>;
};

export type UpdateExternalAction = {
  actionBodyJson: Scalars['String'];
  actionTypeId: Scalars['ID'];
  completedById: InputMaybe<Scalars['ID']>;
  dateCompleted: InputMaybe<Scalars['DateTime']>;
  entityId: Scalars['ID'];
  entityType: EntityType;
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  status: ExternalActionStatus;
};

export type UpdateExternalActionType = {
  actionTypeDescription: Scalars['String'];
  actionTypeName: Scalars['String'];
  id: Scalars['ID'];
  priority: Scalars['Int'];
};

export type UpdateExternalReference = {
  entityId: Scalars['ID'];
  entityType: EntityType;
  externalKey: Scalars['String'];
  externalSystem: ExternalSystem;
  id: Scalars['ID'];
};

export type UpdateFacilityNonAcceptanceReason = {
  facilityNonAcceptanceReasonType: NonAcceptanceType;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateFbo = {
  address: AddressInput;
  airportId: Scalars['ID'];
  fboType: FboType;
  fuelBrand: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sourceSystemId: InputMaybe<Scalars['Int']>;
};

export type UpdateFirewallRule = {
  action: AccessControlAction;
  companyId: InputMaybe<Scalars['ID']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  ipRange: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateFlightFollowingReport = {
  centerOfGravity: InputMaybe<Scalars['Float']>;
  confirmedFboId: InputMaybe<Scalars['ID']>;
  cruisingAltitude: InputMaybe<Scalars['Int']>;
  departureTime: InputMaybe<Scalars['DateTime']>;
  destination: InputMaybe<Scalars['String']>;
  estimatedTimeEnrouteMinutes: InputMaybe<Scalars['Int']>;
  flightRule: InputMaybe<FlightRule>;
  flightType: InputMaybe<FlightType>;
  fuel: InputMaybe<Scalars['String']>;
  highestFeatureEnroute: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  licenseRequiredToFlyAcknowledged: InputMaybe<Scalars['Boolean']>;
  medicalCrewRA: InputMaybe<Scalars['Int']>;
  operationId: InputMaybe<Scalars['ID']>;
  placeUnitEnRoute: InputMaybe<Scalars['Boolean']>;
  riskAnalysis: InputMaybe<Scalars['String']>;
  riskAnalysisAcknowledged: InputMaybe<Scalars['Boolean']>;
  riskAnalysisNumber: InputMaybe<Scalars['String']>;
  soulsOnBoard: InputMaybe<Scalars['Int']>;
  summary: InputMaybe<Scalars['String']>;
  takeOffWeight: InputMaybe<Scalars['Float']>;
  trackingViaGps: InputMaybe<Scalars['Boolean']>;
  tripId: Scalars['ID'];
  tripLegId: InputMaybe<Scalars['ID']>;
};

export type UpdateFuelTank = {
  address: AddressInput;
  baseId: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  locationName: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  operationsEnded: InputMaybe<Scalars['DateTime']>;
  operationsStarted: InputMaybe<Scalars['DateTime']>;
  sourceSystemId: InputMaybe<Scalars['Int']>;
};

export type UpdateGmrCadNumber = {
  cardId: Scalars['ID'];
  gmrCADNumber: InputMaybe<Scalars['String']>;
};

export type UpdateLocation = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  closedDate: InputMaybe<Scalars['DateTime']>;
  duplicateOfId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isLandingZoneOutOfService: InputMaybe<Scalars['Boolean']>;
  isPreferred: Scalars['Boolean'];
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  landingZoneOutOfServiceExpirationDate: InputMaybe<Scalars['DateTime']>;
  landingZoneOutOfServiceNotes: InputMaybe<Scalars['String']>;
  landingZoneOutOfServiceReasonId: InputMaybe<Scalars['ID']>;
  locationType: LocationType;
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  sourceSystemId: InputMaybe<Scalars['String']>;
  timezoneCd: InputMaybe<Scalars['String']>;
};

export type UpdateLocationHazard = {
  effectiveDate: InputMaybe<Scalars['DateTime']>;
  expirationDate: InputMaybe<Scalars['DateTime']>;
  hazard: Scalars['String'];
  id: Scalars['ID'];
  locationId: Scalars['ID'];
};

export type UpdateMaintenanceFacility = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  id: Scalars['ID'];
  isPreferred: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateManifestEntry = {
  confirmedAt: InputMaybe<Scalars['DateTime']>;
  confirmedById: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  passengerId: Scalars['ID'];
  tripLegId: Scalars['ID'];
};

export type UpdateMedicalControlContactLogEntry = {
  cardId: Scalars['ID'];
  id: Scalars['ID'];
  isSuccessful: Scalars['Boolean'];
  notes: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  time: Scalars['DateTime'];
};

export type UpdateMedicalFacility = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  closedDate: InputMaybe<Scalars['DateTime']>;
  defaultFixedWingLandingZoneId: InputMaybe<Scalars['ID']>;
  defaultLandingZoneId: InputMaybe<Scalars['ID']>;
  firmType: InputMaybe<Scalars['String']>;
  hospitalSpecialization: InputMaybe<Scalars['String']>;
  hospitalType: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPreferred: Scalars['Boolean'];
  masterDataSetId: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nemsisCode: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  npi: Scalars['String'];
  providerNumber: InputMaybe<Scalars['String']>;
  sourceSystemId: InputMaybe<Scalars['Int']>;
  stateFacilityName: InputMaybe<Scalars['String']>;
  stateSourceSystemId: InputMaybe<Scalars['ID']>;
  status: InputMaybe<MedicalFacilityStatus>;
  website: InputMaybe<Scalars['String']>;
};

export type UpdateMedicalFacilityContact = {
  emailAddress: InputMaybe<Scalars['String']>;
  faxPhoneNumber: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  medicalFacilityId: Scalars['ID'];
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  primaryPhoneNumber: InputMaybe<Scalars['String']>;
  secondaryPhoneNumber: InputMaybe<Scalars['String']>;
  smsPhoneNumber: InputMaybe<Scalars['String']>;
};

export type UpdateMedicalFacilityCustomIdentifiers = {
  identifiersWithCommCenterId: Array<IdNameListItemInput>;
  medicalFacilityId: Scalars['ID'];
};

export type UpdateMedicalFacilityPhysician = {
  id: Scalars['ID'];
  medicalFacilityId: Scalars['ID'];
  physicianId: Scalars['ID'];
};

export type UpdateMedicalFacilityUnit = {
  id: Scalars['ID'];
  medicalFacilityId: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: InputMaybe<Scalars['String']>;
};

export type UpdateNewAgencyLocationRequest = {
  entityId: InputMaybe<Scalars['ID']>;
  entityType: EntityType;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  requestedByPersonId: Scalars['ID'];
  type: NewAgencyLocationRequestOriginType;
};

export type UpdateNextDueType = {
  dataType: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateNonReferralReason = {
  associatedCancellationReasonId: InputMaybe<Scalars['ID']>;
  associatedCancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateNotification = {
  body: Scalars['String'];
  cardId: InputMaybe<Scalars['ID']>;
  entityId: InputMaybe<Scalars['ID']>;
  entityType: InputMaybe<EntityType>;
  id: Scalars['ID'];
  sourceTemplateId: InputMaybe<Scalars['ID']>;
  status: NotificationStatus;
  subject: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationGroup = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  isEmailNotificationPreferred: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  regionId: InputMaybe<Scalars['ID']>;
  type: InputMaybe<NotificationGroupType>;
  types: InputMaybe<Array<InputMaybe<NotificationGroupType>>>;
  unitId: InputMaybe<Scalars['ID']>;
};

export type UpdateNotificationGroupMember = {
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  notificationGroupId: Scalars['ID'];
  userId: InputMaybe<Scalars['ID']>;
};

export type UpdateNotificationRecipient = {
  id: Scalars['ID'];
  messageId: InputMaybe<Scalars['ID']>;
  messageStatus: InputMaybe<MessageStatus>;
  name: InputMaybe<Scalars['String']>;
  notificationAddress: InputMaybe<Scalars['String']>;
  notificationId: Scalars['ID'];
  userId: InputMaybe<Scalars['ID']>;
};

export type UpdateNotificationSubscription = {
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationGroupId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type UpdateNotificationTemplate = {
  activationRuleId: InputMaybe<Scalars['ID']>;
  bodyTemplate: Scalars['String'];
  canBeManualTrigger: Scalars['Boolean'];
  companyId: InputMaybe<Scalars['ID']>;
  contextType: EntityType;
  groupTypes: InputMaybe<Array<InputMaybe<NotificationGroupType>>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationType: InputMaybe<NotificationType>;
  recipientTypes: InputMaybe<Array<InputMaybe<NotificationRecipientType>>>;
  requiresApproval: InputMaybe<Scalars['Boolean']>;
  subjectTemplate: InputMaybe<Scalars['String']>;
  triggerType: InputMaybe<NotificationTriggerType>;
  triggerValue: InputMaybe<Scalars['String']>;
  viewModelType: InputMaybe<Scalars['String']>;
};

export type UpdateOdometerReadings = {
  arrivingNote: InputMaybe<Scalars['String']>;
  arrivingOdometerReading: InputMaybe<Scalars['Float']>;
  departingNote: InputMaybe<Scalars['String']>;
  departingOdometerReading: InputMaybe<Scalars['Float']>;
  tripLegId: Scalars['ID'];
};

export type UpdateOemActivity = {
  activityType: OemActivityType;
  authorId: InputMaybe<Scalars['ID']>;
  content: InputMaybe<Scalars['String']>;
  currentStatus: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  oemPlanChangeRequestId: InputMaybe<Scalars['ID']>;
  oemPlanId: Scalars['ID'];
  priorStatus: InputMaybe<Scalars['String']>;
  time: InputMaybe<Scalars['DateTime']>;
};

export type UpdateOemAsset = {
  assetDispatchCompanyId: InputMaybe<Scalars['ID']>;
  assetId: Scalars['ID'];
  assetType: OemAssetType;
  id: Scalars['ID'];
  oemPlanId: Scalars['ID'];
  oemUnitId: InputMaybe<Scalars['ID']>;
  originalUnitId: InputMaybe<Scalars['ID']>;
  requestedBaseId: InputMaybe<Scalars['ID']>;
  requestedPlacardNumber: InputMaybe<Scalars['String']>;
  requestedUnitAbbreviation: InputMaybe<Scalars['String']>;
  requestedUnitName: InputMaybe<Scalars['String']>;
  status: OemAssetStatus;
};

export type UpdateOemPlan = {
  companyId: Scalars['ID'];
  defaultBaseId: Scalars['ID'];
  description: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  oemCompanyId: Scalars['ID'];
  outOfServiceReasonId: Scalars['ID'];
  planStatus: OemPlanStatus;
  planYear: Scalars['Int'];
};

export type UpdateOemPlanChangeRequest = {
  dateCancelled: InputMaybe<Scalars['DateTime']>;
  dateCompleted: InputMaybe<Scalars['DateTime']>;
  dateRequested: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  oemAssetId: Scalars['ID'];
  oemPlanId: Scalars['ID'];
  originalAssetStatus: OemAssetStatus;
  requestedAssetStatus: OemAssetStatus;
  requestedById: InputMaybe<Scalars['ID']>;
  status: OemPlanChangeRequestStatus;
};

export type UpdateOfferAlgorithm = {
  activationRuleId: Scalars['ID'];
  companyId: Scalars['ID'];
  companyIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  distanceCalculation: DistanceCalculation;
  id: Scalars['ID'];
  includeCompetitors: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  minimumFlightRule: InputMaybe<FlightRule>;
  name: Scalars['String'];
  oneCallAgreement: Scalars['Boolean'];
  preferredUnits: Array<PreferredUnitInput>;
  rank: Scalars['Int'];
  transportOfferAlgorithm: TransportOfferAlgorithm;
};

export type UpdateOfferRank = {
  id: Scalars['ID'];
  insertAfterId: InputMaybe<Scalars['ID']>;
  insertBeforeId: InputMaybe<Scalars['ID']>;
  notes: InputMaybe<Scalars['String']>;
};

export type UpdateOperation = {
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  dateOperationEnded: InputMaybe<Scalars['DateTime']>;
  dateOperationStarted: Scalars['DateTime'];
  id: Scalars['ID'];
  riskAnalysisAcknowledged: Scalars['Boolean'];
  riskAnalysisNumber: InputMaybe<Scalars['String']>;
  standbyActivationType: InputMaybe<StandbyActivationType>;
  status: OperationStatus;
  type: OperationType;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleId: Scalars['ID'];
};

export type UpdateOperationContactInfo = {
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  operationId: Scalars['ID'];
};

export type UpdateOutOfComplianceCrewMember = {
  comment: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateOutOfServiceEvent = {
  address: InputMaybe<AddressInput>;
  alertTimeInMinutes: InputMaybe<Scalars['Int']>;
  alertWhenEventEnds: Scalars['Boolean'];
  alternatePOC: InputMaybe<Scalars['String']>;
  amtPointOfContactId: InputMaybe<Scalars['ID']>;
  assignedBaseId: InputMaybe<Scalars['ID']>;
  businessUnitCompanyId: InputMaybe<Scalars['ID']>;
  endTime: InputMaybe<Scalars['DateTime']>;
  estimatedEndTime: Scalars['DateTime'];
  humanErrorDamageType: InputMaybe<HumanErrorDamageType>;
  id: Scalars['ID'];
  isAMTAvailable: InputMaybe<Scalars['Boolean']>;
  isAcknowledgementRequired: Scalars['Boolean'];
  isAirworthy: Scalars['Boolean'];
  isBirdStrike: Scalars['Boolean'];
  isFAR135415Reportable: InputMaybe<Scalars['Boolean']>;
  isFAR135417Reportable: InputMaybe<Scalars['Boolean']>;
  isOpportunisticOOS: InputMaybe<Scalars['Boolean']>;
  isPatientOnboard: Scalars['Boolean'];
  isPlanned: Scalars['Boolean'];
  locationId: InputMaybe<Scalars['ID']>;
  maintenanceFacilityId: InputMaybe<Scalars['ID']>;
  maintenanceLocation: InputMaybe<Scalars['String']>;
  maintenanceTypes: InputMaybe<Array<InputMaybe<OosTicketMaintenanceType>>>;
  mxDuringPeakTimeReason: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  oosRequestType: InputMaybe<OosRequestType>;
  opportunityMXTypes: InputMaybe<Array<InputMaybe<OpportunityMXType>>>;
  outOfServiceTicketId: InputMaybe<Scalars['ID']>;
  paipEventId: InputMaybe<Scalars['ID']>;
  parentOutOfServiceEventId: InputMaybe<Scalars['ID']>;
  qarReasons: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  reasonId: Scalars['ID'];
  rtsDelayReasonTypes: InputMaybe<Array<InputMaybe<RtsDelayReasonType>>>;
  scheduledStartTime: InputMaybe<Scalars['DateTime']>;
  secondaryReasonComment: InputMaybe<Scalars['String']>;
  secondaryReasonId: InputMaybe<Scalars['ID']>;
  spareVehicleId: InputMaybe<Scalars['ID']>;
  startTime: InputMaybe<Scalars['DateTime']>;
  ticketDescription: InputMaybe<Scalars['String']>;
  type: OutOfServiceType;
  unitRemainsOutOfServiceNotes: InputMaybe<Scalars['String']>;
  unitRemainsOutOfServiceReasonId: InputMaybe<Scalars['ID']>;
  unitRemainsOutOfServiceSecondaryReasonId: InputMaybe<Scalars['ID']>;
  waitingForParts: Scalars['Boolean'];
  waitingForTooling: Scalars['Boolean'];
};

export type UpdateOutOfServiceEventNote = {
  content: Scalars['String'];
  id: Scalars['ID'];
  noteTime: Scalars['DateTime'];
  outOfServiceEventId: Scalars['ID'];
};

export type UpdateOutOfServiceQARReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateOutOfServiceReason = {
  controllable: Scalars['Boolean'];
  description: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isVehicleReason: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateOutOfServiceSecondaryReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
  outOfServiceReasonId: Scalars['ID'];
};

export type UpdatePaipEvent = {
  endTime: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  reasonId: Scalars['ID'];
  regionId: InputMaybe<Scalars['ID']>;
  startTime: Scalars['DateTime'];
  unitIds: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
};

export type UpdatePaipReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
  outOfServiceReasonId: InputMaybe<Scalars['ID']>;
};

export type UpdatePassdownLog = {
  acknowledgedById: InputMaybe<Scalars['ID']>;
  authorId: InputMaybe<Scalars['ID']>;
  body: Scalars['String'];
  dateAcknowledged: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  logDate: Scalars['DateTime'];
  name: Scalars['String'];
  regionId: Scalars['ID'];
  regionIdList: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requiresAcknowledgement: Scalars['Boolean'];
};

export type UpdatePatientClinicalInfo = {
  bpDiastolic: InputMaybe<Scalars['Int']>;
  bpSystolic: InputMaybe<Scalars['Int']>;
  gcs: InputMaybe<Scalars['Int']>;
  heartRate: InputMaybe<Scalars['Int']>;
  medicalRecordNumber: InputMaybe<Scalars['String']>;
  oxygenSaturation: InputMaybe<Scalars['Float']>;
  requestPatientId: Scalars['ID'];
  respiratoryRate: InputMaybe<Scalars['Float']>;
  temperatureInCelsius: InputMaybe<Scalars['Float']>;
  transferReasonId: InputMaybe<Scalars['ID']>;
};

export type UpdatePatientInfo = {
  dateOfBirth: InputMaybe<Scalars['DateTime']>;
  estimatedAgeInHours: InputMaybe<Scalars['Float']>;
  firstName: InputMaybe<Scalars['String']>;
  gender: Gender;
  isIntubated: InputMaybe<Scalars['Boolean']>;
  isIsolette: Scalars['Boolean'];
  isoletteNotes: InputMaybe<Scalars['String']>;
  isoletteType: InputMaybe<IsoletteType>;
  lastName: InputMaybe<Scalars['String']>;
  medicalRecordNumber: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  numberOfDrips: InputMaybe<Scalars['Int']>;
  patientId: InputMaybe<Scalars['ID']>;
  requestId: Scalars['ID'];
  requestPatientId: Scalars['ID'];
  rideAlongDateOfBirth: InputMaybe<Scalars['DateTime']>;
  rideAlongName: InputMaybe<Scalars['String']>;
  rideAlongRequested: InputMaybe<YesNoType>;
  rideAlongWeightInKg: InputMaybe<Scalars['Float']>;
  specialtyEquipment: InputMaybe<Scalars['String']>;
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type UpdatePerson = {
  activateOktaAccount: Scalars['Boolean'];
  activeDirectoryId: InputMaybe<Scalars['String']>;
  allBasesAccessible: InputMaybe<Scalars['Boolean']>;
  allCommunicationCentersAccessible: InputMaybe<Scalars['Boolean']>;
  allCompaniesAccessible: InputMaybe<Scalars['Boolean']>;
  allTrmProgramsAccessible: InputMaybe<Scalars['Boolean']>;
  applyToActiveDirectory: InputMaybe<Scalars['Boolean']>;
  aviationCompanyId: InputMaybe<Scalars['ID']>;
  baseId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  dateLastUpdatedFromGMRWorkday: InputMaybe<Scalars['DateTime']>;
  departmentId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  employeeId: InputMaybe<Scalars['String']>;
  employeeType: EmployeeType;
  faaCompanyId: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  grantTcsAccess: Scalars['Boolean'];
  hireDate: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAviationSupervisor: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationId: InputMaybe<Scalars['ID']>;
  notificationAddress: InputMaybe<Scalars['String']>;
  primaryCommunicationCenterId: InputMaybe<Scalars['ID']>;
  programId: InputMaybe<Scalars['ID']>;
  reportsToPersonId: InputMaybe<Scalars['ID']>;
  terminationDate: InputMaybe<Scalars['DateTime']>;
  timeType: TimeType;
  title: InputMaybe<Scalars['String']>;
};

export type UpdatePhysician = {
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type UpdatePilotUnitConfiguration = {
  etloInMinutes: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  lastPilotUpdateById: InputMaybe<Scalars['ID']>;
  lastPilotUpdateTime: InputMaybe<Scalars['DateTime']>;
  maximumFlightRule: FlightRule;
  pilotNotes: InputMaybe<Scalars['String']>;
  positions: Array<UpsertUnitPosition>;
  weatherStatus: WeatherStatus;
};

export type UpdatePlannedCardCompletionTime = {
  id: Scalars['ID'];
  plannedCompletionTime: Scalars['DateTime'];
};

export type UpdatePositionReport = {
  altitude: InputMaybe<Scalars['Float']>;
  coordinates: InputMaybe<CoordinatesInput>;
  dateConfirmed: InputMaybe<Scalars['DateTime']>;
  estimatedMinutesEnRoute: InputMaybe<Scalars['Int']>;
  fuelRemaining: InputMaybe<Scalars['String']>;
  gpsProvider: InputMaybe<GpsProvider>;
  heading: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  positionTime: Scalars['DateTime'];
  source: PositionReportSource;
  speedInKnots: InputMaybe<Scalars['Float']>;
  timezoneCd: InputMaybe<Scalars['String']>;
  tripId: Scalars['ID'];
};

export type UpdatePositionReportAlert = {
  hasReceivedQualifyingReport: Scalars['Boolean'];
  id: Scalars['ID'];
  vehicleId: Scalars['ID'];
};

export type UpdateProgram = {
  abbreviation: Scalars['String'];
  adminId: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateProgramBase = {
  baseId: Scalars['ID'];
  endTime: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  programId: Scalars['ID'];
  startTime: InputMaybe<Scalars['DateTime']>;
};

export type UpdateQuestion = {
  choices: InputMaybe<Array<InputMaybe<UpsertQuestionChoice>>>;
  dataType: InputMaybe<QuestionDataType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  question: Scalars['String'];
  questionType: QuestionType;
};

export type UpdateQuestionnaire = {
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: InputMaybe<Array<InputMaybe<UpsertQuestionnaireSection>>>;
  type: QuestionnaireType;
};

export type UpdateQuestionnaireQuestionResponse = {
  explanation: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  matchType: RuleMatchType;
  questionnaireResponseId: Scalars['ID'];
  questionnaireSectionQuestionId: Scalars['ID'];
  responseValue: InputMaybe<Scalars['String']>;
  reviewRequired: Scalars['Boolean'];
};

export type UpdateQuestionnaireQuestionResponseDeep = {
  explanation: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  matchType: RuleMatchType;
  notes: Array<UpsertQuestionnaireQuestionResponseNote>;
  questionnaireResponseId: Scalars['ID'];
  questionnaireSectionQuestionId: Scalars['ID'];
  responseValue: InputMaybe<Scalars['String']>;
  reviewRequired: Scalars['Boolean'];
};

export type UpdateQuestionnaireQuestionResponseNote = {
  authorId: Scalars['ID'];
  dateAuthored: Scalars['DateTime'];
  id: Scalars['ID'];
  note: Scalars['String'];
  questionnaireQuestionResponseId: Scalars['ID'];
};

export type UpdateQuestionnaireResponse = {
  cardId: Scalars['ID'];
  communicationsReviewById: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  completedById: InputMaybe<Scalars['ID']>;
  currentReviewLevel: InputMaybe<UserRole>;
  dateCommunicationsReviewed: InputMaybe<Scalars['DateTime']>;
  dateCompleted: InputMaybe<Scalars['DateTime']>;
  dateManagerReviewed: InputMaybe<Scalars['DateTime']>;
  dateSupervisorReviewed: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  managerReviewById: InputMaybe<Scalars['ID']>;
  questionnaireId: Scalars['ID'];
  status: QuestionnaireResponseStatus;
  supervisorReviewById: InputMaybe<Scalars['ID']>;
};

export type UpdateQuestionnaireResponseDeep = {
  cardId: Scalars['ID'];
  companyId: Scalars['ID'];
  currentReviewLevel: InputMaybe<UserRole>;
  id: Scalars['ID'];
  questionResponses: Array<UpdateQuestionnaireQuestionResponseDeep>;
  questionnaireId: Scalars['ID'];
  status: QuestionnaireResponseStatus;
};

export type UpdateReceivingFacilityAutoAcceptance = {
  isAutoAccept: Scalars['Boolean'];
  requestLocationId: Scalars['ID'];
};

export type UpdateRecipientMessageStatus = {
  notificationRecipientId: InputMaybe<Scalars['ID']>;
  trackedMessageId: InputMaybe<Scalars['ID']>;
};

export type UpdateRegion = {
  abbreviation: Scalars['String'];
  communicationCenterId: Scalars['ID'];
  dispatchNumber: InputMaybe<Scalars['String']>;
  emSystemDivisionName: InputMaybe<Scalars['String']>;
  etcInMinutes: InputMaybe<Scalars['Int']>;
  fixedWingPreferredThresholdInNauticalMiles: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  regionGroupId: Scalars['ID'];
  timezoneCd: InputMaybe<Scalars['String']>;
};

export type UpdateRegionBase = {
  baseId: Scalars['ID'];
  id: Scalars['ID'];
  regionId: Scalars['ID'];
};

export type UpdateRegionGroup = {
  abbreviation: Scalars['String'];
  companyId: Scalars['ID'];
  departmentId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateReleaseNote = {
  description: Scalars['String'];
  id: Scalars['ID'];
  releaseDate: InputMaybe<Scalars['DateTime']>;
  releaseNumber: Scalars['String'];
};

export type UpdateRendezvousRequest = {
  agencyEta: InputMaybe<Scalars['DateTime']>;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  arrivedDestAt: InputMaybe<Scalars['DateTime']>;
  arrivedLzAt: InputMaybe<Scalars['DateTime']>;
  cancelledAt: InputMaybe<Scalars['DateTime']>;
  confirmedAt: InputMaybe<Scalars['DateTime']>;
  contactInformation: InputMaybe<Scalars['String']>;
  departedDestAt: InputMaybe<Scalars['DateTime']>;
  departedLzAt: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  latestStatus: InputMaybe<Scalars['String']>;
  latestStatusTimestamp: InputMaybe<Scalars['DateTime']>;
  notes: InputMaybe<Scalars['String']>;
  rendezvousLocationDescription: InputMaybe<Scalars['String']>;
  requestLocationId: Scalars['ID'];
  transportUnitNumber: InputMaybe<Scalars['String']>;
  utilizationStatus: AmrUtilizationStatus;
};

export type UpdateRequest = {
  commitUnitToStandby: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  includeCompetitors: InputMaybe<Scalars['Boolean']>;
  isStandbyRequest: Scalars['Boolean'];
  minimumFlightRule: InputMaybe<FlightRule>;
  requestedVehicleType: InputMaybe<VehicleType>;
  requiredCapabilityIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  safetyQuestions: SafetyQuestionsInput;
  transportOfferAlgorithm: InputMaybe<TransportOfferAlgorithm>;
};

export type UpdateRequestAtlo = {
  atloInMinutes: Scalars['Int'];
  etloInMinutes: Scalars['Int'];
  id: Scalars['ID'];
};

export type UpdateRequestLocation = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  bedNumber: InputMaybe<Scalars['String']>;
  diversionReasonId: InputMaybe<Scalars['ID']>;
  diversionReasonOtherNotes: InputMaybe<Scalars['String']>;
  estimatedGroundTimeInMinutes: InputMaybe<Scalars['Int']>;
  estimatedRendezvousTimeInMinutes: InputMaybe<Scalars['Int']>;
  externalActionId: InputMaybe<Scalars['ID']>;
  fboId: InputMaybe<Scalars['ID']>;
  groundContact: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  medicalFacilityId: InputMaybe<Scalars['ID']>;
  medicalFacilityUnitId: InputMaybe<Scalars['ID']>;
  medicalUnitId: InputMaybe<Scalars['ID']>;
  medicalUnitName: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  physicianId: InputMaybe<Scalars['ID']>;
  physicianName: InputMaybe<Scalars['String']>;
  requestId: Scalars['ID'];
  roomNumber: InputMaybe<Scalars['String']>;
  timezoneCd: InputMaybe<Scalars['String']>;
  type: WaypointType;
  unConfirmed: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRequestPatient = {
  bpDiastolic: InputMaybe<Scalars['Int']>;
  bpSystolic: InputMaybe<Scalars['Int']>;
  chiefComplaintNotes: InputMaybe<Scalars['String']>;
  dateOfBirth: InputMaybe<Scalars['DateTime']>;
  estimatedAgeInHours: InputMaybe<Scalars['Float']>;
  firstName: InputMaybe<Scalars['String']>;
  gcs: InputMaybe<Scalars['Int']>;
  gender: Gender;
  heartRate: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  isIntubated: InputMaybe<Scalars['Boolean']>;
  isIsolette: Scalars['Boolean'];
  isoletteNotes: InputMaybe<Scalars['String']>;
  isoletteType: InputMaybe<IsoletteType>;
  lastName: InputMaybe<Scalars['String']>;
  medicalRecordNumber: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  numberOfDrips: InputMaybe<Scalars['Int']>;
  oxygenSaturation: InputMaybe<Scalars['Float']>;
  patientId: InputMaybe<Scalars['ID']>;
  requestId: Scalars['ID'];
  respiratoryRate: InputMaybe<Scalars['Float']>;
  rideAlongDateOfBirth: InputMaybe<Scalars['DateTime']>;
  rideAlongName: InputMaybe<Scalars['String']>;
  rideAlongRequested: InputMaybe<YesNoType>;
  rideAlongWeightInKg: InputMaybe<Scalars['Float']>;
  specialtyEquipment: InputMaybe<Scalars['String']>;
  temperatureInCelsius: InputMaybe<Scalars['Float']>;
  transferReasonId: InputMaybe<Scalars['ID']>;
  transportReasonCategory: InputMaybe<TransportReasonCategory>;
  transportReasonId: InputMaybe<Scalars['ID']>;
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type UpdateRequestPublicUtilityInfo = {
  missionConfiguration: MissionConfiguration;
  missionProfile: MissionProfile;
  requestId: Scalars['ID'];
};

export type UpdateRequestRegion = {
  regionId: Scalars['ID'];
  requestId: Scalars['ID'];
};

export type UpdateRequestSafetyQuestions = {
  otherServiceDeclined: InputMaybe<Scalars['Boolean']>;
  otherServiceDescription: InputMaybe<Scalars['String']>;
  otherServiceResponseDescription: InputMaybe<Scalars['String']>;
  otherServicesAreRespondingToTransferring: InputMaybe<Scalars['Boolean']>;
  requestId: Scalars['ID'];
};

export type UpdateRequestStandbyStatus = {
  commitUnitToStandby: Scalars['Boolean'];
  isStandbyRequest: Scalars['Boolean'];
  requestId: Scalars['ID'];
};

export type UpdateRequester = {
  affiliationType: InputMaybe<AffiliationType>;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  agencyLocationName: InputMaybe<Scalars['String']>;
  callbackNumber: InputMaybe<Scalars['String']>;
  caller: InputMaybe<Scalars['String']>;
  email: InputMaybe<Scalars['String']>;
  facilityId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDoublePatient: InputMaybe<Scalars['Boolean']>;
  isNewAgencyLocation: InputMaybe<Scalars['Boolean']>;
  isStandbyRequest: InputMaybe<Scalars['Boolean']>;
  isWingToWing: InputMaybe<Scalars['Boolean']>;
  missionRole: InputMaybe<MissionRoleType>;
  referralReasonId: InputMaybe<Scalars['ID']>;
  referringAgencyLocationId: InputMaybe<Scalars['ID']>;
  referringCompanyId: InputMaybe<Scalars['ID']>;
  referringRecordNumber: InputMaybe<Scalars['String']>;
  requestId: InputMaybe<Scalars['ID']>;
  requestedVehicleType: InputMaybe<VehicleType>;
  roleId: InputMaybe<Scalars['ID']>;
  vetNumber: InputMaybe<Scalars['String']>;
};

export type UpdateRequesterRole = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateRequesterSpecialtyTeam = {
  requesterId: Scalars['ID'];
  specialtyTeamId: InputMaybe<Scalars['ID']>;
  specialtyTeamMemberIds: Array<Scalars['ID']>;
  specialtyTeamNotes: InputMaybe<Scalars['String']>;
};

export type UpdateRequestorAgencyLocation = {
  agencyLocationId: Scalars['ID'];
  cardId: Scalars['ID'];
};

export type UpdateRiskAnalysis = {
  operationId: Scalars['ID'];
  riskAnalysisAcknowledged: Scalars['Boolean'];
  riskAnalysisNumber: InputMaybe<Scalars['String']>;
};

export type UpdateSkip = {
  convertToDecline: InputMaybe<Scalars['Boolean']>;
  crewNotified: InputMaybe<Scalars['DateTime']>;
  declineReasonId: Scalars['ID'];
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  notes: InputMaybe<Scalars['String']>;
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  responseReceived: InputMaybe<Scalars['DateTime']>;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitId: Scalars['ID'];
};

export type UpdateSpecialtyTeam = {
  affiliationId: Scalars['ID'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateSpecialtyTeamMember = {
  id: Scalars['ID'];
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type UpdateState = {
  code: Scalars['String'];
  id: Scalars['ID'];
  isLicenseRequiredToFly: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type UpdateSupportRequest = {
  companyId: Scalars['ID'];
  content: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isEmailSent: Scalars['Boolean'];
  notes: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  subject: InputMaybe<Scalars['String']>;
  supportRequestStatus: SupportRequestStatus;
  supportRequestType: SupportRequestType;
};

export type UpdateSupportRequestEmailSent = {
  supportRequestId: Scalars['ID'];
};

export type UpdateTcsRealtimeTrackingTab = {
  personId: Scalars['ID'];
  tabId: Scalars['String'];
};

export type UpdateTimeline = {
  activationRuleId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  items: InputMaybe<Array<InputMaybe<UpsertTimelineItem>>>;
  name: Scalars['String'];
  timelineType: InputMaybe<TimelineTypes>;
};

export type UpdateTimelineItem = {
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  sequence: Scalars['Int'];
  timelineId: Scalars['ID'];
  timestampTypeId: Scalars['ID'];
};

export type UpdateTimestamp = {
  cardId: Scalars['ID'];
  id: Scalars['ID'];
  note: InputMaybe<Scalars['String']>;
  operationId: InputMaybe<Scalars['ID']>;
  personsInvolved: InputMaybe<Scalars['String']>;
  requestId: InputMaybe<Scalars['ID']>;
  time: Scalars['DateTime'];
  typeId: Scalars['ID'];
};

export type UpdateTimestampType = {
  companies: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  description: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  systemTimestampType: InputMaybe<SystemTimestampType>;
};

export type UpdateTimezone = {
  abbreviation: Scalars['String'];
  code: Scalars['String'];
  id: Scalars['ID'];
  isDst: Scalars['Boolean'];
  name: Scalars['String'];
  utcOffset: Scalars['Int'];
};

export type UpdateTrackedMessage = {
  body: Scalars['String'];
  doNotDivert: InputMaybe<Scalars['Boolean']>;
  fromAddress: InputMaybe<Scalars['String']>;
  fromName: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  medium: InputMaybe<MessageTransport>;
  recipientAddress: Scalars['String'];
  recipientName: InputMaybe<Scalars['String']>;
  referenceNumber: InputMaybe<Scalars['String']>;
  status: MessageStatus;
  subject: InputMaybe<Scalars['String']>;
  vendorConversationId: InputMaybe<Scalars['String']>;
  vendorId: InputMaybe<Scalars['String']>;
  vendorMessageId: InputMaybe<Scalars['String']>;
};

export type UpdateTransferCenter = {
  communicationCenterId: Scalars['ID'];
  description: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateTransferCenterCallInfo = {
  careLevelRequested: InputMaybe<CareLevel>;
  requesterId: Scalars['ID'];
  transferCenterId: InputMaybe<Scalars['ID']>;
  transferCenterNotes: InputMaybe<Scalars['String']>;
  transportingAgencyLocationId: InputMaybe<Scalars['ID']>;
};

export type UpdateTransferReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateTransportOffer = {
  agencyLocationId: InputMaybe<Scalars['ID']>;
  baseId: InputMaybe<Scalars['ID']>;
  bearingInDegrees: InputMaybe<Scalars['Float']>;
  cancellationReasonId: InputMaybe<Scalars['ID']>;
  cancellationReasonNotes: InputMaybe<Scalars['String']>;
  cancellationSecondaryReasonId: InputMaybe<Scalars['ID']>;
  crew: InputMaybe<Array<InputMaybe<UnitPositionSnapshotInput>>>;
  crewMustFlyToArriveAtSending: InputMaybe<Scalars['Boolean']>;
  crewNotified: InputMaybe<Scalars['DateTime']>;
  dateDeclinedOrAborted: InputMaybe<Scalars['DateTime']>;
  declineReasonId: InputMaybe<Scalars['ID']>;
  declineSecondaryReasonId: InputMaybe<Scalars['ID']>;
  declinedOrAbortedById: InputMaybe<Scalars['ID']>;
  distanceInMiles: InputMaybe<Scalars['Float']>;
  estimatedDepartureTimeInMinutes: InputMaybe<Scalars['Int']>;
  estimatedTimeEnRouteInMinutes: InputMaybe<Scalars['Int']>;
  etc: InputMaybe<Scalars['Float']>;
  homeBaseDistanceInMiles: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  isInternalAgency: Scalars['Boolean'];
  isOnDelay: Scalars['Boolean'];
  isOneCallAgreement: Scalars['Boolean'];
  isReferral: InputMaybe<Scalars['Boolean']>;
  nonReferralReasonId: InputMaybe<Scalars['ID']>;
  nonReferralReasonNotes: InputMaybe<Scalars['String']>;
  notes: InputMaybe<Scalars['String']>;
  notificationAcknowledged: InputMaybe<Scalars['DateTime']>;
  offerTime: InputMaybe<Scalars['DateTime']>;
  onBaseETAInMinutes: InputMaybe<Scalars['Int']>;
  outOfServiceEventId: InputMaybe<Scalars['ID']>;
  patientOriginatesAtUnit: InputMaybe<Scalars['Boolean']>;
  preferredRank: InputMaybe<Scalars['Int']>;
  rank: Scalars['Int'];
  requestId: Scalars['ID'];
  response: TransportOfferResponse;
  responseReceived: InputMaybe<Scalars['DateTime']>;
  specialtyTeamETEInMinutes: InputMaybe<Scalars['Int']>;
  specialtyTeamETLOInMinutes: InputMaybe<Scalars['Int']>;
  status: TransportOfferStatus;
  transportCheckInitiated: InputMaybe<Scalars['DateTime']>;
  unitDescription: InputMaybe<Scalars['String']>;
  unitId: InputMaybe<Scalars['ID']>;
  vehicleCoordinates: InputMaybe<CoordinatesInput>;
  vehicleId: InputMaybe<Scalars['ID']>;
  vehicleType: InputMaybe<VehicleType>;
  wasBulkSkip: Scalars['Boolean'];
};

export type UpdateTransportOfferEta = {
  estimatedDepartureTimeInMinutes: InputMaybe<Scalars['Int']>;
  estimatedTimeEnRouteInMinutes: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  patientOriginatesAtUnit: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTransportOfferOption = {
  includeAbortedUnit: Scalars['Boolean'];
  includeCompetitors: InputMaybe<Scalars['Boolean']>;
  minimumFlightRule: InputMaybe<FlightRule>;
  requestId: Scalars['ID'];
  requestedVehicleType: InputMaybe<VehicleType>;
  requiredCapabilities: Array<RequiredCapabilityInput>;
  transportOfferAlgorithm: InputMaybe<TransportOfferAlgorithm>;
};

export type UpdateTransportReason = {
  id: Scalars['ID'];
  name: Scalars['String'];
  operationType: InputMaybe<OperationType>;
};

export type UpdateTrip = {
  agencyId: InputMaybe<Scalars['ID']>;
  agencyLocationId: InputMaybe<Scalars['ID']>;
  calculatedLoadedMiles: InputMaybe<Scalars['Float']>;
  gpsLoadedMiles: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  operationId: Scalars['ID'];
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type UpdateTripLegDuration = {
  asOfTime: Scalars['DateTime'];
  durationInMinutes: Scalars['Int'];
  estimateSource: EstimatedDurationSource;
  positionReportId: InputMaybe<Scalars['ID']>;
  tripId: Scalars['ID'];
  tripLegId: Scalars['ID'];
};

export type UpdateTripLegOnFinal = {
  id: Scalars['ID'];
};

export type UpdateTripPassenger = {
  abbreviation: Scalars['String'];
  crewMemberId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  personId: InputMaybe<Scalars['ID']>;
  positionName: InputMaybe<Scalars['String']>;
  positionType: InputMaybe<UnitPositionType>;
  tripId: Scalars['ID'];
  type: PassengerType;
  weightInKg: InputMaybe<Scalars['Float']>;
};

export type UpdateTrmUser = {
  additionalProgramIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  agencyIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId: Scalars['ID'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  medicalFacilityIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  personId: InputMaybe<Scalars['ID']>;
  phoneNumber: Scalars['String'];
  preferredProgramId: Scalars['ID'];
};

export type UpdateUnit = {
  abbreviation: Scalars['String'];
  baseId: Scalars['ID'];
  completeFlightInstanceId: InputMaybe<Scalars['ID']>;
  emSystemResourceId: InputMaybe<Scalars['String']>;
  etloInMinutes: InputMaybe<Scalars['Int']>;
  excludeStates: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  integrations: Array<IntegrationSystem>;
  isAdministrative: InputMaybe<Scalars['Boolean']>;
  isExternallyManaged: Scalars['Boolean'];
  isSpare: Scalars['Boolean'];
  lastPilotUpdateById: InputMaybe<Scalars['ID']>;
  lastPilotUpdateTime: InputMaybe<Scalars['DateTime']>;
  maximumFlightRule: FlightRule;
  name: Scalars['String'];
  oemPlacardNumber: InputMaybe<Scalars['String']>;
  onBaseETAInMinutes: InputMaybe<Scalars['Int']>;
  pilotNotes: InputMaybe<Scalars['String']>;
  primaryOutOfServiceEventId: InputMaybe<Scalars['ID']>;
  regionId: Scalars['ID'];
  updatePhoneNumbersFromExternal: Scalars['Boolean'];
  weatherStatus: WeatherStatus;
};

export type UpdateUnitActivationRule = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  maximumDistanceInMiles: InputMaybe<Scalars['Int']>;
  missionRoleTypes: Array<MissionRoleType>;
  operationTypes: Array<OperationType>;
  unitId: Scalars['ID'];
};

export type UpdateUnitConfiguration = {
  abbreviation: Scalars['String'];
  baseId: Scalars['ID'];
  completeFlightInstanceId: InputMaybe<Scalars['ID']>;
  emSystemResourceId: InputMaybe<Scalars['String']>;
  etloInMinutes: InputMaybe<Scalars['Int']>;
  excludeStates: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  integrations: Array<IntegrationSystem>;
  isAdministrative: InputMaybe<Scalars['Boolean']>;
  isExternallyManaged: Scalars['Boolean'];
  isSpare: Scalars['Boolean'];
  lastPilotUpdateById: InputMaybe<Scalars['ID']>;
  lastPilotUpdateTime: InputMaybe<Scalars['DateTime']>;
  maximumFlightRule: FlightRule;
  name: Scalars['String'];
  onBaseETAInMinutes: InputMaybe<Scalars['Int']>;
  pilotNotes: InputMaybe<Scalars['String']>;
  positions: Array<UpsertUnitPosition>;
  primaryOutOfServiceEventId: InputMaybe<Scalars['ID']>;
  regionId: Scalars['ID'];
  updatePhoneNumbersFromExternal: Scalars['Boolean'];
  weatherStatus: WeatherStatus;
};

export type UpdateUnitEMSystemMapping = {
  divisionName: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  resourceId: Scalars['String'];
  sendGps: Scalars['Boolean'];
  unitId: Scalars['ID'];
};

export type UpdateUnitNote = {
  content: Scalars['String'];
  id: Scalars['ID'];
  noteTime: Scalars['DateTime'];
};

export type UpdateUnitPosition = {
  firstName: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isFlightCrew: Scalars['Boolean'];
  isNonEmployee: Scalars['Boolean'];
  lastName: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  teamMemberId: InputMaybe<Scalars['ID']>;
  type: UnitPositionType;
  unitId: Scalars['ID'];
};

export type UpdateUnitShift = {
  endTimeInMinutes: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startTimeInMinutes: Scalars['Int'];
  unitId: Scalars['ID'];
};

export type UpdateVehicle = {
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  completeFlightId: InputMaybe<Scalars['ID']>;
  configurationClassId: InputMaybe<Scalars['ID']>;
  cruiseSpeed: InputMaybe<Scalars['Int']>;
  dateAcquired: InputMaybe<Scalars['DateTime']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  faaCompanyId: InputMaybe<Scalars['ID']>;
  flightLogProcess: FlightLogProcess;
  hideFromOOSRUM: Scalars['Boolean'];
  id: Scalars['ID'];
  isPlaceholder: Scalars['Boolean'];
  isPositionTrackingEnabled: Scalars['Boolean'];
  isRetired: Scalars['Boolean'];
  isUnderLease: Scalars['Boolean'];
  makeId: InputMaybe<Scalars['ID']>;
  modelId: InputMaybe<Scalars['ID']>;
  phoneNumber: InputMaybe<Scalars['String']>;
  regionId: InputMaybe<Scalars['ID']>;
  registrationNumber: Scalars['String'];
  role: VehicleRole;
  serialNumber: InputMaybe<Scalars['String']>;
  skytracIMEI: InputMaybe<Scalars['String']>;
  stateInspectionRequired: Scalars['Boolean'];
  type: VehicleType;
  vehicleDescription: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['Int']>;
};

export type UpdateVehicleConfigurationClass = {
  engineCount: Scalars['Int'];
  engineParameters: Array<Scalars['String']>;
  id: Scalars['ID'];
  legacyName: Scalars['String'];
  maintenanceSystemId: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateVehicleControlZone = {
  companyId: Scalars['ID'];
  controlZoneId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type UpdateVehicleDisposition = {
  currentAgencyLocationId: InputMaybe<Scalars['ID']>;
  currentTripId: InputMaybe<Scalars['ID']>;
  currentTripLegId: InputMaybe<Scalars['ID']>;
  currentWaypointId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  latestPositionReportId: InputMaybe<Scalars['ID']>;
  status: VehicleStatus;
  vehicleId: Scalars['ID'];
  vehiclePositionSummaryId: InputMaybe<Scalars['ID']>;
};

export type UpdateVehicleMaintenance = {
  deferralDueDates: Array<DeferralDueDateWithOptionalIdInput>;
  id: Scalars['ID'];
  isReleasedFromOCF: InputMaybe<Scalars['Boolean']>;
  nextDues: Array<NextDueWithOptionalIdInput>;
  notes: InputMaybe<Scalars['String']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type UpdateVehicleMake = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateVehicleModel = {
  cruiseSpeedInMph: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateVehicleStateInspection = {
  id: Scalars['ID'];
  inspectionDate: Scalars['DateTime'];
  stateAbbrevation: Scalars['String'];
  vehicleId: Scalars['ID'];
};

export type UpdateWaypoint = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  arrivalTime: InputMaybe<Scalars['DateTime']>;
  arrivingType: InputMaybe<WaypointType>;
  currentEtaId: InputMaybe<Scalars['ID']>;
  departureTime: InputMaybe<Scalars['DateTime']>;
  estimatedDurationId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isPatientDropoff: InputMaybe<Scalars['Boolean']>;
  isPatientPickup: InputMaybe<Scalars['Boolean']>;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  timezoneCd: InputMaybe<Scalars['String']>;
  type: WaypointType;
};

export type UpdateWaypointDuration = {
  asOfTime: Scalars['DateTime'];
  durationInMinutes: Scalars['Int'];
  estimateSource: EstimatedDurationSource;
  positionReportId: InputMaybe<Scalars['ID']>;
  tripId: Scalars['ID'];
  waypointId: Scalars['ID'];
};

export type UpsertPersonNotificationGroups = {
  notificationGroupIds: Array<Scalars['ID']>;
  personId: Scalars['ID'];
};

export type UpsertQuestionChoice = {
  id: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
  questionId: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};

export type UpsertQuestionnaireQuestionResponseNote = {
  authorId: Scalars['ID'];
  dateAuthored: Scalars['DateTime'];
  note: Scalars['String'];
  questionnaireQuestionResponseId: Scalars['ID'];
  questionnaireQuestionResponseNoteId: InputMaybe<Scalars['ID']>;
};

export type UpsertQuestionnaireSection = {
  id: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  questionnaireId: InputMaybe<Scalars['ID']>;
  questions: InputMaybe<Array<InputMaybe<UpsertQuestionnaireSectionQuestion>>>;
  sequence: Scalars['Int'];
};

export type UpsertQuestionnaireSectionQuestion = {
  activationRuleId: InputMaybe<Scalars['ID']>;
  activityType: InputMaybe<Scalars['String']>;
  explanationRequiredChoices: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  id: InputMaybe<Scalars['ID']>;
  isDisabled: Scalars['Boolean'];
  questionId: Scalars['ID'];
  questionnaireSectionId: InputMaybe<Scalars['ID']>;
  responsibleRole: UserRole;
  reviewRequiredChoices: InputMaybe<Array<InputMaybe<IdListItemInput>>>;
  sequence: Scalars['Int'];
};

export type UpsertTimelineItem = {
  id: InputMaybe<Scalars['ID']>;
  required: Scalars['Boolean'];
  sequence: Scalars['Int'];
  timelineId: InputMaybe<Scalars['ID']>;
  timestampTypeId: Scalars['ID'];
};

export type UpsertUnitPosition = {
  firstName: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['ID']>;
  isFlightCrew: Scalars['Boolean'];
  isNonEmployee: Scalars['Boolean'];
  lastName: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notificationAddress: InputMaybe<Scalars['String']>;
  teamMemberId: InputMaybe<Scalars['ID']>;
  type: UnitPositionType;
  unitId: Scalars['ID'];
};

export type UpsertVehicleMaintenanceParameters = {
  id: Scalars['ID'];
  isReleasedFromOCF: InputMaybe<Scalars['Boolean']>;
  maintenanceParams: InputMaybe<MaintenanceParametersInput>;
};

export type UserApplicationSettings = {
  __typename: 'UserApplicationSettings';
  tcsRealtimeTracking: TcsRealtimeTracking;
};

export type UserApplicationSettingsInput = {
  tcsRealtimeTracking: TcsRealtimeTrackingInput;
};

export enum UserRole {
  AsbDataManager = 'AsbDataManager',
  AsbViewer = 'AsbViewer',
  AviationDataManager = 'AviationDataManager',
  AviationPermissionsManager = 'AviationPermissionsManager',
  AviationSupervisor = 'AviationSupervisor',
  Biller = 'Biller',
  BillerCorrectionsTeam = 'BillerCorrectionsTeam',
  Clinical = 'Clinical',
  Communications = 'Communications',
  CommunicationsSupervisor = 'CommunicationsSupervisor',
  ComplianceManager = 'ComplianceManager',
  Developer = 'Developer',
  Executive = 'Executive',
  External = 'External',
  FixedWingCoordinator = 'FixedWingCoordinator',
  FleetStatusOperations = 'FleetStatusOperations',
  FleetStatusViewer = 'FleetStatusViewer',
  FlightLogViewer = 'FlightLogViewer',
  GlobalDataManager = 'GlobalDataManager',
  GlobalPermissionsManager = 'GlobalPermissionsManager',
  ImageTrend = 'ImageTrend',
  Mechanic = 'Mechanic',
  OCC = 'OCC',
  OccReader = 'OccReader',
  OosMaintenanceController = 'OosMaintenanceController',
  OosQA = 'OosQA',
  OosViewer = 'OosViewer',
  OperationsDataManager = 'OperationsDataManager',
  OperationsPermissionsManager = 'OperationsPermissionsManager',
  OpsReader = 'OpsReader',
  OrgReader = 'OrgReader',
  Pilot = 'Pilot',
  PrdAdmin = 'PrdAdmin',
  PrdUser = 'PrdUser',
  ProgramManager = 'ProgramManager',
  QaManager = 'QaManager',
  QaSupervisor = 'QaSupervisor',
  RemoteUser = 'RemoteUser',
  Stakeholder = 'Stakeholder',
  Support = 'Support',
  TrmProgramAdmin = 'TrmProgramAdmin',
}

export type Vehicle = Entity &
  Evented & {
    __typename: 'Vehicle';
    _events: MessageEnvelopeCollection;
    activationRules: Maybe<Array<Maybe<ActivationRule>>>;
    cardSummaries: Maybe<Array<Maybe<CardSummary>>>;
    communicationCenter: Maybe<CommunicationCenter>;
    communicationCenterId: Maybe<Scalars['ID']>;
    company: Company;
    companyId: Scalars['ID'];
    completeFlightId: Maybe<Scalars['ID']>;
    configurationClass: Maybe<VehicleConfigurationClass>;
    configurationClassId: Maybe<Scalars['ID']>;
    controlZone: Maybe<ControlZone>;
    controlZoneId: Maybe<Scalars['ID']>;
    cruiseSpeed: Maybe<Scalars['Int']>;
    dateAcquired: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dispatchCompany: Maybe<Company>;
    dispatchCompanyId: Maybe<Scalars['ID']>;
    faaCompanyId: Maybe<Scalars['ID']>;
    flightLogProcess: FlightLogProcess;
    hideFromOOSRUM: Scalars['Boolean'];
    id: Scalars['ID'];
    isHidden: Maybe<Scalars['Boolean']>;
    isPlaceholder: Scalars['Boolean'];
    isPositionTrackingEnabled: Scalars['Boolean'];
    isRetired: Scalars['Boolean'];
    isThirdPartyVehicle: Maybe<Scalars['Boolean']>;
    isUnderLease: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    make: Maybe<VehicleMake>;
    makeId: Maybe<Scalars['ID']>;
    model: Maybe<VehicleModel>;
    modelId: Maybe<Scalars['ID']>;
    operations: Array<Operation>;
    outOfServiceEvents: Maybe<Array<Maybe<OutOfServiceEvent>>>;
    outOfServiceTickets: Array<OutOfServiceTicket>;
    parentUnitId: Maybe<Scalars['ID']>;
    phoneNumber: Maybe<Scalars['String']>;
    positionReportAlerts: Array<PositionReportAlert>;
    ramco: Maybe<RamcoVehicleConfiguration>;
    regionId: Maybe<Scalars['ID']>;
    registrationNumber: Scalars['String'];
    role: VehicleRole;
    serialNumber: Maybe<Scalars['String']>;
    skytracIMEI: Maybe<Scalars['String']>;
    stateInspectionRequired: Scalars['Boolean'];
    transportOffers: Maybe<Array<Maybe<TransportOffer>>>;
    trips: Maybe<Array<Maybe<Trip>>>;
    type: VehicleType;
    unitSummaries: Maybe<Array<Maybe<UnitSummary>>>;
    units: Maybe<Array<Maybe<Unit>>>;
    vehicleControlZones: Maybe<Array<Maybe<VehicleControlZone>>>;
    vehicleDescription: Maybe<Scalars['String']>;
    vehicleDispositions: Array<VehicleDisposition>;
    vehicleMaintenances: Maybe<Array<Maybe<VehicleMaintenance>>>;
    vehicleNotificationGroups: Array<VehicleNotificationGroup>;
    vehiclePositionSummaries: Array<VehiclePositionSummary>;
    vehicleStateInspections: Array<VehicleStateInspection>;
    year: Maybe<Scalars['Int']>;
  };

export type Vehicle_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleCollection = {
  __typename: 'VehicleCollection';
  items: Array<Vehicle>;
  meta: VehicleCollectionMetadata;
};

export type VehicleCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleConfigurationClass = Entity &
  Evented & {
    __typename: 'VehicleConfigurationClass';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    engineCount: Scalars['Int'];
    engineParameters: Array<Scalars['String']>;
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    legacyName: Scalars['String'];
    maintenanceSystemId: Scalars['String'];
    name: Scalars['String'];
    vehicles: Maybe<Array<Maybe<Vehicle>>>;
  };

export type VehicleConfigurationClass_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleConfigurationClassCollection = {
  __typename: 'VehicleConfigurationClassCollection';
  items: Array<VehicleConfigurationClass>;
  meta: VehicleConfigurationClassCollectionMetadata;
};

export type VehicleConfigurationClassCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleConfigurationClassCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleConfigurationClassFilter = {
  nameLike: InputMaybe<Scalars['String']>;
};

export type VehicleConfigurationClassQueries = {
  __typename: 'VehicleConfigurationClassQueries';
  all: VehicleConfigurationClassCollection;
  byId: Maybe<VehicleConfigurationClass>;
};

export type VehicleConfigurationClassQueriesallArgs = {
  filter: InputMaybe<VehicleConfigurationClassFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleConfigurationClassQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type VehicleControlZone = Entity &
  Evented & {
    __typename: 'VehicleControlZone';
    _events: MessageEnvelopeCollection;
    company: Company;
    companyId: Scalars['ID'];
    controlZone: Maybe<ControlZone>;
    controlZoneId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
  };

export type VehicleControlZone_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleControlZoneCollection = {
  __typename: 'VehicleControlZoneCollection';
  items: Array<VehicleControlZone>;
  meta: VehicleControlZoneCollectionMetadata;
};

export type VehicleControlZoneCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleControlZoneCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleControlZoneFilter = {
  controlZoneId: InputMaybe<Scalars['ID']>;
  vehicleId: InputMaybe<Scalars['ID']>;
};

export type VehicleControlZoneQueries = {
  __typename: 'VehicleControlZoneQueries';
  all: VehicleControlZoneCollection;
  byId: Maybe<VehicleControlZone>;
};

export type VehicleControlZoneQueriesallArgs = {
  filter: InputMaybe<VehicleControlZoneFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleControlZoneQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type VehicleDisposition = Entity &
  Evented & {
    __typename: 'VehicleDisposition';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    currentAgencyLocation: Maybe<AgencyLocation>;
    currentAgencyLocationId: Maybe<Scalars['ID']>;
    currentTrip: Maybe<Trip>;
    currentTripId: Maybe<Scalars['ID']>;
    currentTripLeg: Maybe<TripLeg>;
    currentTripLegId: Maybe<Scalars['ID']>;
    currentWaypoint: Maybe<Waypoint>;
    currentWaypointId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    etlo: Maybe<Scalars['DateTime']>;
    from: Maybe<WaypointSummary>;
    id: Scalars['ID'];
    isAssetOutOfService: Maybe<Scalars['Boolean']>;
    lastQualifyingPositionReportTime: Maybe<Scalars['DateTime']>;
    lastTripId: Maybe<Scalars['ID']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    latestFlightFollowingReport: Maybe<FlightFollowingReport>;
    latestFlightFollowingReportId: Maybe<Scalars['ID']>;
    latestPositionReport: Maybe<PositionReport>;
    latestPositionReportId: Maybe<Scalars['ID']>;
    latitude: Maybe<Scalars['Float']>;
    longitude: Maybe<Scalars['Float']>;
    notes: Maybe<Scalars['String']>;
    positionSource: Maybe<PositionReportSource>;
    positionTime: Maybe<Scalars['DateTime']>;
    status: VehicleStatus;
    statusDescription: Maybe<Scalars['String']>;
    to: Maybe<WaypointSummary>;
    vehicle: Vehicle;
    vehicleId: Scalars['ID'];
    vehiclePositionSummary: Maybe<VehiclePositionSummary>;
    vehiclePositionSummaryId: Maybe<Scalars['ID']>;
    vehicleSummaries: Array<VehicleSummary>;
  };

export type VehicleDisposition_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleDispositionCollection = {
  __typename: 'VehicleDispositionCollection';
  items: Array<VehicleDisposition>;
  meta: VehicleDispositionCollectionMetadata;
};

export type VehicleDispositionCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleDispositionCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleDispositionFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  ids: InputMaybe<Array<Scalars['ID']>>;
  status: InputMaybe<VehicleStatus>;
  vehicleIds: InputMaybe<Array<Scalars['ID']>>;
};

export type VehicleFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  companyIdList: InputMaybe<Array<Scalars['ID']>>;
  controlZoneCompanyId: InputMaybe<Scalars['ID']>;
  controlZoneId: InputMaybe<Scalars['ID']>;
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  excludeAir: InputMaybe<Scalars['Boolean']>;
  excludeGround: InputMaybe<Scalars['Boolean']>;
  excludeHiddenFromOOSRum: InputMaybe<Scalars['Boolean']>;
  excludeRetired: InputMaybe<Scalars['Boolean']>;
  includeHidden: InputMaybe<Scalars['Boolean']>;
  registrationNumberLike: InputMaybe<Scalars['String']>;
  vehicleIdList: InputMaybe<Array<Scalars['ID']>>;
};

export type VehicleMaintenance = Entity &
  Evented & {
    __typename: 'VehicleMaintenance';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    deferralDueDates: Array<DeferralDueDate>;
    id: Scalars['ID'];
    isReleasedFromOCF: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    maintenanceParams: Maybe<MaintenanceParameters>;
    nextDues: Array<NextDue>;
    notes: Maybe<Scalars['String']>;
    vehicle: Maybe<Vehicle>;
    vehicleId: Maybe<Scalars['ID']>;
  };

export type VehicleMaintenance_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleMaintenanceCollection = {
  __typename: 'VehicleMaintenanceCollection';
  items: Array<VehicleMaintenance>;
  meta: VehicleMaintenanceCollectionMetadata;
};

export type VehicleMaintenanceCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleMaintenanceCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleMake = Entity &
  Evented & {
    __typename: 'VehicleMake';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    vehicles: Maybe<Array<Maybe<Vehicle>>>;
  };

export type VehicleMake_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleMakeCollection = {
  __typename: 'VehicleMakeCollection';
  items: Array<VehicleMake>;
  meta: VehicleMakeCollectionMetadata;
};

export type VehicleMakeCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleMakeCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleModel = Entity &
  Evented & {
    __typename: 'VehicleModel';
    _events: MessageEnvelopeCollection;
    cruiseSpeedInMph: Maybe<Scalars['Int']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    vehicles: Maybe<Array<Maybe<Vehicle>>>;
  };

export type VehicleModel_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleModelCollection = {
  __typename: 'VehicleModelCollection';
  items: Array<VehicleModel>;
  meta: VehicleModelCollectionMetadata;
};

export type VehicleModelCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleModelCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleModelFilter = {
  id: InputMaybe<Scalars['ID']>;
  nameLike: InputMaybe<Scalars['String']>;
};

export type VehicleModelQueries = {
  __typename: 'VehicleModelQueries';
  all: VehicleModelCollection;
  byId: Maybe<VehicleModel>;
};

export type VehicleModelQueriesallArgs = {
  filter: InputMaybe<VehicleModelFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleModelQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type VehicleNotificationGroup = Entity &
  Evented & {
    __typename: 'VehicleNotificationGroup';
    _events: MessageEnvelopeCollection;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    notificationGroup: NotificationGroup;
    notificationGroupId: Scalars['ID'];
    vehicle: Vehicle;
    vehicleId: Scalars['ID'];
  };

export type VehicleNotificationGroup_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleNotificationGroupCollection = {
  __typename: 'VehicleNotificationGroupCollection';
  items: Array<VehicleNotificationGroup>;
  meta: VehicleNotificationGroupCollectionMetadata;
};

export type VehicleNotificationGroupCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleNotificationGroupCollectionMetadata';
  total: Scalars['Int'];
};

export type VehiclePositionSummary = Entity &
  Evented & {
    __typename: 'VehiclePositionSummary';
    _events: MessageEnvelopeCollection;
    altitude: Maybe<Scalars['Float']>;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    etlo: Maybe<Scalars['DateTime']>;
    gpsProvider: Maybe<GpsProvider>;
    heading: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    lastGpsAutoPositionTime: Maybe<Scalars['DateTime']>;
    lastLandedTime: Maybe<Scalars['DateTime']>;
    lastPositionReportId: Maybe<Scalars['ID']>;
    lastQualifyingPositionReportTime: Maybe<Scalars['DateTime']>;
    lastTakeOffTime: Maybe<Scalars['DateTime']>;
    latitude: Scalars['Float'];
    longitude: Scalars['Float'];
    positionSource: PositionReportSource;
    positionTime: Scalars['DateTime'];
    speedInKnots: Maybe<Scalars['Float']>;
    vehicle: Vehicle;
    vehicleDispositions: Maybe<Array<Maybe<VehicleDisposition>>>;
    vehicleId: Scalars['ID'];
  };

export type VehiclePositionSummary_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehiclePositionSummaryCollection = {
  __typename: 'VehiclePositionSummaryCollection';
  items: Array<VehiclePositionSummary>;
  meta: VehiclePositionSummaryCollectionMetadata;
};

export type VehiclePositionSummaryCollectionMetadata = CollectionMetadata & {
  __typename: 'VehiclePositionSummaryCollectionMetadata';
  total: Scalars['Int'];
};

export type VehiclePositionSummaryFilter = {
  afterDate: InputMaybe<Scalars['DateTime']>;
  companyIdList: InputMaybe<Array<Scalars['ID']>>;
  positionReportSource: InputMaybe<PositionReportSource>;
};

export type VehicleQueries = {
  __typename: 'VehicleQueries';
  _allVehicleModelsMeta: QueryMeta;
  all: VehicleCollection;
  allVehicleModels: Array<VehicleModel>;
  byId: Maybe<Vehicle>;
  dispositions: VehicleDispositionCollection;
  summaries: VehicleSummaryCollection;
  summaryById: Maybe<VehicleSummary>;
  vehicleModelById: Maybe<VehicleModel>;
};

export type VehicleQueriesallArgs = {
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleQueriesallVehicleModelsArgs = {
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type VehicleQueriesdispositionsArgs = {
  filter: InputMaybe<VehicleDispositionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleQueriessummariesArgs = {
  fetchpolicy: InputMaybe<FetchPolicy>;
  filter: InputMaybe<VehicleSummaryFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleQueriessummaryByIdArgs = {
  id: Scalars['ID'];
};

export type VehicleQueriesvehicleModelByIdArgs = {
  id: Scalars['ID'];
};

export enum VehicleRole {
  Primary = 'Primary',
  Spare = 'Spare',
  Support = 'Support',
  Unspecified = 'Unspecified',
}

export type VehicleStateInspection = Entity &
  Evented & {
    __typename: 'VehicleStateInspection';
    _events: MessageEnvelopeCollection;
    companyId: Scalars['ID'];
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    id: Scalars['ID'];
    inspectionDate: Scalars['DateTime'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    stateAbbrevation: Scalars['String'];
    vehicle: Vehicle;
    vehicleId: Scalars['ID'];
  };

export type VehicleStateInspection_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleStateInspectionCollection = {
  __typename: 'VehicleStateInspectionCollection';
  items: Array<VehicleStateInspection>;
  meta: VehicleStateInspectionCollectionMetadata;
};

export type VehicleStateInspectionCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleStateInspectionCollectionMetadata';
  total: Scalars['Int'];
};

export enum VehicleStatus {
  AtWaypoint = 'AtWaypoint',
  EnRoute = 'EnRoute',
}

export type VehicleSummary = Entity &
  Evented & {
    __typename: 'VehicleSummary';
    _events: MessageEnvelopeCollection;
    cardSummaries: Maybe<Array<Maybe<CardSummary>>>;
    communicationCenter: Maybe<CommunicationCenter>;
    communicationCenterId: Maybe<Scalars['ID']>;
    companyId: Scalars['ID'];
    currentCard: Maybe<Card>;
    currentCardId: Maybe<Scalars['ID']>;
    currentCardNumber: Maybe<Scalars['String']>;
    currentCardSummary: Maybe<CardSummary>;
    currentCardSummaryId: Maybe<Scalars['ID']>;
    currentOrNextLegSequence: Maybe<Scalars['Int']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    dateOnFinalMarked: Maybe<Scalars['DateTime']>;
    dispatchCompanyId: Maybe<Scalars['ID']>;
    eta: Maybe<Scalars['DateTime']>;
    etlo: Maybe<Scalars['DateTime']>;
    from: Maybe<WaypointSummary>;
    id: Scalars['ID'];
    lastKnownCoordinates: Maybe<Coordinates>;
    lastQualifyingPositionReportTime: Maybe<Scalars['DateTime']>;
    latestPositionReportSummary: Maybe<PositionReportSummary>;
    makeName: Maybe<Scalars['String']>;
    modelName: Maybe<Scalars['String']>;
    regionId: Scalars['ID'];
    registrationNumber: Scalars['String'];
    serialNumber: Maybe<Scalars['String']>;
    status: VehicleStatus;
    statusDescription: Scalars['String'];
    to: Maybe<WaypointSummary>;
    totalLegCount: Maybe<Scalars['Int']>;
    type: VehicleType;
    unit: Unit;
    unitId: Scalars['ID'];
    unitSummaryId: Scalars['ID'];
    vehicleDisposition: VehicleDisposition;
    vehicleDispositionId: Scalars['ID'];
  };

export type VehicleSummary_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type VehicleSummaryCollection = {
  __typename: 'VehicleSummaryCollection';
  items: Array<VehicleSummary>;
  meta: VehicleSummaryCollectionMetadata;
};

export type VehicleSummaryCollectionMetadata = CollectionMetadata & {
  __typename: 'VehicleSummaryCollectionMetadata';
  total: Scalars['Int'];
};

export type VehicleSummaryFilter = {
  afterDate: InputMaybe<Scalars['DateTime']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
  controlZoneCompanyId: InputMaybe<Scalars['ID']>;
  controlZoneId: InputMaybe<Scalars['ID']>;
  excludeCurrentDispatchCompany: InputMaybe<Scalars['Boolean']>;
  regionId: InputMaybe<Scalars['ID']>;
};

export enum VehicleType {
  Air = 'Air',
  FixedWing = 'FixedWing',
  Ground = 'Ground',
  RotorWing = 'RotorWing',
  Unspecified = 'Unspecified',
}

export enum VisibilityType {
  Author = 'Author',
  CommunicationsCenter = 'CommunicationsCenter',
  EntityOnly = 'EntityOnly',
  Region = 'Region',
  TargetOnly = 'TargetOnly',
}

export type Waypoint = Entity &
  Evented & {
    __typename: 'Waypoint';
    _events: MessageEnvelopeCollection;
    abbreviation: Scalars['String'];
    address: Address;
    arrivalTime: Maybe<Scalars['DateTime']>;
    arrivingLeg: Maybe<TripLeg>;
    arrivingType: Maybe<WaypointType>;
    companyId: Scalars['ID'];
    currentEta: Maybe<Eta>;
    currentEtaId: Maybe<Scalars['ID']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    departingLeg: Maybe<TripLeg>;
    departureTime: Maybe<Scalars['DateTime']>;
    estimatedDuration: Maybe<EstimatedDuration>;
    estimatedDurationId: Maybe<Scalars['ID']>;
    etas: Array<Eta>;
    id: Scalars['ID'];
    isPatientDropoff: Maybe<Scalars['Boolean']>;
    isPatientPickup: Maybe<Scalars['Boolean']>;
    isRotorWingLz: Maybe<Scalars['Boolean']>;
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    location: Maybe<Location>;
    locationId: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    timezoneCd: Maybe<Scalars['String']>;
    type: WaypointType;
    vehicleDispositions: Maybe<Array<Maybe<VehicleDisposition>>>;
  };

export type Waypoint_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type WaypointCollection = {
  __typename: 'WaypointCollection';
  items: Array<Waypoint>;
  meta: WaypointCollectionMetadata;
};

export type WaypointCollectionMetadata = CollectionMetadata & {
  __typename: 'WaypointCollectionMetadata';
  total: Scalars['Int'];
};

export type WaypointFilter = {
  companyId: InputMaybe<Scalars['ID']>;
  ids: InputMaybe<Array<Scalars['ID']>>;
};

export type WaypointQueries = {
  __typename: 'WaypointQueries';
  all: WaypointCollection;
};

export type WaypointQueriesallArgs = {
  filter: InputMaybe<WaypointFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type WaypointSpec = {
  __typename: 'WaypointSpec';
  abbreviation: Scalars['String'];
  address: Address;
  isRotorWingLz: Maybe<Scalars['Boolean']>;
  locationId: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  timezoneCd: Maybe<Scalars['String']>;
  type: WaypointType;
};

export type WaypointSpecInput = {
  abbreviation: Scalars['String'];
  address: AddressInput;
  isRotorWingLz: InputMaybe<Scalars['Boolean']>;
  locationId: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  timezoneCd: InputMaybe<Scalars['String']>;
  type: WaypointType;
};

export type WaypointSummary = {
  __typename: 'WaypointSummary';
  abbreviation: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: WaypointType;
};

export type WaypointSummaryInput = {
  abbreviation: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: WaypointType;
};

export enum WaypointType {
  DropoffTeam = 'DropoffTeam',
  EnRouteDiversion = 'EnRouteDiversion',
  FuelBurn = 'FuelBurn',
  FuelLocation = 'FuelLocation',
  Other = 'Other',
  PatientDropoffRendezvous = 'PatientDropoffRendezvous',
  PatientPickupRendezvous = 'PatientPickupRendezvous',
  PickupTeam = 'PickupTeam',
  Post = 'Post',
  PublicRelationsSite = 'PublicRelationsSite',
  ReceivingFacility = 'ReceivingFacility',
  RendezvousPoint = 'RendezvousPoint',
  SceneLocation = 'SceneLocation',
  SendingFacility = 'SendingFacility',
}

export enum WeatherStatus {
  Green = 'Green',
  Red = 'Red',
  Unspecified = 'Unspecified',
  Yellow = 'Yellow',
}

export enum WebOrderCallType {
  PhoneOrder = 'PhoneOrder',
  RapidCall = 'RapidCall',
  RapidSOS = 'RapidSOS',
  WebOrder = 'WebOrder',
}

export type WebOrderLog = Entity &
  Evented & {
    __typename: 'WebOrderLog';
    _events: MessageEnvelopeCollection;
    acknowledgedBy: Maybe<Person>;
    acknowledgedById: Maybe<Scalars['ID']>;
    changes: Maybe<Array<Maybe<WebOrderLogEntityChanges>>>;
    dateAcknowledged: Maybe<Scalars['DateTime']>;
    dateCreated: Scalars['DateTime'];
    dateDeleted: Maybe<Scalars['DateTime']>;
    dateLastUpdated: Scalars['DateTime'];
    entityId: Maybe<Scalars['ID']>;
    entityType: Maybe<EntityType>;
    errors: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isSuccess: Scalars['Boolean'];
    lastUpdatedBy: Maybe<Person>;
    lastUpdatedById: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    requestJson: Scalars['String'];
  };

export type WebOrderLog_eventsArgs = {
  filter: InputMaybe<EventedFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type WebOrderLogCollection = {
  __typename: 'WebOrderLogCollection';
  items: Array<WebOrderLog>;
  meta: WebOrderLogCollectionMetadata;
};

export type WebOrderLogCollectionMetadata = CollectionMetadata & {
  __typename: 'WebOrderLogCollectionMetadata';
  total: Scalars['Int'];
};

export type WebOrderLogEntityChanges = {
  __typename: 'WebOrderLogEntityChanges';
  entityType: Scalars['String'];
  fieldName: Scalars['String'];
  id: Scalars['ID'];
  newValue: Maybe<Scalars['String']>;
  oldValue: Maybe<Scalars['String']>;
};

export type WebOrderLogEntityChangesInput = {
  entityType: Scalars['String'];
  fieldName: Scalars['String'];
  id: Scalars['ID'];
  newValue: InputMaybe<Scalars['String']>;
  oldValue: InputMaybe<Scalars['String']>;
};

export enum WebhookSendStatus {
  Failed = 'Failed',
  Queued = 'Queued',
  Retrying = 'Retrying',
  Success = 'Success',
}

export enum YesNoType {
  No = 'No',
  Unspecified = 'Unspecified',
  Yes = 'Yes',
}

export type vehcilePositionSummaryQueries = {
  __typename: 'vehcilePositionSummaryQueries';
  all: VehiclePositionSummaryCollection;
  byVehicleId: Maybe<VehiclePositionSummary>;
};

export type vehcilePositionSummaryQueriesallArgs = {
  filter: InputMaybe<VehiclePositionSummaryFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
};

export type vehcilePositionSummaryQueriesbyVehicleIdArgs = {
  vehicleId: Scalars['ID'];
};

export type webOrderLogQueries = {
  __typename: 'webOrderLogQueries';
  byActiveCards: WebOrderLogCollection;
  byEntityId: WebOrderLogCollection;
  byId: Maybe<WebOrderLog>;
};

export type webOrderLogQueriesbyEntityIdArgs = {
  entityId: Scalars['ID'];
};

export type webOrderLogQueriesbyIdArgs = {
  id: Scalars['ID'];
};

export type PersonPermissionsDetailPage_FetchPersonByIdQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type PersonPermissionsDetailPage_FetchPersonByIdQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      firstName: string;
      lastName: string;
      userRoles: Array<UserRole | null> | null;
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
    } | null;
  };
};

export type AsbPageComponent_FetchAllVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AsbPageComponent_FetchAllVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
        vehicleMaintenances: Array<{
          __typename: 'VehicleMaintenance';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          notes: string | null;
          isReleasedFromOCF: boolean | null;
          vehicleId: string | null;
          deferralDueDates: Array<{
            __typename: 'DeferralDueDate';
            id: string;
            dueDate: Date | number | string;
            triggerValue: number | null;
            notes: string | null;
          }>;
          nextDues: Array<{
            __typename: 'NextDue';
            id: string;
            typeId: string;
            cycleType: NextDueCycleType;
            value: string;
            triggerValue: number;
            notes: string | null;
            inTolerance: boolean | null;
          }>;
          maintenanceParams: {
            __typename: 'MaintenanceParameters';
            endingHobbs: number | null;
            airframeTime: number | null;
            totalLandings: number | null;
            engine1: {
              __typename: 'EngineParameters';
              time: number | null;
              starts: number | null;
            } | null;
            engine2: {
              __typename: 'EngineParameters';
              time: number | null;
              starts: number | null;
            } | null;
          } | null;
        } | null> | null;
        vehicleStateInspections: Array<{
          __typename: 'VehicleStateInspection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          inspectionDate: Date | number | string;
          vehicleId: string;
          companyId: string;
        }>;
      }>;
    };
  };
};

export type AsbPageComponent_FetchAllNextDueTypesQueryVariables = Exact<{
  filter: InputMaybe<NextDueTypeFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AsbPageComponent_FetchAllNextDueTypesQuery = {
  __typename: 'Query';
  nextDueTypes: {
    __typename: 'NextDueTypeQueries';
    all: {
      __typename: 'NextDueTypeCollection';
      items: Array<{ __typename: 'NextDueType'; id: string; name: string; dataType: string }>;
    };
  };
};

export type AsbPageComponent_FetchAllVehicleModelsQueryVariables = Exact<{
  filter: InputMaybe<VehicleModelFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AsbPageComponent_FetchAllVehicleModelsQuery = {
  __typename: 'Query';
  vehicleModels: {
    __typename: 'VehicleModelQueries';
    all: {
      __typename: 'VehicleModelCollection';
      items: Array<{
        __typename: 'VehicleModel';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cruiseSpeedInMph: number | null;
      }>;
    };
  };
};

export type GlobalDataContextService_FetchQueryVariables = Exact<{ [key: string]: never }>;

export type GlobalDataContextService_FetchQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    summaries: {
      __typename: 'UnitSummaryCollection';
      items: Array<{
        __typename: 'UnitSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        isCrewAvailable: boolean;
        baseId: string;
        regionId: string;
        companyId: string;
        isAdministrative: boolean | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        lastPilotUpdateName: string | null;
        baseTimezoneCd: string | null;
        vehicleSummaryId: string | null;
        vehicleId: string | null;
        communicationCenterId: string | null;
        shifts: Array<{
          __typename: 'UnitShiftSummary';
          id: string;
          name: string;
          startTimeInMinutes: number;
          endTimeInMinutes: number;
        }>;
        outOfServiceEvents: Array<{
          __typename: 'OutOfServiceEventSummary';
          id: string;
          type: OutOfServiceType;
          eventNumber: string;
          estimatedEndTime: Date | number | string;
          reasonName: string;
          reasonId: string;
          startTime: Date | number | string | null;
          isOpportunisticOOS: boolean | null;
          notes: string | null;
        }>;
        positions: Array<{
          __typename: 'UnitPositionSummary';
          id: string;
          name: string;
          type: UnitPositionType;
          isFlightCrew: boolean;
          isNonEmployee: boolean;
          isNonCompliant: boolean;
          notificationAddress: string | null;
          teamMemberId: string | null;
          teamMemberFirstName: string | null;
          teamMemberLastName: string | null;
          nonComplianceReason: string | null;
        }>;
        paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'UnitSummaryCollectionMetadata'; total: number };
    };
  };
  vehicles: {
    __typename: 'VehicleQueries';
    summaries: {
      __typename: 'VehicleSummaryCollection';
      items: Array<{
        __typename: 'VehicleSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        unitSummaryId: string;
        regionId: string;
        status: VehicleStatus;
        statusDescription: string;
        vehicleDispositionId: string;
        unitId: string;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        makeName: string | null;
        modelName: string | null;
        etlo: Date | number | string | null;
        eta: Date | number | string | null;
        currentCardNumber: string | null;
        currentCardSummaryId: string | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        currentOrNextLegSequence: number | null;
        totalLegCount: number | null;
        dateOnFinalMarked: Date | number | string | null;
        communicationCenterId: string | null;
        currentCardId: string | null;
        from: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        to: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        latestPositionReportSummary: {
          __typename: 'PositionReportSummary';
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
        } | null;
        lastKnownCoordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      }>;
      meta: { __typename: 'VehicleSummaryCollectionMetadata'; total: number };
    };
  };
  requesterReferralReasons: {
    __typename: 'RequesterReferralReasonQueries';
    all: {
      __typename: 'RequesterReferralReasonCollection';
      items: Array<{
        __typename: 'RequesterReferralReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
    };
  };
  outOfServiceReasons: {
    __typename: 'OutOfServiceReasonQueries';
    all: {
      __typename: 'OutOfServiceReasonCollection';
      items: Array<{
        __typename: 'OutOfServiceReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        controllable: boolean;
        isVehicleReason: boolean;
        description: string | null;
      }>;
      meta: { __typename: 'OutOfServiceReasonCollectionMetadata'; total: number };
    };
  };
  outOfServiceSecondaryReasons: {
    __typename: 'OutOfServiceSecondaryReasonQueries';
    all: {
      __typename: 'OutOfServiceSecondaryReasonCollection';
      items: Array<{
        __typename: 'OutOfServiceSecondaryReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        outOfServiceReasonId: string;
      }>;
      meta: { __typename: 'OutOfServiceSecondaryReasonCollectionMetadata'; total: number };
    };
  };
  companies: {
    __typename: 'CompanyQueries';
    all: {
      __typename: 'CompanyCollection';
      items: Array<{
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      }>;
      meta: { __typename: 'CompanyCollectionMetadata'; total: number };
    };
  };
  regionGroups: {
    __typename: 'RegionGroupQueries';
    all: {
      __typename: 'RegionGroupCollection';
      items: Array<{
        __typename: 'RegionGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        departmentId: string;
        companyId: string;
      }>;
      meta: { __typename: 'RegionGroupCollectionMetadata'; total: number };
    };
  };
  regions: {
    __typename: 'RegionQueries';
    all: {
      __typename: 'RegionCollection';
      items: Array<{
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
      }>;
      meta: { __typename: 'RegionCollectionMetadata'; total: number };
    };
  };
  applicationNotifications: {
    __typename: 'ApplicationNotificationQueries';
    all: {
      __typename: 'ApplicationNotificationCollection';
      items: Array<{
        __typename: 'ApplicationNotification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: ApplicationNotificationUrgency;
        displayOnBanner: boolean;
        dismissable: boolean;
        notification: string;
        title: string | null;
        effectiveDate: Date | number | string | null;
        expirationDate: Date | number | string | null;
        createdById: string | null;
        companyId: string | null;
        regionId: string | null;
      }>;
      meta: { __typename: 'ApplicationNotificationCollectionMetadata'; total: number };
    };
  };
  configurationSettings: {
    __typename: 'ConfigurationSettingQueries';
    global: {
      __typename: 'ConfigurationSetting';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      companyId: string | null;
      defaultUnitCommittedDeclineReasonId: string | null;
      defaultUnitOutOfServiceDeclineReasonId: string | null;
      requestReferredInternallyCancellationReasonId: string | null;
      requestReferredExternallyCancellationReasonId: string | null;
      crewGoingByGroundOutOfServiceReasonId: string | null;
      assetReassignedDeclineReasonId: string | null;
      externallyCancelledCancellationReasonId: string | null;
      pilotReportGracePeriodInMinutes: number | null;
      sameDestinationWarningThresholdInMinutes: number | null;
      bugRequestEmail: string | null;
      featureRequestEmail: string | null;
      proximityAlertDistanceInNauticalMiles: number | null;
    } | null;
  };
  gis: {
    __typename: 'GisQueries';
    allTimezones: Array<{
      __typename: 'Timezone';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      code: string;
      isDst: boolean;
      utcOffset: number;
    }>;
  };
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    all: {
      __typename: 'DeclineReasonCollection';
      items: Array<{
        __typename: 'DeclineReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        declineCategoryId: string;
        controllable: boolean;
        canBeSkipReason: boolean;
        canBeAbortReason: boolean;
        canBeBulkSkipReason: boolean;
        canBeOneCallSkipReason: boolean;
        isUnitAvailableAfterAbort: boolean;
        secondaryReasonRequired: boolean;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineReasonCollectionMetadata'; total: number };
    };
  };
  declineSecondaryReasons: {
    __typename: 'DeclineSecondaryReasonQueries';
    all: {
      __typename: 'DeclineSecondaryReasonCollection';
      items: Array<{
        __typename: 'DeclineSecondaryReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        declineReasonId: string;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineSecondaryReasonCollectionMetadata'; total: number };
    };
  };
  declineCategories: {
    __typename: 'DeclineCategoryQueries';
    all: {
      __typename: 'DeclineCategoryCollection';
      items: Array<{
        __typename: 'DeclineCategory';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isVisibleInOps: boolean;
        defaultDeclineReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineCategoryCollectionMetadata'; total: number };
    };
  };
  cancellationReasons: {
    __typename: 'CancellationReasonQueries';
    all: {
      __typename: 'CancellationReasonCollection';
      items: Array<{
        __typename: 'CancellationReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        isTransferCenterReason: boolean;
        secondaryReasonRequired: boolean;
        canBeUnitCancellationReason: boolean | null;
        cancellationCategoryId: string | null;
      }>;
      meta: { __typename: 'CancellationReasonCollectionMetadata'; total: number };
    };
  };
  cancellationSecondaryReasons: {
    __typename: 'CancellationSecondaryReasonQueries';
    all: {
      __typename: 'CancellationSecondaryReasonCollection';
      items: Array<{
        __typename: 'CancellationSecondaryReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cancellationReasonId: string;
      }>;
      meta: { __typename: 'CancellationSecondaryReasonCollectionMetadata'; total: number };
    };
  };
  capabilities: {
    __typename: 'CapabilityQueries';
    all: {
      __typename: 'CapabilityCollection';
      items: Array<{
        __typename: 'Capability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        description: string;
        entityType: EntityType;
      }>;
      meta: { __typename: 'CapabilityCollectionMetadata'; total: number };
    };
  };
  timestampTypes: {
    __typename: 'TimestampTypeQueries';
    all: {
      __typename: 'TimestampTypeCollection';
      items: Array<{
        __typename: 'TimestampType';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        order: number;
        systemTimestampType: SystemTimestampType | null;
        description: string | null;
        companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'TimestampTypeCollectionMetadata'; total: number };
    };
  };
  transportReasons: {
    __typename: 'TransportReasonQueries';
    all: {
      __typename: 'TransportReasonCollection';
      items: Array<{
        __typename: 'TransportReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        operationType: OperationType | null;
      }>;
      meta: { __typename: 'TransportReasonCollectionMetadata'; total: number };
    };
  };
  transferReasons: {
    __typename: 'TransferReasonQueries';
    all: {
      __typename: 'TransferReasonCollection';
      items: Array<{
        __typename: 'TransferReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
      meta: { __typename: 'TransferReasonCollectionMetadata'; total: number };
    };
  };
  diversionReasons: {
    __typename: 'DiversionReasonQueries';
    all: {
      __typename: 'DiversionReasonCollection';
      items: Array<{
        __typename: 'DiversionReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
      meta: { __typename: 'DiversionReasonCollectionMetadata'; total: number };
    };
  };
  nonReferralReasons: {
    __typename: 'NonReferralReasonQueries';
    all: {
      __typename: 'NonReferralReasonCollection';
      items: Array<{
        __typename: 'NonReferralReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        associatedCancellationReasonId: string | null;
        associatedCancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'NonReferralReasonCollectionMetadata'; total: number };
    };
  };
  facilityNonAcceptanceReasons: {
    __typename: 'FacilityNonAcceptanceReasonQueries';
    all: {
      __typename: 'FacilityNonAcceptanceReasonCollection';
      items: Array<{
        __typename: 'FacilityNonAcceptanceReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        facilityNonAcceptanceReasonType: NonAcceptanceType;
      }>;
      meta: { __typename: 'FacilityNonAcceptanceReasonCollectionMetadata'; total: number };
    };
  };
  externalActionTypes: {
    __typename: 'ExternalActionTypeQueries';
    all: {
      __typename: 'ExternalActionTypeCollection';
      items: Array<{
        __typename: 'ExternalActionType';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        actionTypeName: string;
        actionTypeDescription: string;
        priority: number;
      }>;
      meta: { __typename: 'ExternalActionTypeCollectionMetadata'; total: number };
    };
  };
  archiveLogs: {
    __typename: 'ArchiveLogQueries';
    latestAll: {
      __typename: 'ArchiveLogCollection';
      items: Array<{
        __typename: 'ArchiveLog';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        archiveEntityType: ArchiveEntityType;
        archivedUntilDate: Date | number | string;
        isError: boolean;
        notes: string | null;
      }>;
    };
  };
  states: {
    __typename: 'StateQueries';
    all: {
      __typename: 'StateCollection';
      items: Array<{
        __typename: 'State';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        code: string;
        isLicenseRequiredToFly: boolean | null;
      }>;
    };
  };
  paipReasons: {
    __typename: 'PaipReasonQueries';
    all: {
      __typename: 'PaipReasonCollection';
      items: Array<{
        __typename: 'PaipReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        outOfServiceReasonId: string | null;
      }>;
    };
  };
  authenticatedIdentity: {
    __typename: 'Person';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employeeType: EmployeeType;
    timeType: TimeType;
    activateOktaAccount: boolean;
    grantTcsAccess: boolean;
    isOutOfFlightCompliance: boolean;
    companyId: string;
    title: string | null;
    employeeId: string | null;
    hireDate: Date | number | string | null;
    terminationDate: Date | number | string | null;
    departmentId: string | null;
    reportsToPersonId: string | null;
    baseId: string | null;
    locationId: string | null;
    programId: string | null;
    activeDirectoryId: string | null;
    notificationAddress: string | null;
    userRoles: Array<UserRole | null> | null;
    allCompaniesAccessible: boolean | null;
    allBasesAccessible: boolean | null;
    allTrmProgramsAccessible: boolean | null;
    allCommunicationCentersAccessible: boolean | null;
    faaCompanyId: string | null;
    dispatchCompanyId: string | null;
    aviationCompanyId: string | null;
    primaryCommunicationCenterId: string | null;
    outOfFlightComplianceComment: string | null;
    dateLastUpdatedFromGMRWorkday: Date | number | string | null;
    appSettings: {
      __typename: 'UserApplicationSettings';
      tcsRealtimeTracking: {
        __typename: 'TcsRealtimeTracking';
        tabId: string | null;
        tabDate: Date | number | string | null;
      };
    } | null;
    additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  };
  userIdentity: {
    __typename: 'Person';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employeeType: EmployeeType;
    timeType: TimeType;
    activateOktaAccount: boolean;
    grantTcsAccess: boolean;
    isOutOfFlightCompliance: boolean;
    companyId: string;
    title: string | null;
    employeeId: string | null;
    hireDate: Date | number | string | null;
    terminationDate: Date | number | string | null;
    departmentId: string | null;
    reportsToPersonId: string | null;
    baseId: string | null;
    locationId: string | null;
    programId: string | null;
    activeDirectoryId: string | null;
    notificationAddress: string | null;
    userRoles: Array<UserRole | null> | null;
    allCompaniesAccessible: boolean | null;
    allBasesAccessible: boolean | null;
    allTrmProgramsAccessible: boolean | null;
    allCommunicationCentersAccessible: boolean | null;
    faaCompanyId: string | null;
    dispatchCompanyId: string | null;
    aviationCompanyId: string | null;
    primaryCommunicationCenterId: string | null;
    outOfFlightComplianceComment: string | null;
    dateLastUpdatedFromGMRWorkday: Date | number | string | null;
    accessibleItems: Array<{
      __typename: 'AccessibleItem';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      type: EntityType;
      entityId: string;
      personId: string;
      userRoles: Array<UserRole | null> | null;
    }>;
    appSettings: {
      __typename: 'UserApplicationSettings';
      tcsRealtimeTracking: {
        __typename: 'TcsRealtimeTracking';
        tabId: string | null;
        tabDate: Date | number | string | null;
      };
    } | null;
    additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  };
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        states: Array<string | null> | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
    };
  };
  controlZones: {
    __typename: 'ControlZoneQueries';
    all: {
      __typename: 'ControlZoneCollection';
      items: Array<{
        __typename: 'ControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
      }>;
    };
  };
  vehicleControlZones: {
    __typename: 'VehicleControlZoneQueries';
    all: {
      __typename: 'VehicleControlZoneCollection';
      items: Array<{
        __typename: 'VehicleControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        companyId: string;
        controlZoneId: string | null;
        vehicleId: string | null;
      }>;
    };
  };
  baseControlZones: {
    __typename: 'BaseControlZoneQueries';
    all: {
      __typename: 'BaseControlZoneCollection';
      items: Array<{
        __typename: 'BaseControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        controlZoneId: string;
        baseId: string;
        companyId: string;
      }>;
    };
  };
};

export type CardSearchComponent_SearchForCardsQueryVariables = Exact<{
  filter: InputMaybe<CardSearchFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type CardSearchComponent_SearchForCardsQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    search: {
      __typename: 'CardSearchResultCollection';
      meta: { __typename: 'CardCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'CardSearchResult';
        id: string;
        cardNumber: string;
        companyId: string;
        companyCode: string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        status: CardStatus | null;
        callStatus: CardCallStatus | null;
        isBillable: boolean;
        isLocked: boolean | null;
        lastOfferedUnit: { __typename: 'CardSearchResultUnit'; id: string; name: string } | null;
        lastOfferedVehicle: {
          __typename: 'CardSearchResultVehicle';
          id: string;
          registrationNumber: string;
        } | null;
        operation: {
          __typename: 'CardSearchResultOperation';
          id: string;
          status: OperationStatus;
          type: OperationType;
          unit: { __typename: 'CardSearchResultUnit'; id: string; name: string } | null;
          vehicle: {
            __typename: 'CardSearchResultVehicle';
            id: string;
            registrationNumber: string;
          } | null;
        } | null;
        request: {
          __typename: 'CardSearchResultRequest';
          id: string;
          status: RequestStatus;
          requestedOperationType: OperationType;
          pickupLocation: {
            __typename: 'CardSearchResultRequestLocation';
            id: string;
            name: string;
            type: WaypointType;
            locationId: string | null;
            medicalFacilityId: string | null;
            medicalFacilityName: string | null;
            medicalFacilityAbbreviation: string | null;
          } | null;
          dropoffLocation: {
            __typename: 'CardSearchResultRequestLocation';
            id: string;
            name: string;
            type: WaypointType;
            locationId: string | null;
            medicalFacilityId: string | null;
            medicalFacilityName: string | null;
            medicalFacilityAbbreviation: string | null;
          } | null;
        } | null;
      }>;
    };
  };
};

export type NewCardSearchComponent_SearchForCardsQueryVariables = Exact<{
  filter: InputMaybe<CardSearchFilterV2>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NewCardSearchComponent_SearchForCardsQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    searchv2: {
      __typename: 'CardSearchResultCollection';
      meta: { __typename: 'CardCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'CardSearchResult';
        id: string;
        cardNumber: string;
        createdById: string | null;
        createdBy: string | null;
        companyId: string;
        companyCode: string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        status: CardStatus | null;
        callStatus: CardCallStatus | null;
        isBillable: boolean;
        isLocked: boolean | null;
        lastOfferedUnit: { __typename: 'CardSearchResultUnit'; id: string; name: string } | null;
        lastOfferedVehicle: {
          __typename: 'CardSearchResultVehicle';
          id: string;
          registrationNumber: string;
        } | null;
        operation: {
          __typename: 'CardSearchResultOperation';
          id: string;
          status: OperationStatus;
          type: OperationType;
          unit: { __typename: 'CardSearchResultUnit'; id: string; name: string } | null;
          vehicle: {
            __typename: 'CardSearchResultVehicle';
            id: string;
            registrationNumber: string;
          } | null;
        } | null;
        request: {
          __typename: 'CardSearchResultRequest';
          id: string;
          status: RequestStatus;
          requestedOperationType: OperationType;
          pickupLocation: {
            __typename: 'CardSearchResultRequestLocation';
            id: string;
            name: string;
            type: WaypointType;
            locationId: string | null;
            medicalFacilityId: string | null;
            medicalFacilityName: string | null;
            medicalFacilityAbbreviation: string | null;
          } | null;
          dropoffLocation: {
            __typename: 'CardSearchResultRequestLocation';
            id: string;
            name: string;
            type: WaypointType;
            locationId: string | null;
            medicalFacilityId: string | null;
            medicalFacilityName: string | null;
            medicalFacilityAbbreviation: string | null;
          } | null;
        } | null;
        region: {
          __typename: 'CardSearchResultRegion';
          id: string;
          name: string;
          communicationCenter: {
            __typename: 'CardSearchResultCommunicationCenter';
            id: string;
            name: string;
          } | null;
        } | null;
      }>;
    };
  };
};

export type NewCardSearchComponent_FetchAllPeopleQueryVariables = Exact<{
  nameLike: InputMaybe<Scalars['String']>;
  personId: InputMaybe<Scalars['ID']>;
  companyId: InputMaybe<Scalars['ID']>;
}>;

export type NewCardSearchComponent_FetchAllPeopleQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    all: {
      __typename: 'PersonCollection';
      items: Array<{
        __typename: 'Person';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        employeeType: EmployeeType;
        timeType: TimeType;
        activateOktaAccount: boolean;
        grantTcsAccess: boolean;
        isOutOfFlightCompliance: boolean;
        companyId: string;
        title: string | null;
        employeeId: string | null;
        hireDate: Date | number | string | null;
        terminationDate: Date | number | string | null;
        departmentId: string | null;
        reportsToPersonId: string | null;
        baseId: string | null;
        locationId: string | null;
        programId: string | null;
        activeDirectoryId: string | null;
        notificationAddress: string | null;
        userRoles: Array<UserRole | null> | null;
        allCompaniesAccessible: boolean | null;
        allBasesAccessible: boolean | null;
        allTrmProgramsAccessible: boolean | null;
        allCommunicationCentersAccessible: boolean | null;
        faaCompanyId: string | null;
        dispatchCompanyId: string | null;
        aviationCompanyId: string | null;
        primaryCommunicationCenterId: string | null;
        outOfFlightComplianceComment: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        appSettings: {
          __typename: 'UserApplicationSettings';
          tcsRealtimeTracking: {
            __typename: 'TcsRealtimeTracking';
            tabId: string | null;
            tabDate: Date | number | string | null;
          };
        } | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'PersonCollectionMetadata'; total: number };
    };
  };
};

export type NewCardSearchComponent_FetchAllAgencyLocationsQueryVariables = Exact<{
  filter: InputMaybe<AgencyLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NewCardSearchComponent_FetchAllAgencyLocationsQuery = {
  __typename: 'Query';
  agencyLocations: {
    __typename: 'AgencyLocationQueries';
    all: {
      __typename: 'AgencyLocationCollection';
      items: Array<{
        __typename: 'AgencyLocation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isInTransportNet: boolean;
        agencyId: string;
        emailAddress: string | null;
        primaryPhoneNumber: string | null;
        secondaryPhoneNumber: string | null;
        smsPhoneNumber: string | null;
        faxPhoneNumber: string | null;
        notes: string | null;
        vehicleType: VehicleType | null;
        estimatedDepartureTimeInMinutes: number | null;
        locationId: string | null;
      }>;
      meta: { __typename: 'AgencyLocationCollectionMetadata'; total: number };
    };
  };
};

export type NewCardSearchComponent_FetchAllCommunicationCentersQueryVariables = Exact<{
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NewCardSearchComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
      meta: { __typename: 'CommunicationCenterCollectionMetadata'; total: number };
    };
  };
};

export type OosRumEventsComponent_FetchOosDashboardEventsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceEventDashboardDataFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumEventsComponent_FetchOosDashboardEventsQuery = {
  __typename: 'Query';
  outOfServiceEvents: {
    __typename: 'OutOfServiceEventQueries';
    dashboard: {
      __typename: 'OutOfServiceEventDashboardDataCollection';
      items: Array<{
        __typename: 'OutOfServiceEventDashboardData';
        id: string;
        eventNumber: string;
        startTime: Date | number | string | null;
        endTime: Date | number | string | null;
        registrationNumber: string | null;
        unitVehicleTailNumber: string | null;
        companyId: string;
        communicationCenterName: string | null;
        reasonId: string;
        reasonName: string;
        secondaryReasonId: string | null;
        secondaryReasonName: string | null;
        unitName: string | null;
        baseName: string | null;
        estimatedEndTime: Date | number | string;
        vehicleId: string | null;
        typeName: string;
        entityType: string | null;
        communicationCenterId: string | null;
        acknowledgementNotes: string | null;
        dateAcknowledged: Date | number | string | null;
        subeventsCount: number | null;
        maintenanceFacilityName: string | null;
        isAcknowledgementRequired: boolean;
      }>;
      meta: { __typename: 'OutOfServiceEventDashboardDataMetadata'; total: number };
    };
  };
};

export type OosRumEventsComponent_FetchOosEventsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceEventFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumEventsComponent_FetchOosEventsQuery = {
  __typename: 'Query';
  outOfServiceEvents: {
    __typename: 'OutOfServiceEventQueries';
    all: {
      __typename: 'OutOfServiceEventCollection';
      meta: { __typename: 'OutOfServiceEventCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'OutOfServiceEvent';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: OutOfServiceType;
        eventNumber: string;
        estimatedEndTime: Date | number | string;
        reasonId: string;
        isAirworthy: boolean;
        initialEstimatedEndTime: Date | number | string;
        alertWhenEventEnds: boolean;
        isPlanned: boolean;
        isBirdStrike: boolean;
        isPatientOnboard: boolean;
        waitingForParts: boolean;
        waitingForTooling: boolean;
        isAcknowledgementRequired: boolean;
        companyId: string;
        startTime: Date | number | string | null;
        isOpportunisticOOS: boolean | null;
        unitId: string | null;
        vehicleId: string | null;
        secondaryReasonId: string | null;
        scheduledStartTime: Date | number | string | null;
        endTime: Date | number | string | null;
        notes: string | null;
        linkedCardId: string | null;
        createdById: string | null;
        endedById: string | null;
        secondaryReasonComment: string | null;
        parentOutOfServiceEventId: string | null;
        paipEventId: string | null;
        copiedFromId: string | null;
        alertTimeInMinutes: number | null;
        outOfServiceTicketId: string | null;
        maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
        opportunityMXTypes: Array<OpportunityMXType | null> | null;
        rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
        maintenanceLocation: string | null;
        mxDuringPeakTimeReason: string | null;
        assignedBaseId: string | null;
        amtPointOfContactId: string | null;
        alternatePOC: string | null;
        spareVehicleId: string | null;
        ticketDescription: string | null;
        humanErrorDamageType: HumanErrorDamageType | null;
        businessUnitCompanyId: string | null;
        isAMTAvailable: boolean | null;
        isFAR135415Reportable: boolean | null;
        isFAR135417Reportable: boolean | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        acknowledgementNotes: string | null;
        maintenanceFacilityId: string | null;
        locationId: string | null;
        oosRequestType: OosRequestType | null;
        isEventAlreadyClosed: boolean | null;
        qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        crew: Array<{
          __typename: 'OutOfServiceCrew';
          id: string;
          personId: string;
          unitPositionId: string;
          isFlightCrew: boolean;
          positionType: UnitPositionType | null;
          unitPositionRole: string | null;
          endDate: Date | number | string | null;
          notificationAddress: string | null;
        } | null> | null;
      }>;
    };
  };
};

export type OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesQueryVariables =
  Exact<{
    filter: InputMaybe<NotificationTemplateFilter>;
    first: InputMaybe<Scalars['Int']>;
    skip: InputMaybe<Scalars['Int']>;
  }>;

export type OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesQuery = {
  __typename: 'Query';
  notificationTemplates: {
    __typename: 'NotificationTemplateQueries';
    all: {
      __typename: 'NotificationTemplateCollection';
      items: Array<{
        __typename: 'NotificationTemplate';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        contextType: EntityType;
        bodyTemplate: string;
        canBeManualTrigger: boolean;
        companyId: string | null;
        triggerType: NotificationTriggerType | null;
        triggerValue: string | null;
        activationRuleId: string | null;
        recipientTypes: Array<NotificationRecipientType | null> | null;
        subjectTemplate: string | null;
        requiresApproval: boolean | null;
        groupTypes: Array<NotificationGroupType | null> | null;
        createdById: string | null;
      }>;
    };
  };
};

export type OosRumNotificationAddDialogComponent_DeriveOosTemplateQueryVariables = Exact<{
  outOfServiceEventId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;

export type OosRumNotificationAddDialogComponent_DeriveOosTemplateQuery = {
  __typename: 'Query';
  notificationTemplates: {
    __typename: 'NotificationTemplateQueries';
    deriveOOSTemplate: {
      __typename: 'NotificationTemplateResponse';
      activityId: string | null;
      responseCode: string | null;
      errors: Array<string | null> | null;
      data: {
        __typename: 'NotificationTemplateData';
        subject: string | null;
        body: string | null;
        recipients: Array<{
          __typename: 'Recipient';
          name: string | null;
          address: string;
        } | null> | null;
      } | null;
    };
  };
};

export type OosRumAddDialogComponent_FetchOosEventsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceEventDashboardDataFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumAddDialogComponent_FetchOosEventsQuery = {
  __typename: 'Query';
  outOfServiceEvents: {
    __typename: 'OutOfServiceEventQueries';
    dashboard: {
      __typename: 'OutOfServiceEventDashboardDataCollection';
      items: Array<{
        __typename: 'OutOfServiceEventDashboardData';
        id: string;
        eventNumber: string;
      }>;
      meta: { __typename: 'OutOfServiceEventDashboardDataMetadata'; total: number };
    };
  };
};

export type OosRumAddDialogComponent_FetchUnitPositionsByUnitIdQueryVariables = Exact<{
  unitId: Scalars['ID'];
}>;

export type OosRumAddDialogComponent_FetchUnitPositionsByUnitIdQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      id: string;
      positions: Array<{
        __typename: 'UnitPosition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        type: UnitPositionType;
        isFlightCrew: boolean;
        isNonEmployee: boolean;
        unitId: string;
        companyId: string;
        notificationAddress: string | null;
        teamMemberId: string | null;
        firstName: string | null;
        lastName: string | null;
      }>;
    } | null;
  };
};

export type OosRumAddDialogComponent_FetchVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosRumAddDialogComponent_FetchVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{ __typename: 'Vehicle'; id: string; registrationNumber: string }>;
    };
  };
};

export type OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsQueryVariables =
  Exact<{
    vehicleId: Scalars['ID'];
  }>;

export type OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      id: string;
      vehicleNotificationGroups: Array<{
        __typename: 'VehicleNotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        vehicleId: string;
        notificationGroupId: string;
        notificationGroup: {
          __typename: 'NotificationGroup';
          types: Array<NotificationGroupType | null> | null;
          name: string;
          members: Array<{
            __typename: 'NotificationGroupMember';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            notificationGroupId: string;
            companyId: string;
            userId: string | null;
            notificationAddress: string | null;
            user: { __typename: 'Person'; notificationAddress: string | null } | null;
          }>;
        };
      }>;
    } | null;
  };
};

export type OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsQueryVariables = Exact<{
  vehicleId: Scalars['ID'];
}>;

export type OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byVehicleId: {
      __typename: 'Unit';
      notificationSubscriptions: Array<{
        __typename: 'NotificationSubscription';
        notificationGroup: {
          __typename: 'NotificationGroup';
          types: Array<NotificationGroupType | null> | null;
          name: string;
          members: Array<{
            __typename: 'NotificationGroupMember';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            notificationGroupId: string;
            companyId: string;
            userId: string | null;
            notificationAddress: string | null;
            user: { __typename: 'Person'; notificationAddress: string | null } | null;
          }>;
        };
      }>;
    } | null;
  };
};

export type OosRumNotificationsComponent_FetchOosDashboardNotificationsQueryVariables = Exact<{
  filter: InputMaybe<NotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosRumNotificationsComponent_FetchOosDashboardNotificationsQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    all: {
      __typename: 'NotificationCollection';
      items: Array<{
        __typename: 'Notification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: NotificationStatus;
        body: string;
        companyId: string;
        cardId: string | null;
        subject: string | null;
        sourceTemplateId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        createdById: string | null;
      }>;
      meta: { __typename: 'NotificationCollectionMetadata'; total: number };
    };
  };
};

export type OosRumNotificationsComponent_FetchAllNotificationTemplatesQueryVariables = Exact<{
  filter: InputMaybe<NotificationTemplateFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosRumNotificationsComponent_FetchAllNotificationTemplatesQuery = {
  __typename: 'Query';
  notificationTemplates: {
    __typename: 'NotificationTemplateQueries';
    all: {
      __typename: 'NotificationTemplateCollection';
      items: Array<{
        __typename: 'NotificationTemplate';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        contextType: EntityType;
        bodyTemplate: string;
        canBeManualTrigger: boolean;
        companyId: string | null;
        triggerType: NotificationTriggerType | null;
        triggerValue: string | null;
        activationRuleId: string | null;
        recipientTypes: Array<NotificationRecipientType | null> | null;
        subjectTemplate: string | null;
        requiresApproval: boolean | null;
        groupTypes: Array<NotificationGroupType | null> | null;
        createdById: string | null;
      }>;
    };
  };
};

export type OosRumTicketFormComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketFormComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{ __typename: 'Base'; name: string; id: string }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type OosRumTicketFormComponent_FetchQarReasonsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OosRumTicketFormComponent_FetchQarReasonsQuery = {
  __typename: 'Query';
  outOfServiceQARReasons: {
    __typename: 'OutOfServiceQARReasonQueries';
    all: {
      __typename: 'OutOfServiceQARReasonCollection';
      items: Array<{ __typename: 'OutOfServiceQARReason'; name: string; id: string }>;
    };
  };
};

export type OosRumTicketFormComponent_FetchVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketFormComponent_FetchVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        id: string;
        registrationNumber: string;
        communicationCenterId: string | null;
      }>;
    };
  };
};

export type OosRumTicketFormComponent_FetchOosEventsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceEventFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketFormComponent_FetchOosEventsQuery = {
  __typename: 'Query';
  outOfServiceEvents: {
    __typename: 'OutOfServiceEventQueries';
    all: {
      __typename: 'OutOfServiceEventCollection';
      meta: { __typename: 'OutOfServiceEventCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'OutOfServiceEvent';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: OutOfServiceType;
        eventNumber: string;
        estimatedEndTime: Date | number | string;
        reasonId: string;
        isAirworthy: boolean;
        initialEstimatedEndTime: Date | number | string;
        alertWhenEventEnds: boolean;
        isPlanned: boolean;
        isBirdStrike: boolean;
        isPatientOnboard: boolean;
        waitingForParts: boolean;
        waitingForTooling: boolean;
        isAcknowledgementRequired: boolean;
        companyId: string;
        startTime: Date | number | string | null;
        isOpportunisticOOS: boolean | null;
        unitId: string | null;
        vehicleId: string | null;
        secondaryReasonId: string | null;
        scheduledStartTime: Date | number | string | null;
        endTime: Date | number | string | null;
        notes: string | null;
        linkedCardId: string | null;
        createdById: string | null;
        endedById: string | null;
        secondaryReasonComment: string | null;
        parentOutOfServiceEventId: string | null;
        paipEventId: string | null;
        copiedFromId: string | null;
        alertTimeInMinutes: number | null;
        outOfServiceTicketId: string | null;
        maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
        opportunityMXTypes: Array<OpportunityMXType | null> | null;
        rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
        maintenanceLocation: string | null;
        mxDuringPeakTimeReason: string | null;
        assignedBaseId: string | null;
        amtPointOfContactId: string | null;
        alternatePOC: string | null;
        spareVehicleId: string | null;
        ticketDescription: string | null;
        humanErrorDamageType: HumanErrorDamageType | null;
        businessUnitCompanyId: string | null;
        isAMTAvailable: boolean | null;
        isFAR135415Reportable: boolean | null;
        isFAR135417Reportable: boolean | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        acknowledgementNotes: string | null;
        maintenanceFacilityId: string | null;
        locationId: string | null;
        oosRequestType: OosRequestType | null;
        isEventAlreadyClosed: boolean | null;
        qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        crew: Array<{
          __typename: 'OutOfServiceCrew';
          id: string;
          personId: string;
          unitPositionId: string;
          isFlightCrew: boolean;
          positionType: UnitPositionType | null;
          unitPositionRole: string | null;
          endDate: Date | number | string | null;
          notificationAddress: string | null;
        } | null> | null;
      }>;
    };
  };
};

export type OosRumTicketFormComponent_FetchMaintenanceFacilitiesQueryVariables = Exact<{
  filter: InputMaybe<MaintenanceFacilityFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketFormComponent_FetchMaintenanceFacilitiesQuery = {
  __typename: 'Query';
  maintenanceFacilities: {
    __typename: 'MaintenanceFacilityQueries';
    all: {
      __typename: 'MaintenanceFacilityCollection';
      items: Array<{ __typename: 'MaintenanceFacility'; name: string; id: string }>;
    };
  };
};

export type OosRumTicketFormComponent_FetchVehicleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type OosRumTicketFormComponent_FetchVehicleByIdQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      type: VehicleType;
      registrationNumber: string;
      isUnderLease: boolean;
      role: VehicleRole;
      flightLogProcess: FlightLogProcess;
      isPlaceholder: boolean;
      stateInspectionRequired: boolean;
      isRetired: boolean;
      isPositionTrackingEnabled: boolean;
      hideFromOOSRUM: boolean;
      companyId: string;
      serialNumber: string | null;
      dispatchCompanyId: string | null;
      year: number | null;
      dateAcquired: Date | number | string | null;
      makeId: string | null;
      modelId: string | null;
      cruiseSpeed: number | null;
      configurationClassId: string | null;
      isThirdPartyVehicle: boolean | null;
      parentUnitId: string | null;
      isHidden: boolean | null;
      faaCompanyId: string | null;
      skytracIMEI: string | null;
      phoneNumber: string | null;
      completeFlightId: string | null;
      controlZoneId: string | null;
      communicationCenterId: string | null;
      regionId: string | null;
      vehicleDescription: string | null;
      vehicleDispositions: Array<{
        __typename: 'VehicleDisposition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        vehicleId: string;
        status: VehicleStatus;
        companyId: string;
        currentWaypointId: string | null;
        currentTripLegId: string | null;
        currentTripId: string | null;
        lastTripId: string | null;
        currentAgencyLocationId: string | null;
        notes: string | null;
        isAssetOutOfService: boolean | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        latitude: number | null;
        longitude: number | null;
        etlo: Date | number | string | null;
        statusDescription: string | null;
        positionTime: Date | number | string | null;
        positionSource: PositionReportSource | null;
        vehiclePositionSummaryId: string | null;
        latestPositionReportId: string | null;
        latestFlightFollowingReportId: string | null;
        currentWaypoint: {
          __typename: 'Waypoint';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          companyId: string;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          arrivalTime: Date | number | string | null;
          departureTime: Date | number | string | null;
          locationId: string | null;
          isPatientPickup: boolean | null;
          isPatientDropoff: boolean | null;
          arrivingType: WaypointType | null;
          estimatedDurationId: string | null;
          currentEtaId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
          location: {
            __typename: 'Location';
            id: string;
            locationType: LocationType;
            name: string;
            abbreviation: string;
            notes: string | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            };
          } | null;
        } | null;
        from: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        to: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
      }>;
    } | null;
  };
};

export type OosRumTicketsComponent_FetchOosDashboardTicketsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceTicketDashboardDataFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketsComponent_FetchOosDashboardTicketsQuery = {
  __typename: 'Query';
  outOfServiceTickets: {
    __typename: 'OutOfServiceTicketQueries';
    dashboard: {
      __typename: 'OutOfServiceTicketDashboardDataCollection';
      items: Array<{
        __typename: 'OutOfServiceTicketDashboardData';
        id: string;
        ticketNumber: string;
        ticketDescription: string;
        companyId: string;
        maintenanceTypes: string;
        maintenanceFacilityName: string | null;
        unitId: string | null;
        unitName: string | null;
        unitAbbreviation: string | null;
        communicationCenterId: string | null;
        communicationCenterName: string | null;
        vehicleId: string | null;
        spareVehicleId: string | null;
        spareRegistrationNumber: string | null;
        registrationNumber: string;
        assignedBaseId: string | null;
        assignedBaseName: string | null;
        outOfServiceTime: Date | number | string | null;
        pointOfContactId: string | null;
        pointOfContactName: string | null;
        submittedById: string;
        submittedByName: string;
        statusName: string;
        acknowledgementNotes: string | null;
        dateAcknowledged: Date | number | string | null;
      }>;
      meta: { __typename: 'OutOfServiceTicketDashboardDataMetadata'; total: number };
    };
  };
};

export type OosRumTicketsComponent_FetchOosTicketsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceTicketFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketsComponent_FetchOosTicketsQuery = {
  __typename: 'Query';
  outOfServiceTickets: {
    __typename: 'OutOfServiceTicketQueries';
    all: {
      __typename: 'OutOfServiceTicketCollection';
      items: Array<{
        __typename: 'OutOfServiceTicket';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        isPlanned: boolean;
        maintenanceTypes: Array<OosTicketMaintenanceType>;
        vehicleId: string;
        outOfServiceTime: Date | number | string;
        ertsDateTime: Date | number | string;
        submittedById: string;
        ticketDescription: string;
        isBirdStrike: boolean;
        isPatientOnboard: boolean;
        waitingForParts: boolean;
        waitingForTooling: boolean;
        status: OosTicketStatusType;
        companyId: string;
        ticketNumber: string | null;
        businessUnitCompanyId: string | null;
        assignedBaseId: string | null;
        maintenanceLocation: string | null;
        dateSubmittedForReview: Date | number | string | null;
        pointOfContactId: string | null;
        alternatePOC: string | null;
        spareVehicleId: string | null;
        opportunityMXTypes: Array<OpportunityMXType | null> | null;
        mxDuringPeakTimeReason: string | null;
        waitingForPartsTimestamp: Date | number | string | null;
        waitingForToolingTimestamp: Date | number | string | null;
        isAMTAvailable: boolean | null;
        isFAR135415Reportable: boolean | null;
        isFAR135417Reportable: boolean | null;
        acceptedById: string | null;
        dateAccepted: Date | number | string | null;
        humanErrorDamageType: HumanErrorDamageType | null;
        rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
        pageoutCompletedById: string | null;
        datePageoutCompleted: Date | number | string | null;
        primaryReasonId: string | null;
        secondaryReasonId: string | null;
        outOfServiceType: OutOfServiceType | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        acknowledgementNotes: string | null;
        maintenanceFacilityId: string | null;
        locationId: string | null;
        isOpportunisticOOS: boolean | null;
        qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
      }>;
      meta: { __typename: 'OutOfServiceTicketCollectionMetadata'; total: number };
    };
  };
};

export type OosRumTicketsComponent_FetchVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosRumTicketsComponent_FetchVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      }>;
    };
  };
};

export type CardActivityHistory_FetchCardLinksQueryVariables = Exact<{
  filter: InputMaybe<CardLinkFilter>;
}>;

export type CardActivityHistory_FetchCardLinksQuery = {
  __typename: 'Query';
  cardLinks: {
    __typename: 'CardLinkQueries';
    all: {
      __typename: 'CardLinkCollection';
      items: Array<{
        __typename: 'CardLink';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: CardLinkType;
        fromCardId: string;
        toCardId: string;
        toCardNumber: string;
        companyId: string;
        rendezvousRequestId: string | null;
      }>;
    };
  };
};

export type CardTimelineComponent_FetchTimelineItemsQueryVariables = Exact<{
  filter: InputMaybe<TimelineItemFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type CardTimelineComponent_FetchTimelineItemsQuery = {
  __typename: 'Query';
  timelineItems: {
    __typename: 'TimelineItemQueries';
    all: {
      __typename: 'TimelineItemCollection';
      items: Array<{
        __typename: 'TimelineItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        timestampTypeId: string;
        required: boolean;
        sequence: number;
        timelineId: string;
        timeline: {
          __typename: 'Timeline';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string | null;
          activationRuleId: string | null;
          timelineType: TimelineTypes | null;
        };
      }>;
      meta: { __typename: 'TimelineItemCollectionMetadata'; total: number };
    };
  };
};

export type RequestLocationFormComponent_FetchMedicalFacilityEntitiesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RequestLocationFormComponent_FetchMedicalFacilityEntitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      npi: string;
      providerNumber: string | null;
      sourceSystemId: number | null;
      masterDataSetId: number | null;
      firmType: string | null;
      hospitalType: string | null;
      hospitalSpecialization: string | null;
      website: string | null;
      defaultLandingZoneId: string | null;
      defaultFixedWingLandingZoneId: string | null;
      notes: string | null;
      stateSourceSystemId: string | null;
      nemsisCode: string | null;
      stateFacilityName: string | null;
      status: MedicalFacilityStatus | null;
      archiveNotes: string | null;
      archiveClearedDate: Date | number | string | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultFixedWingLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      units: Array<{
        __typename: 'MedicalFacilityUnit';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        medicalFacilityId: string;
        phoneNumber: string | null;
      }>;
      associatedPhysicians: Array<{
        __typename: 'MedicalFacilityPhysician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        physicianId: string;
        medicalFacilityId: string;
        physician: {
          __typename: 'Physician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
        };
      }>;
      communicationCenterCustomIdentifiers: Array<{
        __typename: 'IdNameListItem';
        id: string;
        name: string;
      } | null> | null;
    } | null;
  };
};

export type CardContactComponent_FetchTimelineItemsQueryVariables = Exact<{
  filter: InputMaybe<TimelineItemFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type CardContactComponent_FetchTimelineItemsQuery = {
  __typename: 'Query';
  timelineItems: {
    __typename: 'TimelineItemQueries';
    all: {
      __typename: 'TimelineItemCollection';
      items: Array<{
        __typename: 'TimelineItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        timestampTypeId: string;
        required: boolean;
        sequence: number;
        timelineId: string;
        timeline: {
          __typename: 'Timeline';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string | null;
          activationRuleId: string | null;
          timelineType: TimelineTypes | null;
        };
      }>;
      meta: { __typename: 'TimelineItemCollectionMetadata'; total: number };
    };
  };
};

export type CardContactComponent_GetCardbyCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type CardContactComponent_GetCardbyCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
    } | null;
  };
};

export type CardContactComponent_GetRegionByIdQueryVariables = Exact<{
  regionId: Scalars['ID'];
}>;

export type CardContactComponent_GetRegionByIdQuery = {
  __typename: 'Query';
  regions: {
    __typename: 'RegionQueries';
    byId: {
      __typename: 'Region';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      communicationCenterId: string;
      isTransferCenterRegion: boolean;
      regionGroupId: string;
      companyId: string;
      timezoneCd: string | null;
      emSystemDivisionName: string | null;
      dispatchNumber: string | null;
      fixedWingPreferredThresholdInNauticalMiles: number | null;
      etcInMinutes: number | null;
    } | null;
  };
};

export type ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesQueryVariables =
  Exact<{
    filter: InputMaybe<MedicalFacilityFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    all: {
      __typename: 'MedicalFacilityCollection';
      items: Array<{
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      }>;
    };
  };
};

export type Card_FetchNotificationEntitiesQueryVariables = Exact<{
  filter: InputMaybe<NotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
  includeItems?: Scalars['Boolean'];
  includeCount?: Scalars['Boolean'];
}>;

export type Card_FetchNotificationEntitiesQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    all: {
      __typename: 'NotificationCollection';
      items?: Array<{
        __typename: 'Notification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: NotificationStatus;
        body: string;
        companyId: string;
        cardId: string | null;
        subject: string | null;
        sourceTemplateId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        createdById: string | null;
        recipients: Array<{
          __typename: 'NotificationRecipient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          notificationId: string;
          companyId: string;
          name: string | null;
          notificationAddress: string | null;
          userId: string | null;
          messageId: string | null;
          messageStatus: MessageStatus | null;
          message: {
            __typename: 'TrackedMessage';
            messageStatusUpdates: Array<{
              __typename: 'MessageStatusUpdate';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              status: MessageStatus;
              trackedMessageId: string;
              error: string | null;
              vendorMessage: string | null;
              metadataJson: string | null;
            }>;
          } | null;
        }>;
      }>;
      meta?: { __typename: 'NotificationCollectionMetadata'; total: number };
    };
  };
};

export type Card_FetchTimeEntitiesQueryVariables = Exact<{
  cardId: Scalars['ID'];
  timestampsFilter: InputMaybe<TimestampsByCardFilter>;
  timestampsUsersfilter: InputMaybe<TimestampsByCardFilter>;
  includeTimestamps?: Scalars['Boolean'];
  includeTimestampDistinctUsers?: Scalars['Boolean'];
  includeActiveTimelines?: Scalars['Boolean'];
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type Card_FetchTimeEntitiesQuery = {
  __typename: 'Query';
  timestampsByCard: {
    __typename: 'TimestampQueries';
    byCardId: {
      __typename: 'TimestampCollection';
      items: Array<{
        __typename: 'Timestamp';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        time: Date | number | string;
        typeId: string;
        cardId: string;
        companyId: string;
        userId: string | null;
        note: string | null;
        requestId: string | null;
        operationId: string | null;
        personsInvolved: string | null;
      }>;
      meta: { __typename: 'TimestampCollectionMetadata'; total: number };
    };
  };
  timestampUsersByCard: {
    __typename: 'TimestampQueries';
    byCardId: {
      __typename: 'TimestampCollection';
      items: Array<{
        __typename: 'Timestamp';
        user: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      meta: { __typename: 'TimestampCollectionMetadata'; total: number };
    };
  };
  activeTimelines?: {
    __typename: 'ActiveTimelineQueries';
    byCardId: {
      __typename: 'ActiveTimelineCollection';
      items: Array<{
        __typename: 'ActiveTimeline';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        timelineId: string;
        companyId: string;
        matchType: RuleMatchType;
        entityType: EntityType;
        entityId: string;
      }>;
      meta: { __typename: 'ActiveTimelineCollectionMetadata'; total: number };
    };
  };
};

export type QuestionnaireResponseContextResolver_FetchQuestionnaireResponseQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type QuestionnaireResponseContextResolver_FetchQuestionnaireResponseQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      questionnaireResponses: Array<{
        __typename: 'QuestionnaireResponse';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: QuestionnaireResponseStatus;
        questionnaireId: string;
        companyId: string;
        cardId: string;
        currentReviewLevel: UserRole | null;
        completedById: string | null;
        dateCompleted: Date | number | string | null;
        communicationsReviewById: string | null;
        dateCommunicationsReviewed: Date | number | string | null;
        supervisorReviewById: string | null;
        dateSupervisorReviewed: Date | number | string | null;
        managerReviewById: string | null;
        dateManagerReviewed: Date | number | string | null;
        questionnaireQuestionResponses: Array<{
          __typename: 'QuestionnaireQuestionResponse';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireResponseId: string;
          questionnaireSectionQuestionId: string;
          matchType: RuleMatchType;
          reviewRequired: boolean;
          companyId: string;
          responseValue: string | null;
          explanation: string | null;
          questionnaireQuestionResponseNotes: Array<{
            __typename: 'QuestionnaireQuestionResponseNote';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            questionnaireQuestionResponseId: string;
            authorId: string;
            dateAuthored: Date | number | string;
            note: string;
            companyId: string;
          }>;
        }>;
        questionnaire: {
          __typename: 'Questionnaire';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          type: QuestionnaireType;
          communicationCenterId: string | null;
          questionnaireSections: Array<{
            __typename: 'QuestionnaireSection';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            questionnaireId: string;
            sequence: number;
            questionnaireSectionQuestions: Array<{
              __typename: 'QuestionnaireSectionQuestion';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              questionnaireSectionId: string;
              questionId: string;
              responsibleRole: UserRole;
              sequence: number;
              isDisabled: boolean;
              activationRuleId: string | null;
              activityType: string | null;
              question: {
                __typename: 'Question';
                dateLastUpdated: Date | number | string;
                dateCreated: Date | number | string;
                dateDeleted: Date | number | string | null;
                lastUpdatedById: string | null;
                id: string;
                name: string;
                question: string;
                questionType: QuestionType;
                dataType: QuestionDataType | null;
                choices: Array<{
                  __typename: 'QuestionChoice';
                  dateLastUpdated: Date | number | string;
                  dateCreated: Date | number | string;
                  dateDeleted: Date | number | string | null;
                  lastUpdatedById: string | null;
                  id: string;
                  label: string;
                  value: string;
                  questionId: string;
                }>;
              };
              explanationRequiredChoices: Array<{
                __typename: 'IdListItem';
                id: string;
              } | null> | null;
              reviewRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
            }>;
          }>;
        };
      }>;
    } | null;
  };
};

export type RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsQueryVariables =
  Exact<{
    filter: InputMaybe<SpecialtyTeamFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsQuery = {
  __typename: 'Query';
  specialtyTeams: {
    __typename: 'SpecialtyTeamQueries';
    all: {
      __typename: 'SpecialtyTeamCollection';
      items: Array<{
        __typename: 'SpecialtyTeam';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        affiliationId: string;
        companyId: string;
      }>;
      meta: { __typename: 'SpecialtyTeamCollectionMetadata'; total: number };
    };
  };
};

export type SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersQueryVariables =
  Exact<{
    filter: InputMaybe<SpecialtyTeamMemberFilter>;
  }>;

export type SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersQuery = {
  __typename: 'Query';
  specialtyTeamMembers: {
    __typename: 'SpectialtyTeamMemberQueries';
    all: {
      __typename: 'SpecialtyTeamMemberCollection';
      items: Array<{
        __typename: 'SpecialtyTeamMember';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        specialtyTeamId: string;
        teamMemberId: string;
        companyId: string;
        weightInKg: number | null;
        teamMember: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
      meta: { __typename: 'SpecialtyTeamMemberCollectionMetadata'; total: number };
    };
  };
};

export type CommunicationCenterInfoComponent_FetchCommunicationCenterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CommunicationCenterInfoComponent_FetchCommunicationCenterQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      status: UnitStatus;
      weatherStatus: WeatherStatus;
      baseId: string;
      regionId: string;
      isExternallyManaged: boolean;
      maximumFlightRule: FlightRule;
      isOnDelay: boolean;
      isEnabled: boolean;
      isSpare: boolean;
      integrations: Array<IntegrationSystem>;
      isCrewAvailable: boolean;
      updatePhoneNumbersFromExternal: boolean;
      companyId: string;
      isAdministrative: boolean | null;
      vehicleId: string | null;
      isHidden: boolean | null;
      isThirdPartyUnit: boolean | null;
      etloInMinutes: number | null;
      pilotNotes: string | null;
      lastPilotUpdateTime: Date | number | string | null;
      lastPilotUpdateById: string | null;
      plannedAvailableNotes: string | null;
      plannedAvailableTime: Date | number | string | null;
      oemPlacardNumber: string | null;
      primaryOutOfServiceEventId: string | null;
      emSystemResourceId: string | null;
      onBaseETAInMinutes: number | null;
      crewSourcedFromUnitId: string | null;
      completeFlightInstanceId: string | null;
      parentUnitId: string | null;
      region: {
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
        communicationCenter: {
          __typename: 'CommunicationCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          playAlertForManualPositionReports: boolean;
          enableRAAlert: boolean;
          useCrewPhoneNumber: boolean;
          displayContactTimeline: boolean;
          companyId: string;
          timezoneCd: string | null;
          primaryPhoneNumber: string | null;
          emailAddress: string | null;
          showReferToGmrWarning: boolean | null;
          alertFrequencyForGroundVehicles: number | null;
        };
      };
      crewSourcedToUnits: Array<{
        __typename: 'CrewSourcedUnit';
        id: string;
        unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
      } | null> | null;
    } | null;
  };
};

export type ExternalAgencyInfoComponent_FetchExternalAgencyLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ExternalAgencyInfoComponent_FetchExternalAgencyLocationQuery = {
  __typename: 'Query';
  agencyLocations: {
    __typename: 'AgencyLocationQueries';
    byId: {
      __typename: 'AgencyLocation';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      isInTransportNet: boolean;
      agencyId: string;
      emailAddress: string | null;
      primaryPhoneNumber: string | null;
      secondaryPhoneNumber: string | null;
      smsPhoneNumber: string | null;
      faxPhoneNumber: string | null;
      notes: string | null;
      vehicleType: VehicleType | null;
      estimatedDepartureTimeInMinutes: number | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
    } | null;
  };
};

export type FetchRequestCandidateUnitContextQueryVariables = Exact<{
  unitId: Scalars['ID'];
}>;

export type FetchRequestCandidateUnitContextQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      excludeStates: Array<string | null> | null;
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      status: UnitStatus;
      weatherStatus: WeatherStatus;
      baseId: string;
      regionId: string;
      isExternallyManaged: boolean;
      maximumFlightRule: FlightRule;
      isOnDelay: boolean;
      isEnabled: boolean;
      isSpare: boolean;
      integrations: Array<IntegrationSystem>;
      isCrewAvailable: boolean;
      updatePhoneNumbersFromExternal: boolean;
      companyId: string;
      isAdministrative: boolean | null;
      vehicleId: string | null;
      isHidden: boolean | null;
      isThirdPartyUnit: boolean | null;
      etloInMinutes: number | null;
      pilotNotes: string | null;
      lastPilotUpdateTime: Date | number | string | null;
      lastPilotUpdateById: string | null;
      plannedAvailableNotes: string | null;
      plannedAvailableTime: Date | number | string | null;
      oemPlacardNumber: string | null;
      primaryOutOfServiceEventId: string | null;
      emSystemResourceId: string | null;
      onBaseETAInMinutes: number | null;
      crewSourcedFromUnitId: string | null;
      completeFlightInstanceId: string | null;
      parentUnitId: string | null;
      positions: Array<{
        __typename: 'UnitPosition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        type: UnitPositionType;
        isFlightCrew: boolean;
        isNonEmployee: boolean;
        unitId: string;
        companyId: string;
        notificationAddress: string | null;
        teamMemberId: string | null;
        firstName: string | null;
        lastName: string | null;
        teamMember: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      shifts: Array<{
        __typename: 'UnitShift';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        startTimeInMinutes: number;
        endTimeInMinutes: number;
        unitId: string;
        companyId: string;
      }>;
      vehicle: {
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
        vehicleDispositions: Array<{
          __typename: 'VehicleDisposition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          status: VehicleStatus;
          companyId: string;
          currentWaypointId: string | null;
          currentTripLegId: string | null;
          currentTripId: string | null;
          lastTripId: string | null;
          currentAgencyLocationId: string | null;
          notes: string | null;
          isAssetOutOfService: boolean | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          latitude: number | null;
          longitude: number | null;
          etlo: Date | number | string | null;
          statusDescription: string | null;
          positionTime: Date | number | string | null;
          positionSource: PositionReportSource | null;
          vehiclePositionSummaryId: string | null;
          latestPositionReportId: string | null;
          latestFlightFollowingReportId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
        }>;
        model: {
          __typename: 'VehicleModel';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cruiseSpeedInMph: number | null;
        } | null;
        vehicleStateInspections: Array<{
          __typename: 'VehicleStateInspection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          inspectionDate: Date | number | string;
          vehicleId: string;
          companyId: string;
        }>;
      } | null;
      crewSourcedToUnits: Array<{
        __typename: 'CrewSourcedUnit';
        id: string;
        unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
      } | null> | null;
    } | null;
  };
};

export type RequestViewComponent_FetchAllSpecialtyTeamMembersQueryVariables = Exact<{
  filter: InputMaybe<SpecialtyTeamMemberFilter>;
}>;

export type RequestViewComponent_FetchAllSpecialtyTeamMembersQuery = {
  __typename: 'Query';
  specialtyTeamMembers: {
    __typename: 'SpectialtyTeamMemberQueries';
    all: {
      __typename: 'SpecialtyTeamMemberCollection';
      items: Array<{
        __typename: 'SpecialtyTeamMember';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        specialtyTeamId: string;
        teamMemberId: string;
        companyId: string;
        weightInKg: number | null;
        teamMember: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
      meta: { __typename: 'SpecialtyTeamMemberCollectionMetadata'; total: number };
    };
  };
};

export type FetchTransportOfferUnitContextQueryVariables = Exact<{
  unitId: Scalars['ID'];
}>;

export type FetchTransportOfferUnitContextQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      excludeStates: Array<string | null> | null;
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      status: UnitStatus;
      weatherStatus: WeatherStatus;
      baseId: string;
      regionId: string;
      isExternallyManaged: boolean;
      maximumFlightRule: FlightRule;
      isOnDelay: boolean;
      isEnabled: boolean;
      isSpare: boolean;
      integrations: Array<IntegrationSystem>;
      isCrewAvailable: boolean;
      updatePhoneNumbersFromExternal: boolean;
      companyId: string;
      isAdministrative: boolean | null;
      vehicleId: string | null;
      isHidden: boolean | null;
      isThirdPartyUnit: boolean | null;
      etloInMinutes: number | null;
      pilotNotes: string | null;
      lastPilotUpdateTime: Date | number | string | null;
      lastPilotUpdateById: string | null;
      plannedAvailableNotes: string | null;
      plannedAvailableTime: Date | number | string | null;
      oemPlacardNumber: string | null;
      primaryOutOfServiceEventId: string | null;
      emSystemResourceId: string | null;
      onBaseETAInMinutes: number | null;
      crewSourcedFromUnitId: string | null;
      completeFlightInstanceId: string | null;
      parentUnitId: string | null;
      positions: Array<{
        __typename: 'UnitPosition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        type: UnitPositionType;
        isFlightCrew: boolean;
        isNonEmployee: boolean;
        unitId: string;
        companyId: string;
        notificationAddress: string | null;
        teamMemberId: string | null;
        firstName: string | null;
        lastName: string | null;
        teamMember: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      shifts: Array<{
        __typename: 'UnitShift';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        startTimeInMinutes: number;
        endTimeInMinutes: number;
        unitId: string;
        companyId: string;
      }>;
      vehicle: {
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
        vehicleDispositions: Array<{
          __typename: 'VehicleDisposition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          status: VehicleStatus;
          companyId: string;
          currentWaypointId: string | null;
          currentTripLegId: string | null;
          currentTripId: string | null;
          lastTripId: string | null;
          currentAgencyLocationId: string | null;
          notes: string | null;
          isAssetOutOfService: boolean | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          latitude: number | null;
          longitude: number | null;
          etlo: Date | number | string | null;
          statusDescription: string | null;
          positionTime: Date | number | string | null;
          positionSource: PositionReportSource | null;
          vehiclePositionSummaryId: string | null;
          latestPositionReportId: string | null;
          latestFlightFollowingReportId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
        }>;
        model: {
          __typename: 'VehicleModel';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cruiseSpeedInMph: number | null;
        } | null;
        vehicleStateInspections: Array<{
          __typename: 'VehicleStateInspection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          inspectionDate: Date | number | string;
          vehicleId: string;
          companyId: string;
        }>;
      } | null;
      crewSourcedToUnits: Array<{
        __typename: 'CrewSourcedUnit';
        id: string;
        unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
      } | null> | null;
    } | null;
  };
};

export type FetchTransportOffersForCardQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type FetchTransportOffersForCardQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      request: {
        __typename: 'Request';
        transportOffers: Array<{
          __typename: 'TransportOffer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TransportOfferStatus;
          rank: number;
          response: TransportOfferResponse;
          wasBulkSkip: boolean;
          isOnDelay: boolean;
          isOneCallAgreement: boolean;
          isInternalAgency: boolean;
          requestId: string;
          companyId: string;
          distanceInMiles: number | null;
          bearingInDegrees: number | null;
          estimatedDepartureTimeInMinutes: number | null;
          estimatedTimeEnRouteInMinutes: number | null;
          offerTime: Date | number | string | null;
          crewNotified: Date | number | string | null;
          transportCheckInitiated: Date | number | string | null;
          notificationAcknowledged: Date | number | string | null;
          responseReceived: Date | number | string | null;
          declineReasonId: string | null;
          declineSecondaryReasonId: string | null;
          nonReferralReasonId: string | null;
          nonReferralReasonNotes: string | null;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          outOfServiceEventId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          agencyLocationId: string | null;
          unitDescription: string | null;
          isReferral: boolean | null;
          vehicleType: VehicleType | null;
          patientOriginatesAtUnit: boolean | null;
          homeBaseDistanceInMiles: number | null;
          baseId: string | null;
          preferredRank: number | null;
          notes: string | null;
          onBaseETAInMinutes: number | null;
          specialtyTeamETLOInMinutes: number | null;
          specialtyTeamETEInMinutes: number | null;
          dateDeclinedOrAborted: Date | number | string | null;
          declinedOrAbortedById: string | null;
          etc: number | null;
          crewMustFlyToArriveAtSending: boolean | null;
          vehicleCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
          crew: Array<{
            __typename: 'UnitPositionSnapshot';
            id: string;
            firstName: string;
            lastName: string;
            type: UnitPositionType;
          } | null> | null;
        }>;
        transportOfferOptions: Array<{
          __typename: 'TransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          type: TransportOfferOptionType;
          requestId: string;
          companyId: string;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        }>;
      } | null;
    } | null;
  };
};

export type PatientInfoComponent_FetchCardByCardIdQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;

export type PatientInfoComponent_FetchCardByCardIdQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byId: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
      request: {
        __typename: 'Request';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: RequestStatus;
        requestedOperationType: OperationType;
        isStandbyRequest: boolean;
        standbyActivationRequested: boolean;
        missionConfiguration: MissionConfiguration;
        missionProfile: MissionProfile;
        companyId: string;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
        cancellationReasonNotes: string | null;
        requestedVehicleType: VehicleType | null;
        primaryUnitServiceAreaId: string | null;
        commitUnitToStandby: boolean | null;
        initiationType: RequestInitiationType | null;
        assignmentDelayedTime: Date | number | string | null;
        assignmentDelayedReasonId: string | null;
        regionId: string | null;
        includeCompetitors: boolean | null;
        transportOfferAlgorithmId: string | null;
        transportOfferAlgorithm: TransportOfferAlgorithm | null;
        minimumFlightRule: FlightRule | null;
        transportTrackingLink: string | null;
        latestWeatherDeclineUnitId: string | null;
        latestWeatherDeclineTime: Date | number | string | null;
        latestWeatherDeclineReasonId: string | null;
        latestWeatherDeclineSecondaryReasonId: string | null;
        webOrderCallType: WebOrderCallType | null;
        etloInMinutes: number | null;
        atloInMinutes: number | null;
        requester: {
          __typename: 'Requester';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          affiliationType: AffiliationType | null;
          caller: string | null;
          roleId: string | null;
          missionRole: MissionRoleType | null;
          callbackNumber: string | null;
          email: string | null;
          facilityId: string | null;
          agencyLocationId: string | null;
          isNewAgencyLocation: boolean | null;
          agencyLocationName: string | null;
          referringCompanyId: string | null;
          referringAgencyLocationId: string | null;
          referralReasonId: string | null;
          referringRecordNumber: string | null;
          specialtyTeamNotes: string | null;
          specialtyTeamId: string | null;
          careLevelRequested: CareLevel | null;
          transferCenterId: string | null;
          transferCenterNotes: string | null;
          transportingAgencyLocationId: string | null;
          isDoublePatient: boolean | null;
          isWingToWing: boolean | null;
          vetNumber: string | null;
          requestId: string | null;
          specialtyTeamMembers: Array<{ __typename: 'IdListItem'; id: string }>;
        } | null;
        patients: Array<{
          __typename: 'RequestPatient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          gender: Gender;
          isIsolette: boolean;
          requestId: string;
          companyId: string;
          patientId: string | null;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          transportReasonId: string | null;
          notes: string | null;
          chiefComplaintNotes: string | null;
          transportReasonCategory: TransportReasonCategory | null;
          isIntubated: boolean | null;
          numberOfDrips: number | null;
          specialtyEquipment: string | null;
          rideAlongRequested: YesNoType | null;
          isoletteType: IsoletteType | null;
          isoletteNotes: string | null;
          transferReasonId: string | null;
          estimatedAgeInHours: number | null;
          gcs: number | null;
          bpSystolic: number | null;
          bpDiastolic: number | null;
          heartRate: number | null;
          oxygenSaturation: number | null;
          respiratoryRate: number | null;
          temperatureInCelsius: number | null;
          rideAlongWeightInKg: number | null;
          medicalRecordNumber: string | null;
          rideAlongName: string | null;
          rideAlongDateOfBirth: Date | number | string | null;
        }>;
        safetyQuestions: {
          __typename: 'SafetyQuestions';
          otherServiceDeclined: boolean | null;
          otherServiceDescription: string | null;
          otherServicesAreRespondingToTransferring: boolean | null;
          otherServiceResponseDescription: string | null;
        };
        requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
      } | null;
    } | null;
  };
};

export type QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesQueryVariables = Exact<{
  filter: InputMaybe<QuestionnaireResponseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesQuery = {
  __typename: 'Query';
  questionnaireResponses: {
    __typename: 'QuestionnaireResponseQueries';
    all: {
      __typename: 'QuestionnaireResponseCollection';
      items: Array<{
        __typename: 'QuestionnaireResponse';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: QuestionnaireResponseStatus;
        questionnaireId: string;
        companyId: string;
        cardId: string;
        currentReviewLevel: UserRole | null;
        completedById: string | null;
        dateCompleted: Date | number | string | null;
        communicationsReviewById: string | null;
        dateCommunicationsReviewed: Date | number | string | null;
        supervisorReviewById: string | null;
        dateSupervisorReviewed: Date | number | string | null;
        managerReviewById: string | null;
        dateManagerReviewed: Date | number | string | null;
        card: {
          __typename: 'Card';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: CardStatus;
          cardNumber: string;
          companyId: string;
          dateContactCompleted: Date | number | string | null;
          dateCardClosed: Date | number | string | null;
          transferredToCardId: string | null;
          transferredFromCardId: string | null;
          linkedCardId: string | null;
          closeComment: string | null;
          reOpenComment: string | null;
          postTransportDebriefCompleted: boolean | null;
          isBillable: boolean | null;
          notBillableType: NotBillableType | null;
          notBillableComment: string | null;
          apiWebhookSubscriptionId: string | null;
          createdById: string | null;
          plannedCompletionTime: Date | number | string | null;
          reOpenReasonId: string | null;
          lastOperationId: string | null;
          diversionType: DiversionType | null;
          gmrUtilizationStatus: AmrUtilizationStatus | null;
          gmrCADNumber: string | null;
          isLocked: boolean | null;
          crewWillTransportWithReplacementGroundUnit: boolean | null;
          operationId: string | null;
          requestId: string | null;
          operation: {
            __typename: 'Operation';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: OperationStatus;
            type: OperationType;
            vehicleId: string;
            dateOperationStarted: Date | number | string;
            riskAnalysisAcknowledged: boolean;
            companyId: string;
            unitId: string | null;
            dateOperationEnded: Date | number | string | null;
            unitActivationTime: Date | number | string | null;
            riskAnalysisNumber: string | null;
            standbyActivationType: StandbyActivationType | null;
            caller: string | null;
            callbackNumber: string | null;
            initialOperationType: OperationType | null;
            unit: {
              __typename: 'Unit';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              abbreviation: string;
              status: UnitStatus;
              weatherStatus: WeatherStatus;
              baseId: string;
              regionId: string;
              isExternallyManaged: boolean;
              maximumFlightRule: FlightRule;
              isOnDelay: boolean;
              isEnabled: boolean;
              isSpare: boolean;
              integrations: Array<IntegrationSystem>;
              isCrewAvailable: boolean;
              updatePhoneNumbersFromExternal: boolean;
              companyId: string;
              isAdministrative: boolean | null;
              vehicleId: string | null;
              isHidden: boolean | null;
              isThirdPartyUnit: boolean | null;
              etloInMinutes: number | null;
              pilotNotes: string | null;
              lastPilotUpdateTime: Date | number | string | null;
              lastPilotUpdateById: string | null;
              plannedAvailableNotes: string | null;
              plannedAvailableTime: Date | number | string | null;
              oemPlacardNumber: string | null;
              primaryOutOfServiceEventId: string | null;
              emSystemResourceId: string | null;
              onBaseETAInMinutes: number | null;
              crewSourcedFromUnitId: string | null;
              completeFlightInstanceId: string | null;
              parentUnitId: string | null;
              crewSourcedToUnits: Array<{
                __typename: 'CrewSourcedUnit';
                id: string;
                unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
              } | null> | null;
            } | null;
          } | null;
          request: {
            __typename: 'Request';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: RequestStatus;
            requestedOperationType: OperationType;
            isStandbyRequest: boolean;
            standbyActivationRequested: boolean;
            missionConfiguration: MissionConfiguration;
            missionProfile: MissionProfile;
            companyId: string;
            cancellationReasonId: string | null;
            cancellationSecondaryReasonId: string | null;
            cancellationReasonNotes: string | null;
            requestedVehicleType: VehicleType | null;
            primaryUnitServiceAreaId: string | null;
            commitUnitToStandby: boolean | null;
            initiationType: RequestInitiationType | null;
            assignmentDelayedTime: Date | number | string | null;
            assignmentDelayedReasonId: string | null;
            regionId: string | null;
            includeCompetitors: boolean | null;
            transportOfferAlgorithmId: string | null;
            transportOfferAlgorithm: TransportOfferAlgorithm | null;
            minimumFlightRule: FlightRule | null;
            transportTrackingLink: string | null;
            latestWeatherDeclineUnitId: string | null;
            latestWeatherDeclineTime: Date | number | string | null;
            latestWeatherDeclineReasonId: string | null;
            latestWeatherDeclineSecondaryReasonId: string | null;
            webOrderCallType: WebOrderCallType | null;
            etloInMinutes: number | null;
            atloInMinutes: number | null;
            safetyQuestions: {
              __typename: 'SafetyQuestions';
              otherServiceDeclined: boolean | null;
              otherServiceDescription: string | null;
              otherServicesAreRespondingToTransferring: boolean | null;
              otherServiceResponseDescription: string | null;
            };
            requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
          } | null;
        };
        questionnaire: {
          __typename: 'Questionnaire';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          type: QuestionnaireType;
          communicationCenterId: string | null;
        };
      }>;
    };
  };
};

export type RegionBoardAllPage_FetchCardsByPatientNameQueryVariables = Exact<{
  patientNameLike: Scalars['String'];
  withStatuses: InputMaybe<Array<CardStatus> | CardStatus>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type RegionBoardAllPage_FetchCardsByPatientNameQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    all: {
      __typename: 'CardCollection';
      items: Array<{
        __typename: 'Card';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: CardStatus;
        cardNumber: string;
        companyId: string;
        dateContactCompleted: Date | number | string | null;
        dateCardClosed: Date | number | string | null;
        transferredToCardId: string | null;
        transferredFromCardId: string | null;
        linkedCardId: string | null;
        closeComment: string | null;
        reOpenComment: string | null;
        postTransportDebriefCompleted: boolean | null;
        isBillable: boolean | null;
        notBillableType: NotBillableType | null;
        notBillableComment: string | null;
        apiWebhookSubscriptionId: string | null;
        createdById: string | null;
        plannedCompletionTime: Date | number | string | null;
        reOpenReasonId: string | null;
        lastOperationId: string | null;
        diversionType: DiversionType | null;
        gmrUtilizationStatus: AmrUtilizationStatus | null;
        gmrCADNumber: string | null;
        isLocked: boolean | null;
        crewWillTransportWithReplacementGroundUnit: boolean | null;
        operationId: string | null;
        requestId: string | null;
        request: {
          __typename: 'Request';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: RequestStatus;
          requestedOperationType: OperationType;
          isStandbyRequest: boolean;
          standbyActivationRequested: boolean;
          missionConfiguration: MissionConfiguration;
          missionProfile: MissionProfile;
          companyId: string;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          requestedVehicleType: VehicleType | null;
          primaryUnitServiceAreaId: string | null;
          commitUnitToStandby: boolean | null;
          initiationType: RequestInitiationType | null;
          assignmentDelayedTime: Date | number | string | null;
          assignmentDelayedReasonId: string | null;
          regionId: string | null;
          includeCompetitors: boolean | null;
          transportOfferAlgorithmId: string | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          webOrderCallType: WebOrderCallType | null;
          etloInMinutes: number | null;
          atloInMinutes: number | null;
          patients: Array<{
            __typename: 'RequestPatient';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            gender: Gender;
            isIsolette: boolean;
            requestId: string;
            companyId: string;
            patientId: string | null;
            firstName: string | null;
            lastName: string | null;
            dateOfBirth: Date | number | string | null;
            weightInKg: number | null;
            transportReasonId: string | null;
            notes: string | null;
            chiefComplaintNotes: string | null;
            transportReasonCategory: TransportReasonCategory | null;
            isIntubated: boolean | null;
            numberOfDrips: number | null;
            specialtyEquipment: string | null;
            rideAlongRequested: YesNoType | null;
            isoletteType: IsoletteType | null;
            isoletteNotes: string | null;
            transferReasonId: string | null;
            estimatedAgeInHours: number | null;
            gcs: number | null;
            bpSystolic: number | null;
            bpDiastolic: number | null;
            heartRate: number | null;
            oxygenSaturation: number | null;
            respiratoryRate: number | null;
            temperatureInCelsius: number | null;
            rideAlongWeightInKg: number | null;
            medicalRecordNumber: string | null;
            rideAlongName: string | null;
            rideAlongDateOfBirth: Date | number | string | null;
          }>;
          safetyQuestions: {
            __typename: 'SafetyQuestions';
            otherServiceDeclined: boolean | null;
            otherServiceDescription: string | null;
            otherServicesAreRespondingToTransferring: boolean | null;
            otherServiceResponseDescription: string | null;
          };
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        } | null;
      }>;
    };
  };
};

export type RegionBoardVehiclesPageComponent_FetchAllVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type RegionBoardVehiclesPageComponent_FetchAllVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      }>;
    };
  };
};

export type TransferCenterRegionBoardComponent_FetchQueryVariables = Exact<{
  regionId: Scalars['ID'];
}>;

export type TransferCenterRegionBoardComponent_FetchQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    all: {
      __typename: 'CardCollection';
      items: Array<{
        __typename: 'Card';
        id: string;
        cardNumber: string;
        request: {
          __typename: 'Request';
          transportOfferOptions: Array<{
            __typename: 'TransportOfferOption';
            requestedVehicleType: VehicleType | null;
          }>;
          requester: {
            __typename: 'Requester';
            transferCenterId: string | null;
            transferCenterNotes: string | null;
            careLevelRequested: CareLevel | null;
            transferCenter: { __typename: 'TransferCenter'; name: string } | null;
          } | null;
          patients: Array<{
            __typename: 'RequestPatient';
            firstName: string | null;
            lastName: string | null;
          }>;
          locations: Array<{
            __typename: 'RequestLocation';
            physician: { __typename: 'Physician'; firstName: string; lastName: string } | null;
          }>;
        } | null;
      }>;
      meta: { __typename: 'CardCollectionMetadata'; total: number };
    };
  };
};

export type OpsCompanyDataContextService_FetchQueryVariables = Exact<{
  dispatchCompanyId: Scalars['ID'];
}>;

export type OpsCompanyDataContextService_FetchQuery = {
  __typename: 'Query';
  companies: {
    __typename: 'CompanyQueries';
    byId: {
      __typename: 'Company';
      transferCenters: Array<{
        __typename: 'TransferCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        communicationCenterId: string;
        companyId: string;
        description: string | null;
      }>;
      regionGroups: Array<{
        __typename: 'RegionGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        departmentId: string;
        companyId: string;
        department: {
          __typename: 'Department';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
        };
        regions: Array<{
          __typename: 'Region';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          communicationCenterId: string;
          isTransferCenterRegion: boolean;
          regionGroupId: string;
          companyId: string;
          timezoneCd: string | null;
          emSystemDivisionName: string | null;
          dispatchNumber: string | null;
          fixedWingPreferredThresholdInNauticalMiles: number | null;
          etcInMinutes: number | null;
        }>;
      }>;
      externalActions: Array<{
        __typename: 'ExternalAction';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        entityId: string;
        status: ExternalActionStatus;
        entityType: EntityType;
        actionTypeId: string;
        actionBodyJson: string;
        companyId: string;
        completedById: string | null;
        dateCompleted: Date | number | string | null;
        notes: string | null;
      }>;
    } | null;
  };
  activeAlerts: {
    __typename: 'ActiveAlertQueries';
    all: {
      __typename: 'ActiveAlertCollection';
      items: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
      }>;
      meta: { __typename: 'ActiveAlertCollectionMetadata'; total: number };
    };
  };
  positionReportAlerts: {
    __typename: 'PositionReportAlertQueries';
    all: {
      __typename: 'PositionReportAlertCollection';
      items: Array<{
        __typename: 'PositionReportAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        vehicleId: string;
        hasReceivedQualifyingReport: boolean;
        companyId: string;
      }>;
    };
  };
  webOrderLogs: {
    __typename: 'webOrderLogQueries';
    byActiveCards: {
      __typename: 'WebOrderLogCollection';
      items: Array<{
        __typename: 'WebOrderLog';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        requestJson: string;
        name: string;
        isSuccess: boolean;
        errors: string | null;
        entityId: string | null;
        entityType: EntityType | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        changes: Array<{
          __typename: 'WebOrderLogEntityChanges';
          id: string;
          entityType: string;
          fieldName: string;
          oldValue: string | null;
          newValue: string | null;
        } | null> | null;
      }>;
    };
  };
};

export type CardAttachmentsDialogComponent_FetchAttachmentsQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;

export type CardAttachmentsDialogComponent_FetchAttachmentsQuery = {
  __typename: 'Query';
  attachments: {
    __typename: 'AttachmentQueries';
    all: {
      __typename: 'AttachmentCollection';
      items: Array<{
        __typename: 'Attachment';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        attachmentEntityType: AttachmentEntityType;
        fileName: string;
        entityId: string | null;
        fileSizeInBytes: number | null;
        contentType: string | null;
      }>;
    };
  };
};

export type ScheduledAlertsListDialogComponent_FetchActiveAlertsQueryVariables = Exact<{
  filter: InputMaybe<ActiveAlertFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ScheduledAlertsListDialogComponent_FetchActiveAlertsQuery = {
  __typename: 'Query';
  activeAlerts: {
    __typename: 'ActiveAlertQueries';
    all: {
      __typename: 'ActiveAlertCollection';
      items: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
        author: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
        region: {
          __typename: 'Region';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          communicationCenterId: string;
          isTransferCenterRegion: boolean;
          regionGroupId: string;
          companyId: string;
          timezoneCd: string | null;
          emSystemDivisionName: string | null;
          dispatchNumber: string | null;
          fixedWingPreferredThresholdInNauticalMiles: number | null;
          etcInMinutes: number | null;
        } | null;
        communicationCenter: {
          __typename: 'CommunicationCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          playAlertForManualPositionReports: boolean;
          enableRAAlert: boolean;
          useCrewPhoneNumber: boolean;
          displayContactTimeline: boolean;
          companyId: string;
          timezoneCd: string | null;
          primaryPhoneNumber: string | null;
          emailAddress: string | null;
          showReferToGmrWarning: boolean | null;
          alertFrequencyForGroundVehicles: number | null;
        } | null;
      }>;
      meta: { __typename: 'ActiveAlertCollectionMetadata'; total: number };
    };
  };
};

export type oosEventNotesComponent_FetchOosEventNotesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type oosEventNotesComponent_FetchOosEventNotesQuery = {
  __typename: 'Query';
  outOfServiceEventNotes: {
    __typename: 'OutOfServiceEventNoteQueries';
    byOutOfServiceEventId: {
      __typename: 'OutOfServiceEventNoteCollection';
      items: Array<{
        __typename: 'OutOfServiceEventNote';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        outOfServiceEventId: string;
        content: string;
        noteTime: Date | number | string;
        isSystem: boolean;
        companyId: string;
        authorId: string | null;
        noteCategory: string | null;
        noteMetadataJson: string | null;
      }>;
    };
  };
};

export type OosEventNotifications_FetchNotificationsQueryVariables = Exact<{
  filter: InputMaybe<NotificationFilter>;
}>;

export type OosEventNotifications_FetchNotificationsQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    all: {
      __typename: 'NotificationCollection';
      items: Array<{
        __typename: 'Notification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: NotificationStatus;
        body: string;
        companyId: string;
        cardId: string | null;
        subject: string | null;
        sourceTemplateId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        createdById: string | null;
        recipients: Array<{
          __typename: 'NotificationRecipient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          notificationId: string;
          companyId: string;
          name: string | null;
          notificationAddress: string | null;
          userId: string | null;
          messageId: string | null;
          messageStatus: MessageStatus | null;
          message: {
            __typename: 'TrackedMessage';
            messageStatusUpdates: Array<{
              __typename: 'MessageStatusUpdate';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              status: MessageStatus;
              trackedMessageId: string;
              error: string | null;
              vendorMessage: string | null;
              metadataJson: string | null;
            }>;
          } | null;
        }>;
      }>;
    };
  };
};

export type OosFormComponent_FetchQarReasonsQueryVariables = Exact<{ [key: string]: never }>;

export type OosFormComponent_FetchQarReasonsQuery = {
  __typename: 'Query';
  outOfServiceQARReasons: {
    __typename: 'OutOfServiceQARReasonQueries';
    all: {
      __typename: 'OutOfServiceQARReasonCollection';
      items: Array<{ __typename: 'OutOfServiceQARReason'; name: string; id: string }>;
    };
  };
};

export type OosFormComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosFormComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{ __typename: 'Base'; name: string; id: string }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type OosFormComponent_FetchVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OosFormComponent_FetchVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        id: string;
        registrationNumber: string;
        communicationCenterId: string | null;
      }>;
    };
  };
};

export type OosFormComponent_FetchMaintenanceFacilitiesQueryVariables = Exact<{
  filter: InputMaybe<MaintenanceFacilityFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosFormComponent_FetchMaintenanceFacilitiesQuery = {
  __typename: 'Query';
  maintenanceFacilities: {
    __typename: 'MaintenanceFacilityQueries';
    all: {
      __typename: 'MaintenanceFacilityCollection';
      items: Array<{
        __typename: 'MaintenanceFacility';
        name: string;
        id: string;
        locationId: string | null;
      }>;
    };
  };
};

export type OosFormComponent_FetchUnitPositionsByUnitIdQueryVariables = Exact<{
  unitId: Scalars['ID'];
}>;

export type OosFormComponent_FetchUnitPositionsByUnitIdQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      id: string;
      positions: Array<{
        __typename: 'UnitPosition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        type: UnitPositionType;
        isFlightCrew: boolean;
        isNonEmployee: boolean;
        unitId: string;
        companyId: string;
        notificationAddress: string | null;
        teamMemberId: string | null;
        firstName: string | null;
        lastName: string | null;
      }>;
    } | null;
  };
};

export type OosHistoryComponent_FetchHistoryQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceEventFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OosHistoryComponent_FetchHistoryQuery = {
  __typename: 'Query';
  outOfServiceEvents: {
    __typename: 'OutOfServiceEventQueries';
    all: {
      __typename: 'OutOfServiceEventCollection';
      meta: { __typename: 'OutOfServiceEventCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'OutOfServiceEvent';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: OutOfServiceType;
        eventNumber: string;
        estimatedEndTime: Date | number | string;
        reasonId: string;
        isAirworthy: boolean;
        initialEstimatedEndTime: Date | number | string;
        alertWhenEventEnds: boolean;
        isPlanned: boolean;
        isBirdStrike: boolean;
        isPatientOnboard: boolean;
        waitingForParts: boolean;
        waitingForTooling: boolean;
        isAcknowledgementRequired: boolean;
        companyId: string;
        startTime: Date | number | string | null;
        isOpportunisticOOS: boolean | null;
        unitId: string | null;
        vehicleId: string | null;
        secondaryReasonId: string | null;
        scheduledStartTime: Date | number | string | null;
        endTime: Date | number | string | null;
        notes: string | null;
        linkedCardId: string | null;
        createdById: string | null;
        endedById: string | null;
        secondaryReasonComment: string | null;
        parentOutOfServiceEventId: string | null;
        paipEventId: string | null;
        copiedFromId: string | null;
        alertTimeInMinutes: number | null;
        outOfServiceTicketId: string | null;
        maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
        opportunityMXTypes: Array<OpportunityMXType | null> | null;
        rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
        maintenanceLocation: string | null;
        mxDuringPeakTimeReason: string | null;
        assignedBaseId: string | null;
        amtPointOfContactId: string | null;
        alternatePOC: string | null;
        spareVehicleId: string | null;
        ticketDescription: string | null;
        humanErrorDamageType: HumanErrorDamageType | null;
        businessUnitCompanyId: string | null;
        isAMTAvailable: boolean | null;
        isFAR135415Reportable: boolean | null;
        isFAR135417Reportable: boolean | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        acknowledgementNotes: string | null;
        maintenanceFacilityId: string | null;
        locationId: string | null;
        oosRequestType: OosRequestType | null;
        isEventAlreadyClosed: boolean | null;
        qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        crew: Array<{
          __typename: 'OutOfServiceCrew';
          id: string;
          personId: string;
          unitPositionId: string;
          isFlightCrew: boolean;
          positionType: UnitPositionType | null;
          unitPositionRole: string | null;
          endDate: Date | number | string | null;
          notificationAddress: string | null;
        } | null> | null;
      }>;
    };
  };
};

export type OosService_LoadOosManagerDialagDataQueryVariables = Exact<{ [key: string]: never }>;

export type OosService_LoadOosManagerDialagDataQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      }>;
    };
  };
};

export type CardNoteEditHistoryDialogComponent_FetchCardNoteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CardNoteEditHistoryDialogComponent_FetchCardNoteQuery = {
  __typename: 'Query';
  cardNotes: {
    __typename: 'CardNoteQueries';
    byId: {
      __typename: 'CardNote';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      content: string;
      noteTime: Date | number | string;
      isInternal: boolean;
      isSystem: boolean;
      cardId: string;
      companyId: string;
      authorId: string | null;
      noteCategory: string | null;
      noteMetadataJson: string | null;
      receivedFromCardId: string | null;
      _events: {
        __typename: 'MessageEnvelopeCollection';
        meta: { __typename: 'MessageEnvelopeCollectionMetadata'; total: number };
        items: Array<{
          __typename: 'MessageEnvelope';
          messageId: string;
          timestamp: Date | number | string;
          personId: string | null;
          message: { __typename: 'Message'; messageData: { [key: string]: any } };
          person: { __typename: 'Person'; firstName: string; lastName: string } | null;
        }>;
      };
      sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type GroundLegFormComponent_FetchAllLocationsQueryVariables = Exact<{
  filter: InputMaybe<LocationQueryFilter>;
}>;

export type GroundLegFormComponent_FetchAllLocationsQuery = {
  __typename: 'Query';
  locations: {
    __typename: 'LocationQueries';
    all: {
      __typename: 'LocationCollection';
      items: Array<{
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'LocationCollectionMetadata'; total: number };
    };
  };
};

export type MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsQuery = {
  __typename: 'Query';
  baseMedicalControlContacts: {
    __typename: 'BaseMedicalControlContactQueries';
    byBaseId: {
      __typename: 'BaseMedicalControlContactCollection';
      items: Array<{
        __typename: 'BaseMedicalControlContact';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        personId: string;
        rank: number;
        baseId: string;
        companyId: string;
        specialty: string | null;
        person: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
        baseMedicalControlContactStates: Array<{
          __typename: 'BaseMedicalControlContactState';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          companyId: string;
          baseMedicalControlContactId: string | null;
        } | null> | null;
      }>;
    };
  };
};

export type MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      npi: string;
      providerNumber: string | null;
      sourceSystemId: number | null;
      masterDataSetId: number | null;
      firmType: string | null;
      hospitalType: string | null;
      hospitalSpecialization: string | null;
      website: string | null;
      defaultLandingZoneId: string | null;
      defaultFixedWingLandingZoneId: string | null;
      notes: string | null;
      stateSourceSystemId: string | null;
      nemsisCode: string | null;
      stateFacilityName: string | null;
      status: MedicalFacilityStatus | null;
      archiveNotes: string | null;
      archiveClearedDate: Date | number | string | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultFixedWingLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      units: Array<{
        __typename: 'MedicalFacilityUnit';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        medicalFacilityId: string;
        phoneNumber: string | null;
      }>;
      associatedPhysicians: Array<{
        __typename: 'MedicalFacilityPhysician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        physicianId: string;
        medicalFacilityId: string;
        physician: {
          __typename: 'Physician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
        };
      }>;
      communicationCenterCustomIdentifiers: Array<{
        __typename: 'IdNameListItem';
        id: string;
        name: string;
      } | null> | null;
    } | null;
  };
};

export type MileageCalculatorDialogComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type MileageCalculatorDialogComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type MileageCalculatorDialogComponent_FetchAllVehicleModelsQueryVariables = Exact<{
  filter: InputMaybe<VehicleModelFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type MileageCalculatorDialogComponent_FetchAllVehicleModelsQuery = {
  __typename: 'Query';
  vehicleModels: {
    __typename: 'VehicleModelQueries';
    all: {
      __typename: 'VehicleModelCollection';
      items: Array<{
        __typename: 'VehicleModel';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cruiseSpeedInMph: number | null;
      }>;
      meta: { __typename: 'VehicleModelCollectionMetadata'; total: number };
    };
  };
};

export type NotificationAddDialogComponent_FetchAllNotificationTemplatesQueryVariables = Exact<{
  filter: InputMaybe<NotificationTemplateFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NotificationAddDialogComponent_FetchAllNotificationTemplatesQuery = {
  __typename: 'Query';
  notificationTemplates: {
    __typename: 'NotificationTemplateQueries';
    all: {
      __typename: 'NotificationTemplateCollection';
      items: Array<{
        __typename: 'NotificationTemplate';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        contextType: EntityType;
        bodyTemplate: string;
        canBeManualTrigger: boolean;
        companyId: string | null;
        triggerType: NotificationTriggerType | null;
        triggerValue: string | null;
        activationRuleId: string | null;
        recipientTypes: Array<NotificationRecipientType | null> | null;
        subjectTemplate: string | null;
        requiresApproval: boolean | null;
        groupTypes: Array<NotificationGroupType | null> | null;
        createdById: string | null;
      }>;
    };
  };
};

export type NotificationAddDialogComponent_FetchNotificationTemplateDetailsQueryVariables = Exact<{
  args: InputMaybe<NotificationTemplateRequest>;
}>;

export type NotificationAddDialogComponent_FetchNotificationTemplateDetailsQuery = {
  __typename: 'Query';
  notificationTemplates: {
    __typename: 'NotificationTemplateQueries';
    templateDetails: {
      __typename: 'NotificationTemplateResponse';
      activityId: string | null;
      responseCode: string | null;
      errors: Array<string | null> | null;
      data: {
        __typename: 'NotificationTemplateData';
        subject: string | null;
        body: string | null;
        recipients: Array<{
          __typename: 'Recipient';
          name: string | null;
          address: string;
        } | null> | null;
      } | null;
    };
  };
};

export type NotificationsEditDialogComponent_FetchNotificationQueryVariables = Exact<{
  notificationId: Scalars['ID'];
}>;

export type NotificationsEditDialogComponent_FetchNotificationQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    byId: {
      __typename: 'Notification';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: NotificationStatus;
      body: string;
      companyId: string;
      cardId: string | null;
      subject: string | null;
      sourceTemplateId: string | null;
      entityType: EntityType | null;
      entityId: string | null;
      createdById: string | null;
      recipients: Array<{
        __typename: 'NotificationRecipient';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        notificationId: string;
        companyId: string;
        name: string | null;
        notificationAddress: string | null;
        userId: string | null;
        messageId: string | null;
        messageStatus: MessageStatus | null;
        message: {
          __typename: 'TrackedMessage';
          messageStatusUpdates: Array<{
            __typename: 'MessageStatusUpdate';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: MessageStatus;
            trackedMessageId: string;
            error: string | null;
            vendorMessage: string | null;
            metadataJson: string | null;
          }>;
        } | null;
      }>;
    } | null;
  };
};

export type NotificationsManageDialogComponent_FetchNotificationQueryVariables = Exact<{
  notificationId: Scalars['ID'];
}>;

export type NotificationsManageDialogComponent_FetchNotificationQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    byId: {
      __typename: 'Notification';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: NotificationStatus;
      body: string;
      companyId: string;
      cardId: string | null;
      subject: string | null;
      sourceTemplateId: string | null;
      entityType: EntityType | null;
      entityId: string | null;
      createdById: string | null;
      recipients: Array<{
        __typename: 'NotificationRecipient';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        notificationId: string;
        companyId: string;
        name: string | null;
        notificationAddress: string | null;
        userId: string | null;
        messageId: string | null;
        messageStatus: MessageStatus | null;
        message: {
          __typename: 'TrackedMessage';
          messageStatusUpdates: Array<{
            __typename: 'MessageStatusUpdate';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: MessageStatus;
            trackedMessageId: string;
            error: string | null;
            vendorMessage: string | null;
            metadataJson: string | null;
          }>;
        } | null;
      }>;
    } | null;
  };
};

export type NotificationsListDialogComponent_FetchNotificationsQueryVariables = Exact<{
  filter: InputMaybe<NotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NotificationsListDialogComponent_FetchNotificationsQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    all: {
      __typename: 'NotificationCollection';
      items: Array<{
        __typename: 'Notification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: NotificationStatus;
        body: string;
        companyId: string;
        cardId: string | null;
        subject: string | null;
        sourceTemplateId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        createdById: string | null;
        recipients: Array<{
          __typename: 'NotificationRecipient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          notificationId: string;
          companyId: string;
          name: string | null;
          notificationAddress: string | null;
          userId: string | null;
          messageId: string | null;
          messageStatus: MessageStatus | null;
          message: {
            __typename: 'TrackedMessage';
            messageStatusUpdates: Array<{
              __typename: 'MessageStatusUpdate';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              status: MessageStatus;
              trackedMessageId: string;
              error: string | null;
              vendorMessage: string | null;
              metadataJson: string | null;
            }>;
          } | null;
        }>;
      }>;
      meta: { __typename: 'NotificationCollectionMetadata'; total: number };
    };
  };
};

export type PaipEventManagerDialogComponent_FetchPaipEventsQueryVariables = Exact<{
  filter: InputMaybe<PaipEventFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type PaipEventManagerDialogComponent_FetchPaipEventsQuery = {
  __typename: 'Query';
  paipEvents: {
    __typename: 'PaipEventQueries';
    all: {
      __typename: 'PaipEventCollection';
      items: Array<{
        __typename: 'PaipEvent';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        reasonId: string;
        startTime: Date | number | string;
        companyId: string;
        regionId: string | null;
        eventNumber: string | null;
        endTime: Date | number | string | null;
        notes: string | null;
        unitIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        cardIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'PaipEventCollectionMetadata'; total: number };
    };
  };
};

export type RecipientGroupManageDialogComponent_FetchAllNotificationGroupsQueryVariables = Exact<{
  filter: InputMaybe<NotificationGroupFilter>;
}>;

export type RecipientGroupManageDialogComponent_FetchAllNotificationGroupsQuery = {
  __typename: 'Query';
  notificationGroups: {
    __typename: 'NotificationGroupQueries';
    all: {
      __typename: 'NotificationGroupCollection';
      items: Array<{
        __typename: 'NotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        unitId: string | null;
        regionId: string | null;
        type: NotificationGroupType | null;
        types: Array<NotificationGroupType | null> | null;
        isEmailNotificationPreferred: boolean | null;
      }>;
      meta: { __typename: 'NotificationGroupCollectionMetadata'; total: number };
    };
  };
};

export type RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersQueryVariables =
  Exact<{
    filter: InputMaybe<NotificationGroupMemberFilter>;
  }>;

export type RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersQuery = {
  __typename: 'Query';
  notificationGroupMembers: {
    __typename: 'NotificationGroupMemberQueries';
    all: {
      __typename: 'NotificationGroupMemberCollection';
      items: Array<{
        __typename: 'NotificationGroupMember';
        id: string;
        notificationGroupId: string;
        name: string;
        userId: string | null;
        notificationAddress: string | null;
        user: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          isAviationSupervisor: boolean;
          notificationAddress: string | null;
        } | null;
      }>;
      meta: { __typename: 'NotificationGroupMemberCollectionMetadata'; total: number };
    };
  };
};

export type TransportAbortDialogComponent_FetchAllVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type TransportAbortDialogComponent_FetchAllVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      }>;
    };
  };
};

export type TransportAbortDialogComponent_FetchTransportOffersByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type TransportAbortDialogComponent_FetchTransportOffersByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      request: {
        __typename: 'Request';
        transportOffers: Array<{
          __typename: 'TransportOffer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TransportOfferStatus;
          rank: number;
          response: TransportOfferResponse;
          wasBulkSkip: boolean;
          isOnDelay: boolean;
          isOneCallAgreement: boolean;
          isInternalAgency: boolean;
          requestId: string;
          companyId: string;
          distanceInMiles: number | null;
          bearingInDegrees: number | null;
          estimatedDepartureTimeInMinutes: number | null;
          estimatedTimeEnRouteInMinutes: number | null;
          offerTime: Date | number | string | null;
          crewNotified: Date | number | string | null;
          transportCheckInitiated: Date | number | string | null;
          notificationAcknowledged: Date | number | string | null;
          responseReceived: Date | number | string | null;
          declineReasonId: string | null;
          declineSecondaryReasonId: string | null;
          nonReferralReasonId: string | null;
          nonReferralReasonNotes: string | null;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          outOfServiceEventId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          agencyLocationId: string | null;
          unitDescription: string | null;
          isReferral: boolean | null;
          vehicleType: VehicleType | null;
          patientOriginatesAtUnit: boolean | null;
          homeBaseDistanceInMiles: number | null;
          baseId: string | null;
          preferredRank: number | null;
          notes: string | null;
          onBaseETAInMinutes: number | null;
          specialtyTeamETLOInMinutes: number | null;
          specialtyTeamETEInMinutes: number | null;
          dateDeclinedOrAborted: Date | number | string | null;
          declinedOrAbortedById: string | null;
          etc: number | null;
          crewMustFlyToArriveAtSending: boolean | null;
          vehicleCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
          crew: Array<{
            __typename: 'UnitPositionSnapshot';
            id: string;
            firstName: string;
            lastName: string;
            type: UnitPositionType;
          } | null> | null;
        }>;
      } | null;
    } | null;
  };
};

export type UnitNoteListComponent_FetchUnitNotesQueryVariables = Exact<{
  filter: InputMaybe<UnitNoteFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type UnitNoteListComponent_FetchUnitNotesQuery = {
  __typename: 'Query';
  unitNotes: {
    __typename: 'UnitNoteQueries';
    all: {
      __typename: 'UnitNoteCollection';
      items: Array<{
        __typename: 'UnitNote';
        id: string;
        authorId: string | null;
        companyId: string;
        content: string;
        noteTime: Date | number | string;
        unitId: string;
        unit: { __typename: 'Unit'; name: string; abbreviation: string };
        author: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      meta: { __typename: 'UnitNoteCollectionMetadata'; total: number };
    };
  };
};

export type UnitShiftListComponent_FetchUnitShiftsQueryVariables = Exact<{
  filter: InputMaybe<UnitShiftFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type UnitShiftListComponent_FetchUnitShiftsQuery = {
  __typename: 'Query';
  unitShifts: {
    __typename: 'UnitShiftQueries';
    all: {
      __typename: 'UnitShiftCollection';
      items: Array<{
        __typename: 'UnitShift';
        id: string;
        companyId: string;
        name: string;
        startTimeInMinutes: number;
        endTimeInMinutes: number;
        unitId: string;
        unit: { __typename: 'Unit'; name: string; abbreviation: string };
      }>;
      meta: { __typename: 'UnitShiftCollectionMetadata'; total: number };
    };
  };
};

export type PassdownLogDetailsComponent_FetchPassdownLogQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type PassdownLogDetailsComponent_FetchPassdownLogQuery = {
  __typename: 'Query';
  passdownLogs: {
    __typename: 'PassdownLogQueries';
    byId: {
      __typename: 'PassdownLog';
      regionIdList: Array<string | null> | null;
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      regionId: string;
      logDate: Date | number | string;
      body: string;
      requiresAcknowledgement: boolean;
      companyId: string;
      dateAcknowledged: Date | number | string | null;
      acknowledgedById: string | null;
      authorId: string | null;
      passdownLogAcknowledgements: Array<{
        __typename: 'PassdownLogAcknowledgement';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        passdownLogId: string;
        dateAcknowledged: Date | number | string;
        acknowledgedById: string;
        companyId: string;
      }>;
    } | null;
  };
};

export type PassdownLogDialogComponent_FetchAllPassdownLogsQueryVariables = Exact<{
  filter: InputMaybe<PassdownLogFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type PassdownLogDialogComponent_FetchAllPassdownLogsQuery = {
  __typename: 'Query';
  passdownLogs: {
    __typename: 'PassdownLogQueries';
    all: {
      __typename: 'PassdownLogCollection';
      items: Array<{
        __typename: 'PassdownLog';
        regionIdList: Array<string | null> | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        regionId: string;
        logDate: Date | number | string;
        body: string;
        requiresAcknowledgement: boolean;
        companyId: string;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        authorId: string | null;
        author: { __typename: 'Person'; firstName: string; lastName: string } | null;
        acknowledgedBy: { __typename: 'Person'; firstName: string; lastName: string } | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
        passdownLogAcknowledgements: Array<{
          __typename: 'PassdownLogAcknowledgement';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passdownLogId: string;
          dateAcknowledged: Date | number | string;
          acknowledgedById: string;
          companyId: string;
        }>;
        passdownLogArchivedLogs: Array<{
          __typename: 'PassdownLogArchivedLog';
          passdownLogId: string;
          archivedBy: { __typename: 'Person'; id: string };
        }>;
      }>;
      meta: { __typename: 'PassdownLogCollectionMetadata'; total: number };
    };
  };
};

export type PassdownLogEditHistoryDialogComponent_FetchPassdownLogQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type PassdownLogEditHistoryDialogComponent_FetchPassdownLogQuery = {
  __typename: 'Query';
  passdownLogs: {
    __typename: 'PassdownLogQueries';
    byId: {
      __typename: 'PassdownLog';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      regionId: string;
      logDate: Date | number | string;
      body: string;
      requiresAcknowledgement: boolean;
      companyId: string;
      dateAcknowledged: Date | number | string | null;
      acknowledgedById: string | null;
      authorId: string | null;
      _events: {
        __typename: 'MessageEnvelopeCollection';
        meta: { __typename: 'MessageEnvelopeCollectionMetadata'; total: number };
        items: Array<{
          __typename: 'MessageEnvelope';
          messageId: string;
          timestamp: Date | number | string;
          personId: string | null;
          message: { __typename: 'Message'; messageData: { [key: string]: any } };
          person: { __typename: 'Person'; firstName: string; lastName: string } | null;
        }>;
      };
    } | null;
  };
};

export type ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdQuery =
  {
    __typename: 'Query';
    medicalFacilities: {
      __typename: 'MedicalFacilityQueries';
      byId: {
        __typename: 'MedicalFacility';
        units: Array<{
          __typename: 'MedicalFacilityUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          medicalFacilityId: string;
          phoneNumber: string | null;
        }>;
      } | null;
    };
  };

export type ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      associatedPhysicians: Array<{
        __typename: 'MedicalFacilityPhysician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        physicianId: string;
        medicalFacilityId: string;
        physician: {
          __typename: 'Physician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
        };
      }>;
    } | null;
  };
};

export type ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesQueryVariables =
  Exact<{
    filter: InputMaybe<MedicalFacilityFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    all: {
      __typename: 'MedicalFacilityCollection';
      items: Array<{
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      }>;
    };
  };
};

export type ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesQueryVariables =
  Exact<{
    filter: InputMaybe<MedicalFacilityFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    all: {
      __typename: 'MedicalFacilityCollection';
      items: Array<{
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      }>;
    };
  };
};

export type RequestCallDialogComponent_FetchAgencyLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RequestCallDialogComponent_FetchAgencyLocationQuery = {
  __typename: 'Query';
  agencyLocations: {
    __typename: 'AgencyLocationQueries';
    byId: {
      __typename: 'AgencyLocation';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      isInTransportNet: boolean;
      agencyId: string;
      emailAddress: string | null;
      primaryPhoneNumber: string | null;
      secondaryPhoneNumber: string | null;
      smsPhoneNumber: string | null;
      faxPhoneNumber: string | null;
      notes: string | null;
      vehicleType: VehicleType | null;
      estimatedDepartureTimeInMinutes: number | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
    } | null;
  };
};

export type CancellationFormComponent_FetchAllCancellationCategoriesQueryVariables = Exact<{
  filter: InputMaybe<CancellationCategoryFilter>;
}>;

export type CancellationFormComponent_FetchAllCancellationCategoriesQuery = {
  __typename: 'Query';
  cancellationCategories: {
    __typename: 'CancellationCategoryQueries';
    all: {
      __typename: 'CancellationCategoryCollection';
      items: Array<{
        __typename: 'CancellationCategory';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isVisibleInOps: boolean;
        defaultCancellationReasonId: string | null;
      }>;
    };
  };
};

export type DeclineFormComponent_FetchAllDeclineCategoriesQueryVariables = Exact<{
  filter: InputMaybe<DeclineCategoryFilter>;
}>;

export type DeclineFormComponent_FetchAllDeclineCategoriesQuery = {
  __typename: 'Query';
  declineCategories: {
    __typename: 'DeclineCategoryQueries';
    all: {
      __typename: 'DeclineCategoryCollection';
      items: Array<{
        __typename: 'DeclineCategory';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isVisibleInOps: boolean;
        defaultDeclineReasonId: string | null;
      }>;
    };
  };
};

export type TransportOfferDeclineComponent_FetchTransportOffersByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type TransportOfferDeclineComponent_FetchTransportOffersByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      request: {
        __typename: 'Request';
        transportOffers: Array<{
          __typename: 'TransportOffer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TransportOfferStatus;
          rank: number;
          response: TransportOfferResponse;
          wasBulkSkip: boolean;
          isOnDelay: boolean;
          isOneCallAgreement: boolean;
          isInternalAgency: boolean;
          requestId: string;
          companyId: string;
          distanceInMiles: number | null;
          bearingInDegrees: number | null;
          estimatedDepartureTimeInMinutes: number | null;
          estimatedTimeEnRouteInMinutes: number | null;
          offerTime: Date | number | string | null;
          crewNotified: Date | number | string | null;
          transportCheckInitiated: Date | number | string | null;
          notificationAcknowledged: Date | number | string | null;
          responseReceived: Date | number | string | null;
          declineReasonId: string | null;
          declineSecondaryReasonId: string | null;
          nonReferralReasonId: string | null;
          nonReferralReasonNotes: string | null;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          outOfServiceEventId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          agencyLocationId: string | null;
          unitDescription: string | null;
          isReferral: boolean | null;
          vehicleType: VehicleType | null;
          patientOriginatesAtUnit: boolean | null;
          homeBaseDistanceInMiles: number | null;
          baseId: string | null;
          preferredRank: number | null;
          notes: string | null;
          onBaseETAInMinutes: number | null;
          specialtyTeamETLOInMinutes: number | null;
          specialtyTeamETEInMinutes: number | null;
          dateDeclinedOrAborted: Date | number | string | null;
          declinedOrAbortedById: string | null;
          etc: number | null;
          crewMustFlyToArriveAtSending: boolean | null;
          vehicleCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
          crew: Array<{
            __typename: 'UnitPositionSnapshot';
            id: string;
            firstName: string;
            lastName: string;
            type: UnitPositionType;
          } | null> | null;
        }>;
      } | null;
    } | null;
  };
};

export type TransportOfferDeclineComponent_FetchAllDelayReasonsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TransportOfferDeclineComponent_FetchAllDelayReasonsQuery = {
  __typename: 'Query';
  requests: {
    __typename: 'RequestQueries';
    allAssignmentDelayedReasons: Array<{
      __typename: 'AssignmentDelayedReason';
      id: string;
      name: string;
    }>;
  };
};

export type UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdQuery = {
  __typename: 'Query';
  unitActivationRules: {
    __typename: 'UnitActivationRuleQueries';
    byUnitId: {
      __typename: 'UnitActivationRule';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      companyId: string;
      unitId: string;
      operationTypes: Array<OperationType>;
      missionRoleTypes: Array<MissionRoleType>;
      maximumDistanceInMiles: number | null;
    } | null;
  };
};

export type UnitEditDialogComponent_FetchUnitEMSystemMappingsQueryVariables = Exact<{
  filter: InputMaybe<UnitEMSystemMappingFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type UnitEditDialogComponent_FetchUnitEMSystemMappingsQuery = {
  __typename: 'Query';
  unitEMSystemMappings: {
    __typename: 'UnitEMSystemMappingQueries';
    all: {
      __typename: 'UnitEMSystemMappingCollection';
      meta: { __typename: 'UnitEMSystemMappingCollectionMetadata'; total: number };
    };
  };
};

export type UnitFormComponent_FetchAllCompleteFlightInstancesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UnitFormComponent_FetchAllCompleteFlightInstancesQuery = {
  __typename: 'Query';
  completeFlightInstances: {
    __typename: 'CompleteFlightInstanceQueries';
    all: {
      __typename: 'CompleteFlightInstanceCollection';
      items: Array<{
        __typename: 'CompleteFlightInstance';
        completeFlightInstanceName: string;
        id: string;
      }>;
    };
  };
};

export type UnitRepositionDialogComponent_FetchVehiclePositionSummaryQueryVariables = Exact<{
  vehicleId: Scalars['ID'];
}>;

export type UnitRepositionDialogComponent_FetchVehiclePositionSummaryQuery = {
  __typename: 'Query';
  vehiclePositionSummary: {
    __typename: 'vehcilePositionSummaryQueries';
    byVehicleId: {
      __typename: 'VehiclePositionSummary';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      id: string;
      vehicleId: string;
      latitude: number;
      longitude: number;
      positionSource: PositionReportSource;
      positionTime: Date | number | string;
      companyId: string;
      lastPositionReportId: string | null;
      lastQualifyingPositionReportTime: Date | number | string | null;
      etlo: Date | number | string | null;
      lastGpsAutoPositionTime: Date | number | string | null;
      lastTakeOffTime: Date | number | string | null;
      lastLandedTime: Date | number | string | null;
      gpsProvider: GpsProvider | null;
      altitude: number | null;
      speedInKnots: number | null;
      heading: number | null;
    } | null;
  };
};

export type UnitRepositionDialogComponent_FetchVehicleStateInspectionsQueryVariables = Exact<{
  vehicleId: Scalars['ID'];
}>;

export type UnitRepositionDialogComponent_FetchVehicleStateInspectionsQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      vehicleStateInspections: Array<{
        __typename: 'VehicleStateInspection';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        stateAbbrevation: string;
        inspectionDate: Date | number | string;
        vehicleId: string;
        companyId: string;
      }>;
    } | null;
  };
};

export type FetchUnitEditContextQueryVariables = Exact<{
  unitId: Scalars['ID'];
}>;

export type FetchUnitEditContextQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      excludeStates: Array<string | null> | null;
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      status: UnitStatus;
      weatherStatus: WeatherStatus;
      baseId: string;
      regionId: string;
      isExternallyManaged: boolean;
      maximumFlightRule: FlightRule;
      isOnDelay: boolean;
      isEnabled: boolean;
      isSpare: boolean;
      integrations: Array<IntegrationSystem>;
      isCrewAvailable: boolean;
      updatePhoneNumbersFromExternal: boolean;
      companyId: string;
      isAdministrative: boolean | null;
      vehicleId: string | null;
      isHidden: boolean | null;
      isThirdPartyUnit: boolean | null;
      etloInMinutes: number | null;
      pilotNotes: string | null;
      lastPilotUpdateTime: Date | number | string | null;
      lastPilotUpdateById: string | null;
      plannedAvailableNotes: string | null;
      plannedAvailableTime: Date | number | string | null;
      oemPlacardNumber: string | null;
      primaryOutOfServiceEventId: string | null;
      emSystemResourceId: string | null;
      onBaseETAInMinutes: number | null;
      crewSourcedFromUnitId: string | null;
      completeFlightInstanceId: string | null;
      parentUnitId: string | null;
      positions: Array<{
        __typename: 'UnitPosition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        type: UnitPositionType;
        isFlightCrew: boolean;
        isNonEmployee: boolean;
        unitId: string;
        companyId: string;
        notificationAddress: string | null;
        teamMemberId: string | null;
        firstName: string | null;
        lastName: string | null;
        teamMember: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      shifts: Array<{
        __typename: 'UnitShift';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        startTimeInMinutes: number;
        endTimeInMinutes: number;
        unitId: string;
        companyId: string;
      }>;
      vehicle: {
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
        vehicleDispositions: Array<{
          __typename: 'VehicleDisposition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          status: VehicleStatus;
          companyId: string;
          currentWaypointId: string | null;
          currentTripLegId: string | null;
          currentTripId: string | null;
          lastTripId: string | null;
          currentAgencyLocationId: string | null;
          notes: string | null;
          isAssetOutOfService: boolean | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          latitude: number | null;
          longitude: number | null;
          etlo: Date | number | string | null;
          statusDescription: string | null;
          positionTime: Date | number | string | null;
          positionSource: PositionReportSource | null;
          vehiclePositionSummaryId: string | null;
          latestPositionReportId: string | null;
          latestFlightFollowingReportId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
        }>;
        model: {
          __typename: 'VehicleModel';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cruiseSpeedInMph: number | null;
        } | null;
        vehicleStateInspections: Array<{
          __typename: 'VehicleStateInspection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          inspectionDate: Date | number | string;
          vehicleId: string;
          companyId: string;
        }>;
      } | null;
      crewSourcedToUnits: Array<{
        __typename: 'CrewSourcedUnit';
        id: string;
        unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
      } | null> | null;
    } | null;
  };
};

export type UnitContextFragment = {
  __typename: 'Unit';
  excludeStates: Array<string | null> | null;
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  status: UnitStatus;
  weatherStatus: WeatherStatus;
  baseId: string;
  regionId: string;
  isExternallyManaged: boolean;
  maximumFlightRule: FlightRule;
  isOnDelay: boolean;
  isEnabled: boolean;
  isSpare: boolean;
  integrations: Array<IntegrationSystem>;
  isCrewAvailable: boolean;
  updatePhoneNumbersFromExternal: boolean;
  companyId: string;
  isAdministrative: boolean | null;
  vehicleId: string | null;
  isHidden: boolean | null;
  isThirdPartyUnit: boolean | null;
  etloInMinutes: number | null;
  pilotNotes: string | null;
  lastPilotUpdateTime: Date | number | string | null;
  lastPilotUpdateById: string | null;
  plannedAvailableNotes: string | null;
  plannedAvailableTime: Date | number | string | null;
  oemPlacardNumber: string | null;
  primaryOutOfServiceEventId: string | null;
  emSystemResourceId: string | null;
  onBaseETAInMinutes: number | null;
  crewSourcedFromUnitId: string | null;
  completeFlightInstanceId: string | null;
  parentUnitId: string | null;
  positions: Array<{
    __typename: 'UnitPosition';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    name: string;
    type: UnitPositionType;
    isFlightCrew: boolean;
    isNonEmployee: boolean;
    unitId: string;
    companyId: string;
    notificationAddress: string | null;
    teamMemberId: string | null;
    firstName: string | null;
    lastName: string | null;
    teamMember: {
      __typename: 'Person';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      employeeType: EmployeeType;
      timeType: TimeType;
      activateOktaAccount: boolean;
      grantTcsAccess: boolean;
      isOutOfFlightCompliance: boolean;
      companyId: string;
      title: string | null;
      employeeId: string | null;
      hireDate: Date | number | string | null;
      terminationDate: Date | number | string | null;
      departmentId: string | null;
      reportsToPersonId: string | null;
      baseId: string | null;
      locationId: string | null;
      programId: string | null;
      activeDirectoryId: string | null;
      notificationAddress: string | null;
      userRoles: Array<UserRole | null> | null;
      allCompaniesAccessible: boolean | null;
      allBasesAccessible: boolean | null;
      allTrmProgramsAccessible: boolean | null;
      allCommunicationCentersAccessible: boolean | null;
      faaCompanyId: string | null;
      dispatchCompanyId: string | null;
      aviationCompanyId: string | null;
      primaryCommunicationCenterId: string | null;
      outOfFlightComplianceComment: string | null;
      dateLastUpdatedFromGMRWorkday: Date | number | string | null;
      appSettings: {
        __typename: 'UserApplicationSettings';
        tcsRealtimeTracking: {
          __typename: 'TcsRealtimeTracking';
          tabId: string | null;
          tabDate: Date | number | string | null;
        };
      } | null;
      additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  }>;
  shifts: Array<{
    __typename: 'UnitShift';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    name: string;
    startTimeInMinutes: number;
    endTimeInMinutes: number;
    unitId: string;
    companyId: string;
  }>;
  vehicle: {
    __typename: 'Vehicle';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    type: VehicleType;
    registrationNumber: string;
    isUnderLease: boolean;
    role: VehicleRole;
    flightLogProcess: FlightLogProcess;
    isPlaceholder: boolean;
    stateInspectionRequired: boolean;
    isRetired: boolean;
    isPositionTrackingEnabled: boolean;
    hideFromOOSRUM: boolean;
    companyId: string;
    serialNumber: string | null;
    dispatchCompanyId: string | null;
    year: number | null;
    dateAcquired: Date | number | string | null;
    makeId: string | null;
    modelId: string | null;
    cruiseSpeed: number | null;
    configurationClassId: string | null;
    isThirdPartyVehicle: boolean | null;
    parentUnitId: string | null;
    isHidden: boolean | null;
    faaCompanyId: string | null;
    skytracIMEI: string | null;
    phoneNumber: string | null;
    completeFlightId: string | null;
    controlZoneId: string | null;
    communicationCenterId: string | null;
    regionId: string | null;
    vehicleDescription: string | null;
    vehicleDispositions: Array<{
      __typename: 'VehicleDisposition';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      vehicleId: string;
      status: VehicleStatus;
      companyId: string;
      currentWaypointId: string | null;
      currentTripLegId: string | null;
      currentTripId: string | null;
      lastTripId: string | null;
      currentAgencyLocationId: string | null;
      notes: string | null;
      isAssetOutOfService: boolean | null;
      lastQualifyingPositionReportTime: Date | number | string | null;
      latitude: number | null;
      longitude: number | null;
      etlo: Date | number | string | null;
      statusDescription: string | null;
      positionTime: Date | number | string | null;
      positionSource: PositionReportSource | null;
      vehiclePositionSummaryId: string | null;
      latestPositionReportId: string | null;
      latestFlightFollowingReportId: string | null;
      from: {
        __typename: 'WaypointSummary';
        id: string;
        name: string;
        abbreviation: string;
        type: WaypointType;
      } | null;
      to: {
        __typename: 'WaypointSummary';
        id: string;
        name: string;
        abbreviation: string;
        type: WaypointType;
      } | null;
    }>;
    model: {
      __typename: 'VehicleModel';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      cruiseSpeedInMph: number | null;
    } | null;
    vehicleStateInspections: Array<{
      __typename: 'VehicleStateInspection';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      stateAbbrevation: string;
      inspectionDate: Date | number | string;
      vehicleId: string;
      companyId: string;
    }>;
  } | null;
  crewSourcedToUnits: Array<{
    __typename: 'CrewSourcedUnit';
    id: string;
    unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
  } | null> | null;
};

export type WebOrderLogsDialog_FetchWebOrderLogsByEntityIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type WebOrderLogsDialog_FetchWebOrderLogsByEntityIdQuery = {
  __typename: 'Query';
  webOrderLogs: {
    __typename: 'webOrderLogQueries';
    byEntityId: {
      __typename: 'WebOrderLogCollection';
      items: Array<{
        __typename: 'WebOrderLog';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        requestJson: string;
        name: string;
        isSuccess: boolean;
        errors: string | null;
        entityId: string | null;
        entityType: EntityType | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        changes: Array<{
          __typename: 'WebOrderLogEntityChanges';
          id: string;
          entityType: string;
          fieldName: string;
          oldValue: string | null;
          newValue: string | null;
        } | null> | null;
      }>;
    };
  };
};

export type CardArchivedRecordsFetchService_FetchArchivedCardNotesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CardArchivedRecordsFetchService_FetchArchivedCardNotesQuery = {
  __typename: 'Query';
  cardNoteArchives: {
    __typename: 'CardNoteArchiveQueries';
    byCardId: {
      __typename: 'CardNoteArchiveCollection';
      items: Array<{
        __typename: 'CardNoteArchive';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        content: string;
        noteTime: Date | number | string;
        isInternal: boolean;
        isSystem: boolean;
        dateArchived: Date | number | string;
        cardId: string;
        companyId: string;
        authorId: string | null;
        noteCategory: string | null;
        noteMetadataJson: string | null;
        receivedFromCardId: string | null;
        sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
    };
  };
};

export type CardArchivedRecordsFetchService_FetchArchivedPositionReportsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CardArchivedRecordsFetchService_FetchArchivedPositionReportsQuery = {
  __typename: 'Query';
  positionReportArchives: {
    __typename: 'PositionReportArchiveQueries';
    byTripId: {
      __typename: 'PositionReportArchiveCollection';
      items: Array<{
        __typename: 'PositionReportArchive';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        positionTime: Date | number | string;
        source: PositionReportSource;
        dateArchived: Date | number | string;
        tripId: string;
        companyId: string;
        altitude: number | null;
        speedInKnots: number | null;
        heading: number | null;
        estimatedMinutesEnRoute: number | null;
        fuelRemaining: string | null;
        timezoneCd: string | null;
        dateConfirmed: Date | number | string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      }>;
    };
  };
};

export type ActivationRuleDetailsComponent_FetchActivationRuleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ActivationRuleDetailsComponent_FetchActivationRuleByIdQuery = {
  __typename: 'Query';
  activationRules: {
    __typename: 'ActivationRuleQueries';
    byId: {
      __typename: 'ActivationRule';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string | null;
      isShared: boolean | null;
      companyId: string | null;
      regionId: string | null;
      baseId: string | null;
      unitId: string | null;
      vehicleId: string | null;
      specialtyTeamId: string | null;
      vehicleTypes: Array<VehicleType | null> | null;
      medicalFacilityId: string | null;
      locationId: string | null;
      operationTypes: Array<OperationType | null> | null;
      timestampTypeId: string | null;
      systemTimestampType: SystemTimestampType | null;
      outOfServiceReasonId: string | null;
      paipReasonId: string | null;
      outOfServiceType: OutOfServiceType | null;
      automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
      ageInMinutes: number | null;
      waypointTypes: Array<WaypointType | null> | null;
      missionRoleTypes: Array<MissionRoleType | null> | null;
      company: {
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      } | null;
      region: {
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
      } | null;
      base: {
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      } | null;
      vehicle: {
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      } | null;
      unit: {
        __typename: 'Unit';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        baseId: string;
        regionId: string;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        integrations: Array<IntegrationSystem>;
        isCrewAvailable: boolean;
        updatePhoneNumbersFromExternal: boolean;
        companyId: string;
        isAdministrative: boolean | null;
        vehicleId: string | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        oemPlacardNumber: string | null;
        primaryOutOfServiceEventId: string | null;
        emSystemResourceId: string | null;
        onBaseETAInMinutes: number | null;
        crewSourcedFromUnitId: string | null;
        completeFlightInstanceId: string | null;
        parentUnitId: string | null;
        crewSourcedToUnits: Array<{
          __typename: 'CrewSourcedUnit';
          id: string;
          unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
        } | null> | null;
      } | null;
      medicalFacility: {
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      } | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      alerts: Array<{
        __typename: 'Alert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        entityType: EntityType;
        activationRuleId: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        isAudible: boolean;
        title: string | null;
        effectiveDate: Date | number | string | null;
        expirationDate: Date | number | string | null;
        paused: boolean | null;
        createdById: string | null;
      }>;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
      declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type ActivationRuleForm_GetRegionsQueryVariables = Exact<{
  filter: InputMaybe<RegionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ActivationRuleForm_GetRegionsQuery = {
  __typename: 'Query';
  regions: {
    __typename: 'RegionQueries';
    all: {
      __typename: 'RegionCollection';
      items: Array<{
        __typename: 'Region';
        id: string;
        name: string;
        communicationCenter: { __typename: 'CommunicationCenter'; id: string; name: string };
      }>;
    };
  };
};

export type ActivationRuleForm_GetCommunicationCentersQueryVariables = Exact<{
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ActivationRuleForm_GetCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{ __typename: 'CommunicationCenter'; id: string; name: string }>;
    };
  };
};

export type ActivationRuleForm_GetActivationRuleIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ActivationRuleForm_GetActivationRuleIdQuery = {
  __typename: 'Query';
  activationRules: {
    __typename: 'ActivationRuleQueries';
    byId: {
      __typename: 'ActivationRule';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string | null;
      isShared: boolean | null;
      companyId: string | null;
      regionId: string | null;
      baseId: string | null;
      unitId: string | null;
      vehicleId: string | null;
      specialtyTeamId: string | null;
      vehicleTypes: Array<VehicleType | null> | null;
      medicalFacilityId: string | null;
      locationId: string | null;
      operationTypes: Array<OperationType | null> | null;
      timestampTypeId: string | null;
      systemTimestampType: SystemTimestampType | null;
      outOfServiceReasonId: string | null;
      paipReasonId: string | null;
      outOfServiceType: OutOfServiceType | null;
      automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
      ageInMinutes: number | null;
      waypointTypes: Array<WaypointType | null> | null;
      missionRoleTypes: Array<MissionRoleType | null> | null;
      medicalFacility: {
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        requesters: Array<{ __typename: 'Requester'; id: string } | null> | null;
        requests: Array<{ __typename: 'RequestLocation'; id: string } | null> | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      } | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
      declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type ActivationRuleForm_GetDeclineReasonsQueryVariables = Exact<{
  filter: InputMaybe<DeclineReasonFilter>;
}>;

export type ActivationRuleForm_GetDeclineReasonsQuery = {
  __typename: 'Query';
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    all: {
      __typename: 'DeclineReasonCollection';
      items: Array<{
        __typename: 'DeclineReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        declineCategoryId: string;
        controllable: boolean;
        canBeSkipReason: boolean;
        canBeAbortReason: boolean;
        canBeBulkSkipReason: boolean;
        canBeOneCallSkipReason: boolean;
        isUnitAvailableAfterAbort: boolean;
        secondaryReasonRequired: boolean;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineReasonCollectionMetadata'; total: number };
    };
  };
};

export type AgencyListPageComponent_FetchAgenciesQueryVariables = Exact<{
  filter: InputMaybe<AgencyFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AgencyListPageComponent_FetchAgenciesQuery = {
  __typename: 'Query';
  agencies: {
    __typename: 'AgencyQueries';
    all: {
      __typename: 'AgencyCollection';
      items: Array<{
        __typename: 'Agency';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        type: AgencyType;
        isCompetitor: boolean;
        isInternallyOwned: boolean;
        parentCompanyId: string | null;
        notes: string | null;
        locations: Array<{
          __typename: 'AgencyLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isInTransportNet: boolean;
          agencyId: string;
          emailAddress: string | null;
          primaryPhoneNumber: string | null;
          secondaryPhoneNumber: string | null;
          smsPhoneNumber: string | null;
          faxPhoneNumber: string | null;
          notes: string | null;
          vehicleType: VehicleType | null;
          estimatedDepartureTimeInMinutes: number | null;
          locationId: string | null;
          location: {
            __typename: 'Location';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            locationType: LocationType;
            isPreferred: boolean;
            timezoneCd: string | null;
            isRotorWingLz: boolean | null;
            notes: string | null;
            sourceSystemId: string | null;
            closedDate: Date | number | string | null;
            duplicateOfId: string | null;
            isLandingZoneOutOfService: boolean | null;
            landingZoneOutOfServiceNotes: string | null;
            landingZoneOutOfServiceExpirationDate: Date | number | string | null;
            landingZoneOutOfServiceReasonId: string | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            };
          } | null;
        }>;
      }>;
      meta: { __typename: 'AgencyCollectionMetadata'; total: number };
    };
  };
};

export type AgencyLocationListComponent_FetchAllAgencyLocationsQueryVariables = Exact<{
  filter: InputMaybe<AgencyLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AgencyLocationListComponent_FetchAllAgencyLocationsQuery = {
  __typename: 'Query';
  agencyLocations: {
    __typename: 'AgencyLocationQueries';
    all: {
      __typename: 'AgencyLocationCollection';
      items: Array<{
        __typename: 'AgencyLocation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isInTransportNet: boolean;
        agencyId: string;
        emailAddress: string | null;
        primaryPhoneNumber: string | null;
        secondaryPhoneNumber: string | null;
        smsPhoneNumber: string | null;
        faxPhoneNumber: string | null;
        notes: string | null;
        vehicleType: VehicleType | null;
        estimatedDepartureTimeInMinutes: number | null;
        locationId: string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
      }>;
      meta: { __typename: 'AgencyLocationCollectionMetadata'; total: number };
    };
  };
};

export type AgencyLocationManagePageComponent_FetchAgencyLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type AgencyLocationManagePageComponent_FetchAgencyLocationByIdQuery = {
  __typename: 'Query';
  agencyLocations: {
    __typename: 'AgencyLocationQueries';
    byId: {
      __typename: 'AgencyLocation';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      isInTransportNet: boolean;
      agencyId: string;
      emailAddress: string | null;
      primaryPhoneNumber: string | null;
      secondaryPhoneNumber: string | null;
      smsPhoneNumber: string | null;
      faxPhoneNumber: string | null;
      notes: string | null;
      vehicleType: VehicleType | null;
      estimatedDepartureTimeInMinutes: number | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
    } | null;
  };
};

export type FboListPageComponent_FetchAllFbosQueryVariables = Exact<{
  filter: InputMaybe<FboFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type FboListPageComponent_FetchAllFbosQuery = {
  __typename: 'Query';
  fbos: {
    __typename: 'FboQueries';
    all: {
      __typename: 'FboCollection';
      items: Array<{
        __typename: 'Fbo';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        airportId: string;
        fboType: FboType;
        fuelBrand: string | null;
        sourceSystemId: number | null;
        locationId: string | null;
        airports: Array<{
          __typename: 'Airport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          airportType: string;
          airportCodeType: AirportCodeType;
          sourceSystemId: number | null;
          preferredFboId: string | null;
          locationId: string | null;
        } | null> | null;
      }>;
      meta: { __typename: 'FboCollectionMetadata'; total: number };
    };
  };
};

export type AirportListPageComponent_FetchAllAirportsQueryVariables = Exact<{
  filter: InputMaybe<AirportFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AirportListPageComponent_FetchAllAirportsQuery = {
  __typename: 'Query';
  airports: {
    __typename: 'AirportQueries';
    all: {
      __typename: 'AirportCollection';
      items: Array<{
        __typename: 'Airport';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        code: string;
        airportType: string;
        airportCodeType: AirportCodeType;
        sourceSystemId: number | null;
        preferredFboId: string | null;
        locationId: string | null;
        preferredFbo: {
          __typename: 'Fbo';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          airportId: string;
          fboType: FboType;
          fuelBrand: string | null;
          sourceSystemId: number | null;
          locationId: string | null;
        } | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
      }>;
      meta: { __typename: 'AirportCollectionMetadata'; total: number };
    };
  };
};

export type AlertListPageQueryVariables = Exact<{
  filter: InputMaybe<AlertFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type AlertListPageQuery = {
  __typename: 'Query';
  alerts: {
    __typename: 'AlertQueries';
    all: {
      __typename: 'AlertCollection';
      items: Array<{
        __typename: 'Alert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        entityType: EntityType;
        activationRuleId: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        isAudible: boolean;
        title: string | null;
        effectiveDate: Date | number | string | null;
        expirationDate: Date | number | string | null;
        paused: boolean | null;
        createdById: string | null;
        activationRule: {
          __typename: 'ActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string | null;
          isShared: boolean | null;
          companyId: string | null;
          regionId: string | null;
          baseId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          specialtyTeamId: string | null;
          vehicleTypes: Array<VehicleType | null> | null;
          medicalFacilityId: string | null;
          locationId: string | null;
          operationTypes: Array<OperationType | null> | null;
          timestampTypeId: string | null;
          systemTimestampType: SystemTimestampType | null;
          outOfServiceReasonId: string | null;
          paipReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
          ageInMinutes: number | null;
          waypointTypes: Array<WaypointType | null> | null;
          missionRoleTypes: Array<MissionRoleType | null> | null;
          medicalFacility: {
            __typename: 'MedicalFacility';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            npi: string;
            providerNumber: string | null;
            sourceSystemId: number | null;
            masterDataSetId: number | null;
            firmType: string | null;
            hospitalType: string | null;
            hospitalSpecialization: string | null;
            website: string | null;
            defaultLandingZoneId: string | null;
            defaultFixedWingLandingZoneId: string | null;
            notes: string | null;
            stateSourceSystemId: string | null;
            nemsisCode: string | null;
            stateFacilityName: string | null;
            status: MedicalFacilityStatus | null;
            archiveNotes: string | null;
            archiveClearedDate: Date | number | string | null;
            locationId: string | null;
            communicationCenterCustomIdentifiers: Array<{
              __typename: 'IdNameListItem';
              id: string;
              name: string;
            } | null> | null;
          } | null;
          location: {
            __typename: 'Location';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            locationType: LocationType;
            isPreferred: boolean;
            timezoneCd: string | null;
            isRotorWingLz: boolean | null;
            notes: string | null;
            sourceSystemId: string | null;
            closedDate: Date | number | string | null;
            duplicateOfId: string | null;
            isLandingZoneOutOfService: boolean | null;
            landingZoneOutOfServiceNotes: string | null;
            landingZoneOutOfServiceExpirationDate: Date | number | string | null;
            landingZoneOutOfServiceReasonId: string | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            };
          } | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
      meta: { __typename: 'AlertCollectionMetadata'; total: number };
    };
  };
};

export type ApplicationNotificationFormComponent_FetchAllRegionsQueryVariables = Exact<{
  filter: InputMaybe<RegionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ApplicationNotificationFormComponent_FetchAllRegionsQuery = {
  __typename: 'Query';
  regions: {
    __typename: 'RegionQueries';
    all: {
      __typename: 'RegionCollection';
      items: Array<{
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
        regionGroup: {
          __typename: 'RegionGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          departmentId: string;
          companyId: string;
        };
      }>;
      meta: { __typename: 'RegionCollectionMetadata'; total: number };
    };
  };
};

export type ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsQueryVariables =
  Exact<{
    filter: InputMaybe<ApplicationNotificationFilter>;
    first: InputMaybe<Scalars['Int']>;
    skip: InputMaybe<Scalars['Int']>;
  }>;

export type ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsQuery = {
  __typename: 'Query';
  applicationNotifications: {
    __typename: 'ApplicationNotificationQueries';
    all: {
      __typename: 'ApplicationNotificationCollection';
      items: Array<{
        __typename: 'ApplicationNotification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: ApplicationNotificationUrgency;
        displayOnBanner: boolean;
        dismissable: boolean;
        notification: string;
        title: string | null;
        effectiveDate: Date | number | string | null;
        expirationDate: Date | number | string | null;
        createdById: string | null;
        companyId: string | null;
        regionId: string | null;
      }>;
      meta: { __typename: 'ApplicationNotificationCollectionMetadata'; total: number };
    };
  };
};

export type CancellationCategoryFormComponent_FetchAllCancellationReasonsQueryVariables = Exact<{
  filter: InputMaybe<CancellationReasonFilter>;
}>;

export type CancellationCategoryFormComponent_FetchAllCancellationReasonsQuery = {
  __typename: 'Query';
  cancellationReasons: {
    __typename: 'CancellationReasonQueries';
    all: {
      __typename: 'CancellationReasonCollection';
      items: Array<{
        __typename: 'CancellationReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        isTransferCenterReason: boolean;
        secondaryReasonRequired: boolean;
        canBeUnitCancellationReason: boolean | null;
        cancellationCategoryId: string | null;
      }>;
      meta: { __typename: 'CancellationReasonCollectionMetadata'; total: number };
    };
  };
};

export type CancellationCategoryListPageComponent_FetchAllCancellationCategoriesQueryVariables =
  Exact<{
    filter: InputMaybe<CancellationCategoryFilter>;
  }>;

export type CancellationCategoryListPageComponent_FetchAllCancellationCategoriesQuery = {
  __typename: 'Query';
  cancellationCategories: {
    __typename: 'CancellationCategoryQueries';
    all: {
      __typename: 'CancellationCategoryCollection';
      items: Array<{
        __typename: 'CancellationCategory';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isVisibleInOps: boolean;
        defaultCancellationReasonId: string | null;
        defaultCancellationReason: {
          __typename: 'CancellationReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          isTransferCenterReason: boolean;
          secondaryReasonRequired: boolean;
          canBeUnitCancellationReason: boolean | null;
          cancellationCategoryId: string | null;
        } | null;
      }>;
      meta: { __typename: 'CancellationCategoryCollectionMetadata'; total: number };
    };
  };
};

export type CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdQuery = {
  __typename: 'Query';
  cancellationReasons: {
    __typename: 'CancellationReasonQueries';
    byId: {
      __typename: 'CancellationReason';
      cancellationSecondaryReasons: Array<{
        __typename: 'CancellationSecondaryReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cancellationReasonId: string;
      }>;
    } | null;
  };
};

export type CancellationReasonListPageComponent_FetchAllCancellationReasonsQueryVariables = Exact<{
  filter: InputMaybe<CancellationReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type CancellationReasonListPageComponent_FetchAllCancellationReasonsQuery = {
  __typename: 'Query';
  cancellationReasons: {
    __typename: 'CancellationReasonQueries';
    all: {
      __typename: 'CancellationReasonCollection';
      items: Array<{
        __typename: 'CancellationReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        isTransferCenterReason: boolean;
        secondaryReasonRequired: boolean;
        canBeUnitCancellationReason: boolean | null;
        cancellationCategoryId: string | null;
      }>;
      meta: { __typename: 'CancellationReasonCollectionMetadata'; total: number };
    };
  };
};

export type CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdQuery =
  {
    __typename: 'Query';
    cancellationReasons: {
      __typename: 'CancellationReasonQueries';
      byId: {
        __typename: 'CancellationReason';
        cancellationSecondaryReasons: Array<{
          __typename: 'CancellationSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cancellationReasonId: string;
        }>;
      } | null;
    };
  };

export type CapabilityListPageComponent_FetchAllCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<CapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type CapabilityListPageComponent_FetchAllCapabilitiesQuery = {
  __typename: 'Query';
  capabilities: {
    __typename: 'CapabilityQueries';
    all: {
      __typename: 'CapabilityCollection';
      items: Array<{
        __typename: 'Capability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        description: string;
        entityType: EntityType;
      }>;
      meta: { __typename: 'CapabilityCollectionMetadata'; total: number };
    };
  };
};

export type CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsQueryVariables = Exact<{
  filter: InputMaybe<CardReopenReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsQuery = {
  __typename: 'Query';
  cardReopenReasons: {
    __typename: 'CardReopenReasonQueries';
    all: {
      __typename: 'CardReOpenReasonCollection';
      items: Array<{
        __typename: 'CardReOpenReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        affectsTrip: boolean;
      }>;
      meta: { __typename: 'CardReOpenReasonCollectionMetadata'; total: number };
    };
  };
};

export type CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    byId: {
      __typename: 'CommunicationCenter';
      states: Array<string | null> | null;
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      includeCompetitors: boolean;
      playAlertForManualPositionReports: boolean;
      enableRAAlert: boolean;
      useCrewPhoneNumber: boolean;
      displayContactTimeline: boolean;
      companyId: string;
      timezoneCd: string | null;
      primaryPhoneNumber: string | null;
      emailAddress: string | null;
      showReferToGmrWarning: boolean | null;
      alertFrequencyForGroundVehicles: number | null;
      company: {
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      };
      transferCenterRegion: {
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
      } | null;
    } | null;
  };
};

export type CommunicationCenterListPageComponent_FetchAllCommunicationCentersQueryVariables =
  Exact<{
    filter: InputMaybe<CommunicationCenterFilter>;
    first: InputMaybe<Scalars['Int']>;
    skip: InputMaybe<Scalars['Int']>;
  }>;

export type CommunicationCenterListPageComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        states: Array<string | null> | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        transferCenterRegion: {
          __typename: 'Region';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          communicationCenterId: string;
          isTransferCenterRegion: boolean;
          regionGroupId: string;
          companyId: string;
          timezoneCd: string | null;
          emSystemDivisionName: string | null;
          dispatchNumber: string | null;
          fixedWingPreferredThresholdInNauticalMiles: number | null;
          etcInMinutes: number | null;
        } | null;
      }>;
      meta: { __typename: 'CommunicationCenterCollectionMetadata'; total: number };
    };
  };
};

export type CommunicationCenterRegionsListComponent_FetchRegionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CommunicationCenterRegionsListComponent_FetchRegionsQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    byId: {
      __typename: 'CommunicationCenter';
      regions: Array<{
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
    } | null;
  };
};

export type CommunicationCenterTransferCentersListComponent_FetchTransferCentersQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type CommunicationCenterTransferCentersListComponent_FetchTransferCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    byId: {
      __typename: 'CommunicationCenter';
      transferCenters: Array<{
        __typename: 'TransferCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        communicationCenterId: string;
        companyId: string;
        description: string | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
    } | null;
  };
};

export type CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsQuery =
  {
    __typename: 'Query';
    communicationCenters: {
      __typename: 'CommunicationCenterQueries';
      byId: {
        __typename: 'CommunicationCenter';
        communicationCenterTransportOfferOption: {
          __typename: 'CommunicationCenterTransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          communicationCenterId: string | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapabilityIdList'; id: string }>;
        };
      } | null;
    };
  };

export type ControlZoneBasesListComponent_FetchBasesQueryVariables = Exact<{
  controlZoneId: Scalars['ID'];
}>;

export type ControlZoneBasesListComponent_FetchBasesQuery = {
  __typename: 'Query';
  baseControlZones: {
    __typename: 'BaseControlZoneQueries';
    all: {
      __typename: 'BaseControlZoneCollection';
      items: Array<{
        __typename: 'BaseControlZone';
        id: string;
        base: {
          __typename: 'Base';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationId: string;
          businessModel: BusinessModel;
          companyId: string;
          plannedOperationsStart: Date | number | string | null;
          operationsStarted: Date | number | string | null;
          operationsTerminated: Date | number | string | null;
          dateOfMaturity: Date | number | string | null;
          primaryPhoneNumber: string | null;
          estimatedLiftoffTime: number | null;
          licenseNumber: string | null;
          enableFlightLogDutyLog: boolean | null;
          dispatchBaseId: string | null;
          reportBaseId: string | null;
          aviationCompanyId: string | null;
          workdayBaseId: string | null;
          gmrWorkdayLocationId: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          pilotPhoneNumber: string | null;
          crewPhoneNumber1: string | null;
          crewPhoneNumber2: string | null;
          brandName: string | null;
          medicalFacilityId: string | null;
          hoursOfOperation: {
            __typename: 'HoursOfOperation';
            is24Hours: boolean | null;
            startTime: Date | number | string | null;
            endTime: Date | number | string | null;
          };
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        controlZone: {
          __typename: 'ControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
        };
      }>;
      meta: { __typename: 'BaseControlZoneCollectionMetadata'; total: number };
    };
  };
};

export type ControlZoneListPageComponent_FetchAllControlZonesQueryVariables = Exact<{
  filter: InputMaybe<ControlZoneFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ControlZoneListPageComponent_FetchAllControlZonesQuery = {
  __typename: 'Query';
  controlZones: {
    __typename: 'ControlZoneQueries';
    all: {
      __typename: 'ControlZoneCollection';
      items: Array<{
        __typename: 'ControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
      }>;
      meta: { __typename: 'ControlZoneCollectionMetadata'; total: number };
    };
  };
};

export type ControlZoneVehiclesListComponent_FetchVehiclesQueryVariables = Exact<{
  controlZoneId: Scalars['ID'];
}>;

export type ControlZoneVehiclesListComponent_FetchVehiclesQuery = {
  __typename: 'Query';
  vehicleControlZones: {
    __typename: 'VehicleControlZoneQueries';
    all: {
      __typename: 'VehicleControlZoneCollection';
      items: Array<{
        __typename: 'VehicleControlZone';
        id: string;
        vehicle: {
          __typename: 'Vehicle';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          isUnderLease: boolean;
          role: VehicleRole;
          flightLogProcess: FlightLogProcess;
          isPlaceholder: boolean;
          stateInspectionRequired: boolean;
          isRetired: boolean;
          isPositionTrackingEnabled: boolean;
          hideFromOOSRUM: boolean;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          year: number | null;
          dateAcquired: Date | number | string | null;
          makeId: string | null;
          modelId: string | null;
          cruiseSpeed: number | null;
          configurationClassId: string | null;
          isThirdPartyVehicle: boolean | null;
          parentUnitId: string | null;
          isHidden: boolean | null;
          faaCompanyId: string | null;
          skytracIMEI: string | null;
          phoneNumber: string | null;
          completeFlightId: string | null;
          controlZoneId: string | null;
          communicationCenterId: string | null;
          regionId: string | null;
          vehicleDescription: string | null;
        } | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        controlZone: {
          __typename: 'ControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
        } | null;
      }>;
      meta: { __typename: 'VehicleControlZoneCollectionMetadata'; total: number };
    };
  };
};

export type DeclineCategoryFormComponent_FetchAllDeclineReasonsQueryVariables = Exact<{
  filter: InputMaybe<DeclineReasonFilter>;
}>;

export type DeclineCategoryFormComponent_FetchAllDeclineReasonsQuery = {
  __typename: 'Query';
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    all: {
      __typename: 'DeclineReasonCollection';
      items: Array<{
        __typename: 'DeclineReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        declineCategoryId: string;
        controllable: boolean;
        canBeSkipReason: boolean;
        canBeAbortReason: boolean;
        canBeBulkSkipReason: boolean;
        canBeOneCallSkipReason: boolean;
        isUnitAvailableAfterAbort: boolean;
        secondaryReasonRequired: boolean;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineReasonCollectionMetadata'; total: number };
    };
  };
};

export type DeclineCategoryListPageComponent_FetchAllDeclineCategoriesQueryVariables = Exact<{
  filter: InputMaybe<DeclineCategoryFilter>;
}>;

export type DeclineCategoryListPageComponent_FetchAllDeclineCategoriesQuery = {
  __typename: 'Query';
  declineCategories: {
    __typename: 'DeclineCategoryQueries';
    all: {
      __typename: 'DeclineCategoryCollection';
      items: Array<{
        __typename: 'DeclineCategory';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isVisibleInOps: boolean;
        defaultDeclineReasonId: string | null;
        defaultDeclineReason: {
          __typename: 'DeclineReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          declineCategoryId: string;
          controllable: boolean;
          canBeSkipReason: boolean;
          canBeAbortReason: boolean;
          canBeBulkSkipReason: boolean;
          canBeOneCallSkipReason: boolean;
          isUnitAvailableAfterAbort: boolean;
          secondaryReasonRequired: boolean;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
        } | null;
      }>;
      meta: { __typename: 'DeclineCategoryCollectionMetadata'; total: number };
    };
  };
};

export type DeclineReasonFormComponent_FetchAllDeclineCategoriesQueryVariables = Exact<{
  filter: InputMaybe<DeclineCategoryFilter>;
}>;

export type DeclineReasonFormComponent_FetchAllDeclineCategoriesQuery = {
  __typename: 'Query';
  declineCategories: {
    __typename: 'DeclineCategoryQueries';
    all: {
      __typename: 'DeclineCategoryCollection';
      items: Array<{
        __typename: 'DeclineCategory';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isVisibleInOps: boolean;
        defaultDeclineReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineCategoryCollectionMetadata'; total: number };
    };
  };
};

export type DeclineReasonListPageComponent_FetchAllDeclineReasonsQueryVariables = Exact<{
  filter: InputMaybe<DeclineReasonFilter>;
}>;

export type DeclineReasonListPageComponent_FetchAllDeclineReasonsQuery = {
  __typename: 'Query';
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    all: {
      __typename: 'DeclineReasonCollection';
      items: Array<{
        __typename: 'DeclineReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        declineCategoryId: string;
        controllable: boolean;
        canBeSkipReason: boolean;
        canBeAbortReason: boolean;
        canBeBulkSkipReason: boolean;
        canBeOneCallSkipReason: boolean;
        isUnitAvailableAfterAbort: boolean;
        secondaryReasonRequired: boolean;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineReasonCollectionMetadata'; total: number };
    };
  };
};

export type DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdQuery = {
  __typename: 'Query';
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    byId: {
      __typename: 'DeclineReason';
      declineSecondaryReasons: Array<{
        __typename: 'DeclineSecondaryReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        declineReasonId: string;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
    } | null;
  };
};

export type DiversionReasonListPageComponent_FetchAllDiversionReasonsQueryVariables = Exact<{
  filter: InputMaybe<DiversionReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type DiversionReasonListPageComponent_FetchAllDiversionReasonsQuery = {
  __typename: 'Query';
  diversionReasons: {
    __typename: 'DiversionReasonQueries';
    all: {
      __typename: 'DiversionReasonCollection';
      items: Array<{
        __typename: 'DiversionReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
      meta: { __typename: 'DiversionReasonCollectionMetadata'; total: number };
    };
  };
};

export type FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsQueryVariables =
  Exact<{
    filter: InputMaybe<FacilityNonAcceptanceReasonFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsQuery =
  {
    __typename: 'Query';
    facilityNonAcceptanceReasons: {
      __typename: 'FacilityNonAcceptanceReasonQueries';
      all: {
        __typename: 'FacilityNonAcceptanceReasonCollection';
        items: Array<{
          __typename: 'FacilityNonAcceptanceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          facilityNonAcceptanceReasonType: NonAcceptanceType;
          lastUpdatedBy: {
            __typename: 'Person';
            id: string;
            firstName: string;
            lastName: string;
          } | null;
        }>;
        meta: { __typename: 'FacilityNonAcceptanceReasonCollectionMetadata'; total: number };
      };
    };
  };

export type FirewallRuleListPageComponent_FetchAllFirewallRulesQueryVariables = Exact<{
  filter: InputMaybe<FirewallRuleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type FirewallRuleListPageComponent_FetchAllFirewallRulesQuery = {
  __typename: 'Query';
  firewallRules: {
    __typename: 'FirewallRuleQueries';
    all: {
      __typename: 'FirewallRuleCollection';
      items: Array<{
        __typename: 'FirewallRule';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        action: AccessControlAction;
        ipRange: string;
        enabled: boolean;
        companyId: string | null;
      }>;
      meta: { __typename: 'FirewallRuleCollectionMetadata'; total: number };
    };
  };
};

export type FuelTankListPageComponent_FetchAllFuelTanksQueryVariables = Exact<{
  filter: InputMaybe<FuelTankFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type FuelTankListPageComponent_FetchAllFuelTanksQuery = {
  __typename: 'Query';
  fueltanks: {
    __typename: 'FuelTankQueries';
    all: {
      __typename: 'FuelTankCollection';
      items: Array<{
        __typename: 'FuelTank';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        code: string;
        name: string;
        locationId: string;
        companyId: string;
        operationsStarted: Date | number | string | null;
        operationsEnded: Date | number | string | null;
        sourceSystemId: number | null;
        baseId: string | null;
        locationName: string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        };
      }>;
      meta: { __typename: 'FuelTankCollectionMetadata'; total: number };
    };
  };
};

export type FuelTankManagePageComponent_FetchFuelTankByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FuelTankManagePageComponent_FetchFuelTankByIdQuery = {
  __typename: 'Query';
  fueltanks: {
    __typename: 'FuelTankQueries';
    byId: {
      __typename: 'FuelTank';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      code: string;
      name: string;
      locationId: string;
      companyId: string;
      operationsStarted: Date | number | string | null;
      operationsEnded: Date | number | string | null;
      sourceSystemId: number | null;
      baseId: string | null;
      locationName: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      };
    } | null;
  };
};

export type GlobalSettingsFormComponent_FetchAllDeclineReasonsQueryVariables = Exact<{
  filter: InputMaybe<DeclineReasonFilter>;
}>;

export type GlobalSettingsFormComponent_FetchAllDeclineReasonsQuery = {
  __typename: 'Query';
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    all: {
      __typename: 'DeclineReasonCollection';
      items: Array<{
        __typename: 'DeclineReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        declineCategoryId: string;
        controllable: boolean;
        canBeSkipReason: boolean;
        canBeAbortReason: boolean;
        canBeBulkSkipReason: boolean;
        canBeOneCallSkipReason: boolean;
        isUnitAvailableAfterAbort: boolean;
        secondaryReasonRequired: boolean;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
      }>;
      meta: { __typename: 'DeclineReasonCollectionMetadata'; total: number };
    };
  };
};

export type GlobalSettingsFormComponent_FetchAllCancellationReasonsQueryVariables = Exact<{
  filter: InputMaybe<CancellationReasonFilter>;
}>;

export type GlobalSettingsFormComponent_FetchAllCancellationReasonsQuery = {
  __typename: 'Query';
  cancellationReasons: {
    __typename: 'CancellationReasonQueries';
    all: {
      __typename: 'CancellationReasonCollection';
      items: Array<{
        __typename: 'CancellationReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        isTransferCenterReason: boolean;
        secondaryReasonRequired: boolean;
        canBeUnitCancellationReason: boolean | null;
        cancellationCategoryId: string | null;
      }>;
      meta: { __typename: 'CancellationReasonCollectionMetadata'; total: number };
    };
  };
};

export type GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsQueryVariables =
  Exact<{ [key: string]: never }>;

export type GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsQuery = {
  __typename: 'Query';
  declineReasons: {
    __typename: 'DeclineReasonQueries';
    all: {
      __typename: 'DeclineReasonCollection';
      items: Array<{ __typename: 'DeclineReason'; id: string; name: string }>;
    };
  };
  requests: {
    __typename: 'RequestQueries';
    allCancellationReasons: Array<{ __typename: 'CancellationReason'; id: string; name: string }>;
  };
  configurationSettings: {
    __typename: 'ConfigurationSettingQueries';
    global: {
      __typename: 'ConfigurationSetting';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      companyId: string | null;
      defaultUnitCommittedDeclineReasonId: string | null;
      defaultUnitOutOfServiceDeclineReasonId: string | null;
      requestReferredInternallyCancellationReasonId: string | null;
      requestReferredExternallyCancellationReasonId: string | null;
      crewGoingByGroundOutOfServiceReasonId: string | null;
      assetReassignedDeclineReasonId: string | null;
      externallyCancelledCancellationReasonId: string | null;
      pilotReportGracePeriodInMinutes: number | null;
      sameDestinationWarningThresholdInMinutes: number | null;
      bugRequestEmail: string | null;
      featureRequestEmail: string | null;
      proximityAlertDistanceInNauticalMiles: number | null;
    } | null;
  };
};

export type GlobalSettingsManagePageComponent_FetchConfigurationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GlobalSettingsManagePageComponent_FetchConfigurationSettingsQuery = {
  __typename: 'Query';
  configurationSettings: {
    __typename: 'ConfigurationSettingQueries';
    global: {
      __typename: 'ConfigurationSetting';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      companyId: string | null;
      defaultUnitCommittedDeclineReasonId: string | null;
      defaultUnitOutOfServiceDeclineReasonId: string | null;
      requestReferredInternallyCancellationReasonId: string | null;
      requestReferredExternallyCancellationReasonId: string | null;
      crewGoingByGroundOutOfServiceReasonId: string | null;
      assetReassignedDeclineReasonId: string | null;
      externallyCancelledCancellationReasonId: string | null;
      pilotReportGracePeriodInMinutes: number | null;
      sameDestinationWarningThresholdInMinutes: number | null;
      bugRequestEmail: string | null;
      featureRequestEmail: string | null;
      proximityAlertDistanceInNauticalMiles: number | null;
    } | null;
  };
};

export type HazardListComponent_FetchAllLocationHazardsQueryVariables = Exact<{
  filter: InputMaybe<LocationHazardFilter>;
}>;

export type HazardListComponent_FetchAllLocationHazardsQuery = {
  __typename: 'Query';
  locationHazards: {
    __typename: 'LocationHazardQueries';
    all: {
      __typename: 'LocationHazardCollection';
      items: Array<{
        __typename: 'LocationHazard';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        locationId: string;
        hazard: string;
        companyId: string;
        effectiveDate: Date | number | string | null;
        expirationDate: Date | number | string | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'LocationHazardCollectionMetadata'; total: number };
    };
  };
};

export type LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsQuery = {
  __typename: 'Query';
  landingZoneOutOfServiceReasons: {
    __typename: 'LandingZoneOutOfServiceReasonQueries';
    all: {
      __typename: 'LandingZoneOutOfServiceReasonCollection';
      items: Array<{
        __typename: 'LandingZoneOutOfServiceReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
    };
  };
};

export type LandingZoneListPageComponent_FetchAllLandingZonesQueryVariables = Exact<{
  filter: InputMaybe<LocationQueryFilter>;
}>;

export type LandingZoneListPageComponent_FetchAllLandingZonesQuery = {
  __typename: 'Query';
  locations: {
    __typename: 'LocationQueries';
    all: {
      __typename: 'LocationCollection';
      items: Array<{
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'LocationCollectionMetadata'; total: number };
    };
  };
};

export type MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesQueryVariables =
  Exact<{
    filter: InputMaybe<MaintenanceFacilityFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesQuery = {
  __typename: 'Query';
  maintenanceFacilities: {
    __typename: 'MaintenanceFacilityQueries';
    all: {
      __typename: 'MaintenanceFacilityCollection';
      items: Array<{
        __typename: 'MaintenanceFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'MaintenanceFacilityCollectionMetadata'; total: number };
    };
  };
};

export type MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdQuery = {
  __typename: 'Query';
  maintenanceFacilities: {
    __typename: 'MaintenanceFacilityQueries';
    byId: {
      __typename: 'MaintenanceFacility';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      lastUpdatedBy: {
        __typename: 'Person';
        id: string;
        firstName: string;
        lastName: string;
      } | null;
    } | null;
  };
};

export type MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesQueryVariables = Exact<{
  filter: InputMaybe<MedicalFacilityFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    all: {
      __typename: 'MedicalFacilityCollection';
      items: Array<{
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      }>;
      meta: { __typename: 'MedicalFacilityCollectionMetadata'; total: number };
    };
  };
};

export type MedicaFacilityContactListComponent_FetchMedicalFacilityContactsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MedicaFacilityContactListComponent_FetchMedicalFacilityContactsQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      contacts: Array<{
        __typename: 'MedicalFacilityContact';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        medicalFacilityId: string;
        emailAddress: string | null;
        primaryPhoneNumber: string | null;
        secondaryPhoneNumber: string | null;
        smsPhoneNumber: string | null;
        faxPhoneNumber: string | null;
        notes: string | null;
      }>;
    } | null;
  };
};

export type MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      npi: string;
      providerNumber: string | null;
      sourceSystemId: number | null;
      masterDataSetId: number | null;
      firmType: string | null;
      hospitalType: string | null;
      hospitalSpecialization: string | null;
      website: string | null;
      defaultLandingZoneId: string | null;
      defaultFixedWingLandingZoneId: string | null;
      notes: string | null;
      stateSourceSystemId: string | null;
      nemsisCode: string | null;
      stateFacilityName: string | null;
      status: MedicalFacilityStatus | null;
      archiveNotes: string | null;
      archiveClearedDate: Date | number | string | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultFixedWingLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      communicationCenterCustomIdentifiers: Array<{
        __typename: 'IdNameListItem';
        id: string;
        name: string;
      } | null> | null;
    } | null;
  };
};

export type MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<EntityCapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesQuery = {
  __typename: 'Query';
  entityCapabilities: {
    __typename: 'EntityCapabilityQueries';
    all: {
      __typename: 'EntityCapabilityCollection';
      items: Array<{
        __typename: 'EntityCapability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        capabilityId: string;
        entityId: string;
        entityType: EntityType;
        capability: {
          __typename: 'Capability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          description: string;
          entityType: EntityType;
        };
      }>;
      meta: { __typename: 'EntityCapabilityCollectionMetadata'; total: number };
    };
  };
};

export type MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      npi: string;
      providerNumber: string | null;
      sourceSystemId: number | null;
      masterDataSetId: number | null;
      firmType: string | null;
      hospitalType: string | null;
      hospitalSpecialization: string | null;
      website: string | null;
      defaultLandingZoneId: string | null;
      defaultFixedWingLandingZoneId: string | null;
      notes: string | null;
      stateSourceSystemId: string | null;
      nemsisCode: string | null;
      stateFacilityName: string | null;
      status: MedicalFacilityStatus | null;
      archiveNotes: string | null;
      archiveClearedDate: Date | number | string | null;
      locationId: string | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      defaultFixedWingLandingZone: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      communicationCenterCustomIdentifiers: Array<{
        __typename: 'IdNameListItem';
        id: string;
        name: string;
      } | null> | null;
    } | null;
  };
};

export type MedicalFacilityFormComponent_FetchAllCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<CapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type MedicalFacilityFormComponent_FetchAllCapabilitiesQuery = {
  __typename: 'Query';
  capabilities: {
    __typename: 'CapabilityQueries';
    all: {
      __typename: 'CapabilityCollection';
      items: Array<{
        __typename: 'Capability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        description: string;
        entityType: EntityType;
      }>;
      meta: { __typename: 'CapabilityCollectionMetadata'; total: number };
    };
  };
};

export type MedicalFacilityFormComponent_FetchAllEntityCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<EntityCapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type MedicalFacilityFormComponent_FetchAllEntityCapabilitiesQuery = {
  __typename: 'Query';
  entityCapabilities: {
    __typename: 'EntityCapabilityQueries';
    all: {
      __typename: 'EntityCapabilityCollection';
      items: Array<{
        __typename: 'EntityCapability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        capabilityId: string;
        entityId: string;
        entityType: EntityType;
        capability: {
          __typename: 'Capability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          description: string;
          entityType: EntityType;
        };
      }>;
      meta: { __typename: 'EntityCapabilityCollectionMetadata'; total: number };
    };
  };
};

export type MedicalFacilityFormComponent_FetchMedicalFacilitiesQueryVariables = Exact<{
  filter: InputMaybe<MedicalFacilityFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type MedicalFacilityFormComponent_FetchMedicalFacilitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    all: {
      __typename: 'MedicalFacilityCollection';
      items: Array<{
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      }>;
      meta: { __typename: 'MedicalFacilityCollectionMetadata'; total: number };
    };
  };
};

export type MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      abbreviation: string;
      npi: string;
      providerNumber: string | null;
      sourceSystemId: number | null;
      masterDataSetId: number | null;
      firmType: string | null;
      hospitalType: string | null;
      hospitalSpecialization: string | null;
      website: string | null;
      defaultLandingZoneId: string | null;
      defaultFixedWingLandingZoneId: string | null;
      notes: string | null;
      stateSourceSystemId: string | null;
      nemsisCode: string | null;
      stateFacilityName: string | null;
      status: MedicalFacilityStatus | null;
      archiveNotes: string | null;
      archiveClearedDate: Date | number | string | null;
      locationId: string | null;
      contacts: Array<{ __typename: 'MedicalFacilityContact'; id: string }>;
      location: {
        __typename: 'Location';
        locationHazards: Array<{ __typename: 'LocationHazard'; id: string }>;
      } | null;
      activationRules: Array<{ __typename: 'ActivationRule'; id: string } | null> | null;
      communicationCenterCustomIdentifiers: Array<{
        __typename: 'IdNameListItem';
        id: string;
        name: string;
      } | null> | null;
    } | null;
  };
};

export type MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      associatedPhysicians: Array<{
        __typename: 'MedicalFacilityPhysician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        physicianId: string;
        medicalFacilityId: string;
        physician: {
          __typename: 'Physician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
    } | null;
  };
};

export type MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    byId: {
      __typename: 'MedicalFacility';
      units: Array<{
        __typename: 'MedicalFacilityUnit';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        medicalFacilityId: string;
        phoneNumber: string | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
    } | null;
  };
};

export type NonReferralReasonListPageComponent_FetchAllNonReferralReasonsQueryVariables = Exact<{
  filter: InputMaybe<NonReferralReasonFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type NonReferralReasonListPageComponent_FetchAllNonReferralReasonsQuery = {
  __typename: 'Query';
  nonReferralReasons: {
    __typename: 'NonReferralReasonQueries';
    all: {
      __typename: 'NonReferralReasonCollection';
      items: Array<{
        __typename: 'NonReferralReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        associatedCancellationReasonId: string | null;
        associatedCancellationSecondaryReasonId: string | null;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'NonReferralReasonCollectionMetadata'; total: number };
    };
  };
};

export type NotificationTemplateListPageComponent_FetchAllNotificationTemplatesQueryVariables =
  Exact<{
    filter: InputMaybe<NotificationTemplateFilter>;
    first: InputMaybe<Scalars['Int']>;
    skip: InputMaybe<Scalars['Int']>;
  }>;

export type NotificationTemplateListPageComponent_FetchAllNotificationTemplatesQuery = {
  __typename: 'Query';
  notificationTemplates: {
    __typename: 'NotificationTemplateQueries';
    all: {
      __typename: 'NotificationTemplateCollection';
      items: Array<{
        __typename: 'NotificationTemplate';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        contextType: EntityType;
        bodyTemplate: string;
        canBeManualTrigger: boolean;
        companyId: string | null;
        triggerType: NotificationTriggerType | null;
        triggerValue: string | null;
        activationRuleId: string | null;
        recipientTypes: Array<NotificationRecipientType | null> | null;
        subjectTemplate: string | null;
        requiresApproval: boolean | null;
        groupTypes: Array<NotificationGroupType | null> | null;
        createdById: string | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        } | null;
        activationRule: {
          __typename: 'ActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string | null;
          isShared: boolean | null;
          companyId: string | null;
          regionId: string | null;
          baseId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          specialtyTeamId: string | null;
          vehicleTypes: Array<VehicleType | null> | null;
          medicalFacilityId: string | null;
          locationId: string | null;
          operationTypes: Array<OperationType | null> | null;
          timestampTypeId: string | null;
          systemTimestampType: SystemTimestampType | null;
          outOfServiceReasonId: string | null;
          paipReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
          ageInMinutes: number | null;
          waypointTypes: Array<WaypointType | null> | null;
          missionRoleTypes: Array<MissionRoleType | null> | null;
          medicalFacility: {
            __typename: 'MedicalFacility';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            npi: string;
            providerNumber: string | null;
            sourceSystemId: number | null;
            masterDataSetId: number | null;
            firmType: string | null;
            hospitalType: string | null;
            hospitalSpecialization: string | null;
            website: string | null;
            defaultLandingZoneId: string | null;
            defaultFixedWingLandingZoneId: string | null;
            notes: string | null;
            stateSourceSystemId: string | null;
            nemsisCode: string | null;
            stateFacilityName: string | null;
            status: MedicalFacilityStatus | null;
            archiveNotes: string | null;
            archiveClearedDate: Date | number | string | null;
            locationId: string | null;
            communicationCenterCustomIdentifiers: Array<{
              __typename: 'IdNameListItem';
              id: string;
              name: string;
            } | null> | null;
          } | null;
          location: {
            __typename: 'Location';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            locationType: LocationType;
            isPreferred: boolean;
            timezoneCd: string | null;
            isRotorWingLz: boolean | null;
            notes: string | null;
            sourceSystemId: string | null;
            closedDate: Date | number | string | null;
            duplicateOfId: string | null;
            isLandingZoneOutOfService: boolean | null;
            landingZoneOutOfServiceNotes: string | null;
            landingZoneOutOfServiceExpirationDate: Date | number | string | null;
            landingZoneOutOfServiceReasonId: string | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            };
          } | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      meta: { __typename: 'NotificationTemplateCollectionMetadata'; total: number };
    };
  };
};

export type OfferAlgorithmFormComponent_FetchAgencyLocationsQueryVariables = Exact<{
  filter: InputMaybe<AgencyLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OfferAlgorithmFormComponent_FetchAgencyLocationsQuery = {
  __typename: 'Query';
  agencyLocations: {
    __typename: 'AgencyLocationQueries';
    all: {
      __typename: 'AgencyLocationCollection';
      items: Array<{
        __typename: 'AgencyLocation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        isInTransportNet: boolean;
        agencyId: string;
        emailAddress: string | null;
        primaryPhoneNumber: string | null;
        secondaryPhoneNumber: string | null;
        smsPhoneNumber: string | null;
        faxPhoneNumber: string | null;
        notes: string | null;
        vehicleType: VehicleType | null;
        estimatedDepartureTimeInMinutes: number | null;
        locationId: string | null;
      }>;
      meta: { __typename: 'AgencyLocationCollectionMetadata'; total: number };
    };
  };
};

export type OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsQueryVariables = Exact<{
  filter: InputMaybe<OfferAlgorithmFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsQuery = {
  __typename: 'Query';
  offerAlgorithms: {
    __typename: 'OfferAlgorithmQueries';
    all: {
      __typename: 'OfferAlgorithmCollection';
      items: Array<{
        __typename: 'OfferAlgorithm';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        oneCallAgreement: boolean;
        rank: number;
        transportOfferAlgorithm: TransportOfferAlgorithm;
        distanceCalculation: DistanceCalculation;
        activationRuleId: string;
        companyId: string;
        isEnabled: boolean;
        minimumFlightRule: FlightRule | null;
        createdById: string | null;
        activationRule: {
          __typename: 'ActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string | null;
          isShared: boolean | null;
          companyId: string | null;
          regionId: string | null;
          baseId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          specialtyTeamId: string | null;
          vehicleTypes: Array<VehicleType | null> | null;
          medicalFacilityId: string | null;
          locationId: string | null;
          operationTypes: Array<OperationType | null> | null;
          timestampTypeId: string | null;
          systemTimestampType: SystemTimestampType | null;
          outOfServiceReasonId: string | null;
          paipReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
          ageInMinutes: number | null;
          waypointTypes: Array<WaypointType | null> | null;
          missionRoleTypes: Array<MissionRoleType | null> | null;
          medicalFacility: {
            __typename: 'MedicalFacility';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            npi: string;
            providerNumber: string | null;
            sourceSystemId: number | null;
            masterDataSetId: number | null;
            firmType: string | null;
            hospitalType: string | null;
            hospitalSpecialization: string | null;
            website: string | null;
            defaultLandingZoneId: string | null;
            defaultFixedWingLandingZoneId: string | null;
            notes: string | null;
            stateSourceSystemId: string | null;
            nemsisCode: string | null;
            stateFacilityName: string | null;
            status: MedicalFacilityStatus | null;
            archiveNotes: string | null;
            archiveClearedDate: Date | number | string | null;
            locationId: string | null;
            communicationCenterCustomIdentifiers: Array<{
              __typename: 'IdNameListItem';
              id: string;
              name: string;
            } | null> | null;
          } | null;
          location: {
            __typename: 'Location';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            locationType: LocationType;
            isPreferred: boolean;
            timezoneCd: string | null;
            isRotorWingLz: boolean | null;
            notes: string | null;
            sourceSystemId: string | null;
            closedDate: Date | number | string | null;
            duplicateOfId: string | null;
            isLandingZoneOutOfService: boolean | null;
            landingZoneOutOfServiceNotes: string | null;
            landingZoneOutOfServiceExpirationDate: Date | number | string | null;
            landingZoneOutOfServiceReasonId: string | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            };
          } | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
        preferredUnits: Array<{
          __typename: 'PreferredUnit';
          id: string;
          unitAbbreviation: string;
          rank: number;
          type: PreferredUnitType;
        }>;
        companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'OfferAlgorithmCollectionMetadata'; total: number };
    };
  };
};

export type OktaDirectoryListComponent_FetchOktaUsersQueryVariables = Exact<{
  filter: InputMaybe<OktaUserFilter>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type OktaDirectoryListComponent_FetchOktaUsersQuery = {
  __typename: 'Query';
  okta: {
    __typename: 'OktaQueries';
    allUsers: {
      __typename: 'OktaUserCollection';
      items: Array<{
        __typename: 'OktaUser';
        id: string;
        profile: {
          __typename: 'OktaUserProfile';
          login: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeNumber: string | null;
        };
      }>;
    };
  };
};

export type OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdQueryVariables = Exact<{
  idOrLogin: Scalars['ID'];
}>;

export type OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdQuery = {
  __typename: 'Query';
  okta: {
    __typename: 'OktaQueries';
    user: {
      __typename: 'OktaUser';
      id: string;
      status: string;
      lastUpdated: Date | number | string;
      created: Date | number | string;
      profile: {
        __typename: 'OktaUserProfile';
        login: string;
        firstName: string;
        lastName: string;
        email: string;
        employeeNumber: string | null;
      };
    } | null;
  };
};

export type ActivationRuleManageDialog_GetActivationRuleIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ActivationRuleManageDialog_GetActivationRuleIdQuery = {
  __typename: 'Query';
  activationRules: {
    __typename: 'ActivationRuleQueries';
    byId: {
      __typename: 'ActivationRule';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string | null;
      isShared: boolean | null;
      companyId: string | null;
      regionId: string | null;
      baseId: string | null;
      unitId: string | null;
      vehicleId: string | null;
      specialtyTeamId: string | null;
      vehicleTypes: Array<VehicleType | null> | null;
      medicalFacilityId: string | null;
      locationId: string | null;
      operationTypes: Array<OperationType | null> | null;
      timestampTypeId: string | null;
      systemTimestampType: SystemTimestampType | null;
      outOfServiceReasonId: string | null;
      paipReasonId: string | null;
      outOfServiceType: OutOfServiceType | null;
      automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
      ageInMinutes: number | null;
      waypointTypes: Array<WaypointType | null> | null;
      missionRoleTypes: Array<MissionRoleType | null> | null;
      medicalFacility: {
        __typename: 'MedicalFacility';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        npi: string;
        providerNumber: string | null;
        sourceSystemId: number | null;
        masterDataSetId: number | null;
        firmType: string | null;
        hospitalType: string | null;
        hospitalSpecialization: string | null;
        website: string | null;
        defaultLandingZoneId: string | null;
        defaultFixedWingLandingZoneId: string | null;
        notes: string | null;
        stateSourceSystemId: string | null;
        nemsisCode: string | null;
        stateFacilityName: string | null;
        status: MedicalFacilityStatus | null;
        archiveNotes: string | null;
        archiveClearedDate: Date | number | string | null;
        locationId: string | null;
        requesters: Array<{ __typename: 'Requester'; id: string } | null> | null;
        requests: Array<{ __typename: 'RequestLocation'; id: string } | null> | null;
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
      } | null;
      location: {
        __typename: 'Location';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      } | null;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
      declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type CommunicationCenterRegionDialog_FetchUnitsByRegionIdQueryVariables = Exact<{
  regionId: InputMaybe<Scalars['ID']>;
  includeHidden: InputMaybe<Scalars['Boolean']>;
}>;

export type CommunicationCenterRegionDialog_FetchUnitsByRegionIdQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    all: {
      __typename: 'UnitCollection';
      items: Array<{
        __typename: 'Unit';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        baseId: string;
        regionId: string;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        integrations: Array<IntegrationSystem>;
        isCrewAvailable: boolean;
        updatePhoneNumbersFromExternal: boolean;
        companyId: string;
        isAdministrative: boolean | null;
        vehicleId: string | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        oemPlacardNumber: string | null;
        primaryOutOfServiceEventId: string | null;
        emSystemResourceId: string | null;
        onBaseETAInMinutes: number | null;
        crewSourcedFromUnitId: string | null;
        completeFlightInstanceId: string | null;
        parentUnitId: string | null;
        crewSourcedToUnits: Array<{
          __typename: 'CrewSourcedUnit';
          id: string;
          unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
        } | null> | null;
      }>;
    };
  };
};

export type CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersQueryVariables =
  Exact<{
    filter: InputMaybe<CommunicationCenterFilter>;
    first: InputMaybe<Scalars['Int']>;
    skip: InputMaybe<Scalars['Int']>;
  }>;

export type CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
      meta: { __typename: 'CommunicationCenterCollectionMetadata'; total: number };
    };
  };
};

export type ControlZoneBaseForm_GetBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ControlZoneBaseForm_GetBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        company: { __typename: 'Company'; companyCode: string };
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type ControlZoneVehicleForm_GetVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ControlZoneVehicleForm_GetVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
        company: { __typename: 'Company'; companyCode: string };
      }>;
      meta: { __typename: 'VehicleCollectionMetadata'; total: number };
    };
  };
};

export type HazardEditDialogComponent_FetchLocationHazardAttachmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type HazardEditDialogComponent_FetchLocationHazardAttachmentsQuery = {
  __typename: 'Query';
  locationHazards: {
    __typename: 'LocationHazardQueries';
    byId: {
      __typename: 'LocationHazard';
      locationHazardAttachments: Array<{
        __typename: 'LocationHazardAttachment';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        locationHazardId: string;
        fileName: string;
        companyId: string;
        fileSizeInBytes: number | null;
        contentType: string | null;
      }>;
    } | null;
  };
};

export type MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansQueryVariables =
  Exact<{
    filter: InputMaybe<PhysicianFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansQuery = {
  __typename: 'Query';
  physicians: {
    __typename: 'PhysicianQueries';
    all: {
      __typename: 'PhysicianCollection';
      items: Array<{
        __typename: 'Physician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        firstName: string;
        lastName: string;
      }>;
      meta: { __typename: 'PhysicianCollectionMetadata'; total: number };
    };
  };
};

export type NotificationGroupListDialogComponent_FetchAllNotificationGroupsQueryVariables = Exact<{
  filter: InputMaybe<NotificationGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NotificationGroupListDialogComponent_FetchAllNotificationGroupsQuery = {
  __typename: 'Query';
  notificationGroups: {
    __typename: 'NotificationGroupQueries';
    all: {
      __typename: 'NotificationGroupCollection';
      items: Array<{
        __typename: 'NotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        unitId: string | null;
        regionId: string | null;
        type: NotificationGroupType | null;
        types: Array<NotificationGroupType | null> | null;
        isEmailNotificationPreferred: boolean | null;
      }>;
      meta: { __typename: 'NotificationGroupCollectionMetadata'; total: number };
    };
  };
};

export type NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersQueryVariables =
  Exact<{
    filter: InputMaybe<NotificationGroupMemberFilter>;
    first: InputMaybe<Scalars['Int']>;
    skip: InputMaybe<Scalars['Int']>;
  }>;

export type NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersQuery = {
  __typename: 'Query';
  notificationGroupMembers: {
    __typename: 'NotificationGroupMemberQueries';
    all: {
      __typename: 'NotificationGroupMemberCollection';
      items: Array<{
        __typename: 'NotificationGroupMember';
        id: string;
        notificationGroupId: string;
        name: string;
        userId: string | null;
        notificationAddress: string | null;
        user: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          isAviationSupervisor: boolean;
          notificationAddress: string | null;
        } | null;
      }>;
      meta: { __typename: 'NotificationGroupMemberCollectionMetadata'; total: number };
    };
  };
};

export type PersonBaseMedicalControlContactFormComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type PersonBaseMedicalControlContactFormComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{ __typename: 'Base'; name: string; id: string }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsQueryVariables = Exact<{
  filter: InputMaybe<NotificationGroupFilter>;
}>;

export type UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsQuery = {
  __typename: 'Query';
  notificationGroups: {
    __typename: 'NotificationGroupQueries';
    all: {
      __typename: 'NotificationGroupCollection';
      items: Array<{
        __typename: 'NotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        unitId: string | null;
        regionId: string | null;
        type: NotificationGroupType | null;
        types: Array<NotificationGroupType | null> | null;
        isEmailNotificationPreferred: boolean | null;
      }>;
      meta: { __typename: 'NotificationGroupCollectionMetadata'; total: number };
    };
  };
};

export type UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsQueryVariables =
  Exact<{
    personId: Scalars['ID'];
  }>;

export type UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsQuery = {
  __typename: 'Query';
  notificationGroups: {
    __typename: 'NotificationGroupQueries';
    byPerson: Array<{ __typename: 'NotificationGroup'; id: string }>;
  };
};

export type VehicleMaintenanceFormComponent_FetchAllNextDueTypesQueryVariables = Exact<{
  filter: InputMaybe<NextDueTypeFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type VehicleMaintenanceFormComponent_FetchAllNextDueTypesQuery = {
  __typename: 'Query';
  nextDueTypes: {
    __typename: 'NextDueTypeQueries';
    all: {
      __typename: 'NextDueTypeCollection';
      items: Array<{ __typename: 'NextDueType'; id: string; name: string; dataType: string }>;
    };
  };
};

export type OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsQuery = {
  __typename: 'Query';
  outOfServiceReasons: {
    __typename: 'OutOfServiceReasonQueries';
    all: {
      __typename: 'OutOfServiceReasonCollection';
      items: Array<{
        __typename: 'OutOfServiceReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        controllable: boolean;
        isVehicleReason: boolean;
        description: string | null;
      }>;
      meta: { __typename: 'OutOfServiceReasonCollectionMetadata'; total: number };
    };
  };
};

export type OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdQuery =
  {
    __typename: 'Query';
    outOfServiceReasons: {
      __typename: 'OutOfServiceReasonQueries';
      byId: {
        __typename: 'OutOfServiceReason';
        outOfServiceSecondaryReasons: Array<{
          __typename: 'OutOfServiceSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          outOfServiceReasonId: string;
        }>;
      } | null;
    };
  };

export type PaipReasonListPageComponent_FetchAllPaipReasonsQueryVariables = Exact<{
  filter: InputMaybe<PaipReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type PaipReasonListPageComponent_FetchAllPaipReasonsQuery = {
  __typename: 'Query';
  paipReasons: {
    __typename: 'PaipReasonQueries';
    all: {
      __typename: 'PaipReasonCollection';
      items: Array<{
        __typename: 'PaipReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        outOfServiceReasonId: string | null;
        outOfServiceReason: {
          __typename: 'OutOfServiceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          controllable: boolean;
          isVehicleReason: boolean;
          description: string | null;
        } | null;
      }>;
      meta: { __typename: 'PaipReasonCollectionMetadata'; total: number };
    };
  };
};

export type PhysicianListPageComponent_FetchAllPhysiciansQueryVariables = Exact<{
  filter: InputMaybe<PhysicianFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type PhysicianListPageComponent_FetchAllPhysiciansQuery = {
  __typename: 'Query';
  physicians: {
    __typename: 'PhysicianQueries';
    all: {
      __typename: 'PhysicianCollection';
      items: Array<{
        __typename: 'Physician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        firstName: string;
        lastName: string;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'PhysicianCollectionMetadata'; total: number };
    };
  };
};

export type PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesQuery = {
  __typename: 'Query';
  physicians: {
    __typename: 'PhysicianQueries';
    byId: {
      __typename: 'Physician';
      medicalFacilities: Array<{
        __typename: 'MedicalFacilityPhysician';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        physicianId: string;
        medicalFacilityId: string;
        medicalFacility: {
          __typename: 'MedicalFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          npi: string;
          providerNumber: string | null;
          sourceSystemId: number | null;
          masterDataSetId: number | null;
          firmType: string | null;
          hospitalType: string | null;
          hospitalSpecialization: string | null;
          website: string | null;
          defaultLandingZoneId: string | null;
          defaultFixedWingLandingZoneId: string | null;
          notes: string | null;
          stateSourceSystemId: string | null;
          nemsisCode: string | null;
          stateFacilityName: string | null;
          status: MedicalFacilityStatus | null;
          archiveNotes: string | null;
          archiveClearedDate: Date | number | string | null;
          locationId: string | null;
          location: {
            __typename: 'Location';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            locationType: LocationType;
            isPreferred: boolean;
            timezoneCd: string | null;
            isRotorWingLz: boolean | null;
            notes: string | null;
            sourceSystemId: string | null;
            closedDate: Date | number | string | null;
            duplicateOfId: string | null;
            isLandingZoneOutOfService: boolean | null;
            landingZoneOutOfServiceNotes: string | null;
            landingZoneOutOfServiceExpirationDate: Date | number | string | null;
            landingZoneOutOfServiceReasonId: string | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            };
          } | null;
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
    } | null;
  };
};

export type QarReasonListPageComponent_FetchAllQarReasonsQueryVariables = Exact<{
  filter: InputMaybe<OutOfServiceQARReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type QarReasonListPageComponent_FetchAllQarReasonsQuery = {
  __typename: 'Query';
  outOfServiceQARReasons: {
    __typename: 'OutOfServiceQARReasonQueries';
    all: {
      __typename: 'OutOfServiceQARReasonCollection';
      items: Array<{
        __typename: 'OutOfServiceQARReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
      meta: { __typename: 'OutOfServiceQARReasonCollectionMetadata'; total: number };
    };
  };
};

export type QuestionnaireDetailPageComponent_FetchQuestionnaireByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QuestionnaireDetailPageComponent_FetchQuestionnaireByIdQuery = {
  __typename: 'Query';
  questionnaires: {
    __typename: 'QuestionnaireQueries';
    byId: {
      __typename: 'Questionnaire';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      companyId: string;
      type: QuestionnaireType;
      communicationCenterId: string | null;
      questionnaireSections: Array<{
        __typename: 'QuestionnaireSection';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        questionnaireId: string;
        sequence: number;
        questionnaireSectionQuestions: Array<{
          __typename: 'QuestionnaireSectionQuestion';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireSectionId: string;
          questionId: string;
          responsibleRole: UserRole;
          sequence: number;
          isDisabled: boolean;
          activationRuleId: string | null;
          activityType: string | null;
          question: {
            __typename: 'Question';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            question: string;
            questionType: QuestionType;
            dataType: QuestionDataType | null;
            choices: Array<{
              __typename: 'QuestionChoice';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              label: string;
              value: string;
              questionId: string;
            }>;
          };
          activationRule: {
            __typename: 'ActivationRule';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string | null;
            isShared: boolean | null;
            companyId: string | null;
            regionId: string | null;
            baseId: string | null;
            unitId: string | null;
            vehicleId: string | null;
            specialtyTeamId: string | null;
            vehicleTypes: Array<VehicleType | null> | null;
            medicalFacilityId: string | null;
            locationId: string | null;
            operationTypes: Array<OperationType | null> | null;
            timestampTypeId: string | null;
            systemTimestampType: SystemTimestampType | null;
            outOfServiceReasonId: string | null;
            paipReasonId: string | null;
            outOfServiceType: OutOfServiceType | null;
            automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
            ageInMinutes: number | null;
            waypointTypes: Array<WaypointType | null> | null;
            missionRoleTypes: Array<MissionRoleType | null> | null;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
            declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
            communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
            companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          } | null;
          explanationRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          reviewRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }>;
      }>;
    } | null;
  };
};

export type QuestionnaireFormComponent_FetchAllCommunicationCentersQueryVariables = Exact<{
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type QuestionnaireFormComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
      }>;
      meta: { __typename: 'CommunicationCenterCollectionMetadata'; total: number };
    };
  };
};

export type QuestionnaireListPageComponent_FetchQuestionnairesQueryVariables = Exact<{
  filter: InputMaybe<QuestionnaireFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type QuestionnaireListPageComponent_FetchQuestionnairesQuery = {
  __typename: 'Query';
  questionnaires: {
    __typename: 'QuestionnaireQueries';
    all: {
      __typename: 'QuestionnaireCollection';
      items: Array<{
        __typename: 'Questionnaire';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        type: QuestionnaireType;
        communicationCenterId: string | null;
      }>;
      meta: { __typename: 'QuestionnaireCollectionMetadata'; total: number };
    };
  };
};

export type QuestionnaireManagePageComponent_FetchQuestionnaireByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QuestionnaireManagePageComponent_FetchQuestionnaireByIdQuery = {
  __typename: 'Query';
  questionnaires: {
    __typename: 'QuestionnaireQueries';
    byId: {
      __typename: 'Questionnaire';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      companyId: string;
      type: QuestionnaireType;
      communicationCenterId: string | null;
      questionnaireSections: Array<{
        __typename: 'QuestionnaireSection';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        questionnaireId: string;
        sequence: number;
        questionnaireSectionQuestions: Array<{
          __typename: 'QuestionnaireSectionQuestion';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireSectionId: string;
          questionId: string;
          responsibleRole: UserRole;
          sequence: number;
          isDisabled: boolean;
          activationRuleId: string | null;
          activityType: string | null;
          explanationRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          reviewRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }>;
      }>;
    } | null;
  };
};

export type QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdQuery = {
  __typename: 'Query';
  activationRules: {
    __typename: 'ActivationRuleQueries';
    byId: {
      __typename: 'ActivationRule';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string | null;
      isShared: boolean | null;
      companyId: string | null;
      regionId: string | null;
      baseId: string | null;
      unitId: string | null;
      vehicleId: string | null;
      specialtyTeamId: string | null;
      vehicleTypes: Array<VehicleType | null> | null;
      medicalFacilityId: string | null;
      locationId: string | null;
      operationTypes: Array<OperationType | null> | null;
      timestampTypeId: string | null;
      systemTimestampType: SystemTimestampType | null;
      outOfServiceReasonId: string | null;
      paipReasonId: string | null;
      outOfServiceType: OutOfServiceType | null;
      automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
      ageInMinutes: number | null;
      waypointTypes: Array<WaypointType | null> | null;
      missionRoleTypes: Array<MissionRoleType | null> | null;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
      declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type QuestionnaireContextResolverService_FetchQuestionsQueryVariables = Exact<{
  filter: InputMaybe<QuestionFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type QuestionnaireContextResolverService_FetchQuestionsQuery = {
  __typename: 'Query';
  questions: {
    __typename: 'QuestionQueries';
    all: {
      __typename: 'QuestionCollection';
      items: Array<{
        __typename: 'Question';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        question: string;
        questionType: QuestionType;
        dataType: QuestionDataType | null;
        choices: Array<{
          __typename: 'QuestionChoice';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          label: string;
          value: string;
          questionId: string;
        }>;
      }>;
    };
  };
};

export type QuestionDetailPageComponent_FetchQuestionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QuestionDetailPageComponent_FetchQuestionByIdQuery = {
  __typename: 'Query';
  questions: {
    __typename: 'QuestionQueries';
    byId: {
      __typename: 'Question';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      question: string;
      questionType: QuestionType;
      dataType: QuestionDataType | null;
      choices: Array<{
        __typename: 'QuestionChoice';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        label: string;
        value: string;
        questionId: string;
      }>;
    } | null;
  };
};

export type QuestionListPageComponent_FetchQuestionsQueryVariables = Exact<{
  filter: InputMaybe<QuestionFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type QuestionListPageComponent_FetchQuestionsQuery = {
  __typename: 'Query';
  questions: {
    __typename: 'QuestionQueries';
    all: {
      __typename: 'QuestionCollection';
      items: Array<{
        __typename: 'Question';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        question: string;
        questionType: QuestionType;
        dataType: QuestionDataType | null;
        choices: Array<{
          __typename: 'QuestionChoice';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          label: string;
          value: string;
          questionId: string;
        }>;
      }>;
      meta: { __typename: 'QuestionCollectionMetadata'; total: number };
    };
  };
};

export type QuestionManagePageComponent_FetchQuestionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QuestionManagePageComponent_FetchQuestionByIdQuery = {
  __typename: 'Query';
  questions: {
    __typename: 'QuestionQueries';
    byId: {
      __typename: 'Question';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      question: string;
      questionType: QuestionType;
      dataType: QuestionDataType | null;
      choices: Array<{
        __typename: 'QuestionChoice';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        label: string;
        value: string;
        questionId: string;
      }>;
    } | null;
  };
};

export type TimelineDetailPageComponent_FetchTimelineByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type TimelineDetailPageComponent_FetchTimelineByIdQuery = {
  __typename: 'Query';
  timelines: {
    __typename: 'TimelineQueries';
    byId: {
      __typename: 'Timeline';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      companyId: string | null;
      activationRuleId: string | null;
      timelineType: TimelineTypes | null;
      company: {
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      } | null;
      activationRule: {
        __typename: 'ActivationRule';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string | null;
        isShared: boolean | null;
        companyId: string | null;
        regionId: string | null;
        baseId: string | null;
        unitId: string | null;
        vehicleId: string | null;
        specialtyTeamId: string | null;
        vehicleTypes: Array<VehicleType | null> | null;
        medicalFacilityId: string | null;
        locationId: string | null;
        operationTypes: Array<OperationType | null> | null;
        timestampTypeId: string | null;
        systemTimestampType: SystemTimestampType | null;
        outOfServiceReasonId: string | null;
        paipReasonId: string | null;
        outOfServiceType: OutOfServiceType | null;
        automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
        ageInMinutes: number | null;
        waypointTypes: Array<WaypointType | null> | null;
        missionRoleTypes: Array<MissionRoleType | null> | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      } | null;
      items: Array<{
        __typename: 'TimelineItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        timestampTypeId: string;
        required: boolean;
        sequence: number;
        timelineId: string;
        timestampType: {
          __typename: 'TimestampType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          order: number;
          systemTimestampType: SystemTimestampType | null;
          description: string | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
    } | null;
  };
};

export type TimelineFormComponent_FetchActivationRuleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type TimelineFormComponent_FetchActivationRuleByIdQuery = {
  __typename: 'Query';
  activationRules: {
    __typename: 'ActivationRuleQueries';
    byId: {
      __typename: 'ActivationRule';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string | null;
      isShared: boolean | null;
      companyId: string | null;
      regionId: string | null;
      baseId: string | null;
      unitId: string | null;
      vehicleId: string | null;
      specialtyTeamId: string | null;
      vehicleTypes: Array<VehicleType | null> | null;
      medicalFacilityId: string | null;
      locationId: string | null;
      operationTypes: Array<OperationType | null> | null;
      timestampTypeId: string | null;
      systemTimestampType: SystemTimestampType | null;
      outOfServiceReasonId: string | null;
      paipReasonId: string | null;
      outOfServiceType: OutOfServiceType | null;
      automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
      ageInMinutes: number | null;
      waypointTypes: Array<WaypointType | null> | null;
      missionRoleTypes: Array<MissionRoleType | null> | null;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
      declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type TimelineListPageComponent_FetchTimelinesQueryVariables = Exact<{
  filter: InputMaybe<TimelineFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type TimelineListPageComponent_FetchTimelinesQuery = {
  __typename: 'Query';
  timelines: {
    __typename: 'TimelineQueries';
    all: {
      __typename: 'TimelineCollection';
      items: Array<{
        __typename: 'Timeline';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string | null;
        activationRuleId: string | null;
        timelineType: TimelineTypes | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        } | null;
        activationRule: {
          __typename: 'ActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string | null;
          isShared: boolean | null;
          companyId: string | null;
          regionId: string | null;
          baseId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          specialtyTeamId: string | null;
          vehicleTypes: Array<VehicleType | null> | null;
          medicalFacilityId: string | null;
          locationId: string | null;
          operationTypes: Array<OperationType | null> | null;
          timestampTypeId: string | null;
          systemTimestampType: SystemTimestampType | null;
          outOfServiceReasonId: string | null;
          paipReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
          ageInMinutes: number | null;
          waypointTypes: Array<WaypointType | null> | null;
          missionRoleTypes: Array<MissionRoleType | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
      meta: { __typename: 'TimelineCollectionMetadata'; total: number };
    };
  };
};

export type TimelineManagePageComponent_FetchTimelineByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type TimelineManagePageComponent_FetchTimelineByIdQuery = {
  __typename: 'Query';
  timelines: {
    __typename: 'TimelineQueries';
    byId: {
      __typename: 'Timeline';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      name: string;
      companyId: string | null;
      activationRuleId: string | null;
      timelineType: TimelineTypes | null;
      items: Array<{
        __typename: 'TimelineItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        timestampTypeId: string;
        required: boolean;
        sequence: number;
        timelineId: string;
        timestampType: {
          __typename: 'TimestampType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          order: number;
          systemTimestampType: SystemTimestampType | null;
          description: string | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
    } | null;
  };
};

export type TimelinesContextResolverService_FetchTimelinesContextQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TimelinesContextResolverService_FetchTimelinesContextQuery = {
  __typename: 'Query';
  timestampTypes: {
    __typename: 'TimestampTypeQueries';
    all: {
      __typename: 'TimestampTypeCollection';
      items: Array<{
        __typename: 'TimestampType';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        order: number;
        systemTimestampType: SystemTimestampType | null;
        description: string | null;
        companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
    };
  };
};

export type TimestampTypeListPageComponent_FetchAllTimestampTypesQueryVariables = Exact<{
  filter: InputMaybe<TimestampTypeFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type TimestampTypeListPageComponent_FetchAllTimestampTypesQuery = {
  __typename: 'Query';
  timestampTypes: {
    __typename: 'TimestampTypeQueries';
    all: {
      __typename: 'TimestampTypeCollection';
      items: Array<{
        __typename: 'TimestampType';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        order: number;
        systemTimestampType: SystemTimestampType | null;
        description: string | null;
        companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'TimestampTypeCollectionMetadata'; total: number };
    };
  };
};

export type TransferReasonListPageComponent_FetchAllTransferReasonsQueryVariables = Exact<{
  filter: InputMaybe<TransferReasonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type TransferReasonListPageComponent_FetchAllTransferReasonsQuery = {
  __typename: 'Query';
  transferReasons: {
    __typename: 'TransferReasonQueries';
    all: {
      __typename: 'TransferReasonCollection';
      items: Array<{
        __typename: 'TransferReason';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      }>;
      meta: { __typename: 'TransferReasonCollectionMetadata'; total: number };
    };
  };
};

export type TrmUserListPageComponent_FetchTrmUsersQueryVariables = Exact<{
  filter: InputMaybe<TrmUserFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type TrmUserListPageComponent_FetchTrmUsersQuery = {
  __typename: 'Query';
  trmUsers: {
    __typename: 'TrmUserQueries';
    all: {
      __typename: 'TrmUserCollection';
      items: Array<{
        __typename: 'TrmUser';
        firstName: string;
        lastName: string;
        emailAddress: string;
        phoneNumber: string;
        dateCreated: Date | number | string;
        userStatus: TrmUserStatus;
        trmUserAgencies: Array<{
          __typename: 'TrmUserAgency';
          agency: { __typename: 'Agency'; name: string };
        }>;
        trmUserPrograms: Array<{
          __typename: 'TrmUserProgram';
          isPreferred: boolean;
          trmUserId: string;
          programId: string;
          program: { __typename: 'Program'; id: string; name: string; abbreviation: string };
        }>;
        trmUserMedicalFacilities: Array<{
          __typename: 'TrmUserMedicalFacility';
          medicalFacility: { __typename: 'MedicalFacility'; name: string };
        }>;
      }>;
      meta: { __typename: 'TrmUserCollectionMetadata'; total: number };
    };
  };
};

export type TrmUserListPageComponent_FetchAllAgenciesQueryVariables = Exact<{
  filter: InputMaybe<AgencyFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type TrmUserListPageComponent_FetchAllAgenciesQuery = {
  __typename: 'Query';
  agencies: {
    __typename: 'AgencyQueries';
    all: {
      __typename: 'AgencyCollection';
      items: Array<{ __typename: 'Agency'; name: string; id: string }>;
      meta: { __typename: 'AgencyCollectionMetadata'; total: number };
    };
  };
};

export type TrmUserListPageComponent_FetchAllMedicalFacilitiesQueryVariables = Exact<{
  filter: InputMaybe<MedicalFacilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type TrmUserListPageComponent_FetchAllMedicalFacilitiesQuery = {
  __typename: 'Query';
  medicalFacilities: {
    __typename: 'MedicalFacilityQueries';
    all: {
      __typename: 'MedicalFacilityCollection';
      items: Array<{ __typename: 'MedicalFacility'; name: string; id: string }>;
      meta: { __typename: 'MedicalFacilityCollectionMetadata'; total: number };
    };
  };
};

export type VehicleModelsListPageComponent_FetchAllVehicleModelsQueryVariables = Exact<{
  filter: InputMaybe<VehicleModelFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type VehicleModelsListPageComponent_FetchAllVehicleModelsQuery = {
  __typename: 'Query';
  vehicleModels: {
    __typename: 'VehicleModelQueries';
    all: {
      __typename: 'VehicleModelCollection';
      items: Array<{
        __typename: 'VehicleModel';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cruiseSpeedInMph: number | null;
      }>;
      meta: { __typename: 'VehicleModelCollectionMetadata'; total: number };
    };
  };
};

export type BasesFormComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type BasesFormComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQuery = {
  __typename: 'Query';
  baseMedicalControlContacts: {
    __typename: 'BaseMedicalControlContactQueries';
    byBaseId: {
      __typename: 'BaseMedicalControlContactCollection';
      items: Array<{
        __typename: 'BaseMedicalControlContact';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        personId: string;
        rank: number;
        baseId: string;
        companyId: string;
        specialty: string | null;
        person: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
        baseMedicalControlContactStates: Array<{
          __typename: 'BaseMedicalControlContactState';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          companyId: string;
          baseMedicalControlContactId: string | null;
        } | null> | null;
      }>;
      meta: { __typename: 'BaseMedicalControlContactCollectionMetadata'; total: number };
    };
  };
};

export type BasesListPageComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type BasesListPageComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type ComplianceListPageComponent_FetchAllPeopleQueryVariables = Exact<{
  filter: InputMaybe<PersonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type ComplianceListPageComponent_FetchAllPeopleQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    all: {
      __typename: 'PersonCollection';
      items: Array<{
        __typename: 'Person';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        employeeType: EmployeeType;
        timeType: TimeType;
        activateOktaAccount: boolean;
        grantTcsAccess: boolean;
        isOutOfFlightCompliance: boolean;
        companyId: string;
        title: string | null;
        employeeId: string | null;
        hireDate: Date | number | string | null;
        terminationDate: Date | number | string | null;
        departmentId: string | null;
        reportsToPersonId: string | null;
        baseId: string | null;
        locationId: string | null;
        programId: string | null;
        activeDirectoryId: string | null;
        notificationAddress: string | null;
        userRoles: Array<UserRole | null> | null;
        allCompaniesAccessible: boolean | null;
        allBasesAccessible: boolean | null;
        allTrmProgramsAccessible: boolean | null;
        allCommunicationCentersAccessible: boolean | null;
        faaCompanyId: string | null;
        dispatchCompanyId: string | null;
        aviationCompanyId: string | null;
        primaryCommunicationCenterId: string | null;
        outOfFlightComplianceComment: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        department: {
          __typename: 'Department';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
        } | null;
        accessibleItems: Array<{
          __typename: 'AccessibleItem';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: EntityType;
          entityId: string;
          personId: string;
          userRoles: Array<UserRole | null> | null;
        }>;
        appSettings: {
          __typename: 'UserApplicationSettings';
          tcsRealtimeTracking: {
            __typename: 'TcsRealtimeTracking';
            tabId: string | null;
            tabDate: Date | number | string | null;
          };
        } | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'PersonCollectionMetadata'; total: number };
    };
  };
};

export type NotificationGroupListPageComponent_FetchAllNotificationGroupsQueryVariables = Exact<{
  filter: InputMaybe<NotificationGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type NotificationGroupListPageComponent_FetchAllNotificationGroupsQuery = {
  __typename: 'Query';
  notificationGroups: {
    __typename: 'NotificationGroupQueries';
    all: {
      __typename: 'NotificationGroupCollection';
      items: Array<{
        __typename: 'NotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        unitId: string | null;
        regionId: string | null;
        type: NotificationGroupType | null;
        types: Array<NotificationGroupType | null> | null;
        isEmailNotificationPreferred: boolean | null;
      }>;
      meta: { __typename: 'NotificationGroupCollectionMetadata'; total: number };
    };
  };
};

export type ManageCommunicationCenterRoleResolverService_ResolveQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type ManageCommunicationCenterRoleResolverService_ResolveQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      employeeType: EmployeeType;
      timeType: TimeType;
      activateOktaAccount: boolean;
      grantTcsAccess: boolean;
      isOutOfFlightCompliance: boolean;
      companyId: string;
      title: string | null;
      employeeId: string | null;
      hireDate: Date | number | string | null;
      terminationDate: Date | number | string | null;
      departmentId: string | null;
      reportsToPersonId: string | null;
      baseId: string | null;
      locationId: string | null;
      programId: string | null;
      activeDirectoryId: string | null;
      notificationAddress: string | null;
      userRoles: Array<UserRole | null> | null;
      allCompaniesAccessible: boolean | null;
      allBasesAccessible: boolean | null;
      allTrmProgramsAccessible: boolean | null;
      allCommunicationCentersAccessible: boolean | null;
      faaCompanyId: string | null;
      dispatchCompanyId: string | null;
      aviationCompanyId: string | null;
      primaryCommunicationCenterId: string | null;
      outOfFlightComplianceComment: string | null;
      dateLastUpdatedFromGMRWorkday: Date | number | string | null;
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
      appSettings: {
        __typename: 'UserApplicationSettings';
        tcsRealtimeTracking: {
          __typename: 'TcsRealtimeTracking';
          tabId: string | null;
          tabDate: Date | number | string | null;
        };
      } | null;
      additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
  companies: {
    __typename: 'CompanyQueries';
    all: {
      __typename: 'CompanyCollection';
      items: Array<{
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      }>;
    };
  };
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
    };
  };
};

export type PersonListPageComponent_FetchAllPeopleQueryVariables = Exact<{
  filter: InputMaybe<PersonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type PersonListPageComponent_FetchAllPeopleQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    all: {
      __typename: 'PersonCollection';
      items: Array<{
        __typename: 'Person';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        employeeType: EmployeeType;
        timeType: TimeType;
        activateOktaAccount: boolean;
        grantTcsAccess: boolean;
        isOutOfFlightCompliance: boolean;
        companyId: string;
        title: string | null;
        employeeId: string | null;
        hireDate: Date | number | string | null;
        terminationDate: Date | number | string | null;
        departmentId: string | null;
        reportsToPersonId: string | null;
        baseId: string | null;
        locationId: string | null;
        programId: string | null;
        activeDirectoryId: string | null;
        notificationAddress: string | null;
        userRoles: Array<UserRole | null> | null;
        allCompaniesAccessible: boolean | null;
        allBasesAccessible: boolean | null;
        allTrmProgramsAccessible: boolean | null;
        allCommunicationCentersAccessible: boolean | null;
        faaCompanyId: string | null;
        dispatchCompanyId: string | null;
        aviationCompanyId: string | null;
        primaryCommunicationCenterId: string | null;
        outOfFlightComplianceComment: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        appSettings: {
          __typename: 'UserApplicationSettings';
          tcsRealtimeTracking: {
            __typename: 'TcsRealtimeTracking';
            tabId: string | null;
            tabDate: Date | number | string | null;
          };
        } | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'PersonCollectionMetadata'; total: number };
    };
  };
};

export type PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQuery = {
  __typename: 'Query';
  baseMedicalControlContacts: {
    __typename: 'BaseMedicalControlContactQueries';
    byPersonId: {
      __typename: 'BaseMedicalControlContactCollection';
      items: Array<{
        __typename: 'BaseMedicalControlContact';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        personId: string;
        rank: number;
        baseId: string;
        companyId: string;
        specialty: string | null;
        person: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
        base: {
          __typename: 'Base';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationId: string;
          businessModel: BusinessModel;
          companyId: string;
          plannedOperationsStart: Date | number | string | null;
          operationsStarted: Date | number | string | null;
          operationsTerminated: Date | number | string | null;
          dateOfMaturity: Date | number | string | null;
          primaryPhoneNumber: string | null;
          estimatedLiftoffTime: number | null;
          licenseNumber: string | null;
          enableFlightLogDutyLog: boolean | null;
          dispatchBaseId: string | null;
          reportBaseId: string | null;
          aviationCompanyId: string | null;
          workdayBaseId: string | null;
          gmrWorkdayLocationId: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          pilotPhoneNumber: string | null;
          crewPhoneNumber1: string | null;
          crewPhoneNumber2: string | null;
          brandName: string | null;
          medicalFacilityId: string | null;
          hoursOfOperation: {
            __typename: 'HoursOfOperation';
            is24Hours: boolean | null;
            startTime: Date | number | string | null;
            endTime: Date | number | string | null;
          };
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
        baseMedicalControlContactStates: Array<{
          __typename: 'BaseMedicalControlContactState';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          companyId: string;
          baseMedicalControlContactId: string | null;
        } | null> | null;
      }>;
      meta: { __typename: 'BaseMedicalControlContactCollectionMetadata'; total: number };
    };
  };
};

export type UserDetailPageComponent_FetchOktaPersonEntitiesByIdQueryVariables = Exact<{
  idOrLogin: Scalars['ID'];
}>;

export type UserDetailPageComponent_FetchOktaPersonEntitiesByIdQuery = {
  __typename: 'Query';
  okta: {
    __typename: 'OktaQueries';
    user: {
      __typename: 'OktaUser';
      id: string;
      lastUpdated: Date | number | string;
      created: Date | number | string;
      profile: {
        __typename: 'OktaUserProfile';
        login: string;
        firstName: string;
        lastName: string;
        email: string;
        employeeNumber: string | null;
      };
    } | null;
  };
};

export type UserFormComponent_FetchAccessibleItemsQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type UserFormComponent_FetchAccessibleItemsQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
    } | null;
  };
};

export type UserFormComponent_FetchAllCommunicationCentersQueryVariables = Exact<{
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type UserFormComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
      meta: { __typename: 'CommunicationCenterCollectionMetadata'; total: number };
    };
  };
};

export type UserFormComponent_FetchAllProgramsQueryVariables = Exact<{
  filter: InputMaybe<ProgramFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type UserFormComponent_FetchAllProgramsQuery = {
  __typename: 'Query';
  programs: {
    __typename: 'ProgramQueries';
    all: {
      __typename: 'ProgramCollection';
      items: Array<{
        __typename: 'Program';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        code: string;
        companyId: string;
        adminId: string | null;
      }>;
      meta: { __typename: 'ProgramCollectionMetadata'; total: number };
    };
  };
};

export type UserFormComponent_FetchAllBasesQueryVariables = Exact<{
  filter: InputMaybe<BaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type UserFormComponent_FetchAllBasesQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'BaseCollectionMetadata'; total: number };
    };
  };
};

export type ManageOccRolePageResolver_ResolveQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type ManageOccRolePageResolver_ResolveQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      employeeType: EmployeeType;
      timeType: TimeType;
      activateOktaAccount: boolean;
      grantTcsAccess: boolean;
      isOutOfFlightCompliance: boolean;
      companyId: string;
      title: string | null;
      employeeId: string | null;
      hireDate: Date | number | string | null;
      terminationDate: Date | number | string | null;
      departmentId: string | null;
      reportsToPersonId: string | null;
      baseId: string | null;
      locationId: string | null;
      programId: string | null;
      activeDirectoryId: string | null;
      notificationAddress: string | null;
      userRoles: Array<UserRole | null> | null;
      allCompaniesAccessible: boolean | null;
      allBasesAccessible: boolean | null;
      allTrmProgramsAccessible: boolean | null;
      allCommunicationCentersAccessible: boolean | null;
      faaCompanyId: string | null;
      dispatchCompanyId: string | null;
      aviationCompanyId: string | null;
      primaryCommunicationCenterId: string | null;
      outOfFlightComplianceComment: string | null;
      dateLastUpdatedFromGMRWorkday: Date | number | string | null;
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
      appSettings: {
        __typename: 'UserApplicationSettings';
        tcsRealtimeTracking: {
          __typename: 'TcsRealtimeTracking';
          tabId: string | null;
          tabDate: Date | number | string | null;
        };
      } | null;
      additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
  companies: {
    __typename: 'CompanyQueries';
    all: {
      __typename: 'CompanyCollection';
      items: Array<{
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      }>;
    };
  };
  controlZones: {
    __typename: 'ControlZoneQueries';
    all: {
      __typename: 'ControlZoneCollection';
      items: Array<{
        __typename: 'ControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
      }>;
    };
  };
};

export type ManageOccRolePage_ResolverQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type ManageOccRolePage_ResolverQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      employeeType: EmployeeType;
      timeType: TimeType;
      activateOktaAccount: boolean;
      grantTcsAccess: boolean;
      isOutOfFlightCompliance: boolean;
      companyId: string;
      title: string | null;
      employeeId: string | null;
      hireDate: Date | number | string | null;
      terminationDate: Date | number | string | null;
      departmentId: string | null;
      reportsToPersonId: string | null;
      baseId: string | null;
      locationId: string | null;
      programId: string | null;
      activeDirectoryId: string | null;
      notificationAddress: string | null;
      userRoles: Array<UserRole | null> | null;
      allCompaniesAccessible: boolean | null;
      allBasesAccessible: boolean | null;
      allTrmProgramsAccessible: boolean | null;
      allCommunicationCentersAccessible: boolean | null;
      faaCompanyId: string | null;
      dispatchCompanyId: string | null;
      aviationCompanyId: string | null;
      primaryCommunicationCenterId: string | null;
      outOfFlightComplianceComment: string | null;
      dateLastUpdatedFromGMRWorkday: Date | number | string | null;
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
      appSettings: {
        __typename: 'UserApplicationSettings';
        tcsRealtimeTracking: {
          __typename: 'TcsRealtimeTracking';
          tabId: string | null;
          tabDate: Date | number | string | null;
        };
      } | null;
      additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
  companies: {
    __typename: 'CompanyQueries';
    all: {
      __typename: 'CompanyCollection';
      items: Array<{
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      }>;
    };
  };
  controlZones: {
    __typename: 'ControlZoneQueries';
    all: {
      __typename: 'ControlZoneCollection';
      items: Array<{
        __typename: 'ControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
      }>;
    };
  };
};

export type RegionGroupsFormComponent_FetchAllDepartmentsQueryVariables = Exact<{
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type RegionGroupsFormComponent_FetchAllDepartmentsQuery = {
  __typename: 'Query';
  allDepartments: Array<{ __typename: 'Department'; id: string; name: string; code: string }>;
};

export type RegionGroupsListPageComponent_FetchAllRegionGroupsQueryVariables = Exact<{
  filter: InputMaybe<RegionGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type RegionGroupsListPageComponent_FetchAllRegionGroupsQuery = {
  __typename: 'Query';
  regionGroups: {
    __typename: 'RegionGroupQueries';
    all: {
      __typename: 'RegionGroupCollection';
      items: Array<{
        __typename: 'RegionGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        departmentId: string;
        companyId: string;
      }>;
      meta: { __typename: 'RegionGroupCollectionMetadata'; total: number };
    };
  };
};

export type RegionFormComponent_FetchAllCommunicationCentersQueryVariables = Exact<{
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type RegionFormComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
      meta: { __typename: 'CommunicationCenterCollectionMetadata'; total: number };
    };
  };
};

export type RegionFormComponent_FetchAllRegionGroupsQueryVariables = Exact<{
  filter: InputMaybe<RegionGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type RegionFormComponent_FetchAllRegionGroupsQuery = {
  __typename: 'Query';
  regionGroups: {
    __typename: 'RegionGroupQueries';
    all: {
      __typename: 'RegionGroupCollection';
      items: Array<{
        __typename: 'RegionGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        departmentId: string;
        companyId: string;
      }>;
      meta: { __typename: 'RegionGroupCollectionMetadata'; total: number };
    };
  };
};

export type RegionsListPageComponent_FetchAllRegionsQueryVariables = Exact<{
  filter: InputMaybe<RegionFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type RegionsListPageComponent_FetchAllRegionsQuery = {
  __typename: 'Query';
  regions: {
    __typename: 'RegionQueries';
    all: {
      __typename: 'RegionCollection';
      items: Array<{
        __typename: 'Region';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        communicationCenterId: string;
        isTransferCenterRegion: boolean;
        regionGroupId: string;
        companyId: string;
        timezoneCd: string | null;
        emSystemDivisionName: string | null;
        dispatchNumber: string | null;
        fixedWingPreferredThresholdInNauticalMiles: number | null;
        etcInMinutes: number | null;
        regionGroup: {
          __typename: 'RegionGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          departmentId: string;
          companyId: string;
        };
        communicationCenter: {
          __typename: 'CommunicationCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          playAlertForManualPositionReports: boolean;
          enableRAAlert: boolean;
          useCrewPhoneNumber: boolean;
          displayContactTimeline: boolean;
          companyId: string;
          timezoneCd: string | null;
          primaryPhoneNumber: string | null;
          emailAddress: string | null;
          showReferToGmrWarning: boolean | null;
          alertFrequencyForGroundVehicles: number | null;
        };
      }>;
      meta: { __typename: 'RegionCollectionMetadata'; total: number };
    };
  };
};

export type SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsQueryVariables = Exact<{
  filter: InputMaybe<SpecialtyTeamFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsQuery = {
  __typename: 'Query';
  specialtyTeams: {
    __typename: 'SpecialtyTeamQueries';
    all: {
      __typename: 'SpecialtyTeamCollection';
      items: Array<{
        __typename: 'SpecialtyTeam';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        affiliationId: string;
        companyId: string;
      }>;
      meta: { __typename: 'SpecialtyTeamCollectionMetadata'; total: number };
    };
  };
};

export type SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersQueryVariables =
  Exact<{
    filter: InputMaybe<SpecialtyTeamMemberFilter>;
    skip: InputMaybe<Scalars['Int']>;
    first: InputMaybe<Scalars['Int']>;
  }>;

export type SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersQuery = {
  __typename: 'Query';
  specialtyTeamMembers: {
    __typename: 'SpectialtyTeamMemberQueries';
    all: {
      __typename: 'SpecialtyTeamMemberCollection';
      items: Array<{
        __typename: 'SpecialtyTeamMember';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        specialtyTeamId: string;
        teamMemberId: string;
        companyId: string;
        weightInKg: number | null;
        teamMember: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
      meta: { __typename: 'SpecialtyTeamMemberCollectionMetadata'; total: number };
    };
  };
};

export type VehicleDetailPageComponent_FetchVehicleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type VehicleDetailPageComponent_FetchVehicleByIdQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      type: VehicleType;
      registrationNumber: string;
      isUnderLease: boolean;
      role: VehicleRole;
      flightLogProcess: FlightLogProcess;
      isPlaceholder: boolean;
      stateInspectionRequired: boolean;
      isRetired: boolean;
      isPositionTrackingEnabled: boolean;
      hideFromOOSRUM: boolean;
      companyId: string;
      serialNumber: string | null;
      dispatchCompanyId: string | null;
      year: number | null;
      dateAcquired: Date | number | string | null;
      makeId: string | null;
      modelId: string | null;
      cruiseSpeed: number | null;
      configurationClassId: string | null;
      isThirdPartyVehicle: boolean | null;
      parentUnitId: string | null;
      isHidden: boolean | null;
      faaCompanyId: string | null;
      skytracIMEI: string | null;
      phoneNumber: string | null;
      completeFlightId: string | null;
      controlZoneId: string | null;
      communicationCenterId: string | null;
      regionId: string | null;
      vehicleDescription: string | null;
      company: {
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      };
      configurationClass: {
        __typename: 'VehicleConfigurationClass';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        legacyName: string;
        engineCount: number;
        maintenanceSystemId: string;
      } | null;
      make: {
        __typename: 'VehicleMake';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
      } | null;
      model: {
        __typename: 'VehicleModel';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cruiseSpeedInMph: number | null;
      } | null;
    } | null;
  };
};

export type VehicleFormComponent_FetchAllVehicleMakesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VehicleFormComponent_FetchAllVehicleMakesQuery = {
  __typename: 'Query';
  allVehicleMakes: Array<{ __typename: 'VehicleMake'; id: string; name: string }>;
};

export type VehicleFormComponent_FetchAllCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<CapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type VehicleFormComponent_FetchAllCapabilitiesQuery = {
  __typename: 'Query';
  capabilities: {
    __typename: 'CapabilityQueries';
    all: {
      __typename: 'CapabilityCollection';
      items: Array<{
        __typename: 'Capability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        description: string;
        entityType: EntityType;
      }>;
      meta: { __typename: 'CapabilityCollectionMetadata'; total: number };
    };
  };
};

export type VehicleFormComponent_FetchAllEntityCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<EntityCapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type VehicleFormComponent_FetchAllEntityCapabilitiesQuery = {
  __typename: 'Query';
  entityCapabilities: {
    __typename: 'EntityCapabilityQueries';
    all: {
      __typename: 'EntityCapabilityCollection';
      items: Array<{
        __typename: 'EntityCapability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        capabilityId: string;
        entityId: string;
        entityType: EntityType;
        capability: {
          __typename: 'Capability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          description: string;
          entityType: EntityType;
        };
      }>;
      meta: { __typename: 'EntityCapabilityCollectionMetadata'; total: number };
    };
  };
};

export type VehicleFormComponent_FetchAllCommunicationCentersQueryVariables = Exact<{
  filter: InputMaybe<CommunicationCenterFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type VehicleFormComponent_FetchAllCommunicationCentersQuery = {
  __typename: 'Query';
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{ __typename: 'CommunicationCenter'; id: string; name: string }>;
    };
  };
};

export type VehicleImageUploadDialogComponent_FetchAttachmentQueryVariables = Exact<{
  filter: InputMaybe<AttachmentFilter>;
}>;

export type VehicleImageUploadDialogComponent_FetchAttachmentQuery = {
  __typename: 'Query';
  attachments: {
    __typename: 'AttachmentQueries';
    all: {
      __typename: 'AttachmentCollection';
      items: Array<{
        __typename: 'Attachment';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        attachmentEntityType: AttachmentEntityType;
        fileName: string;
        entityId: string | null;
        fileSizeInBytes: number | null;
        contentType: string | null;
      }>;
    };
  };
};

export type VehicleMaintenanceListComponent_FetchVehicleMaintenanceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type VehicleMaintenanceListComponent_FetchVehicleMaintenanceQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      vehicleMaintenances: Array<{
        __typename: 'VehicleMaintenance';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        companyId: string;
        notes: string | null;
        isReleasedFromOCF: boolean | null;
        vehicleId: string | null;
        deferralDueDates: Array<{
          __typename: 'DeferralDueDate';
          id: string;
          dueDate: Date | number | string;
          triggerValue: number | null;
          notes: string | null;
        }>;
        nextDues: Array<{
          __typename: 'NextDue';
          id: string;
          typeId: string;
          cycleType: NextDueCycleType;
          value: string;
          triggerValue: number;
          notes: string | null;
          inTolerance: boolean | null;
        }>;
        maintenanceParams: {
          __typename: 'MaintenanceParameters';
          endingHobbs: number | null;
          airframeTime: number | null;
          totalLandings: number | null;
          engine1: {
            __typename: 'EngineParameters';
            time: number | null;
            starts: number | null;
          } | null;
          engine2: {
            __typename: 'EngineParameters';
            time: number | null;
            starts: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  };
};

export type VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsQueryVariables =
  Exact<{
    filter: InputMaybe<NotificationGroupFilter>;
  }>;

export type VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsQuery = {
  __typename: 'Query';
  notificationGroups: {
    __typename: 'NotificationGroupQueries';
    all: {
      __typename: 'NotificationGroupCollection';
      items: Array<{
        __typename: 'NotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
        unitId: string | null;
        regionId: string | null;
        type: NotificationGroupType | null;
        types: Array<NotificationGroupType | null> | null;
        isEmailNotificationPreferred: boolean | null;
      }>;
    };
  };
};

export type VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsQueryVariables =
  Exact<{
    id: Scalars['ID'];
  }>;

export type VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      id: string;
      vehicleNotificationGroups: Array<{
        __typename: 'VehicleNotificationGroup';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        vehicleId: string;
        notificationGroupId: string;
        notificationGroup: { __typename: 'NotificationGroup'; name: string };
      }>;
    } | null;
  };
};

export type VehicleStateInspectionListComponent_FetchVehicleStateInspectionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type VehicleStateInspectionListComponent_FetchVehicleStateInspectionsQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      vehicleStateInspections: Array<{
        __typename: 'VehicleStateInspection';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        stateAbbrevation: string;
        inspectionDate: Date | number | string;
        vehicleId: string;
        companyId: string;
      }>;
    } | null;
  };
};

export type VehiclesListPageComponent_FetchAllVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type VehiclesListPageComponent_FetchAllVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        configurationClass: {
          __typename: 'VehicleConfigurationClass';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          legacyName: string;
          engineCount: number;
          maintenanceSystemId: string;
        } | null;
        make: {
          __typename: 'VehicleMake';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        } | null;
        model: {
          __typename: 'VehicleModel';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cruiseSpeedInMph: number | null;
        } | null;
      }>;
      meta: { __typename: 'VehicleCollectionMetadata'; total: number };
    };
  };
};

export type ReleaseNotesListPageComponent_FetchReleaseNotesQueryVariables = Exact<{
  filter: InputMaybe<ReleaseNoteFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type ReleaseNotesListPageComponent_FetchReleaseNotesQuery = {
  __typename: 'Query';
  releaseNotes: {
    __typename: 'ReleaseNoteQueries';
    all: {
      __typename: 'ReleaseNoteCollection';
      items: Array<{
        __typename: 'ReleaseNote';
        id: string;
        description: string;
        releaseNumber: string;
        releaseDate: Date | number | string | null;
        dateCreated: Date | number | string;
        dateLastUpdated: Date | number | string;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'ReleaseNoteCollectionMetadata'; total: number };
    };
  };
};

export type GetRttCardByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type GetRttCardByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
      activeAlerts: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
      }>;
      operation: {
        __typename: 'Operation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: OperationStatus;
        type: OperationType;
        vehicleId: string;
        dateOperationStarted: Date | number | string;
        riskAnalysisAcknowledged: boolean;
        companyId: string;
        unitId: string | null;
        dateOperationEnded: Date | number | string | null;
        unitActivationTime: Date | number | string | null;
        riskAnalysisNumber: string | null;
        standbyActivationType: StandbyActivationType | null;
        caller: string | null;
        callbackNumber: string | null;
        initialOperationType: OperationType | null;
        unit: {
          __typename: 'Unit';
          excludeStates: Array<string | null> | null;
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          baseId: string;
          regionId: string;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          integrations: Array<IntegrationSystem>;
          isCrewAvailable: boolean;
          updatePhoneNumbersFromExternal: boolean;
          companyId: string;
          isAdministrative: boolean | null;
          vehicleId: string | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          oemPlacardNumber: string | null;
          primaryOutOfServiceEventId: string | null;
          emSystemResourceId: string | null;
          onBaseETAInMinutes: number | null;
          crewSourcedFromUnitId: string | null;
          completeFlightInstanceId: string | null;
          parentUnitId: string | null;
          region: {
            __typename: 'Region';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            communicationCenterId: string;
            isTransferCenterRegion: boolean;
            regionGroupId: string;
            companyId: string;
            timezoneCd: string | null;
            emSystemDivisionName: string | null;
            dispatchNumber: string | null;
            fixedWingPreferredThresholdInNauticalMiles: number | null;
            etcInMinutes: number | null;
            communicationCenter: {
              __typename: 'CommunicationCenter';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              includeCompetitors: boolean;
              playAlertForManualPositionReports: boolean;
              enableRAAlert: boolean;
              useCrewPhoneNumber: boolean;
              displayContactTimeline: boolean;
              companyId: string;
              timezoneCd: string | null;
              primaryPhoneNumber: string | null;
              emailAddress: string | null;
              showReferToGmrWarning: boolean | null;
              alertFrequencyForGroundVehicles: number | null;
            };
          };
          positions: Array<{
            __typename: 'UnitPosition';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            type: UnitPositionType;
            isFlightCrew: boolean;
            isNonEmployee: boolean;
            unitId: string;
            companyId: string;
            notificationAddress: string | null;
            teamMemberId: string | null;
            firstName: string | null;
            lastName: string | null;
            teamMember: {
              __typename: 'Person';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              firstName: string;
              lastName: string;
              email: string;
              employeeType: EmployeeType;
              timeType: TimeType;
              activateOktaAccount: boolean;
              grantTcsAccess: boolean;
              isOutOfFlightCompliance: boolean;
              companyId: string;
              title: string | null;
              employeeId: string | null;
              hireDate: Date | number | string | null;
              terminationDate: Date | number | string | null;
              departmentId: string | null;
              reportsToPersonId: string | null;
              baseId: string | null;
              locationId: string | null;
              programId: string | null;
              activeDirectoryId: string | null;
              notificationAddress: string | null;
              userRoles: Array<UserRole | null> | null;
              allCompaniesAccessible: boolean | null;
              allBasesAccessible: boolean | null;
              allTrmProgramsAccessible: boolean | null;
              allCommunicationCentersAccessible: boolean | null;
              faaCompanyId: string | null;
              dispatchCompanyId: string | null;
              aviationCompanyId: string | null;
              primaryCommunicationCenterId: string | null;
              outOfFlightComplianceComment: string | null;
              dateLastUpdatedFromGMRWorkday: Date | number | string | null;
              appSettings: {
                __typename: 'UserApplicationSettings';
                tcsRealtimeTracking: {
                  __typename: 'TcsRealtimeTracking';
                  tabId: string | null;
                  tabDate: Date | number | string | null;
                };
              } | null;
              additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
            } | null;
          }>;
          shifts: Array<{
            __typename: 'UnitShift';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            startTimeInMinutes: number;
            endTimeInMinutes: number;
            unitId: string;
            companyId: string;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
            model: {
              __typename: 'VehicleModel';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              cruiseSpeedInMph: number | null;
            } | null;
            vehicleStateInspections: Array<{
              __typename: 'VehicleStateInspection';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              stateAbbrevation: string;
              inspectionDate: Date | number | string;
              vehicleId: string;
              companyId: string;
            }>;
          } | null;
          crewSourcedToUnits: Array<{
            __typename: 'CrewSourcedUnit';
            id: string;
            unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
          } | null> | null;
        } | null;
        trips: Array<{
          __typename: 'Trip';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          operationId: string;
          companyId: string;
          vehicleId: string | null;
          agencyId: string | null;
          agencyLocationId: string | null;
          calculatedLoadedMiles: number | null;
          gpsLoadedMiles: number | null;
          estimatedDurations: Array<{
            __typename: 'EstimatedDuration';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            asOfTime: Date | number | string;
            durationInMinutes: number;
            isOfficial: boolean;
            estimateSource: EstimatedDurationSource;
            durationType: EstimatedDurationType;
            ownerId: string;
            tripId: string;
            companyId: string;
            positionReportId: string | null;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
          } | null;
          positionReports: Array<{
            __typename: 'PositionReport';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
            tripId: string;
            companyId: string;
            altitude: number | null;
            speedInKnots: number | null;
            heading: number | null;
            estimatedMinutesEnRoute: number | null;
            fuelRemaining: string | null;
            timezoneCd: string | null;
            dateConfirmed: Date | number | string | null;
            gpsProvider: GpsProvider | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          }>;
          legs: Array<{
            __typename: 'TripLeg';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: TripLegStatus;
            sequence: number;
            tripId: string;
            companyId: string;
            estimatedDistanceInMiles: number | null;
            departingOdometerReading: number | null;
            departingNote: string | null;
            arrivingOdometerReading: number | null;
            arrivingNote: string | null;
            isEmergent: boolean | null;
            abortDate: Date | number | string | null;
            encodedPolyline: string | null;
            dateOnFinalMarked: Date | number | string | null;
            officialEteId: string | null;
            calculatedEteId: string | null;
            endingWaypointId: string | null;
            startingWaypointId: string | null;
            startingWaypoint: {
              __typename: 'Waypoint';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              companyId: string;
              timezoneCd: string | null;
              isRotorWingLz: boolean | null;
              arrivalTime: Date | number | string | null;
              departureTime: Date | number | string | null;
              locationId: string | null;
              isPatientPickup: boolean | null;
              isPatientDropoff: boolean | null;
              arrivingType: WaypointType | null;
              estimatedDurationId: string | null;
              currentEtaId: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              location: {
                __typename: 'Location';
                id: string;
                locationType: LocationType;
                name: string;
                abbreviation: string;
                notes: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
              } | null;
            } | null;
            endingWaypoint: {
              __typename: 'Waypoint';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              companyId: string;
              timezoneCd: string | null;
              isRotorWingLz: boolean | null;
              arrivalTime: Date | number | string | null;
              departureTime: Date | number | string | null;
              locationId: string | null;
              isPatientPickup: boolean | null;
              isPatientDropoff: boolean | null;
              arrivingType: WaypointType | null;
              estimatedDurationId: string | null;
              currentEtaId: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              location: {
                __typename: 'Location';
                id: string;
                locationType: LocationType;
                name: string;
                abbreviation: string;
                notes: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
              } | null;
            } | null;
          }>;
        }>;
      } | null;
    } | null;
  };
};

export type GetRttSummariesQueryVariables = Exact<{
  cardFilter: InputMaybe<CardSummaryFilter>;
  unitFilter: InputMaybe<UnitSummaryFilter>;
}>;

export type GetRttSummariesQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    summaries: {
      __typename: 'CardSummaryCollection';
      items: Array<{
        __typename: 'CardSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        status: CardStatus;
        cardNumber: string;
        operationType: OperationType;
        regionId: string;
        companyId: string;
        dateContactCompleted: Date | number | string | null;
        apiWebhookSubscriptionId: string | null;
        webOrderAcknowledgedTime: Date | number | string | null;
        diversionType: DiversionType | null;
        gmrUtilizationStatus: AmrUtilizationStatus | null;
        gmrCADNumber: string | null;
        vehicleId: string | null;
        vehicleSummaryId: string | null;
        communicationCenterId: string | null;
        unitId: string | null;
        unitSummaryId: string | null;
        operation: {
          __typename: 'OperationSummary';
          id: string;
          status: OperationStatus;
          unitId: string | null;
          vehicleId: string | null;
          riskAnalysisNumber: string | null;
          riskAnalysisAcknowledged: boolean | null;
          tripId: string | null;
        } | null;
        request: {
          __typename: 'RequestSummary';
          id: string;
          status: RequestStatus;
          isStandbyRequest: boolean;
          isSisterCompanyReferral: boolean;
          standbyActivationRequested: boolean;
          assignmentDelayedReason: string | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          assignmentDelayedTime: Date | number | string | null;
          requester: {
            __typename: 'RequesterSummary';
            id: string;
            missionRole: MissionRoleType;
            vetNumber: string | null;
          } | null;
          from: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
          to: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
        } | null;
        patients: Array<{
          __typename: 'RequestPatientSummary';
          id: string;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          dateCreated: Date | number | string | null;
        } | null> | null;
      }>;
    };
  };
  units: {
    __typename: 'UnitQueries';
    summaries: {
      __typename: 'UnitSummaryCollection';
      items: Array<{
        __typename: 'UnitSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        isCrewAvailable: boolean;
        baseId: string;
        regionId: string;
        companyId: string;
        isAdministrative: boolean | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        lastPilotUpdateName: string | null;
        baseTimezoneCd: string | null;
        vehicleSummaryId: string | null;
        vehicleId: string | null;
        communicationCenterId: string | null;
        vehicleSummary: {
          __typename: 'VehicleSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          unitSummaryId: string;
          regionId: string;
          status: VehicleStatus;
          statusDescription: string;
          vehicleDispositionId: string;
          unitId: string;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          makeName: string | null;
          modelName: string | null;
          etlo: Date | number | string | null;
          eta: Date | number | string | null;
          currentCardNumber: string | null;
          currentCardSummaryId: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          currentOrNextLegSequence: number | null;
          totalLegCount: number | null;
          dateOnFinalMarked: Date | number | string | null;
          communicationCenterId: string | null;
          currentCardId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          latestPositionReportSummary: {
            __typename: 'PositionReportSummary';
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
          } | null;
          lastKnownCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        shifts: Array<{
          __typename: 'UnitShiftSummary';
          id: string;
          name: string;
          startTimeInMinutes: number;
          endTimeInMinutes: number;
        }>;
        outOfServiceEvents: Array<{
          __typename: 'OutOfServiceEventSummary';
          id: string;
          type: OutOfServiceType;
          eventNumber: string;
          estimatedEndTime: Date | number | string;
          reasonName: string;
          reasonId: string;
          startTime: Date | number | string | null;
          isOpportunisticOOS: boolean | null;
          notes: string | null;
        }>;
        positions: Array<{
          __typename: 'UnitPositionSummary';
          id: string;
          name: string;
          type: UnitPositionType;
          isFlightCrew: boolean;
          isNonEmployee: boolean;
          isNonCompliant: boolean;
          notificationAddress: string | null;
          teamMemberId: string | null;
          teamMemberFirstName: string | null;
          teamMemberLastName: string | null;
          nonComplianceReason: string | null;
        }>;
        paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
    };
  };
};

export type LocationSearchDialogComponent_FetchAllLocationsQueryVariables = Exact<{
  filter: InputMaybe<LocationQueryFilter>;
}>;

export type LocationSearchDialogComponent_FetchAllLocationsQuery = {
  __typename: 'Query';
  locations: {
    __typename: 'LocationQueries';
    all: {
      __typename: 'LocationCollection';
      items: Array<{
        __typename: 'Location';
        distanceToReceivingMiles: number | null;
        distanceToReceivingNauticaMiles: number | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
        entityCapabilities: Array<{
          __typename: 'EntityCapability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          capabilityId: string;
          entityId: string;
          entityType: EntityType;
          capability: {
            __typename: 'Capability';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            description: string;
            entityType: EntityType;
          };
        }>;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'LocationCollectionMetadata'; total: number };
    };
  };
};

export type LocationSearchDialogComponent_FetchAllCapabilitiesQueryVariables = Exact<{
  filter: InputMaybe<CapabilityFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type LocationSearchDialogComponent_FetchAllCapabilitiesQuery = {
  __typename: 'Query';
  capabilities: {
    __typename: 'CapabilityQueries';
    all: {
      __typename: 'CapabilityCollection';
      items: Array<{
        __typename: 'Capability';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        description: string;
        entityType: EntityType;
      }>;
      meta: { __typename: 'CapabilityCollectionMetadata'; total: number };
    };
  };
};

export type LocationSearchComponent_FetchAllLocationsQueryVariables = Exact<{
  filter: InputMaybe<LocationQueryFilter>;
}>;

export type LocationSearchComponent_FetchAllLocationsQuery = {
  __typename: 'Query';
  locations: {
    __typename: 'LocationQueries';
    all: {
      __typename: 'LocationCollection';
      items: Array<{
        __typename: 'Location';
        distanceToReceivingMiles: number | null;
        distanceToReceivingNauticaMiles: number | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationType: LocationType;
        isPreferred: boolean;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        notes: string | null;
        sourceSystemId: string | null;
        closedDate: Date | number | string | null;
        duplicateOfId: string | null;
        isLandingZoneOutOfService: boolean | null;
        landingZoneOutOfServiceNotes: string | null;
        landingZoneOutOfServiceExpirationDate: Date | number | string | null;
        landingZoneOutOfServiceReasonId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
        entityCapabilities: Array<{
          __typename: 'EntityCapability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          capabilityId: string;
          entityId: string;
          entityType: EntityType;
          capability: {
            __typename: 'Capability';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            description: string;
            entityType: EntityType;
          };
        }>;
        lastUpdatedBy: {
          __typename: 'Person';
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      }>;
      meta: { __typename: 'LocationCollectionMetadata'; total: number };
    };
  };
};

export type OmnisearchCardResultsComponent_SearchForCardsQueryVariables = Exact<{
  filter: InputMaybe<CardSearchFilterV2>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type OmnisearchCardResultsComponent_SearchForCardsQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    searchv2: {
      __typename: 'CardSearchResultCollection';
      meta: { __typename: 'CardCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'CardSearchResult';
        id: string;
        cardNumber: string;
        createdById: string | null;
        createdBy: string | null;
        companyId: string;
        companyCode: string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        status: CardStatus | null;
        callStatus: CardCallStatus | null;
        isBillable: boolean;
        isLocked: boolean | null;
        lastOfferedUnit: { __typename: 'CardSearchResultUnit'; id: string; name: string } | null;
        lastOfferedVehicle: {
          __typename: 'CardSearchResultVehicle';
          id: string;
          registrationNumber: string;
        } | null;
        operation: {
          __typename: 'CardSearchResultOperation';
          id: string;
          status: OperationStatus;
          type: OperationType;
          unit: { __typename: 'CardSearchResultUnit'; id: string; name: string } | null;
          vehicle: {
            __typename: 'CardSearchResultVehicle';
            id: string;
            registrationNumber: string;
          } | null;
        } | null;
        request: {
          __typename: 'CardSearchResultRequest';
          id: string;
          status: RequestStatus;
          requestedOperationType: OperationType;
          pickupLocation: {
            __typename: 'CardSearchResultRequestLocation';
            id: string;
            name: string;
            type: WaypointType;
            locationId: string | null;
            medicalFacilityId: string | null;
            medicalFacilityName: string | null;
            medicalFacilityAbbreviation: string | null;
          } | null;
          dropoffLocation: {
            __typename: 'CardSearchResultRequestLocation';
            id: string;
            name: string;
            type: WaypointType;
            locationId: string | null;
            medicalFacilityId: string | null;
            medicalFacilityName: string | null;
            medicalFacilityAbbreviation: string | null;
          } | null;
        } | null;
        region: {
          __typename: 'CardSearchResultRegion';
          id: string;
          name: string;
          communicationCenter: {
            __typename: 'CardSearchResultCommunicationCenter';
            id: string;
            name: string;
          } | null;
        } | null;
      }>;
    };
  };
};

export type PeopleFetchService_FetchAllPeopleQueryVariables = Exact<{
  filter: InputMaybe<PersonFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type PeopleFetchService_FetchAllPeopleQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    all: {
      __typename: 'PersonCollection';
      items: Array<{
        __typename: 'Person';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        employeeType: EmployeeType;
        timeType: TimeType;
        activateOktaAccount: boolean;
        grantTcsAccess: boolean;
        isOutOfFlightCompliance: boolean;
        companyId: string;
        title: string | null;
        employeeId: string | null;
        hireDate: Date | number | string | null;
        terminationDate: Date | number | string | null;
        departmentId: string | null;
        reportsToPersonId: string | null;
        baseId: string | null;
        locationId: string | null;
        programId: string | null;
        activeDirectoryId: string | null;
        notificationAddress: string | null;
        userRoles: Array<UserRole | null> | null;
        allCompaniesAccessible: boolean | null;
        allBasesAccessible: boolean | null;
        allTrmProgramsAccessible: boolean | null;
        allCommunicationCentersAccessible: boolean | null;
        faaCompanyId: string | null;
        dispatchCompanyId: string | null;
        aviationCompanyId: string | null;
        primaryCommunicationCenterId: string | null;
        outOfFlightComplianceComment: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        location: {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        } | null;
        company: {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        };
        department: {
          __typename: 'Department';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
        } | null;
        accessibleItems: Array<{
          __typename: 'AccessibleItem';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: EntityType;
          entityId: string;
          personId: string;
          userRoles: Array<UserRole | null> | null;
        }>;
        appSettings: {
          __typename: 'UserApplicationSettings';
          tcsRealtimeTracking: {
            __typename: 'TcsRealtimeTracking';
            tabId: string | null;
            tabDate: Date | number | string | null;
          };
        } | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'PersonCollectionMetadata'; total: number };
    };
  };
};

export type SupportRequestDialogComponent_FetchAttachmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SupportRequestDialogComponent_FetchAttachmentsQuery = {
  __typename: 'Query';
  supportRequests: {
    __typename: 'SupportRequestQueries';
    byId: {
      __typename: 'SupportRequest';
      attachments: Array<{
        __typename: 'Attachment';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        attachmentEntityType: AttachmentEntityType;
        fileName: string;
        entityId: string | null;
        fileSizeInBytes: number | null;
        contentType: string | null;
      }>;
    } | null;
  };
};

export type SupportRequestListComponent_FetchAllSupportRequestsQueryVariables = Exact<{
  filter: InputMaybe<SupportRequestFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type SupportRequestListComponent_FetchAllSupportRequestsQuery = {
  __typename: 'Query';
  supportRequests: {
    __typename: 'SupportRequestQueries';
    all: {
      __typename: 'SupportRequestCollection';
      items: Array<{
        __typename: 'SupportRequest';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        supportRequestType: SupportRequestType;
        isEmailSent: boolean;
        supportRequestStatus: SupportRequestStatus;
        personId: string;
        companyId: string;
        subject: string | null;
        content: string | null;
        notes: string | null;
        attachments: Array<{
          __typename: 'Attachment';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          attachmentEntityType: AttachmentEntityType;
          fileName: string;
          entityId: string | null;
          fileSizeInBytes: number | null;
          contentType: string | null;
        }>;
      }>;
      meta: { __typename: 'SupportRequestCollectionMetadata'; total: number };
    };
  };
};

export type SupportRequestResolver_FetchSupportRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SupportRequestResolver_FetchSupportRequestQuery = {
  __typename: 'Query';
  supportRequests: {
    __typename: 'SupportRequestQueries';
    byId: {
      __typename: 'SupportRequest';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      supportRequestType: SupportRequestType;
      isEmailSent: boolean;
      supportRequestStatus: SupportRequestStatus;
      personId: string;
      companyId: string;
      subject: string | null;
      content: string | null;
      notes: string | null;
      attachments: Array<{
        __typename: 'Attachment';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        attachmentEntityType: AttachmentEntityType;
        fileName: string;
        entityId: string | null;
        fileSizeInBytes: number | null;
        contentType: string | null;
      }>;
    } | null;
  };
};

export type DeveloperNotesPageComponent_FetchDevNotesQueryVariables = Exact<{
  filter: InputMaybe<DevNoteFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type DeveloperNotesPageComponent_FetchDevNotesQuery = {
  __typename: 'Query';
  cardNotes: {
    __typename: 'CardNoteQueries';
    devNotes: {
      __typename: 'DevNoteCollection';
      items: Array<{
        __typename: 'DevNoteResult';
        content: string | null;
        noteTime: Date | number | string | null;
        authorId: string;
        dateCreated: Date | number | string;
        cardNumber: string | null;
        companyName: string | null;
        name: string | null;
      }>;
      meta: { __typename: 'DevNoteCollectionMetadata'; total: number };
    };
  };
};

export type GetFleetStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetFleetStatusQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    all: {
      __typename: 'UnitCollection';
      items: Array<{
        __typename: 'Unit';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        baseId: string;
        regionId: string;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        integrations: Array<IntegrationSystem>;
        isCrewAvailable: boolean;
        updatePhoneNumbersFromExternal: boolean;
        companyId: string;
        isAdministrative: boolean | null;
        vehicleId: string | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        oemPlacardNumber: string | null;
        primaryOutOfServiceEventId: string | null;
        emSystemResourceId: string | null;
        onBaseETAInMinutes: number | null;
        crewSourcedFromUnitId: string | null;
        completeFlightInstanceId: string | null;
        parentUnitId: string | null;
        vehicle: {
          __typename: 'Vehicle';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          isUnderLease: boolean;
          role: VehicleRole;
          flightLogProcess: FlightLogProcess;
          isPlaceholder: boolean;
          stateInspectionRequired: boolean;
          isRetired: boolean;
          isPositionTrackingEnabled: boolean;
          hideFromOOSRUM: boolean;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          year: number | null;
          dateAcquired: Date | number | string | null;
          makeId: string | null;
          modelId: string | null;
          cruiseSpeed: number | null;
          configurationClassId: string | null;
          isThirdPartyVehicle: boolean | null;
          parentUnitId: string | null;
          isHidden: boolean | null;
          faaCompanyId: string | null;
          skytracIMEI: string | null;
          phoneNumber: string | null;
          completeFlightId: string | null;
          controlZoneId: string | null;
          communicationCenterId: string | null;
          regionId: string | null;
          vehicleDescription: string | null;
          make: {
            __typename: 'VehicleMake';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
          } | null;
          model: {
            __typename: 'VehicleModel';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            cruiseSpeedInMph: number | null;
          } | null;
          vehicleDispositions: Array<{
            __typename: 'VehicleDisposition';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            vehicleId: string;
            status: VehicleStatus;
            companyId: string;
            currentWaypointId: string | null;
            currentTripLegId: string | null;
            currentTripId: string | null;
            lastTripId: string | null;
            currentAgencyLocationId: string | null;
            notes: string | null;
            isAssetOutOfService: boolean | null;
            lastQualifyingPositionReportTime: Date | number | string | null;
            latitude: number | null;
            longitude: number | null;
            etlo: Date | number | string | null;
            statusDescription: string | null;
            positionTime: Date | number | string | null;
            positionSource: PositionReportSource | null;
            vehiclePositionSummaryId: string | null;
            latestPositionReportId: string | null;
            latestFlightFollowingReportId: string | null;
            currentWaypoint: {
              __typename: 'Waypoint';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              companyId: string;
              timezoneCd: string | null;
              isRotorWingLz: boolean | null;
              arrivalTime: Date | number | string | null;
              departureTime: Date | number | string | null;
              locationId: string | null;
              isPatientPickup: boolean | null;
              isPatientDropoff: boolean | null;
              arrivingType: WaypointType | null;
              estimatedDurationId: string | null;
              currentEtaId: string | null;
              location: {
                __typename: 'Location';
                dateLastUpdated: Date | number | string;
                dateCreated: Date | number | string;
                dateDeleted: Date | number | string | null;
                lastUpdatedById: string | null;
                id: string;
                name: string;
                abbreviation: string;
                locationType: LocationType;
                isPreferred: boolean;
                timezoneCd: string | null;
                isRotorWingLz: boolean | null;
                notes: string | null;
                sourceSystemId: string | null;
                closedDate: Date | number | string | null;
                duplicateOfId: string | null;
                isLandingZoneOutOfService: boolean | null;
                landingZoneOutOfServiceNotes: string | null;
                landingZoneOutOfServiceExpirationDate: Date | number | string | null;
                landingZoneOutOfServiceReasonId: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
              } | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
            } | null;
            latestPositionReport: {
              __typename: 'PositionReport';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              positionTime: Date | number | string;
              source: PositionReportSource;
              tripId: string;
              companyId: string;
              altitude: number | null;
              speedInKnots: number | null;
              heading: number | null;
              estimatedMinutesEnRoute: number | null;
              fuelRemaining: string | null;
              timezoneCd: string | null;
              dateConfirmed: Date | number | string | null;
              gpsProvider: GpsProvider | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
            latestFlightFollowingReport: {
              __typename: 'FlightFollowingReport';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              tripId: string;
              companyId: string;
              summary: string | null;
              fuel: string | null;
              estimatedTimeEnrouteMinutes: number | null;
              riskAnalysis: string | null;
              flightType: FlightType | null;
              soulsOnBoard: number | null;
              highestFeatureEnroute: number | null;
              takeOffWeight: number | null;
              centerOfGravity: number | null;
              destination: string | null;
              trackingViaGps: boolean | null;
              flightRule: FlightRule | null;
              tripLegId: string | null;
              confirmedFboId: string | null;
              cruisingAltitude: number | null;
              medicalCrewRA: number | null;
            } | null;
            from: {
              __typename: 'WaypointSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
            } | null;
            to: {
              __typename: 'WaypointSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
            } | null;
          }>;
        } | null;
        crewSourcedToUnits: Array<{
          __typename: 'CrewSourcedUnit';
          id: string;
          unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
        } | null> | null;
      }>;
    };
  };
};

export type GetFleetStatusCardSummariesQueryVariables = Exact<{
  filter: InputMaybe<CardSummaryFilter>;
}>;

export type GetFleetStatusCardSummariesQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    summaries: {
      __typename: 'CardSummaryCollection';
      items: Array<{
        __typename: 'CardSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        status: CardStatus;
        cardNumber: string;
        operationType: OperationType;
        regionId: string;
        companyId: string;
        dateContactCompleted: Date | number | string | null;
        apiWebhookSubscriptionId: string | null;
        webOrderAcknowledgedTime: Date | number | string | null;
        diversionType: DiversionType | null;
        gmrUtilizationStatus: AmrUtilizationStatus | null;
        gmrCADNumber: string | null;
        vehicleId: string | null;
        vehicleSummaryId: string | null;
        communicationCenterId: string | null;
        unitId: string | null;
        unitSummaryId: string | null;
        operation: {
          __typename: 'OperationSummary';
          id: string;
          status: OperationStatus;
          unitId: string | null;
          vehicleId: string | null;
          riskAnalysisNumber: string | null;
          riskAnalysisAcknowledged: boolean | null;
          tripId: string | null;
        } | null;
        request: {
          __typename: 'RequestSummary';
          id: string;
          status: RequestStatus;
          isStandbyRequest: boolean;
          isSisterCompanyReferral: boolean;
          standbyActivationRequested: boolean;
          assignmentDelayedReason: string | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          assignmentDelayedTime: Date | number | string | null;
          requester: {
            __typename: 'RequesterSummary';
            id: string;
            missionRole: MissionRoleType;
            vetNumber: string | null;
          } | null;
          from: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
          to: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
        } | null;
        patients: Array<{
          __typename: 'RequestPatientSummary';
          id: string;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          dateCreated: Date | number | string | null;
        } | null> | null;
      }>;
    };
  };
};

export type GetFleetStatusActiveAlertsQueryVariables = Exact<{
  filter: InputMaybe<ActiveAlertFilter>;
}>;

export type GetFleetStatusActiveAlertsQuery = {
  __typename: 'Query';
  activeAlerts: {
    __typename: 'ActiveAlertQueries';
    all: {
      __typename: 'ActiveAlertCollection';
      items: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
        author: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
        region: {
          __typename: 'Region';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          communicationCenterId: string;
          isTransferCenterRegion: boolean;
          regionGroupId: string;
          companyId: string;
          timezoneCd: string | null;
          emSystemDivisionName: string | null;
          dispatchNumber: string | null;
          fixedWingPreferredThresholdInNauticalMiles: number | null;
          etcInMinutes: number | null;
        } | null;
        communicationCenter: {
          __typename: 'CommunicationCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          playAlertForManualPositionReports: boolean;
          enableRAAlert: boolean;
          useCrewPhoneNumber: boolean;
          displayContactTimeline: boolean;
          companyId: string;
          timezoneCd: string | null;
          primaryPhoneNumber: string | null;
          emailAddress: string | null;
          showReferToGmrWarning: boolean | null;
          alertFrequencyForGroundVehicles: number | null;
        } | null;
        activeAlertAcknowledgements: Array<{
          __typename: 'ActiveAlertAcknowledgement';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          activeAlertId: string;
          dateAcknowledged: Date | number | string;
          acknowledgedById: string;
          companyId: string;
        }>;
      }>;
    };
  };
};

export type GetFleetStatusVehiclesQueryVariables = Exact<{
  filter: InputMaybe<VehicleFilter>;
}>;

export type GetFleetStatusVehiclesQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    all: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      }>;
    };
  };
};

export type GetFleetStatusVehiclePositionSummariesQueryVariables = Exact<{
  filter: InputMaybe<VehiclePositionSummaryFilter>;
}>;

export type GetFleetStatusVehiclePositionSummariesQuery = {
  __typename: 'Query';
  vehiclePositionSummary: {
    __typename: 'vehcilePositionSummaryQueries';
    all: {
      __typename: 'VehiclePositionSummaryCollection';
      items: Array<{
        __typename: 'VehiclePositionSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        vehicleId: string;
        latitude: number;
        longitude: number;
        positionSource: PositionReportSource;
        positionTime: Date | number | string;
        companyId: string;
        lastPositionReportId: string | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        etlo: Date | number | string | null;
        lastGpsAutoPositionTime: Date | number | string | null;
        lastTakeOffTime: Date | number | string | null;
        lastLandedTime: Date | number | string | null;
        gpsProvider: GpsProvider | null;
        altitude: number | null;
        speedInKnots: number | null;
        heading: number | null;
      }>;
    };
  };
};

export type GetFleetStatusCardByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type GetFleetStatusCardByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
      activeAlerts: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
      }>;
      request: {
        __typename: 'Request';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: RequestStatus;
        requestedOperationType: OperationType;
        isStandbyRequest: boolean;
        standbyActivationRequested: boolean;
        missionConfiguration: MissionConfiguration;
        missionProfile: MissionProfile;
        companyId: string;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
        cancellationReasonNotes: string | null;
        requestedVehicleType: VehicleType | null;
        primaryUnitServiceAreaId: string | null;
        commitUnitToStandby: boolean | null;
        initiationType: RequestInitiationType | null;
        assignmentDelayedTime: Date | number | string | null;
        assignmentDelayedReasonId: string | null;
        regionId: string | null;
        includeCompetitors: boolean | null;
        transportOfferAlgorithmId: string | null;
        transportOfferAlgorithm: TransportOfferAlgorithm | null;
        minimumFlightRule: FlightRule | null;
        transportTrackingLink: string | null;
        latestWeatherDeclineUnitId: string | null;
        latestWeatherDeclineTime: Date | number | string | null;
        latestWeatherDeclineReasonId: string | null;
        latestWeatherDeclineSecondaryReasonId: string | null;
        webOrderCallType: WebOrderCallType | null;
        etloInMinutes: number | null;
        atloInMinutes: number | null;
        safetyQuestions: {
          __typename: 'SafetyQuestions';
          otherServiceDeclined: boolean | null;
          otherServiceDescription: string | null;
          otherServicesAreRespondingToTransferring: boolean | null;
          otherServiceResponseDescription: string | null;
        };
        requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
      } | null;
      operation: {
        __typename: 'Operation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: OperationStatus;
        type: OperationType;
        vehicleId: string;
        dateOperationStarted: Date | number | string;
        riskAnalysisAcknowledged: boolean;
        companyId: string;
        unitId: string | null;
        dateOperationEnded: Date | number | string | null;
        unitActivationTime: Date | number | string | null;
        riskAnalysisNumber: string | null;
        standbyActivationType: StandbyActivationType | null;
        caller: string | null;
        callbackNumber: string | null;
        initialOperationType: OperationType | null;
        unit: {
          __typename: 'Unit';
          excludeStates: Array<string | null> | null;
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          baseId: string;
          regionId: string;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          integrations: Array<IntegrationSystem>;
          isCrewAvailable: boolean;
          updatePhoneNumbersFromExternal: boolean;
          companyId: string;
          isAdministrative: boolean | null;
          vehicleId: string | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          oemPlacardNumber: string | null;
          primaryOutOfServiceEventId: string | null;
          emSystemResourceId: string | null;
          onBaseETAInMinutes: number | null;
          crewSourcedFromUnitId: string | null;
          completeFlightInstanceId: string | null;
          parentUnitId: string | null;
          positions: Array<{
            __typename: 'UnitPosition';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            type: UnitPositionType;
            isFlightCrew: boolean;
            isNonEmployee: boolean;
            unitId: string;
            companyId: string;
            notificationAddress: string | null;
            teamMemberId: string | null;
            firstName: string | null;
            lastName: string | null;
            teamMember: {
              __typename: 'Person';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              firstName: string;
              lastName: string;
              email: string;
              employeeType: EmployeeType;
              timeType: TimeType;
              activateOktaAccount: boolean;
              grantTcsAccess: boolean;
              isOutOfFlightCompliance: boolean;
              companyId: string;
              title: string | null;
              employeeId: string | null;
              hireDate: Date | number | string | null;
              terminationDate: Date | number | string | null;
              departmentId: string | null;
              reportsToPersonId: string | null;
              baseId: string | null;
              locationId: string | null;
              programId: string | null;
              activeDirectoryId: string | null;
              notificationAddress: string | null;
              userRoles: Array<UserRole | null> | null;
              allCompaniesAccessible: boolean | null;
              allBasesAccessible: boolean | null;
              allTrmProgramsAccessible: boolean | null;
              allCommunicationCentersAccessible: boolean | null;
              faaCompanyId: string | null;
              dispatchCompanyId: string | null;
              aviationCompanyId: string | null;
              primaryCommunicationCenterId: string | null;
              outOfFlightComplianceComment: string | null;
              dateLastUpdatedFromGMRWorkday: Date | number | string | null;
              appSettings: {
                __typename: 'UserApplicationSettings';
                tcsRealtimeTracking: {
                  __typename: 'TcsRealtimeTracking';
                  tabId: string | null;
                  tabDate: Date | number | string | null;
                };
              } | null;
              additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
            } | null;
          }>;
          shifts: Array<{
            __typename: 'UnitShift';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            startTimeInMinutes: number;
            endTimeInMinutes: number;
            unitId: string;
            companyId: string;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
            model: {
              __typename: 'VehicleModel';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              cruiseSpeedInMph: number | null;
            } | null;
            vehicleStateInspections: Array<{
              __typename: 'VehicleStateInspection';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              stateAbbrevation: string;
              inspectionDate: Date | number | string;
              vehicleId: string;
              companyId: string;
            }>;
          } | null;
          crewSourcedToUnits: Array<{
            __typename: 'CrewSourcedUnit';
            id: string;
            unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
          } | null> | null;
        } | null;
        trips: Array<{
          __typename: 'Trip';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          operationId: string;
          companyId: string;
          vehicleId: string | null;
          agencyId: string | null;
          agencyLocationId: string | null;
          calculatedLoadedMiles: number | null;
          gpsLoadedMiles: number | null;
          estimatedDurations: Array<{
            __typename: 'EstimatedDuration';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            asOfTime: Date | number | string;
            durationInMinutes: number;
            isOfficial: boolean;
            estimateSource: EstimatedDurationSource;
            durationType: EstimatedDurationType;
            ownerId: string;
            tripId: string;
            companyId: string;
            positionReportId: string | null;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
          } | null;
          agency: {
            __typename: 'Agency';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            type: AgencyType;
            isCompetitor: boolean;
            isInternallyOwned: boolean;
            parentCompanyId: string | null;
            notes: string | null;
          } | null;
          etas: Array<{
            __typename: 'Eta';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            asOfTime: Date | number | string;
            estimatedArrivalTime: Date | number | string;
            calculatedArrivalTime: Date | number | string;
            currentTripId: string;
            waypointId: string;
            companyId: string;
          }>;
          positionReports: Array<{
            __typename: 'PositionReport';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
            tripId: string;
            companyId: string;
            altitude: number | null;
            speedInKnots: number | null;
            heading: number | null;
            estimatedMinutesEnRoute: number | null;
            fuelRemaining: string | null;
            timezoneCd: string | null;
            dateConfirmed: Date | number | string | null;
            gpsProvider: GpsProvider | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          }>;
          flightFollowingReports: Array<{
            __typename: 'FlightFollowingReport';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            tripId: string;
            companyId: string;
            summary: string | null;
            fuel: string | null;
            estimatedTimeEnrouteMinutes: number | null;
            riskAnalysis: string | null;
            flightType: FlightType | null;
            soulsOnBoard: number | null;
            highestFeatureEnroute: number | null;
            takeOffWeight: number | null;
            centerOfGravity: number | null;
            destination: string | null;
            trackingViaGps: boolean | null;
            flightRule: FlightRule | null;
            tripLegId: string | null;
            confirmedFboId: string | null;
            cruisingAltitude: number | null;
            medicalCrewRA: number | null;
          }>;
          passengers: Array<{
            __typename: 'TripPassenger';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            type: PassengerType;
            tripId: string;
            companyId: string;
            weightInKg: number | null;
            positionName: string | null;
            positionType: UnitPositionType | null;
            notificationAddress: string | null;
            personId: string | null;
            crewMemberId: string | null;
            manifestEntries: Array<{
              __typename: 'ManifestEntry';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              passengerId: string;
              tripLegId: string;
              companyId: string;
              confirmedAt: Date | number | string | null;
              confirmedById: string | null;
            }>;
          }>;
          legs: Array<{
            __typename: 'TripLeg';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: TripLegStatus;
            sequence: number;
            tripId: string;
            companyId: string;
            estimatedDistanceInMiles: number | null;
            departingOdometerReading: number | null;
            departingNote: string | null;
            arrivingOdometerReading: number | null;
            arrivingNote: string | null;
            isEmergent: boolean | null;
            abortDate: Date | number | string | null;
            encodedPolyline: string | null;
            dateOnFinalMarked: Date | number | string | null;
            officialEteId: string | null;
            calculatedEteId: string | null;
            endingWaypointId: string | null;
            startingWaypointId: string | null;
            startingWaypoint: {
              __typename: 'Waypoint';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              companyId: string;
              timezoneCd: string | null;
              isRotorWingLz: boolean | null;
              arrivalTime: Date | number | string | null;
              departureTime: Date | number | string | null;
              locationId: string | null;
              isPatientPickup: boolean | null;
              isPatientDropoff: boolean | null;
              arrivingType: WaypointType | null;
              estimatedDurationId: string | null;
              currentEtaId: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              location: {
                __typename: 'Location';
                dateLastUpdated: Date | number | string;
                dateCreated: Date | number | string;
                dateDeleted: Date | number | string | null;
                lastUpdatedById: string | null;
                id: string;
                name: string;
                abbreviation: string;
                locationType: LocationType;
                isPreferred: boolean;
                timezoneCd: string | null;
                isRotorWingLz: boolean | null;
                notes: string | null;
                sourceSystemId: string | null;
                closedDate: Date | number | string | null;
                duplicateOfId: string | null;
                isLandingZoneOutOfService: boolean | null;
                landingZoneOutOfServiceNotes: string | null;
                landingZoneOutOfServiceExpirationDate: Date | number | string | null;
                landingZoneOutOfServiceReasonId: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
              } | null;
            } | null;
            endingWaypoint: {
              __typename: 'Waypoint';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              companyId: string;
              timezoneCd: string | null;
              isRotorWingLz: boolean | null;
              arrivalTime: Date | number | string | null;
              departureTime: Date | number | string | null;
              locationId: string | null;
              isPatientPickup: boolean | null;
              isPatientDropoff: boolean | null;
              arrivingType: WaypointType | null;
              estimatedDurationId: string | null;
              currentEtaId: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              location: {
                __typename: 'Location';
                dateLastUpdated: Date | number | string;
                dateCreated: Date | number | string;
                dateDeleted: Date | number | string | null;
                lastUpdatedById: string | null;
                id: string;
                name: string;
                abbreviation: string;
                locationType: LocationType;
                isPreferred: boolean;
                timezoneCd: string | null;
                isRotorWingLz: boolean | null;
                notes: string | null;
                sourceSystemId: string | null;
                closedDate: Date | number | string | null;
                duplicateOfId: string | null;
                isLandingZoneOutOfService: boolean | null;
                landingZoneOutOfServiceNotes: string | null;
                landingZoneOutOfServiceExpirationDate: Date | number | string | null;
                landingZoneOutOfServiceReasonId: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
              } | null;
            } | null;
          }>;
        }>;
      } | null;
    } | null;
  };
};

export type GetFleetStatusVehicleDispositionsQueryVariables = Exact<{
  filter: InputMaybe<VehicleDispositionFilter>;
}>;

export type GetFleetStatusVehicleDispositionsQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    dispositions: {
      __typename: 'VehicleDispositionCollection';
      items: Array<{
        __typename: 'VehicleDisposition';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        vehicleId: string;
        status: VehicleStatus;
        companyId: string;
        currentWaypointId: string | null;
        currentTripLegId: string | null;
        currentTripId: string | null;
        lastTripId: string | null;
        currentAgencyLocationId: string | null;
        notes: string | null;
        isAssetOutOfService: boolean | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        latitude: number | null;
        longitude: number | null;
        etlo: Date | number | string | null;
        statusDescription: string | null;
        positionTime: Date | number | string | null;
        positionSource: PositionReportSource | null;
        vehiclePositionSummaryId: string | null;
        latestPositionReportId: string | null;
        latestFlightFollowingReportId: string | null;
        from: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        to: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
      }>;
    };
  };
};

export type GetFleetStatusWaypointsQueryVariables = Exact<{
  filter: InputMaybe<WaypointFilter>;
}>;

export type GetFleetStatusWaypointsQuery = {
  __typename: 'Query';
  waypoints: {
    __typename: 'WaypointQueries';
    all: {
      __typename: 'WaypointCollection';
      items: Array<{
        __typename: 'Waypoint';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        type: WaypointType;
        companyId: string;
        timezoneCd: string | null;
        isRotorWingLz: boolean | null;
        arrivalTime: Date | number | string | null;
        departureTime: Date | number | string | null;
        locationId: string | null;
        isPatientPickup: boolean | null;
        isPatientDropoff: boolean | null;
        arrivingType: WaypointType | null;
        estimatedDurationId: string | null;
        currentEtaId: string | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        };
      }>;
    };
  };
};

export type GetAccessibleItemsQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type GetAccessibleItemsQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
    } | null;
  };
};

export type GetCardActiveAlertsByCardIdQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;

export type GetCardActiveAlertsByCardIdQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byId: {
      __typename: 'Card';
      activeAlerts: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
      }>;
    } | null;
  };
};

export type CardLocationInfoLocationFieldsFragment = {
  __typename: 'Location';
  id: string;
  locationType: LocationType;
  name: string;
  abbreviation: string;
  notes: string | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  };
  locationHazards: Array<{ __typename: 'LocationHazard'; id: string; hazard: string }>;
};

export type GetCardLocationInfoByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type GetCardLocationInfoByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      id: string;
      cardNumber: string;
      operationId: string | null;
      requestId: string | null;
      activeAlerts: Array<{
        __typename: 'ActiveAlert';
        id: string;
        matchType: RuleMatchType;
        urgency: AlertUrgency;
        content: string;
      }>;
      operation: {
        __typename: 'Operation';
        id: string;
        trips: Array<{
          __typename: 'Trip';
          id: string;
          legs: Array<{
            __typename: 'TripLeg';
            id: string;
            sequence: number;
            startingWaypointId: string | null;
            endingWaypointId: string | null;
            startingWaypoint: {
              __typename: 'Waypoint';
              id: string;
              type: WaypointType;
              locationId: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              location: {
                __typename: 'Location';
                id: string;
                locationType: LocationType;
                name: string;
                abbreviation: string;
                notes: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
                locationHazards: Array<{
                  __typename: 'LocationHazard';
                  id: string;
                  hazard: string;
                }>;
              } | null;
            } | null;
            endingWaypoint: {
              __typename: 'Waypoint';
              id: string;
              type: WaypointType;
              locationId: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              location: {
                __typename: 'Location';
                id: string;
                locationType: LocationType;
                name: string;
                abbreviation: string;
                notes: string | null;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                };
                locationHazards: Array<{
                  __typename: 'LocationHazard';
                  id: string;
                  hazard: string;
                }>;
              } | null;
            } | null;
          }>;
        }>;
      } | null;
      request: {
        __typename: 'Request';
        id: string;
        locations: Array<{
          __typename: 'RequestLocation';
          id: string;
          locationId: string | null;
          requestId: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          notes: string | null;
          groundContact: string | null;
          medicalFacilityId: string | null;
          fboId: string | null;
          request: {
            __typename: 'Request';
            requester: { __typename: 'Requester'; callbackNumber: string | null } | null;
          };
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
          medicalFacility: {
            __typename: 'MedicalFacility';
            id: string;
            name: string;
            abbreviation: string;
            notes: string | null;
            locationId: string | null;
            contacts: Array<{
              __typename: 'MedicalFacilityContact';
              id: string;
              name: string;
              primaryPhoneNumber: string | null;
              secondaryPhoneNumber: string | null;
              smsPhoneNumber: string | null;
              faxPhoneNumber: string | null;
            }>;
            location: {
              __typename: 'Location';
              id: string;
              locationType: LocationType;
              name: string;
              abbreviation: string;
              notes: string | null;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              };
              locationHazards: Array<{ __typename: 'LocationHazard'; id: string; hazard: string }>;
            } | null;
          } | null;
          fbo: { __typename: 'Fbo'; id: string; name: string } | null;
          rendezvousRequests: Array<{
            __typename: 'RendezvousRequest';
            id: string;
            requestLocationId: string;
            agencyEta: Date | number | string | null;
            notes: string | null;
            agencyLocation: {
              __typename: 'AgencyLocation';
              id: string;
              agencyId: string;
              name: string;
            } | null;
          }>;
        }>;
      } | null;
    } | null;
  };
};

export type GetCardNotesByCardQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;

export type GetCardNotesByCardQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byId: {
      __typename: 'Card';
      notes: Array<{
        __typename: 'CardNote';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        content: string;
        noteTime: Date | number | string;
        isInternal: boolean;
        isSystem: boolean;
        cardId: string;
        companyId: string;
        authorId: string | null;
        noteCategory: string | null;
        noteMetadataJson: string | null;
        receivedFromCardId: string | null;
        author: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
        sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
    } | null;
  };
};

export type AddressFieldsFragment = {
  __typename: 'Address';
  streetAddress: string | null;
  city: string | null;
  region: string | null;
  postalCode: string | null;
  country: string | null;
  county: string | null;
  gpsId: string | null;
  coordinates: {
    __typename: 'Coordinates';
    latitude: number | null;
    longitude: number | null;
  } | null;
};

export type AuditLogFieldsFragment = {
  __typename: 'AuditLog';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  eventCategory: string;
  commandName: string;
  success: boolean;
  occurredAt: Date | number | string;
  userId: string | null;
  userEmail: string | null;
  apiKeyId: string | null;
  impersonatedBy: string | null;
  activityId: string | null;
  errorMessage: string | null;
  sourceSystem: string | null;
  ipAddress: string | null;
  entityChanges: Array<{
    __typename: 'AuditEntityChange';
    id: string;
    entityType: string;
    entityId: string;
    changeType: string;
    properties: Array<{
      __typename: 'AuditPropertyChange';
      name: string;
      dataTypeName: string;
      previous: string;
      current: string;
    }>;
  } | null> | null;
};

export type FetchAuditLogByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAuditLogByIdQuery = {
  __typename: 'Query';
  auditLog: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | {
          __typename: 'AuditLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          eventCategory: string;
          commandName: string;
          success: boolean;
          occurredAt: Date | number | string;
          userId: string | null;
          userEmail: string | null;
          apiKeyId: string | null;
          impersonatedBy: string | null;
          activityId: string | null;
          errorMessage: string | null;
          sourceSystem: string | null;
          ipAddress: string | null;
          entityChanges: Array<{
            __typename: 'AuditEntityChange';
            id: string;
            entityType: string;
            entityId: string;
            changeType: string;
            properties: Array<{
              __typename: 'AuditPropertyChange';
              name: string;
              dataTypeName: string;
              previous: string;
              current: string;
            }>;
          } | null> | null;
        }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAuditLogByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAuditLogByIdsQuery = {
  __typename: 'Query';
  auditLog: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | {
          __typename: 'AuditLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          eventCategory: string;
          commandName: string;
          success: boolean;
          occurredAt: Date | number | string;
          userId: string | null;
          userEmail: string | null;
          apiKeyId: string | null;
          impersonatedBy: string | null;
          activityId: string | null;
          errorMessage: string | null;
          sourceSystem: string | null;
          ipAddress: string | null;
          entityChanges: Array<{
            __typename: 'AuditEntityChange';
            id: string;
            entityType: string;
            entityId: string;
            changeType: string;
            properties: Array<{
              __typename: 'AuditPropertyChange';
              name: string;
              dataTypeName: string;
              previous: string;
              current: string;
            }>;
          } | null> | null;
        }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ActivationRuleFieldsFragment = {
  __typename: 'ActivationRule';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string | null;
  isShared: boolean | null;
  companyId: string | null;
  regionId: string | null;
  baseId: string | null;
  unitId: string | null;
  vehicleId: string | null;
  specialtyTeamId: string | null;
  vehicleTypes: Array<VehicleType | null> | null;
  medicalFacilityId: string | null;
  locationId: string | null;
  operationTypes: Array<OperationType | null> | null;
  timestampTypeId: string | null;
  systemTimestampType: SystemTimestampType | null;
  outOfServiceReasonId: string | null;
  paipReasonId: string | null;
  outOfServiceType: OutOfServiceType | null;
  automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
  ageInMinutes: number | null;
  waypointTypes: Array<WaypointType | null> | null;
  missionRoleTypes: Array<MissionRoleType | null> | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  } | null;
  declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchActivationRuleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchActivationRuleByIdQuery = {
  __typename: 'Query';
  activationRule: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | {
          __typename: 'ActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string | null;
          isShared: boolean | null;
          companyId: string | null;
          regionId: string | null;
          baseId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          specialtyTeamId: string | null;
          vehicleTypes: Array<VehicleType | null> | null;
          medicalFacilityId: string | null;
          locationId: string | null;
          operationTypes: Array<OperationType | null> | null;
          timestampTypeId: string | null;
          systemTimestampType: SystemTimestampType | null;
          outOfServiceReasonId: string | null;
          paipReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
          ageInMinutes: number | null;
          waypointTypes: Array<WaypointType | null> | null;
          missionRoleTypes: Array<MissionRoleType | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchActivationRuleByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchActivationRuleByIdsQuery = {
  __typename: 'Query';
  activationRule: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | {
          __typename: 'ActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string | null;
          isShared: boolean | null;
          companyId: string | null;
          regionId: string | null;
          baseId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          specialtyTeamId: string | null;
          vehicleTypes: Array<VehicleType | null> | null;
          medicalFacilityId: string | null;
          locationId: string | null;
          operationTypes: Array<OperationType | null> | null;
          timestampTypeId: string | null;
          systemTimestampType: SystemTimestampType | null;
          outOfServiceReasonId: string | null;
          paipReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          automatedAlertAlgorithmType: AutomatedAlertAlgorithmType | null;
          ageInMinutes: number | null;
          waypointTypes: Array<WaypointType | null> | null;
          missionRoleTypes: Array<MissionRoleType | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          declineReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          communicationCenters: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ActiveAlertAcknowledgementFieldsFragment = {
  __typename: 'ActiveAlertAcknowledgement';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  activeAlertId: string;
  dateAcknowledged: Date | number | string;
  acknowledgedById: string;
  companyId: string;
};

export type FetchActiveAlertAcknowledgementByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchActiveAlertAcknowledgementByIdQuery = {
  __typename: 'Query';
  activeAlertAcknowledgement: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | {
          __typename: 'ActiveAlertAcknowledgement';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          activeAlertId: string;
          dateAcknowledged: Date | number | string;
          acknowledgedById: string;
          companyId: string;
        }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchActiveAlertAcknowledgementByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchActiveAlertAcknowledgementByIdsQuery = {
  __typename: 'Query';
  activeAlertAcknowledgement: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | {
          __typename: 'ActiveAlertAcknowledgement';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          activeAlertId: string;
          dateAcknowledged: Date | number | string;
          acknowledgedById: string;
          companyId: string;
        }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ActiveAlertFieldsFragment = {
  __typename: 'ActiveAlert';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  urgency: AlertUrgency;
  content: string;
  lifecycleStage: AlertLifecycleStage;
  requiresAcknowledgement: boolean;
  matchType: RuleMatchType;
  visibilityType: VisibilityType;
  isGpsAlert: boolean;
  isActive: boolean;
  isAudible: boolean;
  isAcknowledgementRepeatable: boolean;
  companyId: string;
  target: AlertTarget | null;
  targetId: string | null;
  entityType: EntityType | null;
  entityId: string | null;
  title: string | null;
  definitionId: string | null;
  dateAcknowledged: Date | number | string | null;
  acknowledgedById: string | null;
  parentEntityType: EntityType | null;
  parentEntityId: string | null;
  activationTime: Date | number | string | null;
  escalationDurationInSeconds: number | null;
  snoozeMaxInSeconds: number | null;
  authorId: string | null;
  regionId: string | null;
  communicationCenterId: string | null;
  lookupHash: string | null;
  referenceEntityType: EntityType | null;
  referenceEntityId: string | null;
};

export type FetchActiveAlertByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchActiveAlertByIdQuery = {
  __typename: 'Query';
  activeAlert: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | {
          __typename: 'ActiveAlert';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          urgency: AlertUrgency;
          content: string;
          lifecycleStage: AlertLifecycleStage;
          requiresAcknowledgement: boolean;
          matchType: RuleMatchType;
          visibilityType: VisibilityType;
          isGpsAlert: boolean;
          isActive: boolean;
          isAudible: boolean;
          isAcknowledgementRepeatable: boolean;
          companyId: string;
          target: AlertTarget | null;
          targetId: string | null;
          entityType: EntityType | null;
          entityId: string | null;
          title: string | null;
          definitionId: string | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          parentEntityType: EntityType | null;
          parentEntityId: string | null;
          activationTime: Date | number | string | null;
          escalationDurationInSeconds: number | null;
          snoozeMaxInSeconds: number | null;
          authorId: string | null;
          regionId: string | null;
          communicationCenterId: string | null;
          lookupHash: string | null;
          referenceEntityType: EntityType | null;
          referenceEntityId: string | null;
        }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchActiveAlertByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchActiveAlertByIdsQuery = {
  __typename: 'Query';
  activeAlert: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | {
          __typename: 'ActiveAlert';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          urgency: AlertUrgency;
          content: string;
          lifecycleStage: AlertLifecycleStage;
          requiresAcknowledgement: boolean;
          matchType: RuleMatchType;
          visibilityType: VisibilityType;
          isGpsAlert: boolean;
          isActive: boolean;
          isAudible: boolean;
          isAcknowledgementRepeatable: boolean;
          companyId: string;
          target: AlertTarget | null;
          targetId: string | null;
          entityType: EntityType | null;
          entityId: string | null;
          title: string | null;
          definitionId: string | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          parentEntityType: EntityType | null;
          parentEntityId: string | null;
          activationTime: Date | number | string | null;
          escalationDurationInSeconds: number | null;
          snoozeMaxInSeconds: number | null;
          authorId: string | null;
          regionId: string | null;
          communicationCenterId: string | null;
          lookupHash: string | null;
          referenceEntityType: EntityType | null;
          referenceEntityId: string | null;
        }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ActiveCardUnitOfferingFieldsFragment = {
  __typename: 'ActiveCardUnitOffering';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  cardId: string;
  unitId: string;
  companyId: string;
};

export type FetchActiveCardUnitOfferingByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchActiveCardUnitOfferingByIdQuery = {
  __typename: 'Query';
  activeCardUnitOffering: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | {
          __typename: 'ActiveCardUnitOffering';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          cardId: string;
          unitId: string;
          companyId: string;
        }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchActiveCardUnitOfferingByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchActiveCardUnitOfferingByIdsQuery = {
  __typename: 'Query';
  activeCardUnitOffering: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | {
          __typename: 'ActiveCardUnitOffering';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          cardId: string;
          unitId: string;
          companyId: string;
        }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ActiveTimelineFieldsFragment = {
  __typename: 'ActiveTimeline';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  timelineId: string;
  companyId: string;
  matchType: RuleMatchType;
  entityType: EntityType;
  entityId: string;
};

export type FetchActiveTimelineByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchActiveTimelineByIdQuery = {
  __typename: 'Query';
  activeTimeline: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | {
          __typename: 'ActiveTimeline';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          timelineId: string;
          companyId: string;
          matchType: RuleMatchType;
          entityType: EntityType;
          entityId: string;
        }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchActiveTimelineByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchActiveTimelineByIdsQuery = {
  __typename: 'Query';
  activeTimeline: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | {
          __typename: 'ActiveTimeline';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          timelineId: string;
          companyId: string;
          matchType: RuleMatchType;
          entityType: EntityType;
          entityId: string;
        }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type AlertFieldsFragment = {
  __typename: 'Alert';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  entityType: EntityType;
  activationRuleId: string;
  urgency: AlertUrgency;
  content: string;
  lifecycleStage: AlertLifecycleStage;
  requiresAcknowledgement: boolean;
  isAudible: boolean;
  title: string | null;
  effectiveDate: Date | number | string | null;
  expirationDate: Date | number | string | null;
  paused: boolean | null;
  createdById: string | null;
};

export type FetchAlertByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAlertByIdQuery = {
  __typename: 'Query';
  alert: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | {
          __typename: 'Alert';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          entityType: EntityType;
          activationRuleId: string;
          urgency: AlertUrgency;
          content: string;
          lifecycleStage: AlertLifecycleStage;
          requiresAcknowledgement: boolean;
          isAudible: boolean;
          title: string | null;
          effectiveDate: Date | number | string | null;
          expirationDate: Date | number | string | null;
          paused: boolean | null;
          createdById: string | null;
        }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAlertByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAlertByIdsQuery = {
  __typename: 'Query';
  alert: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | {
          __typename: 'Alert';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          entityType: EntityType;
          activationRuleId: string;
          urgency: AlertUrgency;
          content: string;
          lifecycleStage: AlertLifecycleStage;
          requiresAcknowledgement: boolean;
          isAudible: boolean;
          title: string | null;
          effectiveDate: Date | number | string | null;
          expirationDate: Date | number | string | null;
          paused: boolean | null;
          createdById: string | null;
        }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ApplicationNotificationFieldsFragment = {
  __typename: 'ApplicationNotification';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  urgency: ApplicationNotificationUrgency;
  displayOnBanner: boolean;
  dismissable: boolean;
  notification: string;
  title: string | null;
  effectiveDate: Date | number | string | null;
  expirationDate: Date | number | string | null;
  createdById: string | null;
  companyId: string | null;
  regionId: string | null;
};

export type FetchApplicationNotificationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchApplicationNotificationByIdQuery = {
  __typename: 'Query';
  applicationNotification: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | {
          __typename: 'ApplicationNotification';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          urgency: ApplicationNotificationUrgency;
          displayOnBanner: boolean;
          dismissable: boolean;
          notification: string;
          title: string | null;
          effectiveDate: Date | number | string | null;
          expirationDate: Date | number | string | null;
          createdById: string | null;
          companyId: string | null;
          regionId: string | null;
        }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchApplicationNotificationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchApplicationNotificationByIdsQuery = {
  __typename: 'Query';
  applicationNotification: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | {
          __typename: 'ApplicationNotification';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          urgency: ApplicationNotificationUrgency;
          displayOnBanner: boolean;
          dismissable: boolean;
          notification: string;
          title: string | null;
          effectiveDate: Date | number | string | null;
          expirationDate: Date | number | string | null;
          createdById: string | null;
          companyId: string | null;
          regionId: string | null;
        }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type AssignmentDelayedReasonFieldsFragment = {
  __typename: 'AssignmentDelayedReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchAssignmentDelayedReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAssignmentDelayedReasonByIdQuery = {
  __typename: 'Query';
  assignmentDelayedReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | {
          __typename: 'AssignmentDelayedReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAssignmentDelayedReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAssignmentDelayedReasonByIdsQuery = {
  __typename: 'Query';
  assignmentDelayedReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | {
          __typename: 'AssignmentDelayedReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CancellationCategoryFieldsFragment = {
  __typename: 'CancellationCategory';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  isVisibleInOps: boolean;
  defaultCancellationReasonId: string | null;
};

export type FetchCancellationCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCancellationCategoryByIdQuery = {
  __typename: 'Query';
  cancellationCategory: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | {
          __typename: 'CancellationCategory';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isVisibleInOps: boolean;
          defaultCancellationReasonId: string | null;
        }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCancellationCategoryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCancellationCategoryByIdsQuery = {
  __typename: 'Query';
  cancellationCategory: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | {
          __typename: 'CancellationCategory';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isVisibleInOps: boolean;
          defaultCancellationReasonId: string | null;
        }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CancellationReasonFieldsFragment = {
  __typename: 'CancellationReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  isTransferCenterReason: boolean;
  secondaryReasonRequired: boolean;
  canBeUnitCancellationReason: boolean | null;
  cancellationCategoryId: string | null;
};

export type FetchCancellationReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCancellationReasonByIdQuery = {
  __typename: 'Query';
  cancellationReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | {
          __typename: 'CancellationReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          isTransferCenterReason: boolean;
          secondaryReasonRequired: boolean;
          canBeUnitCancellationReason: boolean | null;
          cancellationCategoryId: string | null;
        }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCancellationReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCancellationReasonByIdsQuery = {
  __typename: 'Query';
  cancellationReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | {
          __typename: 'CancellationReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          isTransferCenterReason: boolean;
          secondaryReasonRequired: boolean;
          canBeUnitCancellationReason: boolean | null;
          cancellationCategoryId: string | null;
        }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CancellationSecondaryReasonFieldsFragment = {
  __typename: 'CancellationSecondaryReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  cancellationReasonId: string;
};

export type FetchCancellationSecondaryReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCancellationSecondaryReasonByIdQuery = {
  __typename: 'Query';
  cancellationSecondaryReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | {
          __typename: 'CancellationSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cancellationReasonId: string;
        }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCancellationSecondaryReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCancellationSecondaryReasonByIdsQuery = {
  __typename: 'Query';
  cancellationSecondaryReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | {
          __typename: 'CancellationSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cancellationReasonId: string;
        }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CardFieldsFragment = {
  __typename: 'Card';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: CardStatus;
  cardNumber: string;
  companyId: string;
  dateContactCompleted: Date | number | string | null;
  dateCardClosed: Date | number | string | null;
  transferredToCardId: string | null;
  transferredFromCardId: string | null;
  linkedCardId: string | null;
  closeComment: string | null;
  reOpenComment: string | null;
  postTransportDebriefCompleted: boolean | null;
  isBillable: boolean | null;
  notBillableType: NotBillableType | null;
  notBillableComment: string | null;
  apiWebhookSubscriptionId: string | null;
  createdById: string | null;
  plannedCompletionTime: Date | number | string | null;
  reOpenReasonId: string | null;
  lastOperationId: string | null;
  diversionType: DiversionType | null;
  gmrUtilizationStatus: AmrUtilizationStatus | null;
  gmrCADNumber: string | null;
  isLocked: boolean | null;
  crewWillTransportWithReplacementGroundUnit: boolean | null;
  operationId: string | null;
  requestId: string | null;
};

export type FetchCardByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCardByIdQuery = {
  __typename: 'Query';
  card: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | {
          __typename: 'Card';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: CardStatus;
          cardNumber: string;
          companyId: string;
          dateContactCompleted: Date | number | string | null;
          dateCardClosed: Date | number | string | null;
          transferredToCardId: string | null;
          transferredFromCardId: string | null;
          linkedCardId: string | null;
          closeComment: string | null;
          reOpenComment: string | null;
          postTransportDebriefCompleted: boolean | null;
          isBillable: boolean | null;
          notBillableType: NotBillableType | null;
          notBillableComment: string | null;
          apiWebhookSubscriptionId: string | null;
          createdById: string | null;
          plannedCompletionTime: Date | number | string | null;
          reOpenReasonId: string | null;
          lastOperationId: string | null;
          diversionType: DiversionType | null;
          gmrUtilizationStatus: AmrUtilizationStatus | null;
          gmrCADNumber: string | null;
          isLocked: boolean | null;
          crewWillTransportWithReplacementGroundUnit: boolean | null;
          operationId: string | null;
          requestId: string | null;
        }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCardByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCardByIdsQuery = {
  __typename: 'Query';
  card: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | {
          __typename: 'Card';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: CardStatus;
          cardNumber: string;
          companyId: string;
          dateContactCompleted: Date | number | string | null;
          dateCardClosed: Date | number | string | null;
          transferredToCardId: string | null;
          transferredFromCardId: string | null;
          linkedCardId: string | null;
          closeComment: string | null;
          reOpenComment: string | null;
          postTransportDebriefCompleted: boolean | null;
          isBillable: boolean | null;
          notBillableType: NotBillableType | null;
          notBillableComment: string | null;
          apiWebhookSubscriptionId: string | null;
          createdById: string | null;
          plannedCompletionTime: Date | number | string | null;
          reOpenReasonId: string | null;
          lastOperationId: string | null;
          diversionType: DiversionType | null;
          gmrUtilizationStatus: AmrUtilizationStatus | null;
          gmrCADNumber: string | null;
          isLocked: boolean | null;
          crewWillTransportWithReplacementGroundUnit: boolean | null;
          operationId: string | null;
          requestId: string | null;
        }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CardLinkFieldsFragment = {
  __typename: 'CardLink';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  type: CardLinkType;
  fromCardId: string;
  toCardId: string;
  toCardNumber: string;
  companyId: string;
  rendezvousRequestId: string | null;
};

export type FetchCardLinkByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCardLinkByIdQuery = {
  __typename: 'Query';
  cardLink: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | {
          __typename: 'CardLink';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: CardLinkType;
          fromCardId: string;
          toCardId: string;
          toCardNumber: string;
          companyId: string;
          rendezvousRequestId: string | null;
        }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCardLinkByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCardLinkByIdsQuery = {
  __typename: 'Query';
  cardLink: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | {
          __typename: 'CardLink';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: CardLinkType;
          fromCardId: string;
          toCardId: string;
          toCardNumber: string;
          companyId: string;
          rendezvousRequestId: string | null;
        }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CardNoteArchiveFieldsFragment = {
  __typename: 'CardNoteArchive';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  content: string;
  noteTime: Date | number | string;
  isInternal: boolean;
  isSystem: boolean;
  dateArchived: Date | number | string;
  cardId: string;
  companyId: string;
  authorId: string | null;
  noteCategory: string | null;
  noteMetadataJson: string | null;
  receivedFromCardId: string | null;
  sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchCardNoteArchiveByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCardNoteArchiveByIdQuery = {
  __typename: 'Query';
  cardNoteArchive: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | {
          __typename: 'CardNoteArchive';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          content: string;
          noteTime: Date | number | string;
          isInternal: boolean;
          isSystem: boolean;
          dateArchived: Date | number | string;
          cardId: string;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
          receivedFromCardId: string | null;
          sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCardNoteArchiveByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCardNoteArchiveByIdsQuery = {
  __typename: 'Query';
  cardNoteArchive: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | {
          __typename: 'CardNoteArchive';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          content: string;
          noteTime: Date | number | string;
          isInternal: boolean;
          isSystem: boolean;
          dateArchived: Date | number | string;
          cardId: string;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
          receivedFromCardId: string | null;
          sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CardNoteFieldsFragment = {
  __typename: 'CardNote';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  content: string;
  noteTime: Date | number | string;
  isInternal: boolean;
  isSystem: boolean;
  cardId: string;
  companyId: string;
  authorId: string | null;
  noteCategory: string | null;
  noteMetadataJson: string | null;
  receivedFromCardId: string | null;
  sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchCardNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCardNoteByIdQuery = {
  __typename: 'Query';
  cardNote: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | {
          __typename: 'CardNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          content: string;
          noteTime: Date | number | string;
          isInternal: boolean;
          isSystem: boolean;
          cardId: string;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
          receivedFromCardId: string | null;
          sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCardNoteByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCardNoteByIdsQuery = {
  __typename: 'Query';
  cardNote: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | {
          __typename: 'CardNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          content: string;
          noteTime: Date | number | string;
          isInternal: boolean;
          isSystem: boolean;
          cardId: string;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
          receivedFromCardId: string | null;
          sentToCards: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CardReOpenReasonFieldsFragment = {
  __typename: 'CardReOpenReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  affectsTrip: boolean;
};

export type FetchCardReOpenReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCardReOpenReasonByIdQuery = {
  __typename: 'Query';
  cardReOpenReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | {
          __typename: 'CardReOpenReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          affectsTrip: boolean;
        }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCardReOpenReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCardReOpenReasonByIdsQuery = {
  __typename: 'Query';
  cardReOpenReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | {
          __typename: 'CardReOpenReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          affectsTrip: boolean;
        }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CardSummaryFieldsFragment = {
  __typename: 'CardSummary';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  id: string;
  status: CardStatus;
  cardNumber: string;
  operationType: OperationType;
  regionId: string;
  companyId: string;
  dateContactCompleted: Date | number | string | null;
  apiWebhookSubscriptionId: string | null;
  webOrderAcknowledgedTime: Date | number | string | null;
  diversionType: DiversionType | null;
  gmrUtilizationStatus: AmrUtilizationStatus | null;
  gmrCADNumber: string | null;
  vehicleId: string | null;
  vehicleSummaryId: string | null;
  communicationCenterId: string | null;
  unitId: string | null;
  unitSummaryId: string | null;
  operation: {
    __typename: 'OperationSummary';
    id: string;
    status: OperationStatus;
    unitId: string | null;
    vehicleId: string | null;
    riskAnalysisNumber: string | null;
    riskAnalysisAcknowledged: boolean | null;
    tripId: string | null;
  } | null;
  request: {
    __typename: 'RequestSummary';
    id: string;
    status: RequestStatus;
    isStandbyRequest: boolean;
    isSisterCompanyReferral: boolean;
    standbyActivationRequested: boolean;
    assignmentDelayedReason: string | null;
    transportTrackingLink: string | null;
    latestWeatherDeclineUnitId: string | null;
    latestWeatherDeclineTime: Date | number | string | null;
    latestWeatherDeclineReasonId: string | null;
    latestWeatherDeclineSecondaryReasonId: string | null;
    assignmentDelayedTime: Date | number | string | null;
    requester: {
      __typename: 'RequesterSummary';
      id: string;
      missionRole: MissionRoleType;
      vetNumber: string | null;
    } | null;
    from: {
      __typename: 'RequestLocationSummary';
      id: string;
      name: string;
      abbreviation: string;
      type: WaypointType;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
    } | null;
    to: {
      __typename: 'RequestLocationSummary';
      id: string;
      name: string;
      abbreviation: string;
      type: WaypointType;
      address: {
        __typename: 'Address';
        streetAddress: string | null;
        city: string | null;
        region: string | null;
        postalCode: string | null;
        country: string | null;
        county: string | null;
        gpsId: string | null;
        coordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
  patients: Array<{
    __typename: 'RequestPatientSummary';
    id: string;
    dateOfBirth: Date | number | string | null;
    weightInKg: number | null;
    dateCreated: Date | number | string | null;
  } | null> | null;
};

export type FetchCardSummaryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCardSummaryByIdQuery = {
  __typename: 'Query';
  cardSummary: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | {
          __typename: 'CardSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          status: CardStatus;
          cardNumber: string;
          operationType: OperationType;
          regionId: string;
          companyId: string;
          dateContactCompleted: Date | number | string | null;
          apiWebhookSubscriptionId: string | null;
          webOrderAcknowledgedTime: Date | number | string | null;
          diversionType: DiversionType | null;
          gmrUtilizationStatus: AmrUtilizationStatus | null;
          gmrCADNumber: string | null;
          vehicleId: string | null;
          vehicleSummaryId: string | null;
          communicationCenterId: string | null;
          unitId: string | null;
          unitSummaryId: string | null;
          operation: {
            __typename: 'OperationSummary';
            id: string;
            status: OperationStatus;
            unitId: string | null;
            vehicleId: string | null;
            riskAnalysisNumber: string | null;
            riskAnalysisAcknowledged: boolean | null;
            tripId: string | null;
          } | null;
          request: {
            __typename: 'RequestSummary';
            id: string;
            status: RequestStatus;
            isStandbyRequest: boolean;
            isSisterCompanyReferral: boolean;
            standbyActivationRequested: boolean;
            assignmentDelayedReason: string | null;
            transportTrackingLink: string | null;
            latestWeatherDeclineUnitId: string | null;
            latestWeatherDeclineTime: Date | number | string | null;
            latestWeatherDeclineReasonId: string | null;
            latestWeatherDeclineSecondaryReasonId: string | null;
            assignmentDelayedTime: Date | number | string | null;
            requester: {
              __typename: 'RequesterSummary';
              id: string;
              missionRole: MissionRoleType;
              vetNumber: string | null;
            } | null;
            from: {
              __typename: 'RequestLocationSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              } | null;
            } | null;
            to: {
              __typename: 'RequestLocationSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              } | null;
            } | null;
          } | null;
          patients: Array<{
            __typename: 'RequestPatientSummary';
            id: string;
            dateOfBirth: Date | number | string | null;
            weightInKg: number | null;
            dateCreated: Date | number | string | null;
          } | null> | null;
        }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCardSummaryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCardSummaryByIdsQuery = {
  __typename: 'Query';
  cardSummary: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | {
          __typename: 'CardSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          status: CardStatus;
          cardNumber: string;
          operationType: OperationType;
          regionId: string;
          companyId: string;
          dateContactCompleted: Date | number | string | null;
          apiWebhookSubscriptionId: string | null;
          webOrderAcknowledgedTime: Date | number | string | null;
          diversionType: DiversionType | null;
          gmrUtilizationStatus: AmrUtilizationStatus | null;
          gmrCADNumber: string | null;
          vehicleId: string | null;
          vehicleSummaryId: string | null;
          communicationCenterId: string | null;
          unitId: string | null;
          unitSummaryId: string | null;
          operation: {
            __typename: 'OperationSummary';
            id: string;
            status: OperationStatus;
            unitId: string | null;
            vehicleId: string | null;
            riskAnalysisNumber: string | null;
            riskAnalysisAcknowledged: boolean | null;
            tripId: string | null;
          } | null;
          request: {
            __typename: 'RequestSummary';
            id: string;
            status: RequestStatus;
            isStandbyRequest: boolean;
            isSisterCompanyReferral: boolean;
            standbyActivationRequested: boolean;
            assignmentDelayedReason: string | null;
            transportTrackingLink: string | null;
            latestWeatherDeclineUnitId: string | null;
            latestWeatherDeclineTime: Date | number | string | null;
            latestWeatherDeclineReasonId: string | null;
            latestWeatherDeclineSecondaryReasonId: string | null;
            assignmentDelayedTime: Date | number | string | null;
            requester: {
              __typename: 'RequesterSummary';
              id: string;
              missionRole: MissionRoleType;
              vetNumber: string | null;
            } | null;
            from: {
              __typename: 'RequestLocationSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              } | null;
            } | null;
            to: {
              __typename: 'RequestLocationSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              } | null;
            } | null;
          } | null;
          patients: Array<{
            __typename: 'RequestPatientSummary';
            id: string;
            dateOfBirth: Date | number | string | null;
            weightInKg: number | null;
            dateCreated: Date | number | string | null;
          } | null> | null;
        }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ConfigurationSettingFieldsFragment = {
  __typename: 'ConfigurationSetting';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  companyId: string | null;
  defaultUnitCommittedDeclineReasonId: string | null;
  defaultUnitOutOfServiceDeclineReasonId: string | null;
  requestReferredInternallyCancellationReasonId: string | null;
  requestReferredExternallyCancellationReasonId: string | null;
  crewGoingByGroundOutOfServiceReasonId: string | null;
  assetReassignedDeclineReasonId: string | null;
  externallyCancelledCancellationReasonId: string | null;
  pilotReportGracePeriodInMinutes: number | null;
  sameDestinationWarningThresholdInMinutes: number | null;
  bugRequestEmail: string | null;
  featureRequestEmail: string | null;
  proximityAlertDistanceInNauticalMiles: number | null;
};

export type FetchConfigurationSettingByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchConfigurationSettingByIdQuery = {
  __typename: 'Query';
  configurationSetting: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | {
          __typename: 'ConfigurationSetting';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string | null;
          defaultUnitCommittedDeclineReasonId: string | null;
          defaultUnitOutOfServiceDeclineReasonId: string | null;
          requestReferredInternallyCancellationReasonId: string | null;
          requestReferredExternallyCancellationReasonId: string | null;
          crewGoingByGroundOutOfServiceReasonId: string | null;
          assetReassignedDeclineReasonId: string | null;
          externallyCancelledCancellationReasonId: string | null;
          pilotReportGracePeriodInMinutes: number | null;
          sameDestinationWarningThresholdInMinutes: number | null;
          bugRequestEmail: string | null;
          featureRequestEmail: string | null;
          proximityAlertDistanceInNauticalMiles: number | null;
        }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchConfigurationSettingByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchConfigurationSettingByIdsQuery = {
  __typename: 'Query';
  configurationSetting: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | {
          __typename: 'ConfigurationSetting';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string | null;
          defaultUnitCommittedDeclineReasonId: string | null;
          defaultUnitOutOfServiceDeclineReasonId: string | null;
          requestReferredInternallyCancellationReasonId: string | null;
          requestReferredExternallyCancellationReasonId: string | null;
          crewGoingByGroundOutOfServiceReasonId: string | null;
          assetReassignedDeclineReasonId: string | null;
          externallyCancelledCancellationReasonId: string | null;
          pilotReportGracePeriodInMinutes: number | null;
          sameDestinationWarningThresholdInMinutes: number | null;
          bugRequestEmail: string | null;
          featureRequestEmail: string | null;
          proximityAlertDistanceInNauticalMiles: number | null;
        }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ConversationFieldsFragment = {
  __typename: 'Conversation';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  uniqueName: string;
  vendorConversationId: string;
  conversationState: ConversationState;
  entityId: string | null;
  entityType: EntityType | null;
  metadata: { __typename: 'ConversationMetadata'; name: string | null } | null;
};

export type FetchConversationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchConversationByIdQuery = {
  __typename: 'Query';
  conversation: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | {
          __typename: 'Conversation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          uniqueName: string;
          vendorConversationId: string;
          conversationState: ConversationState;
          entityId: string | null;
          entityType: EntityType | null;
          metadata: { __typename: 'ConversationMetadata'; name: string | null } | null;
        }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchConversationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchConversationByIdsQuery = {
  __typename: 'Query';
  conversation: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | {
          __typename: 'Conversation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          uniqueName: string;
          vendorConversationId: string;
          conversationState: ConversationState;
          entityId: string | null;
          entityType: EntityType | null;
          metadata: { __typename: 'ConversationMetadata'; name: string | null } | null;
        }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ConversationParticipantFieldsFragment = {
  __typename: 'ConversationParticipant';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  conversationId: string;
  messagingAddress: string;
  vendorParticipantId: string;
  metadata: { __typename: 'ParticipantMetadata'; role: string | null } | null;
};

export type FetchConversationParticipantByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchConversationParticipantByIdQuery = {
  __typename: 'Query';
  conversationParticipant: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | {
          __typename: 'ConversationParticipant';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          conversationId: string;
          messagingAddress: string;
          vendorParticipantId: string;
          metadata: { __typename: 'ParticipantMetadata'; role: string | null } | null;
        }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchConversationParticipantByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchConversationParticipantByIdsQuery = {
  __typename: 'Query';
  conversationParticipant: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | {
          __typename: 'ConversationParticipant';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          conversationId: string;
          messagingAddress: string;
          vendorParticipantId: string;
          metadata: { __typename: 'ParticipantMetadata'; role: string | null } | null;
        }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type DeclineCategoryFieldsFragment = {
  __typename: 'DeclineCategory';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  isVisibleInOps: boolean;
  defaultDeclineReasonId: string | null;
};

export type FetchDeclineCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchDeclineCategoryByIdQuery = {
  __typename: 'Query';
  declineCategory: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | {
          __typename: 'DeclineCategory';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isVisibleInOps: boolean;
          defaultDeclineReasonId: string | null;
        }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchDeclineCategoryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchDeclineCategoryByIdsQuery = {
  __typename: 'Query';
  declineCategory: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | {
          __typename: 'DeclineCategory';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isVisibleInOps: boolean;
          defaultDeclineReasonId: string | null;
        }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type DeclineReasonFieldsFragment = {
  __typename: 'DeclineReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  declineCategoryId: string;
  controllable: boolean;
  canBeSkipReason: boolean;
  canBeAbortReason: boolean;
  canBeBulkSkipReason: boolean;
  canBeOneCallSkipReason: boolean;
  isUnitAvailableAfterAbort: boolean;
  secondaryReasonRequired: boolean;
  cancellationReasonId: string | null;
  cancellationSecondaryReasonId: string | null;
};

export type FetchDeclineReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchDeclineReasonByIdQuery = {
  __typename: 'Query';
  declineReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | {
          __typename: 'DeclineReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          declineCategoryId: string;
          controllable: boolean;
          canBeSkipReason: boolean;
          canBeAbortReason: boolean;
          canBeBulkSkipReason: boolean;
          canBeOneCallSkipReason: boolean;
          isUnitAvailableAfterAbort: boolean;
          secondaryReasonRequired: boolean;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
        }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchDeclineReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchDeclineReasonByIdsQuery = {
  __typename: 'Query';
  declineReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | {
          __typename: 'DeclineReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          declineCategoryId: string;
          controllable: boolean;
          canBeSkipReason: boolean;
          canBeAbortReason: boolean;
          canBeBulkSkipReason: boolean;
          canBeOneCallSkipReason: boolean;
          isUnitAvailableAfterAbort: boolean;
          secondaryReasonRequired: boolean;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
        }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type DeclineSecondaryReasonFieldsFragment = {
  __typename: 'DeclineSecondaryReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  declineReasonId: string;
  cancellationReasonId: string | null;
  cancellationSecondaryReasonId: string | null;
};

export type FetchDeclineSecondaryReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchDeclineSecondaryReasonByIdQuery = {
  __typename: 'Query';
  declineSecondaryReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | {
          __typename: 'DeclineSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          declineReasonId: string;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
        }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchDeclineSecondaryReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchDeclineSecondaryReasonByIdsQuery = {
  __typename: 'Query';
  declineSecondaryReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | {
          __typename: 'DeclineSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          declineReasonId: string;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
        }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type DiversionReasonFieldsFragment = {
  __typename: 'DiversionReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchDiversionReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchDiversionReasonByIdQuery = {
  __typename: 'Query';
  diversionReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | {
          __typename: 'DiversionReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchDiversionReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchDiversionReasonByIdsQuery = {
  __typename: 'Query';
  diversionReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | {
          __typename: 'DiversionReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type EscortRequestFieldsFragment = {
  __typename: 'EscortRequest';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  escortName: string;
  relationship: PatientRelationshipType;
  escortWeightInKg: number;
  requestApprovalTime: Date | number | string;
  requestId: string;
  companyId: string;
};

export type FetchEscortRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchEscortRequestByIdQuery = {
  __typename: 'Query';
  escortRequest: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | {
          __typename: 'EscortRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          escortName: string;
          relationship: PatientRelationshipType;
          escortWeightInKg: number;
          requestApprovalTime: Date | number | string;
          requestId: string;
          companyId: string;
        }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchEscortRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchEscortRequestByIdsQuery = {
  __typename: 'Query';
  escortRequest: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | {
          __typename: 'EscortRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          escortName: string;
          relationship: PatientRelationshipType;
          escortWeightInKg: number;
          requestApprovalTime: Date | number | string;
          requestId: string;
          companyId: string;
        }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type EstimatedDurationFieldsFragment = {
  __typename: 'EstimatedDuration';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  asOfTime: Date | number | string;
  durationInMinutes: number;
  isOfficial: boolean;
  estimateSource: EstimatedDurationSource;
  durationType: EstimatedDurationType;
  ownerId: string;
  tripId: string;
  companyId: string;
  positionReportId: string | null;
};

export type FetchEstimatedDurationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchEstimatedDurationByIdQuery = {
  __typename: 'Query';
  estimatedDuration: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | {
          __typename: 'EstimatedDuration';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          asOfTime: Date | number | string;
          durationInMinutes: number;
          isOfficial: boolean;
          estimateSource: EstimatedDurationSource;
          durationType: EstimatedDurationType;
          ownerId: string;
          tripId: string;
          companyId: string;
          positionReportId: string | null;
        }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchEstimatedDurationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchEstimatedDurationByIdsQuery = {
  __typename: 'Query';
  estimatedDuration: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | {
          __typename: 'EstimatedDuration';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          asOfTime: Date | number | string;
          durationInMinutes: number;
          isOfficial: boolean;
          estimateSource: EstimatedDurationSource;
          durationType: EstimatedDurationType;
          ownerId: string;
          tripId: string;
          companyId: string;
          positionReportId: string | null;
        }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type EtaFieldsFragment = {
  __typename: 'Eta';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  asOfTime: Date | number | string;
  estimatedArrivalTime: Date | number | string;
  calculatedArrivalTime: Date | number | string;
  currentTripId: string;
  waypointId: string;
  companyId: string;
};

export type FetchEtaByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchEtaByIdQuery = {
  __typename: 'Query';
  eta: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | {
          __typename: 'Eta';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          asOfTime: Date | number | string;
          estimatedArrivalTime: Date | number | string;
          calculatedArrivalTime: Date | number | string;
          currentTripId: string;
          waypointId: string;
          companyId: string;
        }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchEtaByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchEtaByIdsQuery = {
  __typename: 'Query';
  eta: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | {
          __typename: 'Eta';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          asOfTime: Date | number | string;
          estimatedArrivalTime: Date | number | string;
          calculatedArrivalTime: Date | number | string;
          currentTripId: string;
          waypointId: string;
          companyId: string;
        }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ExternalActionFieldsFragment = {
  __typename: 'ExternalAction';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  entityId: string;
  status: ExternalActionStatus;
  entityType: EntityType;
  actionTypeId: string;
  actionBodyJson: string;
  companyId: string;
  completedById: string | null;
  dateCompleted: Date | number | string | null;
  notes: string | null;
};

export type FetchExternalActionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchExternalActionByIdQuery = {
  __typename: 'Query';
  externalAction: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | {
          __typename: 'ExternalAction';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          entityId: string;
          status: ExternalActionStatus;
          entityType: EntityType;
          actionTypeId: string;
          actionBodyJson: string;
          companyId: string;
          completedById: string | null;
          dateCompleted: Date | number | string | null;
          notes: string | null;
        }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchExternalActionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchExternalActionByIdsQuery = {
  __typename: 'Query';
  externalAction: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | {
          __typename: 'ExternalAction';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          entityId: string;
          status: ExternalActionStatus;
          entityType: EntityType;
          actionTypeId: string;
          actionBodyJson: string;
          companyId: string;
          completedById: string | null;
          dateCompleted: Date | number | string | null;
          notes: string | null;
        }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ExternalActionTypeFieldsFragment = {
  __typename: 'ExternalActionType';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  actionTypeName: string;
  actionTypeDescription: string;
  priority: number;
};

export type FetchExternalActionTypeByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchExternalActionTypeByIdQuery = {
  __typename: 'Query';
  externalActionType: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | {
          __typename: 'ExternalActionType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          actionTypeName: string;
          actionTypeDescription: string;
          priority: number;
        }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchExternalActionTypeByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchExternalActionTypeByIdsQuery = {
  __typename: 'Query';
  externalActionType: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | {
          __typename: 'ExternalActionType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          actionTypeName: string;
          actionTypeDescription: string;
          priority: number;
        }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ExternalSystemUnitFieldsFragment = {
  __typename: 'ExternalSystemUnit';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  unitId: string;
  vehicleId: string;
  regionId: string;
  companyId: string;
  unitStatus: UnitStatus;
  vehicleType: VehicleType;
  registrationNumber: string;
  vehicleStatus: VehicleStatus;
  vehicleStatusDescription: string;
  currentCardNumber: string | null;
  lastKnownLocationName: string | null;
  lastQualifyingPositionReportTime: Date | number | string | null;
  baseId: string | null;
  modelName: string | null;
  outOfServiceEvents: Array<{
    __typename: 'OutOfServiceEventSummary';
    id: string;
    type: OutOfServiceType;
    eventNumber: string;
    estimatedEndTime: Date | number | string;
    reasonName: string;
    reasonId: string;
    startTime: Date | number | string | null;
    isOpportunisticOOS: boolean | null;
    notes: string | null;
  }>;
  lastKnownCoordinates: {
    __typename: 'Coordinates';
    latitude: number | null;
    longitude: number | null;
  } | null;
};

export type FetchExternalSystemUnitByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchExternalSystemUnitByIdQuery = {
  __typename: 'Query';
  externalSystemUnit: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | {
          __typename: 'ExternalSystemUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          unitId: string;
          vehicleId: string;
          regionId: string;
          companyId: string;
          unitStatus: UnitStatus;
          vehicleType: VehicleType;
          registrationNumber: string;
          vehicleStatus: VehicleStatus;
          vehicleStatusDescription: string;
          currentCardNumber: string | null;
          lastKnownLocationName: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          baseId: string | null;
          modelName: string | null;
          outOfServiceEvents: Array<{
            __typename: 'OutOfServiceEventSummary';
            id: string;
            type: OutOfServiceType;
            eventNumber: string;
            estimatedEndTime: Date | number | string;
            reasonName: string;
            reasonId: string;
            startTime: Date | number | string | null;
            isOpportunisticOOS: boolean | null;
            notes: string | null;
          }>;
          lastKnownCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchExternalSystemUnitByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchExternalSystemUnitByIdsQuery = {
  __typename: 'Query';
  externalSystemUnit: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | {
          __typename: 'ExternalSystemUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          unitId: string;
          vehicleId: string;
          regionId: string;
          companyId: string;
          unitStatus: UnitStatus;
          vehicleType: VehicleType;
          registrationNumber: string;
          vehicleStatus: VehicleStatus;
          vehicleStatusDescription: string;
          currentCardNumber: string | null;
          lastKnownLocationName: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          baseId: string | null;
          modelName: string | null;
          outOfServiceEvents: Array<{
            __typename: 'OutOfServiceEventSummary';
            id: string;
            type: OutOfServiceType;
            eventNumber: string;
            estimatedEndTime: Date | number | string;
            reasonName: string;
            reasonId: string;
            startTime: Date | number | string | null;
            isOpportunisticOOS: boolean | null;
            notes: string | null;
          }>;
          lastKnownCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type FacilityNonAcceptanceReasonFieldsFragment = {
  __typename: 'FacilityNonAcceptanceReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  facilityNonAcceptanceReasonType: NonAcceptanceType;
};

export type FetchFacilityNonAcceptanceReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchFacilityNonAcceptanceReasonByIdQuery = {
  __typename: 'Query';
  facilityNonAcceptanceReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | {
          __typename: 'FacilityNonAcceptanceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          facilityNonAcceptanceReasonType: NonAcceptanceType;
        }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchFacilityNonAcceptanceReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchFacilityNonAcceptanceReasonByIdsQuery = {
  __typename: 'Query';
  facilityNonAcceptanceReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | {
          __typename: 'FacilityNonAcceptanceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          facilityNonAcceptanceReasonType: NonAcceptanceType;
        }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type FirewallRuleFieldsFragment = {
  __typename: 'FirewallRule';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  action: AccessControlAction;
  ipRange: string;
  enabled: boolean;
  companyId: string | null;
};

export type FetchFirewallRuleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchFirewallRuleByIdQuery = {
  __typename: 'Query';
  firewallRule: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | {
          __typename: 'FirewallRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          action: AccessControlAction;
          ipRange: string;
          enabled: boolean;
          companyId: string | null;
        }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchFirewallRuleByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchFirewallRuleByIdsQuery = {
  __typename: 'Query';
  firewallRule: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | {
          __typename: 'FirewallRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          action: AccessControlAction;
          ipRange: string;
          enabled: boolean;
          companyId: string | null;
        }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type FlightFollowingReportFieldsFragment = {
  __typename: 'FlightFollowingReport';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  tripId: string;
  companyId: string;
  summary: string | null;
  fuel: string | null;
  estimatedTimeEnrouteMinutes: number | null;
  riskAnalysis: string | null;
  flightType: FlightType | null;
  soulsOnBoard: number | null;
  highestFeatureEnroute: number | null;
  takeOffWeight: number | null;
  centerOfGravity: number | null;
  destination: string | null;
  trackingViaGps: boolean | null;
  flightRule: FlightRule | null;
  tripLegId: string | null;
  confirmedFboId: string | null;
  cruisingAltitude: number | null;
  medicalCrewRA: number | null;
};

export type FetchFlightFollowingReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchFlightFollowingReportByIdQuery = {
  __typename: 'Query';
  flightFollowingReport: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | {
          __typename: 'FlightFollowingReport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          tripId: string;
          companyId: string;
          summary: string | null;
          fuel: string | null;
          estimatedTimeEnrouteMinutes: number | null;
          riskAnalysis: string | null;
          flightType: FlightType | null;
          soulsOnBoard: number | null;
          highestFeatureEnroute: number | null;
          takeOffWeight: number | null;
          centerOfGravity: number | null;
          destination: string | null;
          trackingViaGps: boolean | null;
          flightRule: FlightRule | null;
          tripLegId: string | null;
          confirmedFboId: string | null;
          cruisingAltitude: number | null;
          medicalCrewRA: number | null;
        }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchFlightFollowingReportByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchFlightFollowingReportByIdsQuery = {
  __typename: 'Query';
  flightFollowingReport: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | {
          __typename: 'FlightFollowingReport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          tripId: string;
          companyId: string;
          summary: string | null;
          fuel: string | null;
          estimatedTimeEnrouteMinutes: number | null;
          riskAnalysis: string | null;
          flightType: FlightType | null;
          soulsOnBoard: number | null;
          highestFeatureEnroute: number | null;
          takeOffWeight: number | null;
          centerOfGravity: number | null;
          destination: string | null;
          trackingViaGps: boolean | null;
          flightRule: FlightRule | null;
          tripLegId: string | null;
          confirmedFboId: string | null;
          cruisingAltitude: number | null;
          medicalCrewRA: number | null;
        }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type LandingZoneOutOfServiceReasonFieldsFragment = {
  __typename: 'LandingZoneOutOfServiceReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchLandingZoneOutOfServiceReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchLandingZoneOutOfServiceReasonByIdQuery = {
  __typename: 'Query';
  landingZoneOutOfServiceReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | {
          __typename: 'LandingZoneOutOfServiceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchLandingZoneOutOfServiceReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchLandingZoneOutOfServiceReasonByIdsQuery = {
  __typename: 'Query';
  landingZoneOutOfServiceReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | {
          __typename: 'LandingZoneOutOfServiceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type LocationHazardAttachmentFieldsFragment = {
  __typename: 'LocationHazardAttachment';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  locationHazardId: string;
  fileName: string;
  companyId: string;
  fileSizeInBytes: number | null;
  contentType: string | null;
};

export type FetchLocationHazardAttachmentByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchLocationHazardAttachmentByIdQuery = {
  __typename: 'Query';
  locationHazardAttachment: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | {
          __typename: 'LocationHazardAttachment';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          locationHazardId: string;
          fileName: string;
          companyId: string;
          fileSizeInBytes: number | null;
          contentType: string | null;
        }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchLocationHazardAttachmentByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchLocationHazardAttachmentByIdsQuery = {
  __typename: 'Query';
  locationHazardAttachment: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | {
          __typename: 'LocationHazardAttachment';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          locationHazardId: string;
          fileName: string;
          companyId: string;
          fileSizeInBytes: number | null;
          contentType: string | null;
        }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type LocationHazardFieldsFragment = {
  __typename: 'LocationHazard';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  locationId: string;
  hazard: string;
  companyId: string;
  effectiveDate: Date | number | string | null;
  expirationDate: Date | number | string | null;
};

export type FetchLocationHazardByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchLocationHazardByIdQuery = {
  __typename: 'Query';
  locationHazard: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | {
          __typename: 'LocationHazard';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          locationId: string;
          hazard: string;
          companyId: string;
          effectiveDate: Date | number | string | null;
          expirationDate: Date | number | string | null;
        }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchLocationHazardByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchLocationHazardByIdsQuery = {
  __typename: 'Query';
  locationHazard: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | {
          __typename: 'LocationHazard';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          locationId: string;
          hazard: string;
          companyId: string;
          effectiveDate: Date | number | string | null;
          expirationDate: Date | number | string | null;
        }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ManifestEntryFieldsFragment = {
  __typename: 'ManifestEntry';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  passengerId: string;
  tripLegId: string;
  companyId: string;
  confirmedAt: Date | number | string | null;
  confirmedById: string | null;
};

export type FetchManifestEntryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchManifestEntryByIdQuery = {
  __typename: 'Query';
  manifestEntry: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | {
          __typename: 'ManifestEntry';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passengerId: string;
          tripLegId: string;
          companyId: string;
          confirmedAt: Date | number | string | null;
          confirmedById: string | null;
        }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchManifestEntryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchManifestEntryByIdsQuery = {
  __typename: 'Query';
  manifestEntry: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | {
          __typename: 'ManifestEntry';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passengerId: string;
          tripLegId: string;
          companyId: string;
          confirmedAt: Date | number | string | null;
          confirmedById: string | null;
        }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MedicalControlContactLogEntryFieldsFragment = {
  __typename: 'MedicalControlContactLogEntry';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  cardId: string;
  timestampId: string;
  personId: string;
  isSuccessful: boolean;
  companyId: string;
};

export type FetchMedicalControlContactLogEntryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMedicalControlContactLogEntryByIdQuery = {
  __typename: 'Query';
  medicalControlContactLogEntry: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | {
          __typename: 'MedicalControlContactLogEntry';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          cardId: string;
          timestampId: string;
          personId: string;
          isSuccessful: boolean;
          companyId: string;
        }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMedicalControlContactLogEntryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMedicalControlContactLogEntryByIdsQuery = {
  __typename: 'Query';
  medicalControlContactLogEntry: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | {
          __typename: 'MedicalControlContactLogEntry';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          cardId: string;
          timestampId: string;
          personId: string;
          isSuccessful: boolean;
          companyId: string;
        }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MessageStatusUpdateFieldsFragment = {
  __typename: 'MessageStatusUpdate';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: MessageStatus;
  trackedMessageId: string;
  error: string | null;
  vendorMessage: string | null;
  metadataJson: string | null;
};

export type FetchMessageStatusUpdateByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMessageStatusUpdateByIdQuery = {
  __typename: 'Query';
  messageStatusUpdate: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | {
          __typename: 'MessageStatusUpdate';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: MessageStatus;
          trackedMessageId: string;
          error: string | null;
          vendorMessage: string | null;
          metadataJson: string | null;
        }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMessageStatusUpdateByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMessageStatusUpdateByIdsQuery = {
  __typename: 'Query';
  messageStatusUpdate: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | {
          __typename: 'MessageStatusUpdate';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: MessageStatus;
          trackedMessageId: string;
          error: string | null;
          vendorMessage: string | null;
          metadataJson: string | null;
        }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NewAgencyLocationRequestFieldsFragment = {
  __typename: 'NewAgencyLocationRequest';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  phoneNumber: string;
  name: string;
  requestedByPersonId: string;
  entityType: EntityType;
  type: NewAgencyLocationRequestOriginType;
  entityId: string | null;
};

export type FetchNewAgencyLocationRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNewAgencyLocationRequestByIdQuery = {
  __typename: 'Query';
  newAgencyLocationRequest: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | {
          __typename: 'NewAgencyLocationRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          phoneNumber: string;
          name: string;
          requestedByPersonId: string;
          entityType: EntityType;
          type: NewAgencyLocationRequestOriginType;
          entityId: string | null;
        }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNewAgencyLocationRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNewAgencyLocationRequestByIdsQuery = {
  __typename: 'Query';
  newAgencyLocationRequest: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | {
          __typename: 'NewAgencyLocationRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          phoneNumber: string;
          name: string;
          requestedByPersonId: string;
          entityType: EntityType;
          type: NewAgencyLocationRequestOriginType;
          entityId: string | null;
        }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NextDueTypeFieldsFragment = {
  __typename: 'NextDueType';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  dataType: string;
};

export type FetchNextDueTypeByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNextDueTypeByIdQuery = {
  __typename: 'Query';
  nextDueType: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | {
          __typename: 'NextDueType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          dataType: string;
        }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNextDueTypeByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNextDueTypeByIdsQuery = {
  __typename: 'Query';
  nextDueType: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | {
          __typename: 'NextDueType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          dataType: string;
        }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NonReferralReasonFieldsFragment = {
  __typename: 'NonReferralReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  associatedCancellationReasonId: string | null;
  associatedCancellationSecondaryReasonId: string | null;
};

export type FetchNonReferralReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNonReferralReasonByIdQuery = {
  __typename: 'Query';
  nonReferralReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | {
          __typename: 'NonReferralReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          associatedCancellationReasonId: string | null;
          associatedCancellationSecondaryReasonId: string | null;
        }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNonReferralReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNonReferralReasonByIdsQuery = {
  __typename: 'Query';
  nonReferralReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | {
          __typename: 'NonReferralReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          associatedCancellationReasonId: string | null;
          associatedCancellationSecondaryReasonId: string | null;
        }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NotificationFieldsFragment = {
  __typename: 'Notification';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: NotificationStatus;
  body: string;
  companyId: string;
  cardId: string | null;
  subject: string | null;
  sourceTemplateId: string | null;
  entityType: EntityType | null;
  entityId: string | null;
  createdById: string | null;
};

export type FetchNotificationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNotificationByIdQuery = {
  __typename: 'Query';
  notification: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | {
          __typename: 'Notification';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: NotificationStatus;
          body: string;
          companyId: string;
          cardId: string | null;
          subject: string | null;
          sourceTemplateId: string | null;
          entityType: EntityType | null;
          entityId: string | null;
          createdById: string | null;
        }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNotificationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNotificationByIdsQuery = {
  __typename: 'Query';
  notification: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | {
          __typename: 'Notification';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: NotificationStatus;
          body: string;
          companyId: string;
          cardId: string | null;
          subject: string | null;
          sourceTemplateId: string | null;
          entityType: EntityType | null;
          entityId: string | null;
          createdById: string | null;
        }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NotificationGroupFieldsFragment = {
  __typename: 'NotificationGroup';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  companyId: string;
  unitId: string | null;
  regionId: string | null;
  type: NotificationGroupType | null;
  types: Array<NotificationGroupType | null> | null;
  isEmailNotificationPreferred: boolean | null;
};

export type FetchNotificationGroupByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNotificationGroupByIdQuery = {
  __typename: 'Query';
  notificationGroup: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | {
          __typename: 'NotificationGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          unitId: string | null;
          regionId: string | null;
          type: NotificationGroupType | null;
          types: Array<NotificationGroupType | null> | null;
          isEmailNotificationPreferred: boolean | null;
        }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNotificationGroupByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNotificationGroupByIdsQuery = {
  __typename: 'Query';
  notificationGroup: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | {
          __typename: 'NotificationGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          unitId: string | null;
          regionId: string | null;
          type: NotificationGroupType | null;
          types: Array<NotificationGroupType | null> | null;
          isEmailNotificationPreferred: boolean | null;
        }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NotificationGroupMemberFieldsFragment = {
  __typename: 'NotificationGroupMember';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  notificationGroupId: string;
  companyId: string;
  userId: string | null;
  notificationAddress: string | null;
};

export type FetchNotificationGroupMemberByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNotificationGroupMemberByIdQuery = {
  __typename: 'Query';
  notificationGroupMember: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | {
          __typename: 'NotificationGroupMember';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          notificationGroupId: string;
          companyId: string;
          userId: string | null;
          notificationAddress: string | null;
        }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNotificationGroupMemberByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNotificationGroupMemberByIdsQuery = {
  __typename: 'Query';
  notificationGroupMember: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | {
          __typename: 'NotificationGroupMember';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          notificationGroupId: string;
          companyId: string;
          userId: string | null;
          notificationAddress: string | null;
        }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NotificationRecipientFieldsFragment = {
  __typename: 'NotificationRecipient';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  notificationId: string;
  companyId: string;
  name: string | null;
  notificationAddress: string | null;
  userId: string | null;
  messageId: string | null;
  messageStatus: MessageStatus | null;
};

export type FetchNotificationRecipientByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNotificationRecipientByIdQuery = {
  __typename: 'Query';
  notificationRecipient: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | {
          __typename: 'NotificationRecipient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          notificationId: string;
          companyId: string;
          name: string | null;
          notificationAddress: string | null;
          userId: string | null;
          messageId: string | null;
          messageStatus: MessageStatus | null;
        }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNotificationRecipientByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNotificationRecipientByIdsQuery = {
  __typename: 'Query';
  notificationRecipient: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | {
          __typename: 'NotificationRecipient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          notificationId: string;
          companyId: string;
          name: string | null;
          notificationAddress: string | null;
          userId: string | null;
          messageId: string | null;
          messageStatus: MessageStatus | null;
        }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NotificationSubscriptionFieldsFragment = {
  __typename: 'NotificationSubscription';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  unitId: string;
  notificationGroupId: string;
  companyId: string;
};

export type FetchNotificationSubscriptionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNotificationSubscriptionByIdQuery = {
  __typename: 'Query';
  notificationSubscription: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | {
          __typename: 'NotificationSubscription';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          unitId: string;
          notificationGroupId: string;
          companyId: string;
        }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNotificationSubscriptionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNotificationSubscriptionByIdsQuery = {
  __typename: 'Query';
  notificationSubscription: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | {
          __typename: 'NotificationSubscription';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          unitId: string;
          notificationGroupId: string;
          companyId: string;
        }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type NotificationTemplateFieldsFragment = {
  __typename: 'NotificationTemplate';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  contextType: EntityType;
  bodyTemplate: string;
  canBeManualTrigger: boolean;
  companyId: string | null;
  triggerType: NotificationTriggerType | null;
  triggerValue: string | null;
  activationRuleId: string | null;
  recipientTypes: Array<NotificationRecipientType | null> | null;
  subjectTemplate: string | null;
  requiresApproval: boolean | null;
  groupTypes: Array<NotificationGroupType | null> | null;
  createdById: string | null;
};

export type FetchNotificationTemplateByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchNotificationTemplateByIdQuery = {
  __typename: 'Query';
  notificationTemplate: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | {
          __typename: 'NotificationTemplate';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          contextType: EntityType;
          bodyTemplate: string;
          canBeManualTrigger: boolean;
          companyId: string | null;
          triggerType: NotificationTriggerType | null;
          triggerValue: string | null;
          activationRuleId: string | null;
          recipientTypes: Array<NotificationRecipientType | null> | null;
          subjectTemplate: string | null;
          requiresApproval: boolean | null;
          groupTypes: Array<NotificationGroupType | null> | null;
          createdById: string | null;
        }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchNotificationTemplateByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchNotificationTemplateByIdsQuery = {
  __typename: 'Query';
  notificationTemplate: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | {
          __typename: 'NotificationTemplate';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          contextType: EntityType;
          bodyTemplate: string;
          canBeManualTrigger: boolean;
          companyId: string | null;
          triggerType: NotificationTriggerType | null;
          triggerValue: string | null;
          activationRuleId: string | null;
          recipientTypes: Array<NotificationRecipientType | null> | null;
          subjectTemplate: string | null;
          requiresApproval: boolean | null;
          groupTypes: Array<NotificationGroupType | null> | null;
          createdById: string | null;
        }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OemActivityFieldsFragment = {
  __typename: 'OemActivity';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  oemPlanId: string;
  activityType: OemActivityType;
  time: Date | number | string | null;
  authorId: string | null;
  content: string | null;
  priorStatus: string | null;
  currentStatus: string | null;
  oemPlanChangeRequestId: string | null;
};

export type FetchOemActivityByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOemActivityByIdQuery = {
  __typename: 'Query';
  oemActivity: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | {
          __typename: 'OemActivity';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          oemPlanId: string;
          activityType: OemActivityType;
          time: Date | number | string | null;
          authorId: string | null;
          content: string | null;
          priorStatus: string | null;
          currentStatus: string | null;
          oemPlanChangeRequestId: string | null;
        }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOemActivityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOemActivityByIdsQuery = {
  __typename: 'Query';
  oemActivity: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | {
          __typename: 'OemActivity';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          oemPlanId: string;
          activityType: OemActivityType;
          time: Date | number | string | null;
          authorId: string | null;
          content: string | null;
          priorStatus: string | null;
          currentStatus: string | null;
          oemPlanChangeRequestId: string | null;
        }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OemAssetFieldsFragment = {
  __typename: 'OemAsset';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  oemPlanId: string;
  assetId: string;
  assetType: OemAssetType;
  status: OemAssetStatus;
  assetDispatchCompanyId: string | null;
  originalUnitId: string | null;
  oemUnitId: string | null;
  requestedPlacardNumber: string | null;
  requestedUnitName: string | null;
  requestedUnitAbbreviation: string | null;
  requestedBaseId: string | null;
};

export type FetchOemAssetByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOemAssetByIdQuery = {
  __typename: 'Query';
  oemAsset: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | {
          __typename: 'OemAsset';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          oemPlanId: string;
          assetId: string;
          assetType: OemAssetType;
          status: OemAssetStatus;
          assetDispatchCompanyId: string | null;
          originalUnitId: string | null;
          oemUnitId: string | null;
          requestedPlacardNumber: string | null;
          requestedUnitName: string | null;
          requestedUnitAbbreviation: string | null;
          requestedBaseId: string | null;
        }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOemAssetByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOemAssetByIdsQuery = {
  __typename: 'Query';
  oemAsset: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | {
          __typename: 'OemAsset';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          oemPlanId: string;
          assetId: string;
          assetType: OemAssetType;
          status: OemAssetStatus;
          assetDispatchCompanyId: string | null;
          originalUnitId: string | null;
          oemUnitId: string | null;
          requestedPlacardNumber: string | null;
          requestedUnitName: string | null;
          requestedUnitAbbreviation: string | null;
          requestedBaseId: string | null;
        }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OemPlanChangeRequestFieldsFragment = {
  __typename: 'OemPlanChangeRequest';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  oemPlanId: string;
  oemAssetId: string;
  status: OemPlanChangeRequestStatus;
  originalAssetStatus: OemAssetStatus;
  requestedAssetStatus: OemAssetStatus;
  requestedById: string | null;
  dateRequested: Date | number | string | null;
  dateCompleted: Date | number | string | null;
  dateCancelled: Date | number | string | null;
  notes: string | null;
};

export type FetchOemPlanChangeRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOemPlanChangeRequestByIdQuery = {
  __typename: 'Query';
  oemPlanChangeRequest: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | {
          __typename: 'OemPlanChangeRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          oemPlanId: string;
          oemAssetId: string;
          status: OemPlanChangeRequestStatus;
          originalAssetStatus: OemAssetStatus;
          requestedAssetStatus: OemAssetStatus;
          requestedById: string | null;
          dateRequested: Date | number | string | null;
          dateCompleted: Date | number | string | null;
          dateCancelled: Date | number | string | null;
          notes: string | null;
        }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOemPlanChangeRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOemPlanChangeRequestByIdsQuery = {
  __typename: 'Query';
  oemPlanChangeRequest: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | {
          __typename: 'OemPlanChangeRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          oemPlanId: string;
          oemAssetId: string;
          status: OemPlanChangeRequestStatus;
          originalAssetStatus: OemAssetStatus;
          requestedAssetStatus: OemAssetStatus;
          requestedById: string | null;
          dateRequested: Date | number | string | null;
          dateCompleted: Date | number | string | null;
          dateCancelled: Date | number | string | null;
          notes: string | null;
        }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OemPlanFieldsFragment = {
  __typename: 'OemPlan';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  companyId: string;
  oemCompanyId: string;
  outOfServiceReasonId: string;
  defaultBaseId: string;
  planStatus: OemPlanStatus;
  planYear: number;
  description: string | null;
};

export type FetchOemPlanByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOemPlanByIdQuery = {
  __typename: 'Query';
  oemPlan: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | {
          __typename: 'OemPlan';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          oemCompanyId: string;
          outOfServiceReasonId: string;
          defaultBaseId: string;
          planStatus: OemPlanStatus;
          planYear: number;
          description: string | null;
        }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOemPlanByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOemPlanByIdsQuery = {
  __typename: 'Query';
  oemPlan: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | {
          __typename: 'OemPlan';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          oemCompanyId: string;
          outOfServiceReasonId: string;
          defaultBaseId: string;
          planStatus: OemPlanStatus;
          planYear: number;
          description: string | null;
        }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OfferAlgorithmFieldsFragment = {
  __typename: 'OfferAlgorithm';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  includeCompetitors: boolean;
  oneCallAgreement: boolean;
  rank: number;
  transportOfferAlgorithm: TransportOfferAlgorithm;
  distanceCalculation: DistanceCalculation;
  activationRuleId: string;
  companyId: string;
  isEnabled: boolean;
  minimumFlightRule: FlightRule | null;
  createdById: string | null;
  preferredUnits: Array<{
    __typename: 'PreferredUnit';
    id: string;
    unitAbbreviation: string;
    rank: number;
    type: PreferredUnitType;
  }>;
  companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchOfferAlgorithmByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOfferAlgorithmByIdQuery = {
  __typename: 'Query';
  offerAlgorithm: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | {
          __typename: 'OfferAlgorithm';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          oneCallAgreement: boolean;
          rank: number;
          transportOfferAlgorithm: TransportOfferAlgorithm;
          distanceCalculation: DistanceCalculation;
          activationRuleId: string;
          companyId: string;
          isEnabled: boolean;
          minimumFlightRule: FlightRule | null;
          createdById: string | null;
          preferredUnits: Array<{
            __typename: 'PreferredUnit';
            id: string;
            unitAbbreviation: string;
            rank: number;
            type: PreferredUnitType;
          }>;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOfferAlgorithmByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOfferAlgorithmByIdsQuery = {
  __typename: 'Query';
  offerAlgorithm: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | {
          __typename: 'OfferAlgorithm';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          oneCallAgreement: boolean;
          rank: number;
          transportOfferAlgorithm: TransportOfferAlgorithm;
          distanceCalculation: DistanceCalculation;
          activationRuleId: string;
          companyId: string;
          isEnabled: boolean;
          minimumFlightRule: FlightRule | null;
          createdById: string | null;
          preferredUnits: Array<{
            __typename: 'PreferredUnit';
            id: string;
            unitAbbreviation: string;
            rank: number;
            type: PreferredUnitType;
          }>;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OperationFieldsFragment = {
  __typename: 'Operation';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: OperationStatus;
  type: OperationType;
  vehicleId: string;
  dateOperationStarted: Date | number | string;
  riskAnalysisAcknowledged: boolean;
  companyId: string;
  unitId: string | null;
  dateOperationEnded: Date | number | string | null;
  unitActivationTime: Date | number | string | null;
  riskAnalysisNumber: string | null;
  standbyActivationType: StandbyActivationType | null;
  caller: string | null;
  callbackNumber: string | null;
  initialOperationType: OperationType | null;
};

export type FetchOperationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOperationByIdQuery = {
  __typename: 'Query';
  operation: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | {
          __typename: 'Operation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: OperationStatus;
          type: OperationType;
          vehicleId: string;
          dateOperationStarted: Date | number | string;
          riskAnalysisAcknowledged: boolean;
          companyId: string;
          unitId: string | null;
          dateOperationEnded: Date | number | string | null;
          unitActivationTime: Date | number | string | null;
          riskAnalysisNumber: string | null;
          standbyActivationType: StandbyActivationType | null;
          caller: string | null;
          callbackNumber: string | null;
          initialOperationType: OperationType | null;
        }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOperationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOperationByIdsQuery = {
  __typename: 'Query';
  operation: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | {
          __typename: 'Operation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: OperationStatus;
          type: OperationType;
          vehicleId: string;
          dateOperationStarted: Date | number | string;
          riskAnalysisAcknowledged: boolean;
          companyId: string;
          unitId: string | null;
          dateOperationEnded: Date | number | string | null;
          unitActivationTime: Date | number | string | null;
          riskAnalysisNumber: string | null;
          standbyActivationType: StandbyActivationType | null;
          caller: string | null;
          callbackNumber: string | null;
          initialOperationType: OperationType | null;
        }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OutOfServiceEventFieldsFragment = {
  __typename: 'OutOfServiceEvent';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  type: OutOfServiceType;
  eventNumber: string;
  estimatedEndTime: Date | number | string;
  reasonId: string;
  isAirworthy: boolean;
  initialEstimatedEndTime: Date | number | string;
  alertWhenEventEnds: boolean;
  isPlanned: boolean;
  isBirdStrike: boolean;
  isPatientOnboard: boolean;
  waitingForParts: boolean;
  waitingForTooling: boolean;
  isAcknowledgementRequired: boolean;
  companyId: string;
  startTime: Date | number | string | null;
  isOpportunisticOOS: boolean | null;
  unitId: string | null;
  vehicleId: string | null;
  secondaryReasonId: string | null;
  scheduledStartTime: Date | number | string | null;
  endTime: Date | number | string | null;
  notes: string | null;
  linkedCardId: string | null;
  createdById: string | null;
  endedById: string | null;
  secondaryReasonComment: string | null;
  parentOutOfServiceEventId: string | null;
  paipEventId: string | null;
  copiedFromId: string | null;
  alertTimeInMinutes: number | null;
  outOfServiceTicketId: string | null;
  maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
  opportunityMXTypes: Array<OpportunityMXType | null> | null;
  rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
  maintenanceLocation: string | null;
  mxDuringPeakTimeReason: string | null;
  assignedBaseId: string | null;
  amtPointOfContactId: string | null;
  alternatePOC: string | null;
  spareVehicleId: string | null;
  ticketDescription: string | null;
  humanErrorDamageType: HumanErrorDamageType | null;
  businessUnitCompanyId: string | null;
  isAMTAvailable: boolean | null;
  isFAR135415Reportable: boolean | null;
  isFAR135417Reportable: boolean | null;
  dateAcknowledged: Date | number | string | null;
  acknowledgedById: string | null;
  acknowledgementNotes: string | null;
  maintenanceFacilityId: string | null;
  locationId: string | null;
  oosRequestType: OosRequestType | null;
  isEventAlreadyClosed: boolean | null;
  qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  } | null;
  crew: Array<{
    __typename: 'OutOfServiceCrew';
    id: string;
    personId: string;
    unitPositionId: string;
    isFlightCrew: boolean;
    positionType: UnitPositionType | null;
    unitPositionRole: string | null;
    endDate: Date | number | string | null;
    notificationAddress: string | null;
  } | null> | null;
};

export type FetchOutOfServiceEventByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOutOfServiceEventByIdQuery = {
  __typename: 'Query';
  outOfServiceEvent: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | {
          __typename: 'OutOfServiceEvent';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: OutOfServiceType;
          eventNumber: string;
          estimatedEndTime: Date | number | string;
          reasonId: string;
          isAirworthy: boolean;
          initialEstimatedEndTime: Date | number | string;
          alertWhenEventEnds: boolean;
          isPlanned: boolean;
          isBirdStrike: boolean;
          isPatientOnboard: boolean;
          waitingForParts: boolean;
          waitingForTooling: boolean;
          isAcknowledgementRequired: boolean;
          companyId: string;
          startTime: Date | number | string | null;
          isOpportunisticOOS: boolean | null;
          unitId: string | null;
          vehicleId: string | null;
          secondaryReasonId: string | null;
          scheduledStartTime: Date | number | string | null;
          endTime: Date | number | string | null;
          notes: string | null;
          linkedCardId: string | null;
          createdById: string | null;
          endedById: string | null;
          secondaryReasonComment: string | null;
          parentOutOfServiceEventId: string | null;
          paipEventId: string | null;
          copiedFromId: string | null;
          alertTimeInMinutes: number | null;
          outOfServiceTicketId: string | null;
          maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
          opportunityMXTypes: Array<OpportunityMXType | null> | null;
          rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
          maintenanceLocation: string | null;
          mxDuringPeakTimeReason: string | null;
          assignedBaseId: string | null;
          amtPointOfContactId: string | null;
          alternatePOC: string | null;
          spareVehicleId: string | null;
          ticketDescription: string | null;
          humanErrorDamageType: HumanErrorDamageType | null;
          businessUnitCompanyId: string | null;
          isAMTAvailable: boolean | null;
          isFAR135415Reportable: boolean | null;
          isFAR135417Reportable: boolean | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          acknowledgementNotes: string | null;
          maintenanceFacilityId: string | null;
          locationId: string | null;
          oosRequestType: OosRequestType | null;
          isEventAlreadyClosed: boolean | null;
          qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          crew: Array<{
            __typename: 'OutOfServiceCrew';
            id: string;
            personId: string;
            unitPositionId: string;
            isFlightCrew: boolean;
            positionType: UnitPositionType | null;
            unitPositionRole: string | null;
            endDate: Date | number | string | null;
            notificationAddress: string | null;
          } | null> | null;
        }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOutOfServiceEventByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOutOfServiceEventByIdsQuery = {
  __typename: 'Query';
  outOfServiceEvent: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | {
          __typename: 'OutOfServiceEvent';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: OutOfServiceType;
          eventNumber: string;
          estimatedEndTime: Date | number | string;
          reasonId: string;
          isAirworthy: boolean;
          initialEstimatedEndTime: Date | number | string;
          alertWhenEventEnds: boolean;
          isPlanned: boolean;
          isBirdStrike: boolean;
          isPatientOnboard: boolean;
          waitingForParts: boolean;
          waitingForTooling: boolean;
          isAcknowledgementRequired: boolean;
          companyId: string;
          startTime: Date | number | string | null;
          isOpportunisticOOS: boolean | null;
          unitId: string | null;
          vehicleId: string | null;
          secondaryReasonId: string | null;
          scheduledStartTime: Date | number | string | null;
          endTime: Date | number | string | null;
          notes: string | null;
          linkedCardId: string | null;
          createdById: string | null;
          endedById: string | null;
          secondaryReasonComment: string | null;
          parentOutOfServiceEventId: string | null;
          paipEventId: string | null;
          copiedFromId: string | null;
          alertTimeInMinutes: number | null;
          outOfServiceTicketId: string | null;
          maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
          opportunityMXTypes: Array<OpportunityMXType | null> | null;
          rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
          maintenanceLocation: string | null;
          mxDuringPeakTimeReason: string | null;
          assignedBaseId: string | null;
          amtPointOfContactId: string | null;
          alternatePOC: string | null;
          spareVehicleId: string | null;
          ticketDescription: string | null;
          humanErrorDamageType: HumanErrorDamageType | null;
          businessUnitCompanyId: string | null;
          isAMTAvailable: boolean | null;
          isFAR135415Reportable: boolean | null;
          isFAR135417Reportable: boolean | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          acknowledgementNotes: string | null;
          maintenanceFacilityId: string | null;
          locationId: string | null;
          oosRequestType: OosRequestType | null;
          isEventAlreadyClosed: boolean | null;
          qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
          crew: Array<{
            __typename: 'OutOfServiceCrew';
            id: string;
            personId: string;
            unitPositionId: string;
            isFlightCrew: boolean;
            positionType: UnitPositionType | null;
            unitPositionRole: string | null;
            endDate: Date | number | string | null;
            notificationAddress: string | null;
          } | null> | null;
        }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OutOfServiceEventNoteFieldsFragment = {
  __typename: 'OutOfServiceEventNote';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  outOfServiceEventId: string;
  content: string;
  noteTime: Date | number | string;
  isSystem: boolean;
  companyId: string;
  authorId: string | null;
  noteCategory: string | null;
  noteMetadataJson: string | null;
};

export type FetchOutOfServiceEventNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOutOfServiceEventNoteByIdQuery = {
  __typename: 'Query';
  outOfServiceEventNote: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | {
          __typename: 'OutOfServiceEventNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          outOfServiceEventId: string;
          content: string;
          noteTime: Date | number | string;
          isSystem: boolean;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
        }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOutOfServiceEventNoteByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOutOfServiceEventNoteByIdsQuery = {
  __typename: 'Query';
  outOfServiceEventNote: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | {
          __typename: 'OutOfServiceEventNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          outOfServiceEventId: string;
          content: string;
          noteTime: Date | number | string;
          isSystem: boolean;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
        }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OutOfServiceReasonFieldsFragment = {
  __typename: 'OutOfServiceReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  controllable: boolean;
  isVehicleReason: boolean;
  description: string | null;
};

export type FetchOutOfServiceReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOutOfServiceReasonByIdQuery = {
  __typename: 'Query';
  outOfServiceReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | {
          __typename: 'OutOfServiceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          controllable: boolean;
          isVehicleReason: boolean;
          description: string | null;
        }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOutOfServiceReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOutOfServiceReasonByIdsQuery = {
  __typename: 'Query';
  outOfServiceReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | {
          __typename: 'OutOfServiceReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          controllable: boolean;
          isVehicleReason: boolean;
          description: string | null;
        }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OutOfServiceSecondaryReasonFieldsFragment = {
  __typename: 'OutOfServiceSecondaryReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  outOfServiceReasonId: string;
};

export type FetchOutOfServiceSecondaryReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOutOfServiceSecondaryReasonByIdQuery = {
  __typename: 'Query';
  outOfServiceSecondaryReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | {
          __typename: 'OutOfServiceSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          outOfServiceReasonId: string;
        }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOutOfServiceSecondaryReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOutOfServiceSecondaryReasonByIdsQuery = {
  __typename: 'Query';
  outOfServiceSecondaryReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | {
          __typename: 'OutOfServiceSecondaryReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          outOfServiceReasonId: string;
        }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OutOfServiceTicketFieldsFragment = {
  __typename: 'OutOfServiceTicket';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  isPlanned: boolean;
  maintenanceTypes: Array<OosTicketMaintenanceType>;
  vehicleId: string;
  outOfServiceTime: Date | number | string;
  ertsDateTime: Date | number | string;
  submittedById: string;
  ticketDescription: string;
  isBirdStrike: boolean;
  isPatientOnboard: boolean;
  waitingForParts: boolean;
  waitingForTooling: boolean;
  status: OosTicketStatusType;
  companyId: string;
  ticketNumber: string | null;
  businessUnitCompanyId: string | null;
  assignedBaseId: string | null;
  maintenanceLocation: string | null;
  dateSubmittedForReview: Date | number | string | null;
  pointOfContactId: string | null;
  alternatePOC: string | null;
  spareVehicleId: string | null;
  opportunityMXTypes: Array<OpportunityMXType | null> | null;
  mxDuringPeakTimeReason: string | null;
  waitingForPartsTimestamp: Date | number | string | null;
  waitingForToolingTimestamp: Date | number | string | null;
  isAMTAvailable: boolean | null;
  isFAR135415Reportable: boolean | null;
  isFAR135417Reportable: boolean | null;
  acceptedById: string | null;
  dateAccepted: Date | number | string | null;
  humanErrorDamageType: HumanErrorDamageType | null;
  rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
  pageoutCompletedById: string | null;
  datePageoutCompleted: Date | number | string | null;
  primaryReasonId: string | null;
  secondaryReasonId: string | null;
  outOfServiceType: OutOfServiceType | null;
  dateAcknowledged: Date | number | string | null;
  acknowledgedById: string | null;
  acknowledgementNotes: string | null;
  maintenanceFacilityId: string | null;
  locationId: string | null;
  isOpportunisticOOS: boolean | null;
  qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  } | null;
};

export type FetchOutOfServiceTicketByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOutOfServiceTicketByIdQuery = {
  __typename: 'Query';
  outOfServiceTicket: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | {
          __typename: 'OutOfServiceTicket';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          isPlanned: boolean;
          maintenanceTypes: Array<OosTicketMaintenanceType>;
          vehicleId: string;
          outOfServiceTime: Date | number | string;
          ertsDateTime: Date | number | string;
          submittedById: string;
          ticketDescription: string;
          isBirdStrike: boolean;
          isPatientOnboard: boolean;
          waitingForParts: boolean;
          waitingForTooling: boolean;
          status: OosTicketStatusType;
          companyId: string;
          ticketNumber: string | null;
          businessUnitCompanyId: string | null;
          assignedBaseId: string | null;
          maintenanceLocation: string | null;
          dateSubmittedForReview: Date | number | string | null;
          pointOfContactId: string | null;
          alternatePOC: string | null;
          spareVehicleId: string | null;
          opportunityMXTypes: Array<OpportunityMXType | null> | null;
          mxDuringPeakTimeReason: string | null;
          waitingForPartsTimestamp: Date | number | string | null;
          waitingForToolingTimestamp: Date | number | string | null;
          isAMTAvailable: boolean | null;
          isFAR135415Reportable: boolean | null;
          isFAR135417Reportable: boolean | null;
          acceptedById: string | null;
          dateAccepted: Date | number | string | null;
          humanErrorDamageType: HumanErrorDamageType | null;
          rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
          pageoutCompletedById: string | null;
          datePageoutCompleted: Date | number | string | null;
          primaryReasonId: string | null;
          secondaryReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          acknowledgementNotes: string | null;
          maintenanceFacilityId: string | null;
          locationId: string | null;
          isOpportunisticOOS: boolean | null;
          qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
        }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOutOfServiceTicketByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOutOfServiceTicketByIdsQuery = {
  __typename: 'Query';
  outOfServiceTicket: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | {
          __typename: 'OutOfServiceTicket';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          isPlanned: boolean;
          maintenanceTypes: Array<OosTicketMaintenanceType>;
          vehicleId: string;
          outOfServiceTime: Date | number | string;
          ertsDateTime: Date | number | string;
          submittedById: string;
          ticketDescription: string;
          isBirdStrike: boolean;
          isPatientOnboard: boolean;
          waitingForParts: boolean;
          waitingForTooling: boolean;
          status: OosTicketStatusType;
          companyId: string;
          ticketNumber: string | null;
          businessUnitCompanyId: string | null;
          assignedBaseId: string | null;
          maintenanceLocation: string | null;
          dateSubmittedForReview: Date | number | string | null;
          pointOfContactId: string | null;
          alternatePOC: string | null;
          spareVehicleId: string | null;
          opportunityMXTypes: Array<OpportunityMXType | null> | null;
          mxDuringPeakTimeReason: string | null;
          waitingForPartsTimestamp: Date | number | string | null;
          waitingForToolingTimestamp: Date | number | string | null;
          isAMTAvailable: boolean | null;
          isFAR135415Reportable: boolean | null;
          isFAR135417Reportable: boolean | null;
          acceptedById: string | null;
          dateAccepted: Date | number | string | null;
          humanErrorDamageType: HumanErrorDamageType | null;
          rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
          pageoutCompletedById: string | null;
          datePageoutCompleted: Date | number | string | null;
          primaryReasonId: string | null;
          secondaryReasonId: string | null;
          outOfServiceType: OutOfServiceType | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          acknowledgementNotes: string | null;
          maintenanceFacilityId: string | null;
          locationId: string | null;
          isOpportunisticOOS: boolean | null;
          qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
        }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PaipEventFieldsFragment = {
  __typename: 'PaipEvent';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  reasonId: string;
  startTime: Date | number | string;
  companyId: string;
  regionId: string | null;
  eventNumber: string | null;
  endTime: Date | number | string | null;
  notes: string | null;
  unitIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  cardIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchPaipEventByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaipEventByIdQuery = {
  __typename: 'Query';
  paipEvent: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | {
          __typename: 'PaipEvent';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          reasonId: string;
          startTime: Date | number | string;
          companyId: string;
          regionId: string | null;
          eventNumber: string | null;
          endTime: Date | number | string | null;
          notes: string | null;
          unitIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          cardIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPaipEventByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPaipEventByIdsQuery = {
  __typename: 'Query';
  paipEvent: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | {
          __typename: 'PaipEvent';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          reasonId: string;
          startTime: Date | number | string;
          companyId: string;
          regionId: string | null;
          eventNumber: string | null;
          endTime: Date | number | string | null;
          notes: string | null;
          unitIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          cardIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PaipReasonFieldsFragment = {
  __typename: 'PaipReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  outOfServiceReasonId: string | null;
};

export type FetchPaipReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaipReasonByIdQuery = {
  __typename: 'Query';
  paipReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | {
          __typename: 'PaipReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          outOfServiceReasonId: string | null;
        }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPaipReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPaipReasonByIdsQuery = {
  __typename: 'Query';
  paipReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | {
          __typename: 'PaipReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          outOfServiceReasonId: string | null;
        }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PassdownLogAcknowledgementFieldsFragment = {
  __typename: 'PassdownLogAcknowledgement';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  passdownLogId: string;
  dateAcknowledged: Date | number | string;
  acknowledgedById: string;
  companyId: string;
};

export type FetchPassdownLogAcknowledgementByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPassdownLogAcknowledgementByIdQuery = {
  __typename: 'Query';
  passdownLogAcknowledgement: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | {
          __typename: 'PassdownLogAcknowledgement';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passdownLogId: string;
          dateAcknowledged: Date | number | string;
          acknowledgedById: string;
          companyId: string;
        }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPassdownLogAcknowledgementByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPassdownLogAcknowledgementByIdsQuery = {
  __typename: 'Query';
  passdownLogAcknowledgement: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | {
          __typename: 'PassdownLogAcknowledgement';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passdownLogId: string;
          dateAcknowledged: Date | number | string;
          acknowledgedById: string;
          companyId: string;
        }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PassdownLogArchivedLogFieldsFragment = {
  __typename: 'PassdownLogArchivedLog';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  passdownLogId: string;
  archivedById: string;
  dateArchived: Date | number | string;
  companyId: string;
};

export type FetchPassdownLogArchivedLogByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPassdownLogArchivedLogByIdQuery = {
  __typename: 'Query';
  passdownLogArchivedLog: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | {
          __typename: 'PassdownLogArchivedLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passdownLogId: string;
          archivedById: string;
          dateArchived: Date | number | string;
          companyId: string;
        }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPassdownLogArchivedLogByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPassdownLogArchivedLogByIdsQuery = {
  __typename: 'Query';
  passdownLogArchivedLog: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | {
          __typename: 'PassdownLogArchivedLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          passdownLogId: string;
          archivedById: string;
          dateArchived: Date | number | string;
          companyId: string;
        }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PassdownLogFieldsFragment = {
  __typename: 'PassdownLog';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  regionId: string;
  logDate: Date | number | string;
  body: string;
  requiresAcknowledgement: boolean;
  companyId: string;
  dateAcknowledged: Date | number | string | null;
  acknowledgedById: string | null;
  authorId: string | null;
};

export type FetchPassdownLogByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPassdownLogByIdQuery = {
  __typename: 'Query';
  passdownLog: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | {
          __typename: 'PassdownLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          regionId: string;
          logDate: Date | number | string;
          body: string;
          requiresAcknowledgement: boolean;
          companyId: string;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          authorId: string | null;
        }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPassdownLogByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPassdownLogByIdsQuery = {
  __typename: 'Query';
  passdownLog: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | {
          __typename: 'PassdownLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          regionId: string;
          logDate: Date | number | string;
          body: string;
          requiresAcknowledgement: boolean;
          companyId: string;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          authorId: string | null;
        }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PatientFieldsFragment = {
  __typename: 'Patient';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  gender: Gender;
  companyId: string;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: Date | number | string | null;
};

export type FetchPatientByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPatientByIdQuery = {
  __typename: 'Query';
  patient: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | {
          __typename: 'Patient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          gender: Gender;
          companyId: string;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
        }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPatientByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPatientByIdsQuery = {
  __typename: 'Query';
  patient: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | {
          __typename: 'Patient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          gender: Gender;
          companyId: string;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
        }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PositionReportAlertFieldsFragment = {
  __typename: 'PositionReportAlert';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  vehicleId: string;
  hasReceivedQualifyingReport: boolean;
  companyId: string;
};

export type FetchPositionReportAlertByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPositionReportAlertByIdQuery = {
  __typename: 'Query';
  positionReportAlert: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | {
          __typename: 'PositionReportAlert';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          hasReceivedQualifyingReport: boolean;
          companyId: string;
        }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPositionReportAlertByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPositionReportAlertByIdsQuery = {
  __typename: 'Query';
  positionReportAlert: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | {
          __typename: 'PositionReportAlert';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          hasReceivedQualifyingReport: boolean;
          companyId: string;
        }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PositionReportArchiveFieldsFragment = {
  __typename: 'PositionReportArchive';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  positionTime: Date | number | string;
  source: PositionReportSource;
  dateArchived: Date | number | string;
  tripId: string;
  companyId: string;
  altitude: number | null;
  speedInKnots: number | null;
  heading: number | null;
  estimatedMinutesEnRoute: number | null;
  fuelRemaining: string | null;
  timezoneCd: string | null;
  dateConfirmed: Date | number | string | null;
  coordinates: {
    __typename: 'Coordinates';
    latitude: number | null;
    longitude: number | null;
  } | null;
};

export type FetchPositionReportArchiveByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPositionReportArchiveByIdQuery = {
  __typename: 'Query';
  positionReportArchive: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | {
          __typename: 'PositionReportArchive';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
          dateArchived: Date | number | string;
          tripId: string;
          companyId: string;
          altitude: number | null;
          speedInKnots: number | null;
          heading: number | null;
          estimatedMinutesEnRoute: number | null;
          fuelRemaining: string | null;
          timezoneCd: string | null;
          dateConfirmed: Date | number | string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPositionReportArchiveByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPositionReportArchiveByIdsQuery = {
  __typename: 'Query';
  positionReportArchive: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | {
          __typename: 'PositionReportArchive';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
          dateArchived: Date | number | string;
          tripId: string;
          companyId: string;
          altitude: number | null;
          speedInKnots: number | null;
          heading: number | null;
          estimatedMinutesEnRoute: number | null;
          fuelRemaining: string | null;
          timezoneCd: string | null;
          dateConfirmed: Date | number | string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PositionReportFieldsFragment = {
  __typename: 'PositionReport';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  positionTime: Date | number | string;
  source: PositionReportSource;
  tripId: string;
  companyId: string;
  altitude: number | null;
  speedInKnots: number | null;
  heading: number | null;
  estimatedMinutesEnRoute: number | null;
  fuelRemaining: string | null;
  timezoneCd: string | null;
  dateConfirmed: Date | number | string | null;
  gpsProvider: GpsProvider | null;
  coordinates: {
    __typename: 'Coordinates';
    latitude: number | null;
    longitude: number | null;
  } | null;
};

export type FetchPositionReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPositionReportByIdQuery = {
  __typename: 'Query';
  positionReport: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | {
          __typename: 'PositionReport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
          tripId: string;
          companyId: string;
          altitude: number | null;
          speedInKnots: number | null;
          heading: number | null;
          estimatedMinutesEnRoute: number | null;
          fuelRemaining: string | null;
          timezoneCd: string | null;
          dateConfirmed: Date | number | string | null;
          gpsProvider: GpsProvider | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPositionReportByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPositionReportByIdsQuery = {
  __typename: 'Query';
  positionReport: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | {
          __typename: 'PositionReport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
          tripId: string;
          companyId: string;
          altitude: number | null;
          speedInKnots: number | null;
          heading: number | null;
          estimatedMinutesEnRoute: number | null;
          fuelRemaining: string | null;
          timezoneCd: string | null;
          dateConfirmed: Date | number | string | null;
          gpsProvider: GpsProvider | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionChoiceFieldsFragment = {
  __typename: 'QuestionChoice';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  label: string;
  value: string;
  questionId: string;
};

export type FetchQuestionChoiceByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionChoiceByIdQuery = {
  __typename: 'Query';
  questionChoice: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | {
          __typename: 'QuestionChoice';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          label: string;
          value: string;
          questionId: string;
        }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionChoiceByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionChoiceByIdsQuery = {
  __typename: 'Query';
  questionChoice: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | {
          __typename: 'QuestionChoice';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          label: string;
          value: string;
          questionId: string;
        }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionFieldsFragment = {
  __typename: 'Question';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  question: string;
  questionType: QuestionType;
  dataType: QuestionDataType | null;
};

export type FetchQuestionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionByIdQuery = {
  __typename: 'Query';
  question: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | {
          __typename: 'Question';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          question: string;
          questionType: QuestionType;
          dataType: QuestionDataType | null;
        }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionByIdsQuery = {
  __typename: 'Query';
  question: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | {
          __typename: 'Question';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          question: string;
          questionType: QuestionType;
          dataType: QuestionDataType | null;
        }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionnaireFieldsFragment = {
  __typename: 'Questionnaire';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  companyId: string;
  type: QuestionnaireType;
  communicationCenterId: string | null;
};

export type FetchQuestionnaireByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionnaireByIdQuery = {
  __typename: 'Query';
  questionnaire: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | {
          __typename: 'Questionnaire';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          type: QuestionnaireType;
          communicationCenterId: string | null;
        }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionnaireByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionnaireByIdsQuery = {
  __typename: 'Query';
  questionnaire: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | {
          __typename: 'Questionnaire';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          type: QuestionnaireType;
          communicationCenterId: string | null;
        }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionnaireQuestionResponseFieldsFragment = {
  __typename: 'QuestionnaireQuestionResponse';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  questionnaireResponseId: string;
  questionnaireSectionQuestionId: string;
  matchType: RuleMatchType;
  reviewRequired: boolean;
  companyId: string;
  responseValue: string | null;
  explanation: string | null;
};

export type FetchQuestionnaireQuestionResponseByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionnaireQuestionResponseByIdQuery = {
  __typename: 'Query';
  questionnaireQuestionResponse: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | {
          __typename: 'QuestionnaireQuestionResponse';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireResponseId: string;
          questionnaireSectionQuestionId: string;
          matchType: RuleMatchType;
          reviewRequired: boolean;
          companyId: string;
          responseValue: string | null;
          explanation: string | null;
        }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionnaireQuestionResponseByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionnaireQuestionResponseByIdsQuery = {
  __typename: 'Query';
  questionnaireQuestionResponse: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | {
          __typename: 'QuestionnaireQuestionResponse';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireResponseId: string;
          questionnaireSectionQuestionId: string;
          matchType: RuleMatchType;
          reviewRequired: boolean;
          companyId: string;
          responseValue: string | null;
          explanation: string | null;
        }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionnaireQuestionResponseNoteFieldsFragment = {
  __typename: 'QuestionnaireQuestionResponseNote';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  questionnaireQuestionResponseId: string;
  authorId: string;
  dateAuthored: Date | number | string;
  note: string;
  companyId: string;
};

export type FetchQuestionnaireQuestionResponseNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionnaireQuestionResponseNoteByIdQuery = {
  __typename: 'Query';
  questionnaireQuestionResponseNote: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | {
          __typename: 'QuestionnaireQuestionResponseNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireQuestionResponseId: string;
          authorId: string;
          dateAuthored: Date | number | string;
          note: string;
          companyId: string;
        }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionnaireQuestionResponseNoteByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionnaireQuestionResponseNoteByIdsQuery = {
  __typename: 'Query';
  questionnaireQuestionResponseNote: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | {
          __typename: 'QuestionnaireQuestionResponseNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireQuestionResponseId: string;
          authorId: string;
          dateAuthored: Date | number | string;
          note: string;
          companyId: string;
        }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionnaireResponseFieldsFragment = {
  __typename: 'QuestionnaireResponse';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: QuestionnaireResponseStatus;
  questionnaireId: string;
  companyId: string;
  cardId: string;
  currentReviewLevel: UserRole | null;
  completedById: string | null;
  dateCompleted: Date | number | string | null;
  communicationsReviewById: string | null;
  dateCommunicationsReviewed: Date | number | string | null;
  supervisorReviewById: string | null;
  dateSupervisorReviewed: Date | number | string | null;
  managerReviewById: string | null;
  dateManagerReviewed: Date | number | string | null;
};

export type FetchQuestionnaireResponseByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionnaireResponseByIdQuery = {
  __typename: 'Query';
  questionnaireResponse: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | {
          __typename: 'QuestionnaireResponse';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: QuestionnaireResponseStatus;
          questionnaireId: string;
          companyId: string;
          cardId: string;
          currentReviewLevel: UserRole | null;
          completedById: string | null;
          dateCompleted: Date | number | string | null;
          communicationsReviewById: string | null;
          dateCommunicationsReviewed: Date | number | string | null;
          supervisorReviewById: string | null;
          dateSupervisorReviewed: Date | number | string | null;
          managerReviewById: string | null;
          dateManagerReviewed: Date | number | string | null;
        }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionnaireResponseByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionnaireResponseByIdsQuery = {
  __typename: 'Query';
  questionnaireResponse: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | {
          __typename: 'QuestionnaireResponse';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: QuestionnaireResponseStatus;
          questionnaireId: string;
          companyId: string;
          cardId: string;
          currentReviewLevel: UserRole | null;
          completedById: string | null;
          dateCompleted: Date | number | string | null;
          communicationsReviewById: string | null;
          dateCommunicationsReviewed: Date | number | string | null;
          supervisorReviewById: string | null;
          dateSupervisorReviewed: Date | number | string | null;
          managerReviewById: string | null;
          dateManagerReviewed: Date | number | string | null;
        }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionnaireSectionFieldsFragment = {
  __typename: 'QuestionnaireSection';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  questionnaireId: string;
  sequence: number;
};

export type FetchQuestionnaireSectionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionnaireSectionByIdQuery = {
  __typename: 'Query';
  questionnaireSection: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | {
          __typename: 'QuestionnaireSection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          questionnaireId: string;
          sequence: number;
        }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionnaireSectionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionnaireSectionByIdsQuery = {
  __typename: 'Query';
  questionnaireSection: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | {
          __typename: 'QuestionnaireSection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          questionnaireId: string;
          sequence: number;
        }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type QuestionnaireSectionQuestionFieldsFragment = {
  __typename: 'QuestionnaireSectionQuestion';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  questionnaireSectionId: string;
  questionId: string;
  responsibleRole: UserRole;
  sequence: number;
  isDisabled: boolean;
  activationRuleId: string | null;
  activityType: string | null;
  explanationRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  reviewRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchQuestionnaireSectionQuestionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchQuestionnaireSectionQuestionByIdQuery = {
  __typename: 'Query';
  questionnaireSectionQuestion: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | {
          __typename: 'QuestionnaireSectionQuestion';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireSectionId: string;
          questionId: string;
          responsibleRole: UserRole;
          sequence: number;
          isDisabled: boolean;
          activationRuleId: string | null;
          activityType: string | null;
          explanationRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          reviewRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchQuestionnaireSectionQuestionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchQuestionnaireSectionQuestionByIdsQuery = {
  __typename: 'Query';
  questionnaireSectionQuestion: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | {
          __typename: 'QuestionnaireSectionQuestion';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireSectionId: string;
          questionId: string;
          responsibleRole: UserRole;
          sequence: number;
          isDisabled: boolean;
          activationRuleId: string | null;
          activityType: string | null;
          explanationRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
          reviewRequiredChoices: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ReceivingFacilityRequestFieldsFragment = {
  __typename: 'ReceivingFacilityRequest';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: ReceivingFacilityRequestStatus;
  cardId: string;
  requestId: string;
  medicalFacilityId: string;
  requestLocationId: string;
  companyId: string;
  nonAcceptanceType: NonAcceptanceType | null;
  nonAcceptanceReasonId: string | null;
  referredToFacilityId: string | null;
};

export type FetchReceivingFacilityRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchReceivingFacilityRequestByIdQuery = {
  __typename: 'Query';
  receivingFacilityRequest: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | {
          __typename: 'ReceivingFacilityRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: ReceivingFacilityRequestStatus;
          cardId: string;
          requestId: string;
          medicalFacilityId: string;
          requestLocationId: string;
          companyId: string;
          nonAcceptanceType: NonAcceptanceType | null;
          nonAcceptanceReasonId: string | null;
          referredToFacilityId: string | null;
        }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchReceivingFacilityRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchReceivingFacilityRequestByIdsQuery = {
  __typename: 'Query';
  receivingFacilityRequest: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | {
          __typename: 'ReceivingFacilityRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: ReceivingFacilityRequestStatus;
          cardId: string;
          requestId: string;
          medicalFacilityId: string;
          requestLocationId: string;
          companyId: string;
          nonAcceptanceType: NonAcceptanceType | null;
          nonAcceptanceReasonId: string | null;
          referredToFacilityId: string | null;
        }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RendezvousRequestFieldsFragment = {
  __typename: 'RendezvousRequest';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  type: SupplementalLegType;
  utilizationStatus: AmrUtilizationStatus;
  requestLocationId: string;
  companyId: string;
  agencyLocationId: string | null;
  agencyEta: Date | number | string | null;
  rendezvousLocationDescription: string | null;
  contactInformation: string | null;
  confirmedAt: Date | number | string | null;
  departedLzAt: Date | number | string | null;
  arrivedDestAt: Date | number | string | null;
  departedDestAt: Date | number | string | null;
  arrivedLzAt: Date | number | string | null;
  cancelledAt: Date | number | string | null;
  notes: string | null;
  transportUnitNumber: string | null;
  latestStatus: string | null;
  latestStatusTimestamp: Date | number | string | null;
};

export type FetchRendezvousRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRendezvousRequestByIdQuery = {
  __typename: 'Query';
  rendezvousRequest: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | {
          __typename: 'RendezvousRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: SupplementalLegType;
          utilizationStatus: AmrUtilizationStatus;
          requestLocationId: string;
          companyId: string;
          agencyLocationId: string | null;
          agencyEta: Date | number | string | null;
          rendezvousLocationDescription: string | null;
          contactInformation: string | null;
          confirmedAt: Date | number | string | null;
          departedLzAt: Date | number | string | null;
          arrivedDestAt: Date | number | string | null;
          departedDestAt: Date | number | string | null;
          arrivedLzAt: Date | number | string | null;
          cancelledAt: Date | number | string | null;
          notes: string | null;
          transportUnitNumber: string | null;
          latestStatus: string | null;
          latestStatusTimestamp: Date | number | string | null;
        }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRendezvousRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRendezvousRequestByIdsQuery = {
  __typename: 'Query';
  rendezvousRequest: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | {
          __typename: 'RendezvousRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: SupplementalLegType;
          utilizationStatus: AmrUtilizationStatus;
          requestLocationId: string;
          companyId: string;
          agencyLocationId: string | null;
          agencyEta: Date | number | string | null;
          rendezvousLocationDescription: string | null;
          contactInformation: string | null;
          confirmedAt: Date | number | string | null;
          departedLzAt: Date | number | string | null;
          arrivedDestAt: Date | number | string | null;
          departedDestAt: Date | number | string | null;
          arrivedLzAt: Date | number | string | null;
          cancelledAt: Date | number | string | null;
          notes: string | null;
          transportUnitNumber: string | null;
          latestStatus: string | null;
          latestStatusTimestamp: Date | number | string | null;
        }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RequestFieldsFragment = {
  __typename: 'Request';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: RequestStatus;
  requestedOperationType: OperationType;
  isStandbyRequest: boolean;
  standbyActivationRequested: boolean;
  missionConfiguration: MissionConfiguration;
  missionProfile: MissionProfile;
  companyId: string;
  cancellationReasonId: string | null;
  cancellationSecondaryReasonId: string | null;
  cancellationReasonNotes: string | null;
  requestedVehicleType: VehicleType | null;
  primaryUnitServiceAreaId: string | null;
  commitUnitToStandby: boolean | null;
  initiationType: RequestInitiationType | null;
  assignmentDelayedTime: Date | number | string | null;
  assignmentDelayedReasonId: string | null;
  regionId: string | null;
  includeCompetitors: boolean | null;
  transportOfferAlgorithmId: string | null;
  transportOfferAlgorithm: TransportOfferAlgorithm | null;
  minimumFlightRule: FlightRule | null;
  transportTrackingLink: string | null;
  latestWeatherDeclineUnitId: string | null;
  latestWeatherDeclineTime: Date | number | string | null;
  latestWeatherDeclineReasonId: string | null;
  latestWeatherDeclineSecondaryReasonId: string | null;
  webOrderCallType: WebOrderCallType | null;
  etloInMinutes: number | null;
  atloInMinutes: number | null;
  safetyQuestions: {
    __typename: 'SafetyQuestions';
    otherServiceDeclined: boolean | null;
    otherServiceDescription: string | null;
    otherServicesAreRespondingToTransferring: boolean | null;
    otherServiceResponseDescription: string | null;
  };
  requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
};

export type FetchRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRequestByIdQuery = {
  __typename: 'Query';
  request: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | {
          __typename: 'Request';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: RequestStatus;
          requestedOperationType: OperationType;
          isStandbyRequest: boolean;
          standbyActivationRequested: boolean;
          missionConfiguration: MissionConfiguration;
          missionProfile: MissionProfile;
          companyId: string;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          requestedVehicleType: VehicleType | null;
          primaryUnitServiceAreaId: string | null;
          commitUnitToStandby: boolean | null;
          initiationType: RequestInitiationType | null;
          assignmentDelayedTime: Date | number | string | null;
          assignmentDelayedReasonId: string | null;
          regionId: string | null;
          includeCompetitors: boolean | null;
          transportOfferAlgorithmId: string | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          webOrderCallType: WebOrderCallType | null;
          etloInMinutes: number | null;
          atloInMinutes: number | null;
          safetyQuestions: {
            __typename: 'SafetyQuestions';
            otherServiceDeclined: boolean | null;
            otherServiceDescription: string | null;
            otherServicesAreRespondingToTransferring: boolean | null;
            otherServiceResponseDescription: string | null;
          };
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRequestByIdsQuery = {
  __typename: 'Query';
  request: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | {
          __typename: 'Request';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: RequestStatus;
          requestedOperationType: OperationType;
          isStandbyRequest: boolean;
          standbyActivationRequested: boolean;
          missionConfiguration: MissionConfiguration;
          missionProfile: MissionProfile;
          companyId: string;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          requestedVehicleType: VehicleType | null;
          primaryUnitServiceAreaId: string | null;
          commitUnitToStandby: boolean | null;
          initiationType: RequestInitiationType | null;
          assignmentDelayedTime: Date | number | string | null;
          assignmentDelayedReasonId: string | null;
          regionId: string | null;
          includeCompetitors: boolean | null;
          transportOfferAlgorithmId: string | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          webOrderCallType: WebOrderCallType | null;
          etloInMinutes: number | null;
          atloInMinutes: number | null;
          safetyQuestions: {
            __typename: 'SafetyQuestions';
            otherServiceDeclined: boolean | null;
            otherServiceDescription: string | null;
            otherServicesAreRespondingToTransferring: boolean | null;
            otherServiceResponseDescription: string | null;
          };
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RequesterFieldsFragment = {
  __typename: 'Requester';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  companyId: string;
  affiliationType: AffiliationType | null;
  caller: string | null;
  roleId: string | null;
  missionRole: MissionRoleType | null;
  callbackNumber: string | null;
  email: string | null;
  facilityId: string | null;
  agencyLocationId: string | null;
  isNewAgencyLocation: boolean | null;
  agencyLocationName: string | null;
  referringCompanyId: string | null;
  referringAgencyLocationId: string | null;
  referralReasonId: string | null;
  referringRecordNumber: string | null;
  specialtyTeamNotes: string | null;
  specialtyTeamId: string | null;
  careLevelRequested: CareLevel | null;
  transferCenterId: string | null;
  transferCenterNotes: string | null;
  transportingAgencyLocationId: string | null;
  isDoublePatient: boolean | null;
  isWingToWing: boolean | null;
  vetNumber: string | null;
  requestId: string | null;
  specialtyTeamMembers: Array<{ __typename: 'IdListItem'; id: string }>;
};

export type FetchRequesterByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRequesterByIdQuery = {
  __typename: 'Query';
  requester: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | {
          __typename: 'Requester';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          affiliationType: AffiliationType | null;
          caller: string | null;
          roleId: string | null;
          missionRole: MissionRoleType | null;
          callbackNumber: string | null;
          email: string | null;
          facilityId: string | null;
          agencyLocationId: string | null;
          isNewAgencyLocation: boolean | null;
          agencyLocationName: string | null;
          referringCompanyId: string | null;
          referringAgencyLocationId: string | null;
          referralReasonId: string | null;
          referringRecordNumber: string | null;
          specialtyTeamNotes: string | null;
          specialtyTeamId: string | null;
          careLevelRequested: CareLevel | null;
          transferCenterId: string | null;
          transferCenterNotes: string | null;
          transportingAgencyLocationId: string | null;
          isDoublePatient: boolean | null;
          isWingToWing: boolean | null;
          vetNumber: string | null;
          requestId: string | null;
          specialtyTeamMembers: Array<{ __typename: 'IdListItem'; id: string }>;
        }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRequesterByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRequesterByIdsQuery = {
  __typename: 'Query';
  requester: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | {
          __typename: 'Requester';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          affiliationType: AffiliationType | null;
          caller: string | null;
          roleId: string | null;
          missionRole: MissionRoleType | null;
          callbackNumber: string | null;
          email: string | null;
          facilityId: string | null;
          agencyLocationId: string | null;
          isNewAgencyLocation: boolean | null;
          agencyLocationName: string | null;
          referringCompanyId: string | null;
          referringAgencyLocationId: string | null;
          referralReasonId: string | null;
          referringRecordNumber: string | null;
          specialtyTeamNotes: string | null;
          specialtyTeamId: string | null;
          careLevelRequested: CareLevel | null;
          transferCenterId: string | null;
          transferCenterNotes: string | null;
          transportingAgencyLocationId: string | null;
          isDoublePatient: boolean | null;
          isWingToWing: boolean | null;
          vetNumber: string | null;
          requestId: string | null;
          specialtyTeamMembers: Array<{ __typename: 'IdListItem'; id: string }>;
        }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RequesterReferralReasonFieldsFragment = {
  __typename: 'RequesterReferralReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchRequesterReferralReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRequesterReferralReasonByIdQuery = {
  __typename: 'Query';
  requesterReferralReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | {
          __typename: 'RequesterReferralReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRequesterReferralReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRequesterReferralReasonByIdsQuery = {
  __typename: 'Query';
  requesterReferralReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | {
          __typename: 'RequesterReferralReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RequesterRoleFieldsFragment = {
  __typename: 'RequesterRole';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchRequesterRoleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRequesterRoleByIdQuery = {
  __typename: 'Query';
  requesterRole: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | {
          __typename: 'RequesterRole';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRequesterRoleByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRequesterRoleByIdsQuery = {
  __typename: 'Query';
  requesterRole: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | {
          __typename: 'RequesterRole';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RequestLocationFieldsFragment = {
  __typename: 'RequestLocation';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  type: WaypointType;
  requestId: string;
  companyId: string;
  locationId: string | null;
  timezoneCd: string | null;
  isRotorWingLz: boolean | null;
  medicalFacilityId: string | null;
  roomNumber: string | null;
  medicalFacilityUnitId: string | null;
  notes: string | null;
  groundContact: string | null;
  estimatedRendezvousTimeInMinutes: number | null;
  estimatedGroundTimeInMinutes: number | null;
  fboId: string | null;
  physicianId: string | null;
  diversionReasonId: string | null;
  diversionReasonOtherNotes: string | null;
  isAutoAccepted: boolean | null;
  dateConfirmed: Date | number | string | null;
  confirmedByUserId: string | null;
  unConfirmed: boolean | null;
  physicianName: string | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  };
};

export type FetchRequestLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRequestLocationByIdQuery = {
  __typename: 'Query';
  requestLocation: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | {
          __typename: 'RequestLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          requestId: string;
          companyId: string;
          locationId: string | null;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          medicalFacilityId: string | null;
          roomNumber: string | null;
          medicalFacilityUnitId: string | null;
          notes: string | null;
          groundContact: string | null;
          estimatedRendezvousTimeInMinutes: number | null;
          estimatedGroundTimeInMinutes: number | null;
          fboId: string | null;
          physicianId: string | null;
          diversionReasonId: string | null;
          diversionReasonOtherNotes: string | null;
          isAutoAccepted: boolean | null;
          dateConfirmed: Date | number | string | null;
          confirmedByUserId: string | null;
          unConfirmed: boolean | null;
          physicianName: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRequestLocationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRequestLocationByIdsQuery = {
  __typename: 'Query';
  requestLocation: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | {
          __typename: 'RequestLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          requestId: string;
          companyId: string;
          locationId: string | null;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          medicalFacilityId: string | null;
          roomNumber: string | null;
          medicalFacilityUnitId: string | null;
          notes: string | null;
          groundContact: string | null;
          estimatedRendezvousTimeInMinutes: number | null;
          estimatedGroundTimeInMinutes: number | null;
          fboId: string | null;
          physicianId: string | null;
          diversionReasonId: string | null;
          diversionReasonOtherNotes: string | null;
          isAutoAccepted: boolean | null;
          dateConfirmed: Date | number | string | null;
          confirmedByUserId: string | null;
          unConfirmed: boolean | null;
          physicianName: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RequestPatientFieldsFragment = {
  __typename: 'RequestPatient';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  gender: Gender;
  isIsolette: boolean;
  requestId: string;
  companyId: string;
  patientId: string | null;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: Date | number | string | null;
  weightInKg: number | null;
  transportReasonId: string | null;
  notes: string | null;
  chiefComplaintNotes: string | null;
  transportReasonCategory: TransportReasonCategory | null;
  isIntubated: boolean | null;
  numberOfDrips: number | null;
  specialtyEquipment: string | null;
  rideAlongRequested: YesNoType | null;
  isoletteType: IsoletteType | null;
  isoletteNotes: string | null;
  transferReasonId: string | null;
  estimatedAgeInHours: number | null;
  gcs: number | null;
  bpSystolic: number | null;
  bpDiastolic: number | null;
  heartRate: number | null;
  oxygenSaturation: number | null;
  respiratoryRate: number | null;
  temperatureInCelsius: number | null;
  rideAlongWeightInKg: number | null;
  medicalRecordNumber: string | null;
  rideAlongName: string | null;
  rideAlongDateOfBirth: Date | number | string | null;
};

export type FetchRequestPatientByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRequestPatientByIdQuery = {
  __typename: 'Query';
  requestPatient: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | {
          __typename: 'RequestPatient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          gender: Gender;
          isIsolette: boolean;
          requestId: string;
          companyId: string;
          patientId: string | null;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          transportReasonId: string | null;
          notes: string | null;
          chiefComplaintNotes: string | null;
          transportReasonCategory: TransportReasonCategory | null;
          isIntubated: boolean | null;
          numberOfDrips: number | null;
          specialtyEquipment: string | null;
          rideAlongRequested: YesNoType | null;
          isoletteType: IsoletteType | null;
          isoletteNotes: string | null;
          transferReasonId: string | null;
          estimatedAgeInHours: number | null;
          gcs: number | null;
          bpSystolic: number | null;
          bpDiastolic: number | null;
          heartRate: number | null;
          oxygenSaturation: number | null;
          respiratoryRate: number | null;
          temperatureInCelsius: number | null;
          rideAlongWeightInKg: number | null;
          medicalRecordNumber: string | null;
          rideAlongName: string | null;
          rideAlongDateOfBirth: Date | number | string | null;
        }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRequestPatientByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRequestPatientByIdsQuery = {
  __typename: 'Query';
  requestPatient: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | {
          __typename: 'RequestPatient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          gender: Gender;
          isIsolette: boolean;
          requestId: string;
          companyId: string;
          patientId: string | null;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          transportReasonId: string | null;
          notes: string | null;
          chiefComplaintNotes: string | null;
          transportReasonCategory: TransportReasonCategory | null;
          isIntubated: boolean | null;
          numberOfDrips: number | null;
          specialtyEquipment: string | null;
          rideAlongRequested: YesNoType | null;
          isoletteType: IsoletteType | null;
          isoletteNotes: string | null;
          transferReasonId: string | null;
          estimatedAgeInHours: number | null;
          gcs: number | null;
          bpSystolic: number | null;
          bpDiastolic: number | null;
          heartRate: number | null;
          oxygenSaturation: number | null;
          respiratoryRate: number | null;
          temperatureInCelsius: number | null;
          rideAlongWeightInKg: number | null;
          medicalRecordNumber: string | null;
          rideAlongName: string | null;
          rideAlongDateOfBirth: Date | number | string | null;
        }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type SystemTimerFieldsFragment = {
  __typename: 'SystemTimer';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  description: string;
  commandName: string;
  runIntervalInSeconds: number;
  hasRunCondition: boolean;
  isEnqueued: boolean;
  lastRunDate: Date | number | string | null;
};

export type FetchSystemTimerByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchSystemTimerByIdQuery = {
  __typename: 'Query';
  systemTimer: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | {
          __typename: 'SystemTimer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          description: string;
          commandName: string;
          runIntervalInSeconds: number;
          hasRunCondition: boolean;
          isEnqueued: boolean;
          lastRunDate: Date | number | string | null;
        }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchSystemTimerByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchSystemTimerByIdsQuery = {
  __typename: 'Query';
  systemTimer: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | {
          __typename: 'SystemTimer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          description: string;
          commandName: string;
          runIntervalInSeconds: number;
          hasRunCondition: boolean;
          isEnqueued: boolean;
          lastRunDate: Date | number | string | null;
        }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TimelineFieldsFragment = {
  __typename: 'Timeline';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  companyId: string | null;
  activationRuleId: string | null;
  timelineType: TimelineTypes | null;
};

export type FetchTimelineByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTimelineByIdQuery = {
  __typename: 'Query';
  timeline: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | {
          __typename: 'Timeline';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string | null;
          activationRuleId: string | null;
          timelineType: TimelineTypes | null;
        }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTimelineByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTimelineByIdsQuery = {
  __typename: 'Query';
  timeline: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | {
          __typename: 'Timeline';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string | null;
          activationRuleId: string | null;
          timelineType: TimelineTypes | null;
        }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TimelineItemFieldsFragment = {
  __typename: 'TimelineItem';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  timestampTypeId: string;
  required: boolean;
  sequence: number;
  timelineId: string;
};

export type FetchTimelineItemByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTimelineItemByIdQuery = {
  __typename: 'Query';
  timelineItem: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | {
          __typename: 'TimelineItem';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          timestampTypeId: string;
          required: boolean;
          sequence: number;
          timelineId: string;
        }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTimelineItemByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTimelineItemByIdsQuery = {
  __typename: 'Query';
  timelineItem: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | {
          __typename: 'TimelineItem';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          timestampTypeId: string;
          required: boolean;
          sequence: number;
          timelineId: string;
        }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TimestampFieldsFragment = {
  __typename: 'Timestamp';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  time: Date | number | string;
  typeId: string;
  cardId: string;
  companyId: string;
  userId: string | null;
  note: string | null;
  requestId: string | null;
  operationId: string | null;
  personsInvolved: string | null;
};

export type FetchTimestampByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTimestampByIdQuery = {
  __typename: 'Query';
  timestamp: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | {
          __typename: 'Timestamp';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          time: Date | number | string;
          typeId: string;
          cardId: string;
          companyId: string;
          userId: string | null;
          note: string | null;
          requestId: string | null;
          operationId: string | null;
          personsInvolved: string | null;
        }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTimestampByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTimestampByIdsQuery = {
  __typename: 'Query';
  timestamp: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | {
          __typename: 'Timestamp';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          time: Date | number | string;
          typeId: string;
          cardId: string;
          companyId: string;
          userId: string | null;
          note: string | null;
          requestId: string | null;
          operationId: string | null;
          personsInvolved: string | null;
        }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TimestampTypeFieldsFragment = {
  __typename: 'TimestampType';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  order: number;
  systemTimestampType: SystemTimestampType | null;
  description: string | null;
  companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchTimestampTypeByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTimestampTypeByIdQuery = {
  __typename: 'Query';
  timestampType: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | {
          __typename: 'TimestampType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          order: number;
          systemTimestampType: SystemTimestampType | null;
          description: string | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTimestampTypeByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTimestampTypeByIdsQuery = {
  __typename: 'Query';
  timestampType: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | {
          __typename: 'TimestampType';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          order: number;
          systemTimestampType: SystemTimestampType | null;
          description: string | null;
          companies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TrackedMessageFieldsFragment = {
  __typename: 'TrackedMessage';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  recipientAddress: string;
  body: string;
  status: MessageStatus;
  recipientName: string | null;
  subject: string | null;
  fromName: string | null;
  fromAddress: string | null;
  doNotDivert: boolean | null;
  medium: MessageTransport | null;
  vendorId: string | null;
  vendorMessageId: string | null;
  referenceNumber: string | null;
  vendorConversationId: string | null;
};

export type FetchTrackedMessageByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTrackedMessageByIdQuery = {
  __typename: 'Query';
  trackedMessage: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | {
          __typename: 'TrackedMessage';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          recipientAddress: string;
          body: string;
          status: MessageStatus;
          recipientName: string | null;
          subject: string | null;
          fromName: string | null;
          fromAddress: string | null;
          doNotDivert: boolean | null;
          medium: MessageTransport | null;
          vendorId: string | null;
          vendorMessageId: string | null;
          referenceNumber: string | null;
          vendorConversationId: string | null;
        }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTrackedMessageByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTrackedMessageByIdsQuery = {
  __typename: 'Query';
  trackedMessage: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | {
          __typename: 'TrackedMessage';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          recipientAddress: string;
          body: string;
          status: MessageStatus;
          recipientName: string | null;
          subject: string | null;
          fromName: string | null;
          fromAddress: string | null;
          doNotDivert: boolean | null;
          medium: MessageTransport | null;
          vendorId: string | null;
          vendorMessageId: string | null;
          referenceNumber: string | null;
          vendorConversationId: string | null;
        }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TransferReasonFieldsFragment = {
  __typename: 'TransferReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchTransferReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransferReasonByIdQuery = {
  __typename: 'Query';
  transferReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | {
          __typename: 'TransferReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTransferReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTransferReasonByIdsQuery = {
  __typename: 'Query';
  transferReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | {
          __typename: 'TransferReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TransportOfferFieldsFragment = {
  __typename: 'TransportOffer';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: TransportOfferStatus;
  rank: number;
  response: TransportOfferResponse;
  wasBulkSkip: boolean;
  isOnDelay: boolean;
  isOneCallAgreement: boolean;
  isInternalAgency: boolean;
  requestId: string;
  companyId: string;
  distanceInMiles: number | null;
  bearingInDegrees: number | null;
  estimatedDepartureTimeInMinutes: number | null;
  estimatedTimeEnRouteInMinutes: number | null;
  offerTime: Date | number | string | null;
  crewNotified: Date | number | string | null;
  transportCheckInitiated: Date | number | string | null;
  notificationAcknowledged: Date | number | string | null;
  responseReceived: Date | number | string | null;
  declineReasonId: string | null;
  declineSecondaryReasonId: string | null;
  nonReferralReasonId: string | null;
  nonReferralReasonNotes: string | null;
  cancellationReasonId: string | null;
  cancellationSecondaryReasonId: string | null;
  cancellationReasonNotes: string | null;
  outOfServiceEventId: string | null;
  unitId: string | null;
  vehicleId: string | null;
  agencyLocationId: string | null;
  unitDescription: string | null;
  isReferral: boolean | null;
  vehicleType: VehicleType | null;
  patientOriginatesAtUnit: boolean | null;
  homeBaseDistanceInMiles: number | null;
  baseId: string | null;
  preferredRank: number | null;
  notes: string | null;
  onBaseETAInMinutes: number | null;
  specialtyTeamETLOInMinutes: number | null;
  specialtyTeamETEInMinutes: number | null;
  dateDeclinedOrAborted: Date | number | string | null;
  declinedOrAbortedById: string | null;
  etc: number | null;
  crewMustFlyToArriveAtSending: boolean | null;
  vehicleCoordinates: {
    __typename: 'Coordinates';
    latitude: number | null;
    longitude: number | null;
  } | null;
  crew: Array<{
    __typename: 'UnitPositionSnapshot';
    id: string;
    firstName: string;
    lastName: string;
    type: UnitPositionType;
  } | null> | null;
};

export type FetchTransportOfferByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransportOfferByIdQuery = {
  __typename: 'Query';
  transportOffer: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | {
          __typename: 'TransportOffer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TransportOfferStatus;
          rank: number;
          response: TransportOfferResponse;
          wasBulkSkip: boolean;
          isOnDelay: boolean;
          isOneCallAgreement: boolean;
          isInternalAgency: boolean;
          requestId: string;
          companyId: string;
          distanceInMiles: number | null;
          bearingInDegrees: number | null;
          estimatedDepartureTimeInMinutes: number | null;
          estimatedTimeEnRouteInMinutes: number | null;
          offerTime: Date | number | string | null;
          crewNotified: Date | number | string | null;
          transportCheckInitiated: Date | number | string | null;
          notificationAcknowledged: Date | number | string | null;
          responseReceived: Date | number | string | null;
          declineReasonId: string | null;
          declineSecondaryReasonId: string | null;
          nonReferralReasonId: string | null;
          nonReferralReasonNotes: string | null;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          outOfServiceEventId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          agencyLocationId: string | null;
          unitDescription: string | null;
          isReferral: boolean | null;
          vehicleType: VehicleType | null;
          patientOriginatesAtUnit: boolean | null;
          homeBaseDistanceInMiles: number | null;
          baseId: string | null;
          preferredRank: number | null;
          notes: string | null;
          onBaseETAInMinutes: number | null;
          specialtyTeamETLOInMinutes: number | null;
          specialtyTeamETEInMinutes: number | null;
          dateDeclinedOrAborted: Date | number | string | null;
          declinedOrAbortedById: string | null;
          etc: number | null;
          crewMustFlyToArriveAtSending: boolean | null;
          vehicleCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
          crew: Array<{
            __typename: 'UnitPositionSnapshot';
            id: string;
            firstName: string;
            lastName: string;
            type: UnitPositionType;
          } | null> | null;
        }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTransportOfferByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTransportOfferByIdsQuery = {
  __typename: 'Query';
  transportOffer: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | {
          __typename: 'TransportOffer';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TransportOfferStatus;
          rank: number;
          response: TransportOfferResponse;
          wasBulkSkip: boolean;
          isOnDelay: boolean;
          isOneCallAgreement: boolean;
          isInternalAgency: boolean;
          requestId: string;
          companyId: string;
          distanceInMiles: number | null;
          bearingInDegrees: number | null;
          estimatedDepartureTimeInMinutes: number | null;
          estimatedTimeEnRouteInMinutes: number | null;
          offerTime: Date | number | string | null;
          crewNotified: Date | number | string | null;
          transportCheckInitiated: Date | number | string | null;
          notificationAcknowledged: Date | number | string | null;
          responseReceived: Date | number | string | null;
          declineReasonId: string | null;
          declineSecondaryReasonId: string | null;
          nonReferralReasonId: string | null;
          nonReferralReasonNotes: string | null;
          cancellationReasonId: string | null;
          cancellationSecondaryReasonId: string | null;
          cancellationReasonNotes: string | null;
          outOfServiceEventId: string | null;
          unitId: string | null;
          vehicleId: string | null;
          agencyLocationId: string | null;
          unitDescription: string | null;
          isReferral: boolean | null;
          vehicleType: VehicleType | null;
          patientOriginatesAtUnit: boolean | null;
          homeBaseDistanceInMiles: number | null;
          baseId: string | null;
          preferredRank: number | null;
          notes: string | null;
          onBaseETAInMinutes: number | null;
          specialtyTeamETLOInMinutes: number | null;
          specialtyTeamETEInMinutes: number | null;
          dateDeclinedOrAborted: Date | number | string | null;
          declinedOrAbortedById: string | null;
          etc: number | null;
          crewMustFlyToArriveAtSending: boolean | null;
          vehicleCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
          crew: Array<{
            __typename: 'UnitPositionSnapshot';
            id: string;
            firstName: string;
            lastName: string;
            type: UnitPositionType;
          } | null> | null;
        }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TransportOfferOptionFieldsFragment = {
  __typename: 'TransportOfferOption';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  includeAbortedUnit: boolean;
  type: TransportOfferOptionType;
  requestId: string;
  companyId: string;
  requestedVehicleType: VehicleType | null;
  transportOfferAlgorithm: TransportOfferAlgorithm | null;
  minimumFlightRule: FlightRule | null;
  includeCompetitors: boolean | null;
  requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
};

export type FetchTransportOfferOptionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransportOfferOptionByIdQuery = {
  __typename: 'Query';
  transportOfferOption: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | {
          __typename: 'TransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          type: TransportOfferOptionType;
          requestId: string;
          companyId: string;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTransportOfferOptionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTransportOfferOptionByIdsQuery = {
  __typename: 'Query';
  transportOfferOption: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | {
          __typename: 'TransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          type: TransportOfferOptionType;
          requestId: string;
          companyId: string;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TransportReasonFieldsFragment = {
  __typename: 'TransportReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  operationType: OperationType | null;
};

export type FetchTransportReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransportReasonByIdQuery = {
  __typename: 'Query';
  transportReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | {
          __typename: 'TransportReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          operationType: OperationType | null;
        }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTransportReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTransportReasonByIdsQuery = {
  __typename: 'Query';
  transportReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | {
          __typename: 'TransportReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          operationType: OperationType | null;
        }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TripFieldsFragment = {
  __typename: 'Trip';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  operationId: string;
  companyId: string;
  vehicleId: string | null;
  agencyId: string | null;
  agencyLocationId: string | null;
  calculatedLoadedMiles: number | null;
  gpsLoadedMiles: number | null;
};

export type FetchTripByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTripByIdQuery = {
  __typename: 'Query';
  trip: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | {
          __typename: 'Trip';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          operationId: string;
          companyId: string;
          vehicleId: string | null;
          agencyId: string | null;
          agencyLocationId: string | null;
          calculatedLoadedMiles: number | null;
          gpsLoadedMiles: number | null;
        }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTripByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTripByIdsQuery = {
  __typename: 'Query';
  trip: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | {
          __typename: 'Trip';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          operationId: string;
          companyId: string;
          vehicleId: string | null;
          agencyId: string | null;
          agencyLocationId: string | null;
          calculatedLoadedMiles: number | null;
          gpsLoadedMiles: number | null;
        }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TripLegFieldsFragment = {
  __typename: 'TripLeg';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  status: TripLegStatus;
  sequence: number;
  tripId: string;
  companyId: string;
  estimatedDistanceInMiles: number | null;
  departingOdometerReading: number | null;
  departingNote: string | null;
  arrivingOdometerReading: number | null;
  arrivingNote: string | null;
  isEmergent: boolean | null;
  abortDate: Date | number | string | null;
  encodedPolyline: string | null;
  dateOnFinalMarked: Date | number | string | null;
  officialEteId: string | null;
  calculatedEteId: string | null;
  endingWaypointId: string | null;
  startingWaypointId: string | null;
};

export type FetchTripLegByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTripLegByIdQuery = {
  __typename: 'Query';
  tripLeg: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | {
          __typename: 'TripLeg';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TripLegStatus;
          sequence: number;
          tripId: string;
          companyId: string;
          estimatedDistanceInMiles: number | null;
          departingOdometerReading: number | null;
          departingNote: string | null;
          arrivingOdometerReading: number | null;
          arrivingNote: string | null;
          isEmergent: boolean | null;
          abortDate: Date | number | string | null;
          encodedPolyline: string | null;
          dateOnFinalMarked: Date | number | string | null;
          officialEteId: string | null;
          calculatedEteId: string | null;
          endingWaypointId: string | null;
          startingWaypointId: string | null;
        }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTripLegByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTripLegByIdsQuery = {
  __typename: 'Query';
  tripLeg: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | {
          __typename: 'TripLeg';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: TripLegStatus;
          sequence: number;
          tripId: string;
          companyId: string;
          estimatedDistanceInMiles: number | null;
          departingOdometerReading: number | null;
          departingNote: string | null;
          arrivingOdometerReading: number | null;
          arrivingNote: string | null;
          isEmergent: boolean | null;
          abortDate: Date | number | string | null;
          encodedPolyline: string | null;
          dateOnFinalMarked: Date | number | string | null;
          officialEteId: string | null;
          calculatedEteId: string | null;
          endingWaypointId: string | null;
          startingWaypointId: string | null;
        }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TripPassengerFieldsFragment = {
  __typename: 'TripPassenger';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  type: PassengerType;
  tripId: string;
  companyId: string;
  weightInKg: number | null;
  positionName: string | null;
  positionType: UnitPositionType | null;
  notificationAddress: string | null;
  personId: string | null;
  crewMemberId: string | null;
};

export type FetchTripPassengerByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTripPassengerByIdQuery = {
  __typename: 'Query';
  tripPassenger: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | {
          __typename: 'TripPassenger';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: PassengerType;
          tripId: string;
          companyId: string;
          weightInKg: number | null;
          positionName: string | null;
          positionType: UnitPositionType | null;
          notificationAddress: string | null;
          personId: string | null;
          crewMemberId: string | null;
        }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTripPassengerByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTripPassengerByIdsQuery = {
  __typename: 'Query';
  tripPassenger: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | {
          __typename: 'TripPassenger';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: PassengerType;
          tripId: string;
          companyId: string;
          weightInKg: number | null;
          positionName: string | null;
          positionType: UnitPositionType | null;
          notificationAddress: string | null;
          personId: string | null;
          crewMemberId: string | null;
        }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitActivationRuleFieldsFragment = {
  __typename: 'UnitActivationRule';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  companyId: string;
  unitId: string;
  operationTypes: Array<OperationType>;
  missionRoleTypes: Array<MissionRoleType>;
  maximumDistanceInMiles: number | null;
};

export type FetchUnitActivationRuleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitActivationRuleByIdQuery = {
  __typename: 'Query';
  unitActivationRule: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | {
          __typename: 'UnitActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          unitId: string;
          operationTypes: Array<OperationType>;
          missionRoleTypes: Array<MissionRoleType>;
          maximumDistanceInMiles: number | null;
        }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitActivationRuleByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitActivationRuleByIdsQuery = {
  __typename: 'Query';
  unitActivationRule: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | {
          __typename: 'UnitActivationRule';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          unitId: string;
          operationTypes: Array<OperationType>;
          missionRoleTypes: Array<MissionRoleType>;
          maximumDistanceInMiles: number | null;
        }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitEMSystemMappingFieldsFragment = {
  __typename: 'UnitEMSystemMapping';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  resourceId: string;
  sendGps: boolean;
  unitId: string;
  companyId: string;
  divisionName: string | null;
};

export type FetchUnitEMSystemMappingByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitEMSystemMappingByIdQuery = {
  __typename: 'Query';
  unitEMSystemMapping: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | {
          __typename: 'UnitEMSystemMapping';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          resourceId: string;
          sendGps: boolean;
          unitId: string;
          companyId: string;
          divisionName: string | null;
        }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitEMSystemMappingByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitEMSystemMappingByIdsQuery = {
  __typename: 'Query';
  unitEMSystemMapping: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | {
          __typename: 'UnitEMSystemMapping';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          resourceId: string;
          sendGps: boolean;
          unitId: string;
          companyId: string;
          divisionName: string | null;
        }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitFieldsFragment = {
  __typename: 'Unit';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  status: UnitStatus;
  weatherStatus: WeatherStatus;
  baseId: string;
  regionId: string;
  isExternallyManaged: boolean;
  maximumFlightRule: FlightRule;
  isOnDelay: boolean;
  isEnabled: boolean;
  isSpare: boolean;
  integrations: Array<IntegrationSystem>;
  isCrewAvailable: boolean;
  updatePhoneNumbersFromExternal: boolean;
  companyId: string;
  isAdministrative: boolean | null;
  vehicleId: string | null;
  isHidden: boolean | null;
  isThirdPartyUnit: boolean | null;
  etloInMinutes: number | null;
  pilotNotes: string | null;
  lastPilotUpdateTime: Date | number | string | null;
  lastPilotUpdateById: string | null;
  plannedAvailableNotes: string | null;
  plannedAvailableTime: Date | number | string | null;
  oemPlacardNumber: string | null;
  primaryOutOfServiceEventId: string | null;
  emSystemResourceId: string | null;
  onBaseETAInMinutes: number | null;
  crewSourcedFromUnitId: string | null;
  completeFlightInstanceId: string | null;
  parentUnitId: string | null;
  crewSourcedToUnits: Array<{
    __typename: 'CrewSourcedUnit';
    id: string;
    unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
  } | null> | null;
};

export type FetchUnitByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitByIdQuery = {
  __typename: 'Query';
  unit: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | {
          __typename: 'Unit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          baseId: string;
          regionId: string;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          integrations: Array<IntegrationSystem>;
          isCrewAvailable: boolean;
          updatePhoneNumbersFromExternal: boolean;
          companyId: string;
          isAdministrative: boolean | null;
          vehicleId: string | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          oemPlacardNumber: string | null;
          primaryOutOfServiceEventId: string | null;
          emSystemResourceId: string | null;
          onBaseETAInMinutes: number | null;
          crewSourcedFromUnitId: string | null;
          completeFlightInstanceId: string | null;
          parentUnitId: string | null;
          crewSourcedToUnits: Array<{
            __typename: 'CrewSourcedUnit';
            id: string;
            unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
          } | null> | null;
        }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitByIdsQuery = {
  __typename: 'Query';
  unit: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | {
          __typename: 'Unit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          baseId: string;
          regionId: string;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          integrations: Array<IntegrationSystem>;
          isCrewAvailable: boolean;
          updatePhoneNumbersFromExternal: boolean;
          companyId: string;
          isAdministrative: boolean | null;
          vehicleId: string | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          oemPlacardNumber: string | null;
          primaryOutOfServiceEventId: string | null;
          emSystemResourceId: string | null;
          onBaseETAInMinutes: number | null;
          crewSourcedFromUnitId: string | null;
          completeFlightInstanceId: string | null;
          parentUnitId: string | null;
          crewSourcedToUnits: Array<{
            __typename: 'CrewSourcedUnit';
            id: string;
            unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
          } | null> | null;
        }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitNoteFieldsFragment = {
  __typename: 'UnitNote';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  content: string;
  noteTime: Date | number | string;
  unitId: string;
  companyId: string;
  authorId: string | null;
  noteCategory: string | null;
  noteMetadataJson: string | null;
};

export type FetchUnitNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitNoteByIdQuery = {
  __typename: 'Query';
  unitNote: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | {
          __typename: 'UnitNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          content: string;
          noteTime: Date | number | string;
          unitId: string;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
        }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitNoteByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitNoteByIdsQuery = {
  __typename: 'Query';
  unitNote: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | {
          __typename: 'UnitNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          content: string;
          noteTime: Date | number | string;
          unitId: string;
          companyId: string;
          authorId: string | null;
          noteCategory: string | null;
          noteMetadataJson: string | null;
        }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitPositionFieldsFragment = {
  __typename: 'UnitPosition';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  type: UnitPositionType;
  isFlightCrew: boolean;
  isNonEmployee: boolean;
  unitId: string;
  companyId: string;
  notificationAddress: string | null;
  teamMemberId: string | null;
  firstName: string | null;
  lastName: string | null;
};

export type FetchUnitPositionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitPositionByIdQuery = {
  __typename: 'Query';
  unitPosition: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | {
          __typename: 'UnitPosition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          type: UnitPositionType;
          isFlightCrew: boolean;
          isNonEmployee: boolean;
          unitId: string;
          companyId: string;
          notificationAddress: string | null;
          teamMemberId: string | null;
          firstName: string | null;
          lastName: string | null;
        }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitPositionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitPositionByIdsQuery = {
  __typename: 'Query';
  unitPosition: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | {
          __typename: 'UnitPosition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          type: UnitPositionType;
          isFlightCrew: boolean;
          isNonEmployee: boolean;
          unitId: string;
          companyId: string;
          notificationAddress: string | null;
          teamMemberId: string | null;
          firstName: string | null;
          lastName: string | null;
        }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitShiftFieldsFragment = {
  __typename: 'UnitShift';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  startTimeInMinutes: number;
  endTimeInMinutes: number;
  unitId: string;
  companyId: string;
};

export type FetchUnitShiftByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitShiftByIdQuery = {
  __typename: 'Query';
  unitShift: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | {
          __typename: 'UnitShift';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          startTimeInMinutes: number;
          endTimeInMinutes: number;
          unitId: string;
          companyId: string;
        }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitShiftByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitShiftByIdsQuery = {
  __typename: 'Query';
  unitShift: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | {
          __typename: 'UnitShift';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          startTimeInMinutes: number;
          endTimeInMinutes: number;
          unitId: string;
          companyId: string;
        }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitStatusHistoryEntryFieldsFragment = {
  __typename: 'UnitStatusHistoryEntry';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  startTime: Date | number | string;
  endTime: Date | number | string;
  status: UnitStatus;
  unitId: string;
  companyId: string;
};

export type FetchUnitStatusHistoryEntryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitStatusHistoryEntryByIdQuery = {
  __typename: 'Query';
  unitStatusHistoryEntry: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | {
          __typename: 'UnitStatusHistoryEntry';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          startTime: Date | number | string;
          endTime: Date | number | string;
          status: UnitStatus;
          unitId: string;
          companyId: string;
        }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitStatusHistoryEntryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitStatusHistoryEntryByIdsQuery = {
  __typename: 'Query';
  unitStatusHistoryEntry: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | {
          __typename: 'UnitStatusHistoryEntry';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          startTime: Date | number | string;
          endTime: Date | number | string;
          status: UnitStatus;
          unitId: string;
          companyId: string;
        }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type UnitSummaryFieldsFragment = {
  __typename: 'UnitSummary';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  id: string;
  name: string;
  abbreviation: string;
  status: UnitStatus;
  weatherStatus: WeatherStatus;
  isExternallyManaged: boolean;
  maximumFlightRule: FlightRule;
  isOnDelay: boolean;
  isEnabled: boolean;
  isSpare: boolean;
  isCrewAvailable: boolean;
  baseId: string;
  regionId: string;
  companyId: string;
  isAdministrative: boolean | null;
  isHidden: boolean | null;
  isThirdPartyUnit: boolean | null;
  etloInMinutes: number | null;
  pilotNotes: string | null;
  lastPilotUpdateTime: Date | number | string | null;
  lastPilotUpdateById: string | null;
  plannedAvailableNotes: string | null;
  plannedAvailableTime: Date | number | string | null;
  lastPilotUpdateName: string | null;
  baseTimezoneCd: string | null;
  vehicleSummaryId: string | null;
  vehicleId: string | null;
  communicationCenterId: string | null;
  shifts: Array<{
    __typename: 'UnitShiftSummary';
    id: string;
    name: string;
    startTimeInMinutes: number;
    endTimeInMinutes: number;
  }>;
  outOfServiceEvents: Array<{
    __typename: 'OutOfServiceEventSummary';
    id: string;
    type: OutOfServiceType;
    eventNumber: string;
    estimatedEndTime: Date | number | string;
    reasonName: string;
    reasonId: string;
    startTime: Date | number | string | null;
    isOpportunisticOOS: boolean | null;
    notes: string | null;
  }>;
  positions: Array<{
    __typename: 'UnitPositionSummary';
    id: string;
    name: string;
    type: UnitPositionType;
    isFlightCrew: boolean;
    isNonEmployee: boolean;
    isNonCompliant: boolean;
    notificationAddress: string | null;
    teamMemberId: string | null;
    teamMemberFirstName: string | null;
    teamMemberLastName: string | null;
    nonComplianceReason: string | null;
  }>;
  paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchUnitSummaryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUnitSummaryByIdQuery = {
  __typename: 'Query';
  unitSummary: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | {
          __typename: 'UnitSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          isCrewAvailable: boolean;
          baseId: string;
          regionId: string;
          companyId: string;
          isAdministrative: boolean | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          lastPilotUpdateName: string | null;
          baseTimezoneCd: string | null;
          vehicleSummaryId: string | null;
          vehicleId: string | null;
          communicationCenterId: string | null;
          shifts: Array<{
            __typename: 'UnitShiftSummary';
            id: string;
            name: string;
            startTimeInMinutes: number;
            endTimeInMinutes: number;
          }>;
          outOfServiceEvents: Array<{
            __typename: 'OutOfServiceEventSummary';
            id: string;
            type: OutOfServiceType;
            eventNumber: string;
            estimatedEndTime: Date | number | string;
            reasonName: string;
            reasonId: string;
            startTime: Date | number | string | null;
            isOpportunisticOOS: boolean | null;
            notes: string | null;
          }>;
          positions: Array<{
            __typename: 'UnitPositionSummary';
            id: string;
            name: string;
            type: UnitPositionType;
            isFlightCrew: boolean;
            isNonEmployee: boolean;
            isNonCompliant: boolean;
            notificationAddress: string | null;
            teamMemberId: string | null;
            teamMemberFirstName: string | null;
            teamMemberLastName: string | null;
            nonComplianceReason: string | null;
          }>;
          paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchUnitSummaryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchUnitSummaryByIdsQuery = {
  __typename: 'Query';
  unitSummary: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | {
          __typename: 'UnitSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          isCrewAvailable: boolean;
          baseId: string;
          regionId: string;
          companyId: string;
          isAdministrative: boolean | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          lastPilotUpdateName: string | null;
          baseTimezoneCd: string | null;
          vehicleSummaryId: string | null;
          vehicleId: string | null;
          communicationCenterId: string | null;
          shifts: Array<{
            __typename: 'UnitShiftSummary';
            id: string;
            name: string;
            startTimeInMinutes: number;
            endTimeInMinutes: number;
          }>;
          outOfServiceEvents: Array<{
            __typename: 'OutOfServiceEventSummary';
            id: string;
            type: OutOfServiceType;
            eventNumber: string;
            estimatedEndTime: Date | number | string;
            reasonName: string;
            reasonId: string;
            startTime: Date | number | string | null;
            isOpportunisticOOS: boolean | null;
            notes: string | null;
          }>;
          positions: Array<{
            __typename: 'UnitPositionSummary';
            id: string;
            name: string;
            type: UnitPositionType;
            isFlightCrew: boolean;
            isNonEmployee: boolean;
            isNonCompliant: boolean;
            notificationAddress: string | null;
            teamMemberId: string | null;
            teamMemberFirstName: string | null;
            teamMemberLastName: string | null;
            nonComplianceReason: string | null;
          }>;
          paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleDispositionFieldsFragment = {
  __typename: 'VehicleDisposition';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  vehicleId: string;
  status: VehicleStatus;
  companyId: string;
  currentWaypointId: string | null;
  currentTripLegId: string | null;
  currentTripId: string | null;
  lastTripId: string | null;
  currentAgencyLocationId: string | null;
  notes: string | null;
  isAssetOutOfService: boolean | null;
  lastQualifyingPositionReportTime: Date | number | string | null;
  latitude: number | null;
  longitude: number | null;
  etlo: Date | number | string | null;
  statusDescription: string | null;
  positionTime: Date | number | string | null;
  positionSource: PositionReportSource | null;
  vehiclePositionSummaryId: string | null;
  latestPositionReportId: string | null;
  latestFlightFollowingReportId: string | null;
  from: {
    __typename: 'WaypointSummary';
    id: string;
    name: string;
    abbreviation: string;
    type: WaypointType;
  } | null;
  to: {
    __typename: 'WaypointSummary';
    id: string;
    name: string;
    abbreviation: string;
    type: WaypointType;
  } | null;
};

export type FetchVehicleDispositionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleDispositionByIdQuery = {
  __typename: 'Query';
  vehicleDisposition: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | {
          __typename: 'VehicleDisposition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          status: VehicleStatus;
          companyId: string;
          currentWaypointId: string | null;
          currentTripLegId: string | null;
          currentTripId: string | null;
          lastTripId: string | null;
          currentAgencyLocationId: string | null;
          notes: string | null;
          isAssetOutOfService: boolean | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          latitude: number | null;
          longitude: number | null;
          etlo: Date | number | string | null;
          statusDescription: string | null;
          positionTime: Date | number | string | null;
          positionSource: PositionReportSource | null;
          vehiclePositionSummaryId: string | null;
          latestPositionReportId: string | null;
          latestFlightFollowingReportId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
        }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleDispositionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleDispositionByIdsQuery = {
  __typename: 'Query';
  vehicleDisposition: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | {
          __typename: 'VehicleDisposition';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          status: VehicleStatus;
          companyId: string;
          currentWaypointId: string | null;
          currentTripLegId: string | null;
          currentTripId: string | null;
          lastTripId: string | null;
          currentAgencyLocationId: string | null;
          notes: string | null;
          isAssetOutOfService: boolean | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          latitude: number | null;
          longitude: number | null;
          etlo: Date | number | string | null;
          statusDescription: string | null;
          positionTime: Date | number | string | null;
          positionSource: PositionReportSource | null;
          vehiclePositionSummaryId: string | null;
          latestPositionReportId: string | null;
          latestFlightFollowingReportId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
        }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleNotificationGroupFieldsFragment = {
  __typename: 'VehicleNotificationGroup';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  vehicleId: string;
  notificationGroupId: string;
};

export type FetchVehicleNotificationGroupByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleNotificationGroupByIdQuery = {
  __typename: 'Query';
  vehicleNotificationGroup: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | {
          __typename: 'VehicleNotificationGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          notificationGroupId: string;
        }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleNotificationGroupByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleNotificationGroupByIdsQuery = {
  __typename: 'Query';
  vehicleNotificationGroup: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | {
          __typename: 'VehicleNotificationGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          vehicleId: string;
          notificationGroupId: string;
        }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehiclePositionSummaryFieldsFragment = {
  __typename: 'VehiclePositionSummary';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  id: string;
  vehicleId: string;
  latitude: number;
  longitude: number;
  positionSource: PositionReportSource;
  positionTime: Date | number | string;
  companyId: string;
  lastPositionReportId: string | null;
  lastQualifyingPositionReportTime: Date | number | string | null;
  etlo: Date | number | string | null;
  lastGpsAutoPositionTime: Date | number | string | null;
  lastTakeOffTime: Date | number | string | null;
  lastLandedTime: Date | number | string | null;
  gpsProvider: GpsProvider | null;
  altitude: number | null;
  speedInKnots: number | null;
  heading: number | null;
};

export type FetchVehiclePositionSummaryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehiclePositionSummaryByIdQuery = {
  __typename: 'Query';
  vehiclePositionSummary: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | {
          __typename: 'VehiclePositionSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          vehicleId: string;
          latitude: number;
          longitude: number;
          positionSource: PositionReportSource;
          positionTime: Date | number | string;
          companyId: string;
          lastPositionReportId: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          etlo: Date | number | string | null;
          lastGpsAutoPositionTime: Date | number | string | null;
          lastTakeOffTime: Date | number | string | null;
          lastLandedTime: Date | number | string | null;
          gpsProvider: GpsProvider | null;
          altitude: number | null;
          speedInKnots: number | null;
          heading: number | null;
        }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehiclePositionSummaryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehiclePositionSummaryByIdsQuery = {
  __typename: 'Query';
  vehiclePositionSummary: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | {
          __typename: 'VehiclePositionSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          vehicleId: string;
          latitude: number;
          longitude: number;
          positionSource: PositionReportSource;
          positionTime: Date | number | string;
          companyId: string;
          lastPositionReportId: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          etlo: Date | number | string | null;
          lastGpsAutoPositionTime: Date | number | string | null;
          lastTakeOffTime: Date | number | string | null;
          lastLandedTime: Date | number | string | null;
          gpsProvider: GpsProvider | null;
          altitude: number | null;
          speedInKnots: number | null;
          heading: number | null;
        }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleSummaryFieldsFragment = {
  __typename: 'VehicleSummary';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  id: string;
  type: VehicleType;
  registrationNumber: string;
  unitSummaryId: string;
  regionId: string;
  status: VehicleStatus;
  statusDescription: string;
  vehicleDispositionId: string;
  unitId: string;
  companyId: string;
  serialNumber: string | null;
  dispatchCompanyId: string | null;
  makeName: string | null;
  modelName: string | null;
  etlo: Date | number | string | null;
  eta: Date | number | string | null;
  currentCardNumber: string | null;
  currentCardSummaryId: string | null;
  lastQualifyingPositionReportTime: Date | number | string | null;
  currentOrNextLegSequence: number | null;
  totalLegCount: number | null;
  dateOnFinalMarked: Date | number | string | null;
  communicationCenterId: string | null;
  currentCardId: string | null;
  from: {
    __typename: 'WaypointSummary';
    id: string;
    name: string;
    abbreviation: string;
    type: WaypointType;
  } | null;
  to: {
    __typename: 'WaypointSummary';
    id: string;
    name: string;
    abbreviation: string;
    type: WaypointType;
  } | null;
  latestPositionReportSummary: {
    __typename: 'PositionReportSummary';
    id: string;
    positionTime: Date | number | string;
    source: PositionReportSource;
  } | null;
  lastKnownCoordinates: {
    __typename: 'Coordinates';
    latitude: number | null;
    longitude: number | null;
  } | null;
};

export type FetchVehicleSummaryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleSummaryByIdQuery = {
  __typename: 'Query';
  vehicleSummary: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | {
          __typename: 'VehicleSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          unitSummaryId: string;
          regionId: string;
          status: VehicleStatus;
          statusDescription: string;
          vehicleDispositionId: string;
          unitId: string;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          makeName: string | null;
          modelName: string | null;
          etlo: Date | number | string | null;
          eta: Date | number | string | null;
          currentCardNumber: string | null;
          currentCardSummaryId: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          currentOrNextLegSequence: number | null;
          totalLegCount: number | null;
          dateOnFinalMarked: Date | number | string | null;
          communicationCenterId: string | null;
          currentCardId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          latestPositionReportSummary: {
            __typename: 'PositionReportSummary';
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
          } | null;
          lastKnownCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleSummaryByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleSummaryByIdsQuery = {
  __typename: 'Query';
  vehicleSummary: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | {
          __typename: 'VehicleSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          unitSummaryId: string;
          regionId: string;
          status: VehicleStatus;
          statusDescription: string;
          vehicleDispositionId: string;
          unitId: string;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          makeName: string | null;
          modelName: string | null;
          etlo: Date | number | string | null;
          eta: Date | number | string | null;
          currentCardNumber: string | null;
          currentCardSummaryId: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          currentOrNextLegSequence: number | null;
          totalLegCount: number | null;
          dateOnFinalMarked: Date | number | string | null;
          communicationCenterId: string | null;
          currentCardId: string | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          latestPositionReportSummary: {
            __typename: 'PositionReportSummary';
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
          } | null;
          lastKnownCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type WaypointFieldsFragment = {
  __typename: 'Waypoint';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  type: WaypointType;
  companyId: string;
  timezoneCd: string | null;
  isRotorWingLz: boolean | null;
  arrivalTime: Date | number | string | null;
  departureTime: Date | number | string | null;
  locationId: string | null;
  isPatientPickup: boolean | null;
  isPatientDropoff: boolean | null;
  arrivingType: WaypointType | null;
  estimatedDurationId: string | null;
  currentEtaId: string | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  };
};

export type FetchWaypointByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchWaypointByIdQuery = {
  __typename: 'Query';
  waypoint: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | {
          __typename: 'Waypoint';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          companyId: string;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          arrivalTime: Date | number | string | null;
          departureTime: Date | number | string | null;
          locationId: string | null;
          isPatientPickup: boolean | null;
          isPatientDropoff: boolean | null;
          arrivingType: WaypointType | null;
          estimatedDurationId: string | null;
          currentEtaId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchWaypointByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchWaypointByIdsQuery = {
  __typename: 'Query';
  waypoint: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | {
          __typename: 'Waypoint';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          companyId: string;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          arrivalTime: Date | number | string | null;
          departureTime: Date | number | string | null;
          locationId: string | null;
          isPatientPickup: boolean | null;
          isPatientDropoff: boolean | null;
          arrivingType: WaypointType | null;
          estimatedDurationId: string | null;
          currentEtaId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type WebOrderLogFieldsFragment = {
  __typename: 'WebOrderLog';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  requestJson: string;
  name: string;
  isSuccess: boolean;
  errors: string | null;
  entityId: string | null;
  entityType: EntityType | null;
  dateAcknowledged: Date | number | string | null;
  acknowledgedById: string | null;
  changes: Array<{
    __typename: 'WebOrderLogEntityChanges';
    id: string;
    entityType: string;
    fieldName: string;
    oldValue: string | null;
    newValue: string | null;
  } | null> | null;
};

export type FetchWebOrderLogByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchWebOrderLogByIdQuery = {
  __typename: 'Query';
  webOrderLog: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | {
          __typename: 'WebOrderLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          requestJson: string;
          name: string;
          isSuccess: boolean;
          errors: string | null;
          entityId: string | null;
          entityType: EntityType | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          changes: Array<{
            __typename: 'WebOrderLogEntityChanges';
            id: string;
            entityType: string;
            fieldName: string;
            oldValue: string | null;
            newValue: string | null;
          } | null> | null;
        }
      | null;
  };
};

export type FetchWebOrderLogByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchWebOrderLogByIdsQuery = {
  __typename: 'Query';
  webOrderLog: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | {
          __typename: 'WebOrderLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          requestJson: string;
          name: string;
          isSuccess: boolean;
          errors: string | null;
          entityId: string | null;
          entityType: EntityType | null;
          dateAcknowledged: Date | number | string | null;
          acknowledgedById: string | null;
          changes: Array<{
            __typename: 'WebOrderLogEntityChanges';
            id: string;
            entityType: string;
            fieldName: string;
            oldValue: string | null;
            newValue: string | null;
          } | null> | null;
        }
    >;
  };
};

export type AccessibleItemFieldsFragment = {
  __typename: 'AccessibleItem';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  type: EntityType;
  entityId: string;
  personId: string;
  userRoles: Array<UserRole | null> | null;
};

export type FetchAccessibleItemByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAccessibleItemByIdQuery = {
  __typename: 'Query';
  accessibleItem: {
    __typename: 'EntityQueries';
    byId:
      | {
          __typename: 'AccessibleItem';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: EntityType;
          entityId: string;
          personId: string;
          userRoles: Array<UserRole | null> | null;
        }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAccessibleItemByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAccessibleItemByIdsQuery = {
  __typename: 'Query';
  accessibleItem: {
    __typename: 'EntityQueries';
    byIds: Array<
      | {
          __typename: 'AccessibleItem';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: EntityType;
          entityId: string;
          personId: string;
          userRoles: Array<UserRole | null> | null;
        }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type AgencyFieldsFragment = {
  __typename: 'Agency';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  type: AgencyType;
  isCompetitor: boolean;
  isInternallyOwned: boolean;
  parentCompanyId: string | null;
  notes: string | null;
};

export type FetchAgencyByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAgencyByIdQuery = {
  __typename: 'Query';
  agency: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | {
          __typename: 'Agency';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: AgencyType;
          isCompetitor: boolean;
          isInternallyOwned: boolean;
          parentCompanyId: string | null;
          notes: string | null;
        }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAgencyByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAgencyByIdsQuery = {
  __typename: 'Query';
  agency: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | {
          __typename: 'Agency';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: AgencyType;
          isCompetitor: boolean;
          isInternallyOwned: boolean;
          parentCompanyId: string | null;
          notes: string | null;
        }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type AgencyLocationFieldsFragment = {
  __typename: 'AgencyLocation';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  isInTransportNet: boolean;
  agencyId: string;
  emailAddress: string | null;
  primaryPhoneNumber: string | null;
  secondaryPhoneNumber: string | null;
  smsPhoneNumber: string | null;
  faxPhoneNumber: string | null;
  notes: string | null;
  vehicleType: VehicleType | null;
  estimatedDepartureTimeInMinutes: number | null;
  locationId: string | null;
};

export type FetchAgencyLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAgencyLocationByIdQuery = {
  __typename: 'Query';
  agencyLocation: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | {
          __typename: 'AgencyLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isInTransportNet: boolean;
          agencyId: string;
          emailAddress: string | null;
          primaryPhoneNumber: string | null;
          secondaryPhoneNumber: string | null;
          smsPhoneNumber: string | null;
          faxPhoneNumber: string | null;
          notes: string | null;
          vehicleType: VehicleType | null;
          estimatedDepartureTimeInMinutes: number | null;
          locationId: string | null;
        }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAgencyLocationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAgencyLocationByIdsQuery = {
  __typename: 'Query';
  agencyLocation: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | {
          __typename: 'AgencyLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          isInTransportNet: boolean;
          agencyId: string;
          emailAddress: string | null;
          primaryPhoneNumber: string | null;
          secondaryPhoneNumber: string | null;
          smsPhoneNumber: string | null;
          faxPhoneNumber: string | null;
          notes: string | null;
          vehicleType: VehicleType | null;
          estimatedDepartureTimeInMinutes: number | null;
          locationId: string | null;
        }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type AirportFieldsFragment = {
  __typename: 'Airport';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  code: string;
  airportType: string;
  airportCodeType: AirportCodeType;
  sourceSystemId: number | null;
  preferredFboId: string | null;
  locationId: string | null;
};

export type FetchAirportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAirportByIdQuery = {
  __typename: 'Query';
  airport: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | {
          __typename: 'Airport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          airportType: string;
          airportCodeType: AirportCodeType;
          sourceSystemId: number | null;
          preferredFboId: string | null;
          locationId: string | null;
        }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAirportByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAirportByIdsQuery = {
  __typename: 'Query';
  airport: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | {
          __typename: 'Airport';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          airportType: string;
          airportCodeType: AirportCodeType;
          sourceSystemId: number | null;
          preferredFboId: string | null;
          locationId: string | null;
        }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ArchiveLogFieldsFragment = {
  __typename: 'ArchiveLog';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  archiveEntityType: ArchiveEntityType;
  archivedUntilDate: Date | number | string;
  isError: boolean;
  notes: string | null;
};

export type FetchArchiveLogByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchArchiveLogByIdQuery = {
  __typename: 'Query';
  archiveLog: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | {
          __typename: 'ArchiveLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          archiveEntityType: ArchiveEntityType;
          archivedUntilDate: Date | number | string;
          isError: boolean;
          notes: string | null;
        }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchArchiveLogByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchArchiveLogByIdsQuery = {
  __typename: 'Query';
  archiveLog: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | {
          __typename: 'ArchiveLog';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          archiveEntityType: ArchiveEntityType;
          archivedUntilDate: Date | number | string;
          isError: boolean;
          notes: string | null;
        }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type AttachmentFieldsFragment = {
  __typename: 'Attachment';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  attachmentEntityType: AttachmentEntityType;
  fileName: string;
  entityId: string | null;
  fileSizeInBytes: number | null;
  contentType: string | null;
};

export type FetchAttachmentByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAttachmentByIdQuery = {
  __typename: 'Query';
  attachment: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | {
          __typename: 'Attachment';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          attachmentEntityType: AttachmentEntityType;
          fileName: string;
          entityId: string | null;
          fileSizeInBytes: number | null;
          contentType: string | null;
        }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchAttachmentByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchAttachmentByIdsQuery = {
  __typename: 'Query';
  attachment: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | {
          __typename: 'Attachment';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          attachmentEntityType: AttachmentEntityType;
          fileName: string;
          entityId: string | null;
          fileSizeInBytes: number | null;
          contentType: string | null;
        }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type BaseControlZoneFieldsFragment = {
  __typename: 'BaseControlZone';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  controlZoneId: string;
  baseId: string;
  companyId: string;
};

export type FetchBaseControlZoneByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchBaseControlZoneByIdQuery = {
  __typename: 'Query';
  baseControlZone: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | {
          __typename: 'BaseControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          controlZoneId: string;
          baseId: string;
          companyId: string;
        }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchBaseControlZoneByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchBaseControlZoneByIdsQuery = {
  __typename: 'Query';
  baseControlZone: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | {
          __typename: 'BaseControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          controlZoneId: string;
          baseId: string;
          companyId: string;
        }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type BaseFieldsFragment = {
  __typename: 'Base';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  locationId: string;
  businessModel: BusinessModel;
  companyId: string;
  plannedOperationsStart: Date | number | string | null;
  operationsStarted: Date | number | string | null;
  operationsTerminated: Date | number | string | null;
  dateOfMaturity: Date | number | string | null;
  primaryPhoneNumber: string | null;
  estimatedLiftoffTime: number | null;
  licenseNumber: string | null;
  enableFlightLogDutyLog: boolean | null;
  dispatchBaseId: string | null;
  reportBaseId: string | null;
  aviationCompanyId: string | null;
  workdayBaseId: string | null;
  gmrWorkdayLocationId: string | null;
  dateLastUpdatedFromGMRWorkday: Date | number | string | null;
  pilotPhoneNumber: string | null;
  crewPhoneNumber1: string | null;
  crewPhoneNumber2: string | null;
  brandName: string | null;
  medicalFacilityId: string | null;
  hoursOfOperation: {
    __typename: 'HoursOfOperation';
    is24Hours: boolean | null;
    startTime: Date | number | string | null;
    endTime: Date | number | string | null;
  };
  communicationCenterCustomIdentifiers: Array<{
    __typename: 'IdNameListItem';
    id: string;
    name: string;
  } | null> | null;
  additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchBaseByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchBaseByIdQuery = {
  __typename: 'Query';
  base: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | {
          __typename: 'Base';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationId: string;
          businessModel: BusinessModel;
          companyId: string;
          plannedOperationsStart: Date | number | string | null;
          operationsStarted: Date | number | string | null;
          operationsTerminated: Date | number | string | null;
          dateOfMaturity: Date | number | string | null;
          primaryPhoneNumber: string | null;
          estimatedLiftoffTime: number | null;
          licenseNumber: string | null;
          enableFlightLogDutyLog: boolean | null;
          dispatchBaseId: string | null;
          reportBaseId: string | null;
          aviationCompanyId: string | null;
          workdayBaseId: string | null;
          gmrWorkdayLocationId: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          pilotPhoneNumber: string | null;
          crewPhoneNumber1: string | null;
          crewPhoneNumber2: string | null;
          brandName: string | null;
          medicalFacilityId: string | null;
          hoursOfOperation: {
            __typename: 'HoursOfOperation';
            is24Hours: boolean | null;
            startTime: Date | number | string | null;
            endTime: Date | number | string | null;
          };
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchBaseByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchBaseByIdsQuery = {
  __typename: 'Query';
  base: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | {
          __typename: 'Base';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationId: string;
          businessModel: BusinessModel;
          companyId: string;
          plannedOperationsStart: Date | number | string | null;
          operationsStarted: Date | number | string | null;
          operationsTerminated: Date | number | string | null;
          dateOfMaturity: Date | number | string | null;
          primaryPhoneNumber: string | null;
          estimatedLiftoffTime: number | null;
          licenseNumber: string | null;
          enableFlightLogDutyLog: boolean | null;
          dispatchBaseId: string | null;
          reportBaseId: string | null;
          aviationCompanyId: string | null;
          workdayBaseId: string | null;
          gmrWorkdayLocationId: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          pilotPhoneNumber: string | null;
          crewPhoneNumber1: string | null;
          crewPhoneNumber2: string | null;
          brandName: string | null;
          medicalFacilityId: string | null;
          hoursOfOperation: {
            __typename: 'HoursOfOperation';
            is24Hours: boolean | null;
            startTime: Date | number | string | null;
            endTime: Date | number | string | null;
          };
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type BaseMedicalControlContactFieldsFragment = {
  __typename: 'BaseMedicalControlContact';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  personId: string;
  rank: number;
  baseId: string;
  companyId: string;
  specialty: string | null;
};

export type FetchBaseMedicalControlContactByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchBaseMedicalControlContactByIdQuery = {
  __typename: 'Query';
  baseMedicalControlContact: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | {
          __typename: 'BaseMedicalControlContact';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          personId: string;
          rank: number;
          baseId: string;
          companyId: string;
          specialty: string | null;
        }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchBaseMedicalControlContactByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchBaseMedicalControlContactByIdsQuery = {
  __typename: 'Query';
  baseMedicalControlContact: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | {
          __typename: 'BaseMedicalControlContact';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          personId: string;
          rank: number;
          baseId: string;
          companyId: string;
          specialty: string | null;
        }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type BaseMedicalControlContactStateFieldsFragment = {
  __typename: 'BaseMedicalControlContactState';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  stateAbbrevation: string;
  companyId: string;
  baseMedicalControlContactId: string | null;
};

export type FetchBaseMedicalControlContactStateByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchBaseMedicalControlContactStateByIdQuery = {
  __typename: 'Query';
  baseMedicalControlContactState: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | {
          __typename: 'BaseMedicalControlContactState';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          companyId: string;
          baseMedicalControlContactId: string | null;
        }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchBaseMedicalControlContactStateByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchBaseMedicalControlContactStateByIdsQuery = {
  __typename: 'Query';
  baseMedicalControlContactState: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | {
          __typename: 'BaseMedicalControlContactState';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          companyId: string;
          baseMedicalControlContactId: string | null;
        }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CapabilityFieldsFragment = {
  __typename: 'Capability';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  description: string;
  entityType: EntityType;
};

export type FetchCapabilityByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCapabilityByIdQuery = {
  __typename: 'Query';
  capability: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | {
          __typename: 'Capability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          description: string;
          entityType: EntityType;
        }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCapabilityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCapabilityByIdsQuery = {
  __typename: 'Query';
  capability: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | {
          __typename: 'Capability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          description: string;
          entityType: EntityType;
        }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CommunicationCenterFieldsFragment = {
  __typename: 'CommunicationCenter';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  includeCompetitors: boolean;
  playAlertForManualPositionReports: boolean;
  enableRAAlert: boolean;
  useCrewPhoneNumber: boolean;
  displayContactTimeline: boolean;
  companyId: string;
  timezoneCd: string | null;
  primaryPhoneNumber: string | null;
  emailAddress: string | null;
  showReferToGmrWarning: boolean | null;
  alertFrequencyForGroundVehicles: number | null;
};

export type FetchCommunicationCenterByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCommunicationCenterByIdQuery = {
  __typename: 'Query';
  communicationCenter: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | {
          __typename: 'CommunicationCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          playAlertForManualPositionReports: boolean;
          enableRAAlert: boolean;
          useCrewPhoneNumber: boolean;
          displayContactTimeline: boolean;
          companyId: string;
          timezoneCd: string | null;
          primaryPhoneNumber: string | null;
          emailAddress: string | null;
          showReferToGmrWarning: boolean | null;
          alertFrequencyForGroundVehicles: number | null;
        }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCommunicationCenterByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCommunicationCenterByIdsQuery = {
  __typename: 'Query';
  communicationCenter: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | {
          __typename: 'CommunicationCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          includeCompetitors: boolean;
          playAlertForManualPositionReports: boolean;
          enableRAAlert: boolean;
          useCrewPhoneNumber: boolean;
          displayContactTimeline: boolean;
          companyId: string;
          timezoneCd: string | null;
          primaryPhoneNumber: string | null;
          emailAddress: string | null;
          showReferToGmrWarning: boolean | null;
          alertFrequencyForGroundVehicles: number | null;
        }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CommunicationCenterTransportOfferOptionFieldsFragment = {
  __typename: 'CommunicationCenterTransportOfferOption';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  includeAbortedUnit: boolean;
  requestedVehicleType: VehicleType | null;
  transportOfferAlgorithm: TransportOfferAlgorithm | null;
  minimumFlightRule: FlightRule | null;
  includeCompetitors: boolean | null;
  communicationCenterId: string | null;
  requiredCapabilities: Array<{ __typename: 'RequiredCapabilityIdList'; id: string }>;
};

export type FetchCommunicationCenterTransportOfferOptionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCommunicationCenterTransportOfferOptionByIdQuery = {
  __typename: 'Query';
  communicationCenterTransportOfferOption: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | {
          __typename: 'CommunicationCenterTransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          communicationCenterId: string | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapabilityIdList'; id: string }>;
        }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCommunicationCenterTransportOfferOptionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCommunicationCenterTransportOfferOptionByIdsQuery = {
  __typename: 'Query';
  communicationCenterTransportOfferOption: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | {
          __typename: 'CommunicationCenterTransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          communicationCenterId: string | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapabilityIdList'; id: string }>;
        }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CompanyFieldsFragment = {
  __typename: 'Company';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  companyCode: string;
  includeCompetitors: boolean;
  hasPrivateUnits: boolean;
  isOemCompany: boolean;
  gpsFeedResetsPositionReportTime: boolean;
  unitRemainsInServiceWithNoVehicle: boolean;
  enableNotificationGroupTypes: boolean;
  restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
  imageUri: string | null;
  gLCode: string | null;
  callNumberPrefix: string | null;
  timezoneCd: string | null;
  flightFollowingFields: Array<FlightFollowingField | null> | null;
  requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
  crewPatientInfoPageNotificationTemplateId: string | null;
  transportCheckTimerDurationInMinutes: number | null;
};

export type FetchCompanyByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCompanyByIdQuery = {
  __typename: 'Query';
  company: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCompanyByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCompanyByIdsQuery = {
  __typename: 'Query';
  company: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | {
          __typename: 'Company';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          companyCode: string;
          includeCompetitors: boolean;
          hasPrivateUnits: boolean;
          isOemCompany: boolean;
          gpsFeedResetsPositionReportTime: boolean;
          unitRemainsInServiceWithNoVehicle: boolean;
          enableNotificationGroupTypes: boolean;
          restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
          imageUri: string | null;
          gLCode: string | null;
          callNumberPrefix: string | null;
          timezoneCd: string | null;
          flightFollowingFields: Array<FlightFollowingField | null> | null;
          requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
          crewPatientInfoPageNotificationTemplateId: string | null;
          transportCheckTimerDurationInMinutes: number | null;
        }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type CompleteFlightInstanceFieldsFragment = {
  __typename: 'CompleteFlightInstance';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  completeFlightInstanceName: string;
  url: string;
  username: string;
  apiKey: string;
  isPrimary: boolean;
};

export type FetchCompleteFlightInstanceByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCompleteFlightInstanceByIdQuery = {
  __typename: 'Query';
  completeFlightInstance: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | {
          __typename: 'CompleteFlightInstance';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          completeFlightInstanceName: string;
          url: string;
          username: string;
          apiKey: string;
          isPrimary: boolean;
        }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchCompleteFlightInstanceByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchCompleteFlightInstanceByIdsQuery = {
  __typename: 'Query';
  completeFlightInstance: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | {
          __typename: 'CompleteFlightInstance';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          completeFlightInstanceName: string;
          url: string;
          username: string;
          apiKey: string;
          isPrimary: boolean;
        }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ControlZoneFieldsFragment = {
  __typename: 'ControlZone';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  companyId: string;
};

export type FetchControlZoneByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchControlZoneByIdQuery = {
  __typename: 'Query';
  controlZone: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | {
          __typename: 'ControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
        }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchControlZoneByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchControlZoneByIdsQuery = {
  __typename: 'Query';
  controlZone: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | {
          __typename: 'ControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
        }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type DepartmentFieldsFragment = {
  __typename: 'Department';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  code: string;
};

export type FetchDepartmentByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchDepartmentByIdQuery = {
  __typename: 'Query';
  department: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | {
          __typename: 'Department';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
        }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchDepartmentByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchDepartmentByIdsQuery = {
  __typename: 'Query';
  department: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | {
          __typename: 'Department';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
        }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type EntityCapabilityFieldsFragment = {
  __typename: 'EntityCapability';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  capabilityId: string;
  entityId: string;
  entityType: EntityType;
};

export type FetchEntityCapabilityByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchEntityCapabilityByIdQuery = {
  __typename: 'Query';
  entityCapability: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | {
          __typename: 'EntityCapability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          capabilityId: string;
          entityId: string;
          entityType: EntityType;
        }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchEntityCapabilityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchEntityCapabilityByIdsQuery = {
  __typename: 'Query';
  entityCapability: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | {
          __typename: 'EntityCapability';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          capabilityId: string;
          entityId: string;
          entityType: EntityType;
        }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ExternalReferenceFieldsFragment = {
  __typename: 'ExternalReference';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  externalKey: string;
  externalSystem: ExternalSystem;
  entityId: string;
  entityType: EntityType;
};

export type FetchExternalReferenceByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchExternalReferenceByIdQuery = {
  __typename: 'Query';
  externalReference: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | {
          __typename: 'ExternalReference';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          externalKey: string;
          externalSystem: ExternalSystem;
          entityId: string;
          entityType: EntityType;
        }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchExternalReferenceByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchExternalReferenceByIdsQuery = {
  __typename: 'Query';
  externalReference: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | {
          __typename: 'ExternalReference';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          externalKey: string;
          externalSystem: ExternalSystem;
          entityId: string;
          entityType: EntityType;
        }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type FboFieldsFragment = {
  __typename: 'Fbo';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  airportId: string;
  fboType: FboType;
  fuelBrand: string | null;
  sourceSystemId: number | null;
  locationId: string | null;
};

export type FetchFboByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchFboByIdQuery = {
  __typename: 'Query';
  fbo: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | {
          __typename: 'Fbo';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          airportId: string;
          fboType: FboType;
          fuelBrand: string | null;
          sourceSystemId: number | null;
          locationId: string | null;
        }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchFboByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchFboByIdsQuery = {
  __typename: 'Query';
  fbo: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | {
          __typename: 'Fbo';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          airportId: string;
          fboType: FboType;
          fuelBrand: string | null;
          sourceSystemId: number | null;
          locationId: string | null;
        }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type FuelTankFieldsFragment = {
  __typename: 'FuelTank';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  code: string;
  name: string;
  locationId: string;
  companyId: string;
  operationsStarted: Date | number | string | null;
  operationsEnded: Date | number | string | null;
  sourceSystemId: number | null;
  baseId: string | null;
  locationName: string | null;
};

export type FetchFuelTankByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchFuelTankByIdQuery = {
  __typename: 'Query';
  fuelTank: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | {
          __typename: 'FuelTank';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          code: string;
          name: string;
          locationId: string;
          companyId: string;
          operationsStarted: Date | number | string | null;
          operationsEnded: Date | number | string | null;
          sourceSystemId: number | null;
          baseId: string | null;
          locationName: string | null;
        }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchFuelTankByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchFuelTankByIdsQuery = {
  __typename: 'Query';
  fuelTank: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | {
          __typename: 'FuelTank';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          code: string;
          name: string;
          locationId: string;
          companyId: string;
          operationsStarted: Date | number | string | null;
          operationsEnded: Date | number | string | null;
          sourceSystemId: number | null;
          baseId: string | null;
          locationName: string | null;
        }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type LocationFieldsFragment = {
  __typename: 'Location';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  locationType: LocationType;
  isPreferred: boolean;
  timezoneCd: string | null;
  isRotorWingLz: boolean | null;
  notes: string | null;
  sourceSystemId: string | null;
  closedDate: Date | number | string | null;
  duplicateOfId: string | null;
  isLandingZoneOutOfService: boolean | null;
  landingZoneOutOfServiceNotes: string | null;
  landingZoneOutOfServiceExpirationDate: Date | number | string | null;
  landingZoneOutOfServiceReasonId: string | null;
  address: {
    __typename: 'Address';
    streetAddress: string | null;
    city: string | null;
    region: string | null;
    postalCode: string | null;
    country: string | null;
    county: string | null;
    gpsId: string | null;
    coordinates: {
      __typename: 'Coordinates';
      latitude: number | null;
      longitude: number | null;
    } | null;
  };
};

export type FetchLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchLocationByIdQuery = {
  __typename: 'Query';
  location: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchLocationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchLocationByIdsQuery = {
  __typename: 'Query';
  location: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | {
          __typename: 'Location';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationType: LocationType;
          isPreferred: boolean;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          notes: string | null;
          sourceSystemId: string | null;
          closedDate: Date | number | string | null;
          duplicateOfId: string | null;
          isLandingZoneOutOfService: boolean | null;
          landingZoneOutOfServiceNotes: string | null;
          landingZoneOutOfServiceExpirationDate: Date | number | string | null;
          landingZoneOutOfServiceReasonId: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MaintenanceFacilityFieldsFragment = {
  __typename: 'MaintenanceFacility';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  locationId: string | null;
};

export type FetchMaintenanceFacilityByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMaintenanceFacilityByIdQuery = {
  __typename: 'Query';
  maintenanceFacility: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | {
          __typename: 'MaintenanceFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationId: string | null;
        }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMaintenanceFacilityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMaintenanceFacilityByIdsQuery = {
  __typename: 'Query';
  maintenanceFacility: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | {
          __typename: 'MaintenanceFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          locationId: string | null;
        }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MedicalFacilityContactFieldsFragment = {
  __typename: 'MedicalFacilityContact';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  medicalFacilityId: string;
  emailAddress: string | null;
  primaryPhoneNumber: string | null;
  secondaryPhoneNumber: string | null;
  smsPhoneNumber: string | null;
  faxPhoneNumber: string | null;
  notes: string | null;
};

export type FetchMedicalFacilityContactByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMedicalFacilityContactByIdQuery = {
  __typename: 'Query';
  medicalFacilityContact: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | {
          __typename: 'MedicalFacilityContact';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          medicalFacilityId: string;
          emailAddress: string | null;
          primaryPhoneNumber: string | null;
          secondaryPhoneNumber: string | null;
          smsPhoneNumber: string | null;
          faxPhoneNumber: string | null;
          notes: string | null;
        }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMedicalFacilityContactByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMedicalFacilityContactByIdsQuery = {
  __typename: 'Query';
  medicalFacilityContact: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | {
          __typename: 'MedicalFacilityContact';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          medicalFacilityId: string;
          emailAddress: string | null;
          primaryPhoneNumber: string | null;
          secondaryPhoneNumber: string | null;
          smsPhoneNumber: string | null;
          faxPhoneNumber: string | null;
          notes: string | null;
        }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MedicalFacilityFieldsFragment = {
  __typename: 'MedicalFacility';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  npi: string;
  providerNumber: string | null;
  sourceSystemId: number | null;
  masterDataSetId: number | null;
  firmType: string | null;
  hospitalType: string | null;
  hospitalSpecialization: string | null;
  website: string | null;
  defaultLandingZoneId: string | null;
  defaultFixedWingLandingZoneId: string | null;
  notes: string | null;
  stateSourceSystemId: string | null;
  nemsisCode: string | null;
  stateFacilityName: string | null;
  status: MedicalFacilityStatus | null;
  archiveNotes: string | null;
  archiveClearedDate: Date | number | string | null;
  locationId: string | null;
  communicationCenterCustomIdentifiers: Array<{
    __typename: 'IdNameListItem';
    id: string;
    name: string;
  } | null> | null;
};

export type FetchMedicalFacilityByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMedicalFacilityByIdQuery = {
  __typename: 'Query';
  medicalFacility: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | {
          __typename: 'MedicalFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          npi: string;
          providerNumber: string | null;
          sourceSystemId: number | null;
          masterDataSetId: number | null;
          firmType: string | null;
          hospitalType: string | null;
          hospitalSpecialization: string | null;
          website: string | null;
          defaultLandingZoneId: string | null;
          defaultFixedWingLandingZoneId: string | null;
          notes: string | null;
          stateSourceSystemId: string | null;
          nemsisCode: string | null;
          stateFacilityName: string | null;
          status: MedicalFacilityStatus | null;
          archiveNotes: string | null;
          archiveClearedDate: Date | number | string | null;
          locationId: string | null;
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
        }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMedicalFacilityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMedicalFacilityByIdsQuery = {
  __typename: 'Query';
  medicalFacility: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | {
          __typename: 'MedicalFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          npi: string;
          providerNumber: string | null;
          sourceSystemId: number | null;
          masterDataSetId: number | null;
          firmType: string | null;
          hospitalType: string | null;
          hospitalSpecialization: string | null;
          website: string | null;
          defaultLandingZoneId: string | null;
          defaultFixedWingLandingZoneId: string | null;
          notes: string | null;
          stateSourceSystemId: string | null;
          nemsisCode: string | null;
          stateFacilityName: string | null;
          status: MedicalFacilityStatus | null;
          archiveNotes: string | null;
          archiveClearedDate: Date | number | string | null;
          locationId: string | null;
          communicationCenterCustomIdentifiers: Array<{
            __typename: 'IdNameListItem';
            id: string;
            name: string;
          } | null> | null;
        }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MedicalFacilityPhysicianFieldsFragment = {
  __typename: 'MedicalFacilityPhysician';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  physicianId: string;
  medicalFacilityId: string;
};

export type FetchMedicalFacilityPhysicianByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMedicalFacilityPhysicianByIdQuery = {
  __typename: 'Query';
  medicalFacilityPhysician: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | {
          __typename: 'MedicalFacilityPhysician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          physicianId: string;
          medicalFacilityId: string;
        }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMedicalFacilityPhysicianByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMedicalFacilityPhysicianByIdsQuery = {
  __typename: 'Query';
  medicalFacilityPhysician: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | {
          __typename: 'MedicalFacilityPhysician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          physicianId: string;
          medicalFacilityId: string;
        }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MedicalFacilityUnitFieldsFragment = {
  __typename: 'MedicalFacilityUnit';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  medicalFacilityId: string;
  phoneNumber: string | null;
};

export type FetchMedicalFacilityUnitByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMedicalFacilityUnitByIdQuery = {
  __typename: 'Query';
  medicalFacilityUnit: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | {
          __typename: 'MedicalFacilityUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          medicalFacilityId: string;
          phoneNumber: string | null;
        }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMedicalFacilityUnitByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMedicalFacilityUnitByIdsQuery = {
  __typename: 'Query';
  medicalFacilityUnit: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | {
          __typename: 'MedicalFacilityUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          medicalFacilityId: string;
          phoneNumber: string | null;
        }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type MedicalUnitFieldsFragment = {
  __typename: 'MedicalUnit';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchMedicalUnitByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchMedicalUnitByIdQuery = {
  __typename: 'Query';
  medicalUnit: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | {
          __typename: 'MedicalUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchMedicalUnitByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchMedicalUnitByIdsQuery = {
  __typename: 'Query';
  medicalUnit: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | {
          __typename: 'MedicalUnit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type OutOfServiceQARReasonFieldsFragment = {
  __typename: 'OutOfServiceQARReason';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchOutOfServiceQARReasonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOutOfServiceQARReasonByIdQuery = {
  __typename: 'Query';
  outOfServiceQARReason: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | {
          __typename: 'OutOfServiceQARReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchOutOfServiceQARReasonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchOutOfServiceQARReasonByIdsQuery = {
  __typename: 'Query';
  outOfServiceQARReason: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | {
          __typename: 'OutOfServiceQARReason';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PersonFieldsFragment = {
  __typename: 'Person';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  employeeType: EmployeeType;
  timeType: TimeType;
  activateOktaAccount: boolean;
  grantTcsAccess: boolean;
  isOutOfFlightCompliance: boolean;
  companyId: string;
  title: string | null;
  employeeId: string | null;
  hireDate: Date | number | string | null;
  terminationDate: Date | number | string | null;
  departmentId: string | null;
  reportsToPersonId: string | null;
  baseId: string | null;
  locationId: string | null;
  programId: string | null;
  activeDirectoryId: string | null;
  notificationAddress: string | null;
  userRoles: Array<UserRole | null> | null;
  allCompaniesAccessible: boolean | null;
  allBasesAccessible: boolean | null;
  allTrmProgramsAccessible: boolean | null;
  allCommunicationCentersAccessible: boolean | null;
  faaCompanyId: string | null;
  dispatchCompanyId: string | null;
  aviationCompanyId: string | null;
  primaryCommunicationCenterId: string | null;
  outOfFlightComplianceComment: string | null;
  dateLastUpdatedFromGMRWorkday: Date | number | string | null;
  appSettings: {
    __typename: 'UserApplicationSettings';
    tcsRealtimeTracking: {
      __typename: 'TcsRealtimeTracking';
      tabId: string | null;
      tabDate: Date | number | string | null;
    };
  } | null;
  additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
};

export type FetchPersonByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPersonByIdQuery = {
  __typename: 'Query';
  person: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPersonByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPersonByIdsQuery = {
  __typename: 'Query';
  person: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type PhysicianFieldsFragment = {
  __typename: 'Physician';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  firstName: string;
  lastName: string;
};

export type FetchPhysicianByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPhysicianByIdQuery = {
  __typename: 'Query';
  physician: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | {
          __typename: 'Physician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
        }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchPhysicianByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchPhysicianByIdsQuery = {
  __typename: 'Query';
  physician: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | {
          __typename: 'Physician';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
        }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ProgramBaseFieldsFragment = {
  __typename: 'ProgramBase';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  baseId: string;
  programId: string;
  companyId: string;
  startTime: Date | number | string | null;
  endTime: Date | number | string | null;
};

export type FetchProgramBaseByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchProgramBaseByIdQuery = {
  __typename: 'Query';
  programBase: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | {
          __typename: 'ProgramBase';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          baseId: string;
          programId: string;
          companyId: string;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchProgramBaseByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchProgramBaseByIdsQuery = {
  __typename: 'Query';
  programBase: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | {
          __typename: 'ProgramBase';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          baseId: string;
          programId: string;
          companyId: string;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ProgramFieldsFragment = {
  __typename: 'Program';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  code: string;
  companyId: string;
  adminId: string | null;
};

export type FetchProgramByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchProgramByIdQuery = {
  __typename: 'Query';
  program: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | {
          __typename: 'Program';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          companyId: string;
          adminId: string | null;
        }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchProgramByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchProgramByIdsQuery = {
  __typename: 'Query';
  program: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | {
          __typename: 'Program';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          companyId: string;
          adminId: string | null;
        }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RamcoVehicleConfigurationFieldsFragment = {
  __typename: 'RamcoVehicleConfiguration';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  maintenanceSystemId: string;
  tailNumber: string;
  modelNumber: string;
  companyCode: string;
};

export type FetchRamcoVehicleConfigurationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRamcoVehicleConfigurationByIdQuery = {
  __typename: 'Query';
  ramcoVehicleConfiguration: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | {
          __typename: 'RamcoVehicleConfiguration';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          maintenanceSystemId: string;
          tailNumber: string;
          modelNumber: string;
          companyCode: string;
        }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRamcoVehicleConfigurationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRamcoVehicleConfigurationByIdsQuery = {
  __typename: 'Query';
  ramcoVehicleConfiguration: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | {
          __typename: 'RamcoVehicleConfiguration';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          maintenanceSystemId: string;
          tailNumber: string;
          modelNumber: string;
          companyCode: string;
        }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RegionBaseFieldsFragment = {
  __typename: 'RegionBase';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  baseId: string;
  regionId: string;
  companyId: string;
};

export type FetchRegionBaseByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRegionBaseByIdQuery = {
  __typename: 'Query';
  regionBase: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | {
          __typename: 'RegionBase';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          baseId: string;
          regionId: string;
          companyId: string;
        }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRegionBaseByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRegionBaseByIdsQuery = {
  __typename: 'Query';
  regionBase: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | {
          __typename: 'RegionBase';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          baseId: string;
          regionId: string;
          companyId: string;
        }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RegionFieldsFragment = {
  __typename: 'Region';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  communicationCenterId: string;
  isTransferCenterRegion: boolean;
  regionGroupId: string;
  companyId: string;
  timezoneCd: string | null;
  emSystemDivisionName: string | null;
  dispatchNumber: string | null;
  fixedWingPreferredThresholdInNauticalMiles: number | null;
  etcInMinutes: number | null;
};

export type FetchRegionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRegionByIdQuery = {
  __typename: 'Query';
  region: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | {
          __typename: 'Region';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          communicationCenterId: string;
          isTransferCenterRegion: boolean;
          regionGroupId: string;
          companyId: string;
          timezoneCd: string | null;
          emSystemDivisionName: string | null;
          dispatchNumber: string | null;
          fixedWingPreferredThresholdInNauticalMiles: number | null;
          etcInMinutes: number | null;
        }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRegionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRegionByIdsQuery = {
  __typename: 'Query';
  region: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | {
          __typename: 'Region';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          communicationCenterId: string;
          isTransferCenterRegion: boolean;
          regionGroupId: string;
          companyId: string;
          timezoneCd: string | null;
          emSystemDivisionName: string | null;
          dispatchNumber: string | null;
          fixedWingPreferredThresholdInNauticalMiles: number | null;
          etcInMinutes: number | null;
        }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type RegionGroupFieldsFragment = {
  __typename: 'RegionGroup';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  departmentId: string;
  companyId: string;
};

export type FetchRegionGroupByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRegionGroupByIdQuery = {
  __typename: 'Query';
  regionGroup: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | {
          __typename: 'RegionGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          departmentId: string;
          companyId: string;
        }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchRegionGroupByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchRegionGroupByIdsQuery = {
  __typename: 'Query';
  regionGroup: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | {
          __typename: 'RegionGroup';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          departmentId: string;
          companyId: string;
        }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type ReleaseNoteFieldsFragment = {
  __typename: 'ReleaseNote';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  releaseNumber: string;
  description: string;
  releaseDate: Date | number | string | null;
};

export type FetchReleaseNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchReleaseNoteByIdQuery = {
  __typename: 'Query';
  releaseNote: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | {
          __typename: 'ReleaseNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          releaseNumber: string;
          description: string;
          releaseDate: Date | number | string | null;
        }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchReleaseNoteByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchReleaseNoteByIdsQuery = {
  __typename: 'Query';
  releaseNote: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | {
          __typename: 'ReleaseNote';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          releaseNumber: string;
          description: string;
          releaseDate: Date | number | string | null;
        }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type SpecialtyTeamFieldsFragment = {
  __typename: 'SpecialtyTeam';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  affiliationId: string;
  companyId: string;
};

export type FetchSpecialtyTeamByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchSpecialtyTeamByIdQuery = {
  __typename: 'Query';
  specialtyTeam: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | {
          __typename: 'SpecialtyTeam';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          affiliationId: string;
          companyId: string;
        }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchSpecialtyTeamByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchSpecialtyTeamByIdsQuery = {
  __typename: 'Query';
  specialtyTeam: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | {
          __typename: 'SpecialtyTeam';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          affiliationId: string;
          companyId: string;
        }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type SpecialtyTeamMemberFieldsFragment = {
  __typename: 'SpecialtyTeamMember';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  specialtyTeamId: string;
  teamMemberId: string;
  companyId: string;
  weightInKg: number | null;
};

export type FetchSpecialtyTeamMemberByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchSpecialtyTeamMemberByIdQuery = {
  __typename: 'Query';
  specialtyTeamMember: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | {
          __typename: 'SpecialtyTeamMember';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          specialtyTeamId: string;
          teamMemberId: string;
          companyId: string;
          weightInKg: number | null;
        }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchSpecialtyTeamMemberByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchSpecialtyTeamMemberByIdsQuery = {
  __typename: 'Query';
  specialtyTeamMember: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | {
          __typename: 'SpecialtyTeamMember';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          specialtyTeamId: string;
          teamMemberId: string;
          companyId: string;
          weightInKg: number | null;
        }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type StateFieldsFragment = {
  __typename: 'State';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  code: string;
  isLicenseRequiredToFly: boolean | null;
};

export type FetchStateByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchStateByIdQuery = {
  __typename: 'Query';
  state: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | {
          __typename: 'State';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
          isLicenseRequiredToFly: boolean | null;
        }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchStateByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchStateByIdsQuery = {
  __typename: 'Query';
  state: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | {
          __typename: 'State';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          code: string;
          isLicenseRequiredToFly: boolean | null;
        }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type SupportRequestFieldsFragment = {
  __typename: 'SupportRequest';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  supportRequestType: SupportRequestType;
  isEmailSent: boolean;
  supportRequestStatus: SupportRequestStatus;
  personId: string;
  companyId: string;
  subject: string | null;
  content: string | null;
  notes: string | null;
};

export type FetchSupportRequestByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchSupportRequestByIdQuery = {
  __typename: 'Query';
  supportRequest: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | {
          __typename: 'SupportRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          supportRequestType: SupportRequestType;
          isEmailSent: boolean;
          supportRequestStatus: SupportRequestStatus;
          personId: string;
          companyId: string;
          subject: string | null;
          content: string | null;
          notes: string | null;
        }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchSupportRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchSupportRequestByIdsQuery = {
  __typename: 'Query';
  supportRequest: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | {
          __typename: 'SupportRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          supportRequestType: SupportRequestType;
          isEmailSent: boolean;
          supportRequestStatus: SupportRequestStatus;
          personId: string;
          companyId: string;
          subject: string | null;
          content: string | null;
          notes: string | null;
        }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TimezoneFieldsFragment = {
  __typename: 'Timezone';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  abbreviation: string;
  code: string;
  isDst: boolean;
  utcOffset: number;
};

export type FetchTimezoneByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTimezoneByIdQuery = {
  __typename: 'Query';
  timezone: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | {
          __typename: 'Timezone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          isDst: boolean;
          utcOffset: number;
        }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTimezoneByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTimezoneByIdsQuery = {
  __typename: 'Query';
  timezone: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | {
          __typename: 'Timezone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          code: string;
          isDst: boolean;
          utcOffset: number;
        }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TransferCenterFieldsFragment = {
  __typename: 'TransferCenter';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  communicationCenterId: string;
  companyId: string;
  description: string | null;
};

export type FetchTransferCenterByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransferCenterByIdQuery = {
  __typename: 'Query';
  transferCenter: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | {
          __typename: 'TransferCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          communicationCenterId: string;
          companyId: string;
          description: string | null;
        }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTransferCenterByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTransferCenterByIdsQuery = {
  __typename: 'Query';
  transferCenter: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | {
          __typename: 'TransferCenter';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          communicationCenterId: string;
          companyId: string;
          description: string | null;
        }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TrmUserAgencyFieldsFragment = {
  __typename: 'TrmUserAgency';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  trmUserId: string;
  agencyId: string;
  companyId: string;
};

export type FetchTrmUserAgencyByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTrmUserAgencyByIdQuery = {
  __typename: 'Query';
  trmUserAgency: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | {
          __typename: 'TrmUserAgency';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          trmUserId: string;
          agencyId: string;
          companyId: string;
        }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTrmUserAgencyByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTrmUserAgencyByIdsQuery = {
  __typename: 'Query';
  trmUserAgency: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | {
          __typename: 'TrmUserAgency';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          trmUserId: string;
          agencyId: string;
          companyId: string;
        }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TrmUserFieldsFragment = {
  __typename: 'TrmUser';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  userStatus: TrmUserStatus;
  companyId: string;
  personId: string | null;
};

export type FetchTrmUserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTrmUserByIdQuery = {
  __typename: 'Query';
  trmUser: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | {
          __typename: 'TrmUser';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          emailAddress: string;
          firstName: string;
          lastName: string;
          phoneNumber: string;
          userStatus: TrmUserStatus;
          companyId: string;
          personId: string | null;
        }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTrmUserByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTrmUserByIdsQuery = {
  __typename: 'Query';
  trmUser: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | {
          __typename: 'TrmUser';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          emailAddress: string;
          firstName: string;
          lastName: string;
          phoneNumber: string;
          userStatus: TrmUserStatus;
          companyId: string;
          personId: string | null;
        }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TrmUserMedicalFacilityFieldsFragment = {
  __typename: 'TrmUserMedicalFacility';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  trmUserId: string;
  medicalFacilityId: string;
  companyId: string;
};

export type FetchTrmUserMedicalFacilityByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTrmUserMedicalFacilityByIdQuery = {
  __typename: 'Query';
  trmUserMedicalFacility: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | {
          __typename: 'TrmUserMedicalFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          trmUserId: string;
          medicalFacilityId: string;
          companyId: string;
        }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTrmUserMedicalFacilityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTrmUserMedicalFacilityByIdsQuery = {
  __typename: 'Query';
  trmUserMedicalFacility: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | {
          __typename: 'TrmUserMedicalFacility';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          trmUserId: string;
          medicalFacilityId: string;
          companyId: string;
        }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type TrmUserProgramFieldsFragment = {
  __typename: 'TrmUserProgram';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  trmUserId: string;
  programId: string;
  isPreferred: boolean;
  companyId: string;
};

export type FetchTrmUserProgramByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTrmUserProgramByIdQuery = {
  __typename: 'Query';
  trmUserProgram: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | {
          __typename: 'TrmUserProgram';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          trmUserId: string;
          programId: string;
          isPreferred: boolean;
          companyId: string;
        }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchTrmUserProgramByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchTrmUserProgramByIdsQuery = {
  __typename: 'Query';
  trmUserProgram: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | {
          __typename: 'TrmUserProgram';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          trmUserId: string;
          programId: string;
          isPreferred: boolean;
          companyId: string;
        }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleConfigurationClassFieldsFragment = {
  __typename: 'VehicleConfigurationClass';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  legacyName: string;
  engineCount: number;
  maintenanceSystemId: string;
};

export type FetchVehicleConfigurationClassByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleConfigurationClassByIdQuery = {
  __typename: 'Query';
  vehicleConfigurationClass: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | {
          __typename: 'VehicleConfigurationClass';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          legacyName: string;
          engineCount: number;
          maintenanceSystemId: string;
        }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleConfigurationClassByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleConfigurationClassByIdsQuery = {
  __typename: 'Query';
  vehicleConfigurationClass: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | {
          __typename: 'VehicleConfigurationClass';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          legacyName: string;
          engineCount: number;
          maintenanceSystemId: string;
        }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleControlZoneFieldsFragment = {
  __typename: 'VehicleControlZone';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  companyId: string;
  controlZoneId: string | null;
  vehicleId: string | null;
};

export type FetchVehicleControlZoneByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleControlZoneByIdQuery = {
  __typename: 'Query';
  vehicleControlZone: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | {
          __typename: 'VehicleControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          controlZoneId: string | null;
          vehicleId: string | null;
        }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleControlZoneByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleControlZoneByIdsQuery = {
  __typename: 'Query';
  vehicleControlZone: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | {
          __typename: 'VehicleControlZone';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          controlZoneId: string | null;
          vehicleId: string | null;
        }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleFieldsFragment = {
  __typename: 'Vehicle';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  type: VehicleType;
  registrationNumber: string;
  isUnderLease: boolean;
  role: VehicleRole;
  flightLogProcess: FlightLogProcess;
  isPlaceholder: boolean;
  stateInspectionRequired: boolean;
  isRetired: boolean;
  isPositionTrackingEnabled: boolean;
  hideFromOOSRUM: boolean;
  companyId: string;
  serialNumber: string | null;
  dispatchCompanyId: string | null;
  year: number | null;
  dateAcquired: Date | number | string | null;
  makeId: string | null;
  modelId: string | null;
  cruiseSpeed: number | null;
  configurationClassId: string | null;
  isThirdPartyVehicle: boolean | null;
  parentUnitId: string | null;
  isHidden: boolean | null;
  faaCompanyId: string | null;
  skytracIMEI: string | null;
  phoneNumber: string | null;
  completeFlightId: string | null;
  controlZoneId: string | null;
  communicationCenterId: string | null;
  regionId: string | null;
  vehicleDescription: string | null;
};

export type FetchVehicleByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleByIdQuery = {
  __typename: 'Query';
  vehicle: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | {
          __typename: 'Vehicle';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          isUnderLease: boolean;
          role: VehicleRole;
          flightLogProcess: FlightLogProcess;
          isPlaceholder: boolean;
          stateInspectionRequired: boolean;
          isRetired: boolean;
          isPositionTrackingEnabled: boolean;
          hideFromOOSRUM: boolean;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          year: number | null;
          dateAcquired: Date | number | string | null;
          makeId: string | null;
          modelId: string | null;
          cruiseSpeed: number | null;
          configurationClassId: string | null;
          isThirdPartyVehicle: boolean | null;
          parentUnitId: string | null;
          isHidden: boolean | null;
          faaCompanyId: string | null;
          skytracIMEI: string | null;
          phoneNumber: string | null;
          completeFlightId: string | null;
          controlZoneId: string | null;
          communicationCenterId: string | null;
          regionId: string | null;
          vehicleDescription: string | null;
        }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleByIdsQuery = {
  __typename: 'Query';
  vehicle: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | {
          __typename: 'Vehicle';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          isUnderLease: boolean;
          role: VehicleRole;
          flightLogProcess: FlightLogProcess;
          isPlaceholder: boolean;
          stateInspectionRequired: boolean;
          isRetired: boolean;
          isPositionTrackingEnabled: boolean;
          hideFromOOSRUM: boolean;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          year: number | null;
          dateAcquired: Date | number | string | null;
          makeId: string | null;
          modelId: string | null;
          cruiseSpeed: number | null;
          configurationClassId: string | null;
          isThirdPartyVehicle: boolean | null;
          parentUnitId: string | null;
          isHidden: boolean | null;
          faaCompanyId: string | null;
          skytracIMEI: string | null;
          phoneNumber: string | null;
          completeFlightId: string | null;
          controlZoneId: string | null;
          communicationCenterId: string | null;
          regionId: string | null;
          vehicleDescription: string | null;
        }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleMaintenanceFieldsFragment = {
  __typename: 'VehicleMaintenance';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  companyId: string;
  notes: string | null;
  isReleasedFromOCF: boolean | null;
  vehicleId: string | null;
  deferralDueDates: Array<{
    __typename: 'DeferralDueDate';
    id: string;
    dueDate: Date | number | string;
    triggerValue: number | null;
    notes: string | null;
  }>;
  nextDues: Array<{
    __typename: 'NextDue';
    id: string;
    typeId: string;
    cycleType: NextDueCycleType;
    value: string;
    triggerValue: number;
    notes: string | null;
    inTolerance: boolean | null;
  }>;
  maintenanceParams: {
    __typename: 'MaintenanceParameters';
    endingHobbs: number | null;
    airframeTime: number | null;
    totalLandings: number | null;
    engine1: { __typename: 'EngineParameters'; time: number | null; starts: number | null } | null;
    engine2: { __typename: 'EngineParameters'; time: number | null; starts: number | null } | null;
  } | null;
};

export type FetchVehicleMaintenanceByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleMaintenanceByIdQuery = {
  __typename: 'Query';
  vehicleMaintenance: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | {
          __typename: 'VehicleMaintenance';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          notes: string | null;
          isReleasedFromOCF: boolean | null;
          vehicleId: string | null;
          deferralDueDates: Array<{
            __typename: 'DeferralDueDate';
            id: string;
            dueDate: Date | number | string;
            triggerValue: number | null;
            notes: string | null;
          }>;
          nextDues: Array<{
            __typename: 'NextDue';
            id: string;
            typeId: string;
            cycleType: NextDueCycleType;
            value: string;
            triggerValue: number;
            notes: string | null;
            inTolerance: boolean | null;
          }>;
          maintenanceParams: {
            __typename: 'MaintenanceParameters';
            endingHobbs: number | null;
            airframeTime: number | null;
            totalLandings: number | null;
            engine1: {
              __typename: 'EngineParameters';
              time: number | null;
              starts: number | null;
            } | null;
            engine2: {
              __typename: 'EngineParameters';
              time: number | null;
              starts: number | null;
            } | null;
          } | null;
        }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleMaintenanceByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleMaintenanceByIdsQuery = {
  __typename: 'Query';
  vehicleMaintenance: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | {
          __typename: 'VehicleMaintenance';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          notes: string | null;
          isReleasedFromOCF: boolean | null;
          vehicleId: string | null;
          deferralDueDates: Array<{
            __typename: 'DeferralDueDate';
            id: string;
            dueDate: Date | number | string;
            triggerValue: number | null;
            notes: string | null;
          }>;
          nextDues: Array<{
            __typename: 'NextDue';
            id: string;
            typeId: string;
            cycleType: NextDueCycleType;
            value: string;
            triggerValue: number;
            notes: string | null;
            inTolerance: boolean | null;
          }>;
          maintenanceParams: {
            __typename: 'MaintenanceParameters';
            endingHobbs: number | null;
            airframeTime: number | null;
            totalLandings: number | null;
            engine1: {
              __typename: 'EngineParameters';
              time: number | null;
              starts: number | null;
            } | null;
            engine2: {
              __typename: 'EngineParameters';
              time: number | null;
              starts: number | null;
            } | null;
          } | null;
        }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleMakeFieldsFragment = {
  __typename: 'VehicleMake';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
};

export type FetchVehicleMakeByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleMakeByIdQuery = {
  __typename: 'Query';
  vehicleMake: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | {
          __typename: 'VehicleMake';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleMakeByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleMakeByIdsQuery = {
  __typename: 'Query';
  vehicleMake: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | {
          __typename: 'VehicleMake';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
        }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleModelFieldsFragment = {
  __typename: 'VehicleModel';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  name: string;
  cruiseSpeedInMph: number | null;
};

export type FetchVehicleModelByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleModelByIdQuery = {
  __typename: 'Query';
  vehicleModel: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | {
          __typename: 'VehicleModel';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cruiseSpeedInMph: number | null;
        }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleModelByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleModelByIdsQuery = {
  __typename: 'Query';
  vehicleModel: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | {
          __typename: 'VehicleModel';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          cruiseSpeedInMph: number | null;
        }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | { __typename: 'VehicleStateInspection' }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type VehicleStateInspectionFieldsFragment = {
  __typename: 'VehicleStateInspection';
  dateLastUpdated: Date | number | string;
  dateCreated: Date | number | string;
  dateDeleted: Date | number | string | null;
  lastUpdatedById: string | null;
  id: string;
  stateAbbrevation: string;
  inspectionDate: Date | number | string;
  vehicleId: string;
  companyId: string;
};

export type FetchVehicleStateInspectionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchVehicleStateInspectionByIdQuery = {
  __typename: 'Query';
  vehicleStateInspection: {
    __typename: 'EntityQueries';
    byId:
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | {
          __typename: 'VehicleStateInspection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          inspectionDate: Date | number | string;
          vehicleId: string;
          companyId: string;
        }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
      | null;
  };
};

export type FetchVehicleStateInspectionByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchVehicleStateInspectionByIdsQuery = {
  __typename: 'Query';
  vehicleStateInspection: {
    __typename: 'EntityQueries';
    byIds: Array<
      | { __typename: 'AccessibleItem' }
      | { __typename: 'ActivationRule' }
      | { __typename: 'ActiveAlert' }
      | { __typename: 'ActiveAlertAcknowledgement' }
      | { __typename: 'ActiveCardUnitOffering' }
      | { __typename: 'ActiveTimeline' }
      | { __typename: 'Agency' }
      | { __typename: 'AgencyLocation' }
      | { __typename: 'Airport' }
      | { __typename: 'Alert' }
      | { __typename: 'ApplicationNotification' }
      | { __typename: 'ArchiveLog' }
      | { __typename: 'AssignmentDelayedReason' }
      | { __typename: 'Attachment' }
      | { __typename: 'AuditLog' }
      | { __typename: 'Base' }
      | { __typename: 'BaseControlZone' }
      | { __typename: 'BaseMedicalControlContact' }
      | { __typename: 'BaseMedicalControlContactState' }
      | { __typename: 'CancellationCategory' }
      | { __typename: 'CancellationReason' }
      | { __typename: 'CancellationSecondaryReason' }
      | { __typename: 'Capability' }
      | { __typename: 'Card' }
      | { __typename: 'CardLink' }
      | { __typename: 'CardNote' }
      | { __typename: 'CardNoteArchive' }
      | { __typename: 'CardReOpenReason' }
      | { __typename: 'CardSummary' }
      | { __typename: 'CommunicationCenter' }
      | { __typename: 'CommunicationCenterTransportOfferOption' }
      | { __typename: 'Company' }
      | { __typename: 'CompleteFlightInstance' }
      | { __typename: 'ConfigurationSetting' }
      | { __typename: 'ControlZone' }
      | { __typename: 'Conversation' }
      | { __typename: 'ConversationParticipant' }
      | { __typename: 'DeclineCategory' }
      | { __typename: 'DeclineReason' }
      | { __typename: 'DeclineSecondaryReason' }
      | { __typename: 'Department' }
      | { __typename: 'DiversionReason' }
      | { __typename: 'EntityCapability' }
      | { __typename: 'EscortRequest' }
      | { __typename: 'EstimatedDuration' }
      | { __typename: 'Eta' }
      | { __typename: 'ExternalAction' }
      | { __typename: 'ExternalActionType' }
      | { __typename: 'ExternalReference' }
      | { __typename: 'ExternalSystemUnit' }
      | { __typename: 'FacilityNonAcceptanceReason' }
      | { __typename: 'Fbo' }
      | { __typename: 'FirewallRule' }
      | { __typename: 'FlightFollowingReport' }
      | { __typename: 'FuelTank' }
      | { __typename: 'LandingZoneOutOfServiceReason' }
      | { __typename: 'Location' }
      | { __typename: 'LocationHazard' }
      | { __typename: 'LocationHazardAttachment' }
      | { __typename: 'MaintenanceFacility' }
      | { __typename: 'ManifestEntry' }
      | { __typename: 'MedicalControlContactLogEntry' }
      | { __typename: 'MedicalFacility' }
      | { __typename: 'MedicalFacilityContact' }
      | { __typename: 'MedicalFacilityPhysician' }
      | { __typename: 'MedicalFacilityUnit' }
      | { __typename: 'MedicalUnit' }
      | { __typename: 'MessageStatusUpdate' }
      | { __typename: 'NewAgencyLocationRequest' }
      | { __typename: 'NextDueType' }
      | { __typename: 'NonReferralReason' }
      | { __typename: 'Notification' }
      | { __typename: 'NotificationGroup' }
      | { __typename: 'NotificationGroupMember' }
      | { __typename: 'NotificationRecipient' }
      | { __typename: 'NotificationSubscription' }
      | { __typename: 'NotificationTemplate' }
      | { __typename: 'OemActivity' }
      | { __typename: 'OemAsset' }
      | { __typename: 'OemPlan' }
      | { __typename: 'OemPlanChangeRequest' }
      | { __typename: 'OfferAlgorithm' }
      | { __typename: 'Operation' }
      | { __typename: 'OutOfServiceEvent' }
      | { __typename: 'OutOfServiceEventNote' }
      | { __typename: 'OutOfServiceQARReason' }
      | { __typename: 'OutOfServiceReason' }
      | { __typename: 'OutOfServiceSecondaryReason' }
      | { __typename: 'OutOfServiceTicket' }
      | { __typename: 'PaipEvent' }
      | { __typename: 'PaipReason' }
      | { __typename: 'PassdownLog' }
      | { __typename: 'PassdownLogAcknowledgement' }
      | { __typename: 'PassdownLogArchivedLog' }
      | { __typename: 'Patient' }
      | { __typename: 'Person' }
      | { __typename: 'Physician' }
      | { __typename: 'PositionReport' }
      | { __typename: 'PositionReportAlert' }
      | { __typename: 'PositionReportArchive' }
      | { __typename: 'Program' }
      | { __typename: 'ProgramBase' }
      | { __typename: 'Question' }
      | { __typename: 'QuestionChoice' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireQuestionResponse' }
      | { __typename: 'QuestionnaireQuestionResponseNote' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'QuestionnaireSection' }
      | { __typename: 'QuestionnaireSectionQuestion' }
      | { __typename: 'RamcoVehicleConfiguration' }
      | { __typename: 'ReceivingFacilityRequest' }
      | { __typename: 'Region' }
      | { __typename: 'RegionBase' }
      | { __typename: 'RegionGroup' }
      | { __typename: 'ReleaseNote' }
      | { __typename: 'RendezvousRequest' }
      | { __typename: 'Request' }
      | { __typename: 'RequestLocation' }
      | { __typename: 'RequestPatient' }
      | { __typename: 'Requester' }
      | { __typename: 'RequesterReferralReason' }
      | { __typename: 'RequesterRole' }
      | { __typename: 'SpecialtyTeam' }
      | { __typename: 'SpecialtyTeamMember' }
      | { __typename: 'State' }
      | { __typename: 'SupportRequest' }
      | { __typename: 'SystemTimer' }
      | { __typename: 'Timeline' }
      | { __typename: 'TimelineItem' }
      | { __typename: 'Timestamp' }
      | { __typename: 'TimestampType' }
      | { __typename: 'Timezone' }
      | { __typename: 'TrackedMessage' }
      | { __typename: 'TransferCenter' }
      | { __typename: 'TransferReason' }
      | { __typename: 'TransportOffer' }
      | { __typename: 'TransportOfferOption' }
      | { __typename: 'TransportReason' }
      | { __typename: 'Trip' }
      | { __typename: 'TripLeg' }
      | { __typename: 'TripPassenger' }
      | { __typename: 'TrmUser' }
      | { __typename: 'TrmUserAgency' }
      | { __typename: 'TrmUserMedicalFacility' }
      | { __typename: 'TrmUserProgram' }
      | { __typename: 'Unit' }
      | { __typename: 'UnitActivationRule' }
      | { __typename: 'UnitEMSystemMapping' }
      | { __typename: 'UnitNote' }
      | { __typename: 'UnitPosition' }
      | { __typename: 'UnitShift' }
      | { __typename: 'UnitStatusHistoryEntry' }
      | { __typename: 'UnitSummary' }
      | { __typename: 'Vehicle' }
      | { __typename: 'VehicleConfigurationClass' }
      | { __typename: 'VehicleControlZone' }
      | { __typename: 'VehicleDisposition' }
      | { __typename: 'VehicleMaintenance' }
      | { __typename: 'VehicleMake' }
      | { __typename: 'VehicleModel' }
      | { __typename: 'VehicleNotificationGroup' }
      | { __typename: 'VehiclePositionSummary' }
      | {
          __typename: 'VehicleStateInspection';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          stateAbbrevation: string;
          inspectionDate: Date | number | string;
          vehicleId: string;
          companyId: string;
        }
      | { __typename: 'VehicleSummary' }
      | { __typename: 'Waypoint' }
      | { __typename: 'WebOrderLog' }
    >;
  };
};

export type InsightsCardActivityQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;

export type InsightsCardActivityQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byId: {
      __typename: 'Person';
      accessibleItems: Array<{
        __typename: 'AccessibleItem';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: EntityType;
        entityId: string;
        personId: string;
        userRoles: Array<UserRole | null> | null;
      }>;
    } | null;
  };
};

export type GetAllNotificationsQueryVariables = Exact<{
  filter: InputMaybe<NotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type GetAllNotificationsQuery = {
  __typename: 'Query';
  notifications: {
    __typename: 'NotificationQueries';
    all: {
      __typename: 'NotificationCollection';
      items: Array<{
        __typename: 'Notification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: NotificationStatus;
        body: string;
        companyId: string;
        cardId: string | null;
        subject: string | null;
        sourceTemplateId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        createdById: string | null;
      }>;
      meta: { __typename: 'NotificationCollectionMetadata'; total: number };
    };
  };
};

export type GetRamcoVehicleConfigurationByTailNumberQueryVariables = Exact<{
  tailNumber: Scalars['String'];
}>;

export type GetRamcoVehicleConfigurationByTailNumberQuery = {
  __typename: 'Query';
  ramcoVehicleConfigurations: {
    __typename: 'RamcoVehicleConfigurationQueries';
    byTailNumber: {
      __typename: 'RamcoVehicleConfiguration';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      maintenanceSystemId: string;
      tailNumber: string;
      modelNumber: string;
      companyCode: string;
    } | null;
  };
};

export type GetRamcoVehicleConfigurationByVehicleIdQueryVariables = Exact<{
  vehicleId: Scalars['ID'];
}>;

export type GetRamcoVehicleConfigurationByVehicleIdQuery = {
  __typename: 'Query';
  vehicles: {
    __typename: 'VehicleQueries';
    byId: {
      __typename: 'Vehicle';
      ramco: {
        __typename: 'RamcoVehicleConfiguration';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        maintenanceSystemId: string;
        tailNumber: string;
        modelNumber: string;
        companyCode: string;
      } | null;
    } | null;
  };
};

export type GetUnitNotesByUnitQueryVariables = Exact<{
  unitId: Scalars['ID'];
}>;

export type GetUnitNotesByUnitQuery = {
  __typename: 'Query';
  units: {
    __typename: 'UnitQueries';
    byId: {
      __typename: 'Unit';
      notes: Array<{
        __typename: 'UnitNote';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        content: string;
        noteTime: Date | number | string;
        unitId: string;
        companyId: string;
        authorId: string | null;
        noteCategory: string | null;
        noteMetadataJson: string | null;
        author: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
      }>;
    } | null;
  };
};

export type UserContextResolverQueryVariables = Exact<{
  baseFilter: InputMaybe<BaseFilter>;
  programFilter: InputMaybe<ProgramFilter>;
}>;

export type UserContextResolverQuery = {
  __typename: 'Query';
  bases: {
    __typename: 'BaseQueries';
    all: {
      __typename: 'BaseCollection';
      items: Array<{
        __typename: 'Base';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        locationId: string;
        businessModel: BusinessModel;
        companyId: string;
        plannedOperationsStart: Date | number | string | null;
        operationsStarted: Date | number | string | null;
        operationsTerminated: Date | number | string | null;
        dateOfMaturity: Date | number | string | null;
        primaryPhoneNumber: string | null;
        estimatedLiftoffTime: number | null;
        licenseNumber: string | null;
        enableFlightLogDutyLog: boolean | null;
        dispatchBaseId: string | null;
        reportBaseId: string | null;
        aviationCompanyId: string | null;
        workdayBaseId: string | null;
        gmrWorkdayLocationId: string | null;
        dateLastUpdatedFromGMRWorkday: Date | number | string | null;
        pilotPhoneNumber: string | null;
        crewPhoneNumber1: string | null;
        crewPhoneNumber2: string | null;
        brandName: string | null;
        medicalFacilityId: string | null;
        hoursOfOperation: {
          __typename: 'HoursOfOperation';
          is24Hours: boolean | null;
          startTime: Date | number | string | null;
          endTime: Date | number | string | null;
        };
        communicationCenterCustomIdentifiers: Array<{
          __typename: 'IdNameListItem';
          id: string;
          name: string;
        } | null> | null;
        additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
    };
  };
  programs: {
    __typename: 'ProgramQueries';
    all: {
      __typename: 'ProgramCollection';
      items: Array<{
        __typename: 'Program';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        code: string;
        companyId: string;
        adminId: string | null;
      }>;
    };
  };
};

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type GetUserByEmailQuery = {
  __typename: 'Query';
  people: {
    __typename: 'PersonQueries';
    byEmail: {
      __typename: 'Person';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      employeeType: EmployeeType;
      timeType: TimeType;
      activateOktaAccount: boolean;
      grantTcsAccess: boolean;
      isOutOfFlightCompliance: boolean;
      companyId: string;
      title: string | null;
      employeeId: string | null;
      hireDate: Date | number | string | null;
      terminationDate: Date | number | string | null;
      departmentId: string | null;
      reportsToPersonId: string | null;
      baseId: string | null;
      locationId: string | null;
      programId: string | null;
      activeDirectoryId: string | null;
      notificationAddress: string | null;
      userRoles: Array<UserRole | null> | null;
      allCompaniesAccessible: boolean | null;
      allBasesAccessible: boolean | null;
      allTrmProgramsAccessible: boolean | null;
      allCommunicationCentersAccessible: boolean | null;
      faaCompanyId: string | null;
      dispatchCompanyId: string | null;
      aviationCompanyId: string | null;
      primaryCommunicationCenterId: string | null;
      outOfFlightComplianceComment: string | null;
      dateLastUpdatedFromGMRWorkday: Date | number | string | null;
      company: {
        __typename: 'Company';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        abbreviation: string;
        companyCode: string;
        includeCompetitors: boolean;
        hasPrivateUnits: boolean;
        isOemCompany: boolean;
        gpsFeedResetsPositionReportTime: boolean;
        unitRemainsInServiceWithNoVehicle: boolean;
        enableNotificationGroupTypes: boolean;
        restrictRiskAnalysisAcknowledgementToOCCRole: boolean;
        imageUri: string | null;
        gLCode: string | null;
        callNumberPrefix: string | null;
        timezoneCd: string | null;
        flightFollowingFields: Array<FlightFollowingField | null> | null;
        requireSkipReasonsForNonCompanyTransportOffers: boolean | null;
        crewPatientInfoPageNotificationTemplateId: string | null;
        transportCheckTimerDurationInMinutes: number | null;
      };
      appSettings: {
        __typename: 'UserApplicationSettings';
        tcsRealtimeTracking: {
          __typename: 'TcsRealtimeTracking';
          tabId: string | null;
          tabDate: Date | number | string | null;
        };
      } | null;
      additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
    } | null;
  };
};

export type GetVehicleConfigurationClassesQueryVariables = Exact<{
  filter: InputMaybe<VehicleConfigurationClassFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type GetVehicleConfigurationClassesQuery = {
  __typename: 'Query';
  vehicleConfigurationClasses: {
    __typename: 'VehicleConfigurationClassQueries';
    all: {
      __typename: 'VehicleConfigurationClassCollection';
      items: Array<{
        __typename: 'VehicleConfigurationClass';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        legacyName: string;
        engineCount: number;
        maintenanceSystemId: string;
      }>;
      meta: { __typename: 'VehicleConfigurationClassCollectionMetadata'; total: number };
    };
  };
};

export type GetVehicleModelsQueryVariables = Exact<{
  filter: InputMaybe<VehicleModelFilter>;
  first: InputMaybe<Scalars['Int']>;
  skip: InputMaybe<Scalars['Int']>;
}>;

export type GetVehicleModelsQuery = {
  __typename: 'Query';
  vehicleModels: {
    __typename: 'VehicleModelQueries';
    all: {
      __typename: 'VehicleModelCollection';
      items: Array<{
        __typename: 'VehicleModel';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        cruiseSpeedInMph: number | null;
      }>;
      meta: { __typename: 'VehicleModelCollectionMetadata'; total: number };
    };
  };
};

export type FetchCardByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type FetchCardByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
    } | null;
  };
};

export type FetchCardEntitiesQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type FetchCardEntitiesQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byCardNumber: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
      activeAlerts: Array<{
        __typename: 'ActiveAlert';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        urgency: AlertUrgency;
        content: string;
        lifecycleStage: AlertLifecycleStage;
        requiresAcknowledgement: boolean;
        matchType: RuleMatchType;
        visibilityType: VisibilityType;
        isGpsAlert: boolean;
        isActive: boolean;
        isAudible: boolean;
        isAcknowledgementRepeatable: boolean;
        companyId: string;
        target: AlertTarget | null;
        targetId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        title: string | null;
        definitionId: string | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        parentEntityType: EntityType | null;
        parentEntityId: string | null;
        activationTime: Date | number | string | null;
        escalationDurationInSeconds: number | null;
        snoozeMaxInSeconds: number | null;
        authorId: string | null;
        regionId: string | null;
        communicationCenterId: string | null;
        lookupHash: string | null;
        referenceEntityType: EntityType | null;
        referenceEntityId: string | null;
      }>;
      request: {
        __typename: 'Request';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: RequestStatus;
        requestedOperationType: OperationType;
        isStandbyRequest: boolean;
        standbyActivationRequested: boolean;
        missionConfiguration: MissionConfiguration;
        missionProfile: MissionProfile;
        companyId: string;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
        cancellationReasonNotes: string | null;
        requestedVehicleType: VehicleType | null;
        primaryUnitServiceAreaId: string | null;
        commitUnitToStandby: boolean | null;
        initiationType: RequestInitiationType | null;
        assignmentDelayedTime: Date | number | string | null;
        assignmentDelayedReasonId: string | null;
        regionId: string | null;
        includeCompetitors: boolean | null;
        transportOfferAlgorithmId: string | null;
        transportOfferAlgorithm: TransportOfferAlgorithm | null;
        minimumFlightRule: FlightRule | null;
        transportTrackingLink: string | null;
        latestWeatherDeclineUnitId: string | null;
        latestWeatherDeclineTime: Date | number | string | null;
        latestWeatherDeclineReasonId: string | null;
        latestWeatherDeclineSecondaryReasonId: string | null;
        webOrderCallType: WebOrderCallType | null;
        etloInMinutes: number | null;
        atloInMinutes: number | null;
        transportOfferOptions: Array<{
          __typename: 'TransportOfferOption';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          includeAbortedUnit: boolean;
          type: TransportOfferOptionType;
          requestId: string;
          companyId: string;
          requestedVehicleType: VehicleType | null;
          transportOfferAlgorithm: TransportOfferAlgorithm | null;
          minimumFlightRule: FlightRule | null;
          includeCompetitors: boolean | null;
          requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
        }>;
        requester: {
          __typename: 'Requester';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          companyId: string;
          affiliationType: AffiliationType | null;
          caller: string | null;
          roleId: string | null;
          missionRole: MissionRoleType | null;
          callbackNumber: string | null;
          email: string | null;
          facilityId: string | null;
          agencyLocationId: string | null;
          isNewAgencyLocation: boolean | null;
          agencyLocationName: string | null;
          referringCompanyId: string | null;
          referringAgencyLocationId: string | null;
          referralReasonId: string | null;
          referringRecordNumber: string | null;
          specialtyTeamNotes: string | null;
          specialtyTeamId: string | null;
          careLevelRequested: CareLevel | null;
          transferCenterId: string | null;
          transferCenterNotes: string | null;
          transportingAgencyLocationId: string | null;
          isDoublePatient: boolean | null;
          isWingToWing: boolean | null;
          vetNumber: string | null;
          requestId: string | null;
          specialtyTeamMembers: Array<{ __typename: 'IdListItem'; id: string }>;
        } | null;
        locations: Array<{
          __typename: 'RequestLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          requestId: string;
          companyId: string;
          locationId: string | null;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          medicalFacilityId: string | null;
          roomNumber: string | null;
          medicalFacilityUnitId: string | null;
          notes: string | null;
          groundContact: string | null;
          estimatedRendezvousTimeInMinutes: number | null;
          estimatedGroundTimeInMinutes: number | null;
          fboId: string | null;
          physicianId: string | null;
          diversionReasonId: string | null;
          diversionReasonOtherNotes: string | null;
          isAutoAccepted: boolean | null;
          dateConfirmed: Date | number | string | null;
          confirmedByUserId: string | null;
          unConfirmed: boolean | null;
          physicianName: string | null;
          rendezvousRequests: Array<{
            __typename: 'RendezvousRequest';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: SupplementalLegType;
            utilizationStatus: AmrUtilizationStatus;
            requestLocationId: string;
            companyId: string;
            agencyLocationId: string | null;
            agencyEta: Date | number | string | null;
            rendezvousLocationDescription: string | null;
            contactInformation: string | null;
            confirmedAt: Date | number | string | null;
            departedLzAt: Date | number | string | null;
            arrivedDestAt: Date | number | string | null;
            departedDestAt: Date | number | string | null;
            arrivedLzAt: Date | number | string | null;
            cancelledAt: Date | number | string | null;
            notes: string | null;
            transportUnitNumber: string | null;
            latestStatus: string | null;
            latestStatusTimestamp: Date | number | string | null;
            agencyLocation: {
              __typename: 'AgencyLocation';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              isInTransportNet: boolean;
              agencyId: string;
              emailAddress: string | null;
              primaryPhoneNumber: string | null;
              secondaryPhoneNumber: string | null;
              smsPhoneNumber: string | null;
              faxPhoneNumber: string | null;
              notes: string | null;
              vehicleType: VehicleType | null;
              estimatedDepartureTimeInMinutes: number | null;
              locationId: string | null;
            } | null;
            cardLinks: Array<{
              __typename: 'CardLink';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              type: CardLinkType;
              fromCardId: string;
              toCardId: string;
              toCardNumber: string;
              companyId: string;
              rendezvousRequestId: string | null;
            } | null> | null;
          }>;
          diversionReason: {
            __typename: 'DiversionReason';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
          } | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }>;
        patients: Array<{
          __typename: 'RequestPatient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          gender: Gender;
          isIsolette: boolean;
          requestId: string;
          companyId: string;
          patientId: string | null;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          transportReasonId: string | null;
          notes: string | null;
          chiefComplaintNotes: string | null;
          transportReasonCategory: TransportReasonCategory | null;
          isIntubated: boolean | null;
          numberOfDrips: number | null;
          specialtyEquipment: string | null;
          rideAlongRequested: YesNoType | null;
          isoletteType: IsoletteType | null;
          isoletteNotes: string | null;
          transferReasonId: string | null;
          estimatedAgeInHours: number | null;
          gcs: number | null;
          bpSystolic: number | null;
          bpDiastolic: number | null;
          heartRate: number | null;
          oxygenSaturation: number | null;
          respiratoryRate: number | null;
          temperatureInCelsius: number | null;
          rideAlongWeightInKg: number | null;
          medicalRecordNumber: string | null;
          rideAlongName: string | null;
          rideAlongDateOfBirth: Date | number | string | null;
          transferReason: {
            __typename: 'TransferReason';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
          } | null;
        }>;
        receivingFacilityRequests: Array<{
          __typename: 'ReceivingFacilityRequest';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          status: ReceivingFacilityRequestStatus;
          cardId: string;
          requestId: string;
          medicalFacilityId: string;
          requestLocationId: string;
          companyId: string;
          nonAcceptanceType: NonAcceptanceType | null;
          nonAcceptanceReasonId: string | null;
          referredToFacilityId: string | null;
        }>;
        safetyQuestions: {
          __typename: 'SafetyQuestions';
          otherServiceDeclined: boolean | null;
          otherServiceDescription: string | null;
          otherServicesAreRespondingToTransferring: boolean | null;
          otherServiceResponseDescription: string | null;
        };
        requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
      } | null;
      operation: {
        __typename: 'Operation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: OperationStatus;
        type: OperationType;
        vehicleId: string;
        dateOperationStarted: Date | number | string;
        riskAnalysisAcknowledged: boolean;
        companyId: string;
        unitId: string | null;
        dateOperationEnded: Date | number | string | null;
        unitActivationTime: Date | number | string | null;
        riskAnalysisNumber: string | null;
        standbyActivationType: StandbyActivationType | null;
        caller: string | null;
        callbackNumber: string | null;
        initialOperationType: OperationType | null;
        unit: {
          __typename: 'Unit';
          excludeStates: Array<string | null> | null;
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          baseId: string;
          regionId: string;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          integrations: Array<IntegrationSystem>;
          isCrewAvailable: boolean;
          updatePhoneNumbersFromExternal: boolean;
          companyId: string;
          isAdministrative: boolean | null;
          vehicleId: string | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          oemPlacardNumber: string | null;
          primaryOutOfServiceEventId: string | null;
          emSystemResourceId: string | null;
          onBaseETAInMinutes: number | null;
          crewSourcedFromUnitId: string | null;
          completeFlightInstanceId: string | null;
          parentUnitId: string | null;
          positions: Array<{
            __typename: 'UnitPosition';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            type: UnitPositionType;
            isFlightCrew: boolean;
            isNonEmployee: boolean;
            unitId: string;
            companyId: string;
            notificationAddress: string | null;
            teamMemberId: string | null;
            firstName: string | null;
            lastName: string | null;
            teamMember: {
              __typename: 'Person';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              firstName: string;
              lastName: string;
              email: string;
              employeeType: EmployeeType;
              timeType: TimeType;
              activateOktaAccount: boolean;
              grantTcsAccess: boolean;
              isOutOfFlightCompliance: boolean;
              companyId: string;
              title: string | null;
              employeeId: string | null;
              hireDate: Date | number | string | null;
              terminationDate: Date | number | string | null;
              departmentId: string | null;
              reportsToPersonId: string | null;
              baseId: string | null;
              locationId: string | null;
              programId: string | null;
              activeDirectoryId: string | null;
              notificationAddress: string | null;
              userRoles: Array<UserRole | null> | null;
              allCompaniesAccessible: boolean | null;
              allBasesAccessible: boolean | null;
              allTrmProgramsAccessible: boolean | null;
              allCommunicationCentersAccessible: boolean | null;
              faaCompanyId: string | null;
              dispatchCompanyId: string | null;
              aviationCompanyId: string | null;
              primaryCommunicationCenterId: string | null;
              outOfFlightComplianceComment: string | null;
              dateLastUpdatedFromGMRWorkday: Date | number | string | null;
              appSettings: {
                __typename: 'UserApplicationSettings';
                tcsRealtimeTracking: {
                  __typename: 'TcsRealtimeTracking';
                  tabId: string | null;
                  tabDate: Date | number | string | null;
                };
              } | null;
              additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
            } | null;
          }>;
          shifts: Array<{
            __typename: 'UnitShift';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            startTimeInMinutes: number;
            endTimeInMinutes: number;
            unitId: string;
            companyId: string;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
            model: {
              __typename: 'VehicleModel';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              name: string;
              cruiseSpeedInMph: number | null;
            } | null;
            vehicleStateInspections: Array<{
              __typename: 'VehicleStateInspection';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              stateAbbrevation: string;
              inspectionDate: Date | number | string;
              vehicleId: string;
              companyId: string;
            }>;
          } | null;
          crewSourcedToUnits: Array<{
            __typename: 'CrewSourcedUnit';
            id: string;
            unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
          } | null> | null;
        } | null;
        trips: Array<{
          __typename: 'Trip';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          operationId: string;
          companyId: string;
          vehicleId: string | null;
          agencyId: string | null;
          agencyLocationId: string | null;
          calculatedLoadedMiles: number | null;
          gpsLoadedMiles: number | null;
          estimatedDurations: Array<{
            __typename: 'EstimatedDuration';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            asOfTime: Date | number | string;
            durationInMinutes: number;
            isOfficial: boolean;
            estimateSource: EstimatedDurationSource;
            durationType: EstimatedDurationType;
            ownerId: string;
            tripId: string;
            companyId: string;
            positionReportId: string | null;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
          } | null;
          agency: {
            __typename: 'Agency';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            type: AgencyType;
            isCompetitor: boolean;
            isInternallyOwned: boolean;
            parentCompanyId: string | null;
            notes: string | null;
          } | null;
          etas: Array<{
            __typename: 'Eta';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            asOfTime: Date | number | string;
            estimatedArrivalTime: Date | number | string;
            calculatedArrivalTime: Date | number | string;
            currentTripId: string;
            waypointId: string;
            companyId: string;
          }>;
          positionReports: Array<{
            __typename: 'PositionReport';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
            tripId: string;
            companyId: string;
            altitude: number | null;
            speedInKnots: number | null;
            heading: number | null;
            estimatedMinutesEnRoute: number | null;
            fuelRemaining: string | null;
            timezoneCd: string | null;
            dateConfirmed: Date | number | string | null;
            gpsProvider: GpsProvider | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          }>;
          flightFollowingReports: Array<{
            __typename: 'FlightFollowingReport';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            tripId: string;
            companyId: string;
            summary: string | null;
            fuel: string | null;
            estimatedTimeEnrouteMinutes: number | null;
            riskAnalysis: string | null;
            flightType: FlightType | null;
            soulsOnBoard: number | null;
            highestFeatureEnroute: number | null;
            takeOffWeight: number | null;
            centerOfGravity: number | null;
            destination: string | null;
            trackingViaGps: boolean | null;
            flightRule: FlightRule | null;
            tripLegId: string | null;
            confirmedFboId: string | null;
            cruisingAltitude: number | null;
            medicalCrewRA: number | null;
          }>;
          passengers: Array<{
            __typename: 'TripPassenger';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            type: PassengerType;
            tripId: string;
            companyId: string;
            weightInKg: number | null;
            positionName: string | null;
            positionType: UnitPositionType | null;
            notificationAddress: string | null;
            personId: string | null;
            crewMemberId: string | null;
            manifestEntries: Array<{
              __typename: 'ManifestEntry';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              passengerId: string;
              tripLegId: string;
              companyId: string;
              confirmedAt: Date | number | string | null;
              confirmedById: string | null;
            }>;
          }>;
          legs: Array<{
            __typename: 'TripLeg';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: TripLegStatus;
            sequence: number;
            tripId: string;
            companyId: string;
            estimatedDistanceInMiles: number | null;
            departingOdometerReading: number | null;
            departingNote: string | null;
            arrivingOdometerReading: number | null;
            arrivingNote: string | null;
            isEmergent: boolean | null;
            abortDate: Date | number | string | null;
            encodedPolyline: string | null;
            dateOnFinalMarked: Date | number | string | null;
            officialEteId: string | null;
            calculatedEteId: string | null;
            endingWaypointId: string | null;
            startingWaypointId: string | null;
          }>;
        }>;
      } | null;
      questionnaireResponses: Array<{
        __typename: 'QuestionnaireResponse';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: QuestionnaireResponseStatus;
        questionnaireId: string;
        companyId: string;
        cardId: string;
        currentReviewLevel: UserRole | null;
        completedById: string | null;
        dateCompleted: Date | number | string | null;
        communicationsReviewById: string | null;
        dateCommunicationsReviewed: Date | number | string | null;
        supervisorReviewById: string | null;
        dateSupervisorReviewed: Date | number | string | null;
        managerReviewById: string | null;
        dateManagerReviewed: Date | number | string | null;
        questionnaireQuestionResponses: Array<{
          __typename: 'QuestionnaireQuestionResponse';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          questionnaireResponseId: string;
          questionnaireSectionQuestionId: string;
          matchType: RuleMatchType;
          reviewRequired: boolean;
          companyId: string;
          responseValue: string | null;
          explanation: string | null;
          questionnaireQuestionResponseNotes: Array<{
            __typename: 'QuestionnaireQuestionResponseNote';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            questionnaireQuestionResponseId: string;
            authorId: string;
            dateAuthored: Date | number | string;
            note: string;
            companyId: string;
          }>;
        }>;
        questionnaire: {
          __typename: 'Questionnaire';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          companyId: string;
          type: QuestionnaireType;
          communicationCenterId: string | null;
        };
      }>;
      medicalControlContactLogEntries: Array<{
        __typename: 'MedicalControlContactLogEntry';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        cardId: string;
        timestampId: string;
        personId: string;
        isSuccessful: boolean;
        companyId: string;
        person: {
          __typename: 'Person';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          employeeType: EmployeeType;
          timeType: TimeType;
          activateOktaAccount: boolean;
          grantTcsAccess: boolean;
          isOutOfFlightCompliance: boolean;
          companyId: string;
          title: string | null;
          employeeId: string | null;
          hireDate: Date | number | string | null;
          terminationDate: Date | number | string | null;
          departmentId: string | null;
          reportsToPersonId: string | null;
          baseId: string | null;
          locationId: string | null;
          programId: string | null;
          activeDirectoryId: string | null;
          notificationAddress: string | null;
          userRoles: Array<UserRole | null> | null;
          allCompaniesAccessible: boolean | null;
          allBasesAccessible: boolean | null;
          allTrmProgramsAccessible: boolean | null;
          allCommunicationCentersAccessible: boolean | null;
          faaCompanyId: string | null;
          dispatchCompanyId: string | null;
          aviationCompanyId: string | null;
          primaryCommunicationCenterId: string | null;
          outOfFlightComplianceComment: string | null;
          dateLastUpdatedFromGMRWorkday: Date | number | string | null;
          appSettings: {
            __typename: 'UserApplicationSettings';
            tcsRealtimeTracking: {
              __typename: 'TcsRealtimeTracking';
              tabId: string | null;
              tabDate: Date | number | string | null;
            };
          } | null;
          additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        };
      }>;
    } | null;
  };
};

export type FetchOpsSummaryDataQueryVariables = Exact<{
  dispatchCompanyId: InputMaybe<Scalars['ID']>;
  communicationCenterId: InputMaybe<Scalars['ID']>;
  regionId: InputMaybe<Scalars['ID']>;
  controlZoneId: InputMaybe<Scalars['ID']>;
  controlZoneCompanyId: InputMaybe<Scalars['ID']>;
  includeVehicleSummaries?: Scalars['Boolean'];
  includeVehicles?: Scalars['Boolean'];
  includeCards?: Scalars['Boolean'];
  includeUnits?: Scalars['Boolean'];
  includeHiddenUnits?: Scalars['Boolean'];
  includeSpareUnits?: Scalars['Boolean'];
  includeThirdPartyUnits?: Scalars['Boolean'];
  includeExternalSystemUnits?: Scalars['Boolean'];
  includeTcsManagedUnits?: Scalars['Boolean'];
  fetchNested?: Scalars['Boolean'];
  fetchDeep?: Scalars['Boolean'];
  excludeCurrentDispatchCompany?: Scalars['Boolean'];
  summariesFetchAfterDate?: InputMaybe<Scalars['DateTime']>;
  oosEventsFetchAfterDate?: InputMaybe<Scalars['DateTime']>;
}>;

export type FetchOpsSummaryDataQuery = {
  __typename: 'Query';
  outOfServiceEvents?: {
    __typename: 'OutOfServiceEventQueries';
    all: {
      __typename: 'OutOfServiceEventCollection';
      meta: { __typename: 'OutOfServiceEventCollectionMetadata'; total: number };
      items: Array<{
        __typename: 'OutOfServiceEvent';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: OutOfServiceType;
        eventNumber: string;
        estimatedEndTime: Date | number | string;
        reasonId: string;
        isAirworthy: boolean;
        initialEstimatedEndTime: Date | number | string;
        alertWhenEventEnds: boolean;
        isPlanned: boolean;
        isBirdStrike: boolean;
        isPatientOnboard: boolean;
        waitingForParts: boolean;
        waitingForTooling: boolean;
        isAcknowledgementRequired: boolean;
        companyId: string;
        startTime: Date | number | string | null;
        isOpportunisticOOS: boolean | null;
        unitId: string | null;
        vehicleId: string | null;
        secondaryReasonId: string | null;
        scheduledStartTime: Date | number | string | null;
        endTime: Date | number | string | null;
        notes: string | null;
        linkedCardId: string | null;
        createdById: string | null;
        endedById: string | null;
        secondaryReasonComment: string | null;
        parentOutOfServiceEventId: string | null;
        paipEventId: string | null;
        copiedFromId: string | null;
        alertTimeInMinutes: number | null;
        outOfServiceTicketId: string | null;
        maintenanceTypes: Array<OosTicketMaintenanceType | null> | null;
        opportunityMXTypes: Array<OpportunityMXType | null> | null;
        rtsDelayReasonTypes: Array<RtsDelayReasonType | null> | null;
        maintenanceLocation: string | null;
        mxDuringPeakTimeReason: string | null;
        assignedBaseId: string | null;
        amtPointOfContactId: string | null;
        alternatePOC: string | null;
        spareVehicleId: string | null;
        ticketDescription: string | null;
        humanErrorDamageType: HumanErrorDamageType | null;
        businessUnitCompanyId: string | null;
        isAMTAvailable: boolean | null;
        isFAR135415Reportable: boolean | null;
        isFAR135417Reportable: boolean | null;
        dateAcknowledged: Date | number | string | null;
        acknowledgedById: string | null;
        acknowledgementNotes: string | null;
        maintenanceFacilityId: string | null;
        locationId: string | null;
        oosRequestType: OosRequestType | null;
        isEventAlreadyClosed: boolean | null;
        qarReasons: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        address: {
          __typename: 'Address';
          streetAddress: string | null;
          city: string | null;
          region: string | null;
          postalCode: string | null;
          country: string | null;
          county: string | null;
          gpsId: string | null;
          coordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        crew: Array<{
          __typename: 'OutOfServiceCrew';
          id: string;
          personId: string;
          unitPositionId: string;
          isFlightCrew: boolean;
          positionType: UnitPositionType | null;
          unitPositionRole: string | null;
          endDate: Date | number | string | null;
          notificationAddress: string | null;
        } | null> | null;
      }>;
    };
  };
  paipEvents: {
    __typename: 'PaipEventQueries';
    all: {
      __typename: 'PaipEventCollection';
      items: Array<{
        __typename: 'PaipEvent';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        reasonId: string;
        startTime: Date | number | string;
        companyId: string;
        regionId: string | null;
        eventNumber: string | null;
        endTime: Date | number | string | null;
        notes: string | null;
        unitIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        cardIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
    };
  };
  vehicles: {
    __typename: 'VehicleQueries';
    all?: {
      __typename: 'VehicleCollection';
      items: Array<{
        __typename: 'Vehicle';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        isUnderLease: boolean;
        role: VehicleRole;
        flightLogProcess: FlightLogProcess;
        isPlaceholder: boolean;
        stateInspectionRequired: boolean;
        isRetired: boolean;
        isPositionTrackingEnabled: boolean;
        hideFromOOSRUM: boolean;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        year: number | null;
        dateAcquired: Date | number | string | null;
        makeId: string | null;
        modelId: string | null;
        cruiseSpeed: number | null;
        configurationClassId: string | null;
        isThirdPartyVehicle: boolean | null;
        parentUnitId: string | null;
        isHidden: boolean | null;
        faaCompanyId: string | null;
        skytracIMEI: string | null;
        phoneNumber: string | null;
        completeFlightId: string | null;
        controlZoneId: string | null;
        communicationCenterId: string | null;
        regionId: string | null;
        vehicleDescription: string | null;
      }>;
    };
    summaries?: {
      __typename: 'VehicleSummaryCollection';
      items: Array<{
        __typename: 'VehicleSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        unitSummaryId: string;
        regionId: string;
        status: VehicleStatus;
        statusDescription: string;
        vehicleDispositionId: string;
        unitId: string;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        makeName: string | null;
        modelName: string | null;
        etlo: Date | number | string | null;
        eta: Date | number | string | null;
        currentCardNumber: string | null;
        currentCardSummaryId: string | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        currentOrNextLegSequence: number | null;
        totalLegCount: number | null;
        dateOnFinalMarked: Date | number | string | null;
        communicationCenterId: string | null;
        currentCardId: string | null;
        currentCardSummary?: {
          __typename: 'CardSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          status: CardStatus;
          cardNumber: string;
          operationType: OperationType;
          regionId: string;
          companyId: string;
          dateContactCompleted: Date | number | string | null;
          apiWebhookSubscriptionId: string | null;
          webOrderAcknowledgedTime: Date | number | string | null;
          diversionType: DiversionType | null;
          gmrUtilizationStatus: AmrUtilizationStatus | null;
          gmrCADNumber: string | null;
          vehicleId: string | null;
          vehicleSummaryId: string | null;
          communicationCenterId: string | null;
          unitId: string | null;
          unitSummaryId: string | null;
          operation: {
            __typename: 'OperationSummary';
            id: string;
            status: OperationStatus;
            unitId: string | null;
            vehicleId: string | null;
            riskAnalysisNumber: string | null;
            riskAnalysisAcknowledged: boolean | null;
            tripId: string | null;
          } | null;
          request: {
            __typename: 'RequestSummary';
            id: string;
            status: RequestStatus;
            isStandbyRequest: boolean;
            isSisterCompanyReferral: boolean;
            standbyActivationRequested: boolean;
            assignmentDelayedReason: string | null;
            transportTrackingLink: string | null;
            latestWeatherDeclineUnitId: string | null;
            latestWeatherDeclineTime: Date | number | string | null;
            latestWeatherDeclineReasonId: string | null;
            latestWeatherDeclineSecondaryReasonId: string | null;
            assignmentDelayedTime: Date | number | string | null;
            requester: {
              __typename: 'RequesterSummary';
              id: string;
              missionRole: MissionRoleType;
              vetNumber: string | null;
            } | null;
            from: {
              __typename: 'RequestLocationSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              } | null;
            } | null;
            to: {
              __typename: 'RequestLocationSummary';
              id: string;
              name: string;
              abbreviation: string;
              type: WaypointType;
              address: {
                __typename: 'Address';
                streetAddress: string | null;
                city: string | null;
                region: string | null;
                postalCode: string | null;
                country: string | null;
                county: string | null;
                gpsId: string | null;
                coordinates: {
                  __typename: 'Coordinates';
                  latitude: number | null;
                  longitude: number | null;
                } | null;
              } | null;
            } | null;
          } | null;
          patients: Array<{
            __typename: 'RequestPatientSummary';
            id: string;
            dateOfBirth: Date | number | string | null;
            weightInKg: number | null;
            dateCreated: Date | number | string | null;
          } | null> | null;
        } | null;
        from: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        to: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        latestPositionReportSummary: {
          __typename: 'PositionReportSummary';
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
        } | null;
        lastKnownCoordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      }>;
      meta: { __typename: 'VehicleSummaryCollectionMetadata'; total: number };
    };
  };
  cards?: {
    __typename: 'CardQueries';
    summaries: {
      __typename: 'CardSummaryCollection';
      items: Array<{
        __typename: 'CardSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        status: CardStatus;
        cardNumber: string;
        operationType: OperationType;
        regionId: string;
        companyId: string;
        dateContactCompleted: Date | number | string | null;
        apiWebhookSubscriptionId: string | null;
        webOrderAcknowledgedTime: Date | number | string | null;
        diversionType: DiversionType | null;
        gmrUtilizationStatus: AmrUtilizationStatus | null;
        gmrCADNumber: string | null;
        vehicleId: string | null;
        vehicleSummaryId: string | null;
        communicationCenterId: string | null;
        unitId: string | null;
        unitSummaryId: string | null;
        unitSummary?: {
          __typename: 'UnitSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          isCrewAvailable: boolean;
          baseId: string;
          regionId: string;
          companyId: string;
          isAdministrative: boolean | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          lastPilotUpdateName: string | null;
          baseTimezoneCd: string | null;
          vehicleSummaryId: string | null;
          vehicleId: string | null;
          communicationCenterId: string | null;
          shifts: Array<{
            __typename: 'UnitShiftSummary';
            id: string;
            name: string;
            startTimeInMinutes: number;
            endTimeInMinutes: number;
          }>;
          outOfServiceEvents: Array<{
            __typename: 'OutOfServiceEventSummary';
            id: string;
            type: OutOfServiceType;
            eventNumber: string;
            estimatedEndTime: Date | number | string;
            reasonName: string;
            reasonId: string;
            startTime: Date | number | string | null;
            isOpportunisticOOS: boolean | null;
            notes: string | null;
          }>;
          positions: Array<{
            __typename: 'UnitPositionSummary';
            id: string;
            name: string;
            type: UnitPositionType;
            isFlightCrew: boolean;
            isNonEmployee: boolean;
            isNonCompliant: boolean;
            notificationAddress: string | null;
            teamMemberId: string | null;
            teamMemberFirstName: string | null;
            teamMemberLastName: string | null;
            nonComplianceReason: string | null;
          }>;
          paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
        } | null;
        operation: {
          __typename: 'OperationSummary';
          id: string;
          status: OperationStatus;
          unitId: string | null;
          vehicleId: string | null;
          riskAnalysisNumber: string | null;
          riskAnalysisAcknowledged: boolean | null;
          tripId: string | null;
        } | null;
        request: {
          __typename: 'RequestSummary';
          id: string;
          status: RequestStatus;
          isStandbyRequest: boolean;
          isSisterCompanyReferral: boolean;
          standbyActivationRequested: boolean;
          assignmentDelayedReason: string | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          assignmentDelayedTime: Date | number | string | null;
          requester: {
            __typename: 'RequesterSummary';
            id: string;
            missionRole: MissionRoleType;
            vetNumber: string | null;
          } | null;
          from: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
          to: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
        } | null;
        patients: Array<{
          __typename: 'RequestPatientSummary';
          id: string;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          dateCreated: Date | number | string | null;
        } | null> | null;
      }>;
      meta: { __typename: 'CardSummaryCollectionMetadata'; total: number };
    };
  };
  units?: {
    __typename: 'UnitQueries';
    summaries: {
      __typename: 'UnitSummaryCollection';
      items: Array<{
        __typename: 'UnitSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        isCrewAvailable: boolean;
        baseId: string;
        regionId: string;
        companyId: string;
        isAdministrative: boolean | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        lastPilotUpdateName: string | null;
        baseTimezoneCd: string | null;
        vehicleSummaryId: string | null;
        vehicleId: string | null;
        communicationCenterId: string | null;
        vehicleSummary?: {
          __typename: 'VehicleSummary';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          id: string;
          type: VehicleType;
          registrationNumber: string;
          unitSummaryId: string;
          regionId: string;
          status: VehicleStatus;
          statusDescription: string;
          vehicleDispositionId: string;
          unitId: string;
          companyId: string;
          serialNumber: string | null;
          dispatchCompanyId: string | null;
          makeName: string | null;
          modelName: string | null;
          etlo: Date | number | string | null;
          eta: Date | number | string | null;
          currentCardNumber: string | null;
          currentCardSummaryId: string | null;
          lastQualifyingPositionReportTime: Date | number | string | null;
          currentOrNextLegSequence: number | null;
          totalLegCount: number | null;
          dateOnFinalMarked: Date | number | string | null;
          communicationCenterId: string | null;
          currentCardId: string | null;
          currentCardSummary?: {
            __typename: 'CardSummary';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            id: string;
            status: CardStatus;
            cardNumber: string;
            operationType: OperationType;
            regionId: string;
            companyId: string;
            dateContactCompleted: Date | number | string | null;
            apiWebhookSubscriptionId: string | null;
            webOrderAcknowledgedTime: Date | number | string | null;
            diversionType: DiversionType | null;
            gmrUtilizationStatus: AmrUtilizationStatus | null;
            gmrCADNumber: string | null;
            vehicleId: string | null;
            vehicleSummaryId: string | null;
            communicationCenterId: string | null;
            unitId: string | null;
            unitSummaryId: string | null;
            operation: {
              __typename: 'OperationSummary';
              id: string;
              status: OperationStatus;
              unitId: string | null;
              vehicleId: string | null;
              riskAnalysisNumber: string | null;
              riskAnalysisAcknowledged: boolean | null;
              tripId: string | null;
            } | null;
            request: {
              __typename: 'RequestSummary';
              id: string;
              status: RequestStatus;
              isStandbyRequest: boolean;
              isSisterCompanyReferral: boolean;
              standbyActivationRequested: boolean;
              assignmentDelayedReason: string | null;
              transportTrackingLink: string | null;
              latestWeatherDeclineUnitId: string | null;
              latestWeatherDeclineTime: Date | number | string | null;
              latestWeatherDeclineReasonId: string | null;
              latestWeatherDeclineSecondaryReasonId: string | null;
              assignmentDelayedTime: Date | number | string | null;
              requester: {
                __typename: 'RequesterSummary';
                id: string;
                missionRole: MissionRoleType;
                vetNumber: string | null;
              } | null;
              from: {
                __typename: 'RequestLocationSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                } | null;
              } | null;
              to: {
                __typename: 'RequestLocationSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
                address: {
                  __typename: 'Address';
                  streetAddress: string | null;
                  city: string | null;
                  region: string | null;
                  postalCode: string | null;
                  country: string | null;
                  county: string | null;
                  gpsId: string | null;
                  coordinates: {
                    __typename: 'Coordinates';
                    latitude: number | null;
                    longitude: number | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            patients: Array<{
              __typename: 'RequestPatientSummary';
              id: string;
              dateOfBirth: Date | number | string | null;
              weightInKg: number | null;
              dateCreated: Date | number | string | null;
            } | null> | null;
          } | null;
          from: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          to: {
            __typename: 'WaypointSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
          } | null;
          latestPositionReportSummary: {
            __typename: 'PositionReportSummary';
            id: string;
            positionTime: Date | number | string;
            source: PositionReportSource;
          } | null;
          lastKnownCoordinates: {
            __typename: 'Coordinates';
            latitude: number | null;
            longitude: number | null;
          } | null;
        } | null;
        shifts: Array<{
          __typename: 'UnitShiftSummary';
          id: string;
          name: string;
          startTimeInMinutes: number;
          endTimeInMinutes: number;
        }>;
        outOfServiceEvents: Array<{
          __typename: 'OutOfServiceEventSummary';
          id: string;
          type: OutOfServiceType;
          eventNumber: string;
          estimatedEndTime: Date | number | string;
          reasonName: string;
          reasonId: string;
          startTime: Date | number | string | null;
          isOpportunisticOOS: boolean | null;
          notes: string | null;
        }>;
        positions: Array<{
          __typename: 'UnitPositionSummary';
          id: string;
          name: string;
          type: UnitPositionType;
          isFlightCrew: boolean;
          isNonEmployee: boolean;
          isNonCompliant: boolean;
          notificationAddress: string | null;
          teamMemberId: string | null;
          teamMemberFirstName: string | null;
          teamMemberLastName: string | null;
          nonComplianceReason: string | null;
        }>;
        paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'UnitSummaryCollectionMetadata'; total: number };
    };
  };
};

export type FetchCardLinksQueryVariables = Exact<{
  filter: InputMaybe<CardLinkFilter>;
  skip: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;

export type FetchCardLinksQuery = {
  __typename: 'Query';
  cardLinks: {
    __typename: 'CardLinkQueries';
    all: {
      __typename: 'CardLinkCollection';
      items: Array<{
        __typename: 'CardLink';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        type: CardLinkType;
        fromCardId: string;
        toCardId: string;
        toCardNumber: string;
        companyId: string;
        rendezvousRequestId: string | null;
      }>;
      meta: { __typename: 'CardLinkCollectionMetadata'; total: number };
    };
  };
};

export type FetchCardSummaryByCardNumberQueryVariables = Exact<{
  cardNumber: Scalars['ID'];
}>;

export type FetchCardSummaryByCardNumberQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    summaryByCardNumber: {
      __typename: 'CardSummary';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      operationType: OperationType;
      regionId: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      apiWebhookSubscriptionId: string | null;
      webOrderAcknowledgedTime: Date | number | string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      vehicleId: string | null;
      vehicleSummaryId: string | null;
      communicationCenterId: string | null;
      unitId: string | null;
      unitSummaryId: string | null;
      operation: {
        __typename: 'OperationSummary';
        id: string;
        status: OperationStatus;
        unitId: string | null;
        vehicleId: string | null;
        riskAnalysisNumber: string | null;
        riskAnalysisAcknowledged: boolean | null;
        tripId: string | null;
      } | null;
      request: {
        __typename: 'RequestSummary';
        id: string;
        status: RequestStatus;
        isStandbyRequest: boolean;
        isSisterCompanyReferral: boolean;
        standbyActivationRequested: boolean;
        assignmentDelayedReason: string | null;
        transportTrackingLink: string | null;
        latestWeatherDeclineUnitId: string | null;
        latestWeatherDeclineTime: Date | number | string | null;
        latestWeatherDeclineReasonId: string | null;
        latestWeatherDeclineSecondaryReasonId: string | null;
        assignmentDelayedTime: Date | number | string | null;
        requester: {
          __typename: 'RequesterSummary';
          id: string;
          missionRole: MissionRoleType;
          vetNumber: string | null;
        } | null;
        from: {
          __typename: 'RequestLocationSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
        } | null;
        to: {
          __typename: 'RequestLocationSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
        } | null;
      } | null;
      patients: Array<{
        __typename: 'RequestPatientSummary';
        id: string;
        dateOfBirth: Date | number | string | null;
        weightInKg: number | null;
        dateCreated: Date | number | string | null;
      } | null> | null;
    } | null;
  };
};

export type FetchCardSummaryByCardIdQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;

export type FetchCardSummaryByCardIdQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    summaryById: {
      __typename: 'CardSummary';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      operationType: OperationType;
      regionId: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      apiWebhookSubscriptionId: string | null;
      webOrderAcknowledgedTime: Date | number | string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      vehicleId: string | null;
      vehicleSummaryId: string | null;
      communicationCenterId: string | null;
      unitId: string | null;
      unitSummaryId: string | null;
      operation: {
        __typename: 'OperationSummary';
        id: string;
        status: OperationStatus;
        unitId: string | null;
        vehicleId: string | null;
        riskAnalysisNumber: string | null;
        riskAnalysisAcknowledged: boolean | null;
        tripId: string | null;
      } | null;
      request: {
        __typename: 'RequestSummary';
        id: string;
        status: RequestStatus;
        isStandbyRequest: boolean;
        isSisterCompanyReferral: boolean;
        standbyActivationRequested: boolean;
        assignmentDelayedReason: string | null;
        transportTrackingLink: string | null;
        latestWeatherDeclineUnitId: string | null;
        latestWeatherDeclineTime: Date | number | string | null;
        latestWeatherDeclineReasonId: string | null;
        latestWeatherDeclineSecondaryReasonId: string | null;
        assignmentDelayedTime: Date | number | string | null;
        requester: {
          __typename: 'RequesterSummary';
          id: string;
          missionRole: MissionRoleType;
          vetNumber: string | null;
        } | null;
        from: {
          __typename: 'RequestLocationSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
        } | null;
        to: {
          __typename: 'RequestLocationSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          } | null;
        } | null;
      } | null;
      patients: Array<{
        __typename: 'RequestPatientSummary';
        id: string;
        dateOfBirth: Date | number | string | null;
        weightInKg: number | null;
        dateCreated: Date | number | string | null;
      } | null> | null;
    } | null;
  };
};

export type CardUnitOverviewComponent_FetchCardEntitiesByCardIdQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;

export type CardUnitOverviewComponent_FetchCardEntitiesByCardIdQuery = {
  __typename: 'Query';
  cards: {
    __typename: 'CardQueries';
    byId: {
      __typename: 'Card';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      status: CardStatus;
      cardNumber: string;
      companyId: string;
      dateContactCompleted: Date | number | string | null;
      dateCardClosed: Date | number | string | null;
      transferredToCardId: string | null;
      transferredFromCardId: string | null;
      linkedCardId: string | null;
      closeComment: string | null;
      reOpenComment: string | null;
      postTransportDebriefCompleted: boolean | null;
      isBillable: boolean | null;
      notBillableType: NotBillableType | null;
      notBillableComment: string | null;
      apiWebhookSubscriptionId: string | null;
      createdById: string | null;
      plannedCompletionTime: Date | number | string | null;
      reOpenReasonId: string | null;
      lastOperationId: string | null;
      diversionType: DiversionType | null;
      gmrUtilizationStatus: AmrUtilizationStatus | null;
      gmrCADNumber: string | null;
      isLocked: boolean | null;
      crewWillTransportWithReplacementGroundUnit: boolean | null;
      operationId: string | null;
      requestId: string | null;
      request: {
        __typename: 'Request';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: RequestStatus;
        requestedOperationType: OperationType;
        isStandbyRequest: boolean;
        standbyActivationRequested: boolean;
        missionConfiguration: MissionConfiguration;
        missionProfile: MissionProfile;
        companyId: string;
        cancellationReasonId: string | null;
        cancellationSecondaryReasonId: string | null;
        cancellationReasonNotes: string | null;
        requestedVehicleType: VehicleType | null;
        primaryUnitServiceAreaId: string | null;
        commitUnitToStandby: boolean | null;
        initiationType: RequestInitiationType | null;
        assignmentDelayedTime: Date | number | string | null;
        assignmentDelayedReasonId: string | null;
        regionId: string | null;
        includeCompetitors: boolean | null;
        transportOfferAlgorithmId: string | null;
        transportOfferAlgorithm: TransportOfferAlgorithm | null;
        minimumFlightRule: FlightRule | null;
        transportTrackingLink: string | null;
        latestWeatherDeclineUnitId: string | null;
        latestWeatherDeclineTime: Date | number | string | null;
        latestWeatherDeclineReasonId: string | null;
        latestWeatherDeclineSecondaryReasonId: string | null;
        webOrderCallType: WebOrderCallType | null;
        etloInMinutes: number | null;
        atloInMinutes: number | null;
        locations: Array<{
          __typename: 'RequestLocation';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
          requestId: string;
          companyId: string;
          locationId: string | null;
          timezoneCd: string | null;
          isRotorWingLz: boolean | null;
          medicalFacilityId: string | null;
          roomNumber: string | null;
          medicalFacilityUnitId: string | null;
          notes: string | null;
          groundContact: string | null;
          estimatedRendezvousTimeInMinutes: number | null;
          estimatedGroundTimeInMinutes: number | null;
          fboId: string | null;
          physicianId: string | null;
          diversionReasonId: string | null;
          diversionReasonOtherNotes: string | null;
          isAutoAccepted: boolean | null;
          dateConfirmed: Date | number | string | null;
          confirmedByUserId: string | null;
          unConfirmed: boolean | null;
          physicianName: string | null;
          address: {
            __typename: 'Address';
            streetAddress: string | null;
            city: string | null;
            region: string | null;
            postalCode: string | null;
            country: string | null;
            county: string | null;
            gpsId: string | null;
            coordinates: {
              __typename: 'Coordinates';
              latitude: number | null;
              longitude: number | null;
            } | null;
          };
        }>;
        patients: Array<{
          __typename: 'RequestPatient';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          gender: Gender;
          isIsolette: boolean;
          requestId: string;
          companyId: string;
          patientId: string | null;
          firstName: string | null;
          lastName: string | null;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          transportReasonId: string | null;
          notes: string | null;
          chiefComplaintNotes: string | null;
          transportReasonCategory: TransportReasonCategory | null;
          isIntubated: boolean | null;
          numberOfDrips: number | null;
          specialtyEquipment: string | null;
          rideAlongRequested: YesNoType | null;
          isoletteType: IsoletteType | null;
          isoletteNotes: string | null;
          transferReasonId: string | null;
          estimatedAgeInHours: number | null;
          gcs: number | null;
          bpSystolic: number | null;
          bpDiastolic: number | null;
          heartRate: number | null;
          oxygenSaturation: number | null;
          respiratoryRate: number | null;
          temperatureInCelsius: number | null;
          rideAlongWeightInKg: number | null;
          medicalRecordNumber: string | null;
          rideAlongName: string | null;
          rideAlongDateOfBirth: Date | number | string | null;
        }>;
        safetyQuestions: {
          __typename: 'SafetyQuestions';
          otherServiceDeclined: boolean | null;
          otherServiceDescription: string | null;
          otherServicesAreRespondingToTransferring: boolean | null;
          otherServiceResponseDescription: string | null;
        };
        requiredCapabilities: Array<{ __typename: 'RequiredCapability'; id: string }>;
      } | null;
      operation: {
        __typename: 'Operation';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: OperationStatus;
        type: OperationType;
        vehicleId: string;
        dateOperationStarted: Date | number | string;
        riskAnalysisAcknowledged: boolean;
        companyId: string;
        unitId: string | null;
        dateOperationEnded: Date | number | string | null;
        unitActivationTime: Date | number | string | null;
        riskAnalysisNumber: string | null;
        standbyActivationType: StandbyActivationType | null;
        caller: string | null;
        callbackNumber: string | null;
        initialOperationType: OperationType | null;
        unit: {
          __typename: 'Unit';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          name: string;
          abbreviation: string;
          status: UnitStatus;
          weatherStatus: WeatherStatus;
          baseId: string;
          regionId: string;
          isExternallyManaged: boolean;
          maximumFlightRule: FlightRule;
          isOnDelay: boolean;
          isEnabled: boolean;
          isSpare: boolean;
          integrations: Array<IntegrationSystem>;
          isCrewAvailable: boolean;
          updatePhoneNumbersFromExternal: boolean;
          companyId: string;
          isAdministrative: boolean | null;
          vehicleId: string | null;
          isHidden: boolean | null;
          isThirdPartyUnit: boolean | null;
          etloInMinutes: number | null;
          pilotNotes: string | null;
          lastPilotUpdateTime: Date | number | string | null;
          lastPilotUpdateById: string | null;
          plannedAvailableNotes: string | null;
          plannedAvailableTime: Date | number | string | null;
          oemPlacardNumber: string | null;
          primaryOutOfServiceEventId: string | null;
          emSystemResourceId: string | null;
          onBaseETAInMinutes: number | null;
          crewSourcedFromUnitId: string | null;
          completeFlightInstanceId: string | null;
          parentUnitId: string | null;
          crewSourcedToUnits: Array<{
            __typename: 'CrewSourcedUnit';
            id: string;
            unitPositions: Array<{ __typename: 'IdListItem'; id: string }>;
          } | null> | null;
        } | null;
        trips: Array<{
          __typename: 'Trip';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          operationId: string;
          companyId: string;
          vehicleId: string | null;
          agencyId: string | null;
          agencyLocationId: string | null;
          calculatedLoadedMiles: number | null;
          gpsLoadedMiles: number | null;
          estimatedDurations: Array<{
            __typename: 'EstimatedDuration';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            asOfTime: Date | number | string;
            durationInMinutes: number;
            isOfficial: boolean;
            estimateSource: EstimatedDurationSource;
            durationType: EstimatedDurationType;
            ownerId: string;
            tripId: string;
            companyId: string;
            positionReportId: string | null;
          }>;
          vehicle: {
            __typename: 'Vehicle';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            type: VehicleType;
            registrationNumber: string;
            isUnderLease: boolean;
            role: VehicleRole;
            flightLogProcess: FlightLogProcess;
            isPlaceholder: boolean;
            stateInspectionRequired: boolean;
            isRetired: boolean;
            isPositionTrackingEnabled: boolean;
            hideFromOOSRUM: boolean;
            companyId: string;
            serialNumber: string | null;
            dispatchCompanyId: string | null;
            year: number | null;
            dateAcquired: Date | number | string | null;
            makeId: string | null;
            modelId: string | null;
            cruiseSpeed: number | null;
            configurationClassId: string | null;
            isThirdPartyVehicle: boolean | null;
            parentUnitId: string | null;
            isHidden: boolean | null;
            faaCompanyId: string | null;
            skytracIMEI: string | null;
            phoneNumber: string | null;
            completeFlightId: string | null;
            controlZoneId: string | null;
            communicationCenterId: string | null;
            regionId: string | null;
            vehicleDescription: string | null;
            vehicleDispositions: Array<{
              __typename: 'VehicleDisposition';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              vehicleId: string;
              status: VehicleStatus;
              companyId: string;
              currentWaypointId: string | null;
              currentTripLegId: string | null;
              currentTripId: string | null;
              lastTripId: string | null;
              currentAgencyLocationId: string | null;
              notes: string | null;
              isAssetOutOfService: boolean | null;
              lastQualifyingPositionReportTime: Date | number | string | null;
              latitude: number | null;
              longitude: number | null;
              etlo: Date | number | string | null;
              statusDescription: string | null;
              positionTime: Date | number | string | null;
              positionSource: PositionReportSource | null;
              vehiclePositionSummaryId: string | null;
              latestPositionReportId: string | null;
              latestFlightFollowingReportId: string | null;
              from: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
              to: {
                __typename: 'WaypointSummary';
                id: string;
                name: string;
                abbreviation: string;
                type: WaypointType;
              } | null;
            }>;
          } | null;
          passengers: Array<{
            __typename: 'TripPassenger';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            name: string;
            abbreviation: string;
            type: PassengerType;
            tripId: string;
            companyId: string;
            weightInKg: number | null;
            positionName: string | null;
            positionType: UnitPositionType | null;
            notificationAddress: string | null;
            personId: string | null;
            crewMemberId: string | null;
            manifestEntries: Array<{
              __typename: 'ManifestEntry';
              dateLastUpdated: Date | number | string;
              dateCreated: Date | number | string;
              dateDeleted: Date | number | string | null;
              lastUpdatedById: string | null;
              id: string;
              passengerId: string;
              tripLegId: string;
              companyId: string;
              confirmedAt: Date | number | string | null;
              confirmedById: string | null;
            }>;
          }>;
          legs: Array<{
            __typename: 'TripLeg';
            dateLastUpdated: Date | number | string;
            dateCreated: Date | number | string;
            dateDeleted: Date | number | string | null;
            lastUpdatedById: string | null;
            id: string;
            status: TripLegStatus;
            sequence: number;
            tripId: string;
            companyId: string;
            estimatedDistanceInMiles: number | null;
            departingOdometerReading: number | null;
            departingNote: string | null;
            arrivingOdometerReading: number | null;
            arrivingNote: string | null;
            isEmergent: boolean | null;
            abortDate: Date | number | string | null;
            encodedPolyline: string | null;
            dateOnFinalMarked: Date | number | string | null;
            officialEteId: string | null;
            calculatedEteId: string | null;
            endingWaypointId: string | null;
            startingWaypointId: string | null;
          }>;
        }>;
      } | null;
    } | null;
  };
};

export type AttachmentsComponent_FetchAttachmentsQueryVariables = Exact<{
  entityId: Scalars['ID'];
  entityType: AttachmentEntityType;
}>;

export type AttachmentsComponent_FetchAttachmentsQuery = {
  __typename: 'Query';
  attachments: {
    __typename: 'AttachmentQueries';
    all: {
      __typename: 'AttachmentCollection';
      items: Array<{
        __typename: 'Attachment';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        attachmentEntityType: AttachmentEntityType;
        fileName: string;
        entityId: string | null;
        fileSizeInBytes: number | null;
        contentType: string | null;
      }>;
    };
  };
};

export type UserDataContextService_FetchQueryVariables = Exact<{ [key: string]: never }>;

export type UserDataContextService_FetchQuery = {
  __typename: 'Query';
  authenticatedIdentity: {
    __typename: 'Person';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employeeType: EmployeeType;
    timeType: TimeType;
    activateOktaAccount: boolean;
    grantTcsAccess: boolean;
    isOutOfFlightCompliance: boolean;
    companyId: string;
    title: string | null;
    employeeId: string | null;
    hireDate: Date | number | string | null;
    terminationDate: Date | number | string | null;
    departmentId: string | null;
    reportsToPersonId: string | null;
    baseId: string | null;
    locationId: string | null;
    programId: string | null;
    activeDirectoryId: string | null;
    notificationAddress: string | null;
    userRoles: Array<UserRole | null> | null;
    allCompaniesAccessible: boolean | null;
    allBasesAccessible: boolean | null;
    allTrmProgramsAccessible: boolean | null;
    allCommunicationCentersAccessible: boolean | null;
    faaCompanyId: string | null;
    dispatchCompanyId: string | null;
    aviationCompanyId: string | null;
    primaryCommunicationCenterId: string | null;
    outOfFlightComplianceComment: string | null;
    dateLastUpdatedFromGMRWorkday: Date | number | string | null;
    appSettings: {
      __typename: 'UserApplicationSettings';
      tcsRealtimeTracking: {
        __typename: 'TcsRealtimeTracking';
        tabId: string | null;
        tabDate: Date | number | string | null;
      };
    } | null;
    additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  };
  userIdentity: {
    __typename: 'Person';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employeeType: EmployeeType;
    timeType: TimeType;
    activateOktaAccount: boolean;
    grantTcsAccess: boolean;
    isOutOfFlightCompliance: boolean;
    companyId: string;
    title: string | null;
    employeeId: string | null;
    hireDate: Date | number | string | null;
    terminationDate: Date | number | string | null;
    departmentId: string | null;
    reportsToPersonId: string | null;
    baseId: string | null;
    locationId: string | null;
    programId: string | null;
    activeDirectoryId: string | null;
    notificationAddress: string | null;
    userRoles: Array<UserRole | null> | null;
    allCompaniesAccessible: boolean | null;
    allBasesAccessible: boolean | null;
    allTrmProgramsAccessible: boolean | null;
    allCommunicationCentersAccessible: boolean | null;
    faaCompanyId: string | null;
    dispatchCompanyId: string | null;
    aviationCompanyId: string | null;
    primaryCommunicationCenterId: string | null;
    outOfFlightComplianceComment: string | null;
    dateLastUpdatedFromGMRWorkday: Date | number | string | null;
    accessibleItems: Array<{
      __typename: 'AccessibleItem';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      type: EntityType;
      entityId: string;
      personId: string;
      userRoles: Array<UserRole | null> | null;
    }>;
    appSettings: {
      __typename: 'UserApplicationSettings';
      tcsRealtimeTracking: {
        __typename: 'TcsRealtimeTracking';
        tabId: string | null;
        tabDate: Date | number | string | null;
      };
    } | null;
    additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  };
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        states: Array<string | null> | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
    };
  };
  controlZones: {
    __typename: 'ControlZoneQueries';
    all: {
      __typename: 'ControlZoneCollection';
      items: Array<{
        __typename: 'ControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
      }>;
    };
  };
  vehicleControlZones: {
    __typename: 'VehicleControlZoneQueries';
    all: {
      __typename: 'VehicleControlZoneCollection';
      items: Array<{
        __typename: 'VehicleControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        companyId: string;
        controlZoneId: string | null;
        vehicleId: string | null;
      }>;
    };
  };
  baseControlZones: {
    __typename: 'BaseControlZoneQueries';
    all: {
      __typename: 'BaseControlZoneCollection';
      items: Array<{
        __typename: 'BaseControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        controlZoneId: string;
        baseId: string;
        companyId: string;
      }>;
    };
  };
};

export type UserDataContextFragment = {
  __typename: 'Query';
  authenticatedIdentity: {
    __typename: 'Person';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employeeType: EmployeeType;
    timeType: TimeType;
    activateOktaAccount: boolean;
    grantTcsAccess: boolean;
    isOutOfFlightCompliance: boolean;
    companyId: string;
    title: string | null;
    employeeId: string | null;
    hireDate: Date | number | string | null;
    terminationDate: Date | number | string | null;
    departmentId: string | null;
    reportsToPersonId: string | null;
    baseId: string | null;
    locationId: string | null;
    programId: string | null;
    activeDirectoryId: string | null;
    notificationAddress: string | null;
    userRoles: Array<UserRole | null> | null;
    allCompaniesAccessible: boolean | null;
    allBasesAccessible: boolean | null;
    allTrmProgramsAccessible: boolean | null;
    allCommunicationCentersAccessible: boolean | null;
    faaCompanyId: string | null;
    dispatchCompanyId: string | null;
    aviationCompanyId: string | null;
    primaryCommunicationCenterId: string | null;
    outOfFlightComplianceComment: string | null;
    dateLastUpdatedFromGMRWorkday: Date | number | string | null;
    appSettings: {
      __typename: 'UserApplicationSettings';
      tcsRealtimeTracking: {
        __typename: 'TcsRealtimeTracking';
        tabId: string | null;
        tabDate: Date | number | string | null;
      };
    } | null;
    additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  };
  userIdentity: {
    __typename: 'Person';
    dateLastUpdated: Date | number | string;
    dateCreated: Date | number | string;
    dateDeleted: Date | number | string | null;
    lastUpdatedById: string | null;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employeeType: EmployeeType;
    timeType: TimeType;
    activateOktaAccount: boolean;
    grantTcsAccess: boolean;
    isOutOfFlightCompliance: boolean;
    companyId: string;
    title: string | null;
    employeeId: string | null;
    hireDate: Date | number | string | null;
    terminationDate: Date | number | string | null;
    departmentId: string | null;
    reportsToPersonId: string | null;
    baseId: string | null;
    locationId: string | null;
    programId: string | null;
    activeDirectoryId: string | null;
    notificationAddress: string | null;
    userRoles: Array<UserRole | null> | null;
    allCompaniesAccessible: boolean | null;
    allBasesAccessible: boolean | null;
    allTrmProgramsAccessible: boolean | null;
    allCommunicationCentersAccessible: boolean | null;
    faaCompanyId: string | null;
    dispatchCompanyId: string | null;
    aviationCompanyId: string | null;
    primaryCommunicationCenterId: string | null;
    outOfFlightComplianceComment: string | null;
    dateLastUpdatedFromGMRWorkday: Date | number | string | null;
    accessibleItems: Array<{
      __typename: 'AccessibleItem';
      dateLastUpdated: Date | number | string;
      dateCreated: Date | number | string;
      dateDeleted: Date | number | string | null;
      lastUpdatedById: string | null;
      id: string;
      type: EntityType;
      entityId: string;
      personId: string;
      userRoles: Array<UserRole | null> | null;
    }>;
    appSettings: {
      __typename: 'UserApplicationSettings';
      tcsRealtimeTracking: {
        __typename: 'TcsRealtimeTracking';
        tabId: string | null;
        tabDate: Date | number | string | null;
      };
    } | null;
    additionalCompanies: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
  };
  communicationCenters: {
    __typename: 'CommunicationCenterQueries';
    all: {
      __typename: 'CommunicationCenterCollection';
      items: Array<{
        __typename: 'CommunicationCenter';
        states: Array<string | null> | null;
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        includeCompetitors: boolean;
        playAlertForManualPositionReports: boolean;
        enableRAAlert: boolean;
        useCrewPhoneNumber: boolean;
        displayContactTimeline: boolean;
        companyId: string;
        timezoneCd: string | null;
        primaryPhoneNumber: string | null;
        emailAddress: string | null;
        showReferToGmrWarning: boolean | null;
        alertFrequencyForGroundVehicles: number | null;
      }>;
    };
  };
  controlZones: {
    __typename: 'ControlZoneQueries';
    all: {
      __typename: 'ControlZoneCollection';
      items: Array<{
        __typename: 'ControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        name: string;
        companyId: string;
      }>;
    };
  };
  vehicleControlZones: {
    __typename: 'VehicleControlZoneQueries';
    all: {
      __typename: 'VehicleControlZoneCollection';
      items: Array<{
        __typename: 'VehicleControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        companyId: string;
        controlZoneId: string | null;
        vehicleId: string | null;
      }>;
    };
  };
  baseControlZones: {
    __typename: 'BaseControlZoneQueries';
    all: {
      __typename: 'BaseControlZoneCollection';
      items: Array<{
        __typename: 'BaseControlZone';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        controlZoneId: string;
        baseId: string;
        companyId: string;
      }>;
    };
  };
};

export type LocationHazardsComponent_FetchLocationHazardsByLocationIdQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;

export type LocationHazardsComponent_FetchLocationHazardsByLocationIdQuery = {
  __typename: 'Query';
  locationHazards: {
    __typename: 'LocationHazardQueries';
    byLocationId: {
      __typename: 'LocationHazardCollection';
      items: Array<{
        __typename: 'LocationHazard';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        locationId: string;
        hazard: string;
        companyId: string;
        effectiveDate: Date | number | string | null;
        expirationDate: Date | number | string | null;
        locationHazardAttachments: Array<{
          __typename: 'LocationHazardAttachment';
          dateLastUpdated: Date | number | string;
          dateCreated: Date | number | string;
          dateDeleted: Date | number | string | null;
          lastUpdatedById: string | null;
          id: string;
          locationHazardId: string;
          fileName: string;
          companyId: string;
          fileSizeInBytes: number | null;
          contentType: string | null;
        }>;
      }>;
    };
  };
};

export type PollingService_FetchEntitiesQueryVariables = Exact<{
  companyId: InputMaybe<Scalars['ID']>;
  companyIds: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  regionId: InputMaybe<Scalars['ID']>;
  userRoles: InputMaybe<Array<UserRole> | UserRole>;
  includeQuestionnaireResponses?: Scalars['Boolean'];
  includePassdownLogs?: Scalars['Boolean'];
  includeNotifications?: Scalars['Boolean'];
  includeSummaries?: Scalars['Boolean'];
  includeVehiclePositionSummaries?: Scalars['Boolean'];
  vehiclesFetchAfterDate?: InputMaybe<Scalars['DateTime']>;
  unitsFetchAfterDate?: InputMaybe<Scalars['DateTime']>;
  cardsFetchAfterDate?: InputMaybe<Scalars['DateTime']>;
  vehiclePositionSummariesFetchAfterDate?: InputMaybe<Scalars['DateTime']>;
  summariesFetchPolicy?: InputMaybe<FetchPolicy>;
}>;

export type PollingService_FetchEntitiesQuery = {
  __typename: 'Query';
  questionnaireResponses?: {
    __typename: 'QuestionnaireResponseQueries';
    all: {
      __typename: 'QuestionnaireResponseCollection';
      meta: { __typename: 'QuestionnaireResponseCollectionMetadata'; total: number };
    };
  };
  passdownLogs?: {
    __typename: 'PassdownLogQueries';
    all: {
      __typename: 'PassdownLogCollection';
      meta: { __typename: 'PassdownLogCollectionMetadata'; total: number };
    };
  };
  notifications?: {
    __typename: 'NotificationQueries';
    all: {
      __typename: 'NotificationCollection';
      items: Array<{
        __typename: 'Notification';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        lastUpdatedById: string | null;
        id: string;
        status: NotificationStatus;
        body: string;
        companyId: string;
        cardId: string | null;
        subject: string | null;
        sourceTemplateId: string | null;
        entityType: EntityType | null;
        entityId: string | null;
        createdById: string | null;
      }>;
      meta: { __typename: 'NotificationCollectionMetadata'; total: number };
    };
  };
  units?: {
    __typename: 'UnitQueries';
    summaries: {
      __typename: 'UnitSummaryCollection';
      items: Array<{
        __typename: 'UnitSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        name: string;
        abbreviation: string;
        status: UnitStatus;
        weatherStatus: WeatherStatus;
        isExternallyManaged: boolean;
        maximumFlightRule: FlightRule;
        isOnDelay: boolean;
        isEnabled: boolean;
        isSpare: boolean;
        isCrewAvailable: boolean;
        baseId: string;
        regionId: string;
        companyId: string;
        isAdministrative: boolean | null;
        isHidden: boolean | null;
        isThirdPartyUnit: boolean | null;
        etloInMinutes: number | null;
        pilotNotes: string | null;
        lastPilotUpdateTime: Date | number | string | null;
        lastPilotUpdateById: string | null;
        plannedAvailableNotes: string | null;
        plannedAvailableTime: Date | number | string | null;
        lastPilotUpdateName: string | null;
        baseTimezoneCd: string | null;
        vehicleSummaryId: string | null;
        vehicleId: string | null;
        communicationCenterId: string | null;
        shifts: Array<{
          __typename: 'UnitShiftSummary';
          id: string;
          name: string;
          startTimeInMinutes: number;
          endTimeInMinutes: number;
        }>;
        outOfServiceEvents: Array<{
          __typename: 'OutOfServiceEventSummary';
          id: string;
          type: OutOfServiceType;
          eventNumber: string;
          estimatedEndTime: Date | number | string;
          reasonName: string;
          reasonId: string;
          startTime: Date | number | string | null;
          isOpportunisticOOS: boolean | null;
          notes: string | null;
        }>;
        positions: Array<{
          __typename: 'UnitPositionSummary';
          id: string;
          name: string;
          type: UnitPositionType;
          isFlightCrew: boolean;
          isNonEmployee: boolean;
          isNonCompliant: boolean;
          notificationAddress: string | null;
          teamMemberId: string | null;
          teamMemberFirstName: string | null;
          teamMemberLastName: string | null;
          nonComplianceReason: string | null;
        }>;
        paipEventIds: Array<{ __typename: 'IdListItem'; id: string } | null> | null;
      }>;
      meta: { __typename: 'UnitSummaryCollectionMetadata'; total: number };
    };
  };
  vehicles?: {
    __typename: 'VehicleQueries';
    summaries: {
      __typename: 'VehicleSummaryCollection';
      items: Array<{
        __typename: 'VehicleSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        type: VehicleType;
        registrationNumber: string;
        unitSummaryId: string;
        regionId: string;
        status: VehicleStatus;
        statusDescription: string;
        vehicleDispositionId: string;
        unitId: string;
        companyId: string;
        serialNumber: string | null;
        dispatchCompanyId: string | null;
        makeName: string | null;
        modelName: string | null;
        etlo: Date | number | string | null;
        eta: Date | number | string | null;
        currentCardNumber: string | null;
        currentCardSummaryId: string | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        currentOrNextLegSequence: number | null;
        totalLegCount: number | null;
        dateOnFinalMarked: Date | number | string | null;
        communicationCenterId: string | null;
        currentCardId: string | null;
        from: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        to: {
          __typename: 'WaypointSummary';
          id: string;
          name: string;
          abbreviation: string;
          type: WaypointType;
        } | null;
        latestPositionReportSummary: {
          __typename: 'PositionReportSummary';
          id: string;
          positionTime: Date | number | string;
          source: PositionReportSource;
        } | null;
        lastKnownCoordinates: {
          __typename: 'Coordinates';
          latitude: number | null;
          longitude: number | null;
        } | null;
      }>;
      meta: { __typename: 'VehicleSummaryCollectionMetadata'; total: number };
    };
  };
  cards?: {
    __typename: 'CardQueries';
    summaries: {
      __typename: 'CardSummaryCollection';
      items: Array<{
        __typename: 'CardSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        status: CardStatus;
        cardNumber: string;
        operationType: OperationType;
        regionId: string;
        companyId: string;
        dateContactCompleted: Date | number | string | null;
        apiWebhookSubscriptionId: string | null;
        webOrderAcknowledgedTime: Date | number | string | null;
        diversionType: DiversionType | null;
        gmrUtilizationStatus: AmrUtilizationStatus | null;
        gmrCADNumber: string | null;
        vehicleId: string | null;
        vehicleSummaryId: string | null;
        communicationCenterId: string | null;
        unitId: string | null;
        unitSummaryId: string | null;
        operation: {
          __typename: 'OperationSummary';
          id: string;
          status: OperationStatus;
          unitId: string | null;
          vehicleId: string | null;
          riskAnalysisNumber: string | null;
          riskAnalysisAcknowledged: boolean | null;
          tripId: string | null;
        } | null;
        request: {
          __typename: 'RequestSummary';
          id: string;
          status: RequestStatus;
          isStandbyRequest: boolean;
          isSisterCompanyReferral: boolean;
          standbyActivationRequested: boolean;
          assignmentDelayedReason: string | null;
          transportTrackingLink: string | null;
          latestWeatherDeclineUnitId: string | null;
          latestWeatherDeclineTime: Date | number | string | null;
          latestWeatherDeclineReasonId: string | null;
          latestWeatherDeclineSecondaryReasonId: string | null;
          assignmentDelayedTime: Date | number | string | null;
          requester: {
            __typename: 'RequesterSummary';
            id: string;
            missionRole: MissionRoleType;
            vetNumber: string | null;
          } | null;
          from: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
          to: {
            __typename: 'RequestLocationSummary';
            id: string;
            name: string;
            abbreviation: string;
            type: WaypointType;
            address: {
              __typename: 'Address';
              streetAddress: string | null;
              city: string | null;
              region: string | null;
              postalCode: string | null;
              country: string | null;
              county: string | null;
              gpsId: string | null;
              coordinates: {
                __typename: 'Coordinates';
                latitude: number | null;
                longitude: number | null;
              } | null;
            } | null;
          } | null;
        } | null;
        patients: Array<{
          __typename: 'RequestPatientSummary';
          id: string;
          dateOfBirth: Date | number | string | null;
          weightInKg: number | null;
          dateCreated: Date | number | string | null;
        } | null> | null;
      }>;
      meta: { __typename: 'CardSummaryCollectionMetadata'; total: number };
    };
  };
  vehiclePositionSummary?: {
    __typename: 'vehcilePositionSummaryQueries';
    all: {
      __typename: 'VehiclePositionSummaryCollection';
      items: Array<{
        __typename: 'VehiclePositionSummary';
        dateLastUpdated: Date | number | string;
        dateCreated: Date | number | string;
        dateDeleted: Date | number | string | null;
        id: string;
        vehicleId: string;
        latitude: number;
        longitude: number;
        positionSource: PositionReportSource;
        positionTime: Date | number | string;
        companyId: string;
        lastPositionReportId: string | null;
        lastQualifyingPositionReportTime: Date | number | string | null;
        etlo: Date | number | string | null;
        lastGpsAutoPositionTime: Date | number | string | null;
        lastTakeOffTime: Date | number | string | null;
        lastLandedTime: Date | number | string | null;
        gpsProvider: GpsProvider | null;
        altitude: number | null;
        speedInKnots: number | null;
        heading: number | null;
      }>;
    };
  };
};

export const UnitFieldsFragmentDoc = gql`
  fragment UnitFields on Unit {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    status
    weatherStatus
    baseId
    regionId
    isExternallyManaged
    maximumFlightRule
    isOnDelay
    isEnabled
    isSpare
    integrations
    isCrewAvailable
    updatePhoneNumbersFromExternal
    companyId
    isAdministrative
    vehicleId
    isHidden
    isThirdPartyUnit
    etloInMinutes
    pilotNotes
    lastPilotUpdateTime
    lastPilotUpdateById
    plannedAvailableNotes
    plannedAvailableTime
    oemPlacardNumber
    primaryOutOfServiceEventId
    emSystemResourceId
    onBaseETAInMinutes
    crewSourcedFromUnitId
    completeFlightInstanceId
    parentUnitId
    crewSourcedToUnits {
      id
      unitPositions {
        id
      }
    }
  }
`;
export const UnitPositionFieldsFragmentDoc = gql`
  fragment UnitPositionFields on UnitPosition {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    type
    isFlightCrew
    isNonEmployee
    unitId
    companyId
    notificationAddress
    teamMemberId
    firstName
    lastName
  }
`;
export const PersonFieldsFragmentDoc = gql`
  fragment PersonFields on Person {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    firstName
    lastName
    email
    employeeType
    timeType
    activateOktaAccount
    grantTcsAccess
    isOutOfFlightCompliance
    companyId
    title
    employeeId
    hireDate
    terminationDate
    departmentId
    reportsToPersonId
    baseId
    locationId
    programId
    activeDirectoryId
    notificationAddress
    userRoles
    allCompaniesAccessible
    allBasesAccessible
    allTrmProgramsAccessible
    allCommunicationCentersAccessible
    faaCompanyId
    dispatchCompanyId
    aviationCompanyId
    primaryCommunicationCenterId
    outOfFlightComplianceComment
    dateLastUpdatedFromGMRWorkday
    appSettings {
      tcsRealtimeTracking {
        tabId
        tabDate
      }
    }
    additionalCompanies {
      id
    }
  }
`;
export const UnitShiftFieldsFragmentDoc = gql`
  fragment UnitShiftFields on UnitShift {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    startTimeInMinutes
    endTimeInMinutes
    unitId
    companyId
  }
`;
export const VehicleFieldsFragmentDoc = gql`
  fragment VehicleFields on Vehicle {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    type
    registrationNumber
    isUnderLease
    role
    flightLogProcess
    isPlaceholder
    stateInspectionRequired
    isRetired
    isPositionTrackingEnabled
    hideFromOOSRUM
    companyId
    serialNumber
    dispatchCompanyId
    year
    dateAcquired
    makeId
    modelId
    cruiseSpeed
    configurationClassId
    isThirdPartyVehicle
    parentUnitId
    isHidden
    faaCompanyId
    skytracIMEI
    phoneNumber
    completeFlightId
    controlZoneId
    communicationCenterId
    regionId
    vehicleDescription
  }
`;
export const VehicleDispositionFieldsFragmentDoc = gql`
  fragment VehicleDispositionFields on VehicleDisposition {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    vehicleId
    status
    companyId
    currentWaypointId
    currentTripLegId
    currentTripId
    lastTripId
    currentAgencyLocationId
    notes
    isAssetOutOfService
    lastQualifyingPositionReportTime
    latitude
    longitude
    etlo
    statusDescription
    positionTime
    positionSource
    vehiclePositionSummaryId
    latestPositionReportId
    latestFlightFollowingReportId
    from {
      id
      name
      abbreviation
      type
    }
    to {
      id
      name
      abbreviation
      type
    }
  }
`;
export const VehicleModelFieldsFragmentDoc = gql`
  fragment VehicleModelFields on VehicleModel {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    cruiseSpeedInMph
  }
`;
export const VehicleStateInspectionFieldsFragmentDoc = gql`
  fragment VehicleStateInspectionFields on VehicleStateInspection {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    stateAbbrevation
    inspectionDate
    vehicleId
    companyId
  }
`;
export const UnitContextFragmentDoc = gql`
  fragment UnitContext on Unit {
    ...UnitFields
    excludeStates
    positions {
      ...UnitPositionFields
      teamMember {
        ...PersonFields
      }
    }
    shifts {
      ...UnitShiftFields
    }
    vehicle {
      ...VehicleFields
      vehicleDispositions {
        ...VehicleDispositionFields
      }
      model {
        ...VehicleModelFields
      }
      vehicleStateInspections {
        ...VehicleStateInspectionFields
      }
    }
  }
  ${UnitFieldsFragmentDoc}
  ${UnitPositionFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${UnitShiftFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${VehicleModelFieldsFragmentDoc}
  ${VehicleStateInspectionFieldsFragmentDoc}
`;
export const AddressFieldsFragmentDoc = gql`
  fragment AddressFields on Address {
    streetAddress
    city
    region
    postalCode
    country
    county
    gpsId
    coordinates {
      latitude
      longitude
    }
  }
`;
export const CardLocationInfoLocationFieldsFragmentDoc = gql`
  fragment CardLocationInfoLocationFields on Location {
    id
    locationType
    name
    abbreviation
    notes
    address {
      ...AddressFields
    }
    locationHazards {
      id
      hazard
    }
  }
  ${AddressFieldsFragmentDoc}
`;
export const AuditLogFieldsFragmentDoc = gql`
  fragment AuditLogFields on AuditLog {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    eventCategory
    commandName
    success
    occurredAt
    userId
    userEmail
    apiKeyId
    impersonatedBy
    activityId
    errorMessage
    sourceSystem
    ipAddress
    entityChanges {
      id
      entityType
      entityId
      changeType
      properties {
        name
        dataTypeName
        previous
        current
      }
    }
  }
`;
export const ActivationRuleFieldsFragmentDoc = gql`
  fragment ActivationRuleFields on ActivationRule {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    isShared
    companyId
    regionId
    baseId
    unitId
    vehicleId
    specialtyTeamId
    vehicleTypes
    medicalFacilityId
    locationId
    operationTypes
    timestampTypeId
    systemTimestampType
    outOfServiceReasonId
    paipReasonId
    outOfServiceType
    automatedAlertAlgorithmType
    ageInMinutes
    waypointTypes
    missionRoleTypes
    address {
      streetAddress
      city
      region
      postalCode
      country
      county
      gpsId
      coordinates {
        latitude
        longitude
      }
    }
    declineReasons {
      id
    }
    communicationCenters {
      id
    }
    companies {
      id
    }
  }
`;
export const ActiveAlertAcknowledgementFieldsFragmentDoc = gql`
  fragment ActiveAlertAcknowledgementFields on ActiveAlertAcknowledgement {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    activeAlertId
    dateAcknowledged
    acknowledgedById
    companyId
  }
`;
export const ActiveAlertFieldsFragmentDoc = gql`
  fragment ActiveAlertFields on ActiveAlert {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    urgency
    content
    lifecycleStage
    requiresAcknowledgement
    matchType
    visibilityType
    isGpsAlert
    isActive
    isAudible
    isAcknowledgementRepeatable
    companyId
    target
    targetId
    entityType
    entityId
    title
    definitionId
    dateAcknowledged
    acknowledgedById
    parentEntityType
    parentEntityId
    activationTime
    escalationDurationInSeconds
    snoozeMaxInSeconds
    authorId
    regionId
    communicationCenterId
    lookupHash
    referenceEntityType
    referenceEntityId
  }
`;
export const ActiveCardUnitOfferingFieldsFragmentDoc = gql`
  fragment ActiveCardUnitOfferingFields on ActiveCardUnitOffering {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    cardId
    unitId
    companyId
  }
`;
export const ActiveTimelineFieldsFragmentDoc = gql`
  fragment ActiveTimelineFields on ActiveTimeline {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    timelineId
    companyId
    matchType
    entityType
    entityId
  }
`;
export const AlertFieldsFragmentDoc = gql`
  fragment AlertFields on Alert {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    entityType
    activationRuleId
    urgency
    content
    lifecycleStage
    requiresAcknowledgement
    isAudible
    title
    effectiveDate
    expirationDate
    paused
    createdById
  }
`;
export const ApplicationNotificationFieldsFragmentDoc = gql`
  fragment ApplicationNotificationFields on ApplicationNotification {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    urgency
    displayOnBanner
    dismissable
    notification
    title
    effectiveDate
    expirationDate
    createdById
    companyId
    regionId
  }
`;
export const AssignmentDelayedReasonFieldsFragmentDoc = gql`
  fragment AssignmentDelayedReasonFields on AssignmentDelayedReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const CancellationCategoryFieldsFragmentDoc = gql`
  fragment CancellationCategoryFields on CancellationCategory {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    isVisibleInOps
    defaultCancellationReasonId
  }
`;
export const CancellationReasonFieldsFragmentDoc = gql`
  fragment CancellationReasonFields on CancellationReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    isTransferCenterReason
    secondaryReasonRequired
    canBeUnitCancellationReason
    cancellationCategoryId
  }
`;
export const CancellationSecondaryReasonFieldsFragmentDoc = gql`
  fragment CancellationSecondaryReasonFields on CancellationSecondaryReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    cancellationReasonId
  }
`;
export const CardFieldsFragmentDoc = gql`
  fragment CardFields on Card {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    cardNumber
    companyId
    dateContactCompleted
    dateCardClosed
    transferredToCardId
    transferredFromCardId
    linkedCardId
    closeComment
    reOpenComment
    postTransportDebriefCompleted
    isBillable
    notBillableType
    notBillableComment
    apiWebhookSubscriptionId
    createdById
    plannedCompletionTime
    reOpenReasonId
    lastOperationId
    diversionType
    gmrUtilizationStatus
    gmrCADNumber
    isLocked
    crewWillTransportWithReplacementGroundUnit
    operationId
    requestId
  }
`;
export const CardLinkFieldsFragmentDoc = gql`
  fragment CardLinkFields on CardLink {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    type
    fromCardId
    toCardId
    toCardNumber
    companyId
    rendezvousRequestId
  }
`;
export const CardNoteArchiveFieldsFragmentDoc = gql`
  fragment CardNoteArchiveFields on CardNoteArchive {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    content
    noteTime
    isInternal
    isSystem
    dateArchived
    cardId
    companyId
    authorId
    noteCategory
    noteMetadataJson
    receivedFromCardId
    sentToCards {
      id
    }
  }
`;
export const CardNoteFieldsFragmentDoc = gql`
  fragment CardNoteFields on CardNote {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    content
    noteTime
    isInternal
    isSystem
    cardId
    companyId
    authorId
    noteCategory
    noteMetadataJson
    receivedFromCardId
    sentToCards {
      id
    }
  }
`;
export const CardReOpenReasonFieldsFragmentDoc = gql`
  fragment CardReOpenReasonFields on CardReOpenReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    affectsTrip
  }
`;
export const CardSummaryFieldsFragmentDoc = gql`
  fragment CardSummaryFields on CardSummary {
    dateLastUpdated
    dateCreated
    dateDeleted
    id
    status
    cardNumber
    operationType
    regionId
    companyId
    dateContactCompleted
    apiWebhookSubscriptionId
    webOrderAcknowledgedTime
    diversionType
    gmrUtilizationStatus
    gmrCADNumber
    vehicleId
    vehicleSummaryId
    communicationCenterId
    unitId
    unitSummaryId
    operation {
      id
      status
      unitId
      vehicleId
      riskAnalysisNumber
      riskAnalysisAcknowledged
      tripId
    }
    request {
      id
      status
      isStandbyRequest
      isSisterCompanyReferral
      standbyActivationRequested
      assignmentDelayedReason
      transportTrackingLink
      latestWeatherDeclineUnitId
      latestWeatherDeclineTime
      latestWeatherDeclineReasonId
      latestWeatherDeclineSecondaryReasonId
      assignmentDelayedTime
      requester {
        id
        missionRole
        vetNumber
      }
      from {
        id
        name
        abbreviation
        type
        address {
          streetAddress
          city
          region
          postalCode
          country
          county
          gpsId
          coordinates {
            latitude
            longitude
          }
        }
      }
      to {
        id
        name
        abbreviation
        type
        address {
          streetAddress
          city
          region
          postalCode
          country
          county
          gpsId
          coordinates {
            latitude
            longitude
          }
        }
      }
    }
    patients {
      id
      dateOfBirth
      weightInKg
      dateCreated
    }
  }
`;
export const ConfigurationSettingFieldsFragmentDoc = gql`
  fragment ConfigurationSettingFields on ConfigurationSetting {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    companyId
    defaultUnitCommittedDeclineReasonId
    defaultUnitOutOfServiceDeclineReasonId
    requestReferredInternallyCancellationReasonId
    requestReferredExternallyCancellationReasonId
    crewGoingByGroundOutOfServiceReasonId
    assetReassignedDeclineReasonId
    externallyCancelledCancellationReasonId
    pilotReportGracePeriodInMinutes
    sameDestinationWarningThresholdInMinutes
    bugRequestEmail
    featureRequestEmail
    proximityAlertDistanceInNauticalMiles
  }
`;
export const ConversationFieldsFragmentDoc = gql`
  fragment ConversationFields on Conversation {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    uniqueName
    vendorConversationId
    conversationState
    entityId
    entityType
    metadata {
      name
    }
  }
`;
export const ConversationParticipantFieldsFragmentDoc = gql`
  fragment ConversationParticipantFields on ConversationParticipant {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    conversationId
    messagingAddress
    vendorParticipantId
    metadata {
      role
    }
  }
`;
export const DeclineCategoryFieldsFragmentDoc = gql`
  fragment DeclineCategoryFields on DeclineCategory {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    isVisibleInOps
    defaultDeclineReasonId
  }
`;
export const DeclineReasonFieldsFragmentDoc = gql`
  fragment DeclineReasonFields on DeclineReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    declineCategoryId
    controllable
    canBeSkipReason
    canBeAbortReason
    canBeBulkSkipReason
    canBeOneCallSkipReason
    isUnitAvailableAfterAbort
    secondaryReasonRequired
    cancellationReasonId
    cancellationSecondaryReasonId
  }
`;
export const DeclineSecondaryReasonFieldsFragmentDoc = gql`
  fragment DeclineSecondaryReasonFields on DeclineSecondaryReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    declineReasonId
    cancellationReasonId
    cancellationSecondaryReasonId
  }
`;
export const DiversionReasonFieldsFragmentDoc = gql`
  fragment DiversionReasonFields on DiversionReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const EscortRequestFieldsFragmentDoc = gql`
  fragment EscortRequestFields on EscortRequest {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    escortName
    relationship
    escortWeightInKg
    requestApprovalTime
    requestId
    companyId
  }
`;
export const EstimatedDurationFieldsFragmentDoc = gql`
  fragment EstimatedDurationFields on EstimatedDuration {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    asOfTime
    durationInMinutes
    isOfficial
    estimateSource
    durationType
    ownerId
    tripId
    companyId
    positionReportId
  }
`;
export const EtaFieldsFragmentDoc = gql`
  fragment EtaFields on Eta {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    asOfTime
    estimatedArrivalTime
    calculatedArrivalTime
    currentTripId
    waypointId
    companyId
  }
`;
export const ExternalActionFieldsFragmentDoc = gql`
  fragment ExternalActionFields on ExternalAction {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    entityId
    status
    entityType
    actionTypeId
    actionBodyJson
    companyId
    completedById
    dateCompleted
    notes
  }
`;
export const ExternalActionTypeFieldsFragmentDoc = gql`
  fragment ExternalActionTypeFields on ExternalActionType {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    actionTypeName
    actionTypeDescription
    priority
  }
`;
export const ExternalSystemUnitFieldsFragmentDoc = gql`
  fragment ExternalSystemUnitFields on ExternalSystemUnit {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    unitId
    vehicleId
    regionId
    companyId
    unitStatus
    vehicleType
    registrationNumber
    vehicleStatus
    vehicleStatusDescription
    currentCardNumber
    lastKnownLocationName
    lastQualifyingPositionReportTime
    baseId
    modelName
    outOfServiceEvents {
      id
      type
      eventNumber
      estimatedEndTime
      reasonName
      reasonId
      startTime
      isOpportunisticOOS
      notes
    }
    lastKnownCoordinates {
      latitude
      longitude
    }
  }
`;
export const FacilityNonAcceptanceReasonFieldsFragmentDoc = gql`
  fragment FacilityNonAcceptanceReasonFields on FacilityNonAcceptanceReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    facilityNonAcceptanceReasonType
  }
`;
export const FirewallRuleFieldsFragmentDoc = gql`
  fragment FirewallRuleFields on FirewallRule {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    action
    ipRange
    enabled
    companyId
  }
`;
export const FlightFollowingReportFieldsFragmentDoc = gql`
  fragment FlightFollowingReportFields on FlightFollowingReport {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    tripId
    companyId
    summary
    fuel
    estimatedTimeEnrouteMinutes
    riskAnalysis
    flightType
    soulsOnBoard
    highestFeatureEnroute
    takeOffWeight
    centerOfGravity
    destination
    trackingViaGps
    flightRule
    tripLegId
    confirmedFboId
    cruisingAltitude
    medicalCrewRA
  }
`;
export const LandingZoneOutOfServiceReasonFieldsFragmentDoc = gql`
  fragment LandingZoneOutOfServiceReasonFields on LandingZoneOutOfServiceReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const LocationHazardAttachmentFieldsFragmentDoc = gql`
  fragment LocationHazardAttachmentFields on LocationHazardAttachment {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    locationHazardId
    fileName
    companyId
    fileSizeInBytes
    contentType
  }
`;
export const LocationHazardFieldsFragmentDoc = gql`
  fragment LocationHazardFields on LocationHazard {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    locationId
    hazard
    companyId
    effectiveDate
    expirationDate
  }
`;
export const ManifestEntryFieldsFragmentDoc = gql`
  fragment ManifestEntryFields on ManifestEntry {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    passengerId
    tripLegId
    companyId
    confirmedAt
    confirmedById
  }
`;
export const MedicalControlContactLogEntryFieldsFragmentDoc = gql`
  fragment MedicalControlContactLogEntryFields on MedicalControlContactLogEntry {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    cardId
    timestampId
    personId
    isSuccessful
    companyId
  }
`;
export const MessageStatusUpdateFieldsFragmentDoc = gql`
  fragment MessageStatusUpdateFields on MessageStatusUpdate {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    trackedMessageId
    error
    vendorMessage
    metadataJson
  }
`;
export const NewAgencyLocationRequestFieldsFragmentDoc = gql`
  fragment NewAgencyLocationRequestFields on NewAgencyLocationRequest {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    phoneNumber
    name
    requestedByPersonId
    entityType
    type
    entityId
  }
`;
export const NextDueTypeFieldsFragmentDoc = gql`
  fragment NextDueTypeFields on NextDueType {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    dataType
  }
`;
export const NonReferralReasonFieldsFragmentDoc = gql`
  fragment NonReferralReasonFields on NonReferralReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    associatedCancellationReasonId
    associatedCancellationSecondaryReasonId
  }
`;
export const NotificationFieldsFragmentDoc = gql`
  fragment NotificationFields on Notification {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    body
    companyId
    cardId
    subject
    sourceTemplateId
    entityType
    entityId
    createdById
  }
`;
export const NotificationGroupFieldsFragmentDoc = gql`
  fragment NotificationGroupFields on NotificationGroup {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    companyId
    unitId
    regionId
    type
    types
    isEmailNotificationPreferred
  }
`;
export const NotificationGroupMemberFieldsFragmentDoc = gql`
  fragment NotificationGroupMemberFields on NotificationGroupMember {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    notificationGroupId
    companyId
    userId
    notificationAddress
  }
`;
export const NotificationRecipientFieldsFragmentDoc = gql`
  fragment NotificationRecipientFields on NotificationRecipient {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    notificationId
    companyId
    name
    notificationAddress
    userId
    messageId
    messageStatus
  }
`;
export const NotificationSubscriptionFieldsFragmentDoc = gql`
  fragment NotificationSubscriptionFields on NotificationSubscription {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    unitId
    notificationGroupId
    companyId
  }
`;
export const NotificationTemplateFieldsFragmentDoc = gql`
  fragment NotificationTemplateFields on NotificationTemplate {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    contextType
    bodyTemplate
    canBeManualTrigger
    companyId
    triggerType
    triggerValue
    activationRuleId
    recipientTypes
    subjectTemplate
    requiresApproval
    groupTypes
    createdById
  }
`;
export const OemActivityFieldsFragmentDoc = gql`
  fragment OemActivityFields on OemActivity {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    oemPlanId
    activityType
    time
    authorId
    content
    priorStatus
    currentStatus
    oemPlanChangeRequestId
  }
`;
export const OemAssetFieldsFragmentDoc = gql`
  fragment OemAssetFields on OemAsset {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    oemPlanId
    assetId
    assetType
    status
    assetDispatchCompanyId
    originalUnitId
    oemUnitId
    requestedPlacardNumber
    requestedUnitName
    requestedUnitAbbreviation
    requestedBaseId
  }
`;
export const OemPlanChangeRequestFieldsFragmentDoc = gql`
  fragment OemPlanChangeRequestFields on OemPlanChangeRequest {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    oemPlanId
    oemAssetId
    status
    originalAssetStatus
    requestedAssetStatus
    requestedById
    dateRequested
    dateCompleted
    dateCancelled
    notes
  }
`;
export const OemPlanFieldsFragmentDoc = gql`
  fragment OemPlanFields on OemPlan {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    companyId
    oemCompanyId
    outOfServiceReasonId
    defaultBaseId
    planStatus
    planYear
    description
  }
`;
export const OfferAlgorithmFieldsFragmentDoc = gql`
  fragment OfferAlgorithmFields on OfferAlgorithm {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    includeCompetitors
    oneCallAgreement
    rank
    transportOfferAlgorithm
    distanceCalculation
    activationRuleId
    companyId
    isEnabled
    minimumFlightRule
    createdById
    preferredUnits {
      id
      unitAbbreviation
      rank
      type
    }
    companies {
      id
    }
  }
`;
export const OperationFieldsFragmentDoc = gql`
  fragment OperationFields on Operation {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    type
    vehicleId
    dateOperationStarted
    riskAnalysisAcknowledged
    companyId
    unitId
    dateOperationEnded
    unitActivationTime
    riskAnalysisNumber
    standbyActivationType
    caller
    callbackNumber
    initialOperationType
  }
`;
export const OutOfServiceEventFieldsFragmentDoc = gql`
  fragment OutOfServiceEventFields on OutOfServiceEvent {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    type
    eventNumber
    estimatedEndTime
    reasonId
    isAirworthy
    initialEstimatedEndTime
    alertWhenEventEnds
    isPlanned
    isBirdStrike
    isPatientOnboard
    waitingForParts
    waitingForTooling
    isAcknowledgementRequired
    companyId
    startTime
    isOpportunisticOOS
    unitId
    vehicleId
    secondaryReasonId
    scheduledStartTime
    endTime
    notes
    linkedCardId
    createdById
    endedById
    secondaryReasonComment
    parentOutOfServiceEventId
    paipEventId
    copiedFromId
    alertTimeInMinutes
    outOfServiceTicketId
    maintenanceTypes
    opportunityMXTypes
    rtsDelayReasonTypes
    maintenanceLocation
    mxDuringPeakTimeReason
    assignedBaseId
    amtPointOfContactId
    alternatePOC
    spareVehicleId
    ticketDescription
    humanErrorDamageType
    businessUnitCompanyId
    isAMTAvailable
    isFAR135415Reportable
    isFAR135417Reportable
    dateAcknowledged
    acknowledgedById
    acknowledgementNotes
    maintenanceFacilityId
    locationId
    oosRequestType
    isEventAlreadyClosed
    qarReasons {
      id
    }
    address {
      streetAddress
      city
      region
      postalCode
      country
      county
      gpsId
      coordinates {
        latitude
        longitude
      }
    }
    crew {
      id
      personId
      unitPositionId
      isFlightCrew
      positionType
      unitPositionRole
      endDate
      notificationAddress
    }
  }
`;
export const OutOfServiceEventNoteFieldsFragmentDoc = gql`
  fragment OutOfServiceEventNoteFields on OutOfServiceEventNote {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    outOfServiceEventId
    content
    noteTime
    isSystem
    companyId
    authorId
    noteCategory
    noteMetadataJson
  }
`;
export const OutOfServiceReasonFieldsFragmentDoc = gql`
  fragment OutOfServiceReasonFields on OutOfServiceReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    controllable
    isVehicleReason
    description
  }
`;
export const OutOfServiceSecondaryReasonFieldsFragmentDoc = gql`
  fragment OutOfServiceSecondaryReasonFields on OutOfServiceSecondaryReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    outOfServiceReasonId
  }
`;
export const OutOfServiceTicketFieldsFragmentDoc = gql`
  fragment OutOfServiceTicketFields on OutOfServiceTicket {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    isPlanned
    maintenanceTypes
    vehicleId
    outOfServiceTime
    ertsDateTime
    submittedById
    ticketDescription
    isBirdStrike
    isPatientOnboard
    waitingForParts
    waitingForTooling
    status
    companyId
    ticketNumber
    businessUnitCompanyId
    assignedBaseId
    maintenanceLocation
    dateSubmittedForReview
    pointOfContactId
    alternatePOC
    spareVehicleId
    opportunityMXTypes
    mxDuringPeakTimeReason
    waitingForPartsTimestamp
    waitingForToolingTimestamp
    isAMTAvailable
    isFAR135415Reportable
    isFAR135417Reportable
    acceptedById
    dateAccepted
    humanErrorDamageType
    rtsDelayReasonTypes
    pageoutCompletedById
    datePageoutCompleted
    primaryReasonId
    secondaryReasonId
    outOfServiceType
    dateAcknowledged
    acknowledgedById
    acknowledgementNotes
    maintenanceFacilityId
    locationId
    isOpportunisticOOS
    qarReasons {
      id
    }
    address {
      streetAddress
      city
      region
      postalCode
      country
      county
      gpsId
      coordinates {
        latitude
        longitude
      }
    }
  }
`;
export const PaipEventFieldsFragmentDoc = gql`
  fragment PaipEventFields on PaipEvent {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    reasonId
    startTime
    companyId
    regionId
    eventNumber
    endTime
    notes
    unitIds {
      id
    }
    cardIds {
      id
    }
  }
`;
export const PaipReasonFieldsFragmentDoc = gql`
  fragment PaipReasonFields on PaipReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    outOfServiceReasonId
  }
`;
export const PassdownLogAcknowledgementFieldsFragmentDoc = gql`
  fragment PassdownLogAcknowledgementFields on PassdownLogAcknowledgement {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    passdownLogId
    dateAcknowledged
    acknowledgedById
    companyId
  }
`;
export const PassdownLogArchivedLogFieldsFragmentDoc = gql`
  fragment PassdownLogArchivedLogFields on PassdownLogArchivedLog {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    passdownLogId
    archivedById
    dateArchived
    companyId
  }
`;
export const PassdownLogFieldsFragmentDoc = gql`
  fragment PassdownLogFields on PassdownLog {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    regionId
    logDate
    body
    requiresAcknowledgement
    companyId
    dateAcknowledged
    acknowledgedById
    authorId
  }
`;
export const PatientFieldsFragmentDoc = gql`
  fragment PatientFields on Patient {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    gender
    companyId
    firstName
    lastName
    dateOfBirth
  }
`;
export const PositionReportAlertFieldsFragmentDoc = gql`
  fragment PositionReportAlertFields on PositionReportAlert {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    vehicleId
    hasReceivedQualifyingReport
    companyId
  }
`;
export const PositionReportArchiveFieldsFragmentDoc = gql`
  fragment PositionReportArchiveFields on PositionReportArchive {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    positionTime
    source
    dateArchived
    tripId
    companyId
    altitude
    speedInKnots
    heading
    estimatedMinutesEnRoute
    fuelRemaining
    timezoneCd
    dateConfirmed
    coordinates {
      latitude
      longitude
    }
  }
`;
export const PositionReportFieldsFragmentDoc = gql`
  fragment PositionReportFields on PositionReport {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    positionTime
    source
    tripId
    companyId
    altitude
    speedInKnots
    heading
    estimatedMinutesEnRoute
    fuelRemaining
    timezoneCd
    dateConfirmed
    gpsProvider
    coordinates {
      latitude
      longitude
    }
  }
`;
export const QuestionChoiceFieldsFragmentDoc = gql`
  fragment QuestionChoiceFields on QuestionChoice {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    label
    value
    questionId
  }
`;
export const QuestionFieldsFragmentDoc = gql`
  fragment QuestionFields on Question {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    question
    questionType
    dataType
  }
`;
export const QuestionnaireFieldsFragmentDoc = gql`
  fragment QuestionnaireFields on Questionnaire {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    companyId
    type
    communicationCenterId
  }
`;
export const QuestionnaireQuestionResponseFieldsFragmentDoc = gql`
  fragment QuestionnaireQuestionResponseFields on QuestionnaireQuestionResponse {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    questionnaireResponseId
    questionnaireSectionQuestionId
    matchType
    reviewRequired
    companyId
    responseValue
    explanation
  }
`;
export const QuestionnaireQuestionResponseNoteFieldsFragmentDoc = gql`
  fragment QuestionnaireQuestionResponseNoteFields on QuestionnaireQuestionResponseNote {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    questionnaireQuestionResponseId
    authorId
    dateAuthored
    note
    companyId
  }
`;
export const QuestionnaireResponseFieldsFragmentDoc = gql`
  fragment QuestionnaireResponseFields on QuestionnaireResponse {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    questionnaireId
    companyId
    cardId
    currentReviewLevel
    completedById
    dateCompleted
    communicationsReviewById
    dateCommunicationsReviewed
    supervisorReviewById
    dateSupervisorReviewed
    managerReviewById
    dateManagerReviewed
  }
`;
export const QuestionnaireSectionFieldsFragmentDoc = gql`
  fragment QuestionnaireSectionFields on QuestionnaireSection {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    questionnaireId
    sequence
  }
`;
export const QuestionnaireSectionQuestionFieldsFragmentDoc = gql`
  fragment QuestionnaireSectionQuestionFields on QuestionnaireSectionQuestion {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    questionnaireSectionId
    questionId
    responsibleRole
    sequence
    isDisabled
    activationRuleId
    activityType
    explanationRequiredChoices {
      id
    }
    reviewRequiredChoices {
      id
    }
  }
`;
export const ReceivingFacilityRequestFieldsFragmentDoc = gql`
  fragment ReceivingFacilityRequestFields on ReceivingFacilityRequest {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    cardId
    requestId
    medicalFacilityId
    requestLocationId
    companyId
    nonAcceptanceType
    nonAcceptanceReasonId
    referredToFacilityId
  }
`;
export const RendezvousRequestFieldsFragmentDoc = gql`
  fragment RendezvousRequestFields on RendezvousRequest {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    type
    utilizationStatus
    requestLocationId
    companyId
    agencyLocationId
    agencyEta
    rendezvousLocationDescription
    contactInformation
    confirmedAt
    departedLzAt
    arrivedDestAt
    departedDestAt
    arrivedLzAt
    cancelledAt
    notes
    transportUnitNumber
    latestStatus
    latestStatusTimestamp
  }
`;
export const RequestFieldsFragmentDoc = gql`
  fragment RequestFields on Request {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    requestedOperationType
    isStandbyRequest
    standbyActivationRequested
    missionConfiguration
    missionProfile
    companyId
    cancellationReasonId
    cancellationSecondaryReasonId
    cancellationReasonNotes
    requestedVehicleType
    primaryUnitServiceAreaId
    commitUnitToStandby
    initiationType
    assignmentDelayedTime
    assignmentDelayedReasonId
    regionId
    includeCompetitors
    transportOfferAlgorithmId
    transportOfferAlgorithm
    minimumFlightRule
    transportTrackingLink
    latestWeatherDeclineUnitId
    latestWeatherDeclineTime
    latestWeatherDeclineReasonId
    latestWeatherDeclineSecondaryReasonId
    webOrderCallType
    etloInMinutes
    atloInMinutes
    safetyQuestions {
      otherServiceDeclined
      otherServiceDescription
      otherServicesAreRespondingToTransferring
      otherServiceResponseDescription
    }
    requiredCapabilities {
      id
    }
  }
`;
export const RequesterFieldsFragmentDoc = gql`
  fragment RequesterFields on Requester {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    companyId
    affiliationType
    caller
    roleId
    missionRole
    callbackNumber
    email
    facilityId
    agencyLocationId
    isNewAgencyLocation
    agencyLocationName
    referringCompanyId
    referringAgencyLocationId
    referralReasonId
    referringRecordNumber
    specialtyTeamNotes
    specialtyTeamId
    careLevelRequested
    transferCenterId
    transferCenterNotes
    transportingAgencyLocationId
    isDoublePatient
    isWingToWing
    vetNumber
    requestId
    specialtyTeamMembers {
      id
    }
  }
`;
export const RequesterReferralReasonFieldsFragmentDoc = gql`
  fragment RequesterReferralReasonFields on RequesterReferralReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const RequesterRoleFieldsFragmentDoc = gql`
  fragment RequesterRoleFields on RequesterRole {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const RequestLocationFieldsFragmentDoc = gql`
  fragment RequestLocationFields on RequestLocation {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    type
    requestId
    companyId
    locationId
    timezoneCd
    isRotorWingLz
    medicalFacilityId
    roomNumber
    medicalFacilityUnitId
    notes
    groundContact
    estimatedRendezvousTimeInMinutes
    estimatedGroundTimeInMinutes
    fboId
    physicianId
    diversionReasonId
    diversionReasonOtherNotes
    isAutoAccepted
    dateConfirmed
    confirmedByUserId
    unConfirmed
    physicianName
    address {
      streetAddress
      city
      region
      postalCode
      country
      county
      gpsId
      coordinates {
        latitude
        longitude
      }
    }
  }
`;
export const RequestPatientFieldsFragmentDoc = gql`
  fragment RequestPatientFields on RequestPatient {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    gender
    isIsolette
    requestId
    companyId
    patientId
    firstName
    lastName
    dateOfBirth
    weightInKg
    transportReasonId
    notes
    chiefComplaintNotes
    transportReasonCategory
    isIntubated
    numberOfDrips
    specialtyEquipment
    rideAlongRequested
    isoletteType
    isoletteNotes
    transferReasonId
    estimatedAgeInHours
    gcs
    bpSystolic
    bpDiastolic
    heartRate
    oxygenSaturation
    respiratoryRate
    temperatureInCelsius
    rideAlongWeightInKg
    medicalRecordNumber
    rideAlongName
    rideAlongDateOfBirth
  }
`;
export const SystemTimerFieldsFragmentDoc = gql`
  fragment SystemTimerFields on SystemTimer {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    description
    commandName
    runIntervalInSeconds
    hasRunCondition
    isEnqueued
    lastRunDate
  }
`;
export const TimelineFieldsFragmentDoc = gql`
  fragment TimelineFields on Timeline {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    companyId
    activationRuleId
    timelineType
  }
`;
export const TimelineItemFieldsFragmentDoc = gql`
  fragment TimelineItemFields on TimelineItem {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    timestampTypeId
    required
    sequence
    timelineId
  }
`;
export const TimestampFieldsFragmentDoc = gql`
  fragment TimestampFields on Timestamp {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    time
    typeId
    cardId
    companyId
    userId
    note
    requestId
    operationId
    personsInvolved
  }
`;
export const TimestampTypeFieldsFragmentDoc = gql`
  fragment TimestampTypeFields on TimestampType {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    order
    systemTimestampType
    description
    companies {
      id
    }
  }
`;
export const TrackedMessageFieldsFragmentDoc = gql`
  fragment TrackedMessageFields on TrackedMessage {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    recipientAddress
    body
    status
    recipientName
    subject
    fromName
    fromAddress
    doNotDivert
    medium
    vendorId
    vendorMessageId
    referenceNumber
    vendorConversationId
  }
`;
export const TransferReasonFieldsFragmentDoc = gql`
  fragment TransferReasonFields on TransferReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const TransportOfferFieldsFragmentDoc = gql`
  fragment TransportOfferFields on TransportOffer {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    rank
    response
    wasBulkSkip
    isOnDelay
    isOneCallAgreement
    isInternalAgency
    requestId
    companyId
    distanceInMiles
    bearingInDegrees
    estimatedDepartureTimeInMinutes
    estimatedTimeEnRouteInMinutes
    offerTime
    crewNotified
    transportCheckInitiated
    notificationAcknowledged
    responseReceived
    declineReasonId
    declineSecondaryReasonId
    nonReferralReasonId
    nonReferralReasonNotes
    cancellationReasonId
    cancellationSecondaryReasonId
    cancellationReasonNotes
    outOfServiceEventId
    unitId
    vehicleId
    agencyLocationId
    unitDescription
    isReferral
    vehicleType
    patientOriginatesAtUnit
    homeBaseDistanceInMiles
    baseId
    preferredRank
    notes
    onBaseETAInMinutes
    specialtyTeamETLOInMinutes
    specialtyTeamETEInMinutes
    dateDeclinedOrAborted
    declinedOrAbortedById
    etc
    crewMustFlyToArriveAtSending
    vehicleCoordinates {
      latitude
      longitude
    }
    crew {
      id
      firstName
      lastName
      type
    }
  }
`;
export const TransportOfferOptionFieldsFragmentDoc = gql`
  fragment TransportOfferOptionFields on TransportOfferOption {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    includeAbortedUnit
    type
    requestId
    companyId
    requestedVehicleType
    transportOfferAlgorithm
    minimumFlightRule
    includeCompetitors
    requiredCapabilities {
      id
    }
  }
`;
export const TransportReasonFieldsFragmentDoc = gql`
  fragment TransportReasonFields on TransportReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    operationType
  }
`;
export const TripFieldsFragmentDoc = gql`
  fragment TripFields on Trip {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    operationId
    companyId
    vehicleId
    agencyId
    agencyLocationId
    calculatedLoadedMiles
    gpsLoadedMiles
  }
`;
export const TripLegFieldsFragmentDoc = gql`
  fragment TripLegFields on TripLeg {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    status
    sequence
    tripId
    companyId
    estimatedDistanceInMiles
    departingOdometerReading
    departingNote
    arrivingOdometerReading
    arrivingNote
    isEmergent
    abortDate
    encodedPolyline
    dateOnFinalMarked
    officialEteId
    calculatedEteId
    endingWaypointId
    startingWaypointId
  }
`;
export const TripPassengerFieldsFragmentDoc = gql`
  fragment TripPassengerFields on TripPassenger {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    type
    tripId
    companyId
    weightInKg
    positionName
    positionType
    notificationAddress
    personId
    crewMemberId
  }
`;
export const UnitActivationRuleFieldsFragmentDoc = gql`
  fragment UnitActivationRuleFields on UnitActivationRule {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    companyId
    unitId
    operationTypes
    missionRoleTypes
    maximumDistanceInMiles
  }
`;
export const UnitEMSystemMappingFieldsFragmentDoc = gql`
  fragment UnitEMSystemMappingFields on UnitEMSystemMapping {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    resourceId
    sendGps
    unitId
    companyId
    divisionName
  }
`;
export const UnitNoteFieldsFragmentDoc = gql`
  fragment UnitNoteFields on UnitNote {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    content
    noteTime
    unitId
    companyId
    authorId
    noteCategory
    noteMetadataJson
  }
`;
export const UnitStatusHistoryEntryFieldsFragmentDoc = gql`
  fragment UnitStatusHistoryEntryFields on UnitStatusHistoryEntry {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    startTime
    endTime
    status
    unitId
    companyId
  }
`;
export const UnitSummaryFieldsFragmentDoc = gql`
  fragment UnitSummaryFields on UnitSummary {
    dateLastUpdated
    dateCreated
    dateDeleted
    id
    name
    abbreviation
    status
    weatherStatus
    isExternallyManaged
    maximumFlightRule
    isOnDelay
    isEnabled
    isSpare
    isCrewAvailable
    baseId
    regionId
    companyId
    isAdministrative
    isHidden
    isThirdPartyUnit
    etloInMinutes
    pilotNotes
    lastPilotUpdateTime
    lastPilotUpdateById
    plannedAvailableNotes
    plannedAvailableTime
    lastPilotUpdateName
    baseTimezoneCd
    vehicleSummaryId
    vehicleId
    communicationCenterId
    shifts {
      id
      name
      startTimeInMinutes
      endTimeInMinutes
    }
    outOfServiceEvents {
      id
      type
      eventNumber
      estimatedEndTime
      reasonName
      reasonId
      startTime
      isOpportunisticOOS
      notes
    }
    positions {
      id
      name
      type
      isFlightCrew
      isNonEmployee
      isNonCompliant
      notificationAddress
      teamMemberId
      teamMemberFirstName
      teamMemberLastName
      nonComplianceReason
    }
    paipEventIds {
      id
    }
  }
`;
export const VehicleNotificationGroupFieldsFragmentDoc = gql`
  fragment VehicleNotificationGroupFields on VehicleNotificationGroup {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    vehicleId
    notificationGroupId
  }
`;
export const VehiclePositionSummaryFieldsFragmentDoc = gql`
  fragment VehiclePositionSummaryFields on VehiclePositionSummary {
    dateLastUpdated
    dateCreated
    dateDeleted
    id
    vehicleId
    latitude
    longitude
    positionSource
    positionTime
    companyId
    lastPositionReportId
    lastQualifyingPositionReportTime
    etlo
    lastGpsAutoPositionTime
    lastTakeOffTime
    lastLandedTime
    gpsProvider
    altitude
    speedInKnots
    heading
  }
`;
export const VehicleSummaryFieldsFragmentDoc = gql`
  fragment VehicleSummaryFields on VehicleSummary {
    dateLastUpdated
    dateCreated
    dateDeleted
    id
    type
    registrationNumber
    unitSummaryId
    regionId
    status
    statusDescription
    vehicleDispositionId
    unitId
    companyId
    serialNumber
    dispatchCompanyId
    makeName
    modelName
    etlo
    eta
    currentCardNumber
    currentCardSummaryId
    lastQualifyingPositionReportTime
    currentOrNextLegSequence
    totalLegCount
    dateOnFinalMarked
    communicationCenterId
    currentCardId
    from {
      id
      name
      abbreviation
      type
    }
    to {
      id
      name
      abbreviation
      type
    }
    latestPositionReportSummary {
      id
      positionTime
      source
    }
    lastKnownCoordinates {
      latitude
      longitude
    }
  }
`;
export const WaypointFieldsFragmentDoc = gql`
  fragment WaypointFields on Waypoint {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    type
    companyId
    timezoneCd
    isRotorWingLz
    arrivalTime
    departureTime
    locationId
    isPatientPickup
    isPatientDropoff
    arrivingType
    estimatedDurationId
    currentEtaId
    address {
      streetAddress
      city
      region
      postalCode
      country
      county
      gpsId
      coordinates {
        latitude
        longitude
      }
    }
  }
`;
export const WebOrderLogFieldsFragmentDoc = gql`
  fragment WebOrderLogFields on WebOrderLog {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    requestJson
    name
    isSuccess
    errors
    entityId
    entityType
    dateAcknowledged
    acknowledgedById
    changes {
      id
      entityType
      fieldName
      oldValue
      newValue
    }
  }
`;
export const AgencyFieldsFragmentDoc = gql`
  fragment AgencyFields on Agency {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    type
    isCompetitor
    isInternallyOwned
    parentCompanyId
    notes
  }
`;
export const AgencyLocationFieldsFragmentDoc = gql`
  fragment AgencyLocationFields on AgencyLocation {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    isInTransportNet
    agencyId
    emailAddress
    primaryPhoneNumber
    secondaryPhoneNumber
    smsPhoneNumber
    faxPhoneNumber
    notes
    vehicleType
    estimatedDepartureTimeInMinutes
    locationId
  }
`;
export const AirportFieldsFragmentDoc = gql`
  fragment AirportFields on Airport {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    code
    airportType
    airportCodeType
    sourceSystemId
    preferredFboId
    locationId
  }
`;
export const ArchiveLogFieldsFragmentDoc = gql`
  fragment ArchiveLogFields on ArchiveLog {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    archiveEntityType
    archivedUntilDate
    isError
    notes
  }
`;
export const AttachmentFieldsFragmentDoc = gql`
  fragment AttachmentFields on Attachment {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    attachmentEntityType
    fileName
    entityId
    fileSizeInBytes
    contentType
  }
`;
export const BaseFieldsFragmentDoc = gql`
  fragment BaseFields on Base {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    locationId
    businessModel
    companyId
    plannedOperationsStart
    operationsStarted
    operationsTerminated
    dateOfMaturity
    primaryPhoneNumber
    estimatedLiftoffTime
    licenseNumber
    enableFlightLogDutyLog
    dispatchBaseId
    reportBaseId
    aviationCompanyId
    workdayBaseId
    gmrWorkdayLocationId
    dateLastUpdatedFromGMRWorkday
    pilotPhoneNumber
    crewPhoneNumber1
    crewPhoneNumber2
    brandName
    medicalFacilityId
    hoursOfOperation {
      is24Hours
      startTime
      endTime
    }
    communicationCenterCustomIdentifiers {
      id
      name
    }
    additionalCompanies {
      id
    }
  }
`;
export const BaseMedicalControlContactFieldsFragmentDoc = gql`
  fragment BaseMedicalControlContactFields on BaseMedicalControlContact {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    personId
    rank
    baseId
    companyId
    specialty
  }
`;
export const BaseMedicalControlContactStateFieldsFragmentDoc = gql`
  fragment BaseMedicalControlContactStateFields on BaseMedicalControlContactState {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    stateAbbrevation
    companyId
    baseMedicalControlContactId
  }
`;
export const CapabilityFieldsFragmentDoc = gql`
  fragment CapabilityFields on Capability {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    description
    entityType
  }
`;
export const CommunicationCenterTransportOfferOptionFieldsFragmentDoc = gql`
  fragment CommunicationCenterTransportOfferOptionFields on CommunicationCenterTransportOfferOption {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    includeAbortedUnit
    requestedVehicleType
    transportOfferAlgorithm
    minimumFlightRule
    includeCompetitors
    communicationCenterId
    requiredCapabilities {
      id
    }
  }
`;
export const CompanyFieldsFragmentDoc = gql`
  fragment CompanyFields on Company {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    companyCode
    includeCompetitors
    hasPrivateUnits
    isOemCompany
    gpsFeedResetsPositionReportTime
    unitRemainsInServiceWithNoVehicle
    enableNotificationGroupTypes
    restrictRiskAnalysisAcknowledgementToOCCRole
    imageUri
    gLCode
    callNumberPrefix
    timezoneCd
    flightFollowingFields
    requireSkipReasonsForNonCompanyTransportOffers
    crewPatientInfoPageNotificationTemplateId
    transportCheckTimerDurationInMinutes
  }
`;
export const CompleteFlightInstanceFieldsFragmentDoc = gql`
  fragment CompleteFlightInstanceFields on CompleteFlightInstance {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    completeFlightInstanceName
    url
    username
    apiKey
    isPrimary
  }
`;
export const DepartmentFieldsFragmentDoc = gql`
  fragment DepartmentFields on Department {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    code
  }
`;
export const EntityCapabilityFieldsFragmentDoc = gql`
  fragment EntityCapabilityFields on EntityCapability {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    capabilityId
    entityId
    entityType
  }
`;
export const ExternalReferenceFieldsFragmentDoc = gql`
  fragment ExternalReferenceFields on ExternalReference {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    externalKey
    externalSystem
    entityId
    entityType
  }
`;
export const FboFieldsFragmentDoc = gql`
  fragment FboFields on Fbo {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    airportId
    fboType
    fuelBrand
    sourceSystemId
    locationId
  }
`;
export const FuelTankFieldsFragmentDoc = gql`
  fragment FuelTankFields on FuelTank {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    code
    name
    locationId
    companyId
    operationsStarted
    operationsEnded
    sourceSystemId
    baseId
    locationName
  }
`;
export const LocationFieldsFragmentDoc = gql`
  fragment LocationFields on Location {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    locationType
    isPreferred
    timezoneCd
    isRotorWingLz
    notes
    sourceSystemId
    closedDate
    duplicateOfId
    isLandingZoneOutOfService
    landingZoneOutOfServiceNotes
    landingZoneOutOfServiceExpirationDate
    landingZoneOutOfServiceReasonId
    address {
      streetAddress
      city
      region
      postalCode
      country
      county
      gpsId
      coordinates {
        latitude
        longitude
      }
    }
  }
`;
export const MaintenanceFacilityFieldsFragmentDoc = gql`
  fragment MaintenanceFacilityFields on MaintenanceFacility {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    locationId
  }
`;
export const MedicalFacilityContactFieldsFragmentDoc = gql`
  fragment MedicalFacilityContactFields on MedicalFacilityContact {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    medicalFacilityId
    emailAddress
    primaryPhoneNumber
    secondaryPhoneNumber
    smsPhoneNumber
    faxPhoneNumber
    notes
  }
`;
export const MedicalFacilityFieldsFragmentDoc = gql`
  fragment MedicalFacilityFields on MedicalFacility {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    npi
    providerNumber
    sourceSystemId
    masterDataSetId
    firmType
    hospitalType
    hospitalSpecialization
    website
    defaultLandingZoneId
    defaultFixedWingLandingZoneId
    notes
    stateSourceSystemId
    nemsisCode
    stateFacilityName
    status
    archiveNotes
    archiveClearedDate
    locationId
    communicationCenterCustomIdentifiers {
      id
      name
    }
  }
`;
export const MedicalFacilityPhysicianFieldsFragmentDoc = gql`
  fragment MedicalFacilityPhysicianFields on MedicalFacilityPhysician {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    physicianId
    medicalFacilityId
  }
`;
export const MedicalFacilityUnitFieldsFragmentDoc = gql`
  fragment MedicalFacilityUnitFields on MedicalFacilityUnit {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    medicalFacilityId
    phoneNumber
  }
`;
export const MedicalUnitFieldsFragmentDoc = gql`
  fragment MedicalUnitFields on MedicalUnit {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const OutOfServiceQARReasonFieldsFragmentDoc = gql`
  fragment OutOfServiceQARReasonFields on OutOfServiceQARReason {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const PhysicianFieldsFragmentDoc = gql`
  fragment PhysicianFields on Physician {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    firstName
    lastName
  }
`;
export const ProgramBaseFieldsFragmentDoc = gql`
  fragment ProgramBaseFields on ProgramBase {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    baseId
    programId
    companyId
    startTime
    endTime
  }
`;
export const ProgramFieldsFragmentDoc = gql`
  fragment ProgramFields on Program {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    code
    companyId
    adminId
  }
`;
export const RamcoVehicleConfigurationFieldsFragmentDoc = gql`
  fragment RamcoVehicleConfigurationFields on RamcoVehicleConfiguration {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    maintenanceSystemId
    tailNumber
    modelNumber
    companyCode
  }
`;
export const RegionBaseFieldsFragmentDoc = gql`
  fragment RegionBaseFields on RegionBase {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    baseId
    regionId
    companyId
  }
`;
export const RegionFieldsFragmentDoc = gql`
  fragment RegionFields on Region {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    communicationCenterId
    isTransferCenterRegion
    regionGroupId
    companyId
    timezoneCd
    emSystemDivisionName
    dispatchNumber
    fixedWingPreferredThresholdInNauticalMiles
    etcInMinutes
  }
`;
export const RegionGroupFieldsFragmentDoc = gql`
  fragment RegionGroupFields on RegionGroup {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    departmentId
    companyId
  }
`;
export const ReleaseNoteFieldsFragmentDoc = gql`
  fragment ReleaseNoteFields on ReleaseNote {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    releaseNumber
    description
    releaseDate
  }
`;
export const SpecialtyTeamFieldsFragmentDoc = gql`
  fragment SpecialtyTeamFields on SpecialtyTeam {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    affiliationId
    companyId
  }
`;
export const SpecialtyTeamMemberFieldsFragmentDoc = gql`
  fragment SpecialtyTeamMemberFields on SpecialtyTeamMember {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    specialtyTeamId
    teamMemberId
    companyId
    weightInKg
  }
`;
export const StateFieldsFragmentDoc = gql`
  fragment StateFields on State {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    code
    isLicenseRequiredToFly
  }
`;
export const SupportRequestFieldsFragmentDoc = gql`
  fragment SupportRequestFields on SupportRequest {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    supportRequestType
    isEmailSent
    supportRequestStatus
    personId
    companyId
    subject
    content
    notes
  }
`;
export const TimezoneFieldsFragmentDoc = gql`
  fragment TimezoneFields on Timezone {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    abbreviation
    code
    isDst
    utcOffset
  }
`;
export const TransferCenterFieldsFragmentDoc = gql`
  fragment TransferCenterFields on TransferCenter {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    communicationCenterId
    companyId
    description
  }
`;
export const TrmUserAgencyFieldsFragmentDoc = gql`
  fragment TrmUserAgencyFields on TrmUserAgency {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    trmUserId
    agencyId
    companyId
  }
`;
export const TrmUserFieldsFragmentDoc = gql`
  fragment TrmUserFields on TrmUser {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    emailAddress
    firstName
    lastName
    phoneNumber
    userStatus
    companyId
    personId
  }
`;
export const TrmUserMedicalFacilityFieldsFragmentDoc = gql`
  fragment TrmUserMedicalFacilityFields on TrmUserMedicalFacility {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    trmUserId
    medicalFacilityId
    companyId
  }
`;
export const TrmUserProgramFieldsFragmentDoc = gql`
  fragment TrmUserProgramFields on TrmUserProgram {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    trmUserId
    programId
    isPreferred
    companyId
  }
`;
export const VehicleConfigurationClassFieldsFragmentDoc = gql`
  fragment VehicleConfigurationClassFields on VehicleConfigurationClass {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    legacyName
    engineCount
    maintenanceSystemId
  }
`;
export const VehicleMaintenanceFieldsFragmentDoc = gql`
  fragment VehicleMaintenanceFields on VehicleMaintenance {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    companyId
    notes
    isReleasedFromOCF
    vehicleId
    deferralDueDates {
      id
      dueDate
      triggerValue
      notes
    }
    nextDues {
      id
      typeId
      cycleType
      value
      triggerValue
      notes
      inTolerance
    }
    maintenanceParams {
      endingHobbs
      airframeTime
      totalLandings
      engine1 {
        time
        starts
      }
      engine2 {
        time
        starts
      }
    }
  }
`;
export const VehicleMakeFieldsFragmentDoc = gql`
  fragment VehicleMakeFields on VehicleMake {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
  }
`;
export const AccessibleItemFieldsFragmentDoc = gql`
  fragment AccessibleItemFields on AccessibleItem {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    type
    entityId
    personId
    userRoles
  }
`;
export const CommunicationCenterFieldsFragmentDoc = gql`
  fragment CommunicationCenterFields on CommunicationCenter {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    includeCompetitors
    playAlertForManualPositionReports
    enableRAAlert
    useCrewPhoneNumber
    displayContactTimeline
    companyId
    timezoneCd
    primaryPhoneNumber
    emailAddress
    showReferToGmrWarning
    alertFrequencyForGroundVehicles
  }
`;
export const ControlZoneFieldsFragmentDoc = gql`
  fragment ControlZoneFields on ControlZone {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    name
    companyId
  }
`;
export const VehicleControlZoneFieldsFragmentDoc = gql`
  fragment VehicleControlZoneFields on VehicleControlZone {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    companyId
    controlZoneId
    vehicleId
  }
`;
export const BaseControlZoneFieldsFragmentDoc = gql`
  fragment BaseControlZoneFields on BaseControlZone {
    dateLastUpdated
    dateCreated
    dateDeleted
    lastUpdatedById
    id
    controlZoneId
    baseId
    companyId
  }
`;
export const UserDataContextFragmentDoc = gql`
  fragment UserDataContext on Query {
    authenticatedIdentity {
      ...PersonFields
    }
    userIdentity {
      ...PersonFields
      accessibleItems {
        ...AccessibleItemFields
      }
    }
    communicationCenters {
      all {
        items {
          ...CommunicationCenterFields
          states
        }
      }
    }
    controlZones {
      all {
        items {
          ...ControlZoneFields
        }
      }
    }
    vehicleControlZones {
      all {
        items {
          ...VehicleControlZoneFields
        }
      }
    }
    baseControlZones {
      all {
        items {
          ...BaseControlZoneFields
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${AccessibleItemFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
  ${ControlZoneFieldsFragmentDoc}
  ${VehicleControlZoneFieldsFragmentDoc}
  ${BaseControlZoneFieldsFragmentDoc}
`;
export const PersonPermissionsDetailPage_FetchPersonByIdDocument = gql`
  query PersonPermissionsDetailPage_FetchPersonById($personId: ID!) {
    people {
      byId(id: $personId) {
        firstName
        lastName
        userRoles
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
  }
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PersonPermissionsDetailPage_FetchPersonByIdGQL extends Apollo.Query<
  PersonPermissionsDetailPage_FetchPersonByIdQuery,
  PersonPermissionsDetailPage_FetchPersonByIdQueryVariables
> {
  document = PersonPermissionsDetailPage_FetchPersonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AsbPageComponent_FetchAllVehiclesDocument = gql`
  query AsbPageComponent_FetchAllVehicles($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleFields
          vehicleMaintenances {
            ...VehicleMaintenanceFields
          }
          vehicleStateInspections {
            ...VehicleStateInspectionFields
          }
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
  ${VehicleMaintenanceFieldsFragmentDoc}
  ${VehicleStateInspectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AsbPageComponent_FetchAllVehiclesGQL extends Apollo.Query<
  AsbPageComponent_FetchAllVehiclesQuery,
  AsbPageComponent_FetchAllVehiclesQueryVariables
> {
  document = AsbPageComponent_FetchAllVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AsbPageComponent_FetchAllNextDueTypesDocument = gql`
  query AsbPageComponent_FetchAllNextDueTypes($filter: NextDueTypeFilter, $first: Int, $skip: Int) {
    nextDueTypes {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          name
          dataType
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AsbPageComponent_FetchAllNextDueTypesGQL extends Apollo.Query<
  AsbPageComponent_FetchAllNextDueTypesQuery,
  AsbPageComponent_FetchAllNextDueTypesQueryVariables
> {
  document = AsbPageComponent_FetchAllNextDueTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AsbPageComponent_FetchAllVehicleModelsDocument = gql`
  query AsbPageComponent_FetchAllVehicleModels(
    $filter: VehicleModelFilter
    $first: Int
    $skip: Int
  ) {
    vehicleModels {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleModelFields
        }
      }
    }
  }
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AsbPageComponent_FetchAllVehicleModelsGQL extends Apollo.Query<
  AsbPageComponent_FetchAllVehicleModelsQuery,
  AsbPageComponent_FetchAllVehicleModelsQueryVariables
> {
  document = AsbPageComponent_FetchAllVehicleModelsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GlobalDataContextService_FetchDocument = gql`
  query GlobalDataContextService_Fetch {
    ...UserDataContext
    units {
      summaries(filter: { includeThirdParty: false, tcsManagedUnits: true }) {
        items {
          ...UnitSummaryFields
        }
        meta {
          total
          __typename
        }
      }
    }
    vehicles {
      summaries {
        items {
          ...VehicleSummaryFields
        }
        meta {
          total
          __typename
        }
      }
    }
    requesterReferralReasons {
      all {
        items {
          ...RequesterReferralReasonFields
        }
      }
    }
    outOfServiceReasons {
      all {
        items {
          ...OutOfServiceReasonFields
        }
        meta {
          total
        }
      }
    }
    outOfServiceSecondaryReasons {
      all {
        items {
          ...OutOfServiceSecondaryReasonFields
        }
        meta {
          total
        }
      }
    }
    companies {
      all {
        items {
          ...CompanyFields
        }
        meta {
          total
        }
      }
    }
    regionGroups {
      all {
        items {
          ...RegionGroupFields
        }
        meta {
          total
        }
      }
    }
    regions {
      all {
        items {
          ...RegionFields
        }
        meta {
          total
        }
      }
    }
    applicationNotifications {
      all {
        items {
          ...ApplicationNotificationFields
        }
        meta {
          total
        }
      }
    }
    configurationSettings {
      global {
        ...ConfigurationSettingFields
      }
    }
    gis {
      allTimezones {
        ...TimezoneFields
      }
    }
    declineReasons {
      all {
        items {
          ...DeclineReasonFields
        }
        meta {
          total
        }
      }
    }
    declineSecondaryReasons {
      all {
        items {
          ...DeclineSecondaryReasonFields
        }
        meta {
          total
        }
      }
    }
    declineCategories {
      all {
        items {
          ...DeclineCategoryFields
        }
        meta {
          total
        }
      }
    }
    cancellationReasons {
      all {
        items {
          ...CancellationReasonFields
        }
        meta {
          total
        }
      }
    }
    cancellationSecondaryReasons {
      all {
        items {
          ...CancellationSecondaryReasonFields
        }
        meta {
          total
        }
      }
    }
    capabilities {
      all {
        items {
          ...CapabilityFields
        }
        meta {
          total
        }
      }
    }
    timestampTypes {
      all {
        items {
          ...TimestampTypeFields
        }
        meta {
          total
        }
      }
    }
    transportReasons {
      all {
        items {
          ...TransportReasonFields
        }
        meta {
          total
        }
      }
    }
    transferReasons {
      all {
        items {
          ...TransferReasonFields
        }
        meta {
          total
        }
      }
    }
    diversionReasons {
      all {
        items {
          ...DiversionReasonFields
        }
        meta {
          total
        }
      }
    }
    nonReferralReasons {
      all {
        items {
          ...NonReferralReasonFields
        }
        meta {
          total
        }
      }
    }
    facilityNonAcceptanceReasons {
      all {
        items {
          ...FacilityNonAcceptanceReasonFields
        }
        meta {
          total
        }
      }
    }
    externalActionTypes {
      all {
        items {
          ...ExternalActionTypeFields
        }
        meta {
          total
        }
      }
    }
    archiveLogs {
      latestAll {
        items {
          ...ArchiveLogFields
        }
      }
    }
    states {
      all {
        items {
          ...StateFields
        }
      }
    }
    paipReasons {
      all {
        items {
          ...PaipReasonFields
        }
      }
    }
  }
  ${UserDataContextFragmentDoc}
  ${UnitSummaryFieldsFragmentDoc}
  ${VehicleSummaryFieldsFragmentDoc}
  ${RequesterReferralReasonFieldsFragmentDoc}
  ${OutOfServiceReasonFieldsFragmentDoc}
  ${OutOfServiceSecondaryReasonFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${RegionGroupFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${ApplicationNotificationFieldsFragmentDoc}
  ${ConfigurationSettingFieldsFragmentDoc}
  ${TimezoneFieldsFragmentDoc}
  ${DeclineReasonFieldsFragmentDoc}
  ${DeclineSecondaryReasonFieldsFragmentDoc}
  ${DeclineCategoryFieldsFragmentDoc}
  ${CancellationReasonFieldsFragmentDoc}
  ${CancellationSecondaryReasonFieldsFragmentDoc}
  ${CapabilityFieldsFragmentDoc}
  ${TimestampTypeFieldsFragmentDoc}
  ${TransportReasonFieldsFragmentDoc}
  ${TransferReasonFieldsFragmentDoc}
  ${DiversionReasonFieldsFragmentDoc}
  ${NonReferralReasonFieldsFragmentDoc}
  ${FacilityNonAcceptanceReasonFieldsFragmentDoc}
  ${ExternalActionTypeFieldsFragmentDoc}
  ${ArchiveLogFieldsFragmentDoc}
  ${StateFieldsFragmentDoc}
  ${PaipReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GlobalDataContextService_FetchGQL extends Apollo.Query<
  GlobalDataContextService_FetchQuery,
  GlobalDataContextService_FetchQueryVariables
> {
  document = GlobalDataContextService_FetchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardSearchComponent_SearchForCardsDocument = gql`
  query CardSearchComponent_SearchForCards($filter: CardSearchFilter, $first: Int, $skip: Int) {
    cards {
      search(filter: $filter, skip: $skip, first: $first) {
        meta {
          total
        }
        items {
          id
          cardNumber
          companyId
          companyCode
          dateCreated
          dateDeleted
          status
          callStatus
          isBillable
          isLocked
          lastOfferedUnit {
            id
            name
          }
          lastOfferedVehicle {
            id
            registrationNumber
          }
          operation {
            id
            status
            type
            unit {
              id
              name
            }
            vehicle {
              id
              registrationNumber
            }
          }
          request {
            id
            status
            requestedOperationType
            pickupLocation {
              id
              name
              type
              locationId
              medicalFacilityId
              medicalFacilityName
              medicalFacilityAbbreviation
            }
            dropoffLocation {
              id
              name
              type
              locationId
              medicalFacilityId
              medicalFacilityName
              medicalFacilityAbbreviation
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CardSearchComponent_SearchForCardsGQL extends Apollo.Query<
  CardSearchComponent_SearchForCardsQuery,
  CardSearchComponent_SearchForCardsQueryVariables
> {
  document = CardSearchComponent_SearchForCardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewCardSearchComponent_SearchForCardsDocument = gql`
  query NewCardSearchComponent_SearchForCards(
    $filter: CardSearchFilterV2
    $first: Int
    $skip: Int
  ) {
    cards {
      searchv2(filter: $filter, skip: $skip, first: $first) {
        meta {
          total
        }
        items {
          id
          cardNumber
          createdById
          createdBy
          companyId
          companyCode
          dateCreated
          dateDeleted
          status
          callStatus
          isBillable
          isLocked
          lastOfferedUnit {
            id
            name
          }
          lastOfferedVehicle {
            id
            registrationNumber
          }
          operation {
            id
            status
            type
            unit {
              id
              name
            }
            vehicle {
              id
              registrationNumber
            }
          }
          request {
            id
            status
            requestedOperationType
            pickupLocation {
              id
              name
              type
              locationId
              medicalFacilityId
              medicalFacilityName
              medicalFacilityAbbreviation
            }
            dropoffLocation {
              id
              name
              type
              locationId
              medicalFacilityId
              medicalFacilityName
              medicalFacilityAbbreviation
            }
          }
          region {
            id
            name
            communicationCenter {
              id
              name
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class NewCardSearchComponent_SearchForCardsGQL extends Apollo.Query<
  NewCardSearchComponent_SearchForCardsQuery,
  NewCardSearchComponent_SearchForCardsQueryVariables
> {
  document = NewCardSearchComponent_SearchForCardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewCardSearchComponent_FetchAllPeopleDocument = gql`
  query NewCardSearchComponent_FetchAllPeople($nameLike: String, $personId: ID, $companyId: ID) {
    people {
      all(filter: { nameLike: $nameLike, personId: $personId, companyId: $companyId }, first: 25) {
        items {
          ...PersonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NewCardSearchComponent_FetchAllPeopleGQL extends Apollo.Query<
  NewCardSearchComponent_FetchAllPeopleQuery,
  NewCardSearchComponent_FetchAllPeopleQueryVariables
> {
  document = NewCardSearchComponent_FetchAllPeopleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewCardSearchComponent_FetchAllAgencyLocationsDocument = gql`
  query NewCardSearchComponent_FetchAllAgencyLocations(
    $filter: AgencyLocationFilter
    $first: Int
    $skip: Int
  ) {
    agencyLocations {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...AgencyLocationFields
        }
        meta {
          total
        }
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NewCardSearchComponent_FetchAllAgencyLocationsGQL extends Apollo.Query<
  NewCardSearchComponent_FetchAllAgencyLocationsQuery,
  NewCardSearchComponent_FetchAllAgencyLocationsQueryVariables
> {
  document = NewCardSearchComponent_FetchAllAgencyLocationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewCardSearchComponent_FetchAllCommunicationCentersDocument = gql`
  query NewCardSearchComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CommunicationCenterFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NewCardSearchComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  NewCardSearchComponent_FetchAllCommunicationCentersQuery,
  NewCardSearchComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = NewCardSearchComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumEventsComponent_FetchOosDashboardEventsDocument = gql`
  query OosRumEventsComponent_FetchOosDashboardEvents(
    $filter: OutOfServiceEventDashboardDataFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceEvents {
      dashboard(filter: $filter, skip: $skip, first: $first) {
        items {
          id
          eventNumber
          startTime
          endTime
          registrationNumber
          unitVehicleTailNumber
          companyId
          communicationCenterName
          reasonId
          reasonName
          secondaryReasonId
          secondaryReasonName
          unitName
          baseName
          estimatedEndTime
          vehicleId
          typeName
          entityType
          communicationCenterId
          acknowledgementNotes
          dateAcknowledged
          subeventsCount
          maintenanceFacilityName
          isAcknowledgementRequired
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumEventsComponent_FetchOosDashboardEventsGQL extends Apollo.Query<
  OosRumEventsComponent_FetchOosDashboardEventsQuery,
  OosRumEventsComponent_FetchOosDashboardEventsQueryVariables
> {
  document = OosRumEventsComponent_FetchOosDashboardEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumEventsComponent_FetchOosEventsDocument = gql`
  query OosRumEventsComponent_FetchOosEvents(
    $filter: OutOfServiceEventFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceEvents {
      all(filter: $filter, skip: $skip, first: $first) {
        meta {
          total
        }
        items {
          ...OutOfServiceEventFields
        }
      }
    }
  }
  ${OutOfServiceEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumEventsComponent_FetchOosEventsGQL extends Apollo.Query<
  OosRumEventsComponent_FetchOosEventsQuery,
  OosRumEventsComponent_FetchOosEventsQueryVariables
> {
  document = OosRumEventsComponent_FetchOosEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesDocument = gql`
  query OosRumNotificationAddDialogComponent_FetchAllNotificationTemplates(
    $filter: NotificationTemplateFilter
    $first: Int
    $skip: Int
  ) {
    notificationTemplates {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationTemplateFields
        }
      }
    }
  }
  ${NotificationTemplateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesGQL extends Apollo.Query<
  OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesQuery,
  OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesQueryVariables
> {
  document = OosRumNotificationAddDialogComponent_FetchAllNotificationTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumNotificationAddDialogComponent_DeriveOosTemplateDocument = gql`
  query OosRumNotificationAddDialogComponent_DeriveOosTemplate(
    $outOfServiceEventId: ID!
    $templateId: ID!
  ) {
    notificationTemplates {
      deriveOOSTemplate(outOfServiceEventId: $outOfServiceEventId, templateId: $templateId) {
        activityId
        responseCode
        errors
        data {
          recipients {
            name
            address
          }
          subject
          body
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumNotificationAddDialogComponent_DeriveOosTemplateGQL extends Apollo.Query<
  OosRumNotificationAddDialogComponent_DeriveOosTemplateQuery,
  OosRumNotificationAddDialogComponent_DeriveOosTemplateQueryVariables
> {
  document = OosRumNotificationAddDialogComponent_DeriveOosTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumAddDialogComponent_FetchOosEventsDocument = gql`
  query OosRumAddDialogComponent_FetchOosEvents(
    $filter: OutOfServiceEventDashboardDataFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceEvents {
      dashboard(filter: $filter, skip: $skip, first: $first) {
        items {
          id
          eventNumber
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumAddDialogComponent_FetchOosEventsGQL extends Apollo.Query<
  OosRumAddDialogComponent_FetchOosEventsQuery,
  OosRumAddDialogComponent_FetchOosEventsQueryVariables
> {
  document = OosRumAddDialogComponent_FetchOosEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumAddDialogComponent_FetchUnitPositionsByUnitIdDocument = gql`
  query OosRumAddDialogComponent_FetchUnitPositionsByUnitId($unitId: ID!) {
    units {
      byId(id: $unitId) {
        id
        positions {
          ...UnitPositionFields
        }
      }
    }
  }
  ${UnitPositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumAddDialogComponent_FetchUnitPositionsByUnitIdGQL extends Apollo.Query<
  OosRumAddDialogComponent_FetchUnitPositionsByUnitIdQuery,
  OosRumAddDialogComponent_FetchUnitPositionsByUnitIdQueryVariables
> {
  document = OosRumAddDialogComponent_FetchUnitPositionsByUnitIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumAddDialogComponent_FetchVehiclesDocument = gql`
  query OosRumAddDialogComponent_FetchVehicles($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          registrationNumber
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumAddDialogComponent_FetchVehiclesGQL extends Apollo.Query<
  OosRumAddDialogComponent_FetchVehiclesQuery,
  OosRumAddDialogComponent_FetchVehiclesQueryVariables
> {
  document = OosRumAddDialogComponent_FetchVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsDocument = gql`
  query OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroups($vehicleId: ID!) {
    vehicles {
      byId(id: $vehicleId) {
        id
        vehicleNotificationGroups {
          ...VehicleNotificationGroupFields
          notificationGroup {
            types
            name
            members {
              ...NotificationGroupMemberFields
              user {
                notificationAddress
              }
            }
          }
        }
      }
    }
  }
  ${VehicleNotificationGroupFieldsFragmentDoc}
  ${NotificationGroupMemberFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsGQL extends Apollo.Query<
  OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsQuery,
  OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsQueryVariables
> {
  document = OosRumNotificationAddDialogComponent_FetchVehicleNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsDocument = gql`
  query OosRumNotificationAddDialogComponent_FetchUnitNotificationGroups($vehicleId: ID!) {
    units {
      byVehicleId(vehicleId: $vehicleId) {
        notificationSubscriptions {
          notificationGroup {
            members {
              ...NotificationGroupMemberFields
              user {
                notificationAddress
              }
            }
            types
            name
          }
        }
      }
    }
  }
  ${NotificationGroupMemberFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsGQL extends Apollo.Query<
  OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsQuery,
  OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsQueryVariables
> {
  document = OosRumNotificationAddDialogComponent_FetchUnitNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumNotificationsComponent_FetchOosDashboardNotificationsDocument = gql`
  query OosRumNotificationsComponent_FetchOosDashboardNotifications(
    $filter: NotificationFilter
    $first: Int
    $skip: Int
  ) {
    notifications {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationFields
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumNotificationsComponent_FetchOosDashboardNotificationsGQL extends Apollo.Query<
  OosRumNotificationsComponent_FetchOosDashboardNotificationsQuery,
  OosRumNotificationsComponent_FetchOosDashboardNotificationsQueryVariables
> {
  document = OosRumNotificationsComponent_FetchOosDashboardNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumNotificationsComponent_FetchAllNotificationTemplatesDocument = gql`
  query OosRumNotificationsComponent_FetchAllNotificationTemplates(
    $filter: NotificationTemplateFilter
    $first: Int
    $skip: Int
  ) {
    notificationTemplates {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationTemplateFields
        }
      }
    }
  }
  ${NotificationTemplateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumNotificationsComponent_FetchAllNotificationTemplatesGQL extends Apollo.Query<
  OosRumNotificationsComponent_FetchAllNotificationTemplatesQuery,
  OosRumNotificationsComponent_FetchAllNotificationTemplatesQueryVariables
> {
  document = OosRumNotificationsComponent_FetchAllNotificationTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketFormComponent_FetchAllBasesDocument = gql`
  query OosRumTicketFormComponent_FetchAllBases($filter: BaseFilter, $first: Int, $skip: Int) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          name
          id
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketFormComponent_FetchAllBasesGQL extends Apollo.Query<
  OosRumTicketFormComponent_FetchAllBasesQuery,
  OosRumTicketFormComponent_FetchAllBasesQueryVariables
> {
  document = OosRumTicketFormComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketFormComponent_FetchQarReasonsDocument = gql`
  query OosRumTicketFormComponent_FetchQarReasons {
    outOfServiceQARReasons {
      all {
        items {
          name
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketFormComponent_FetchQarReasonsGQL extends Apollo.Query<
  OosRumTicketFormComponent_FetchQarReasonsQuery,
  OosRumTicketFormComponent_FetchQarReasonsQueryVariables
> {
  document = OosRumTicketFormComponent_FetchQarReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketFormComponent_FetchVehiclesDocument = gql`
  query OosRumTicketFormComponent_FetchVehicles($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          registrationNumber
          communicationCenterId
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketFormComponent_FetchVehiclesGQL extends Apollo.Query<
  OosRumTicketFormComponent_FetchVehiclesQuery,
  OosRumTicketFormComponent_FetchVehiclesQueryVariables
> {
  document = OosRumTicketFormComponent_FetchVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketFormComponent_FetchOosEventsDocument = gql`
  query OosRumTicketFormComponent_FetchOosEvents(
    $filter: OutOfServiceEventFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceEvents {
      all(filter: $filter, skip: $skip, first: $first) {
        meta {
          total
        }
        items {
          ...OutOfServiceEventFields
        }
      }
    }
  }
  ${OutOfServiceEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketFormComponent_FetchOosEventsGQL extends Apollo.Query<
  OosRumTicketFormComponent_FetchOosEventsQuery,
  OosRumTicketFormComponent_FetchOosEventsQueryVariables
> {
  document = OosRumTicketFormComponent_FetchOosEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketFormComponent_FetchMaintenanceFacilitiesDocument = gql`
  query OosRumTicketFormComponent_FetchMaintenanceFacilities(
    $filter: MaintenanceFacilityFilter
    $skip: Int
    $first: Int
  ) {
    maintenanceFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          name
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketFormComponent_FetchMaintenanceFacilitiesGQL extends Apollo.Query<
  OosRumTicketFormComponent_FetchMaintenanceFacilitiesQuery,
  OosRumTicketFormComponent_FetchMaintenanceFacilitiesQueryVariables
> {
  document = OosRumTicketFormComponent_FetchMaintenanceFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketFormComponent_FetchVehicleByIdDocument = gql`
  query OosRumTicketFormComponent_FetchVehicleById($id: ID!) {
    vehicles {
      byId(id: $id) {
        ...VehicleFields
        vehicleDispositions {
          ...VehicleDispositionFields
          currentWaypoint {
            ...WaypointFields
            address {
              ...AddressFields
            }
            location {
              id
              locationType
              name
              abbreviation
              notes
              address {
                ...AddressFields
              }
            }
          }
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${WaypointFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketFormComponent_FetchVehicleByIdGQL extends Apollo.Query<
  OosRumTicketFormComponent_FetchVehicleByIdQuery,
  OosRumTicketFormComponent_FetchVehicleByIdQueryVariables
> {
  document = OosRumTicketFormComponent_FetchVehicleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketsComponent_FetchOosDashboardTicketsDocument = gql`
  query OosRumTicketsComponent_FetchOosDashboardTickets(
    $filter: OutOfServiceTicketDashboardDataFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceTickets {
      dashboard(filter: $filter, skip: $skip, first: $first) {
        items {
          id
          ticketNumber
          ticketDescription
          companyId
          maintenanceTypes
          maintenanceFacilityName
          unitId
          unitName
          unitAbbreviation
          communicationCenterId
          communicationCenterName
          vehicleId
          spareVehicleId
          spareRegistrationNumber
          registrationNumber
          assignedBaseId
          assignedBaseName
          outOfServiceTime
          pointOfContactId
          pointOfContactName
          submittedById
          submittedByName
          statusName
          acknowledgementNotes
          dateAcknowledged
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketsComponent_FetchOosDashboardTicketsGQL extends Apollo.Query<
  OosRumTicketsComponent_FetchOosDashboardTicketsQuery,
  OosRumTicketsComponent_FetchOosDashboardTicketsQueryVariables
> {
  document = OosRumTicketsComponent_FetchOosDashboardTicketsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketsComponent_FetchOosTicketsDocument = gql`
  query OosRumTicketsComponent_FetchOosTickets(
    $filter: OutOfServiceTicketFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceTickets {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...OutOfServiceTicketFields
        }
        meta {
          total
        }
      }
    }
  }
  ${OutOfServiceTicketFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketsComponent_FetchOosTicketsGQL extends Apollo.Query<
  OosRumTicketsComponent_FetchOosTicketsQuery,
  OosRumTicketsComponent_FetchOosTicketsQueryVariables
> {
  document = OosRumTicketsComponent_FetchOosTicketsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosRumTicketsComponent_FetchVehiclesDocument = gql`
  query OosRumTicketsComponent_FetchVehicles($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleFields
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosRumTicketsComponent_FetchVehiclesGQL extends Apollo.Query<
  OosRumTicketsComponent_FetchVehiclesQuery,
  OosRumTicketsComponent_FetchVehiclesQueryVariables
> {
  document = OosRumTicketsComponent_FetchVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardActivityHistory_FetchCardLinksDocument = gql`
  query CardActivityHistory_FetchCardLinks($filter: CardLinkFilter) {
    cardLinks {
      all(filter: $filter) {
        items {
          ...CardLinkFields
        }
      }
    }
  }
  ${CardLinkFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardActivityHistory_FetchCardLinksGQL extends Apollo.Query<
  CardActivityHistory_FetchCardLinksQuery,
  CardActivityHistory_FetchCardLinksQueryVariables
> {
  document = CardActivityHistory_FetchCardLinksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardTimelineComponent_FetchTimelineItemsDocument = gql`
  query CardTimelineComponent_FetchTimelineItems(
    $filter: TimelineItemFilter
    $skip: Int
    $first: Int
  ) {
    timelineItems {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...TimelineItemFields
          timeline {
            ...TimelineFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${TimelineItemFieldsFragmentDoc}
  ${TimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardTimelineComponent_FetchTimelineItemsGQL extends Apollo.Query<
  CardTimelineComponent_FetchTimelineItemsQuery,
  CardTimelineComponent_FetchTimelineItemsQueryVariables
> {
  document = CardTimelineComponent_FetchTimelineItemsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestLocationFormComponent_FetchMedicalFacilityEntitiesDocument = gql`
  query RequestLocationFormComponent_FetchMedicalFacilityEntities($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        ...MedicalFacilityFields
        location {
          ...LocationFields
        }
        defaultLandingZone {
          ...LocationFields
        }
        defaultFixedWingLandingZone {
          ...LocationFields
        }
        units {
          ...MedicalFacilityUnitFields
        }
        associatedPhysicians {
          ...MedicalFacilityPhysicianFields
          physician {
            ...PhysicianFields
          }
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${MedicalFacilityUnitFieldsFragmentDoc}
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RequestLocationFormComponent_FetchMedicalFacilityEntitiesGQL extends Apollo.Query<
  RequestLocationFormComponent_FetchMedicalFacilityEntitiesQuery,
  RequestLocationFormComponent_FetchMedicalFacilityEntitiesQueryVariables
> {
  document = RequestLocationFormComponent_FetchMedicalFacilityEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardContactComponent_FetchTimelineItemsDocument = gql`
  query CardContactComponent_FetchTimelineItems(
    $filter: TimelineItemFilter
    $skip: Int
    $first: Int
  ) {
    timelineItems {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...TimelineItemFields
          timeline {
            ...TimelineFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${TimelineItemFieldsFragmentDoc}
  ${TimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardContactComponent_FetchTimelineItemsGQL extends Apollo.Query<
  CardContactComponent_FetchTimelineItemsQuery,
  CardContactComponent_FetchTimelineItemsQueryVariables
> {
  document = CardContactComponent_FetchTimelineItemsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardContactComponent_GetCardbyCardNumberDocument = gql`
  query CardContactComponent_GetCardbyCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        ...CardFields
      }
    }
  }
  ${CardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardContactComponent_GetCardbyCardNumberGQL extends Apollo.Query<
  CardContactComponent_GetCardbyCardNumberQuery,
  CardContactComponent_GetCardbyCardNumberQueryVariables
> {
  document = CardContactComponent_GetCardbyCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardContactComponent_GetRegionByIdDocument = gql`
  query CardContactComponent_GetRegionById($regionId: ID!) {
    regions {
      byId(id: $regionId) {
        ...RegionFields
      }
    }
  }
  ${RegionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardContactComponent_GetRegionByIdGQL extends Apollo.Query<
  CardContactComponent_GetRegionByIdQuery,
  CardContactComponent_GetRegionByIdQueryVariables
> {
  document = CardContactComponent_GetRegionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesDocument = gql`
  query ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilities(
    $filter: MedicalFacilityFilter
    $skip: Int
    $first: Int
  ) {
    medicalFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...MedicalFacilityFields
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesGQL extends Apollo.Query<
  ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesQuery,
  ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesQueryVariables
> {
  document = ReceivingFacilityRequestDivertDialogComponent_FetchMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const Card_FetchNotificationEntitiesDocument = gql`
  query Card_FetchNotificationEntities(
    $filter: NotificationFilter
    $first: Int
    $skip: Int
    $includeItems: Boolean! = true
    $includeCount: Boolean! = false
  ) {
    notifications {
      all(filter: $filter, first: $first, skip: $skip) {
        items @include(if: $includeItems) {
          ...NotificationFields
          recipients {
            ...NotificationRecipientFields
            message {
              messageStatusUpdates {
                ...MessageStatusUpdateFields
              }
            }
          }
        }
        meta @include(if: $includeCount) {
          total
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
  ${NotificationRecipientFieldsFragmentDoc}
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class Card_FetchNotificationEntitiesGQL extends Apollo.Query<
  Card_FetchNotificationEntitiesQuery,
  Card_FetchNotificationEntitiesQueryVariables
> {
  document = Card_FetchNotificationEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const Card_FetchTimeEntitiesDocument = gql`
  query Card_FetchTimeEntities(
    $cardId: ID!
    $timestampsFilter: TimestampsByCardFilter
    $timestampsUsersfilter: TimestampsByCardFilter
    $includeTimestamps: Boolean! = true
    $includeTimestampDistinctUsers: Boolean! = true
    $includeActiveTimelines: Boolean! = true
    $first: Int
    $skip: Int
  ) {
    timestampsByCard: timestamps @include(if: $includeTimestamps) {
      byCardId(cardId: $cardId, filter: $timestampsFilter, first: $first, skip: $skip) {
        items {
          ...TimestampFields
        }
        meta {
          total
        }
      }
    }
    timestampUsersByCard: timestamps @include(if: $includeTimestampDistinctUsers) {
      byCardId(cardId: $cardId, filter: $timestampsUsersfilter, first: $first, skip: $skip) {
        items {
          user {
            ...PersonFields
          }
        }
        meta {
          total
        }
      }
    }
    activeTimelines @include(if: $includeActiveTimelines) {
      byCardId(cardId: $cardId) {
        items {
          ...ActiveTimelineFields
        }
        meta {
          total
        }
      }
    }
  }
  ${TimestampFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${ActiveTimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class Card_FetchTimeEntitiesGQL extends Apollo.Query<
  Card_FetchTimeEntitiesQuery,
  Card_FetchTimeEntitiesQueryVariables
> {
  document = Card_FetchTimeEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireResponseContextResolver_FetchQuestionnaireResponseDocument = gql`
  query QuestionnaireResponseContextResolver_FetchQuestionnaireResponse($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        questionnaireResponses {
          ...QuestionnaireResponseFields
          questionnaireQuestionResponses {
            ...QuestionnaireQuestionResponseFields
            questionnaireQuestionResponseNotes {
              ...QuestionnaireQuestionResponseNoteFields
            }
          }
          questionnaire {
            ...QuestionnaireFields
            questionnaireSections {
              ...QuestionnaireSectionFields
              questionnaireSectionQuestions {
                ...QuestionnaireSectionQuestionFields
                question {
                  ...QuestionFields
                  choices {
                    ...QuestionChoiceFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${QuestionnaireResponseFieldsFragmentDoc}
  ${QuestionnaireQuestionResponseFieldsFragmentDoc}
  ${QuestionnaireQuestionResponseNoteFieldsFragmentDoc}
  ${QuestionnaireFieldsFragmentDoc}
  ${QuestionnaireSectionFieldsFragmentDoc}
  ${QuestionnaireSectionQuestionFieldsFragmentDoc}
  ${QuestionFieldsFragmentDoc}
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireResponseContextResolver_FetchQuestionnaireResponseGQL extends Apollo.Query<
  QuestionnaireResponseContextResolver_FetchQuestionnaireResponseQuery,
  QuestionnaireResponseContextResolver_FetchQuestionnaireResponseQueryVariables
> {
  document = QuestionnaireResponseContextResolver_FetchQuestionnaireResponseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsDocument = gql`
  query RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeams(
    $filter: SpecialtyTeamFilter
    $skip: Int
    $first: Int
  ) {
    specialtyTeams {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...SpecialtyTeamFields
        }
        meta {
          total
        }
      }
    }
  }
  ${SpecialtyTeamFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsGQL extends Apollo.Query<
  RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsQuery,
  RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsQueryVariables
> {
  document = RequestRequesterSpecialtyTeamFormComponent_FetchAllSpecialtyTeamsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersDocument = gql`
  query SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembers(
    $filter: SpecialtyTeamMemberFilter
  ) {
    specialtyTeamMembers {
      all(filter: $filter) {
        items {
          ...SpecialtyTeamMemberFields
          teamMember {
            ...PersonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${SpecialtyTeamMemberFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersGQL extends Apollo.Query<
  SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersQuery,
  SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersQueryVariables
> {
  document = SpecialtyTeamMemberSelectorComponent_FetchAllSpecialtyTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterInfoComponent_FetchCommunicationCenterDocument = gql`
  query CommunicationCenterInfoComponent_FetchCommunicationCenter($id: ID!) {
    units {
      byId(id: $id) {
        ...UnitFields
        region {
          ...RegionFields
          communicationCenter {
            ...CommunicationCenterFields
          }
        }
      }
    }
  }
  ${UnitFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterInfoComponent_FetchCommunicationCenterGQL extends Apollo.Query<
  CommunicationCenterInfoComponent_FetchCommunicationCenterQuery,
  CommunicationCenterInfoComponent_FetchCommunicationCenterQueryVariables
> {
  document = CommunicationCenterInfoComponent_FetchCommunicationCenterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExternalAgencyInfoComponent_FetchExternalAgencyLocationDocument = gql`
  query ExternalAgencyInfoComponent_FetchExternalAgencyLocation($id: ID!) {
    agencyLocations {
      byId(id: $id) {
        ...AgencyLocationFields
        location {
          ...LocationFields
          address {
            ...AddressFields
          }
        }
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ExternalAgencyInfoComponent_FetchExternalAgencyLocationGQL extends Apollo.Query<
  ExternalAgencyInfoComponent_FetchExternalAgencyLocationQuery,
  ExternalAgencyInfoComponent_FetchExternalAgencyLocationQueryVariables
> {
  document = ExternalAgencyInfoComponent_FetchExternalAgencyLocationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestCandidateUnitContextDocument = gql`
  query FetchRequestCandidateUnitContext($unitId: ID!) {
    units {
      byId(id: $unitId) {
        ...UnitContext
      }
    }
  }
  ${UnitContextFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestCandidateUnitContextGQL extends Apollo.Query<
  FetchRequestCandidateUnitContextQuery,
  FetchRequestCandidateUnitContextQueryVariables
> {
  document = FetchRequestCandidateUnitContextDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestViewComponent_FetchAllSpecialtyTeamMembersDocument = gql`
  query RequestViewComponent_FetchAllSpecialtyTeamMembers($filter: SpecialtyTeamMemberFilter) {
    specialtyTeamMembers {
      all(filter: $filter) {
        items {
          ...SpecialtyTeamMemberFields
          teamMember {
            ...PersonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${SpecialtyTeamMemberFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RequestViewComponent_FetchAllSpecialtyTeamMembersGQL extends Apollo.Query<
  RequestViewComponent_FetchAllSpecialtyTeamMembersQuery,
  RequestViewComponent_FetchAllSpecialtyTeamMembersQueryVariables
> {
  document = RequestViewComponent_FetchAllSpecialtyTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportOfferUnitContextDocument = gql`
  query FetchTransportOfferUnitContext($unitId: ID!) {
    units {
      byId(id: $unitId) {
        ...UnitContext
      }
    }
  }
  ${UnitContextFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportOfferUnitContextGQL extends Apollo.Query<
  FetchTransportOfferUnitContextQuery,
  FetchTransportOfferUnitContextQueryVariables
> {
  document = FetchTransportOfferUnitContextDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportOffersForCardDocument = gql`
  query FetchTransportOffersForCard($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        request {
          transportOffers {
            ...TransportOfferFields
          }
          transportOfferOptions {
            ...TransportOfferOptionFields
          }
        }
      }
    }
  }
  ${TransportOfferFieldsFragmentDoc}
  ${TransportOfferOptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportOffersForCardGQL extends Apollo.Query<
  FetchTransportOffersForCardQuery,
  FetchTransportOffersForCardQueryVariables
> {
  document = FetchTransportOffersForCardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientInfoComponent_FetchCardByCardIdDocument = gql`
  query PatientInfoComponent_FetchCardByCardId($cardId: ID!) {
    cards {
      byId(id: $cardId) {
        ...CardFields
        request {
          ...RequestFields
          requester {
            ...RequesterFields
          }
          patients {
            ...RequestPatientFields
          }
        }
      }
    }
  }
  ${CardFieldsFragmentDoc}
  ${RequestFieldsFragmentDoc}
  ${RequesterFieldsFragmentDoc}
  ${RequestPatientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PatientInfoComponent_FetchCardByCardIdGQL extends Apollo.Query<
  PatientInfoComponent_FetchCardByCardIdQuery,
  PatientInfoComponent_FetchCardByCardIdQueryVariables
> {
  document = PatientInfoComponent_FetchCardByCardIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesDocument = gql`
  query QuestionnaireResponseCards_FetchQuestionnaireResponseEntities(
    $filter: QuestionnaireResponseFilter
    $first: Int
    $skip: Int
  ) {
    questionnaireResponses {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...QuestionnaireResponseFields
          card {
            ...CardFields
            operation {
              ...OperationFields
              unit {
                ...UnitFields
              }
            }
            request {
              ...RequestFields
            }
          }
          questionnaire {
            ...QuestionnaireFields
          }
        }
      }
    }
  }
  ${QuestionnaireResponseFieldsFragmentDoc}
  ${CardFieldsFragmentDoc}
  ${OperationFieldsFragmentDoc}
  ${UnitFieldsFragmentDoc}
  ${RequestFieldsFragmentDoc}
  ${QuestionnaireFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesGQL extends Apollo.Query<
  QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesQuery,
  QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesQueryVariables
> {
  document = QuestionnaireResponseCards_FetchQuestionnaireResponseEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionBoardAllPage_FetchCardsByPatientNameDocument = gql`
  query RegionBoardAllPage_FetchCardsByPatientName(
    $patientNameLike: String!
    $withStatuses: [CardStatus!]
    $first: Int
  ) {
    cards {
      all(
        filter: { patientNameLike: $patientNameLike, withStatuses: $withStatuses }
        first: $first
      ) {
        items {
          ...CardFields
          request {
            ...RequestFields
            patients {
              ...RequestPatientFields
            }
          }
        }
      }
    }
  }
  ${CardFieldsFragmentDoc}
  ${RequestFieldsFragmentDoc}
  ${RequestPatientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RegionBoardAllPage_FetchCardsByPatientNameGQL extends Apollo.Query<
  RegionBoardAllPage_FetchCardsByPatientNameQuery,
  RegionBoardAllPage_FetchCardsByPatientNameQueryVariables
> {
  document = RegionBoardAllPage_FetchCardsByPatientNameDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionBoardVehiclesPageComponent_FetchAllVehiclesDocument = gql`
  query RegionBoardVehiclesPageComponent_FetchAllVehicles(
    $filter: VehicleFilter
    $first: Int
    $skip: Int
  ) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleFields
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RegionBoardVehiclesPageComponent_FetchAllVehiclesGQL extends Apollo.Query<
  RegionBoardVehiclesPageComponent_FetchAllVehiclesQuery,
  RegionBoardVehiclesPageComponent_FetchAllVehiclesQueryVariables
> {
  document = RegionBoardVehiclesPageComponent_FetchAllVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TransferCenterRegionBoardComponent_FetchDocument = gql`
  query TransferCenterRegionBoardComponent_Fetch($regionId: ID!) {
    cards {
      all(
        filter: {
          requestRegionId: $regionId
          withoutStatuses: [Closed]
          withoutRequestStatuses: [Cancelled]
        }
      ) {
        items {
          id
          cardNumber
          request {
            transportOfferOptions {
              requestedVehicleType
            }
            requester {
              transferCenterId
              transferCenterNotes
              careLevelRequested
              transferCenter {
                name
              }
            }
            patients {
              firstName
              lastName
            }
            locations {
              physician {
                firstName
                lastName
              }
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TransferCenterRegionBoardComponent_FetchGQL extends Apollo.Query<
  TransferCenterRegionBoardComponent_FetchQuery,
  TransferCenterRegionBoardComponent_FetchQueryVariables
> {
  document = TransferCenterRegionBoardComponent_FetchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OpsCompanyDataContextService_FetchDocument = gql`
  query OpsCompanyDataContextService_Fetch($dispatchCompanyId: ID!) {
    companies {
      byId(id: $dispatchCompanyId) {
        transferCenters {
          ...TransferCenterFields
        }
        regionGroups {
          ...RegionGroupFields
          department {
            ...DepartmentFields
          }
          regions {
            ...RegionFields
          }
        }
        externalActions {
          ...ExternalActionFields
        }
      }
    }
    activeAlerts {
      all(
        filter: {
          unacknowledgedOnly: true
          excludeEntityOnlyVisibilityType: false
          companyId: $dispatchCompanyId
        }
      ) {
        items {
          ...ActiveAlertFields
        }
        meta {
          total
        }
      }
    }
    positionReportAlerts {
      all(filter: { companyId: $dispatchCompanyId, includeOnlyNoQualifiedReportAlerts: true }) {
        items {
          ...PositionReportAlertFields
        }
      }
    }
    webOrderLogs {
      byActiveCards {
        items {
          ...WebOrderLogFields
        }
      }
    }
  }
  ${TransferCenterFieldsFragmentDoc}
  ${RegionGroupFieldsFragmentDoc}
  ${DepartmentFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${ExternalActionFieldsFragmentDoc}
  ${ActiveAlertFieldsFragmentDoc}
  ${PositionReportAlertFieldsFragmentDoc}
  ${WebOrderLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OpsCompanyDataContextService_FetchGQL extends Apollo.Query<
  OpsCompanyDataContextService_FetchQuery,
  OpsCompanyDataContextService_FetchQueryVariables
> {
  document = OpsCompanyDataContextService_FetchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardAttachmentsDialogComponent_FetchAttachmentsDocument = gql`
  query CardAttachmentsDialogComponent_FetchAttachments($cardId: ID!) {
    attachments {
      all(filter: { entityId: $cardId, entityType: Card }) {
        items {
          ...AttachmentFields
        }
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardAttachmentsDialogComponent_FetchAttachmentsGQL extends Apollo.Query<
  CardAttachmentsDialogComponent_FetchAttachmentsQuery,
  CardAttachmentsDialogComponent_FetchAttachmentsQueryVariables
> {
  document = CardAttachmentsDialogComponent_FetchAttachmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ScheduledAlertsListDialogComponent_FetchActiveAlertsDocument = gql`
  query ScheduledAlertsListDialogComponent_FetchActiveAlerts(
    $filter: ActiveAlertFilter
    $first: Int
    $skip: Int
  ) {
    activeAlerts {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...ActiveAlertFields
          author {
            ...PersonFields
          }
          region {
            ...RegionFields
          }
          communicationCenter {
            ...CommunicationCenterFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${ActiveAlertFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ScheduledAlertsListDialogComponent_FetchActiveAlertsGQL extends Apollo.Query<
  ScheduledAlertsListDialogComponent_FetchActiveAlertsQuery,
  ScheduledAlertsListDialogComponent_FetchActiveAlertsQueryVariables
> {
  document = ScheduledAlertsListDialogComponent_FetchActiveAlertsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const oosEventNotesComponent_FetchOosEventNotesDocument = gql`
  query oosEventNotesComponent_FetchOosEventNotes($id: ID!) {
    outOfServiceEventNotes {
      byOutOfServiceEventId(outOfServiceEventId: $id) {
        items {
          ...OutOfServiceEventNoteFields
        }
      }
    }
  }
  ${OutOfServiceEventNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class oosEventNotesComponent_FetchOosEventNotesGQL extends Apollo.Query<
  oosEventNotesComponent_FetchOosEventNotesQuery,
  oosEventNotesComponent_FetchOosEventNotesQueryVariables
> {
  document = oosEventNotesComponent_FetchOosEventNotesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosEventNotifications_FetchNotificationsDocument = gql`
  query OosEventNotifications_FetchNotifications($filter: NotificationFilter) {
    notifications {
      all(filter: $filter) {
        items {
          ...NotificationFields
          recipients {
            ...NotificationRecipientFields
            message {
              messageStatusUpdates {
                ...MessageStatusUpdateFields
              }
            }
          }
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
  ${NotificationRecipientFieldsFragmentDoc}
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosEventNotifications_FetchNotificationsGQL extends Apollo.Query<
  OosEventNotifications_FetchNotificationsQuery,
  OosEventNotifications_FetchNotificationsQueryVariables
> {
  document = OosEventNotifications_FetchNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosFormComponent_FetchQarReasonsDocument = gql`
  query OosFormComponent_FetchQarReasons {
    outOfServiceQARReasons {
      all {
        items {
          name
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosFormComponent_FetchQarReasonsGQL extends Apollo.Query<
  OosFormComponent_FetchQarReasonsQuery,
  OosFormComponent_FetchQarReasonsQueryVariables
> {
  document = OosFormComponent_FetchQarReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosFormComponent_FetchAllBasesDocument = gql`
  query OosFormComponent_FetchAllBases($filter: BaseFilter, $first: Int, $skip: Int) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          name
          id
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosFormComponent_FetchAllBasesGQL extends Apollo.Query<
  OosFormComponent_FetchAllBasesQuery,
  OosFormComponent_FetchAllBasesQueryVariables
> {
  document = OosFormComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosFormComponent_FetchVehiclesDocument = gql`
  query OosFormComponent_FetchVehicles($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          registrationNumber
          communicationCenterId
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosFormComponent_FetchVehiclesGQL extends Apollo.Query<
  OosFormComponent_FetchVehiclesQuery,
  OosFormComponent_FetchVehiclesQueryVariables
> {
  document = OosFormComponent_FetchVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosFormComponent_FetchMaintenanceFacilitiesDocument = gql`
  query OosFormComponent_FetchMaintenanceFacilities(
    $filter: MaintenanceFacilityFilter
    $skip: Int
    $first: Int
  ) {
    maintenanceFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          name
          id
          locationId
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OosFormComponent_FetchMaintenanceFacilitiesGQL extends Apollo.Query<
  OosFormComponent_FetchMaintenanceFacilitiesQuery,
  OosFormComponent_FetchMaintenanceFacilitiesQueryVariables
> {
  document = OosFormComponent_FetchMaintenanceFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosFormComponent_FetchUnitPositionsByUnitIdDocument = gql`
  query OosFormComponent_FetchUnitPositionsByUnitId($unitId: ID!) {
    units {
      byId(id: $unitId) {
        id
        positions {
          ...UnitPositionFields
        }
      }
    }
  }
  ${UnitPositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosFormComponent_FetchUnitPositionsByUnitIdGQL extends Apollo.Query<
  OosFormComponent_FetchUnitPositionsByUnitIdQuery,
  OosFormComponent_FetchUnitPositionsByUnitIdQueryVariables
> {
  document = OosFormComponent_FetchUnitPositionsByUnitIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosHistoryComponent_FetchHistoryDocument = gql`
  query OosHistoryComponent_FetchHistory(
    $filter: OutOfServiceEventFilter
    $skip: Int
    $first: Int
  ) {
    outOfServiceEvents {
      all(filter: $filter, skip: $skip, first: $first) {
        meta {
          total
        }
        items {
          ...OutOfServiceEventFields
        }
      }
    }
  }
  ${OutOfServiceEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosHistoryComponent_FetchHistoryGQL extends Apollo.Query<
  OosHistoryComponent_FetchHistoryQuery,
  OosHistoryComponent_FetchHistoryQueryVariables
> {
  document = OosHistoryComponent_FetchHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OosService_LoadOosManagerDialagDataDocument = gql`
  query OosService_LoadOosManagerDialagData {
    vehicles {
      all {
        items {
          ...VehicleFields
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OosService_LoadOosManagerDialagDataGQL extends Apollo.Query<
  OosService_LoadOosManagerDialagDataQuery,
  OosService_LoadOosManagerDialagDataQueryVariables
> {
  document = OosService_LoadOosManagerDialagDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardNoteEditHistoryDialogComponent_FetchCardNoteDocument = gql`
  query CardNoteEditHistoryDialogComponent_FetchCardNote($id: ID!) {
    cardNotes {
      byId(id: $id) {
        ...CardNoteFields
        _events {
          meta {
            total
          }
          items {
            messageId
            timestamp
            message {
              messageData
            }
            personId
            person {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
  ${CardNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardNoteEditHistoryDialogComponent_FetchCardNoteGQL extends Apollo.Query<
  CardNoteEditHistoryDialogComponent_FetchCardNoteQuery,
  CardNoteEditHistoryDialogComponent_FetchCardNoteQueryVariables
> {
  document = CardNoteEditHistoryDialogComponent_FetchCardNoteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GroundLegFormComponent_FetchAllLocationsDocument = gql`
  query GroundLegFormComponent_FetchAllLocations($filter: LocationQueryFilter) {
    locations {
      all(filter: $filter) {
        items {
          ...LocationFields
          address {
            ...AddressFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GroundLegFormComponent_FetchAllLocationsGQL extends Apollo.Query<
  GroundLegFormComponent_FetchAllLocationsQuery,
  GroundLegFormComponent_FetchAllLocationsQueryVariables
> {
  document = GroundLegFormComponent_FetchAllLocationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsDocument = gql`
  query MedicalControlContactsDialogComponent_FetchBaseMedicalControlContacts($id: ID!) {
    baseMedicalControlContacts {
      byBaseId(id: $id) {
        items {
          ...BaseMedicalControlContactFields
          person {
            ...PersonFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
          baseMedicalControlContactStates {
            ...BaseMedicalControlContactStateFields
          }
        }
      }
    }
  }
  ${BaseMedicalControlContactFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${BaseMedicalControlContactStateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsGQL extends Apollo.Query<
  MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsQuery,
  MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsQueryVariables
> {
  document = MedicalControlContactsDialogComponent_FetchBaseMedicalControlContactsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesDocument = gql`
  query MileageCalculatorDialogComponent_FetchMedicalFacilityEntities($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        ...MedicalFacilityFields
        location {
          ...LocationFields
        }
        defaultLandingZone {
          ...LocationFields
        }
        defaultFixedWingLandingZone {
          ...LocationFields
        }
        units {
          ...MedicalFacilityUnitFields
        }
        associatedPhysicians {
          ...MedicalFacilityPhysicianFields
          physician {
            ...PhysicianFields
          }
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${MedicalFacilityUnitFieldsFragmentDoc}
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesGQL extends Apollo.Query<
  MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesQuery,
  MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesQueryVariables
> {
  document = MileageCalculatorDialogComponent_FetchMedicalFacilityEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MileageCalculatorDialogComponent_FetchAllBasesDocument = gql`
  query MileageCalculatorDialogComponent_FetchAllBases(
    $filter: BaseFilter
    $first: Int
    $skip: Int
  ) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...BaseFields
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MileageCalculatorDialogComponent_FetchAllBasesGQL extends Apollo.Query<
  MileageCalculatorDialogComponent_FetchAllBasesQuery,
  MileageCalculatorDialogComponent_FetchAllBasesQueryVariables
> {
  document = MileageCalculatorDialogComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MileageCalculatorDialogComponent_FetchAllVehicleModelsDocument = gql`
  query MileageCalculatorDialogComponent_FetchAllVehicleModels(
    $filter: VehicleModelFilter
    $first: Int
    $skip: Int
  ) {
    vehicleModels {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleModelFields
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MileageCalculatorDialogComponent_FetchAllVehicleModelsGQL extends Apollo.Query<
  MileageCalculatorDialogComponent_FetchAllVehicleModelsQuery,
  MileageCalculatorDialogComponent_FetchAllVehicleModelsQueryVariables
> {
  document = MileageCalculatorDialogComponent_FetchAllVehicleModelsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationAddDialogComponent_FetchAllNotificationTemplatesDocument = gql`
  query NotificationAddDialogComponent_FetchAllNotificationTemplates(
    $filter: NotificationTemplateFilter
    $first: Int
    $skip: Int
  ) {
    notificationTemplates {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationTemplateFields
        }
      }
    }
  }
  ${NotificationTemplateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationAddDialogComponent_FetchAllNotificationTemplatesGQL extends Apollo.Query<
  NotificationAddDialogComponent_FetchAllNotificationTemplatesQuery,
  NotificationAddDialogComponent_FetchAllNotificationTemplatesQueryVariables
> {
  document = NotificationAddDialogComponent_FetchAllNotificationTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationAddDialogComponent_FetchNotificationTemplateDetailsDocument = gql`
  query NotificationAddDialogComponent_FetchNotificationTemplateDetails(
    $args: NotificationTemplateRequest
  ) {
    notificationTemplates {
      templateDetails(notificationRequest: $args) {
        activityId
        responseCode
        errors
        data {
          recipients {
            name
            address
          }
          subject
          body
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationAddDialogComponent_FetchNotificationTemplateDetailsGQL extends Apollo.Query<
  NotificationAddDialogComponent_FetchNotificationTemplateDetailsQuery,
  NotificationAddDialogComponent_FetchNotificationTemplateDetailsQueryVariables
> {
  document = NotificationAddDialogComponent_FetchNotificationTemplateDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationsEditDialogComponent_FetchNotificationDocument = gql`
  query NotificationsEditDialogComponent_FetchNotification($notificationId: ID!) {
    notifications {
      byId(id: $notificationId) {
        ...NotificationFields
        recipients {
          ...NotificationRecipientFields
          message {
            messageStatusUpdates {
              ...MessageStatusUpdateFields
            }
          }
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
  ${NotificationRecipientFieldsFragmentDoc}
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationsEditDialogComponent_FetchNotificationGQL extends Apollo.Query<
  NotificationsEditDialogComponent_FetchNotificationQuery,
  NotificationsEditDialogComponent_FetchNotificationQueryVariables
> {
  document = NotificationsEditDialogComponent_FetchNotificationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationsManageDialogComponent_FetchNotificationDocument = gql`
  query NotificationsManageDialogComponent_FetchNotification($notificationId: ID!) {
    notifications {
      byId(id: $notificationId) {
        ...NotificationFields
        recipients {
          ...NotificationRecipientFields
          message {
            messageStatusUpdates {
              ...MessageStatusUpdateFields
            }
          }
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
  ${NotificationRecipientFieldsFragmentDoc}
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationsManageDialogComponent_FetchNotificationGQL extends Apollo.Query<
  NotificationsManageDialogComponent_FetchNotificationQuery,
  NotificationsManageDialogComponent_FetchNotificationQueryVariables
> {
  document = NotificationsManageDialogComponent_FetchNotificationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationsListDialogComponent_FetchNotificationsDocument = gql`
  query NotificationsListDialogComponent_FetchNotifications(
    $filter: NotificationFilter
    $first: Int
    $skip: Int
  ) {
    notifications {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationFields
          recipients {
            ...NotificationRecipientFields
            message {
              messageStatusUpdates {
                ...MessageStatusUpdateFields
              }
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
  ${NotificationRecipientFieldsFragmentDoc}
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationsListDialogComponent_FetchNotificationsGQL extends Apollo.Query<
  NotificationsListDialogComponent_FetchNotificationsQuery,
  NotificationsListDialogComponent_FetchNotificationsQueryVariables
> {
  document = NotificationsListDialogComponent_FetchNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PaipEventManagerDialogComponent_FetchPaipEventsDocument = gql`
  query PaipEventManagerDialogComponent_FetchPaipEvents(
    $filter: PaipEventFilter
    $first: Int
    $skip: Int
  ) {
    paipEvents {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PaipEventFields
        }
        meta {
          total
        }
      }
    }
  }
  ${PaipEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PaipEventManagerDialogComponent_FetchPaipEventsGQL extends Apollo.Query<
  PaipEventManagerDialogComponent_FetchPaipEventsQuery,
  PaipEventManagerDialogComponent_FetchPaipEventsQueryVariables
> {
  document = PaipEventManagerDialogComponent_FetchPaipEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RecipientGroupManageDialogComponent_FetchAllNotificationGroupsDocument = gql`
  query RecipientGroupManageDialogComponent_FetchAllNotificationGroups(
    $filter: NotificationGroupFilter
  ) {
    notificationGroups {
      all(filter: $filter) {
        items {
          ...NotificationGroupFields
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RecipientGroupManageDialogComponent_FetchAllNotificationGroupsGQL extends Apollo.Query<
  RecipientGroupManageDialogComponent_FetchAllNotificationGroupsQuery,
  RecipientGroupManageDialogComponent_FetchAllNotificationGroupsQueryVariables
> {
  document = RecipientGroupManageDialogComponent_FetchAllNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersDocument = gql`
  query RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembers(
    $filter: NotificationGroupMemberFilter
  ) {
    notificationGroupMembers {
      all(filter: $filter) {
        items {
          id
          notificationGroupId
          name
          userId
          user {
            id
            firstName
            lastName
            email
            employeeType
            timeType
            isAviationSupervisor
            notificationAddress
          }
          notificationAddress
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersGQL extends Apollo.Query<
  RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersQuery,
  RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersQueryVariables
> {
  document = RecipientGroupManageDialogComponent_FetchAllNotificationGroupMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TransportAbortDialogComponent_FetchAllVehiclesDocument = gql`
  query TransportAbortDialogComponent_FetchAllVehicles(
    $filter: VehicleFilter
    $first: Int
    $skip: Int
  ) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleFields
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TransportAbortDialogComponent_FetchAllVehiclesGQL extends Apollo.Query<
  TransportAbortDialogComponent_FetchAllVehiclesQuery,
  TransportAbortDialogComponent_FetchAllVehiclesQueryVariables
> {
  document = TransportAbortDialogComponent_FetchAllVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TransportAbortDialogComponent_FetchTransportOffersByCardNumberDocument = gql`
  query TransportAbortDialogComponent_FetchTransportOffersByCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        request {
          transportOffers {
            ...TransportOfferFields
          }
        }
      }
    }
  }
  ${TransportOfferFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TransportAbortDialogComponent_FetchTransportOffersByCardNumberGQL extends Apollo.Query<
  TransportAbortDialogComponent_FetchTransportOffersByCardNumberQuery,
  TransportAbortDialogComponent_FetchTransportOffersByCardNumberQueryVariables
> {
  document = TransportAbortDialogComponent_FetchTransportOffersByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitNoteListComponent_FetchUnitNotesDocument = gql`
  query UnitNoteListComponent_FetchUnitNotes($filter: UnitNoteFilter, $first: Int, $skip: Int) {
    unitNotes {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          authorId
          companyId
          content
          noteTime
          unitId
          unit {
            name
            abbreviation
          }
          author {
            ...PersonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UnitNoteListComponent_FetchUnitNotesGQL extends Apollo.Query<
  UnitNoteListComponent_FetchUnitNotesQuery,
  UnitNoteListComponent_FetchUnitNotesQueryVariables
> {
  document = UnitNoteListComponent_FetchUnitNotesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitShiftListComponent_FetchUnitShiftsDocument = gql`
  query UnitShiftListComponent_FetchUnitShifts($filter: UnitShiftFilter, $first: Int, $skip: Int) {
    unitShifts {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          companyId
          name
          startTimeInMinutes
          endTimeInMinutes
          unitId
          unit {
            name
            abbreviation
          }
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnitShiftListComponent_FetchUnitShiftsGQL extends Apollo.Query<
  UnitShiftListComponent_FetchUnitShiftsQuery,
  UnitShiftListComponent_FetchUnitShiftsQueryVariables
> {
  document = UnitShiftListComponent_FetchUnitShiftsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PassdownLogDetailsComponent_FetchPassdownLogDocument = gql`
  query PassdownLogDetailsComponent_FetchPassdownLog($id: ID!) {
    passdownLogs {
      byId(id: $id) {
        ...PassdownLogFields
        regionIdList
        passdownLogAcknowledgements {
          ...PassdownLogAcknowledgementFields
        }
      }
    }
  }
  ${PassdownLogFieldsFragmentDoc}
  ${PassdownLogAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PassdownLogDetailsComponent_FetchPassdownLogGQL extends Apollo.Query<
  PassdownLogDetailsComponent_FetchPassdownLogQuery,
  PassdownLogDetailsComponent_FetchPassdownLogQueryVariables
> {
  document = PassdownLogDetailsComponent_FetchPassdownLogDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PassdownLogDialogComponent_FetchAllPassdownLogsDocument = gql`
  query PassdownLogDialogComponent_FetchAllPassdownLogs(
    $filter: PassdownLogFilter
    $skip: Int
    $first: Int
  ) {
    passdownLogs {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PassdownLogFields
          regionIdList
          author {
            firstName
            lastName
          }
          acknowledgedBy {
            firstName
            lastName
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
          passdownLogAcknowledgements {
            ...PassdownLogAcknowledgementFields
          }
          passdownLogArchivedLogs {
            archivedBy {
              id
            }
            passdownLogId
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PassdownLogFieldsFragmentDoc}
  ${PassdownLogAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PassdownLogDialogComponent_FetchAllPassdownLogsGQL extends Apollo.Query<
  PassdownLogDialogComponent_FetchAllPassdownLogsQuery,
  PassdownLogDialogComponent_FetchAllPassdownLogsQueryVariables
> {
  document = PassdownLogDialogComponent_FetchAllPassdownLogsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PassdownLogEditHistoryDialogComponent_FetchPassdownLogDocument = gql`
  query PassdownLogEditHistoryDialogComponent_FetchPassdownLog($id: ID!) {
    passdownLogs {
      byId(id: $id) {
        ...PassdownLogFields
        _events {
          meta {
            total
          }
          items {
            messageId
            timestamp
            message {
              messageData
            }
            personId
            person {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
  ${PassdownLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PassdownLogEditHistoryDialogComponent_FetchPassdownLogGQL extends Apollo.Query<
  PassdownLogEditHistoryDialogComponent_FetchPassdownLogQuery,
  PassdownLogEditHistoryDialogComponent_FetchPassdownLogQueryVariables
> {
  document = PassdownLogEditHistoryDialogComponent_FetchPassdownLogDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdDocument = gql`
  query ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityId(
    $id: ID!
  ) {
    medicalFacilities {
      byId(id: $id) {
        units {
          ...MedicalFacilityUnitFields
        }
      }
    }
  }
  ${MedicalFacilityUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdGQL extends Apollo.Query<
  ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdQuery,
  ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdQueryVariables
> {
  document =
    ReceivingFacilityRequestAcceptDialog_FetchMedicalFacilityUnitsByMedicalFacilityIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdDocument = gql`
  query ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityId($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        associatedPhysicians {
          ...MedicalFacilityPhysicianFields
          physician {
            ...PhysicianFields
          }
        }
      }
    }
  }
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdGQL extends Apollo.Query<
  ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdQuery,
  ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdQueryVariables
> {
  document = ReceivingFacilityRequestAcceptDialog_FetchPhysiciansByMedicalFacilityIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesDocument = gql`
  query ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilities(
    $filter: MedicalFacilityFilter
    $skip: Int
    $first: Int
  ) {
    medicalFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...MedicalFacilityFields
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesGQL extends Apollo.Query<
  ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesQuery,
  ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesQueryVariables
> {
  document = ReceivingFacilityRequestHistoryAddDialogComponent_FetchMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesDocument = gql`
  query ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilities(
    $filter: MedicalFacilityFilter
    $skip: Int
    $first: Int
  ) {
    medicalFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...MedicalFacilityFields
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesGQL extends Apollo.Query<
  ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesQuery,
  ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesQueryVariables
> {
  document = ReceivingFacilityRequestReferDialogComponent_FetchMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestCallDialogComponent_FetchAgencyLocationDocument = gql`
  query RequestCallDialogComponent_FetchAgencyLocation($id: ID!) {
    agencyLocations {
      byId(id: $id) {
        ...AgencyLocationFields
        location {
          ...LocationFields
          address {
            ...AddressFields
          }
        }
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RequestCallDialogComponent_FetchAgencyLocationGQL extends Apollo.Query<
  RequestCallDialogComponent_FetchAgencyLocationQuery,
  RequestCallDialogComponent_FetchAgencyLocationQueryVariables
> {
  document = RequestCallDialogComponent_FetchAgencyLocationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancellationFormComponent_FetchAllCancellationCategoriesDocument = gql`
  query CancellationFormComponent_FetchAllCancellationCategories(
    $filter: CancellationCategoryFilter
  ) {
    cancellationCategories {
      all(filter: $filter) {
        items {
          ...CancellationCategoryFields
        }
      }
    }
  }
  ${CancellationCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancellationFormComponent_FetchAllCancellationCategoriesGQL extends Apollo.Query<
  CancellationFormComponent_FetchAllCancellationCategoriesQuery,
  CancellationFormComponent_FetchAllCancellationCategoriesQueryVariables
> {
  document = CancellationFormComponent_FetchAllCancellationCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeclineFormComponent_FetchAllDeclineCategoriesDocument = gql`
  query DeclineFormComponent_FetchAllDeclineCategories($filter: DeclineCategoryFilter) {
    declineCategories {
      all(filter: $filter) {
        items {
          ...DeclineCategoryFields
        }
      }
    }
  }
  ${DeclineCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeclineFormComponent_FetchAllDeclineCategoriesGQL extends Apollo.Query<
  DeclineFormComponent_FetchAllDeclineCategoriesQuery,
  DeclineFormComponent_FetchAllDeclineCategoriesQueryVariables
> {
  document = DeclineFormComponent_FetchAllDeclineCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TransportOfferDeclineComponent_FetchTransportOffersByCardNumberDocument = gql`
  query TransportOfferDeclineComponent_FetchTransportOffersByCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        request {
          transportOffers {
            ...TransportOfferFields
          }
        }
      }
    }
  }
  ${TransportOfferFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TransportOfferDeclineComponent_FetchTransportOffersByCardNumberGQL extends Apollo.Query<
  TransportOfferDeclineComponent_FetchTransportOffersByCardNumberQuery,
  TransportOfferDeclineComponent_FetchTransportOffersByCardNumberQueryVariables
> {
  document = TransportOfferDeclineComponent_FetchTransportOffersByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TransportOfferDeclineComponent_FetchAllDelayReasonsDocument = gql`
  query TransportOfferDeclineComponent_FetchAllDelayReasons {
    requests {
      allAssignmentDelayedReasons {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TransportOfferDeclineComponent_FetchAllDelayReasonsGQL extends Apollo.Query<
  TransportOfferDeclineComponent_FetchAllDelayReasonsQuery,
  TransportOfferDeclineComponent_FetchAllDelayReasonsQueryVariables
> {
  document = TransportOfferDeclineComponent_FetchAllDelayReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdDocument = gql`
  query UnitEditDialogComponent_FetchUnitActivationRuleByUnitId($id: ID!) {
    unitActivationRules {
      byUnitId(id: $id) {
        ...UnitActivationRuleFields
      }
    }
  }
  ${UnitActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdGQL extends Apollo.Query<
  UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdQuery,
  UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdQueryVariables
> {
  document = UnitEditDialogComponent_FetchUnitActivationRuleByUnitIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitEditDialogComponent_FetchUnitEMSystemMappingsDocument = gql`
  query UnitEditDialogComponent_FetchUnitEMSystemMappings(
    $filter: UnitEMSystemMappingFilter
    $skip: Int
    $first: Int
  ) {
    unitEMSystemMappings {
      all(filter: $filter, first: $first, skip: $skip) {
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnitEditDialogComponent_FetchUnitEMSystemMappingsGQL extends Apollo.Query<
  UnitEditDialogComponent_FetchUnitEMSystemMappingsQuery,
  UnitEditDialogComponent_FetchUnitEMSystemMappingsQueryVariables
> {
  document = UnitEditDialogComponent_FetchUnitEMSystemMappingsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitFormComponent_FetchAllCompleteFlightInstancesDocument = gql`
  query UnitFormComponent_FetchAllCompleteFlightInstances {
    completeFlightInstances {
      all {
        items {
          completeFlightInstanceName
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnitFormComponent_FetchAllCompleteFlightInstancesGQL extends Apollo.Query<
  UnitFormComponent_FetchAllCompleteFlightInstancesQuery,
  UnitFormComponent_FetchAllCompleteFlightInstancesQueryVariables
> {
  document = UnitFormComponent_FetchAllCompleteFlightInstancesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitRepositionDialogComponent_FetchVehiclePositionSummaryDocument = gql`
  query UnitRepositionDialogComponent_FetchVehiclePositionSummary($vehicleId: ID!) {
    vehiclePositionSummary {
      byVehicleId(vehicleId: $vehicleId) {
        ...VehiclePositionSummaryFields
      }
    }
  }
  ${VehiclePositionSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UnitRepositionDialogComponent_FetchVehiclePositionSummaryGQL extends Apollo.Query<
  UnitRepositionDialogComponent_FetchVehiclePositionSummaryQuery,
  UnitRepositionDialogComponent_FetchVehiclePositionSummaryQueryVariables
> {
  document = UnitRepositionDialogComponent_FetchVehiclePositionSummaryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnitRepositionDialogComponent_FetchVehicleStateInspectionsDocument = gql`
  query UnitRepositionDialogComponent_FetchVehicleStateInspections($vehicleId: ID!) {
    vehicles {
      byId(id: $vehicleId) {
        vehicleStateInspections {
          ...VehicleStateInspectionFields
        }
      }
    }
  }
  ${VehicleStateInspectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UnitRepositionDialogComponent_FetchVehicleStateInspectionsGQL extends Apollo.Query<
  UnitRepositionDialogComponent_FetchVehicleStateInspectionsQuery,
  UnitRepositionDialogComponent_FetchVehicleStateInspectionsQueryVariables
> {
  document = UnitRepositionDialogComponent_FetchVehicleStateInspectionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitEditContextDocument = gql`
  query FetchUnitEditContext($unitId: ID!) {
    units {
      byId(id: $unitId) {
        ...UnitContext
      }
    }
  }
  ${UnitContextFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitEditContextGQL extends Apollo.Query<
  FetchUnitEditContextQuery,
  FetchUnitEditContextQueryVariables
> {
  document = FetchUnitEditContextDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WebOrderLogsDialog_FetchWebOrderLogsByEntityIdDocument = gql`
  query WebOrderLogsDialog_FetchWebOrderLogsByEntityId($id: ID!) {
    webOrderLogs {
      byEntityId(entityId: $id) {
        items {
          ...WebOrderLogFields
        }
      }
    }
  }
  ${WebOrderLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class WebOrderLogsDialog_FetchWebOrderLogsByEntityIdGQL extends Apollo.Query<
  WebOrderLogsDialog_FetchWebOrderLogsByEntityIdQuery,
  WebOrderLogsDialog_FetchWebOrderLogsByEntityIdQueryVariables
> {
  document = WebOrderLogsDialog_FetchWebOrderLogsByEntityIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardArchivedRecordsFetchService_FetchArchivedCardNotesDocument = gql`
  query CardArchivedRecordsFetchService_FetchArchivedCardNotes($id: ID!) {
    cardNoteArchives {
      byCardId(cardId: $id) {
        items {
          ...CardNoteArchiveFields
        }
      }
    }
  }
  ${CardNoteArchiveFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardArchivedRecordsFetchService_FetchArchivedCardNotesGQL extends Apollo.Query<
  CardArchivedRecordsFetchService_FetchArchivedCardNotesQuery,
  CardArchivedRecordsFetchService_FetchArchivedCardNotesQueryVariables
> {
  document = CardArchivedRecordsFetchService_FetchArchivedCardNotesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardArchivedRecordsFetchService_FetchArchivedPositionReportsDocument = gql`
  query CardArchivedRecordsFetchService_FetchArchivedPositionReports($id: ID!) {
    positionReportArchives {
      byTripId(tripId: $id) {
        items {
          ...PositionReportArchiveFields
        }
      }
    }
  }
  ${PositionReportArchiveFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardArchivedRecordsFetchService_FetchArchivedPositionReportsGQL extends Apollo.Query<
  CardArchivedRecordsFetchService_FetchArchivedPositionReportsQuery,
  CardArchivedRecordsFetchService_FetchArchivedPositionReportsQueryVariables
> {
  document = CardArchivedRecordsFetchService_FetchArchivedPositionReportsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivationRuleDetailsComponent_FetchActivationRuleByIdDocument = gql`
  query ActivationRuleDetailsComponent_FetchActivationRuleById($id: ID!) {
    activationRules {
      byId(id: $id) {
        ...ActivationRuleFields
        company {
          ...CompanyFields
        }
        region {
          ...RegionFields
        }
        base {
          ...BaseFields
        }
        vehicle {
          ...VehicleFields
        }
        unit {
          ...UnitFields
        }
        medicalFacility {
          ...MedicalFacilityFields
        }
        location {
          ...LocationFields
        }
        alerts {
          ...AlertFields
        }
        address {
          ...AddressFields
        }
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${BaseFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${UnitFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AlertFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ActivationRuleDetailsComponent_FetchActivationRuleByIdGQL extends Apollo.Query<
  ActivationRuleDetailsComponent_FetchActivationRuleByIdQuery,
  ActivationRuleDetailsComponent_FetchActivationRuleByIdQueryVariables
> {
  document = ActivationRuleDetailsComponent_FetchActivationRuleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivationRuleForm_GetRegionsDocument = gql`
  query ActivationRuleForm_GetRegions($filter: RegionFilter, $first: Int, $skip: Int) {
    regions {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          name
          communicationCenter {
            id
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ActivationRuleForm_GetRegionsGQL extends Apollo.Query<
  ActivationRuleForm_GetRegionsQuery,
  ActivationRuleForm_GetRegionsQueryVariables
> {
  document = ActivationRuleForm_GetRegionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivationRuleForm_GetCommunicationCentersDocument = gql`
  query ActivationRuleForm_GetCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ActivationRuleForm_GetCommunicationCentersGQL extends Apollo.Query<
  ActivationRuleForm_GetCommunicationCentersQuery,
  ActivationRuleForm_GetCommunicationCentersQueryVariables
> {
  document = ActivationRuleForm_GetCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivationRuleForm_GetActivationRuleIdDocument = gql`
  query ActivationRuleForm_GetActivationRuleId($id: ID!) {
    activationRules {
      byId(id: $id) {
        ...ActivationRuleFields
        medicalFacility {
          ...MedicalFacilityFields
          requesters {
            id
          }
          requests {
            id
          }
        }
        location {
          ...LocationFields
          address {
            ...AddressFields
          }
        }
        address {
          ...AddressFields
        }
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ActivationRuleForm_GetActivationRuleIdGQL extends Apollo.Query<
  ActivationRuleForm_GetActivationRuleIdQuery,
  ActivationRuleForm_GetActivationRuleIdQueryVariables
> {
  document = ActivationRuleForm_GetActivationRuleIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivationRuleForm_GetDeclineReasonsDocument = gql`
  query ActivationRuleForm_GetDeclineReasons($filter: DeclineReasonFilter) {
    declineReasons {
      all(filter: $filter) {
        items {
          ...DeclineReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ActivationRuleForm_GetDeclineReasonsGQL extends Apollo.Query<
  ActivationRuleForm_GetDeclineReasonsQuery,
  ActivationRuleForm_GetDeclineReasonsQueryVariables
> {
  document = ActivationRuleForm_GetDeclineReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AgencyListPageComponent_FetchAgenciesDocument = gql`
  query AgencyListPageComponent_FetchAgencies($filter: AgencyFilter, $first: Int, $skip: Int) {
    agencies {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...AgencyFields
          locations {
            ...AgencyLocationFields
            location {
              ...LocationFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${AgencyFieldsFragmentDoc}
  ${AgencyLocationFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AgencyListPageComponent_FetchAgenciesGQL extends Apollo.Query<
  AgencyListPageComponent_FetchAgenciesQuery,
  AgencyListPageComponent_FetchAgenciesQueryVariables
> {
  document = AgencyListPageComponent_FetchAgenciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AgencyLocationListComponent_FetchAllAgencyLocationsDocument = gql`
  query AgencyLocationListComponent_FetchAllAgencyLocations(
    $filter: AgencyLocationFilter
    $first: Int
    $skip: Int
  ) {
    agencyLocations {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...AgencyLocationFields
          location {
            ...LocationFields
            address {
              ...AddressFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AgencyLocationListComponent_FetchAllAgencyLocationsGQL extends Apollo.Query<
  AgencyLocationListComponent_FetchAllAgencyLocationsQuery,
  AgencyLocationListComponent_FetchAllAgencyLocationsQueryVariables
> {
  document = AgencyLocationListComponent_FetchAllAgencyLocationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AgencyLocationManagePageComponent_FetchAgencyLocationByIdDocument = gql`
  query AgencyLocationManagePageComponent_FetchAgencyLocationById($id: ID!) {
    agencyLocations {
      byId(id: $id) {
        ...AgencyLocationFields
        location {
          ...LocationFields
          address {
            ...AddressFields
          }
        }
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AgencyLocationManagePageComponent_FetchAgencyLocationByIdGQL extends Apollo.Query<
  AgencyLocationManagePageComponent_FetchAgencyLocationByIdQuery,
  AgencyLocationManagePageComponent_FetchAgencyLocationByIdQueryVariables
> {
  document = AgencyLocationManagePageComponent_FetchAgencyLocationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FboListPageComponent_FetchAllFbosDocument = gql`
  query FboListPageComponent_FetchAllFbos($filter: FboFilter, $first: Int, $skip: Int) {
    fbos {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...FboFields
          airports {
            ...AirportFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${FboFieldsFragmentDoc}
  ${AirportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FboListPageComponent_FetchAllFbosGQL extends Apollo.Query<
  FboListPageComponent_FetchAllFbosQuery,
  FboListPageComponent_FetchAllFbosQueryVariables
> {
  document = FboListPageComponent_FetchAllFbosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AirportListPageComponent_FetchAllAirportsDocument = gql`
  query AirportListPageComponent_FetchAllAirports($filter: AirportFilter, $first: Int, $skip: Int) {
    airports {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...AirportFields
          preferredFbo {
            ...FboFields
          }
          location {
            ...LocationFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${AirportFieldsFragmentDoc}
  ${FboFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AirportListPageComponent_FetchAllAirportsGQL extends Apollo.Query<
  AirportListPageComponent_FetchAllAirportsQuery,
  AirportListPageComponent_FetchAllAirportsQueryVariables
> {
  document = AirportListPageComponent_FetchAllAirportsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AlertListPageDocument = gql`
  query AlertListPage($filter: AlertFilter, $first: Int, $skip: Int) {
    alerts {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...AlertFields
          activationRule {
            ...ActivationRuleFields
            medicalFacility {
              ...MedicalFacilityFields
            }
            location {
              ...LocationFields
              address {
                ...AddressFields
              }
            }
            address {
              ...AddressFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${AlertFieldsFragmentDoc}
  ${ActivationRuleFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AlertListPageGQL extends Apollo.Query<
  AlertListPageQuery,
  AlertListPageQueryVariables
> {
  document = AlertListPageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApplicationNotificationFormComponent_FetchAllRegionsDocument = gql`
  query ApplicationNotificationFormComponent_FetchAllRegions(
    $filter: RegionFilter
    $first: Int
    $skip: Int
  ) {
    regions {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...RegionFields
          regionGroup {
            ...RegionGroupFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${RegionFieldsFragmentDoc}
  ${RegionGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ApplicationNotificationFormComponent_FetchAllRegionsGQL extends Apollo.Query<
  ApplicationNotificationFormComponent_FetchAllRegionsQuery,
  ApplicationNotificationFormComponent_FetchAllRegionsQueryVariables
> {
  document = ApplicationNotificationFormComponent_FetchAllRegionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsDocument = gql`
  query ApplicationNotificationListPageComponent_FetchAllApplicationNotifications(
    $filter: ApplicationNotificationFilter
    $first: Int
    $skip: Int
  ) {
    applicationNotifications {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...ApplicationNotificationFields
        }
        meta {
          total
        }
      }
    }
  }
  ${ApplicationNotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsGQL extends Apollo.Query<
  ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsQuery,
  ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsQueryVariables
> {
  document = ApplicationNotificationListPageComponent_FetchAllApplicationNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancellationCategoryFormComponent_FetchAllCancellationReasonsDocument = gql`
  query CancellationCategoryFormComponent_FetchAllCancellationReasons(
    $filter: CancellationReasonFilter
  ) {
    cancellationReasons {
      all(filter: $filter) {
        items {
          ...CancellationReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CancellationReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancellationCategoryFormComponent_FetchAllCancellationReasonsGQL extends Apollo.Query<
  CancellationCategoryFormComponent_FetchAllCancellationReasonsQuery,
  CancellationCategoryFormComponent_FetchAllCancellationReasonsQueryVariables
> {
  document = CancellationCategoryFormComponent_FetchAllCancellationReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancellationCategoryListPageComponent_FetchAllCancellationCategoriesDocument = gql`
  query CancellationCategoryListPageComponent_FetchAllCancellationCategories(
    $filter: CancellationCategoryFilter
  ) {
    cancellationCategories {
      all(filter: $filter) {
        items {
          ...CancellationCategoryFields
          defaultCancellationReason {
            ...CancellationReasonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${CancellationCategoryFieldsFragmentDoc}
  ${CancellationReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancellationCategoryListPageComponent_FetchAllCancellationCategoriesGQL extends Apollo.Query<
  CancellationCategoryListPageComponent_FetchAllCancellationCategoriesQuery,
  CancellationCategoryListPageComponent_FetchAllCancellationCategoriesQueryVariables
> {
  document = CancellationCategoryListPageComponent_FetchAllCancellationCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdDocument = gql`
  query CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonId($id: ID!) {
    cancellationReasons {
      byId(id: $id) {
        cancellationSecondaryReasons {
          ...CancellationSecondaryReasonFields
        }
      }
    }
  }
  ${CancellationSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdGQL extends Apollo.Query<
  CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdQuery,
  CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdQueryVariables
> {
  document = CancellationReasonFormComponent_FetchSecondaryReasonsByCancellationReasonIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancellationReasonListPageComponent_FetchAllCancellationReasonsDocument = gql`
  query CancellationReasonListPageComponent_FetchAllCancellationReasons(
    $filter: CancellationReasonFilter
    $first: Int
    $skip: Int
  ) {
    cancellationReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CancellationReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CancellationReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancellationReasonListPageComponent_FetchAllCancellationReasonsGQL extends Apollo.Query<
  CancellationReasonListPageComponent_FetchAllCancellationReasonsQuery,
  CancellationReasonListPageComponent_FetchAllCancellationReasonsQueryVariables
> {
  document = CancellationReasonListPageComponent_FetchAllCancellationReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdDocument = gql`
  query CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonId(
    $id: ID!
  ) {
    cancellationReasons {
      byId(id: $id) {
        cancellationSecondaryReasons {
          ...CancellationSecondaryReasonFields
        }
      }
    }
  }
  ${CancellationSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdGQL extends Apollo.Query<
  CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdQuery,
  CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdQueryVariables
> {
  document =
    CancellationSeconadaryReasonListComponent_FetchSecondaryReasonsByCancellationReasonIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CapabilityListPageComponent_FetchAllCapabilitiesDocument = gql`
  query CapabilityListPageComponent_FetchAllCapabilities(
    $filter: CapabilityFilter
    $first: Int
    $skip: Int
  ) {
    capabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CapabilityFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CapabilityListPageComponent_FetchAllCapabilitiesGQL extends Apollo.Query<
  CapabilityListPageComponent_FetchAllCapabilitiesQuery,
  CapabilityListPageComponent_FetchAllCapabilitiesQueryVariables
> {
  document = CapabilityListPageComponent_FetchAllCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsDocument = gql`
  query CardReOpenReasonListPageComponent_FetchAllCardReOpenReasons(
    $filter: CardReopenReasonFilter
    $first: Int
    $skip: Int
  ) {
    cardReopenReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CardReOpenReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CardReOpenReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsGQL extends Apollo.Query<
  CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsQuery,
  CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsQueryVariables
> {
  document = CardReOpenReasonListPageComponent_FetchAllCardReOpenReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdDocument = gql`
  query CommunicationCenterDetailPageComponent_FetchCommunicationCenterById($id: ID!) {
    communicationCenters {
      byId(id: $id) {
        ...CommunicationCenterFields
        states
        company {
          ...CompanyFields
        }
        transferCenterRegion {
          ...RegionFields
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdGQL extends Apollo.Query<
  CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdQuery,
  CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdQueryVariables
> {
  document = CommunicationCenterDetailPageComponent_FetchCommunicationCenterByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterListPageComponent_FetchAllCommunicationCentersDocument = gql`
  query CommunicationCenterListPageComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CommunicationCenterFields
          states
          company {
            ...CompanyFields
          }
          transferCenterRegion {
            ...RegionFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterListPageComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  CommunicationCenterListPageComponent_FetchAllCommunicationCentersQuery,
  CommunicationCenterListPageComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = CommunicationCenterListPageComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterRegionsListComponent_FetchRegionsDocument = gql`
  query CommunicationCenterRegionsListComponent_FetchRegions($id: ID!) {
    communicationCenters {
      byId(id: $id) {
        regions {
          ...RegionFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  ${RegionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterRegionsListComponent_FetchRegionsGQL extends Apollo.Query<
  CommunicationCenterRegionsListComponent_FetchRegionsQuery,
  CommunicationCenterRegionsListComponent_FetchRegionsQueryVariables
> {
  document = CommunicationCenterRegionsListComponent_FetchRegionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterTransferCentersListComponent_FetchTransferCentersDocument = gql`
  query CommunicationCenterTransferCentersListComponent_FetchTransferCenters($id: ID!) {
    communicationCenters {
      byId(id: $id) {
        transferCenters {
          ...TransferCenterFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  ${TransferCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterTransferCentersListComponent_FetchTransferCentersGQL extends Apollo.Query<
  CommunicationCenterTransferCentersListComponent_FetchTransferCentersQuery,
  CommunicationCenterTransferCentersListComponent_FetchTransferCentersQueryVariables
> {
  document = CommunicationCenterTransferCentersListComponent_FetchTransferCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsDocument = gql`
  query CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptions(
    $id: ID!
  ) {
    communicationCenters {
      byId(id: $id) {
        communicationCenterTransportOfferOption {
          ...CommunicationCenterTransportOfferOptionFields
        }
      }
    }
  }
  ${CommunicationCenterTransportOfferOptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsGQL extends Apollo.Query<
  CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsQuery,
  CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsQueryVariables
> {
  document =
    CommunicationCenterTransportOffersOptionsDialog_FetchCommunicationCenterTransportOffersOptionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ControlZoneBasesListComponent_FetchBasesDocument = gql`
  query ControlZoneBasesListComponent_FetchBases($controlZoneId: ID!) {
    baseControlZones {
      all(filter: { controlZoneId: $controlZoneId }) {
        items {
          id
          base {
            ...BaseFields
          }
          company {
            ...CompanyFields
          }
          controlZone {
            ...ControlZoneFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ControlZoneBasesListComponent_FetchBasesGQL extends Apollo.Query<
  ControlZoneBasesListComponent_FetchBasesQuery,
  ControlZoneBasesListComponent_FetchBasesQueryVariables
> {
  document = ControlZoneBasesListComponent_FetchBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ControlZoneListPageComponent_FetchAllControlZonesDocument = gql`
  query ControlZoneListPageComponent_FetchAllControlZones(
    $filter: ControlZoneFilter
    $first: Int
    $skip: Int
  ) {
    controlZones {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...ControlZoneFields
          company {
            ...CompanyFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${ControlZoneFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ControlZoneListPageComponent_FetchAllControlZonesGQL extends Apollo.Query<
  ControlZoneListPageComponent_FetchAllControlZonesQuery,
  ControlZoneListPageComponent_FetchAllControlZonesQueryVariables
> {
  document = ControlZoneListPageComponent_FetchAllControlZonesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ControlZoneVehiclesListComponent_FetchVehiclesDocument = gql`
  query ControlZoneVehiclesListComponent_FetchVehicles($controlZoneId: ID!) {
    vehicleControlZones {
      all(filter: { controlZoneId: $controlZoneId }) {
        items {
          id
          vehicle {
            ...VehicleFields
          }
          company {
            ...CompanyFields
          }
          controlZone {
            ...ControlZoneFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ControlZoneVehiclesListComponent_FetchVehiclesGQL extends Apollo.Query<
  ControlZoneVehiclesListComponent_FetchVehiclesQuery,
  ControlZoneVehiclesListComponent_FetchVehiclesQueryVariables
> {
  document = ControlZoneVehiclesListComponent_FetchVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeclineCategoryFormComponent_FetchAllDeclineReasonsDocument = gql`
  query DeclineCategoryFormComponent_FetchAllDeclineReasons($filter: DeclineReasonFilter) {
    declineReasons {
      all(filter: $filter) {
        items {
          ...DeclineReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeclineCategoryFormComponent_FetchAllDeclineReasonsGQL extends Apollo.Query<
  DeclineCategoryFormComponent_FetchAllDeclineReasonsQuery,
  DeclineCategoryFormComponent_FetchAllDeclineReasonsQueryVariables
> {
  document = DeclineCategoryFormComponent_FetchAllDeclineReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeclineCategoryListPageComponent_FetchAllDeclineCategoriesDocument = gql`
  query DeclineCategoryListPageComponent_FetchAllDeclineCategories($filter: DeclineCategoryFilter) {
    declineCategories {
      all(filter: $filter) {
        items {
          ...DeclineCategoryFields
          defaultDeclineReason {
            ...DeclineReasonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${DeclineCategoryFieldsFragmentDoc}
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeclineCategoryListPageComponent_FetchAllDeclineCategoriesGQL extends Apollo.Query<
  DeclineCategoryListPageComponent_FetchAllDeclineCategoriesQuery,
  DeclineCategoryListPageComponent_FetchAllDeclineCategoriesQueryVariables
> {
  document = DeclineCategoryListPageComponent_FetchAllDeclineCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeclineReasonFormComponent_FetchAllDeclineCategoriesDocument = gql`
  query DeclineReasonFormComponent_FetchAllDeclineCategories($filter: DeclineCategoryFilter) {
    declineCategories {
      all(filter: $filter) {
        items {
          ...DeclineCategoryFields
        }
        meta {
          total
        }
      }
    }
  }
  ${DeclineCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeclineReasonFormComponent_FetchAllDeclineCategoriesGQL extends Apollo.Query<
  DeclineReasonFormComponent_FetchAllDeclineCategoriesQuery,
  DeclineReasonFormComponent_FetchAllDeclineCategoriesQueryVariables
> {
  document = DeclineReasonFormComponent_FetchAllDeclineCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeclineReasonListPageComponent_FetchAllDeclineReasonsDocument = gql`
  query DeclineReasonListPageComponent_FetchAllDeclineReasons($filter: DeclineReasonFilter) {
    declineReasons {
      all(filter: $filter) {
        items {
          ...DeclineReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeclineReasonListPageComponent_FetchAllDeclineReasonsGQL extends Apollo.Query<
  DeclineReasonListPageComponent_FetchAllDeclineReasonsQuery,
  DeclineReasonListPageComponent_FetchAllDeclineReasonsQueryVariables
> {
  document = DeclineReasonListPageComponent_FetchAllDeclineReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdDocument = gql`
  query DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonId($id: ID!) {
    declineReasons {
      byId(id: $id) {
        declineSecondaryReasons {
          ...DeclineSecondaryReasonFields
        }
      }
    }
  }
  ${DeclineSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdGQL extends Apollo.Query<
  DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdQuery,
  DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdQueryVariables
> {
  document = DeclineSeconadaryReasonListComponent_FetchSecondaryReasonsByDeclineReasonIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DiversionReasonListPageComponent_FetchAllDiversionReasonsDocument = gql`
  query DiversionReasonListPageComponent_FetchAllDiversionReasons(
    $filter: DiversionReasonFilter
    $first: Int
    $skip: Int
  ) {
    diversionReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...DiversionReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${DiversionReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DiversionReasonListPageComponent_FetchAllDiversionReasonsGQL extends Apollo.Query<
  DiversionReasonListPageComponent_FetchAllDiversionReasonsQuery,
  DiversionReasonListPageComponent_FetchAllDiversionReasonsQueryVariables
> {
  document = DiversionReasonListPageComponent_FetchAllDiversionReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsDocument = gql`
  query FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasons(
    $filter: FacilityNonAcceptanceReasonFilter
    $skip: Int
    $first: Int
  ) {
    facilityNonAcceptanceReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...FacilityNonAcceptanceReasonFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${FacilityNonAcceptanceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsGQL extends Apollo.Query<
  FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsQuery,
  FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsQueryVariables
> {
  document =
    FacilityNonAcceptanceReasonListPageComponent_FetchAllFacilityNonAcceptanceReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FirewallRuleListPageComponent_FetchAllFirewallRulesDocument = gql`
  query FirewallRuleListPageComponent_FetchAllFirewallRules(
    $filter: FirewallRuleFilter
    $first: Int
    $skip: Int
  ) {
    firewallRules {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...FirewallRuleFields
        }
        meta {
          total
        }
      }
    }
  }
  ${FirewallRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FirewallRuleListPageComponent_FetchAllFirewallRulesGQL extends Apollo.Query<
  FirewallRuleListPageComponent_FetchAllFirewallRulesQuery,
  FirewallRuleListPageComponent_FetchAllFirewallRulesQueryVariables
> {
  document = FirewallRuleListPageComponent_FetchAllFirewallRulesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FuelTankListPageComponent_FetchAllFuelTanksDocument = gql`
  query FuelTankListPageComponent_FetchAllFuelTanks(
    $filter: FuelTankFilter
    $first: Int
    $skip: Int
  ) {
    fueltanks {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...FuelTankFields
          location {
            ...LocationFields
            address {
              ...AddressFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${FuelTankFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FuelTankListPageComponent_FetchAllFuelTanksGQL extends Apollo.Query<
  FuelTankListPageComponent_FetchAllFuelTanksQuery,
  FuelTankListPageComponent_FetchAllFuelTanksQueryVariables
> {
  document = FuelTankListPageComponent_FetchAllFuelTanksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FuelTankManagePageComponent_FetchFuelTankByIdDocument = gql`
  query FuelTankManagePageComponent_FetchFuelTankById($id: ID!) {
    fueltanks {
      byId(id: $id) {
        ...FuelTankFields
        location {
          ...LocationFields
        }
      }
    }
  }
  ${FuelTankFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FuelTankManagePageComponent_FetchFuelTankByIdGQL extends Apollo.Query<
  FuelTankManagePageComponent_FetchFuelTankByIdQuery,
  FuelTankManagePageComponent_FetchFuelTankByIdQueryVariables
> {
  document = FuelTankManagePageComponent_FetchFuelTankByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GlobalSettingsFormComponent_FetchAllDeclineReasonsDocument = gql`
  query GlobalSettingsFormComponent_FetchAllDeclineReasons($filter: DeclineReasonFilter) {
    declineReasons {
      all(filter: $filter) {
        items {
          ...DeclineReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsFormComponent_FetchAllDeclineReasonsGQL extends Apollo.Query<
  GlobalSettingsFormComponent_FetchAllDeclineReasonsQuery,
  GlobalSettingsFormComponent_FetchAllDeclineReasonsQueryVariables
> {
  document = GlobalSettingsFormComponent_FetchAllDeclineReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GlobalSettingsFormComponent_FetchAllCancellationReasonsDocument = gql`
  query GlobalSettingsFormComponent_FetchAllCancellationReasons($filter: CancellationReasonFilter) {
    cancellationReasons {
      all(filter: $filter) {
        items {
          ...CancellationReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CancellationReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsFormComponent_FetchAllCancellationReasonsGQL extends Apollo.Query<
  GlobalSettingsFormComponent_FetchAllCancellationReasonsQuery,
  GlobalSettingsFormComponent_FetchAllCancellationReasonsQueryVariables
> {
  document = GlobalSettingsFormComponent_FetchAllCancellationReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsDocument = gql`
  query GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasons {
    declineReasons {
      all {
        items {
          id
          name
        }
      }
    }
    requests {
      allCancellationReasons {
        id
        name
      }
    }
    configurationSettings {
      global {
        ...ConfigurationSettingFields
      }
    }
  }
  ${ConfigurationSettingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsGQL extends Apollo.Query<
  GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsQuery,
  GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsQueryVariables
> {
  document = GlobalSettingsListPageComponent_FetchConfiguredRequestActionReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GlobalSettingsManagePageComponent_FetchConfigurationSettingsDocument = gql`
  query GlobalSettingsManagePageComponent_FetchConfigurationSettings {
    configurationSettings {
      global {
        ...ConfigurationSettingFields
      }
    }
  }
  ${ConfigurationSettingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsManagePageComponent_FetchConfigurationSettingsGQL extends Apollo.Query<
  GlobalSettingsManagePageComponent_FetchConfigurationSettingsQuery,
  GlobalSettingsManagePageComponent_FetchConfigurationSettingsQueryVariables
> {
  document = GlobalSettingsManagePageComponent_FetchConfigurationSettingsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const HazardListComponent_FetchAllLocationHazardsDocument = gql`
  query HazardListComponent_FetchAllLocationHazards($filter: LocationHazardFilter) {
    locationHazards {
      all(filter: $filter) {
        items {
          ...LocationHazardFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${LocationHazardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class HazardListComponent_FetchAllLocationHazardsGQL extends Apollo.Query<
  HazardListComponent_FetchAllLocationHazardsQuery,
  HazardListComponent_FetchAllLocationHazardsQueryVariables
> {
  document = HazardListComponent_FetchAllLocationHazardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsDocument = gql`
  query LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasons {
    landingZoneOutOfServiceReasons {
      all {
        items {
          ...LandingZoneOutOfServiceReasonFields
        }
      }
    }
  }
  ${LandingZoneOutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsGQL extends Apollo.Query<
  LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsQuery,
  LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsQueryVariables
> {
  document = LandingZoneFormComponent_FetchAllLandingZoneOutOfServiceReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LandingZoneListPageComponent_FetchAllLandingZonesDocument = gql`
  query LandingZoneListPageComponent_FetchAllLandingZones($filter: LocationQueryFilter) {
    locations {
      all(filter: $filter) {
        items {
          ...LocationFields
          address {
            ...AddressFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LandingZoneListPageComponent_FetchAllLandingZonesGQL extends Apollo.Query<
  LandingZoneListPageComponent_FetchAllLandingZonesQuery,
  LandingZoneListPageComponent_FetchAllLandingZonesQueryVariables
> {
  document = LandingZoneListPageComponent_FetchAllLandingZonesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesDocument = gql`
  query MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilities(
    $filter: MaintenanceFacilityFilter
    $skip: Int
    $first: Int
  ) {
    maintenanceFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...MaintenanceFacilityFields
          location {
            ...LocationFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${MaintenanceFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesGQL extends Apollo.Query<
  MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesQuery,
  MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesQueryVariables
> {
  document = MaintenanceFacilitiesListPageComponent_FetchMaintenanceFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdDocument = gql`
  query MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityById($id: ID!) {
    maintenanceFacilities {
      byId(id: $id) {
        ...MaintenanceFacilityFields
        ...MaintenanceFacilityFields
        location {
          ...LocationFields
        }
        lastUpdatedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
  ${MaintenanceFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdGQL extends Apollo.Query<
  MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdQuery,
  MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdQueryVariables
> {
  document = MaintenanceFacilitiesEditPageComponent_FetchMaintenanceFacilityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesDocument = gql`
  query MedicalFacilitiesListPageComponent_FetchMedicalFacilities(
    $filter: MedicalFacilityFilter
    $skip: Int
    $first: Int
  ) {
    medicalFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...MedicalFacilityFields
          location {
            ...LocationFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesGQL extends Apollo.Query<
  MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesQuery,
  MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesQueryVariables
> {
  document = MedicalFacilitiesListPageComponent_FetchMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicaFacilityContactListComponent_FetchMedicalFacilityContactsDocument = gql`
  query MedicaFacilityContactListComponent_FetchMedicalFacilityContacts($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        contacts {
          ...MedicalFacilityContactFields
        }
      }
    }
  }
  ${MedicalFacilityContactFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicaFacilityContactListComponent_FetchMedicalFacilityContactsGQL extends Apollo.Query<
  MedicaFacilityContactListComponent_FetchMedicalFacilityContactsQuery,
  MedicaFacilityContactListComponent_FetchMedicalFacilityContactsQueryVariables
> {
  document = MedicaFacilityContactListComponent_FetchMedicalFacilityContactsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesDocument = gql`
  query MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntities($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        ...MedicalFacilityFields
        location {
          ...LocationFields
        }
        defaultLandingZone {
          ...LocationFields
        }
        defaultFixedWingLandingZone {
          ...LocationFields
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesGQL extends Apollo.Query<
  MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesQuery,
  MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesQueryVariables
> {
  document = MedicalFacilitiesDetailPageComponent_FetchMedicalFacilityDetailEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesDocument = gql`
  query MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilities(
    $filter: EntityCapabilityFilter
    $first: Int
    $skip: Int
  ) {
    entityCapabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...EntityCapabilityFields
          capability {
            ...CapabilityFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${EntityCapabilityFieldsFragmentDoc}
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesGQL extends Apollo.Query<
  MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesQuery,
  MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesQueryVariables
> {
  document = MedicalFacilitiesDetailPageComponent_FetchAllEntityCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesDocument = gql`
  query MedicalFacilityEditPageComponent_FetchMedicalFacilityEntities($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        ...MedicalFacilityFields
        location {
          ...LocationFields
        }
        defaultLandingZone {
          ...LocationFields
        }
        defaultFixedWingLandingZone {
          ...LocationFields
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesGQL extends Apollo.Query<
  MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesQuery,
  MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesQueryVariables
> {
  document = MedicalFacilityEditPageComponent_FetchMedicalFacilityEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilityFormComponent_FetchAllCapabilitiesDocument = gql`
  query MedicalFacilityFormComponent_FetchAllCapabilities(
    $filter: CapabilityFilter
    $first: Int
    $skip: Int
  ) {
    capabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CapabilityFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilityFormComponent_FetchAllCapabilitiesGQL extends Apollo.Query<
  MedicalFacilityFormComponent_FetchAllCapabilitiesQuery,
  MedicalFacilityFormComponent_FetchAllCapabilitiesQueryVariables
> {
  document = MedicalFacilityFormComponent_FetchAllCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilityFormComponent_FetchAllEntityCapabilitiesDocument = gql`
  query MedicalFacilityFormComponent_FetchAllEntityCapabilities(
    $filter: EntityCapabilityFilter
    $first: Int
    $skip: Int
  ) {
    entityCapabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...EntityCapabilityFields
          capability {
            ...CapabilityFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${EntityCapabilityFieldsFragmentDoc}
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilityFormComponent_FetchAllEntityCapabilitiesGQL extends Apollo.Query<
  MedicalFacilityFormComponent_FetchAllEntityCapabilitiesQuery,
  MedicalFacilityFormComponent_FetchAllEntityCapabilitiesQueryVariables
> {
  document = MedicalFacilityFormComponent_FetchAllEntityCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilityFormComponent_FetchMedicalFacilitiesDocument = gql`
  query MedicalFacilityFormComponent_FetchMedicalFacilities(
    $filter: MedicalFacilityFilter
    $skip: Int
    $first: Int
  ) {
    medicalFacilities {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...MedicalFacilityFields
          location {
            ...LocationFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilityFormComponent_FetchMedicalFacilitiesGQL extends Apollo.Query<
  MedicalFacilityFormComponent_FetchMedicalFacilitiesQuery,
  MedicalFacilityFormComponent_FetchMedicalFacilitiesQueryVariables
> {
  document = MedicalFacilityFormComponent_FetchMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoDocument = gql`
  query MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfo($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        ...MedicalFacilityFields
        contacts {
          id
        }
        location {
          locationHazards {
            id
          }
        }
        activationRules {
          id
        }
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoGQL extends Apollo.Query<
  MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoQuery,
  MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoQueryVariables
> {
  document = MergeMedicalFacilityDialogComponent_FetchMedicalFacilityInfoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansDocument = gql`
  query MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysicians($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        associatedPhysicians {
          ...MedicalFacilityPhysicianFields
          physician {
            ...PhysicianFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansGQL extends Apollo.Query<
  MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansQuery,
  MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansQueryVariables
> {
  document = MedicaFacilityPhysiciansListComponent_FetchMedicalFacilityPhysiciansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsDocument = gql`
  query MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnits($id: ID!) {
    medicalFacilities {
      byId(id: $id) {
        units {
          ...MedicalFacilityUnitFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  ${MedicalFacilityUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsGQL extends Apollo.Query<
  MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsQuery,
  MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsQueryVariables
> {
  document = MedicaFacilityUnitsListComponent_FetchMedicalFacilityUnitsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NonReferralReasonListPageComponent_FetchAllNonReferralReasonsDocument = gql`
  query NonReferralReasonListPageComponent_FetchAllNonReferralReasons(
    $filter: NonReferralReasonFilter
    $skip: Int
    $first: Int
  ) {
    nonReferralReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NonReferralReasonFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${NonReferralReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NonReferralReasonListPageComponent_FetchAllNonReferralReasonsGQL extends Apollo.Query<
  NonReferralReasonListPageComponent_FetchAllNonReferralReasonsQuery,
  NonReferralReasonListPageComponent_FetchAllNonReferralReasonsQueryVariables
> {
  document = NonReferralReasonListPageComponent_FetchAllNonReferralReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationTemplateListPageComponent_FetchAllNotificationTemplatesDocument = gql`
  query NotificationTemplateListPageComponent_FetchAllNotificationTemplates(
    $filter: NotificationTemplateFilter
    $first: Int
    $skip: Int
  ) {
    notificationTemplates {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationTemplateFields
          company {
            ...CompanyFields
          }
          activationRule {
            ...ActivationRuleFields
            medicalFacility {
              ...MedicalFacilityFields
            }
            location {
              ...LocationFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationTemplateFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ActivationRuleFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationTemplateListPageComponent_FetchAllNotificationTemplatesGQL extends Apollo.Query<
  NotificationTemplateListPageComponent_FetchAllNotificationTemplatesQuery,
  NotificationTemplateListPageComponent_FetchAllNotificationTemplatesQueryVariables
> {
  document = NotificationTemplateListPageComponent_FetchAllNotificationTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OfferAlgorithmFormComponent_FetchAgencyLocationsDocument = gql`
  query OfferAlgorithmFormComponent_FetchAgencyLocations(
    $filter: AgencyLocationFilter
    $first: Int
    $skip: Int
  ) {
    agencyLocations {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...AgencyLocationFields
        }
        meta {
          total
        }
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OfferAlgorithmFormComponent_FetchAgencyLocationsGQL extends Apollo.Query<
  OfferAlgorithmFormComponent_FetchAgencyLocationsQuery,
  OfferAlgorithmFormComponent_FetchAgencyLocationsQueryVariables
> {
  document = OfferAlgorithmFormComponent_FetchAgencyLocationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsDocument = gql`
  query OfferAlgorithmListPageComponent_FetchAllOfferAlgorithms(
    $filter: OfferAlgorithmFilter
    $first: Int
    $skip: Int
  ) {
    offerAlgorithms {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...OfferAlgorithmFields
          activationRule {
            ...ActivationRuleFields
            medicalFacility {
              ...MedicalFacilityFields
            }
            location {
              ...LocationFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${OfferAlgorithmFieldsFragmentDoc}
  ${ActivationRuleFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsGQL extends Apollo.Query<
  OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsQuery,
  OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsQueryVariables
> {
  document = OfferAlgorithmListPageComponent_FetchAllOfferAlgorithmsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OktaDirectoryListComponent_FetchOktaUsersDocument = gql`
  query OktaDirectoryListComponent_FetchOktaUsers($filter: OktaUserFilter, $first: Int) {
    okta {
      allUsers(filter: $filter, first: $first) {
        items {
          id
          profile {
            login
            firstName
            lastName
            email
            employeeNumber
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OktaDirectoryListComponent_FetchOktaUsersGQL extends Apollo.Query<
  OktaDirectoryListComponent_FetchOktaUsersQuery,
  OktaDirectoryListComponent_FetchOktaUsersQueryVariables
> {
  document = OktaDirectoryListComponent_FetchOktaUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdDocument = gql`
  query OktaProfileDetailPageComponent_FetchOktaDetailEntitiesById($idOrLogin: ID!) {
    okta {
      user(idOrLogin: $idOrLogin) {
        id
        status
        lastUpdated
        created
        profile {
          login
          firstName
          lastName
          email
          employeeNumber
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdGQL extends Apollo.Query<
  OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdQuery,
  OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdQueryVariables
> {
  document = OktaProfileDetailPageComponent_FetchOktaDetailEntitiesByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivationRuleManageDialog_GetActivationRuleIdDocument = gql`
  query ActivationRuleManageDialog_GetActivationRuleId($id: ID!) {
    activationRules {
      byId(id: $id) {
        ...ActivationRuleFields
        medicalFacility {
          ...MedicalFacilityFields
          requesters {
            id
          }
          requests {
            id
          }
        }
        location {
          ...LocationFields
          address {
            ...AddressFields
          }
        }
        address {
          ...AddressFields
        }
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ActivationRuleManageDialog_GetActivationRuleIdGQL extends Apollo.Query<
  ActivationRuleManageDialog_GetActivationRuleIdQuery,
  ActivationRuleManageDialog_GetActivationRuleIdQueryVariables
> {
  document = ActivationRuleManageDialog_GetActivationRuleIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterRegionDialog_FetchUnitsByRegionIdDocument = gql`
  query CommunicationCenterRegionDialog_FetchUnitsByRegionId(
    $regionId: ID
    $includeHidden: Boolean
  ) {
    units {
      all(filter: { regionId: $regionId, includeHidden: $includeHidden }) {
        items {
          ...UnitFields
        }
      }
    }
  }
  ${UnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterRegionDialog_FetchUnitsByRegionIdGQL extends Apollo.Query<
  CommunicationCenterRegionDialog_FetchUnitsByRegionIdQuery,
  CommunicationCenterRegionDialog_FetchUnitsByRegionIdQueryVariables
> {
  document = CommunicationCenterRegionDialog_FetchUnitsByRegionIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersDocument = gql`
  query CommunicationCenterRegionFormComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CommunicationCenterFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersQuery,
  CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = CommunicationCenterRegionFormComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ControlZoneBaseForm_GetBasesDocument = gql`
  query ControlZoneBaseForm_GetBases($filter: BaseFilter, $first: Int, $skip: Int) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...BaseFields
          company {
            companyCode
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ControlZoneBaseForm_GetBasesGQL extends Apollo.Query<
  ControlZoneBaseForm_GetBasesQuery,
  ControlZoneBaseForm_GetBasesQueryVariables
> {
  document = ControlZoneBaseForm_GetBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ControlZoneVehicleForm_GetVehiclesDocument = gql`
  query ControlZoneVehicleForm_GetVehicles($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleFields
          company {
            companyCode
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ControlZoneVehicleForm_GetVehiclesGQL extends Apollo.Query<
  ControlZoneVehicleForm_GetVehiclesQuery,
  ControlZoneVehicleForm_GetVehiclesQueryVariables
> {
  document = ControlZoneVehicleForm_GetVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const HazardEditDialogComponent_FetchLocationHazardAttachmentsDocument = gql`
  query HazardEditDialogComponent_FetchLocationHazardAttachments($id: ID!) {
    locationHazards {
      byId(id: $id) {
        locationHazardAttachments {
          ...LocationHazardAttachmentFields
        }
      }
    }
  }
  ${LocationHazardAttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class HazardEditDialogComponent_FetchLocationHazardAttachmentsGQL extends Apollo.Query<
  HazardEditDialogComponent_FetchLocationHazardAttachmentsQuery,
  HazardEditDialogComponent_FetchLocationHazardAttachmentsQueryVariables
> {
  document = HazardEditDialogComponent_FetchLocationHazardAttachmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansDocument = gql`
  query MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysicians(
    $filter: PhysicianFilter
    $skip: Int
    $first: Int
  ) {
    physicians {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PhysicianFields
        }
        meta {
          total
        }
      }
    }
  }
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansGQL extends Apollo.Query<
  MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansQuery,
  MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansQueryVariables
> {
  document = MedicalFacilityAssociatedPhysicianFormComponent_FetchAllPhysiciansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationGroupListDialogComponent_FetchAllNotificationGroupsDocument = gql`
  query NotificationGroupListDialogComponent_FetchAllNotificationGroups(
    $filter: NotificationGroupFilter
    $first: Int
    $skip: Int
  ) {
    notificationGroups {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationGroupFields
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationGroupListDialogComponent_FetchAllNotificationGroupsGQL extends Apollo.Query<
  NotificationGroupListDialogComponent_FetchAllNotificationGroupsQuery,
  NotificationGroupListDialogComponent_FetchAllNotificationGroupsQueryVariables
> {
  document = NotificationGroupListDialogComponent_FetchAllNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersDocument = gql`
  query NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembers(
    $filter: NotificationGroupMemberFilter
    $first: Int
    $skip: Int
  ) {
    notificationGroupMembers {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          notificationGroupId
          name
          userId
          user {
            id
            firstName
            lastName
            email
            employeeType
            timeType
            isAviationSupervisor
            notificationAddress
          }
          notificationAddress
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersGQL extends Apollo.Query<
  NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersQuery,
  NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersQueryVariables
> {
  document = NotificationGroupMemberListDialogComponent_FetchAllNotificationGroupMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PersonBaseMedicalControlContactFormComponent_FetchAllBasesDocument = gql`
  query PersonBaseMedicalControlContactFormComponent_FetchAllBases(
    $filter: BaseFilter
    $first: Int
    $skip: Int
  ) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          name
          id
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PersonBaseMedicalControlContactFormComponent_FetchAllBasesGQL extends Apollo.Query<
  PersonBaseMedicalControlContactFormComponent_FetchAllBasesQuery,
  PersonBaseMedicalControlContactFormComponent_FetchAllBasesQueryVariables
> {
  document = PersonBaseMedicalControlContactFormComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsDocument = gql`
  query UserNotificationGroupsDialogComponent_FetchAllNotificationGroups(
    $filter: NotificationGroupFilter
  ) {
    notificationGroups {
      all(filter: $filter) {
        items {
          ...NotificationGroupFields
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsGQL extends Apollo.Query<
  UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsQuery,
  UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsQueryVariables
> {
  document = UserNotificationGroupsDialogComponent_FetchAllNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsDocument = gql`
  query UserNotificationGroupsDialogComponent_FetchUserNotificationGroups($personId: ID!) {
    notificationGroups {
      byPerson(personId: $personId) {
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsGQL extends Apollo.Query<
  UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsQuery,
  UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsQueryVariables
> {
  document = UserNotificationGroupsDialogComponent_FetchUserNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleMaintenanceFormComponent_FetchAllNextDueTypesDocument = gql`
  query VehicleMaintenanceFormComponent_FetchAllNextDueTypes(
    $filter: NextDueTypeFilter
    $first: Int
    $skip: Int
  ) {
    nextDueTypes {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          name
          dataType
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleMaintenanceFormComponent_FetchAllNextDueTypesGQL extends Apollo.Query<
  VehicleMaintenanceFormComponent_FetchAllNextDueTypesQuery,
  VehicleMaintenanceFormComponent_FetchAllNextDueTypesQueryVariables
> {
  document = VehicleMaintenanceFormComponent_FetchAllNextDueTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsDocument = gql`
  query OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasons(
    $filter: OutOfServiceReasonFilter
    $first: Int
    $skip: Int
  ) {
    outOfServiceReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...OutOfServiceReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${OutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsGQL extends Apollo.Query<
  OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsQuery,
  OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsQueryVariables
> {
  document = OutOfServiceReasonListPageComponent_FetchAllOutOfServiceReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdDocument = gql`
  query OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonId($id: ID!) {
    outOfServiceReasons {
      byId(id: $id) {
        outOfServiceSecondaryReasons {
          ...OutOfServiceSecondaryReasonFields
        }
      }
    }
  }
  ${OutOfServiceSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdGQL extends Apollo.Query<
  OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdQuery,
  OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdQueryVariables
> {
  document =
    OutOfServiceSeconadaryReasonListComponent_FetchSecondaryReasonsByPrimaryReasonIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PaipReasonListPageComponent_FetchAllPaipReasonsDocument = gql`
  query PaipReasonListPageComponent_FetchAllPaipReasons(
    $filter: PaipReasonFilter
    $first: Int
    $skip: Int
  ) {
    paipReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PaipReasonFields
          outOfServiceReason {
            ...OutOfServiceReasonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PaipReasonFieldsFragmentDoc}
  ${OutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PaipReasonListPageComponent_FetchAllPaipReasonsGQL extends Apollo.Query<
  PaipReasonListPageComponent_FetchAllPaipReasonsQuery,
  PaipReasonListPageComponent_FetchAllPaipReasonsQueryVariables
> {
  document = PaipReasonListPageComponent_FetchAllPaipReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PhysicianListPageComponent_FetchAllPhysiciansDocument = gql`
  query PhysicianListPageComponent_FetchAllPhysicians(
    $filter: PhysicianFilter
    $skip: Int
    $first: Int
  ) {
    physicians {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PhysicianFields
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PhysicianListPageComponent_FetchAllPhysiciansGQL extends Apollo.Query<
  PhysicianListPageComponent_FetchAllPhysiciansQuery,
  PhysicianListPageComponent_FetchAllPhysiciansQueryVariables
> {
  document = PhysicianListPageComponent_FetchAllPhysiciansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesDocument = gql`
  query PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilities($id: ID!) {
    physicians {
      byId(id: $id) {
        medicalFacilities {
          ...MedicalFacilityPhysicianFields
          medicalFacility {
            ...MedicalFacilityFields
            location {
              ...LocationFields
            }
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
  ${MedicalFacilityFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesGQL extends Apollo.Query<
  PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesQuery,
  PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesQueryVariables
> {
  document = PhysicianMedicalFacilitiesListComponent_FetchPhysicianMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QarReasonListPageComponent_FetchAllQarReasonsDocument = gql`
  query QarReasonListPageComponent_FetchAllQarReasons(
    $filter: OutOfServiceQARReasonFilter
    $first: Int
    $skip: Int
  ) {
    outOfServiceQARReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...OutOfServiceQARReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${OutOfServiceQARReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QarReasonListPageComponent_FetchAllQarReasonsGQL extends Apollo.Query<
  QarReasonListPageComponent_FetchAllQarReasonsQuery,
  QarReasonListPageComponent_FetchAllQarReasonsQueryVariables
> {
  document = QarReasonListPageComponent_FetchAllQarReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireDetailPageComponent_FetchQuestionnaireByIdDocument = gql`
  query QuestionnaireDetailPageComponent_FetchQuestionnaireById($id: ID!) {
    questionnaires {
      byId(id: $id) {
        ...QuestionnaireFields
        questionnaireSections {
          ...QuestionnaireSectionFields
          questionnaireSectionQuestions {
            ...QuestionnaireSectionQuestionFields
            question {
              ...QuestionFields
              choices {
                ...QuestionChoiceFields
              }
            }
            activationRule {
              ...ActivationRuleFields
            }
          }
        }
      }
    }
  }
  ${QuestionnaireFieldsFragmentDoc}
  ${QuestionnaireSectionFieldsFragmentDoc}
  ${QuestionnaireSectionQuestionFieldsFragmentDoc}
  ${QuestionFieldsFragmentDoc}
  ${QuestionChoiceFieldsFragmentDoc}
  ${ActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireDetailPageComponent_FetchQuestionnaireByIdGQL extends Apollo.Query<
  QuestionnaireDetailPageComponent_FetchQuestionnaireByIdQuery,
  QuestionnaireDetailPageComponent_FetchQuestionnaireByIdQueryVariables
> {
  document = QuestionnaireDetailPageComponent_FetchQuestionnaireByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireFormComponent_FetchAllCommunicationCentersDocument = gql`
  query QuestionnaireFormComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CommunicationCenterFields
          company {
            ...CompanyFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireFormComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  QuestionnaireFormComponent_FetchAllCommunicationCentersQuery,
  QuestionnaireFormComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = QuestionnaireFormComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireListPageComponent_FetchQuestionnairesDocument = gql`
  query QuestionnaireListPageComponent_FetchQuestionnaires(
    $filter: QuestionnaireFilter
    $skip: Int
    $first: Int
  ) {
    questionnaires {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...QuestionnaireFields
        }
        meta {
          total
        }
      }
    }
  }
  ${QuestionnaireFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireListPageComponent_FetchQuestionnairesGQL extends Apollo.Query<
  QuestionnaireListPageComponent_FetchQuestionnairesQuery,
  QuestionnaireListPageComponent_FetchQuestionnairesQueryVariables
> {
  document = QuestionnaireListPageComponent_FetchQuestionnairesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireManagePageComponent_FetchQuestionnaireByIdDocument = gql`
  query QuestionnaireManagePageComponent_FetchQuestionnaireById($id: ID!) {
    questionnaires {
      byId(id: $id) {
        ...QuestionnaireFields
        questionnaireSections {
          ...QuestionnaireSectionFields
          questionnaireSectionQuestions {
            ...QuestionnaireSectionQuestionFields
          }
        }
      }
    }
  }
  ${QuestionnaireFieldsFragmentDoc}
  ${QuestionnaireSectionFieldsFragmentDoc}
  ${QuestionnaireSectionQuestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireManagePageComponent_FetchQuestionnaireByIdGQL extends Apollo.Query<
  QuestionnaireManagePageComponent_FetchQuestionnaireByIdQuery,
  QuestionnaireManagePageComponent_FetchQuestionnaireByIdQueryVariables
> {
  document = QuestionnaireManagePageComponent_FetchQuestionnaireByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdDocument = gql`
  query QuestionnaireSectionQuestionFormComponent_FetchActivationRuleById($id: ID!) {
    activationRules {
      byId(id: $id) {
        ...ActivationRuleFields
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdGQL extends Apollo.Query<
  QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdQuery,
  QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdQueryVariables
> {
  document = QuestionnaireSectionQuestionFormComponent_FetchActivationRuleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionnaireContextResolverService_FetchQuestionsDocument = gql`
  query QuestionnaireContextResolverService_FetchQuestions(
    $filter: QuestionFilter
    $skip: Int
    $first: Int
  ) {
    questions {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...QuestionFields
          choices {
            ...QuestionChoiceFields
          }
        }
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireContextResolverService_FetchQuestionsGQL extends Apollo.Query<
  QuestionnaireContextResolverService_FetchQuestionsQuery,
  QuestionnaireContextResolverService_FetchQuestionsQueryVariables
> {
  document = QuestionnaireContextResolverService_FetchQuestionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionDetailPageComponent_FetchQuestionByIdDocument = gql`
  query QuestionDetailPageComponent_FetchQuestionById($id: ID!) {
    questions {
      byId(id: $id) {
        ...QuestionFields
        choices {
          ...QuestionChoiceFields
        }
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionDetailPageComponent_FetchQuestionByIdGQL extends Apollo.Query<
  QuestionDetailPageComponent_FetchQuestionByIdQuery,
  QuestionDetailPageComponent_FetchQuestionByIdQueryVariables
> {
  document = QuestionDetailPageComponent_FetchQuestionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionListPageComponent_FetchQuestionsDocument = gql`
  query QuestionListPageComponent_FetchQuestions($filter: QuestionFilter, $skip: Int, $first: Int) {
    questions {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...QuestionFields
          choices {
            ...QuestionChoiceFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionListPageComponent_FetchQuestionsGQL extends Apollo.Query<
  QuestionListPageComponent_FetchQuestionsQuery,
  QuestionListPageComponent_FetchQuestionsQueryVariables
> {
  document = QuestionListPageComponent_FetchQuestionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QuestionManagePageComponent_FetchQuestionByIdDocument = gql`
  query QuestionManagePageComponent_FetchQuestionById($id: ID!) {
    questions {
      byId(id: $id) {
        ...QuestionFields
        choices {
          ...QuestionChoiceFields
        }
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class QuestionManagePageComponent_FetchQuestionByIdGQL extends Apollo.Query<
  QuestionManagePageComponent_FetchQuestionByIdQuery,
  QuestionManagePageComponent_FetchQuestionByIdQueryVariables
> {
  document = QuestionManagePageComponent_FetchQuestionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TimelineDetailPageComponent_FetchTimelineByIdDocument = gql`
  query TimelineDetailPageComponent_FetchTimelineById($id: ID!) {
    timelines {
      byId(id: $id) {
        ...TimelineFields
        company {
          ...CompanyFields
        }
        activationRule {
          ...ActivationRuleFields
        }
        items {
          ...TimelineItemFields
          timestampType {
            ...TimestampTypeFields
          }
        }
      }
    }
  }
  ${TimelineFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ActivationRuleFieldsFragmentDoc}
  ${TimelineItemFieldsFragmentDoc}
  ${TimestampTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TimelineDetailPageComponent_FetchTimelineByIdGQL extends Apollo.Query<
  TimelineDetailPageComponent_FetchTimelineByIdQuery,
  TimelineDetailPageComponent_FetchTimelineByIdQueryVariables
> {
  document = TimelineDetailPageComponent_FetchTimelineByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TimelineFormComponent_FetchActivationRuleByIdDocument = gql`
  query TimelineFormComponent_FetchActivationRuleById($id: ID!) {
    activationRules {
      byId(id: $id) {
        ...ActivationRuleFields
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TimelineFormComponent_FetchActivationRuleByIdGQL extends Apollo.Query<
  TimelineFormComponent_FetchActivationRuleByIdQuery,
  TimelineFormComponent_FetchActivationRuleByIdQueryVariables
> {
  document = TimelineFormComponent_FetchActivationRuleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TimelineListPageComponent_FetchTimelinesDocument = gql`
  query TimelineListPageComponent_FetchTimelines($filter: TimelineFilter, $skip: Int, $first: Int) {
    timelines {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...TimelineFields
          company {
            ...CompanyFields
          }
          activationRule {
            ...ActivationRuleFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${TimelineFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TimelineListPageComponent_FetchTimelinesGQL extends Apollo.Query<
  TimelineListPageComponent_FetchTimelinesQuery,
  TimelineListPageComponent_FetchTimelinesQueryVariables
> {
  document = TimelineListPageComponent_FetchTimelinesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TimelineManagePageComponent_FetchTimelineByIdDocument = gql`
  query TimelineManagePageComponent_FetchTimelineById($id: ID!) {
    timelines {
      byId(id: $id) {
        ...TimelineFields
        items {
          ...TimelineItemFields
          timestampType {
            ...TimestampTypeFields
          }
        }
      }
    }
  }
  ${TimelineFieldsFragmentDoc}
  ${TimelineItemFieldsFragmentDoc}
  ${TimestampTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TimelineManagePageComponent_FetchTimelineByIdGQL extends Apollo.Query<
  TimelineManagePageComponent_FetchTimelineByIdQuery,
  TimelineManagePageComponent_FetchTimelineByIdQueryVariables
> {
  document = TimelineManagePageComponent_FetchTimelineByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TimelinesContextResolverService_FetchTimelinesContextDocument = gql`
  query TimelinesContextResolverService_FetchTimelinesContext {
    timestampTypes {
      all {
        items {
          ...TimestampTypeFields
        }
      }
    }
  }
  ${TimestampTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TimelinesContextResolverService_FetchTimelinesContextGQL extends Apollo.Query<
  TimelinesContextResolverService_FetchTimelinesContextQuery,
  TimelinesContextResolverService_FetchTimelinesContextQueryVariables
> {
  document = TimelinesContextResolverService_FetchTimelinesContextDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TimestampTypeListPageComponent_FetchAllTimestampTypesDocument = gql`
  query TimestampTypeListPageComponent_FetchAllTimestampTypes(
    $filter: TimestampTypeFilter
    $first: Int
    $skip: Int
  ) {
    timestampTypes {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...TimestampTypeFields
        }
        meta {
          total
        }
      }
    }
  }
  ${TimestampTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TimestampTypeListPageComponent_FetchAllTimestampTypesGQL extends Apollo.Query<
  TimestampTypeListPageComponent_FetchAllTimestampTypesQuery,
  TimestampTypeListPageComponent_FetchAllTimestampTypesQueryVariables
> {
  document = TimestampTypeListPageComponent_FetchAllTimestampTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TransferReasonListPageComponent_FetchAllTransferReasonsDocument = gql`
  query TransferReasonListPageComponent_FetchAllTransferReasons(
    $filter: TransferReasonFilter
    $first: Int
    $skip: Int
  ) {
    transferReasons {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...TransferReasonFields
        }
        meta {
          total
        }
      }
    }
  }
  ${TransferReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TransferReasonListPageComponent_FetchAllTransferReasonsGQL extends Apollo.Query<
  TransferReasonListPageComponent_FetchAllTransferReasonsQuery,
  TransferReasonListPageComponent_FetchAllTransferReasonsQueryVariables
> {
  document = TransferReasonListPageComponent_FetchAllTransferReasonsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TrmUserListPageComponent_FetchTrmUsersDocument = gql`
  query TrmUserListPageComponent_FetchTrmUsers($filter: TrmUserFilter, $skip: Int, $first: Int) {
    trmUsers {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          firstName
          lastName
          emailAddress
          phoneNumber
          dateCreated
          userStatus
          trmUserAgencies {
            agency {
              name
            }
          }
          trmUserPrograms {
            isPreferred
            trmUserId
            programId
            program {
              id
              name
              abbreviation
            }
          }
          trmUserMedicalFacilities {
            medicalFacility {
              name
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TrmUserListPageComponent_FetchTrmUsersGQL extends Apollo.Query<
  TrmUserListPageComponent_FetchTrmUsersQuery,
  TrmUserListPageComponent_FetchTrmUsersQueryVariables
> {
  document = TrmUserListPageComponent_FetchTrmUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TrmUserListPageComponent_FetchAllAgenciesDocument = gql`
  query TrmUserListPageComponent_FetchAllAgencies($filter: AgencyFilter, $first: Int, $skip: Int) {
    agencies {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          name
          id
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TrmUserListPageComponent_FetchAllAgenciesGQL extends Apollo.Query<
  TrmUserListPageComponent_FetchAllAgenciesQuery,
  TrmUserListPageComponent_FetchAllAgenciesQueryVariables
> {
  document = TrmUserListPageComponent_FetchAllAgenciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TrmUserListPageComponent_FetchAllMedicalFacilitiesDocument = gql`
  query TrmUserListPageComponent_FetchAllMedicalFacilities(
    $filter: MedicalFacilityFilter
    $first: Int
    $skip: Int
  ) {
    medicalFacilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          name
          id
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TrmUserListPageComponent_FetchAllMedicalFacilitiesGQL extends Apollo.Query<
  TrmUserListPageComponent_FetchAllMedicalFacilitiesQuery,
  TrmUserListPageComponent_FetchAllMedicalFacilitiesQueryVariables
> {
  document = TrmUserListPageComponent_FetchAllMedicalFacilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleModelsListPageComponent_FetchAllVehicleModelsDocument = gql`
  query VehicleModelsListPageComponent_FetchAllVehicleModels(
    $filter: VehicleModelFilter
    $first: Int
    $skip: Int
  ) {
    vehicleModels {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleModelFields
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleModelsListPageComponent_FetchAllVehicleModelsGQL extends Apollo.Query<
  VehicleModelsListPageComponent_FetchAllVehicleModelsQuery,
  VehicleModelsListPageComponent_FetchAllVehicleModelsQueryVariables
> {
  document = VehicleModelsListPageComponent_FetchAllVehicleModelsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BasesFormComponent_FetchAllBasesDocument = gql`
  query BasesFormComponent_FetchAllBases($filter: BaseFilter, $first: Int, $skip: Int) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...BaseFields
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class BasesFormComponent_FetchAllBasesGQL extends Apollo.Query<
  BasesFormComponent_FetchAllBasesQuery,
  BasesFormComponent_FetchAllBasesQueryVariables
> {
  document = BasesFormComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsDocument = gql`
  query BaseMedicalControlContactListComponent_FetchBaseMedicalControlContacts($id: ID!) {
    baseMedicalControlContacts {
      byBaseId(id: $id) {
        items {
          ...BaseMedicalControlContactFields
          person {
            ...PersonFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
          baseMedicalControlContactStates {
            ...BaseMedicalControlContactStateFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseMedicalControlContactFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${BaseMedicalControlContactStateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsGQL extends Apollo.Query<
  BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQuery,
  BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQueryVariables
> {
  document = BaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BasesListPageComponent_FetchAllBasesDocument = gql`
  query BasesListPageComponent_FetchAllBases($filter: BaseFilter, $first: Int, $skip: Int) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...BaseFields
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class BasesListPageComponent_FetchAllBasesGQL extends Apollo.Query<
  BasesListPageComponent_FetchAllBasesQuery,
  BasesListPageComponent_FetchAllBasesQueryVariables
> {
  document = BasesListPageComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ComplianceListPageComponent_FetchAllPeopleDocument = gql`
  query ComplianceListPageComponent_FetchAllPeople($filter: PersonFilter, $first: Int, $skip: Int) {
    people {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PersonFields
          location {
            ...LocationFields
          }
          company {
            ...CompanyFields
          }
          department {
            ...DepartmentFields
          }
          accessibleItems {
            ...AccessibleItemFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${DepartmentFieldsFragmentDoc}
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ComplianceListPageComponent_FetchAllPeopleGQL extends Apollo.Query<
  ComplianceListPageComponent_FetchAllPeopleQuery,
  ComplianceListPageComponent_FetchAllPeopleQueryVariables
> {
  document = ComplianceListPageComponent_FetchAllPeopleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationGroupListPageComponent_FetchAllNotificationGroupsDocument = gql`
  query NotificationGroupListPageComponent_FetchAllNotificationGroups(
    $filter: NotificationGroupFilter
    $first: Int
    $skip: Int
  ) {
    notificationGroups {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationGroupFields
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class NotificationGroupListPageComponent_FetchAllNotificationGroupsGQL extends Apollo.Query<
  NotificationGroupListPageComponent_FetchAllNotificationGroupsQuery,
  NotificationGroupListPageComponent_FetchAllNotificationGroupsQueryVariables
> {
  document = NotificationGroupListPageComponent_FetchAllNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ManageCommunicationCenterRoleResolverService_ResolveDocument = gql`
  query ManageCommunicationCenterRoleResolverService_Resolve($personId: ID!) {
    people {
      byId(id: $personId) {
        ...PersonFields
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
    companies {
      all {
        items {
          ...CompanyFields
        }
      }
    }
    communicationCenters {
      all {
        items {
          ...CommunicationCenterFields
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${AccessibleItemFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ManageCommunicationCenterRoleResolverService_ResolveGQL extends Apollo.Query<
  ManageCommunicationCenterRoleResolverService_ResolveQuery,
  ManageCommunicationCenterRoleResolverService_ResolveQueryVariables
> {
  document = ManageCommunicationCenterRoleResolverService_ResolveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PersonListPageComponent_FetchAllPeopleDocument = gql`
  query PersonListPageComponent_FetchAllPeople($filter: PersonFilter, $first: Int, $skip: Int) {
    people {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PersonFields
          location {
            ...LocationFields
          }
          company {
            ...CompanyFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PersonListPageComponent_FetchAllPeopleGQL extends Apollo.Query<
  PersonListPageComponent_FetchAllPeopleQuery,
  PersonListPageComponent_FetchAllPeopleQueryVariables
> {
  document = PersonListPageComponent_FetchAllPeopleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsDocument = gql`
  query PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContacts($id: ID!) {
    baseMedicalControlContacts {
      byPersonId(id: $id) {
        items {
          ...BaseMedicalControlContactFields
          person {
            ...PersonFields
          }
          base {
            ...BaseFields
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
          baseMedicalControlContactStates {
            ...BaseMedicalControlContactStateFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseMedicalControlContactFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${BaseFieldsFragmentDoc}
  ${BaseMedicalControlContactStateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsGQL extends Apollo.Query<
  PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQuery,
  PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsQueryVariables
> {
  document = PersonBaseMedicalControlContactListComponent_FetchBaseMedicalControlContactsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserDetailPageComponent_FetchOktaPersonEntitiesByIdDocument = gql`
  query UserDetailPageComponent_FetchOktaPersonEntitiesById($idOrLogin: ID!) {
    okta {
      user(idOrLogin: $idOrLogin) {
        id
        lastUpdated
        created
        profile {
          login
          firstName
          lastName
          email
          employeeNumber
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UserDetailPageComponent_FetchOktaPersonEntitiesByIdGQL extends Apollo.Query<
  UserDetailPageComponent_FetchOktaPersonEntitiesByIdQuery,
  UserDetailPageComponent_FetchOktaPersonEntitiesByIdQueryVariables
> {
  document = UserDetailPageComponent_FetchOktaPersonEntitiesByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserFormComponent_FetchAccessibleItemsDocument = gql`
  query UserFormComponent_FetchAccessibleItems($personId: ID!) {
    people {
      byId(id: $personId) {
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
  }
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserFormComponent_FetchAccessibleItemsGQL extends Apollo.Query<
  UserFormComponent_FetchAccessibleItemsQuery,
  UserFormComponent_FetchAccessibleItemsQueryVariables
> {
  document = UserFormComponent_FetchAccessibleItemsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserFormComponent_FetchAllCommunicationCentersDocument = gql`
  query UserFormComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CommunicationCenterFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserFormComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  UserFormComponent_FetchAllCommunicationCentersQuery,
  UserFormComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = UserFormComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserFormComponent_FetchAllProgramsDocument = gql`
  query UserFormComponent_FetchAllPrograms($filter: ProgramFilter, $first: Int, $skip: Int) {
    programs {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...ProgramFields
        }
        meta {
          total
        }
      }
    }
  }
  ${ProgramFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserFormComponent_FetchAllProgramsGQL extends Apollo.Query<
  UserFormComponent_FetchAllProgramsQuery,
  UserFormComponent_FetchAllProgramsQueryVariables
> {
  document = UserFormComponent_FetchAllProgramsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserFormComponent_FetchAllBasesDocument = gql`
  query UserFormComponent_FetchAllBases($filter: BaseFilter, $first: Int, $skip: Int) {
    bases {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...BaseFields
        }
        meta {
          total
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserFormComponent_FetchAllBasesGQL extends Apollo.Query<
  UserFormComponent_FetchAllBasesQuery,
  UserFormComponent_FetchAllBasesQueryVariables
> {
  document = UserFormComponent_FetchAllBasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ManageOccRolePageResolver_ResolveDocument = gql`
  query ManageOccRolePageResolver_Resolve($personId: ID!) {
    people {
      byId(id: $personId) {
        ...PersonFields
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
    companies {
      all {
        items {
          ...CompanyFields
        }
      }
    }
    controlZones {
      all {
        items {
          ...ControlZoneFields
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${AccessibleItemFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ManageOccRolePageResolver_ResolveGQL extends Apollo.Query<
  ManageOccRolePageResolver_ResolveQuery,
  ManageOccRolePageResolver_ResolveQueryVariables
> {
  document = ManageOccRolePageResolver_ResolveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ManageOccRolePage_ResolverDocument = gql`
  query ManageOccRolePage_Resolver($personId: ID!) {
    people {
      byId(id: $personId) {
        ...PersonFields
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
    companies {
      all {
        items {
          ...CompanyFields
        }
      }
    }
    controlZones {
      all {
        items {
          ...ControlZoneFields
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${AccessibleItemFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ManageOccRolePage_ResolverGQL extends Apollo.Query<
  ManageOccRolePage_ResolverQuery,
  ManageOccRolePage_ResolverQueryVariables
> {
  document = ManageOccRolePage_ResolverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionGroupsFormComponent_FetchAllDepartmentsDocument = gql`
  query RegionGroupsFormComponent_FetchAllDepartments($skip: Int, $first: Int) {
    allDepartments(skip: $skip, first: $first) {
      id
      name
      code
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RegionGroupsFormComponent_FetchAllDepartmentsGQL extends Apollo.Query<
  RegionGroupsFormComponent_FetchAllDepartmentsQuery,
  RegionGroupsFormComponent_FetchAllDepartmentsQueryVariables
> {
  document = RegionGroupsFormComponent_FetchAllDepartmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionGroupsListPageComponent_FetchAllRegionGroupsDocument = gql`
  query RegionGroupsListPageComponent_FetchAllRegionGroups(
    $filter: RegionGroupFilter
    $first: Int
    $skip: Int
  ) {
    regionGroups {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...RegionGroupFields
        }
        meta {
          total
        }
      }
    }
  }
  ${RegionGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RegionGroupsListPageComponent_FetchAllRegionGroupsGQL extends Apollo.Query<
  RegionGroupsListPageComponent_FetchAllRegionGroupsQuery,
  RegionGroupsListPageComponent_FetchAllRegionGroupsQueryVariables
> {
  document = RegionGroupsListPageComponent_FetchAllRegionGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionFormComponent_FetchAllCommunicationCentersDocument = gql`
  query RegionFormComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CommunicationCenterFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RegionFormComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  RegionFormComponent_FetchAllCommunicationCentersQuery,
  RegionFormComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = RegionFormComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionFormComponent_FetchAllRegionGroupsDocument = gql`
  query RegionFormComponent_FetchAllRegionGroups(
    $filter: RegionGroupFilter
    $first: Int
    $skip: Int
  ) {
    regionGroups {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...RegionGroupFields
        }
        meta {
          total
        }
      }
    }
  }
  ${RegionGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RegionFormComponent_FetchAllRegionGroupsGQL extends Apollo.Query<
  RegionFormComponent_FetchAllRegionGroupsQuery,
  RegionFormComponent_FetchAllRegionGroupsQueryVariables
> {
  document = RegionFormComponent_FetchAllRegionGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionsListPageComponent_FetchAllRegionsDocument = gql`
  query RegionsListPageComponent_FetchAllRegions($filter: RegionFilter, $first: Int, $skip: Int) {
    regions {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...RegionFields
          regionGroup {
            ...RegionGroupFields
          }
          communicationCenter {
            ...CommunicationCenterFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${RegionFieldsFragmentDoc}
  ${RegionGroupFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RegionsListPageComponent_FetchAllRegionsGQL extends Apollo.Query<
  RegionsListPageComponent_FetchAllRegionsQuery,
  RegionsListPageComponent_FetchAllRegionsQueryVariables
> {
  document = RegionsListPageComponent_FetchAllRegionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsDocument = gql`
  query SpecialtyTeamListPageComponent_FetchAllSpecialtyTeams(
    $filter: SpecialtyTeamFilter
    $skip: Int
    $first: Int
  ) {
    specialtyTeams {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...SpecialtyTeamFields
        }
        meta {
          total
        }
      }
    }
  }
  ${SpecialtyTeamFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsGQL extends Apollo.Query<
  SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsQuery,
  SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsQueryVariables
> {
  document = SpecialtyTeamListPageComponent_FetchAllSpecialtyTeamsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersDocument = gql`
  query SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembers(
    $filter: SpecialtyTeamMemberFilter
    $skip: Int
    $first: Int
  ) {
    specialtyTeamMembers {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...SpecialtyTeamMemberFields
          teamMember {
            ...PersonFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${SpecialtyTeamMemberFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersGQL extends Apollo.Query<
  SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersQuery,
  SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersQueryVariables
> {
  document = SpecialtyTeamMemberListPageComponent_FetchAllSpecialtyTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleDetailPageComponent_FetchVehicleByIdDocument = gql`
  query VehicleDetailPageComponent_FetchVehicleById($id: ID!) {
    vehicles {
      byId(id: $id) {
        ...VehicleFields
        company {
          ...CompanyFields
        }
        configurationClass {
          ...VehicleConfigurationClassFields
        }
        make {
          ...VehicleMakeFields
        }
        model {
          ...VehicleModelFields
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${VehicleConfigurationClassFieldsFragmentDoc}
  ${VehicleMakeFieldsFragmentDoc}
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleDetailPageComponent_FetchVehicleByIdGQL extends Apollo.Query<
  VehicleDetailPageComponent_FetchVehicleByIdQuery,
  VehicleDetailPageComponent_FetchVehicleByIdQueryVariables
> {
  document = VehicleDetailPageComponent_FetchVehicleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleFormComponent_FetchAllVehicleMakesDocument = gql`
  query VehicleFormComponent_FetchAllVehicleMakes {
    allVehicleMakes {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleFormComponent_FetchAllVehicleMakesGQL extends Apollo.Query<
  VehicleFormComponent_FetchAllVehicleMakesQuery,
  VehicleFormComponent_FetchAllVehicleMakesQueryVariables
> {
  document = VehicleFormComponent_FetchAllVehicleMakesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleFormComponent_FetchAllCapabilitiesDocument = gql`
  query VehicleFormComponent_FetchAllCapabilities(
    $filter: CapabilityFilter
    $first: Int
    $skip: Int
  ) {
    capabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CapabilityFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleFormComponent_FetchAllCapabilitiesGQL extends Apollo.Query<
  VehicleFormComponent_FetchAllCapabilitiesQuery,
  VehicleFormComponent_FetchAllCapabilitiesQueryVariables
> {
  document = VehicleFormComponent_FetchAllCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleFormComponent_FetchAllEntityCapabilitiesDocument = gql`
  query VehicleFormComponent_FetchAllEntityCapabilities(
    $filter: EntityCapabilityFilter
    $first: Int
    $skip: Int
  ) {
    entityCapabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...EntityCapabilityFields
          capability {
            ...CapabilityFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${EntityCapabilityFieldsFragmentDoc}
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleFormComponent_FetchAllEntityCapabilitiesGQL extends Apollo.Query<
  VehicleFormComponent_FetchAllEntityCapabilitiesQuery,
  VehicleFormComponent_FetchAllEntityCapabilitiesQueryVariables
> {
  document = VehicleFormComponent_FetchAllEntityCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleFormComponent_FetchAllCommunicationCentersDocument = gql`
  query VehicleFormComponent_FetchAllCommunicationCenters(
    $filter: CommunicationCenterFilter
    $first: Int
    $skip: Int
  ) {
    communicationCenters {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleFormComponent_FetchAllCommunicationCentersGQL extends Apollo.Query<
  VehicleFormComponent_FetchAllCommunicationCentersQuery,
  VehicleFormComponent_FetchAllCommunicationCentersQueryVariables
> {
  document = VehicleFormComponent_FetchAllCommunicationCentersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleImageUploadDialogComponent_FetchAttachmentDocument = gql`
  query VehicleImageUploadDialogComponent_FetchAttachment($filter: AttachmentFilter) {
    attachments {
      all(filter: $filter) {
        items {
          ...AttachmentFields
        }
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleImageUploadDialogComponent_FetchAttachmentGQL extends Apollo.Query<
  VehicleImageUploadDialogComponent_FetchAttachmentQuery,
  VehicleImageUploadDialogComponent_FetchAttachmentQueryVariables
> {
  document = VehicleImageUploadDialogComponent_FetchAttachmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleMaintenanceListComponent_FetchVehicleMaintenanceDocument = gql`
  query VehicleMaintenanceListComponent_FetchVehicleMaintenance($id: ID!) {
    vehicles {
      byId(id: $id) {
        vehicleMaintenances {
          ...VehicleMaintenanceFields
        }
      }
    }
  }
  ${VehicleMaintenanceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleMaintenanceListComponent_FetchVehicleMaintenanceGQL extends Apollo.Query<
  VehicleMaintenanceListComponent_FetchVehicleMaintenanceQuery,
  VehicleMaintenanceListComponent_FetchVehicleMaintenanceQueryVariables
> {
  document = VehicleMaintenanceListComponent_FetchVehicleMaintenanceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsDocument = gql`
  query VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroups(
    $filter: NotificationGroupFilter
  ) {
    notificationGroups {
      all(filter: $filter) {
        items {
          ...NotificationGroupFields
        }
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsGQL extends Apollo.Query<
  VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsQuery,
  VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsQueryVariables
> {
  document = VehicleNotificationGroupAddDialogComponent_FetchAllNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsDocument = gql`
  query VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroups($id: ID!) {
    vehicles {
      byId(id: $id) {
        id
        vehicleNotificationGroups {
          ...VehicleNotificationGroupFields
          notificationGroup {
            name
          }
        }
      }
    }
  }
  ${VehicleNotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsGQL extends Apollo.Query<
  VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsQuery,
  VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsQueryVariables
> {
  document = VehicleNotificationGroupsListComponent_FetchVehicleNotificationGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleStateInspectionListComponent_FetchVehicleStateInspectionsDocument = gql`
  query VehicleStateInspectionListComponent_FetchVehicleStateInspections($id: ID!) {
    vehicles {
      byId(id: $id) {
        vehicleStateInspections {
          ...VehicleStateInspectionFields
        }
      }
    }
  }
  ${VehicleStateInspectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehicleStateInspectionListComponent_FetchVehicleStateInspectionsGQL extends Apollo.Query<
  VehicleStateInspectionListComponent_FetchVehicleStateInspectionsQuery,
  VehicleStateInspectionListComponent_FetchVehicleStateInspectionsQueryVariables
> {
  document = VehicleStateInspectionListComponent_FetchVehicleStateInspectionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehiclesListPageComponent_FetchAllVehiclesDocument = gql`
  query VehiclesListPageComponent_FetchAllVehicles(
    $filter: VehicleFilter
    $first: Int
    $skip: Int
  ) {
    vehicles {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleFields
          company {
            ...CompanyFields
          }
          configurationClass {
            ...VehicleConfigurationClassFields
          }
          make {
            ...VehicleMakeFields
          }
          model {
            ...VehicleModelFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${VehicleConfigurationClassFieldsFragmentDoc}
  ${VehicleMakeFieldsFragmentDoc}
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class VehiclesListPageComponent_FetchAllVehiclesGQL extends Apollo.Query<
  VehiclesListPageComponent_FetchAllVehiclesQuery,
  VehiclesListPageComponent_FetchAllVehiclesQueryVariables
> {
  document = VehiclesListPageComponent_FetchAllVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReleaseNotesListPageComponent_FetchReleaseNotesDocument = gql`
  query ReleaseNotesListPageComponent_FetchReleaseNotes(
    $filter: ReleaseNoteFilter
    $skip: Int
    $first: Int
  ) {
    releaseNotes {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          id
          description
          releaseNumber
          releaseDate
          dateCreated
          dateLastUpdated
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesListPageComponent_FetchReleaseNotesGQL extends Apollo.Query<
  ReleaseNotesListPageComponent_FetchReleaseNotesQuery,
  ReleaseNotesListPageComponent_FetchReleaseNotesQueryVariables
> {
  document = ReleaseNotesListPageComponent_FetchReleaseNotesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRttCardByCardNumberDocument = gql`
  query GetRttCardByCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        ...CardFields
        activeAlerts {
          ...ActiveAlertFields
        }
        operation {
          ...OperationFields
          unit {
            ...UnitContext
            region {
              ...RegionFields
              communicationCenter {
                ...CommunicationCenterFields
              }
            }
          }
          trips {
            ...TripFields
            estimatedDurations {
              ...EstimatedDurationFields
            }
            vehicle {
              ...VehicleFields
              vehicleDispositions {
                ...VehicleDispositionFields
              }
            }
            positionReports {
              ...PositionReportFields
            }
            legs {
              ...TripLegFields
              startingWaypoint {
                ...WaypointFields
                address {
                  ...AddressFields
                }
                location {
                  id
                  locationType
                  name
                  abbreviation
                  notes
                  address {
                    ...AddressFields
                  }
                }
              }
              endingWaypoint {
                ...WaypointFields
                address {
                  ...AddressFields
                }
                location {
                  id
                  locationType
                  name
                  abbreviation
                  notes
                  address {
                    ...AddressFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${CardFieldsFragmentDoc}
  ${ActiveAlertFieldsFragmentDoc}
  ${OperationFieldsFragmentDoc}
  ${UnitContextFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
  ${TripFieldsFragmentDoc}
  ${EstimatedDurationFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${PositionReportFieldsFragmentDoc}
  ${TripLegFieldsFragmentDoc}
  ${WaypointFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetRttCardByCardNumberGQL extends Apollo.Query<
  GetRttCardByCardNumberQuery,
  GetRttCardByCardNumberQueryVariables
> {
  document = GetRttCardByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRttSummariesDocument = gql`
  query GetRttSummaries($cardFilter: CardSummaryFilter, $unitFilter: UnitSummaryFilter) {
    cards {
      summaries(filter: $cardFilter) {
        items {
          ...CardSummaryFields
        }
      }
    }
    units {
      summaries(filter: $unitFilter) {
        items {
          ...UnitSummaryFields
          vehicleSummary {
            ...VehicleSummaryFields
          }
        }
      }
    }
  }
  ${CardSummaryFieldsFragmentDoc}
  ${UnitSummaryFieldsFragmentDoc}
  ${VehicleSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetRttSummariesGQL extends Apollo.Query<
  GetRttSummariesQuery,
  GetRttSummariesQueryVariables
> {
  document = GetRttSummariesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LocationSearchDialogComponent_FetchAllLocationsDocument = gql`
  query LocationSearchDialogComponent_FetchAllLocations($filter: LocationQueryFilter) {
    locations {
      all(filter: $filter) {
        items {
          ...LocationFields
          distanceToReceivingMiles
          distanceToReceivingNauticaMiles
          address {
            ...AddressFields
          }
          entityCapabilities {
            ...EntityCapabilityFields
            capability {
              ...CapabilityFields
            }
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${EntityCapabilityFieldsFragmentDoc}
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LocationSearchDialogComponent_FetchAllLocationsGQL extends Apollo.Query<
  LocationSearchDialogComponent_FetchAllLocationsQuery,
  LocationSearchDialogComponent_FetchAllLocationsQueryVariables
> {
  document = LocationSearchDialogComponent_FetchAllLocationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LocationSearchDialogComponent_FetchAllCapabilitiesDocument = gql`
  query LocationSearchDialogComponent_FetchAllCapabilities(
    $filter: CapabilityFilter
    $first: Int
    $skip: Int
  ) {
    capabilities {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...CapabilityFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LocationSearchDialogComponent_FetchAllCapabilitiesGQL extends Apollo.Query<
  LocationSearchDialogComponent_FetchAllCapabilitiesQuery,
  LocationSearchDialogComponent_FetchAllCapabilitiesQueryVariables
> {
  document = LocationSearchDialogComponent_FetchAllCapabilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LocationSearchComponent_FetchAllLocationsDocument = gql`
  query LocationSearchComponent_FetchAllLocations($filter: LocationQueryFilter) {
    locations {
      all(filter: $filter) {
        items {
          ...LocationFields
          distanceToReceivingMiles
          distanceToReceivingNauticaMiles
          address {
            ...AddressFields
          }
          entityCapabilities {
            ...EntityCapabilityFields
            capability {
              ...CapabilityFields
            }
          }
          lastUpdatedBy {
            id
            firstName
            lastName
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${LocationFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${EntityCapabilityFieldsFragmentDoc}
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LocationSearchComponent_FetchAllLocationsGQL extends Apollo.Query<
  LocationSearchComponent_FetchAllLocationsQuery,
  LocationSearchComponent_FetchAllLocationsQueryVariables
> {
  document = LocationSearchComponent_FetchAllLocationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OmnisearchCardResultsComponent_SearchForCardsDocument = gql`
  query OmnisearchCardResultsComponent_SearchForCards(
    $filter: CardSearchFilterV2
    $first: Int
    $skip: Int
  ) {
    cards {
      searchv2(filter: $filter, skip: $skip, first: $first) {
        meta {
          total
        }
        items {
          id
          cardNumber
          createdById
          createdBy
          companyId
          companyCode
          dateCreated
          dateDeleted
          status
          callStatus
          isBillable
          isLocked
          lastOfferedUnit {
            id
            name
          }
          lastOfferedVehicle {
            id
            registrationNumber
          }
          operation {
            id
            status
            type
            unit {
              id
              name
            }
            vehicle {
              id
              registrationNumber
            }
          }
          request {
            id
            status
            requestedOperationType
            pickupLocation {
              id
              name
              type
              locationId
              medicalFacilityId
              medicalFacilityName
              medicalFacilityAbbreviation
            }
            dropoffLocation {
              id
              name
              type
              locationId
              medicalFacilityId
              medicalFacilityName
              medicalFacilityAbbreviation
            }
          }
          region {
            id
            name
            communicationCenter {
              id
              name
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OmnisearchCardResultsComponent_SearchForCardsGQL extends Apollo.Query<
  OmnisearchCardResultsComponent_SearchForCardsQuery,
  OmnisearchCardResultsComponent_SearchForCardsQueryVariables
> {
  document = OmnisearchCardResultsComponent_SearchForCardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PeopleFetchService_FetchAllPeopleDocument = gql`
  query PeopleFetchService_FetchAllPeople($filter: PersonFilter, $first: Int, $skip: Int) {
    people {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...PersonFields
          location {
            ...LocationFields
          }
          company {
            ...CompanyFields
          }
          department {
            ...DepartmentFields
          }
          accessibleItems {
            ...AccessibleItemFields
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${DepartmentFieldsFragmentDoc}
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PeopleFetchService_FetchAllPeopleGQL extends Apollo.Query<
  PeopleFetchService_FetchAllPeopleQuery,
  PeopleFetchService_FetchAllPeopleQueryVariables
> {
  document = PeopleFetchService_FetchAllPeopleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SupportRequestDialogComponent_FetchAttachmentsDocument = gql`
  query SupportRequestDialogComponent_FetchAttachments($id: ID!) {
    supportRequests {
      byId(id: $id) {
        attachments {
          ...AttachmentFields
        }
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SupportRequestDialogComponent_FetchAttachmentsGQL extends Apollo.Query<
  SupportRequestDialogComponent_FetchAttachmentsQuery,
  SupportRequestDialogComponent_FetchAttachmentsQueryVariables
> {
  document = SupportRequestDialogComponent_FetchAttachmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SupportRequestListComponent_FetchAllSupportRequestsDocument = gql`
  query SupportRequestListComponent_FetchAllSupportRequests(
    $filter: SupportRequestFilter
    $skip: Int
    $first: Int
  ) {
    supportRequests {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          attachments {
            ...AttachmentFields
          }
          ...SupportRequestFields
        }
        meta {
          total
        }
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
  ${SupportRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SupportRequestListComponent_FetchAllSupportRequestsGQL extends Apollo.Query<
  SupportRequestListComponent_FetchAllSupportRequestsQuery,
  SupportRequestListComponent_FetchAllSupportRequestsQueryVariables
> {
  document = SupportRequestListComponent_FetchAllSupportRequestsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SupportRequestResolver_FetchSupportRequestDocument = gql`
  query SupportRequestResolver_FetchSupportRequest($id: ID!) {
    supportRequests {
      byId(id: $id) {
        attachments {
          ...AttachmentFields
        }
        ...SupportRequestFields
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
  ${SupportRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SupportRequestResolver_FetchSupportRequestGQL extends Apollo.Query<
  SupportRequestResolver_FetchSupportRequestQuery,
  SupportRequestResolver_FetchSupportRequestQueryVariables
> {
  document = SupportRequestResolver_FetchSupportRequestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeveloperNotesPageComponent_FetchDevNotesDocument = gql`
  query DeveloperNotesPageComponent_FetchDevNotes($filter: DevNoteFilter, $first: Int, $skip: Int) {
    cardNotes {
      devNotes(filter: $filter, first: $first, skip: $skip) {
        items {
          content
          noteTime
          authorId
          dateCreated
          cardNumber
          companyName
          name
        }
        meta {
          total
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeveloperNotesPageComponent_FetchDevNotesGQL extends Apollo.Query<
  DeveloperNotesPageComponent_FetchDevNotesQuery,
  DeveloperNotesPageComponent_FetchDevNotesQueryVariables
> {
  document = DeveloperNotesPageComponent_FetchDevNotesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusDocument = gql`
  query GetFleetStatus {
    units {
      all(filter: { allCompanies: true }) {
        items {
          ...UnitFields
          vehicle {
            ...VehicleFields
            make {
              ...VehicleMakeFields
            }
            model {
              ...VehicleModelFields
            }
            vehicleDispositions {
              ...VehicleDispositionFields
              currentWaypoint {
                ...WaypointFields
                location {
                  ...LocationFields
                }
              }
              latestPositionReport {
                ...PositionReportFields
              }
              latestFlightFollowingReport {
                ...FlightFollowingReportFields
              }
            }
          }
        }
      }
    }
  }
  ${UnitFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleMakeFieldsFragmentDoc}
  ${VehicleModelFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${WaypointFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
  ${PositionReportFieldsFragmentDoc}
  ${FlightFollowingReportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusGQL extends Apollo.Query<
  GetFleetStatusQuery,
  GetFleetStatusQueryVariables
> {
  document = GetFleetStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusCardSummariesDocument = gql`
  query GetFleetStatusCardSummaries($filter: CardSummaryFilter) {
    cards {
      summaries(filter: $filter) {
        items {
          ...CardSummaryFields
        }
      }
    }
  }
  ${CardSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusCardSummariesGQL extends Apollo.Query<
  GetFleetStatusCardSummariesQuery,
  GetFleetStatusCardSummariesQueryVariables
> {
  document = GetFleetStatusCardSummariesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusActiveAlertsDocument = gql`
  query GetFleetStatusActiveAlerts($filter: ActiveAlertFilter) {
    activeAlerts {
      all(filter: $filter) {
        items {
          ...ActiveAlertFields
          author {
            ...PersonFields
          }
          region {
            ...RegionFields
          }
          communicationCenter {
            ...CommunicationCenterFields
          }
          activeAlertAcknowledgements {
            ...ActiveAlertAcknowledgementFields
          }
        }
      }
    }
  }
  ${ActiveAlertFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
  ${RegionFieldsFragmentDoc}
  ${CommunicationCenterFieldsFragmentDoc}
  ${ActiveAlertAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusActiveAlertsGQL extends Apollo.Query<
  GetFleetStatusActiveAlertsQuery,
  GetFleetStatusActiveAlertsQueryVariables
> {
  document = GetFleetStatusActiveAlertsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusVehiclesDocument = gql`
  query GetFleetStatusVehicles($filter: VehicleFilter) {
    vehicles {
      all(filter: $filter) {
        items {
          ...VehicleFields
        }
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusVehiclesGQL extends Apollo.Query<
  GetFleetStatusVehiclesQuery,
  GetFleetStatusVehiclesQueryVariables
> {
  document = GetFleetStatusVehiclesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusVehiclePositionSummariesDocument = gql`
  query GetFleetStatusVehiclePositionSummaries($filter: VehiclePositionSummaryFilter) {
    vehiclePositionSummary {
      all(filter: $filter) {
        items {
          ...VehiclePositionSummaryFields
        }
      }
    }
  }
  ${VehiclePositionSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusVehiclePositionSummariesGQL extends Apollo.Query<
  GetFleetStatusVehiclePositionSummariesQuery,
  GetFleetStatusVehiclePositionSummariesQueryVariables
> {
  document = GetFleetStatusVehiclePositionSummariesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusCardByCardNumberDocument = gql`
  query GetFleetStatusCardByCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        ...CardFields
        activeAlerts {
          ...ActiveAlertFields
        }
        request {
          ...RequestFields
        }
        operation {
          ...OperationFields
          unit {
            ...UnitContext
          }
          trips {
            ...TripFields
            estimatedDurations {
              ...EstimatedDurationFields
            }
            vehicle {
              ...VehicleFields
              vehicleDispositions {
                ...VehicleDispositionFields
              }
            }
            agency {
              ...AgencyFields
            }
            etas {
              ...EtaFields
            }
            positionReports {
              ...PositionReportFields
            }
            flightFollowingReports {
              ...FlightFollowingReportFields
            }
            passengers {
              ...TripPassengerFields
              manifestEntries {
                ...ManifestEntryFields
              }
            }
            legs {
              ...TripLegFields
              startingWaypoint {
                ...WaypointFields
                address {
                  ...AddressFields
                }
                location {
                  ...LocationFields
                  address {
                    ...AddressFields
                  }
                }
              }
              endingWaypoint {
                ...WaypointFields
                address {
                  ...AddressFields
                }
                location {
                  ...LocationFields
                  address {
                    ...AddressFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${CardFieldsFragmentDoc}
  ${ActiveAlertFieldsFragmentDoc}
  ${RequestFieldsFragmentDoc}
  ${OperationFieldsFragmentDoc}
  ${UnitContextFragmentDoc}
  ${TripFieldsFragmentDoc}
  ${EstimatedDurationFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${AgencyFieldsFragmentDoc}
  ${EtaFieldsFragmentDoc}
  ${PositionReportFieldsFragmentDoc}
  ${FlightFollowingReportFieldsFragmentDoc}
  ${TripPassengerFieldsFragmentDoc}
  ${ManifestEntryFieldsFragmentDoc}
  ${TripLegFieldsFragmentDoc}
  ${WaypointFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusCardByCardNumberGQL extends Apollo.Query<
  GetFleetStatusCardByCardNumberQuery,
  GetFleetStatusCardByCardNumberQueryVariables
> {
  document = GetFleetStatusCardByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusVehicleDispositionsDocument = gql`
  query GetFleetStatusVehicleDispositions($filter: VehicleDispositionFilter) {
    vehicles {
      dispositions(filter: $filter) {
        items {
          ...VehicleDispositionFields
        }
      }
    }
  }
  ${VehicleDispositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusVehicleDispositionsGQL extends Apollo.Query<
  GetFleetStatusVehicleDispositionsQuery,
  GetFleetStatusVehicleDispositionsQueryVariables
> {
  document = GetFleetStatusVehicleDispositionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFleetStatusWaypointsDocument = gql`
  query GetFleetStatusWaypoints($filter: WaypointFilter) {
    waypoints {
      all(filter: $filter) {
        items {
          ...WaypointFields
        }
      }
    }
  }
  ${WaypointFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFleetStatusWaypointsGQL extends Apollo.Query<
  GetFleetStatusWaypointsQuery,
  GetFleetStatusWaypointsQueryVariables
> {
  document = GetFleetStatusWaypointsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAccessibleItemsDocument = gql`
  query GetAccessibleItems($personId: ID!) {
    people {
      byId(id: $personId) {
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
  }
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetAccessibleItemsGQL extends Apollo.Query<
  GetAccessibleItemsQuery,
  GetAccessibleItemsQueryVariables
> {
  document = GetAccessibleItemsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCardActiveAlertsByCardIdDocument = gql`
  query GetCardActiveAlertsByCardId($cardId: ID!) {
    cards {
      byId(id: $cardId) {
        activeAlerts {
          ...ActiveAlertFields
        }
      }
    }
  }
  ${ActiveAlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetCardActiveAlertsByCardIdGQL extends Apollo.Query<
  GetCardActiveAlertsByCardIdQuery,
  GetCardActiveAlertsByCardIdQueryVariables
> {
  document = GetCardActiveAlertsByCardIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCardLocationInfoByCardNumberDocument = gql`
  query GetCardLocationInfoByCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        id
        cardNumber
        activeAlerts {
          id
          matchType
          urgency
          content
        }
        operationId
        operation {
          id
          trips {
            id
            legs {
              id
              sequence
              startingWaypointId
              startingWaypoint {
                id
                type
                address {
                  ...AddressFields
                }
                locationId
                location {
                  ...CardLocationInfoLocationFields
                }
              }
              endingWaypointId
              endingWaypoint {
                id
                type
                address {
                  ...AddressFields
                }
                locationId
                location {
                  ...CardLocationInfoLocationFields
                }
              }
            }
          }
        }
        requestId
        request {
          id
          locations {
            id
            locationId
            requestId
            name
            abbreviation
            type
            notes
            groundContact
            request {
              requester {
                callbackNumber
              }
            }
            address {
              ...AddressFields
            }
            medicalFacilityId
            medicalFacility {
              id
              name
              abbreviation
              notes
              contacts {
                id
                name
                primaryPhoneNumber
                secondaryPhoneNumber
                smsPhoneNumber
                faxPhoneNumber
              }
              locationId
              location {
                ...CardLocationInfoLocationFields
              }
            }
            fboId
            fbo {
              id
              name
            }
            rendezvousRequests {
              id
              requestLocationId
              agencyEta
              notes
              agencyLocation {
                id
                agencyId
                name
              }
            }
          }
        }
      }
    }
  }
  ${AddressFieldsFragmentDoc}
  ${CardLocationInfoLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetCardLocationInfoByCardNumberGQL extends Apollo.Query<
  GetCardLocationInfoByCardNumberQuery,
  GetCardLocationInfoByCardNumberQueryVariables
> {
  document = GetCardLocationInfoByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCardNotesByCardDocument = gql`
  query GetCardNotesByCard($cardId: ID!) {
    cards {
      byId(id: $cardId) {
        notes {
          ...CardNoteFields
          author {
            ...PersonFields
          }
        }
      }
    }
  }
  ${CardNoteFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetCardNotesByCardGQL extends Apollo.Query<
  GetCardNotesByCardQuery,
  GetCardNotesByCardQueryVariables
> {
  document = GetCardNotesByCardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAuditLogByIdDocument = gql`
  query FetchAuditLogById($id: ID!) {
    auditLog: entities {
      byId(id: $id, type: AuditLog) {
        __typename
        ...AuditLogFields
      }
    }
  }
  ${AuditLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAuditLogByIdGQL extends Apollo.Query<
  FetchAuditLogByIdQuery,
  FetchAuditLogByIdQueryVariables
> {
  document = FetchAuditLogByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAuditLogByIdsDocument = gql`
  query FetchAuditLogByIds($ids: [ID!]!) {
    auditLog: entities {
      byIds(ids: $ids, type: AuditLog) {
        __typename
        ...AuditLogFields
      }
    }
  }
  ${AuditLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAuditLogByIdsGQL extends Apollo.Query<
  FetchAuditLogByIdsQuery,
  FetchAuditLogByIdsQueryVariables
> {
  document = FetchAuditLogByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActivationRuleByIdDocument = gql`
  query FetchActivationRuleById($id: ID!) {
    activationRule: entities {
      byId(id: $id, type: ActivationRule) {
        __typename
        ...ActivationRuleFields
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActivationRuleByIdGQL extends Apollo.Query<
  FetchActivationRuleByIdQuery,
  FetchActivationRuleByIdQueryVariables
> {
  document = FetchActivationRuleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActivationRuleByIdsDocument = gql`
  query FetchActivationRuleByIds($ids: [ID!]!) {
    activationRule: entities {
      byIds(ids: $ids, type: ActivationRule) {
        __typename
        ...ActivationRuleFields
      }
    }
  }
  ${ActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActivationRuleByIdsGQL extends Apollo.Query<
  FetchActivationRuleByIdsQuery,
  FetchActivationRuleByIdsQueryVariables
> {
  document = FetchActivationRuleByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveAlertAcknowledgementByIdDocument = gql`
  query FetchActiveAlertAcknowledgementById($id: ID!) {
    activeAlertAcknowledgement: entities {
      byId(id: $id, type: ActiveAlertAcknowledgement) {
        __typename
        ...ActiveAlertAcknowledgementFields
      }
    }
  }
  ${ActiveAlertAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveAlertAcknowledgementByIdGQL extends Apollo.Query<
  FetchActiveAlertAcknowledgementByIdQuery,
  FetchActiveAlertAcknowledgementByIdQueryVariables
> {
  document = FetchActiveAlertAcknowledgementByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveAlertAcknowledgementByIdsDocument = gql`
  query FetchActiveAlertAcknowledgementByIds($ids: [ID!]!) {
    activeAlertAcknowledgement: entities {
      byIds(ids: $ids, type: ActiveAlertAcknowledgement) {
        __typename
        ...ActiveAlertAcknowledgementFields
      }
    }
  }
  ${ActiveAlertAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveAlertAcknowledgementByIdsGQL extends Apollo.Query<
  FetchActiveAlertAcknowledgementByIdsQuery,
  FetchActiveAlertAcknowledgementByIdsQueryVariables
> {
  document = FetchActiveAlertAcknowledgementByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveAlertByIdDocument = gql`
  query FetchActiveAlertById($id: ID!) {
    activeAlert: entities {
      byId(id: $id, type: ActiveAlert) {
        __typename
        ...ActiveAlertFields
      }
    }
  }
  ${ActiveAlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveAlertByIdGQL extends Apollo.Query<
  FetchActiveAlertByIdQuery,
  FetchActiveAlertByIdQueryVariables
> {
  document = FetchActiveAlertByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveAlertByIdsDocument = gql`
  query FetchActiveAlertByIds($ids: [ID!]!) {
    activeAlert: entities {
      byIds(ids: $ids, type: ActiveAlert) {
        __typename
        ...ActiveAlertFields
      }
    }
  }
  ${ActiveAlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveAlertByIdsGQL extends Apollo.Query<
  FetchActiveAlertByIdsQuery,
  FetchActiveAlertByIdsQueryVariables
> {
  document = FetchActiveAlertByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveCardUnitOfferingByIdDocument = gql`
  query FetchActiveCardUnitOfferingById($id: ID!) {
    activeCardUnitOffering: entities {
      byId(id: $id, type: ActiveCardUnitOffering) {
        __typename
        ...ActiveCardUnitOfferingFields
      }
    }
  }
  ${ActiveCardUnitOfferingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveCardUnitOfferingByIdGQL extends Apollo.Query<
  FetchActiveCardUnitOfferingByIdQuery,
  FetchActiveCardUnitOfferingByIdQueryVariables
> {
  document = FetchActiveCardUnitOfferingByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveCardUnitOfferingByIdsDocument = gql`
  query FetchActiveCardUnitOfferingByIds($ids: [ID!]!) {
    activeCardUnitOffering: entities {
      byIds(ids: $ids, type: ActiveCardUnitOffering) {
        __typename
        ...ActiveCardUnitOfferingFields
      }
    }
  }
  ${ActiveCardUnitOfferingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveCardUnitOfferingByIdsGQL extends Apollo.Query<
  FetchActiveCardUnitOfferingByIdsQuery,
  FetchActiveCardUnitOfferingByIdsQueryVariables
> {
  document = FetchActiveCardUnitOfferingByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveTimelineByIdDocument = gql`
  query FetchActiveTimelineById($id: ID!) {
    activeTimeline: entities {
      byId(id: $id, type: ActiveTimeline) {
        __typename
        ...ActiveTimelineFields
      }
    }
  }
  ${ActiveTimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveTimelineByIdGQL extends Apollo.Query<
  FetchActiveTimelineByIdQuery,
  FetchActiveTimelineByIdQueryVariables
> {
  document = FetchActiveTimelineByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchActiveTimelineByIdsDocument = gql`
  query FetchActiveTimelineByIds($ids: [ID!]!) {
    activeTimeline: entities {
      byIds(ids: $ids, type: ActiveTimeline) {
        __typename
        ...ActiveTimelineFields
      }
    }
  }
  ${ActiveTimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchActiveTimelineByIdsGQL extends Apollo.Query<
  FetchActiveTimelineByIdsQuery,
  FetchActiveTimelineByIdsQueryVariables
> {
  document = FetchActiveTimelineByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAlertByIdDocument = gql`
  query FetchAlertById($id: ID!) {
    alert: entities {
      byId(id: $id, type: Alert) {
        __typename
        ...AlertFields
      }
    }
  }
  ${AlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAlertByIdGQL extends Apollo.Query<
  FetchAlertByIdQuery,
  FetchAlertByIdQueryVariables
> {
  document = FetchAlertByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAlertByIdsDocument = gql`
  query FetchAlertByIds($ids: [ID!]!) {
    alert: entities {
      byIds(ids: $ids, type: Alert) {
        __typename
        ...AlertFields
      }
    }
  }
  ${AlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAlertByIdsGQL extends Apollo.Query<
  FetchAlertByIdsQuery,
  FetchAlertByIdsQueryVariables
> {
  document = FetchAlertByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchApplicationNotificationByIdDocument = gql`
  query FetchApplicationNotificationById($id: ID!) {
    applicationNotification: entities {
      byId(id: $id, type: ApplicationNotification) {
        __typename
        ...ApplicationNotificationFields
      }
    }
  }
  ${ApplicationNotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchApplicationNotificationByIdGQL extends Apollo.Query<
  FetchApplicationNotificationByIdQuery,
  FetchApplicationNotificationByIdQueryVariables
> {
  document = FetchApplicationNotificationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchApplicationNotificationByIdsDocument = gql`
  query FetchApplicationNotificationByIds($ids: [ID!]!) {
    applicationNotification: entities {
      byIds(ids: $ids, type: ApplicationNotification) {
        __typename
        ...ApplicationNotificationFields
      }
    }
  }
  ${ApplicationNotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchApplicationNotificationByIdsGQL extends Apollo.Query<
  FetchApplicationNotificationByIdsQuery,
  FetchApplicationNotificationByIdsQueryVariables
> {
  document = FetchApplicationNotificationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAssignmentDelayedReasonByIdDocument = gql`
  query FetchAssignmentDelayedReasonById($id: ID!) {
    assignmentDelayedReason: entities {
      byId(id: $id, type: AssignmentDelayedReason) {
        __typename
        ...AssignmentDelayedReasonFields
      }
    }
  }
  ${AssignmentDelayedReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAssignmentDelayedReasonByIdGQL extends Apollo.Query<
  FetchAssignmentDelayedReasonByIdQuery,
  FetchAssignmentDelayedReasonByIdQueryVariables
> {
  document = FetchAssignmentDelayedReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAssignmentDelayedReasonByIdsDocument = gql`
  query FetchAssignmentDelayedReasonByIds($ids: [ID!]!) {
    assignmentDelayedReason: entities {
      byIds(ids: $ids, type: AssignmentDelayedReason) {
        __typename
        ...AssignmentDelayedReasonFields
      }
    }
  }
  ${AssignmentDelayedReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAssignmentDelayedReasonByIdsGQL extends Apollo.Query<
  FetchAssignmentDelayedReasonByIdsQuery,
  FetchAssignmentDelayedReasonByIdsQueryVariables
> {
  document = FetchAssignmentDelayedReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCancellationCategoryByIdDocument = gql`
  query FetchCancellationCategoryById($id: ID!) {
    cancellationCategory: entities {
      byId(id: $id, type: CancellationCategory) {
        __typename
        ...CancellationCategoryFields
      }
    }
  }
  ${CancellationCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCancellationCategoryByIdGQL extends Apollo.Query<
  FetchCancellationCategoryByIdQuery,
  FetchCancellationCategoryByIdQueryVariables
> {
  document = FetchCancellationCategoryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCancellationCategoryByIdsDocument = gql`
  query FetchCancellationCategoryByIds($ids: [ID!]!) {
    cancellationCategory: entities {
      byIds(ids: $ids, type: CancellationCategory) {
        __typename
        ...CancellationCategoryFields
      }
    }
  }
  ${CancellationCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCancellationCategoryByIdsGQL extends Apollo.Query<
  FetchCancellationCategoryByIdsQuery,
  FetchCancellationCategoryByIdsQueryVariables
> {
  document = FetchCancellationCategoryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCancellationReasonByIdDocument = gql`
  query FetchCancellationReasonById($id: ID!) {
    cancellationReason: entities {
      byId(id: $id, type: CancellationReason) {
        __typename
        ...CancellationReasonFields
      }
    }
  }
  ${CancellationReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCancellationReasonByIdGQL extends Apollo.Query<
  FetchCancellationReasonByIdQuery,
  FetchCancellationReasonByIdQueryVariables
> {
  document = FetchCancellationReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCancellationReasonByIdsDocument = gql`
  query FetchCancellationReasonByIds($ids: [ID!]!) {
    cancellationReason: entities {
      byIds(ids: $ids, type: CancellationReason) {
        __typename
        ...CancellationReasonFields
      }
    }
  }
  ${CancellationReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCancellationReasonByIdsGQL extends Apollo.Query<
  FetchCancellationReasonByIdsQuery,
  FetchCancellationReasonByIdsQueryVariables
> {
  document = FetchCancellationReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCancellationSecondaryReasonByIdDocument = gql`
  query FetchCancellationSecondaryReasonById($id: ID!) {
    cancellationSecondaryReason: entities {
      byId(id: $id, type: CancellationSecondaryReason) {
        __typename
        ...CancellationSecondaryReasonFields
      }
    }
  }
  ${CancellationSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCancellationSecondaryReasonByIdGQL extends Apollo.Query<
  FetchCancellationSecondaryReasonByIdQuery,
  FetchCancellationSecondaryReasonByIdQueryVariables
> {
  document = FetchCancellationSecondaryReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCancellationSecondaryReasonByIdsDocument = gql`
  query FetchCancellationSecondaryReasonByIds($ids: [ID!]!) {
    cancellationSecondaryReason: entities {
      byIds(ids: $ids, type: CancellationSecondaryReason) {
        __typename
        ...CancellationSecondaryReasonFields
      }
    }
  }
  ${CancellationSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCancellationSecondaryReasonByIdsGQL extends Apollo.Query<
  FetchCancellationSecondaryReasonByIdsQuery,
  FetchCancellationSecondaryReasonByIdsQueryVariables
> {
  document = FetchCancellationSecondaryReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardByIdDocument = gql`
  query FetchCardById($id: ID!) {
    card: entities {
      byId(id: $id, type: Card) {
        __typename
        ...CardFields
      }
    }
  }
  ${CardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardByIdGQL extends Apollo.Query<
  FetchCardByIdQuery,
  FetchCardByIdQueryVariables
> {
  document = FetchCardByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardByIdsDocument = gql`
  query FetchCardByIds($ids: [ID!]!) {
    card: entities {
      byIds(ids: $ids, type: Card) {
        __typename
        ...CardFields
      }
    }
  }
  ${CardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardByIdsGQL extends Apollo.Query<
  FetchCardByIdsQuery,
  FetchCardByIdsQueryVariables
> {
  document = FetchCardByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardLinkByIdDocument = gql`
  query FetchCardLinkById($id: ID!) {
    cardLink: entities {
      byId(id: $id, type: CardLink) {
        __typename
        ...CardLinkFields
      }
    }
  }
  ${CardLinkFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardLinkByIdGQL extends Apollo.Query<
  FetchCardLinkByIdQuery,
  FetchCardLinkByIdQueryVariables
> {
  document = FetchCardLinkByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardLinkByIdsDocument = gql`
  query FetchCardLinkByIds($ids: [ID!]!) {
    cardLink: entities {
      byIds(ids: $ids, type: CardLink) {
        __typename
        ...CardLinkFields
      }
    }
  }
  ${CardLinkFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardLinkByIdsGQL extends Apollo.Query<
  FetchCardLinkByIdsQuery,
  FetchCardLinkByIdsQueryVariables
> {
  document = FetchCardLinkByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardNoteArchiveByIdDocument = gql`
  query FetchCardNoteArchiveById($id: ID!) {
    cardNoteArchive: entities {
      byId(id: $id, type: CardNoteArchive) {
        __typename
        ...CardNoteArchiveFields
      }
    }
  }
  ${CardNoteArchiveFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardNoteArchiveByIdGQL extends Apollo.Query<
  FetchCardNoteArchiveByIdQuery,
  FetchCardNoteArchiveByIdQueryVariables
> {
  document = FetchCardNoteArchiveByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardNoteArchiveByIdsDocument = gql`
  query FetchCardNoteArchiveByIds($ids: [ID!]!) {
    cardNoteArchive: entities {
      byIds(ids: $ids, type: CardNoteArchive) {
        __typename
        ...CardNoteArchiveFields
      }
    }
  }
  ${CardNoteArchiveFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardNoteArchiveByIdsGQL extends Apollo.Query<
  FetchCardNoteArchiveByIdsQuery,
  FetchCardNoteArchiveByIdsQueryVariables
> {
  document = FetchCardNoteArchiveByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardNoteByIdDocument = gql`
  query FetchCardNoteById($id: ID!) {
    cardNote: entities {
      byId(id: $id, type: CardNote) {
        __typename
        ...CardNoteFields
      }
    }
  }
  ${CardNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardNoteByIdGQL extends Apollo.Query<
  FetchCardNoteByIdQuery,
  FetchCardNoteByIdQueryVariables
> {
  document = FetchCardNoteByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardNoteByIdsDocument = gql`
  query FetchCardNoteByIds($ids: [ID!]!) {
    cardNote: entities {
      byIds(ids: $ids, type: CardNote) {
        __typename
        ...CardNoteFields
      }
    }
  }
  ${CardNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardNoteByIdsGQL extends Apollo.Query<
  FetchCardNoteByIdsQuery,
  FetchCardNoteByIdsQueryVariables
> {
  document = FetchCardNoteByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardReOpenReasonByIdDocument = gql`
  query FetchCardReOpenReasonById($id: ID!) {
    cardReOpenReason: entities {
      byId(id: $id, type: CardReOpenReason) {
        __typename
        ...CardReOpenReasonFields
      }
    }
  }
  ${CardReOpenReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardReOpenReasonByIdGQL extends Apollo.Query<
  FetchCardReOpenReasonByIdQuery,
  FetchCardReOpenReasonByIdQueryVariables
> {
  document = FetchCardReOpenReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardReOpenReasonByIdsDocument = gql`
  query FetchCardReOpenReasonByIds($ids: [ID!]!) {
    cardReOpenReason: entities {
      byIds(ids: $ids, type: CardReOpenReason) {
        __typename
        ...CardReOpenReasonFields
      }
    }
  }
  ${CardReOpenReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardReOpenReasonByIdsGQL extends Apollo.Query<
  FetchCardReOpenReasonByIdsQuery,
  FetchCardReOpenReasonByIdsQueryVariables
> {
  document = FetchCardReOpenReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardSummaryByIdDocument = gql`
  query FetchCardSummaryById($id: ID!) {
    cardSummary: entities {
      byId(id: $id, type: CardSummary) {
        __typename
        ...CardSummaryFields
      }
    }
  }
  ${CardSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardSummaryByIdGQL extends Apollo.Query<
  FetchCardSummaryByIdQuery,
  FetchCardSummaryByIdQueryVariables
> {
  document = FetchCardSummaryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardSummaryByIdsDocument = gql`
  query FetchCardSummaryByIds($ids: [ID!]!) {
    cardSummary: entities {
      byIds(ids: $ids, type: CardSummary) {
        __typename
        ...CardSummaryFields
      }
    }
  }
  ${CardSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardSummaryByIdsGQL extends Apollo.Query<
  FetchCardSummaryByIdsQuery,
  FetchCardSummaryByIdsQueryVariables
> {
  document = FetchCardSummaryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchConfigurationSettingByIdDocument = gql`
  query FetchConfigurationSettingById($id: ID!) {
    configurationSetting: entities {
      byId(id: $id, type: ConfigurationSetting) {
        __typename
        ...ConfigurationSettingFields
      }
    }
  }
  ${ConfigurationSettingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchConfigurationSettingByIdGQL extends Apollo.Query<
  FetchConfigurationSettingByIdQuery,
  FetchConfigurationSettingByIdQueryVariables
> {
  document = FetchConfigurationSettingByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchConfigurationSettingByIdsDocument = gql`
  query FetchConfigurationSettingByIds($ids: [ID!]!) {
    configurationSetting: entities {
      byIds(ids: $ids, type: ConfigurationSetting) {
        __typename
        ...ConfigurationSettingFields
      }
    }
  }
  ${ConfigurationSettingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchConfigurationSettingByIdsGQL extends Apollo.Query<
  FetchConfigurationSettingByIdsQuery,
  FetchConfigurationSettingByIdsQueryVariables
> {
  document = FetchConfigurationSettingByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchConversationByIdDocument = gql`
  query FetchConversationById($id: ID!) {
    conversation: entities {
      byId(id: $id, type: Conversation) {
        __typename
        ...ConversationFields
      }
    }
  }
  ${ConversationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchConversationByIdGQL extends Apollo.Query<
  FetchConversationByIdQuery,
  FetchConversationByIdQueryVariables
> {
  document = FetchConversationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchConversationByIdsDocument = gql`
  query FetchConversationByIds($ids: [ID!]!) {
    conversation: entities {
      byIds(ids: $ids, type: Conversation) {
        __typename
        ...ConversationFields
      }
    }
  }
  ${ConversationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchConversationByIdsGQL extends Apollo.Query<
  FetchConversationByIdsQuery,
  FetchConversationByIdsQueryVariables
> {
  document = FetchConversationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchConversationParticipantByIdDocument = gql`
  query FetchConversationParticipantById($id: ID!) {
    conversationParticipant: entities {
      byId(id: $id, type: ConversationParticipant) {
        __typename
        ...ConversationParticipantFields
      }
    }
  }
  ${ConversationParticipantFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchConversationParticipantByIdGQL extends Apollo.Query<
  FetchConversationParticipantByIdQuery,
  FetchConversationParticipantByIdQueryVariables
> {
  document = FetchConversationParticipantByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchConversationParticipantByIdsDocument = gql`
  query FetchConversationParticipantByIds($ids: [ID!]!) {
    conversationParticipant: entities {
      byIds(ids: $ids, type: ConversationParticipant) {
        __typename
        ...ConversationParticipantFields
      }
    }
  }
  ${ConversationParticipantFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchConversationParticipantByIdsGQL extends Apollo.Query<
  FetchConversationParticipantByIdsQuery,
  FetchConversationParticipantByIdsQueryVariables
> {
  document = FetchConversationParticipantByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDeclineCategoryByIdDocument = gql`
  query FetchDeclineCategoryById($id: ID!) {
    declineCategory: entities {
      byId(id: $id, type: DeclineCategory) {
        __typename
        ...DeclineCategoryFields
      }
    }
  }
  ${DeclineCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDeclineCategoryByIdGQL extends Apollo.Query<
  FetchDeclineCategoryByIdQuery,
  FetchDeclineCategoryByIdQueryVariables
> {
  document = FetchDeclineCategoryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDeclineCategoryByIdsDocument = gql`
  query FetchDeclineCategoryByIds($ids: [ID!]!) {
    declineCategory: entities {
      byIds(ids: $ids, type: DeclineCategory) {
        __typename
        ...DeclineCategoryFields
      }
    }
  }
  ${DeclineCategoryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDeclineCategoryByIdsGQL extends Apollo.Query<
  FetchDeclineCategoryByIdsQuery,
  FetchDeclineCategoryByIdsQueryVariables
> {
  document = FetchDeclineCategoryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDeclineReasonByIdDocument = gql`
  query FetchDeclineReasonById($id: ID!) {
    declineReason: entities {
      byId(id: $id, type: DeclineReason) {
        __typename
        ...DeclineReasonFields
      }
    }
  }
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDeclineReasonByIdGQL extends Apollo.Query<
  FetchDeclineReasonByIdQuery,
  FetchDeclineReasonByIdQueryVariables
> {
  document = FetchDeclineReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDeclineReasonByIdsDocument = gql`
  query FetchDeclineReasonByIds($ids: [ID!]!) {
    declineReason: entities {
      byIds(ids: $ids, type: DeclineReason) {
        __typename
        ...DeclineReasonFields
      }
    }
  }
  ${DeclineReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDeclineReasonByIdsGQL extends Apollo.Query<
  FetchDeclineReasonByIdsQuery,
  FetchDeclineReasonByIdsQueryVariables
> {
  document = FetchDeclineReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDeclineSecondaryReasonByIdDocument = gql`
  query FetchDeclineSecondaryReasonById($id: ID!) {
    declineSecondaryReason: entities {
      byId(id: $id, type: DeclineSecondaryReason) {
        __typename
        ...DeclineSecondaryReasonFields
      }
    }
  }
  ${DeclineSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDeclineSecondaryReasonByIdGQL extends Apollo.Query<
  FetchDeclineSecondaryReasonByIdQuery,
  FetchDeclineSecondaryReasonByIdQueryVariables
> {
  document = FetchDeclineSecondaryReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDeclineSecondaryReasonByIdsDocument = gql`
  query FetchDeclineSecondaryReasonByIds($ids: [ID!]!) {
    declineSecondaryReason: entities {
      byIds(ids: $ids, type: DeclineSecondaryReason) {
        __typename
        ...DeclineSecondaryReasonFields
      }
    }
  }
  ${DeclineSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDeclineSecondaryReasonByIdsGQL extends Apollo.Query<
  FetchDeclineSecondaryReasonByIdsQuery,
  FetchDeclineSecondaryReasonByIdsQueryVariables
> {
  document = FetchDeclineSecondaryReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDiversionReasonByIdDocument = gql`
  query FetchDiversionReasonById($id: ID!) {
    diversionReason: entities {
      byId(id: $id, type: DiversionReason) {
        __typename
        ...DiversionReasonFields
      }
    }
  }
  ${DiversionReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDiversionReasonByIdGQL extends Apollo.Query<
  FetchDiversionReasonByIdQuery,
  FetchDiversionReasonByIdQueryVariables
> {
  document = FetchDiversionReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDiversionReasonByIdsDocument = gql`
  query FetchDiversionReasonByIds($ids: [ID!]!) {
    diversionReason: entities {
      byIds(ids: $ids, type: DiversionReason) {
        __typename
        ...DiversionReasonFields
      }
    }
  }
  ${DiversionReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDiversionReasonByIdsGQL extends Apollo.Query<
  FetchDiversionReasonByIdsQuery,
  FetchDiversionReasonByIdsQueryVariables
> {
  document = FetchDiversionReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEscortRequestByIdDocument = gql`
  query FetchEscortRequestById($id: ID!) {
    escortRequest: entities {
      byId(id: $id, type: EscortRequest) {
        __typename
        ...EscortRequestFields
      }
    }
  }
  ${EscortRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEscortRequestByIdGQL extends Apollo.Query<
  FetchEscortRequestByIdQuery,
  FetchEscortRequestByIdQueryVariables
> {
  document = FetchEscortRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEscortRequestByIdsDocument = gql`
  query FetchEscortRequestByIds($ids: [ID!]!) {
    escortRequest: entities {
      byIds(ids: $ids, type: EscortRequest) {
        __typename
        ...EscortRequestFields
      }
    }
  }
  ${EscortRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEscortRequestByIdsGQL extends Apollo.Query<
  FetchEscortRequestByIdsQuery,
  FetchEscortRequestByIdsQueryVariables
> {
  document = FetchEscortRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEstimatedDurationByIdDocument = gql`
  query FetchEstimatedDurationById($id: ID!) {
    estimatedDuration: entities {
      byId(id: $id, type: EstimatedDuration) {
        __typename
        ...EstimatedDurationFields
      }
    }
  }
  ${EstimatedDurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEstimatedDurationByIdGQL extends Apollo.Query<
  FetchEstimatedDurationByIdQuery,
  FetchEstimatedDurationByIdQueryVariables
> {
  document = FetchEstimatedDurationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEstimatedDurationByIdsDocument = gql`
  query FetchEstimatedDurationByIds($ids: [ID!]!) {
    estimatedDuration: entities {
      byIds(ids: $ids, type: EstimatedDuration) {
        __typename
        ...EstimatedDurationFields
      }
    }
  }
  ${EstimatedDurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEstimatedDurationByIdsGQL extends Apollo.Query<
  FetchEstimatedDurationByIdsQuery,
  FetchEstimatedDurationByIdsQueryVariables
> {
  document = FetchEstimatedDurationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEtaByIdDocument = gql`
  query FetchEtaById($id: ID!) {
    eta: entities {
      byId(id: $id, type: Eta) {
        __typename
        ...EtaFields
      }
    }
  }
  ${EtaFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEtaByIdGQL extends Apollo.Query<FetchEtaByIdQuery, FetchEtaByIdQueryVariables> {
  document = FetchEtaByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEtaByIdsDocument = gql`
  query FetchEtaByIds($ids: [ID!]!) {
    eta: entities {
      byIds(ids: $ids, type: Eta) {
        __typename
        ...EtaFields
      }
    }
  }
  ${EtaFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEtaByIdsGQL extends Apollo.Query<
  FetchEtaByIdsQuery,
  FetchEtaByIdsQueryVariables
> {
  document = FetchEtaByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalActionByIdDocument = gql`
  query FetchExternalActionById($id: ID!) {
    externalAction: entities {
      byId(id: $id, type: ExternalAction) {
        __typename
        ...ExternalActionFields
      }
    }
  }
  ${ExternalActionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalActionByIdGQL extends Apollo.Query<
  FetchExternalActionByIdQuery,
  FetchExternalActionByIdQueryVariables
> {
  document = FetchExternalActionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalActionByIdsDocument = gql`
  query FetchExternalActionByIds($ids: [ID!]!) {
    externalAction: entities {
      byIds(ids: $ids, type: ExternalAction) {
        __typename
        ...ExternalActionFields
      }
    }
  }
  ${ExternalActionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalActionByIdsGQL extends Apollo.Query<
  FetchExternalActionByIdsQuery,
  FetchExternalActionByIdsQueryVariables
> {
  document = FetchExternalActionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalActionTypeByIdDocument = gql`
  query FetchExternalActionTypeById($id: ID!) {
    externalActionType: entities {
      byId(id: $id, type: ExternalActionType) {
        __typename
        ...ExternalActionTypeFields
      }
    }
  }
  ${ExternalActionTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalActionTypeByIdGQL extends Apollo.Query<
  FetchExternalActionTypeByIdQuery,
  FetchExternalActionTypeByIdQueryVariables
> {
  document = FetchExternalActionTypeByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalActionTypeByIdsDocument = gql`
  query FetchExternalActionTypeByIds($ids: [ID!]!) {
    externalActionType: entities {
      byIds(ids: $ids, type: ExternalActionType) {
        __typename
        ...ExternalActionTypeFields
      }
    }
  }
  ${ExternalActionTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalActionTypeByIdsGQL extends Apollo.Query<
  FetchExternalActionTypeByIdsQuery,
  FetchExternalActionTypeByIdsQueryVariables
> {
  document = FetchExternalActionTypeByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalSystemUnitByIdDocument = gql`
  query FetchExternalSystemUnitById($id: ID!) {
    externalSystemUnit: entities {
      byId(id: $id, type: ExternalSystemUnit) {
        __typename
        ...ExternalSystemUnitFields
      }
    }
  }
  ${ExternalSystemUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalSystemUnitByIdGQL extends Apollo.Query<
  FetchExternalSystemUnitByIdQuery,
  FetchExternalSystemUnitByIdQueryVariables
> {
  document = FetchExternalSystemUnitByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalSystemUnitByIdsDocument = gql`
  query FetchExternalSystemUnitByIds($ids: [ID!]!) {
    externalSystemUnit: entities {
      byIds(ids: $ids, type: ExternalSystemUnit) {
        __typename
        ...ExternalSystemUnitFields
      }
    }
  }
  ${ExternalSystemUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalSystemUnitByIdsGQL extends Apollo.Query<
  FetchExternalSystemUnitByIdsQuery,
  FetchExternalSystemUnitByIdsQueryVariables
> {
  document = FetchExternalSystemUnitByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFacilityNonAcceptanceReasonByIdDocument = gql`
  query FetchFacilityNonAcceptanceReasonById($id: ID!) {
    facilityNonAcceptanceReason: entities {
      byId(id: $id, type: FacilityNonAcceptanceReason) {
        __typename
        ...FacilityNonAcceptanceReasonFields
      }
    }
  }
  ${FacilityNonAcceptanceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFacilityNonAcceptanceReasonByIdGQL extends Apollo.Query<
  FetchFacilityNonAcceptanceReasonByIdQuery,
  FetchFacilityNonAcceptanceReasonByIdQueryVariables
> {
  document = FetchFacilityNonAcceptanceReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFacilityNonAcceptanceReasonByIdsDocument = gql`
  query FetchFacilityNonAcceptanceReasonByIds($ids: [ID!]!) {
    facilityNonAcceptanceReason: entities {
      byIds(ids: $ids, type: FacilityNonAcceptanceReason) {
        __typename
        ...FacilityNonAcceptanceReasonFields
      }
    }
  }
  ${FacilityNonAcceptanceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFacilityNonAcceptanceReasonByIdsGQL extends Apollo.Query<
  FetchFacilityNonAcceptanceReasonByIdsQuery,
  FetchFacilityNonAcceptanceReasonByIdsQueryVariables
> {
  document = FetchFacilityNonAcceptanceReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFirewallRuleByIdDocument = gql`
  query FetchFirewallRuleById($id: ID!) {
    firewallRule: entities {
      byId(id: $id, type: FirewallRule) {
        __typename
        ...FirewallRuleFields
      }
    }
  }
  ${FirewallRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFirewallRuleByIdGQL extends Apollo.Query<
  FetchFirewallRuleByIdQuery,
  FetchFirewallRuleByIdQueryVariables
> {
  document = FetchFirewallRuleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFirewallRuleByIdsDocument = gql`
  query FetchFirewallRuleByIds($ids: [ID!]!) {
    firewallRule: entities {
      byIds(ids: $ids, type: FirewallRule) {
        __typename
        ...FirewallRuleFields
      }
    }
  }
  ${FirewallRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFirewallRuleByIdsGQL extends Apollo.Query<
  FetchFirewallRuleByIdsQuery,
  FetchFirewallRuleByIdsQueryVariables
> {
  document = FetchFirewallRuleByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFlightFollowingReportByIdDocument = gql`
  query FetchFlightFollowingReportById($id: ID!) {
    flightFollowingReport: entities {
      byId(id: $id, type: FlightFollowingReport) {
        __typename
        ...FlightFollowingReportFields
      }
    }
  }
  ${FlightFollowingReportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFlightFollowingReportByIdGQL extends Apollo.Query<
  FetchFlightFollowingReportByIdQuery,
  FetchFlightFollowingReportByIdQueryVariables
> {
  document = FetchFlightFollowingReportByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFlightFollowingReportByIdsDocument = gql`
  query FetchFlightFollowingReportByIds($ids: [ID!]!) {
    flightFollowingReport: entities {
      byIds(ids: $ids, type: FlightFollowingReport) {
        __typename
        ...FlightFollowingReportFields
      }
    }
  }
  ${FlightFollowingReportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFlightFollowingReportByIdsGQL extends Apollo.Query<
  FetchFlightFollowingReportByIdsQuery,
  FetchFlightFollowingReportByIdsQueryVariables
> {
  document = FetchFlightFollowingReportByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLandingZoneOutOfServiceReasonByIdDocument = gql`
  query FetchLandingZoneOutOfServiceReasonById($id: ID!) {
    landingZoneOutOfServiceReason: entities {
      byId(id: $id, type: LandingZoneOutOfServiceReason) {
        __typename
        ...LandingZoneOutOfServiceReasonFields
      }
    }
  }
  ${LandingZoneOutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLandingZoneOutOfServiceReasonByIdGQL extends Apollo.Query<
  FetchLandingZoneOutOfServiceReasonByIdQuery,
  FetchLandingZoneOutOfServiceReasonByIdQueryVariables
> {
  document = FetchLandingZoneOutOfServiceReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLandingZoneOutOfServiceReasonByIdsDocument = gql`
  query FetchLandingZoneOutOfServiceReasonByIds($ids: [ID!]!) {
    landingZoneOutOfServiceReason: entities {
      byIds(ids: $ids, type: LandingZoneOutOfServiceReason) {
        __typename
        ...LandingZoneOutOfServiceReasonFields
      }
    }
  }
  ${LandingZoneOutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLandingZoneOutOfServiceReasonByIdsGQL extends Apollo.Query<
  FetchLandingZoneOutOfServiceReasonByIdsQuery,
  FetchLandingZoneOutOfServiceReasonByIdsQueryVariables
> {
  document = FetchLandingZoneOutOfServiceReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLocationHazardAttachmentByIdDocument = gql`
  query FetchLocationHazardAttachmentById($id: ID!) {
    locationHazardAttachment: entities {
      byId(id: $id, type: LocationHazardAttachment) {
        __typename
        ...LocationHazardAttachmentFields
      }
    }
  }
  ${LocationHazardAttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLocationHazardAttachmentByIdGQL extends Apollo.Query<
  FetchLocationHazardAttachmentByIdQuery,
  FetchLocationHazardAttachmentByIdQueryVariables
> {
  document = FetchLocationHazardAttachmentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLocationHazardAttachmentByIdsDocument = gql`
  query FetchLocationHazardAttachmentByIds($ids: [ID!]!) {
    locationHazardAttachment: entities {
      byIds(ids: $ids, type: LocationHazardAttachment) {
        __typename
        ...LocationHazardAttachmentFields
      }
    }
  }
  ${LocationHazardAttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLocationHazardAttachmentByIdsGQL extends Apollo.Query<
  FetchLocationHazardAttachmentByIdsQuery,
  FetchLocationHazardAttachmentByIdsQueryVariables
> {
  document = FetchLocationHazardAttachmentByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLocationHazardByIdDocument = gql`
  query FetchLocationHazardById($id: ID!) {
    locationHazard: entities {
      byId(id: $id, type: LocationHazard) {
        __typename
        ...LocationHazardFields
      }
    }
  }
  ${LocationHazardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLocationHazardByIdGQL extends Apollo.Query<
  FetchLocationHazardByIdQuery,
  FetchLocationHazardByIdQueryVariables
> {
  document = FetchLocationHazardByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLocationHazardByIdsDocument = gql`
  query FetchLocationHazardByIds($ids: [ID!]!) {
    locationHazard: entities {
      byIds(ids: $ids, type: LocationHazard) {
        __typename
        ...LocationHazardFields
      }
    }
  }
  ${LocationHazardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLocationHazardByIdsGQL extends Apollo.Query<
  FetchLocationHazardByIdsQuery,
  FetchLocationHazardByIdsQueryVariables
> {
  document = FetchLocationHazardByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchManifestEntryByIdDocument = gql`
  query FetchManifestEntryById($id: ID!) {
    manifestEntry: entities {
      byId(id: $id, type: ManifestEntry) {
        __typename
        ...ManifestEntryFields
      }
    }
  }
  ${ManifestEntryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchManifestEntryByIdGQL extends Apollo.Query<
  FetchManifestEntryByIdQuery,
  FetchManifestEntryByIdQueryVariables
> {
  document = FetchManifestEntryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchManifestEntryByIdsDocument = gql`
  query FetchManifestEntryByIds($ids: [ID!]!) {
    manifestEntry: entities {
      byIds(ids: $ids, type: ManifestEntry) {
        __typename
        ...ManifestEntryFields
      }
    }
  }
  ${ManifestEntryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchManifestEntryByIdsGQL extends Apollo.Query<
  FetchManifestEntryByIdsQuery,
  FetchManifestEntryByIdsQueryVariables
> {
  document = FetchManifestEntryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalControlContactLogEntryByIdDocument = gql`
  query FetchMedicalControlContactLogEntryById($id: ID!) {
    medicalControlContactLogEntry: entities {
      byId(id: $id, type: MedicalControlContactLogEntry) {
        __typename
        ...MedicalControlContactLogEntryFields
      }
    }
  }
  ${MedicalControlContactLogEntryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalControlContactLogEntryByIdGQL extends Apollo.Query<
  FetchMedicalControlContactLogEntryByIdQuery,
  FetchMedicalControlContactLogEntryByIdQueryVariables
> {
  document = FetchMedicalControlContactLogEntryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalControlContactLogEntryByIdsDocument = gql`
  query FetchMedicalControlContactLogEntryByIds($ids: [ID!]!) {
    medicalControlContactLogEntry: entities {
      byIds(ids: $ids, type: MedicalControlContactLogEntry) {
        __typename
        ...MedicalControlContactLogEntryFields
      }
    }
  }
  ${MedicalControlContactLogEntryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalControlContactLogEntryByIdsGQL extends Apollo.Query<
  FetchMedicalControlContactLogEntryByIdsQuery,
  FetchMedicalControlContactLogEntryByIdsQueryVariables
> {
  document = FetchMedicalControlContactLogEntryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMessageStatusUpdateByIdDocument = gql`
  query FetchMessageStatusUpdateById($id: ID!) {
    messageStatusUpdate: entities {
      byId(id: $id, type: MessageStatusUpdate) {
        __typename
        ...MessageStatusUpdateFields
      }
    }
  }
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMessageStatusUpdateByIdGQL extends Apollo.Query<
  FetchMessageStatusUpdateByIdQuery,
  FetchMessageStatusUpdateByIdQueryVariables
> {
  document = FetchMessageStatusUpdateByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMessageStatusUpdateByIdsDocument = gql`
  query FetchMessageStatusUpdateByIds($ids: [ID!]!) {
    messageStatusUpdate: entities {
      byIds(ids: $ids, type: MessageStatusUpdate) {
        __typename
        ...MessageStatusUpdateFields
      }
    }
  }
  ${MessageStatusUpdateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMessageStatusUpdateByIdsGQL extends Apollo.Query<
  FetchMessageStatusUpdateByIdsQuery,
  FetchMessageStatusUpdateByIdsQueryVariables
> {
  document = FetchMessageStatusUpdateByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNewAgencyLocationRequestByIdDocument = gql`
  query FetchNewAgencyLocationRequestById($id: ID!) {
    newAgencyLocationRequest: entities {
      byId(id: $id, type: NewAgencyLocationRequest) {
        __typename
        ...NewAgencyLocationRequestFields
      }
    }
  }
  ${NewAgencyLocationRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNewAgencyLocationRequestByIdGQL extends Apollo.Query<
  FetchNewAgencyLocationRequestByIdQuery,
  FetchNewAgencyLocationRequestByIdQueryVariables
> {
  document = FetchNewAgencyLocationRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNewAgencyLocationRequestByIdsDocument = gql`
  query FetchNewAgencyLocationRequestByIds($ids: [ID!]!) {
    newAgencyLocationRequest: entities {
      byIds(ids: $ids, type: NewAgencyLocationRequest) {
        __typename
        ...NewAgencyLocationRequestFields
      }
    }
  }
  ${NewAgencyLocationRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNewAgencyLocationRequestByIdsGQL extends Apollo.Query<
  FetchNewAgencyLocationRequestByIdsQuery,
  FetchNewAgencyLocationRequestByIdsQueryVariables
> {
  document = FetchNewAgencyLocationRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNextDueTypeByIdDocument = gql`
  query FetchNextDueTypeById($id: ID!) {
    nextDueType: entities {
      byId(id: $id, type: NextDueType) {
        __typename
        ...NextDueTypeFields
      }
    }
  }
  ${NextDueTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNextDueTypeByIdGQL extends Apollo.Query<
  FetchNextDueTypeByIdQuery,
  FetchNextDueTypeByIdQueryVariables
> {
  document = FetchNextDueTypeByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNextDueTypeByIdsDocument = gql`
  query FetchNextDueTypeByIds($ids: [ID!]!) {
    nextDueType: entities {
      byIds(ids: $ids, type: NextDueType) {
        __typename
        ...NextDueTypeFields
      }
    }
  }
  ${NextDueTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNextDueTypeByIdsGQL extends Apollo.Query<
  FetchNextDueTypeByIdsQuery,
  FetchNextDueTypeByIdsQueryVariables
> {
  document = FetchNextDueTypeByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNonReferralReasonByIdDocument = gql`
  query FetchNonReferralReasonById($id: ID!) {
    nonReferralReason: entities {
      byId(id: $id, type: NonReferralReason) {
        __typename
        ...NonReferralReasonFields
      }
    }
  }
  ${NonReferralReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNonReferralReasonByIdGQL extends Apollo.Query<
  FetchNonReferralReasonByIdQuery,
  FetchNonReferralReasonByIdQueryVariables
> {
  document = FetchNonReferralReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNonReferralReasonByIdsDocument = gql`
  query FetchNonReferralReasonByIds($ids: [ID!]!) {
    nonReferralReason: entities {
      byIds(ids: $ids, type: NonReferralReason) {
        __typename
        ...NonReferralReasonFields
      }
    }
  }
  ${NonReferralReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNonReferralReasonByIdsGQL extends Apollo.Query<
  FetchNonReferralReasonByIdsQuery,
  FetchNonReferralReasonByIdsQueryVariables
> {
  document = FetchNonReferralReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationByIdDocument = gql`
  query FetchNotificationById($id: ID!) {
    notification: entities {
      byId(id: $id, type: Notification) {
        __typename
        ...NotificationFields
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationByIdGQL extends Apollo.Query<
  FetchNotificationByIdQuery,
  FetchNotificationByIdQueryVariables
> {
  document = FetchNotificationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationByIdsDocument = gql`
  query FetchNotificationByIds($ids: [ID!]!) {
    notification: entities {
      byIds(ids: $ids, type: Notification) {
        __typename
        ...NotificationFields
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationByIdsGQL extends Apollo.Query<
  FetchNotificationByIdsQuery,
  FetchNotificationByIdsQueryVariables
> {
  document = FetchNotificationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationGroupByIdDocument = gql`
  query FetchNotificationGroupById($id: ID!) {
    notificationGroup: entities {
      byId(id: $id, type: NotificationGroup) {
        __typename
        ...NotificationGroupFields
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationGroupByIdGQL extends Apollo.Query<
  FetchNotificationGroupByIdQuery,
  FetchNotificationGroupByIdQueryVariables
> {
  document = FetchNotificationGroupByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationGroupByIdsDocument = gql`
  query FetchNotificationGroupByIds($ids: [ID!]!) {
    notificationGroup: entities {
      byIds(ids: $ids, type: NotificationGroup) {
        __typename
        ...NotificationGroupFields
      }
    }
  }
  ${NotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationGroupByIdsGQL extends Apollo.Query<
  FetchNotificationGroupByIdsQuery,
  FetchNotificationGroupByIdsQueryVariables
> {
  document = FetchNotificationGroupByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationGroupMemberByIdDocument = gql`
  query FetchNotificationGroupMemberById($id: ID!) {
    notificationGroupMember: entities {
      byId(id: $id, type: NotificationGroupMember) {
        __typename
        ...NotificationGroupMemberFields
      }
    }
  }
  ${NotificationGroupMemberFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationGroupMemberByIdGQL extends Apollo.Query<
  FetchNotificationGroupMemberByIdQuery,
  FetchNotificationGroupMemberByIdQueryVariables
> {
  document = FetchNotificationGroupMemberByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationGroupMemberByIdsDocument = gql`
  query FetchNotificationGroupMemberByIds($ids: [ID!]!) {
    notificationGroupMember: entities {
      byIds(ids: $ids, type: NotificationGroupMember) {
        __typename
        ...NotificationGroupMemberFields
      }
    }
  }
  ${NotificationGroupMemberFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationGroupMemberByIdsGQL extends Apollo.Query<
  FetchNotificationGroupMemberByIdsQuery,
  FetchNotificationGroupMemberByIdsQueryVariables
> {
  document = FetchNotificationGroupMemberByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationRecipientByIdDocument = gql`
  query FetchNotificationRecipientById($id: ID!) {
    notificationRecipient: entities {
      byId(id: $id, type: NotificationRecipient) {
        __typename
        ...NotificationRecipientFields
      }
    }
  }
  ${NotificationRecipientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationRecipientByIdGQL extends Apollo.Query<
  FetchNotificationRecipientByIdQuery,
  FetchNotificationRecipientByIdQueryVariables
> {
  document = FetchNotificationRecipientByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationRecipientByIdsDocument = gql`
  query FetchNotificationRecipientByIds($ids: [ID!]!) {
    notificationRecipient: entities {
      byIds(ids: $ids, type: NotificationRecipient) {
        __typename
        ...NotificationRecipientFields
      }
    }
  }
  ${NotificationRecipientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationRecipientByIdsGQL extends Apollo.Query<
  FetchNotificationRecipientByIdsQuery,
  FetchNotificationRecipientByIdsQueryVariables
> {
  document = FetchNotificationRecipientByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationSubscriptionByIdDocument = gql`
  query FetchNotificationSubscriptionById($id: ID!) {
    notificationSubscription: entities {
      byId(id: $id, type: NotificationSubscription) {
        __typename
        ...NotificationSubscriptionFields
      }
    }
  }
  ${NotificationSubscriptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationSubscriptionByIdGQL extends Apollo.Query<
  FetchNotificationSubscriptionByIdQuery,
  FetchNotificationSubscriptionByIdQueryVariables
> {
  document = FetchNotificationSubscriptionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationSubscriptionByIdsDocument = gql`
  query FetchNotificationSubscriptionByIds($ids: [ID!]!) {
    notificationSubscription: entities {
      byIds(ids: $ids, type: NotificationSubscription) {
        __typename
        ...NotificationSubscriptionFields
      }
    }
  }
  ${NotificationSubscriptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationSubscriptionByIdsGQL extends Apollo.Query<
  FetchNotificationSubscriptionByIdsQuery,
  FetchNotificationSubscriptionByIdsQueryVariables
> {
  document = FetchNotificationSubscriptionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationTemplateByIdDocument = gql`
  query FetchNotificationTemplateById($id: ID!) {
    notificationTemplate: entities {
      byId(id: $id, type: NotificationTemplate) {
        __typename
        ...NotificationTemplateFields
      }
    }
  }
  ${NotificationTemplateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationTemplateByIdGQL extends Apollo.Query<
  FetchNotificationTemplateByIdQuery,
  FetchNotificationTemplateByIdQueryVariables
> {
  document = FetchNotificationTemplateByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchNotificationTemplateByIdsDocument = gql`
  query FetchNotificationTemplateByIds($ids: [ID!]!) {
    notificationTemplate: entities {
      byIds(ids: $ids, type: NotificationTemplate) {
        __typename
        ...NotificationTemplateFields
      }
    }
  }
  ${NotificationTemplateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchNotificationTemplateByIdsGQL extends Apollo.Query<
  FetchNotificationTemplateByIdsQuery,
  FetchNotificationTemplateByIdsQueryVariables
> {
  document = FetchNotificationTemplateByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemActivityByIdDocument = gql`
  query FetchOemActivityById($id: ID!) {
    oemActivity: entities {
      byId(id: $id, type: OemActivity) {
        __typename
        ...OemActivityFields
      }
    }
  }
  ${OemActivityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemActivityByIdGQL extends Apollo.Query<
  FetchOemActivityByIdQuery,
  FetchOemActivityByIdQueryVariables
> {
  document = FetchOemActivityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemActivityByIdsDocument = gql`
  query FetchOemActivityByIds($ids: [ID!]!) {
    oemActivity: entities {
      byIds(ids: $ids, type: OemActivity) {
        __typename
        ...OemActivityFields
      }
    }
  }
  ${OemActivityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemActivityByIdsGQL extends Apollo.Query<
  FetchOemActivityByIdsQuery,
  FetchOemActivityByIdsQueryVariables
> {
  document = FetchOemActivityByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemAssetByIdDocument = gql`
  query FetchOemAssetById($id: ID!) {
    oemAsset: entities {
      byId(id: $id, type: OemAsset) {
        __typename
        ...OemAssetFields
      }
    }
  }
  ${OemAssetFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemAssetByIdGQL extends Apollo.Query<
  FetchOemAssetByIdQuery,
  FetchOemAssetByIdQueryVariables
> {
  document = FetchOemAssetByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemAssetByIdsDocument = gql`
  query FetchOemAssetByIds($ids: [ID!]!) {
    oemAsset: entities {
      byIds(ids: $ids, type: OemAsset) {
        __typename
        ...OemAssetFields
      }
    }
  }
  ${OemAssetFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemAssetByIdsGQL extends Apollo.Query<
  FetchOemAssetByIdsQuery,
  FetchOemAssetByIdsQueryVariables
> {
  document = FetchOemAssetByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemPlanChangeRequestByIdDocument = gql`
  query FetchOemPlanChangeRequestById($id: ID!) {
    oemPlanChangeRequest: entities {
      byId(id: $id, type: OemPlanChangeRequest) {
        __typename
        ...OemPlanChangeRequestFields
      }
    }
  }
  ${OemPlanChangeRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemPlanChangeRequestByIdGQL extends Apollo.Query<
  FetchOemPlanChangeRequestByIdQuery,
  FetchOemPlanChangeRequestByIdQueryVariables
> {
  document = FetchOemPlanChangeRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemPlanChangeRequestByIdsDocument = gql`
  query FetchOemPlanChangeRequestByIds($ids: [ID!]!) {
    oemPlanChangeRequest: entities {
      byIds(ids: $ids, type: OemPlanChangeRequest) {
        __typename
        ...OemPlanChangeRequestFields
      }
    }
  }
  ${OemPlanChangeRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemPlanChangeRequestByIdsGQL extends Apollo.Query<
  FetchOemPlanChangeRequestByIdsQuery,
  FetchOemPlanChangeRequestByIdsQueryVariables
> {
  document = FetchOemPlanChangeRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemPlanByIdDocument = gql`
  query FetchOemPlanById($id: ID!) {
    oemPlan: entities {
      byId(id: $id, type: OemPlan) {
        __typename
        ...OemPlanFields
      }
    }
  }
  ${OemPlanFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemPlanByIdGQL extends Apollo.Query<
  FetchOemPlanByIdQuery,
  FetchOemPlanByIdQueryVariables
> {
  document = FetchOemPlanByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOemPlanByIdsDocument = gql`
  query FetchOemPlanByIds($ids: [ID!]!) {
    oemPlan: entities {
      byIds(ids: $ids, type: OemPlan) {
        __typename
        ...OemPlanFields
      }
    }
  }
  ${OemPlanFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOemPlanByIdsGQL extends Apollo.Query<
  FetchOemPlanByIdsQuery,
  FetchOemPlanByIdsQueryVariables
> {
  document = FetchOemPlanByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOfferAlgorithmByIdDocument = gql`
  query FetchOfferAlgorithmById($id: ID!) {
    offerAlgorithm: entities {
      byId(id: $id, type: OfferAlgorithm) {
        __typename
        ...OfferAlgorithmFields
      }
    }
  }
  ${OfferAlgorithmFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOfferAlgorithmByIdGQL extends Apollo.Query<
  FetchOfferAlgorithmByIdQuery,
  FetchOfferAlgorithmByIdQueryVariables
> {
  document = FetchOfferAlgorithmByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOfferAlgorithmByIdsDocument = gql`
  query FetchOfferAlgorithmByIds($ids: [ID!]!) {
    offerAlgorithm: entities {
      byIds(ids: $ids, type: OfferAlgorithm) {
        __typename
        ...OfferAlgorithmFields
      }
    }
  }
  ${OfferAlgorithmFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOfferAlgorithmByIdsGQL extends Apollo.Query<
  FetchOfferAlgorithmByIdsQuery,
  FetchOfferAlgorithmByIdsQueryVariables
> {
  document = FetchOfferAlgorithmByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOperationByIdDocument = gql`
  query FetchOperationById($id: ID!) {
    operation: entities {
      byId(id: $id, type: Operation) {
        __typename
        ...OperationFields
      }
    }
  }
  ${OperationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOperationByIdGQL extends Apollo.Query<
  FetchOperationByIdQuery,
  FetchOperationByIdQueryVariables
> {
  document = FetchOperationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOperationByIdsDocument = gql`
  query FetchOperationByIds($ids: [ID!]!) {
    operation: entities {
      byIds(ids: $ids, type: Operation) {
        __typename
        ...OperationFields
      }
    }
  }
  ${OperationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOperationByIdsGQL extends Apollo.Query<
  FetchOperationByIdsQuery,
  FetchOperationByIdsQueryVariables
> {
  document = FetchOperationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceEventByIdDocument = gql`
  query FetchOutOfServiceEventById($id: ID!) {
    outOfServiceEvent: entities {
      byId(id: $id, type: OutOfServiceEvent) {
        __typename
        ...OutOfServiceEventFields
      }
    }
  }
  ${OutOfServiceEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceEventByIdGQL extends Apollo.Query<
  FetchOutOfServiceEventByIdQuery,
  FetchOutOfServiceEventByIdQueryVariables
> {
  document = FetchOutOfServiceEventByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceEventByIdsDocument = gql`
  query FetchOutOfServiceEventByIds($ids: [ID!]!) {
    outOfServiceEvent: entities {
      byIds(ids: $ids, type: OutOfServiceEvent) {
        __typename
        ...OutOfServiceEventFields
      }
    }
  }
  ${OutOfServiceEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceEventByIdsGQL extends Apollo.Query<
  FetchOutOfServiceEventByIdsQuery,
  FetchOutOfServiceEventByIdsQueryVariables
> {
  document = FetchOutOfServiceEventByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceEventNoteByIdDocument = gql`
  query FetchOutOfServiceEventNoteById($id: ID!) {
    outOfServiceEventNote: entities {
      byId(id: $id, type: OutOfServiceEventNote) {
        __typename
        ...OutOfServiceEventNoteFields
      }
    }
  }
  ${OutOfServiceEventNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceEventNoteByIdGQL extends Apollo.Query<
  FetchOutOfServiceEventNoteByIdQuery,
  FetchOutOfServiceEventNoteByIdQueryVariables
> {
  document = FetchOutOfServiceEventNoteByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceEventNoteByIdsDocument = gql`
  query FetchOutOfServiceEventNoteByIds($ids: [ID!]!) {
    outOfServiceEventNote: entities {
      byIds(ids: $ids, type: OutOfServiceEventNote) {
        __typename
        ...OutOfServiceEventNoteFields
      }
    }
  }
  ${OutOfServiceEventNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceEventNoteByIdsGQL extends Apollo.Query<
  FetchOutOfServiceEventNoteByIdsQuery,
  FetchOutOfServiceEventNoteByIdsQueryVariables
> {
  document = FetchOutOfServiceEventNoteByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceReasonByIdDocument = gql`
  query FetchOutOfServiceReasonById($id: ID!) {
    outOfServiceReason: entities {
      byId(id: $id, type: OutOfServiceReason) {
        __typename
        ...OutOfServiceReasonFields
      }
    }
  }
  ${OutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceReasonByIdGQL extends Apollo.Query<
  FetchOutOfServiceReasonByIdQuery,
  FetchOutOfServiceReasonByIdQueryVariables
> {
  document = FetchOutOfServiceReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceReasonByIdsDocument = gql`
  query FetchOutOfServiceReasonByIds($ids: [ID!]!) {
    outOfServiceReason: entities {
      byIds(ids: $ids, type: OutOfServiceReason) {
        __typename
        ...OutOfServiceReasonFields
      }
    }
  }
  ${OutOfServiceReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceReasonByIdsGQL extends Apollo.Query<
  FetchOutOfServiceReasonByIdsQuery,
  FetchOutOfServiceReasonByIdsQueryVariables
> {
  document = FetchOutOfServiceReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceSecondaryReasonByIdDocument = gql`
  query FetchOutOfServiceSecondaryReasonById($id: ID!) {
    outOfServiceSecondaryReason: entities {
      byId(id: $id, type: OutOfServiceSecondaryReason) {
        __typename
        ...OutOfServiceSecondaryReasonFields
      }
    }
  }
  ${OutOfServiceSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceSecondaryReasonByIdGQL extends Apollo.Query<
  FetchOutOfServiceSecondaryReasonByIdQuery,
  FetchOutOfServiceSecondaryReasonByIdQueryVariables
> {
  document = FetchOutOfServiceSecondaryReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceSecondaryReasonByIdsDocument = gql`
  query FetchOutOfServiceSecondaryReasonByIds($ids: [ID!]!) {
    outOfServiceSecondaryReason: entities {
      byIds(ids: $ids, type: OutOfServiceSecondaryReason) {
        __typename
        ...OutOfServiceSecondaryReasonFields
      }
    }
  }
  ${OutOfServiceSecondaryReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceSecondaryReasonByIdsGQL extends Apollo.Query<
  FetchOutOfServiceSecondaryReasonByIdsQuery,
  FetchOutOfServiceSecondaryReasonByIdsQueryVariables
> {
  document = FetchOutOfServiceSecondaryReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceTicketByIdDocument = gql`
  query FetchOutOfServiceTicketById($id: ID!) {
    outOfServiceTicket: entities {
      byId(id: $id, type: OutOfServiceTicket) {
        __typename
        ...OutOfServiceTicketFields
      }
    }
  }
  ${OutOfServiceTicketFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceTicketByIdGQL extends Apollo.Query<
  FetchOutOfServiceTicketByIdQuery,
  FetchOutOfServiceTicketByIdQueryVariables
> {
  document = FetchOutOfServiceTicketByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceTicketByIdsDocument = gql`
  query FetchOutOfServiceTicketByIds($ids: [ID!]!) {
    outOfServiceTicket: entities {
      byIds(ids: $ids, type: OutOfServiceTicket) {
        __typename
        ...OutOfServiceTicketFields
      }
    }
  }
  ${OutOfServiceTicketFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceTicketByIdsGQL extends Apollo.Query<
  FetchOutOfServiceTicketByIdsQuery,
  FetchOutOfServiceTicketByIdsQueryVariables
> {
  document = FetchOutOfServiceTicketByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPaipEventByIdDocument = gql`
  query FetchPaipEventById($id: ID!) {
    paipEvent: entities {
      byId(id: $id, type: PaipEvent) {
        __typename
        ...PaipEventFields
      }
    }
  }
  ${PaipEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPaipEventByIdGQL extends Apollo.Query<
  FetchPaipEventByIdQuery,
  FetchPaipEventByIdQueryVariables
> {
  document = FetchPaipEventByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPaipEventByIdsDocument = gql`
  query FetchPaipEventByIds($ids: [ID!]!) {
    paipEvent: entities {
      byIds(ids: $ids, type: PaipEvent) {
        __typename
        ...PaipEventFields
      }
    }
  }
  ${PaipEventFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPaipEventByIdsGQL extends Apollo.Query<
  FetchPaipEventByIdsQuery,
  FetchPaipEventByIdsQueryVariables
> {
  document = FetchPaipEventByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPaipReasonByIdDocument = gql`
  query FetchPaipReasonById($id: ID!) {
    paipReason: entities {
      byId(id: $id, type: PaipReason) {
        __typename
        ...PaipReasonFields
      }
    }
  }
  ${PaipReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPaipReasonByIdGQL extends Apollo.Query<
  FetchPaipReasonByIdQuery,
  FetchPaipReasonByIdQueryVariables
> {
  document = FetchPaipReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPaipReasonByIdsDocument = gql`
  query FetchPaipReasonByIds($ids: [ID!]!) {
    paipReason: entities {
      byIds(ids: $ids, type: PaipReason) {
        __typename
        ...PaipReasonFields
      }
    }
  }
  ${PaipReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPaipReasonByIdsGQL extends Apollo.Query<
  FetchPaipReasonByIdsQuery,
  FetchPaipReasonByIdsQueryVariables
> {
  document = FetchPaipReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPassdownLogAcknowledgementByIdDocument = gql`
  query FetchPassdownLogAcknowledgementById($id: ID!) {
    passdownLogAcknowledgement: entities {
      byId(id: $id, type: PassdownLogAcknowledgement) {
        __typename
        ...PassdownLogAcknowledgementFields
      }
    }
  }
  ${PassdownLogAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPassdownLogAcknowledgementByIdGQL extends Apollo.Query<
  FetchPassdownLogAcknowledgementByIdQuery,
  FetchPassdownLogAcknowledgementByIdQueryVariables
> {
  document = FetchPassdownLogAcknowledgementByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPassdownLogAcknowledgementByIdsDocument = gql`
  query FetchPassdownLogAcknowledgementByIds($ids: [ID!]!) {
    passdownLogAcknowledgement: entities {
      byIds(ids: $ids, type: PassdownLogAcknowledgement) {
        __typename
        ...PassdownLogAcknowledgementFields
      }
    }
  }
  ${PassdownLogAcknowledgementFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPassdownLogAcknowledgementByIdsGQL extends Apollo.Query<
  FetchPassdownLogAcknowledgementByIdsQuery,
  FetchPassdownLogAcknowledgementByIdsQueryVariables
> {
  document = FetchPassdownLogAcknowledgementByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPassdownLogArchivedLogByIdDocument = gql`
  query FetchPassdownLogArchivedLogById($id: ID!) {
    passdownLogArchivedLog: entities {
      byId(id: $id, type: PassdownLogArchivedLog) {
        __typename
        ...PassdownLogArchivedLogFields
      }
    }
  }
  ${PassdownLogArchivedLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPassdownLogArchivedLogByIdGQL extends Apollo.Query<
  FetchPassdownLogArchivedLogByIdQuery,
  FetchPassdownLogArchivedLogByIdQueryVariables
> {
  document = FetchPassdownLogArchivedLogByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPassdownLogArchivedLogByIdsDocument = gql`
  query FetchPassdownLogArchivedLogByIds($ids: [ID!]!) {
    passdownLogArchivedLog: entities {
      byIds(ids: $ids, type: PassdownLogArchivedLog) {
        __typename
        ...PassdownLogArchivedLogFields
      }
    }
  }
  ${PassdownLogArchivedLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPassdownLogArchivedLogByIdsGQL extends Apollo.Query<
  FetchPassdownLogArchivedLogByIdsQuery,
  FetchPassdownLogArchivedLogByIdsQueryVariables
> {
  document = FetchPassdownLogArchivedLogByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPassdownLogByIdDocument = gql`
  query FetchPassdownLogById($id: ID!) {
    passdownLog: entities {
      byId(id: $id, type: PassdownLog) {
        __typename
        ...PassdownLogFields
      }
    }
  }
  ${PassdownLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPassdownLogByIdGQL extends Apollo.Query<
  FetchPassdownLogByIdQuery,
  FetchPassdownLogByIdQueryVariables
> {
  document = FetchPassdownLogByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPassdownLogByIdsDocument = gql`
  query FetchPassdownLogByIds($ids: [ID!]!) {
    passdownLog: entities {
      byIds(ids: $ids, type: PassdownLog) {
        __typename
        ...PassdownLogFields
      }
    }
  }
  ${PassdownLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPassdownLogByIdsGQL extends Apollo.Query<
  FetchPassdownLogByIdsQuery,
  FetchPassdownLogByIdsQueryVariables
> {
  document = FetchPassdownLogByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPatientByIdDocument = gql`
  query FetchPatientById($id: ID!) {
    patient: entities {
      byId(id: $id, type: Patient) {
        __typename
        ...PatientFields
      }
    }
  }
  ${PatientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPatientByIdGQL extends Apollo.Query<
  FetchPatientByIdQuery,
  FetchPatientByIdQueryVariables
> {
  document = FetchPatientByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPatientByIdsDocument = gql`
  query FetchPatientByIds($ids: [ID!]!) {
    patient: entities {
      byIds(ids: $ids, type: Patient) {
        __typename
        ...PatientFields
      }
    }
  }
  ${PatientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPatientByIdsGQL extends Apollo.Query<
  FetchPatientByIdsQuery,
  FetchPatientByIdsQueryVariables
> {
  document = FetchPatientByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPositionReportAlertByIdDocument = gql`
  query FetchPositionReportAlertById($id: ID!) {
    positionReportAlert: entities {
      byId(id: $id, type: PositionReportAlert) {
        __typename
        ...PositionReportAlertFields
      }
    }
  }
  ${PositionReportAlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPositionReportAlertByIdGQL extends Apollo.Query<
  FetchPositionReportAlertByIdQuery,
  FetchPositionReportAlertByIdQueryVariables
> {
  document = FetchPositionReportAlertByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPositionReportAlertByIdsDocument = gql`
  query FetchPositionReportAlertByIds($ids: [ID!]!) {
    positionReportAlert: entities {
      byIds(ids: $ids, type: PositionReportAlert) {
        __typename
        ...PositionReportAlertFields
      }
    }
  }
  ${PositionReportAlertFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPositionReportAlertByIdsGQL extends Apollo.Query<
  FetchPositionReportAlertByIdsQuery,
  FetchPositionReportAlertByIdsQueryVariables
> {
  document = FetchPositionReportAlertByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPositionReportArchiveByIdDocument = gql`
  query FetchPositionReportArchiveById($id: ID!) {
    positionReportArchive: entities {
      byId(id: $id, type: PositionReportArchive) {
        __typename
        ...PositionReportArchiveFields
      }
    }
  }
  ${PositionReportArchiveFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPositionReportArchiveByIdGQL extends Apollo.Query<
  FetchPositionReportArchiveByIdQuery,
  FetchPositionReportArchiveByIdQueryVariables
> {
  document = FetchPositionReportArchiveByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPositionReportArchiveByIdsDocument = gql`
  query FetchPositionReportArchiveByIds($ids: [ID!]!) {
    positionReportArchive: entities {
      byIds(ids: $ids, type: PositionReportArchive) {
        __typename
        ...PositionReportArchiveFields
      }
    }
  }
  ${PositionReportArchiveFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPositionReportArchiveByIdsGQL extends Apollo.Query<
  FetchPositionReportArchiveByIdsQuery,
  FetchPositionReportArchiveByIdsQueryVariables
> {
  document = FetchPositionReportArchiveByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPositionReportByIdDocument = gql`
  query FetchPositionReportById($id: ID!) {
    positionReport: entities {
      byId(id: $id, type: PositionReport) {
        __typename
        ...PositionReportFields
      }
    }
  }
  ${PositionReportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPositionReportByIdGQL extends Apollo.Query<
  FetchPositionReportByIdQuery,
  FetchPositionReportByIdQueryVariables
> {
  document = FetchPositionReportByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPositionReportByIdsDocument = gql`
  query FetchPositionReportByIds($ids: [ID!]!) {
    positionReport: entities {
      byIds(ids: $ids, type: PositionReport) {
        __typename
        ...PositionReportFields
      }
    }
  }
  ${PositionReportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPositionReportByIdsGQL extends Apollo.Query<
  FetchPositionReportByIdsQuery,
  FetchPositionReportByIdsQueryVariables
> {
  document = FetchPositionReportByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionChoiceByIdDocument = gql`
  query FetchQuestionChoiceById($id: ID!) {
    questionChoice: entities {
      byId(id: $id, type: QuestionChoice) {
        __typename
        ...QuestionChoiceFields
      }
    }
  }
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionChoiceByIdGQL extends Apollo.Query<
  FetchQuestionChoiceByIdQuery,
  FetchQuestionChoiceByIdQueryVariables
> {
  document = FetchQuestionChoiceByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionChoiceByIdsDocument = gql`
  query FetchQuestionChoiceByIds($ids: [ID!]!) {
    questionChoice: entities {
      byIds(ids: $ids, type: QuestionChoice) {
        __typename
        ...QuestionChoiceFields
      }
    }
  }
  ${QuestionChoiceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionChoiceByIdsGQL extends Apollo.Query<
  FetchQuestionChoiceByIdsQuery,
  FetchQuestionChoiceByIdsQueryVariables
> {
  document = FetchQuestionChoiceByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionByIdDocument = gql`
  query FetchQuestionById($id: ID!) {
    question: entities {
      byId(id: $id, type: Question) {
        __typename
        ...QuestionFields
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionByIdGQL extends Apollo.Query<
  FetchQuestionByIdQuery,
  FetchQuestionByIdQueryVariables
> {
  document = FetchQuestionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionByIdsDocument = gql`
  query FetchQuestionByIds($ids: [ID!]!) {
    question: entities {
      byIds(ids: $ids, type: Question) {
        __typename
        ...QuestionFields
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionByIdsGQL extends Apollo.Query<
  FetchQuestionByIdsQuery,
  FetchQuestionByIdsQueryVariables
> {
  document = FetchQuestionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireByIdDocument = gql`
  query FetchQuestionnaireById($id: ID!) {
    questionnaire: entities {
      byId(id: $id, type: Questionnaire) {
        __typename
        ...QuestionnaireFields
      }
    }
  }
  ${QuestionnaireFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireByIdGQL extends Apollo.Query<
  FetchQuestionnaireByIdQuery,
  FetchQuestionnaireByIdQueryVariables
> {
  document = FetchQuestionnaireByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireByIdsDocument = gql`
  query FetchQuestionnaireByIds($ids: [ID!]!) {
    questionnaire: entities {
      byIds(ids: $ids, type: Questionnaire) {
        __typename
        ...QuestionnaireFields
      }
    }
  }
  ${QuestionnaireFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireByIdsGQL extends Apollo.Query<
  FetchQuestionnaireByIdsQuery,
  FetchQuestionnaireByIdsQueryVariables
> {
  document = FetchQuestionnaireByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireQuestionResponseByIdDocument = gql`
  query FetchQuestionnaireQuestionResponseById($id: ID!) {
    questionnaireQuestionResponse: entities {
      byId(id: $id, type: QuestionnaireQuestionResponse) {
        __typename
        ...QuestionnaireQuestionResponseFields
      }
    }
  }
  ${QuestionnaireQuestionResponseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireQuestionResponseByIdGQL extends Apollo.Query<
  FetchQuestionnaireQuestionResponseByIdQuery,
  FetchQuestionnaireQuestionResponseByIdQueryVariables
> {
  document = FetchQuestionnaireQuestionResponseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireQuestionResponseByIdsDocument = gql`
  query FetchQuestionnaireQuestionResponseByIds($ids: [ID!]!) {
    questionnaireQuestionResponse: entities {
      byIds(ids: $ids, type: QuestionnaireQuestionResponse) {
        __typename
        ...QuestionnaireQuestionResponseFields
      }
    }
  }
  ${QuestionnaireQuestionResponseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireQuestionResponseByIdsGQL extends Apollo.Query<
  FetchQuestionnaireQuestionResponseByIdsQuery,
  FetchQuestionnaireQuestionResponseByIdsQueryVariables
> {
  document = FetchQuestionnaireQuestionResponseByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireQuestionResponseNoteByIdDocument = gql`
  query FetchQuestionnaireQuestionResponseNoteById($id: ID!) {
    questionnaireQuestionResponseNote: entities {
      byId(id: $id, type: QuestionnaireQuestionResponseNote) {
        __typename
        ...QuestionnaireQuestionResponseNoteFields
      }
    }
  }
  ${QuestionnaireQuestionResponseNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireQuestionResponseNoteByIdGQL extends Apollo.Query<
  FetchQuestionnaireQuestionResponseNoteByIdQuery,
  FetchQuestionnaireQuestionResponseNoteByIdQueryVariables
> {
  document = FetchQuestionnaireQuestionResponseNoteByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireQuestionResponseNoteByIdsDocument = gql`
  query FetchQuestionnaireQuestionResponseNoteByIds($ids: [ID!]!) {
    questionnaireQuestionResponseNote: entities {
      byIds(ids: $ids, type: QuestionnaireQuestionResponseNote) {
        __typename
        ...QuestionnaireQuestionResponseNoteFields
      }
    }
  }
  ${QuestionnaireQuestionResponseNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireQuestionResponseNoteByIdsGQL extends Apollo.Query<
  FetchQuestionnaireQuestionResponseNoteByIdsQuery,
  FetchQuestionnaireQuestionResponseNoteByIdsQueryVariables
> {
  document = FetchQuestionnaireQuestionResponseNoteByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireResponseByIdDocument = gql`
  query FetchQuestionnaireResponseById($id: ID!) {
    questionnaireResponse: entities {
      byId(id: $id, type: QuestionnaireResponse) {
        __typename
        ...QuestionnaireResponseFields
      }
    }
  }
  ${QuestionnaireResponseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireResponseByIdGQL extends Apollo.Query<
  FetchQuestionnaireResponseByIdQuery,
  FetchQuestionnaireResponseByIdQueryVariables
> {
  document = FetchQuestionnaireResponseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireResponseByIdsDocument = gql`
  query FetchQuestionnaireResponseByIds($ids: [ID!]!) {
    questionnaireResponse: entities {
      byIds(ids: $ids, type: QuestionnaireResponse) {
        __typename
        ...QuestionnaireResponseFields
      }
    }
  }
  ${QuestionnaireResponseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireResponseByIdsGQL extends Apollo.Query<
  FetchQuestionnaireResponseByIdsQuery,
  FetchQuestionnaireResponseByIdsQueryVariables
> {
  document = FetchQuestionnaireResponseByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireSectionByIdDocument = gql`
  query FetchQuestionnaireSectionById($id: ID!) {
    questionnaireSection: entities {
      byId(id: $id, type: QuestionnaireSection) {
        __typename
        ...QuestionnaireSectionFields
      }
    }
  }
  ${QuestionnaireSectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireSectionByIdGQL extends Apollo.Query<
  FetchQuestionnaireSectionByIdQuery,
  FetchQuestionnaireSectionByIdQueryVariables
> {
  document = FetchQuestionnaireSectionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireSectionByIdsDocument = gql`
  query FetchQuestionnaireSectionByIds($ids: [ID!]!) {
    questionnaireSection: entities {
      byIds(ids: $ids, type: QuestionnaireSection) {
        __typename
        ...QuestionnaireSectionFields
      }
    }
  }
  ${QuestionnaireSectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireSectionByIdsGQL extends Apollo.Query<
  FetchQuestionnaireSectionByIdsQuery,
  FetchQuestionnaireSectionByIdsQueryVariables
> {
  document = FetchQuestionnaireSectionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireSectionQuestionByIdDocument = gql`
  query FetchQuestionnaireSectionQuestionById($id: ID!) {
    questionnaireSectionQuestion: entities {
      byId(id: $id, type: QuestionnaireSectionQuestion) {
        __typename
        ...QuestionnaireSectionQuestionFields
      }
    }
  }
  ${QuestionnaireSectionQuestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireSectionQuestionByIdGQL extends Apollo.Query<
  FetchQuestionnaireSectionQuestionByIdQuery,
  FetchQuestionnaireSectionQuestionByIdQueryVariables
> {
  document = FetchQuestionnaireSectionQuestionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchQuestionnaireSectionQuestionByIdsDocument = gql`
  query FetchQuestionnaireSectionQuestionByIds($ids: [ID!]!) {
    questionnaireSectionQuestion: entities {
      byIds(ids: $ids, type: QuestionnaireSectionQuestion) {
        __typename
        ...QuestionnaireSectionQuestionFields
      }
    }
  }
  ${QuestionnaireSectionQuestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchQuestionnaireSectionQuestionByIdsGQL extends Apollo.Query<
  FetchQuestionnaireSectionQuestionByIdsQuery,
  FetchQuestionnaireSectionQuestionByIdsQueryVariables
> {
  document = FetchQuestionnaireSectionQuestionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchReceivingFacilityRequestByIdDocument = gql`
  query FetchReceivingFacilityRequestById($id: ID!) {
    receivingFacilityRequest: entities {
      byId(id: $id, type: ReceivingFacilityRequest) {
        __typename
        ...ReceivingFacilityRequestFields
      }
    }
  }
  ${ReceivingFacilityRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchReceivingFacilityRequestByIdGQL extends Apollo.Query<
  FetchReceivingFacilityRequestByIdQuery,
  FetchReceivingFacilityRequestByIdQueryVariables
> {
  document = FetchReceivingFacilityRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchReceivingFacilityRequestByIdsDocument = gql`
  query FetchReceivingFacilityRequestByIds($ids: [ID!]!) {
    receivingFacilityRequest: entities {
      byIds(ids: $ids, type: ReceivingFacilityRequest) {
        __typename
        ...ReceivingFacilityRequestFields
      }
    }
  }
  ${ReceivingFacilityRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchReceivingFacilityRequestByIdsGQL extends Apollo.Query<
  FetchReceivingFacilityRequestByIdsQuery,
  FetchReceivingFacilityRequestByIdsQueryVariables
> {
  document = FetchReceivingFacilityRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRendezvousRequestByIdDocument = gql`
  query FetchRendezvousRequestById($id: ID!) {
    rendezvousRequest: entities {
      byId(id: $id, type: RendezvousRequest) {
        __typename
        ...RendezvousRequestFields
      }
    }
  }
  ${RendezvousRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRendezvousRequestByIdGQL extends Apollo.Query<
  FetchRendezvousRequestByIdQuery,
  FetchRendezvousRequestByIdQueryVariables
> {
  document = FetchRendezvousRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRendezvousRequestByIdsDocument = gql`
  query FetchRendezvousRequestByIds($ids: [ID!]!) {
    rendezvousRequest: entities {
      byIds(ids: $ids, type: RendezvousRequest) {
        __typename
        ...RendezvousRequestFields
      }
    }
  }
  ${RendezvousRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRendezvousRequestByIdsGQL extends Apollo.Query<
  FetchRendezvousRequestByIdsQuery,
  FetchRendezvousRequestByIdsQueryVariables
> {
  document = FetchRendezvousRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestByIdDocument = gql`
  query FetchRequestById($id: ID!) {
    request: entities {
      byId(id: $id, type: Request) {
        __typename
        ...RequestFields
      }
    }
  }
  ${RequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestByIdGQL extends Apollo.Query<
  FetchRequestByIdQuery,
  FetchRequestByIdQueryVariables
> {
  document = FetchRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestByIdsDocument = gql`
  query FetchRequestByIds($ids: [ID!]!) {
    request: entities {
      byIds(ids: $ids, type: Request) {
        __typename
        ...RequestFields
      }
    }
  }
  ${RequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestByIdsGQL extends Apollo.Query<
  FetchRequestByIdsQuery,
  FetchRequestByIdsQueryVariables
> {
  document = FetchRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequesterByIdDocument = gql`
  query FetchRequesterById($id: ID!) {
    requester: entities {
      byId(id: $id, type: Requester) {
        __typename
        ...RequesterFields
      }
    }
  }
  ${RequesterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequesterByIdGQL extends Apollo.Query<
  FetchRequesterByIdQuery,
  FetchRequesterByIdQueryVariables
> {
  document = FetchRequesterByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequesterByIdsDocument = gql`
  query FetchRequesterByIds($ids: [ID!]!) {
    requester: entities {
      byIds(ids: $ids, type: Requester) {
        __typename
        ...RequesterFields
      }
    }
  }
  ${RequesterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequesterByIdsGQL extends Apollo.Query<
  FetchRequesterByIdsQuery,
  FetchRequesterByIdsQueryVariables
> {
  document = FetchRequesterByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequesterReferralReasonByIdDocument = gql`
  query FetchRequesterReferralReasonById($id: ID!) {
    requesterReferralReason: entities {
      byId(id: $id, type: RequesterReferralReason) {
        __typename
        ...RequesterReferralReasonFields
      }
    }
  }
  ${RequesterReferralReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequesterReferralReasonByIdGQL extends Apollo.Query<
  FetchRequesterReferralReasonByIdQuery,
  FetchRequesterReferralReasonByIdQueryVariables
> {
  document = FetchRequesterReferralReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequesterReferralReasonByIdsDocument = gql`
  query FetchRequesterReferralReasonByIds($ids: [ID!]!) {
    requesterReferralReason: entities {
      byIds(ids: $ids, type: RequesterReferralReason) {
        __typename
        ...RequesterReferralReasonFields
      }
    }
  }
  ${RequesterReferralReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequesterReferralReasonByIdsGQL extends Apollo.Query<
  FetchRequesterReferralReasonByIdsQuery,
  FetchRequesterReferralReasonByIdsQueryVariables
> {
  document = FetchRequesterReferralReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequesterRoleByIdDocument = gql`
  query FetchRequesterRoleById($id: ID!) {
    requesterRole: entities {
      byId(id: $id, type: RequesterRole) {
        __typename
        ...RequesterRoleFields
      }
    }
  }
  ${RequesterRoleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequesterRoleByIdGQL extends Apollo.Query<
  FetchRequesterRoleByIdQuery,
  FetchRequesterRoleByIdQueryVariables
> {
  document = FetchRequesterRoleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequesterRoleByIdsDocument = gql`
  query FetchRequesterRoleByIds($ids: [ID!]!) {
    requesterRole: entities {
      byIds(ids: $ids, type: RequesterRole) {
        __typename
        ...RequesterRoleFields
      }
    }
  }
  ${RequesterRoleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequesterRoleByIdsGQL extends Apollo.Query<
  FetchRequesterRoleByIdsQuery,
  FetchRequesterRoleByIdsQueryVariables
> {
  document = FetchRequesterRoleByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestLocationByIdDocument = gql`
  query FetchRequestLocationById($id: ID!) {
    requestLocation: entities {
      byId(id: $id, type: RequestLocation) {
        __typename
        ...RequestLocationFields
      }
    }
  }
  ${RequestLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestLocationByIdGQL extends Apollo.Query<
  FetchRequestLocationByIdQuery,
  FetchRequestLocationByIdQueryVariables
> {
  document = FetchRequestLocationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestLocationByIdsDocument = gql`
  query FetchRequestLocationByIds($ids: [ID!]!) {
    requestLocation: entities {
      byIds(ids: $ids, type: RequestLocation) {
        __typename
        ...RequestLocationFields
      }
    }
  }
  ${RequestLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestLocationByIdsGQL extends Apollo.Query<
  FetchRequestLocationByIdsQuery,
  FetchRequestLocationByIdsQueryVariables
> {
  document = FetchRequestLocationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestPatientByIdDocument = gql`
  query FetchRequestPatientById($id: ID!) {
    requestPatient: entities {
      byId(id: $id, type: RequestPatient) {
        __typename
        ...RequestPatientFields
      }
    }
  }
  ${RequestPatientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestPatientByIdGQL extends Apollo.Query<
  FetchRequestPatientByIdQuery,
  FetchRequestPatientByIdQueryVariables
> {
  document = FetchRequestPatientByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRequestPatientByIdsDocument = gql`
  query FetchRequestPatientByIds($ids: [ID!]!) {
    requestPatient: entities {
      byIds(ids: $ids, type: RequestPatient) {
        __typename
        ...RequestPatientFields
      }
    }
  }
  ${RequestPatientFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRequestPatientByIdsGQL extends Apollo.Query<
  FetchRequestPatientByIdsQuery,
  FetchRequestPatientByIdsQueryVariables
> {
  document = FetchRequestPatientByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSystemTimerByIdDocument = gql`
  query FetchSystemTimerById($id: ID!) {
    systemTimer: entities {
      byId(id: $id, type: SystemTimer) {
        __typename
        ...SystemTimerFields
      }
    }
  }
  ${SystemTimerFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSystemTimerByIdGQL extends Apollo.Query<
  FetchSystemTimerByIdQuery,
  FetchSystemTimerByIdQueryVariables
> {
  document = FetchSystemTimerByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSystemTimerByIdsDocument = gql`
  query FetchSystemTimerByIds($ids: [ID!]!) {
    systemTimer: entities {
      byIds(ids: $ids, type: SystemTimer) {
        __typename
        ...SystemTimerFields
      }
    }
  }
  ${SystemTimerFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSystemTimerByIdsGQL extends Apollo.Query<
  FetchSystemTimerByIdsQuery,
  FetchSystemTimerByIdsQueryVariables
> {
  document = FetchSystemTimerByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimelineByIdDocument = gql`
  query FetchTimelineById($id: ID!) {
    timeline: entities {
      byId(id: $id, type: Timeline) {
        __typename
        ...TimelineFields
      }
    }
  }
  ${TimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimelineByIdGQL extends Apollo.Query<
  FetchTimelineByIdQuery,
  FetchTimelineByIdQueryVariables
> {
  document = FetchTimelineByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimelineByIdsDocument = gql`
  query FetchTimelineByIds($ids: [ID!]!) {
    timeline: entities {
      byIds(ids: $ids, type: Timeline) {
        __typename
        ...TimelineFields
      }
    }
  }
  ${TimelineFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimelineByIdsGQL extends Apollo.Query<
  FetchTimelineByIdsQuery,
  FetchTimelineByIdsQueryVariables
> {
  document = FetchTimelineByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimelineItemByIdDocument = gql`
  query FetchTimelineItemById($id: ID!) {
    timelineItem: entities {
      byId(id: $id, type: TimelineItem) {
        __typename
        ...TimelineItemFields
      }
    }
  }
  ${TimelineItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimelineItemByIdGQL extends Apollo.Query<
  FetchTimelineItemByIdQuery,
  FetchTimelineItemByIdQueryVariables
> {
  document = FetchTimelineItemByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimelineItemByIdsDocument = gql`
  query FetchTimelineItemByIds($ids: [ID!]!) {
    timelineItem: entities {
      byIds(ids: $ids, type: TimelineItem) {
        __typename
        ...TimelineItemFields
      }
    }
  }
  ${TimelineItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimelineItemByIdsGQL extends Apollo.Query<
  FetchTimelineItemByIdsQuery,
  FetchTimelineItemByIdsQueryVariables
> {
  document = FetchTimelineItemByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimestampByIdDocument = gql`
  query FetchTimestampById($id: ID!) {
    timestamp: entities {
      byId(id: $id, type: Timestamp) {
        __typename
        ...TimestampFields
      }
    }
  }
  ${TimestampFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimestampByIdGQL extends Apollo.Query<
  FetchTimestampByIdQuery,
  FetchTimestampByIdQueryVariables
> {
  document = FetchTimestampByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimestampByIdsDocument = gql`
  query FetchTimestampByIds($ids: [ID!]!) {
    timestamp: entities {
      byIds(ids: $ids, type: Timestamp) {
        __typename
        ...TimestampFields
      }
    }
  }
  ${TimestampFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimestampByIdsGQL extends Apollo.Query<
  FetchTimestampByIdsQuery,
  FetchTimestampByIdsQueryVariables
> {
  document = FetchTimestampByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimestampTypeByIdDocument = gql`
  query FetchTimestampTypeById($id: ID!) {
    timestampType: entities {
      byId(id: $id, type: TimestampType) {
        __typename
        ...TimestampTypeFields
      }
    }
  }
  ${TimestampTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimestampTypeByIdGQL extends Apollo.Query<
  FetchTimestampTypeByIdQuery,
  FetchTimestampTypeByIdQueryVariables
> {
  document = FetchTimestampTypeByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimestampTypeByIdsDocument = gql`
  query FetchTimestampTypeByIds($ids: [ID!]!) {
    timestampType: entities {
      byIds(ids: $ids, type: TimestampType) {
        __typename
        ...TimestampTypeFields
      }
    }
  }
  ${TimestampTypeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimestampTypeByIdsGQL extends Apollo.Query<
  FetchTimestampTypeByIdsQuery,
  FetchTimestampTypeByIdsQueryVariables
> {
  document = FetchTimestampTypeByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrackedMessageByIdDocument = gql`
  query FetchTrackedMessageById($id: ID!) {
    trackedMessage: entities {
      byId(id: $id, type: TrackedMessage) {
        __typename
        ...TrackedMessageFields
      }
    }
  }
  ${TrackedMessageFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrackedMessageByIdGQL extends Apollo.Query<
  FetchTrackedMessageByIdQuery,
  FetchTrackedMessageByIdQueryVariables
> {
  document = FetchTrackedMessageByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrackedMessageByIdsDocument = gql`
  query FetchTrackedMessageByIds($ids: [ID!]!) {
    trackedMessage: entities {
      byIds(ids: $ids, type: TrackedMessage) {
        __typename
        ...TrackedMessageFields
      }
    }
  }
  ${TrackedMessageFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrackedMessageByIdsGQL extends Apollo.Query<
  FetchTrackedMessageByIdsQuery,
  FetchTrackedMessageByIdsQueryVariables
> {
  document = FetchTrackedMessageByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransferReasonByIdDocument = gql`
  query FetchTransferReasonById($id: ID!) {
    transferReason: entities {
      byId(id: $id, type: TransferReason) {
        __typename
        ...TransferReasonFields
      }
    }
  }
  ${TransferReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransferReasonByIdGQL extends Apollo.Query<
  FetchTransferReasonByIdQuery,
  FetchTransferReasonByIdQueryVariables
> {
  document = FetchTransferReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransferReasonByIdsDocument = gql`
  query FetchTransferReasonByIds($ids: [ID!]!) {
    transferReason: entities {
      byIds(ids: $ids, type: TransferReason) {
        __typename
        ...TransferReasonFields
      }
    }
  }
  ${TransferReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransferReasonByIdsGQL extends Apollo.Query<
  FetchTransferReasonByIdsQuery,
  FetchTransferReasonByIdsQueryVariables
> {
  document = FetchTransferReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportOfferByIdDocument = gql`
  query FetchTransportOfferById($id: ID!) {
    transportOffer: entities {
      byId(id: $id, type: TransportOffer) {
        __typename
        ...TransportOfferFields
      }
    }
  }
  ${TransportOfferFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportOfferByIdGQL extends Apollo.Query<
  FetchTransportOfferByIdQuery,
  FetchTransportOfferByIdQueryVariables
> {
  document = FetchTransportOfferByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportOfferByIdsDocument = gql`
  query FetchTransportOfferByIds($ids: [ID!]!) {
    transportOffer: entities {
      byIds(ids: $ids, type: TransportOffer) {
        __typename
        ...TransportOfferFields
      }
    }
  }
  ${TransportOfferFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportOfferByIdsGQL extends Apollo.Query<
  FetchTransportOfferByIdsQuery,
  FetchTransportOfferByIdsQueryVariables
> {
  document = FetchTransportOfferByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportOfferOptionByIdDocument = gql`
  query FetchTransportOfferOptionById($id: ID!) {
    transportOfferOption: entities {
      byId(id: $id, type: TransportOfferOption) {
        __typename
        ...TransportOfferOptionFields
      }
    }
  }
  ${TransportOfferOptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportOfferOptionByIdGQL extends Apollo.Query<
  FetchTransportOfferOptionByIdQuery,
  FetchTransportOfferOptionByIdQueryVariables
> {
  document = FetchTransportOfferOptionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportOfferOptionByIdsDocument = gql`
  query FetchTransportOfferOptionByIds($ids: [ID!]!) {
    transportOfferOption: entities {
      byIds(ids: $ids, type: TransportOfferOption) {
        __typename
        ...TransportOfferOptionFields
      }
    }
  }
  ${TransportOfferOptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportOfferOptionByIdsGQL extends Apollo.Query<
  FetchTransportOfferOptionByIdsQuery,
  FetchTransportOfferOptionByIdsQueryVariables
> {
  document = FetchTransportOfferOptionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportReasonByIdDocument = gql`
  query FetchTransportReasonById($id: ID!) {
    transportReason: entities {
      byId(id: $id, type: TransportReason) {
        __typename
        ...TransportReasonFields
      }
    }
  }
  ${TransportReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportReasonByIdGQL extends Apollo.Query<
  FetchTransportReasonByIdQuery,
  FetchTransportReasonByIdQueryVariables
> {
  document = FetchTransportReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransportReasonByIdsDocument = gql`
  query FetchTransportReasonByIds($ids: [ID!]!) {
    transportReason: entities {
      byIds(ids: $ids, type: TransportReason) {
        __typename
        ...TransportReasonFields
      }
    }
  }
  ${TransportReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransportReasonByIdsGQL extends Apollo.Query<
  FetchTransportReasonByIdsQuery,
  FetchTransportReasonByIdsQueryVariables
> {
  document = FetchTransportReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTripByIdDocument = gql`
  query FetchTripById($id: ID!) {
    trip: entities {
      byId(id: $id, type: Trip) {
        __typename
        ...TripFields
      }
    }
  }
  ${TripFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTripByIdGQL extends Apollo.Query<
  FetchTripByIdQuery,
  FetchTripByIdQueryVariables
> {
  document = FetchTripByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTripByIdsDocument = gql`
  query FetchTripByIds($ids: [ID!]!) {
    trip: entities {
      byIds(ids: $ids, type: Trip) {
        __typename
        ...TripFields
      }
    }
  }
  ${TripFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTripByIdsGQL extends Apollo.Query<
  FetchTripByIdsQuery,
  FetchTripByIdsQueryVariables
> {
  document = FetchTripByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTripLegByIdDocument = gql`
  query FetchTripLegById($id: ID!) {
    tripLeg: entities {
      byId(id: $id, type: TripLeg) {
        __typename
        ...TripLegFields
      }
    }
  }
  ${TripLegFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTripLegByIdGQL extends Apollo.Query<
  FetchTripLegByIdQuery,
  FetchTripLegByIdQueryVariables
> {
  document = FetchTripLegByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTripLegByIdsDocument = gql`
  query FetchTripLegByIds($ids: [ID!]!) {
    tripLeg: entities {
      byIds(ids: $ids, type: TripLeg) {
        __typename
        ...TripLegFields
      }
    }
  }
  ${TripLegFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTripLegByIdsGQL extends Apollo.Query<
  FetchTripLegByIdsQuery,
  FetchTripLegByIdsQueryVariables
> {
  document = FetchTripLegByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTripPassengerByIdDocument = gql`
  query FetchTripPassengerById($id: ID!) {
    tripPassenger: entities {
      byId(id: $id, type: TripPassenger) {
        __typename
        ...TripPassengerFields
      }
    }
  }
  ${TripPassengerFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTripPassengerByIdGQL extends Apollo.Query<
  FetchTripPassengerByIdQuery,
  FetchTripPassengerByIdQueryVariables
> {
  document = FetchTripPassengerByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTripPassengerByIdsDocument = gql`
  query FetchTripPassengerByIds($ids: [ID!]!) {
    tripPassenger: entities {
      byIds(ids: $ids, type: TripPassenger) {
        __typename
        ...TripPassengerFields
      }
    }
  }
  ${TripPassengerFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTripPassengerByIdsGQL extends Apollo.Query<
  FetchTripPassengerByIdsQuery,
  FetchTripPassengerByIdsQueryVariables
> {
  document = FetchTripPassengerByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitActivationRuleByIdDocument = gql`
  query FetchUnitActivationRuleById($id: ID!) {
    unitActivationRule: entities {
      byId(id: $id, type: UnitActivationRule) {
        __typename
        ...UnitActivationRuleFields
      }
    }
  }
  ${UnitActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitActivationRuleByIdGQL extends Apollo.Query<
  FetchUnitActivationRuleByIdQuery,
  FetchUnitActivationRuleByIdQueryVariables
> {
  document = FetchUnitActivationRuleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitActivationRuleByIdsDocument = gql`
  query FetchUnitActivationRuleByIds($ids: [ID!]!) {
    unitActivationRule: entities {
      byIds(ids: $ids, type: UnitActivationRule) {
        __typename
        ...UnitActivationRuleFields
      }
    }
  }
  ${UnitActivationRuleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitActivationRuleByIdsGQL extends Apollo.Query<
  FetchUnitActivationRuleByIdsQuery,
  FetchUnitActivationRuleByIdsQueryVariables
> {
  document = FetchUnitActivationRuleByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitEMSystemMappingByIdDocument = gql`
  query FetchUnitEMSystemMappingById($id: ID!) {
    unitEMSystemMapping: entities {
      byId(id: $id, type: UnitEMSystemMapping) {
        __typename
        ...UnitEMSystemMappingFields
      }
    }
  }
  ${UnitEMSystemMappingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitEMSystemMappingByIdGQL extends Apollo.Query<
  FetchUnitEMSystemMappingByIdQuery,
  FetchUnitEMSystemMappingByIdQueryVariables
> {
  document = FetchUnitEMSystemMappingByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitEMSystemMappingByIdsDocument = gql`
  query FetchUnitEMSystemMappingByIds($ids: [ID!]!) {
    unitEMSystemMapping: entities {
      byIds(ids: $ids, type: UnitEMSystemMapping) {
        __typename
        ...UnitEMSystemMappingFields
      }
    }
  }
  ${UnitEMSystemMappingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitEMSystemMappingByIdsGQL extends Apollo.Query<
  FetchUnitEMSystemMappingByIdsQuery,
  FetchUnitEMSystemMappingByIdsQueryVariables
> {
  document = FetchUnitEMSystemMappingByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitByIdDocument = gql`
  query FetchUnitById($id: ID!) {
    unit: entities {
      byId(id: $id, type: Unit) {
        __typename
        ...UnitFields
      }
    }
  }
  ${UnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitByIdGQL extends Apollo.Query<
  FetchUnitByIdQuery,
  FetchUnitByIdQueryVariables
> {
  document = FetchUnitByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitByIdsDocument = gql`
  query FetchUnitByIds($ids: [ID!]!) {
    unit: entities {
      byIds(ids: $ids, type: Unit) {
        __typename
        ...UnitFields
      }
    }
  }
  ${UnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitByIdsGQL extends Apollo.Query<
  FetchUnitByIdsQuery,
  FetchUnitByIdsQueryVariables
> {
  document = FetchUnitByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitNoteByIdDocument = gql`
  query FetchUnitNoteById($id: ID!) {
    unitNote: entities {
      byId(id: $id, type: UnitNote) {
        __typename
        ...UnitNoteFields
      }
    }
  }
  ${UnitNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitNoteByIdGQL extends Apollo.Query<
  FetchUnitNoteByIdQuery,
  FetchUnitNoteByIdQueryVariables
> {
  document = FetchUnitNoteByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitNoteByIdsDocument = gql`
  query FetchUnitNoteByIds($ids: [ID!]!) {
    unitNote: entities {
      byIds(ids: $ids, type: UnitNote) {
        __typename
        ...UnitNoteFields
      }
    }
  }
  ${UnitNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitNoteByIdsGQL extends Apollo.Query<
  FetchUnitNoteByIdsQuery,
  FetchUnitNoteByIdsQueryVariables
> {
  document = FetchUnitNoteByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitPositionByIdDocument = gql`
  query FetchUnitPositionById($id: ID!) {
    unitPosition: entities {
      byId(id: $id, type: UnitPosition) {
        __typename
        ...UnitPositionFields
      }
    }
  }
  ${UnitPositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitPositionByIdGQL extends Apollo.Query<
  FetchUnitPositionByIdQuery,
  FetchUnitPositionByIdQueryVariables
> {
  document = FetchUnitPositionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitPositionByIdsDocument = gql`
  query FetchUnitPositionByIds($ids: [ID!]!) {
    unitPosition: entities {
      byIds(ids: $ids, type: UnitPosition) {
        __typename
        ...UnitPositionFields
      }
    }
  }
  ${UnitPositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitPositionByIdsGQL extends Apollo.Query<
  FetchUnitPositionByIdsQuery,
  FetchUnitPositionByIdsQueryVariables
> {
  document = FetchUnitPositionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitShiftByIdDocument = gql`
  query FetchUnitShiftById($id: ID!) {
    unitShift: entities {
      byId(id: $id, type: UnitShift) {
        __typename
        ...UnitShiftFields
      }
    }
  }
  ${UnitShiftFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitShiftByIdGQL extends Apollo.Query<
  FetchUnitShiftByIdQuery,
  FetchUnitShiftByIdQueryVariables
> {
  document = FetchUnitShiftByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitShiftByIdsDocument = gql`
  query FetchUnitShiftByIds($ids: [ID!]!) {
    unitShift: entities {
      byIds(ids: $ids, type: UnitShift) {
        __typename
        ...UnitShiftFields
      }
    }
  }
  ${UnitShiftFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitShiftByIdsGQL extends Apollo.Query<
  FetchUnitShiftByIdsQuery,
  FetchUnitShiftByIdsQueryVariables
> {
  document = FetchUnitShiftByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitStatusHistoryEntryByIdDocument = gql`
  query FetchUnitStatusHistoryEntryById($id: ID!) {
    unitStatusHistoryEntry: entities {
      byId(id: $id, type: UnitStatusHistoryEntry) {
        __typename
        ...UnitStatusHistoryEntryFields
      }
    }
  }
  ${UnitStatusHistoryEntryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitStatusHistoryEntryByIdGQL extends Apollo.Query<
  FetchUnitStatusHistoryEntryByIdQuery,
  FetchUnitStatusHistoryEntryByIdQueryVariables
> {
  document = FetchUnitStatusHistoryEntryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitStatusHistoryEntryByIdsDocument = gql`
  query FetchUnitStatusHistoryEntryByIds($ids: [ID!]!) {
    unitStatusHistoryEntry: entities {
      byIds(ids: $ids, type: UnitStatusHistoryEntry) {
        __typename
        ...UnitStatusHistoryEntryFields
      }
    }
  }
  ${UnitStatusHistoryEntryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitStatusHistoryEntryByIdsGQL extends Apollo.Query<
  FetchUnitStatusHistoryEntryByIdsQuery,
  FetchUnitStatusHistoryEntryByIdsQueryVariables
> {
  document = FetchUnitStatusHistoryEntryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitSummaryByIdDocument = gql`
  query FetchUnitSummaryById($id: ID!) {
    unitSummary: entities {
      byId(id: $id, type: UnitSummary) {
        __typename
        ...UnitSummaryFields
      }
    }
  }
  ${UnitSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitSummaryByIdGQL extends Apollo.Query<
  FetchUnitSummaryByIdQuery,
  FetchUnitSummaryByIdQueryVariables
> {
  document = FetchUnitSummaryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUnitSummaryByIdsDocument = gql`
  query FetchUnitSummaryByIds($ids: [ID!]!) {
    unitSummary: entities {
      byIds(ids: $ids, type: UnitSummary) {
        __typename
        ...UnitSummaryFields
      }
    }
  }
  ${UnitSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchUnitSummaryByIdsGQL extends Apollo.Query<
  FetchUnitSummaryByIdsQuery,
  FetchUnitSummaryByIdsQueryVariables
> {
  document = FetchUnitSummaryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleDispositionByIdDocument = gql`
  query FetchVehicleDispositionById($id: ID!) {
    vehicleDisposition: entities {
      byId(id: $id, type: VehicleDisposition) {
        __typename
        ...VehicleDispositionFields
      }
    }
  }
  ${VehicleDispositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleDispositionByIdGQL extends Apollo.Query<
  FetchVehicleDispositionByIdQuery,
  FetchVehicleDispositionByIdQueryVariables
> {
  document = FetchVehicleDispositionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleDispositionByIdsDocument = gql`
  query FetchVehicleDispositionByIds($ids: [ID!]!) {
    vehicleDisposition: entities {
      byIds(ids: $ids, type: VehicleDisposition) {
        __typename
        ...VehicleDispositionFields
      }
    }
  }
  ${VehicleDispositionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleDispositionByIdsGQL extends Apollo.Query<
  FetchVehicleDispositionByIdsQuery,
  FetchVehicleDispositionByIdsQueryVariables
> {
  document = FetchVehicleDispositionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleNotificationGroupByIdDocument = gql`
  query FetchVehicleNotificationGroupById($id: ID!) {
    vehicleNotificationGroup: entities {
      byId(id: $id, type: VehicleNotificationGroup) {
        __typename
        ...VehicleNotificationGroupFields
      }
    }
  }
  ${VehicleNotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleNotificationGroupByIdGQL extends Apollo.Query<
  FetchVehicleNotificationGroupByIdQuery,
  FetchVehicleNotificationGroupByIdQueryVariables
> {
  document = FetchVehicleNotificationGroupByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleNotificationGroupByIdsDocument = gql`
  query FetchVehicleNotificationGroupByIds($ids: [ID!]!) {
    vehicleNotificationGroup: entities {
      byIds(ids: $ids, type: VehicleNotificationGroup) {
        __typename
        ...VehicleNotificationGroupFields
      }
    }
  }
  ${VehicleNotificationGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleNotificationGroupByIdsGQL extends Apollo.Query<
  FetchVehicleNotificationGroupByIdsQuery,
  FetchVehicleNotificationGroupByIdsQueryVariables
> {
  document = FetchVehicleNotificationGroupByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehiclePositionSummaryByIdDocument = gql`
  query FetchVehiclePositionSummaryById($id: ID!) {
    vehiclePositionSummary: entities {
      byId(id: $id, type: VehiclePositionSummary) {
        __typename
        ...VehiclePositionSummaryFields
      }
    }
  }
  ${VehiclePositionSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehiclePositionSummaryByIdGQL extends Apollo.Query<
  FetchVehiclePositionSummaryByIdQuery,
  FetchVehiclePositionSummaryByIdQueryVariables
> {
  document = FetchVehiclePositionSummaryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehiclePositionSummaryByIdsDocument = gql`
  query FetchVehiclePositionSummaryByIds($ids: [ID!]!) {
    vehiclePositionSummary: entities {
      byIds(ids: $ids, type: VehiclePositionSummary) {
        __typename
        ...VehiclePositionSummaryFields
      }
    }
  }
  ${VehiclePositionSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehiclePositionSummaryByIdsGQL extends Apollo.Query<
  FetchVehiclePositionSummaryByIdsQuery,
  FetchVehiclePositionSummaryByIdsQueryVariables
> {
  document = FetchVehiclePositionSummaryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleSummaryByIdDocument = gql`
  query FetchVehicleSummaryById($id: ID!) {
    vehicleSummary: entities {
      byId(id: $id, type: VehicleSummary) {
        __typename
        ...VehicleSummaryFields
      }
    }
  }
  ${VehicleSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleSummaryByIdGQL extends Apollo.Query<
  FetchVehicleSummaryByIdQuery,
  FetchVehicleSummaryByIdQueryVariables
> {
  document = FetchVehicleSummaryByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleSummaryByIdsDocument = gql`
  query FetchVehicleSummaryByIds($ids: [ID!]!) {
    vehicleSummary: entities {
      byIds(ids: $ids, type: VehicleSummary) {
        __typename
        ...VehicleSummaryFields
      }
    }
  }
  ${VehicleSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleSummaryByIdsGQL extends Apollo.Query<
  FetchVehicleSummaryByIdsQuery,
  FetchVehicleSummaryByIdsQueryVariables
> {
  document = FetchVehicleSummaryByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchWaypointByIdDocument = gql`
  query FetchWaypointById($id: ID!) {
    waypoint: entities {
      byId(id: $id, type: Waypoint) {
        __typename
        ...WaypointFields
      }
    }
  }
  ${WaypointFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchWaypointByIdGQL extends Apollo.Query<
  FetchWaypointByIdQuery,
  FetchWaypointByIdQueryVariables
> {
  document = FetchWaypointByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchWaypointByIdsDocument = gql`
  query FetchWaypointByIds($ids: [ID!]!) {
    waypoint: entities {
      byIds(ids: $ids, type: Waypoint) {
        __typename
        ...WaypointFields
      }
    }
  }
  ${WaypointFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchWaypointByIdsGQL extends Apollo.Query<
  FetchWaypointByIdsQuery,
  FetchWaypointByIdsQueryVariables
> {
  document = FetchWaypointByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchWebOrderLogByIdDocument = gql`
  query FetchWebOrderLogById($id: ID!) {
    webOrderLog: entities {
      byId(id: $id, type: WebOrderLog) {
        __typename
        ...WebOrderLogFields
      }
    }
  }
  ${WebOrderLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchWebOrderLogByIdGQL extends Apollo.Query<
  FetchWebOrderLogByIdQuery,
  FetchWebOrderLogByIdQueryVariables
> {
  document = FetchWebOrderLogByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchWebOrderLogByIdsDocument = gql`
  query FetchWebOrderLogByIds($ids: [ID!]!) {
    webOrderLog: entities {
      byIds(ids: $ids, type: WebOrderLog) {
        __typename
        ...WebOrderLogFields
      }
    }
  }
  ${WebOrderLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchWebOrderLogByIdsGQL extends Apollo.Query<
  FetchWebOrderLogByIdsQuery,
  FetchWebOrderLogByIdsQueryVariables
> {
  document = FetchWebOrderLogByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAccessibleItemByIdDocument = gql`
  query FetchAccessibleItemById($id: ID!) {
    accessibleItem: entities {
      byId(id: $id, type: AccessibleItem) {
        __typename
        ...AccessibleItemFields
      }
    }
  }
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAccessibleItemByIdGQL extends Apollo.Query<
  FetchAccessibleItemByIdQuery,
  FetchAccessibleItemByIdQueryVariables
> {
  document = FetchAccessibleItemByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAccessibleItemByIdsDocument = gql`
  query FetchAccessibleItemByIds($ids: [ID!]!) {
    accessibleItem: entities {
      byIds(ids: $ids, type: AccessibleItem) {
        __typename
        ...AccessibleItemFields
      }
    }
  }
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAccessibleItemByIdsGQL extends Apollo.Query<
  FetchAccessibleItemByIdsQuery,
  FetchAccessibleItemByIdsQueryVariables
> {
  document = FetchAccessibleItemByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAgencyByIdDocument = gql`
  query FetchAgencyById($id: ID!) {
    agency: entities {
      byId(id: $id, type: Agency) {
        __typename
        ...AgencyFields
      }
    }
  }
  ${AgencyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAgencyByIdGQL extends Apollo.Query<
  FetchAgencyByIdQuery,
  FetchAgencyByIdQueryVariables
> {
  document = FetchAgencyByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAgencyByIdsDocument = gql`
  query FetchAgencyByIds($ids: [ID!]!) {
    agency: entities {
      byIds(ids: $ids, type: Agency) {
        __typename
        ...AgencyFields
      }
    }
  }
  ${AgencyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAgencyByIdsGQL extends Apollo.Query<
  FetchAgencyByIdsQuery,
  FetchAgencyByIdsQueryVariables
> {
  document = FetchAgencyByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAgencyLocationByIdDocument = gql`
  query FetchAgencyLocationById($id: ID!) {
    agencyLocation: entities {
      byId(id: $id, type: AgencyLocation) {
        __typename
        ...AgencyLocationFields
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAgencyLocationByIdGQL extends Apollo.Query<
  FetchAgencyLocationByIdQuery,
  FetchAgencyLocationByIdQueryVariables
> {
  document = FetchAgencyLocationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAgencyLocationByIdsDocument = gql`
  query FetchAgencyLocationByIds($ids: [ID!]!) {
    agencyLocation: entities {
      byIds(ids: $ids, type: AgencyLocation) {
        __typename
        ...AgencyLocationFields
      }
    }
  }
  ${AgencyLocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAgencyLocationByIdsGQL extends Apollo.Query<
  FetchAgencyLocationByIdsQuery,
  FetchAgencyLocationByIdsQueryVariables
> {
  document = FetchAgencyLocationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAirportByIdDocument = gql`
  query FetchAirportById($id: ID!) {
    airport: entities {
      byId(id: $id, type: Airport) {
        __typename
        ...AirportFields
      }
    }
  }
  ${AirportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAirportByIdGQL extends Apollo.Query<
  FetchAirportByIdQuery,
  FetchAirportByIdQueryVariables
> {
  document = FetchAirportByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAirportByIdsDocument = gql`
  query FetchAirportByIds($ids: [ID!]!) {
    airport: entities {
      byIds(ids: $ids, type: Airport) {
        __typename
        ...AirportFields
      }
    }
  }
  ${AirportFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAirportByIdsGQL extends Apollo.Query<
  FetchAirportByIdsQuery,
  FetchAirportByIdsQueryVariables
> {
  document = FetchAirportByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchArchiveLogByIdDocument = gql`
  query FetchArchiveLogById($id: ID!) {
    archiveLog: entities {
      byId(id: $id, type: ArchiveLog) {
        __typename
        ...ArchiveLogFields
      }
    }
  }
  ${ArchiveLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchArchiveLogByIdGQL extends Apollo.Query<
  FetchArchiveLogByIdQuery,
  FetchArchiveLogByIdQueryVariables
> {
  document = FetchArchiveLogByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchArchiveLogByIdsDocument = gql`
  query FetchArchiveLogByIds($ids: [ID!]!) {
    archiveLog: entities {
      byIds(ids: $ids, type: ArchiveLog) {
        __typename
        ...ArchiveLogFields
      }
    }
  }
  ${ArchiveLogFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchArchiveLogByIdsGQL extends Apollo.Query<
  FetchArchiveLogByIdsQuery,
  FetchArchiveLogByIdsQueryVariables
> {
  document = FetchArchiveLogByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAttachmentByIdDocument = gql`
  query FetchAttachmentById($id: ID!) {
    attachment: entities {
      byId(id: $id, type: Attachment) {
        __typename
        ...AttachmentFields
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAttachmentByIdGQL extends Apollo.Query<
  FetchAttachmentByIdQuery,
  FetchAttachmentByIdQueryVariables
> {
  document = FetchAttachmentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchAttachmentByIdsDocument = gql`
  query FetchAttachmentByIds($ids: [ID!]!) {
    attachment: entities {
      byIds(ids: $ids, type: Attachment) {
        __typename
        ...AttachmentFields
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchAttachmentByIdsGQL extends Apollo.Query<
  FetchAttachmentByIdsQuery,
  FetchAttachmentByIdsQueryVariables
> {
  document = FetchAttachmentByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseControlZoneByIdDocument = gql`
  query FetchBaseControlZoneById($id: ID!) {
    baseControlZone: entities {
      byId(id: $id, type: BaseControlZone) {
        __typename
        ...BaseControlZoneFields
      }
    }
  }
  ${BaseControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseControlZoneByIdGQL extends Apollo.Query<
  FetchBaseControlZoneByIdQuery,
  FetchBaseControlZoneByIdQueryVariables
> {
  document = FetchBaseControlZoneByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseControlZoneByIdsDocument = gql`
  query FetchBaseControlZoneByIds($ids: [ID!]!) {
    baseControlZone: entities {
      byIds(ids: $ids, type: BaseControlZone) {
        __typename
        ...BaseControlZoneFields
      }
    }
  }
  ${BaseControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseControlZoneByIdsGQL extends Apollo.Query<
  FetchBaseControlZoneByIdsQuery,
  FetchBaseControlZoneByIdsQueryVariables
> {
  document = FetchBaseControlZoneByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseByIdDocument = gql`
  query FetchBaseById($id: ID!) {
    base: entities {
      byId(id: $id, type: Base) {
        __typename
        ...BaseFields
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseByIdGQL extends Apollo.Query<
  FetchBaseByIdQuery,
  FetchBaseByIdQueryVariables
> {
  document = FetchBaseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseByIdsDocument = gql`
  query FetchBaseByIds($ids: [ID!]!) {
    base: entities {
      byIds(ids: $ids, type: Base) {
        __typename
        ...BaseFields
      }
    }
  }
  ${BaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseByIdsGQL extends Apollo.Query<
  FetchBaseByIdsQuery,
  FetchBaseByIdsQueryVariables
> {
  document = FetchBaseByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseMedicalControlContactByIdDocument = gql`
  query FetchBaseMedicalControlContactById($id: ID!) {
    baseMedicalControlContact: entities {
      byId(id: $id, type: BaseMedicalControlContact) {
        __typename
        ...BaseMedicalControlContactFields
      }
    }
  }
  ${BaseMedicalControlContactFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseMedicalControlContactByIdGQL extends Apollo.Query<
  FetchBaseMedicalControlContactByIdQuery,
  FetchBaseMedicalControlContactByIdQueryVariables
> {
  document = FetchBaseMedicalControlContactByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseMedicalControlContactByIdsDocument = gql`
  query FetchBaseMedicalControlContactByIds($ids: [ID!]!) {
    baseMedicalControlContact: entities {
      byIds(ids: $ids, type: BaseMedicalControlContact) {
        __typename
        ...BaseMedicalControlContactFields
      }
    }
  }
  ${BaseMedicalControlContactFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseMedicalControlContactByIdsGQL extends Apollo.Query<
  FetchBaseMedicalControlContactByIdsQuery,
  FetchBaseMedicalControlContactByIdsQueryVariables
> {
  document = FetchBaseMedicalControlContactByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseMedicalControlContactStateByIdDocument = gql`
  query FetchBaseMedicalControlContactStateById($id: ID!) {
    baseMedicalControlContactState: entities {
      byId(id: $id, type: BaseMedicalControlContactState) {
        __typename
        ...BaseMedicalControlContactStateFields
      }
    }
  }
  ${BaseMedicalControlContactStateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseMedicalControlContactStateByIdGQL extends Apollo.Query<
  FetchBaseMedicalControlContactStateByIdQuery,
  FetchBaseMedicalControlContactStateByIdQueryVariables
> {
  document = FetchBaseMedicalControlContactStateByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchBaseMedicalControlContactStateByIdsDocument = gql`
  query FetchBaseMedicalControlContactStateByIds($ids: [ID!]!) {
    baseMedicalControlContactState: entities {
      byIds(ids: $ids, type: BaseMedicalControlContactState) {
        __typename
        ...BaseMedicalControlContactStateFields
      }
    }
  }
  ${BaseMedicalControlContactStateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchBaseMedicalControlContactStateByIdsGQL extends Apollo.Query<
  FetchBaseMedicalControlContactStateByIdsQuery,
  FetchBaseMedicalControlContactStateByIdsQueryVariables
> {
  document = FetchBaseMedicalControlContactStateByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCapabilityByIdDocument = gql`
  query FetchCapabilityById($id: ID!) {
    capability: entities {
      byId(id: $id, type: Capability) {
        __typename
        ...CapabilityFields
      }
    }
  }
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCapabilityByIdGQL extends Apollo.Query<
  FetchCapabilityByIdQuery,
  FetchCapabilityByIdQueryVariables
> {
  document = FetchCapabilityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCapabilityByIdsDocument = gql`
  query FetchCapabilityByIds($ids: [ID!]!) {
    capability: entities {
      byIds(ids: $ids, type: Capability) {
        __typename
        ...CapabilityFields
      }
    }
  }
  ${CapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCapabilityByIdsGQL extends Apollo.Query<
  FetchCapabilityByIdsQuery,
  FetchCapabilityByIdsQueryVariables
> {
  document = FetchCapabilityByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCommunicationCenterByIdDocument = gql`
  query FetchCommunicationCenterById($id: ID!) {
    communicationCenter: entities {
      byId(id: $id, type: CommunicationCenter) {
        __typename
        ...CommunicationCenterFields
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCommunicationCenterByIdGQL extends Apollo.Query<
  FetchCommunicationCenterByIdQuery,
  FetchCommunicationCenterByIdQueryVariables
> {
  document = FetchCommunicationCenterByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCommunicationCenterByIdsDocument = gql`
  query FetchCommunicationCenterByIds($ids: [ID!]!) {
    communicationCenter: entities {
      byIds(ids: $ids, type: CommunicationCenter) {
        __typename
        ...CommunicationCenterFields
      }
    }
  }
  ${CommunicationCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCommunicationCenterByIdsGQL extends Apollo.Query<
  FetchCommunicationCenterByIdsQuery,
  FetchCommunicationCenterByIdsQueryVariables
> {
  document = FetchCommunicationCenterByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCommunicationCenterTransportOfferOptionByIdDocument = gql`
  query FetchCommunicationCenterTransportOfferOptionById($id: ID!) {
    communicationCenterTransportOfferOption: entities {
      byId(id: $id, type: CommunicationCenterTransportOfferOption) {
        __typename
        ...CommunicationCenterTransportOfferOptionFields
      }
    }
  }
  ${CommunicationCenterTransportOfferOptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCommunicationCenterTransportOfferOptionByIdGQL extends Apollo.Query<
  FetchCommunicationCenterTransportOfferOptionByIdQuery,
  FetchCommunicationCenterTransportOfferOptionByIdQueryVariables
> {
  document = FetchCommunicationCenterTransportOfferOptionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCommunicationCenterTransportOfferOptionByIdsDocument = gql`
  query FetchCommunicationCenterTransportOfferOptionByIds($ids: [ID!]!) {
    communicationCenterTransportOfferOption: entities {
      byIds(ids: $ids, type: CommunicationCenterTransportOfferOption) {
        __typename
        ...CommunicationCenterTransportOfferOptionFields
      }
    }
  }
  ${CommunicationCenterTransportOfferOptionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCommunicationCenterTransportOfferOptionByIdsGQL extends Apollo.Query<
  FetchCommunicationCenterTransportOfferOptionByIdsQuery,
  FetchCommunicationCenterTransportOfferOptionByIdsQueryVariables
> {
  document = FetchCommunicationCenterTransportOfferOptionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCompanyByIdDocument = gql`
  query FetchCompanyById($id: ID!) {
    company: entities {
      byId(id: $id, type: Company) {
        __typename
        ...CompanyFields
      }
    }
  }
  ${CompanyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCompanyByIdGQL extends Apollo.Query<
  FetchCompanyByIdQuery,
  FetchCompanyByIdQueryVariables
> {
  document = FetchCompanyByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCompanyByIdsDocument = gql`
  query FetchCompanyByIds($ids: [ID!]!) {
    company: entities {
      byIds(ids: $ids, type: Company) {
        __typename
        ...CompanyFields
      }
    }
  }
  ${CompanyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCompanyByIdsGQL extends Apollo.Query<
  FetchCompanyByIdsQuery,
  FetchCompanyByIdsQueryVariables
> {
  document = FetchCompanyByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCompleteFlightInstanceByIdDocument = gql`
  query FetchCompleteFlightInstanceById($id: ID!) {
    completeFlightInstance: entities {
      byId(id: $id, type: CompleteFlightInstance) {
        __typename
        ...CompleteFlightInstanceFields
      }
    }
  }
  ${CompleteFlightInstanceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCompleteFlightInstanceByIdGQL extends Apollo.Query<
  FetchCompleteFlightInstanceByIdQuery,
  FetchCompleteFlightInstanceByIdQueryVariables
> {
  document = FetchCompleteFlightInstanceByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCompleteFlightInstanceByIdsDocument = gql`
  query FetchCompleteFlightInstanceByIds($ids: [ID!]!) {
    completeFlightInstance: entities {
      byIds(ids: $ids, type: CompleteFlightInstance) {
        __typename
        ...CompleteFlightInstanceFields
      }
    }
  }
  ${CompleteFlightInstanceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCompleteFlightInstanceByIdsGQL extends Apollo.Query<
  FetchCompleteFlightInstanceByIdsQuery,
  FetchCompleteFlightInstanceByIdsQueryVariables
> {
  document = FetchCompleteFlightInstanceByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchControlZoneByIdDocument = gql`
  query FetchControlZoneById($id: ID!) {
    controlZone: entities {
      byId(id: $id, type: ControlZone) {
        __typename
        ...ControlZoneFields
      }
    }
  }
  ${ControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchControlZoneByIdGQL extends Apollo.Query<
  FetchControlZoneByIdQuery,
  FetchControlZoneByIdQueryVariables
> {
  document = FetchControlZoneByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchControlZoneByIdsDocument = gql`
  query FetchControlZoneByIds($ids: [ID!]!) {
    controlZone: entities {
      byIds(ids: $ids, type: ControlZone) {
        __typename
        ...ControlZoneFields
      }
    }
  }
  ${ControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchControlZoneByIdsGQL extends Apollo.Query<
  FetchControlZoneByIdsQuery,
  FetchControlZoneByIdsQueryVariables
> {
  document = FetchControlZoneByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDepartmentByIdDocument = gql`
  query FetchDepartmentById($id: ID!) {
    department: entities {
      byId(id: $id, type: Department) {
        __typename
        ...DepartmentFields
      }
    }
  }
  ${DepartmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDepartmentByIdGQL extends Apollo.Query<
  FetchDepartmentByIdQuery,
  FetchDepartmentByIdQueryVariables
> {
  document = FetchDepartmentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDepartmentByIdsDocument = gql`
  query FetchDepartmentByIds($ids: [ID!]!) {
    department: entities {
      byIds(ids: $ids, type: Department) {
        __typename
        ...DepartmentFields
      }
    }
  }
  ${DepartmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchDepartmentByIdsGQL extends Apollo.Query<
  FetchDepartmentByIdsQuery,
  FetchDepartmentByIdsQueryVariables
> {
  document = FetchDepartmentByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEntityCapabilityByIdDocument = gql`
  query FetchEntityCapabilityById($id: ID!) {
    entityCapability: entities {
      byId(id: $id, type: EntityCapability) {
        __typename
        ...EntityCapabilityFields
      }
    }
  }
  ${EntityCapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEntityCapabilityByIdGQL extends Apollo.Query<
  FetchEntityCapabilityByIdQuery,
  FetchEntityCapabilityByIdQueryVariables
> {
  document = FetchEntityCapabilityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEntityCapabilityByIdsDocument = gql`
  query FetchEntityCapabilityByIds($ids: [ID!]!) {
    entityCapability: entities {
      byIds(ids: $ids, type: EntityCapability) {
        __typename
        ...EntityCapabilityFields
      }
    }
  }
  ${EntityCapabilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchEntityCapabilityByIdsGQL extends Apollo.Query<
  FetchEntityCapabilityByIdsQuery,
  FetchEntityCapabilityByIdsQueryVariables
> {
  document = FetchEntityCapabilityByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalReferenceByIdDocument = gql`
  query FetchExternalReferenceById($id: ID!) {
    externalReference: entities {
      byId(id: $id, type: ExternalReference) {
        __typename
        ...ExternalReferenceFields
      }
    }
  }
  ${ExternalReferenceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalReferenceByIdGQL extends Apollo.Query<
  FetchExternalReferenceByIdQuery,
  FetchExternalReferenceByIdQueryVariables
> {
  document = FetchExternalReferenceByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchExternalReferenceByIdsDocument = gql`
  query FetchExternalReferenceByIds($ids: [ID!]!) {
    externalReference: entities {
      byIds(ids: $ids, type: ExternalReference) {
        __typename
        ...ExternalReferenceFields
      }
    }
  }
  ${ExternalReferenceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchExternalReferenceByIdsGQL extends Apollo.Query<
  FetchExternalReferenceByIdsQuery,
  FetchExternalReferenceByIdsQueryVariables
> {
  document = FetchExternalReferenceByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFboByIdDocument = gql`
  query FetchFboById($id: ID!) {
    fbo: entities {
      byId(id: $id, type: Fbo) {
        __typename
        ...FboFields
      }
    }
  }
  ${FboFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFboByIdGQL extends Apollo.Query<FetchFboByIdQuery, FetchFboByIdQueryVariables> {
  document = FetchFboByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFboByIdsDocument = gql`
  query FetchFboByIds($ids: [ID!]!) {
    fbo: entities {
      byIds(ids: $ids, type: Fbo) {
        __typename
        ...FboFields
      }
    }
  }
  ${FboFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFboByIdsGQL extends Apollo.Query<
  FetchFboByIdsQuery,
  FetchFboByIdsQueryVariables
> {
  document = FetchFboByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFuelTankByIdDocument = gql`
  query FetchFuelTankById($id: ID!) {
    fuelTank: entities {
      byId(id: $id, type: FuelTank) {
        __typename
        ...FuelTankFields
      }
    }
  }
  ${FuelTankFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFuelTankByIdGQL extends Apollo.Query<
  FetchFuelTankByIdQuery,
  FetchFuelTankByIdQueryVariables
> {
  document = FetchFuelTankByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchFuelTankByIdsDocument = gql`
  query FetchFuelTankByIds($ids: [ID!]!) {
    fuelTank: entities {
      byIds(ids: $ids, type: FuelTank) {
        __typename
        ...FuelTankFields
      }
    }
  }
  ${FuelTankFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchFuelTankByIdsGQL extends Apollo.Query<
  FetchFuelTankByIdsQuery,
  FetchFuelTankByIdsQueryVariables
> {
  document = FetchFuelTankByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLocationByIdDocument = gql`
  query FetchLocationById($id: ID!) {
    location: entities {
      byId(id: $id, type: Location) {
        __typename
        ...LocationFields
      }
    }
  }
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLocationByIdGQL extends Apollo.Query<
  FetchLocationByIdQuery,
  FetchLocationByIdQueryVariables
> {
  document = FetchLocationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchLocationByIdsDocument = gql`
  query FetchLocationByIds($ids: [ID!]!) {
    location: entities {
      byIds(ids: $ids, type: Location) {
        __typename
        ...LocationFields
      }
    }
  }
  ${LocationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchLocationByIdsGQL extends Apollo.Query<
  FetchLocationByIdsQuery,
  FetchLocationByIdsQueryVariables
> {
  document = FetchLocationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMaintenanceFacilityByIdDocument = gql`
  query FetchMaintenanceFacilityById($id: ID!) {
    maintenanceFacility: entities {
      byId(id: $id, type: MaintenanceFacility) {
        __typename
        ...MaintenanceFacilityFields
      }
    }
  }
  ${MaintenanceFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMaintenanceFacilityByIdGQL extends Apollo.Query<
  FetchMaintenanceFacilityByIdQuery,
  FetchMaintenanceFacilityByIdQueryVariables
> {
  document = FetchMaintenanceFacilityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMaintenanceFacilityByIdsDocument = gql`
  query FetchMaintenanceFacilityByIds($ids: [ID!]!) {
    maintenanceFacility: entities {
      byIds(ids: $ids, type: MaintenanceFacility) {
        __typename
        ...MaintenanceFacilityFields
      }
    }
  }
  ${MaintenanceFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMaintenanceFacilityByIdsGQL extends Apollo.Query<
  FetchMaintenanceFacilityByIdsQuery,
  FetchMaintenanceFacilityByIdsQueryVariables
> {
  document = FetchMaintenanceFacilityByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityContactByIdDocument = gql`
  query FetchMedicalFacilityContactById($id: ID!) {
    medicalFacilityContact: entities {
      byId(id: $id, type: MedicalFacilityContact) {
        __typename
        ...MedicalFacilityContactFields
      }
    }
  }
  ${MedicalFacilityContactFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityContactByIdGQL extends Apollo.Query<
  FetchMedicalFacilityContactByIdQuery,
  FetchMedicalFacilityContactByIdQueryVariables
> {
  document = FetchMedicalFacilityContactByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityContactByIdsDocument = gql`
  query FetchMedicalFacilityContactByIds($ids: [ID!]!) {
    medicalFacilityContact: entities {
      byIds(ids: $ids, type: MedicalFacilityContact) {
        __typename
        ...MedicalFacilityContactFields
      }
    }
  }
  ${MedicalFacilityContactFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityContactByIdsGQL extends Apollo.Query<
  FetchMedicalFacilityContactByIdsQuery,
  FetchMedicalFacilityContactByIdsQueryVariables
> {
  document = FetchMedicalFacilityContactByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityByIdDocument = gql`
  query FetchMedicalFacilityById($id: ID!) {
    medicalFacility: entities {
      byId(id: $id, type: MedicalFacility) {
        __typename
        ...MedicalFacilityFields
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityByIdGQL extends Apollo.Query<
  FetchMedicalFacilityByIdQuery,
  FetchMedicalFacilityByIdQueryVariables
> {
  document = FetchMedicalFacilityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityByIdsDocument = gql`
  query FetchMedicalFacilityByIds($ids: [ID!]!) {
    medicalFacility: entities {
      byIds(ids: $ids, type: MedicalFacility) {
        __typename
        ...MedicalFacilityFields
      }
    }
  }
  ${MedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityByIdsGQL extends Apollo.Query<
  FetchMedicalFacilityByIdsQuery,
  FetchMedicalFacilityByIdsQueryVariables
> {
  document = FetchMedicalFacilityByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityPhysicianByIdDocument = gql`
  query FetchMedicalFacilityPhysicianById($id: ID!) {
    medicalFacilityPhysician: entities {
      byId(id: $id, type: MedicalFacilityPhysician) {
        __typename
        ...MedicalFacilityPhysicianFields
      }
    }
  }
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityPhysicianByIdGQL extends Apollo.Query<
  FetchMedicalFacilityPhysicianByIdQuery,
  FetchMedicalFacilityPhysicianByIdQueryVariables
> {
  document = FetchMedicalFacilityPhysicianByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityPhysicianByIdsDocument = gql`
  query FetchMedicalFacilityPhysicianByIds($ids: [ID!]!) {
    medicalFacilityPhysician: entities {
      byIds(ids: $ids, type: MedicalFacilityPhysician) {
        __typename
        ...MedicalFacilityPhysicianFields
      }
    }
  }
  ${MedicalFacilityPhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityPhysicianByIdsGQL extends Apollo.Query<
  FetchMedicalFacilityPhysicianByIdsQuery,
  FetchMedicalFacilityPhysicianByIdsQueryVariables
> {
  document = FetchMedicalFacilityPhysicianByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityUnitByIdDocument = gql`
  query FetchMedicalFacilityUnitById($id: ID!) {
    medicalFacilityUnit: entities {
      byId(id: $id, type: MedicalFacilityUnit) {
        __typename
        ...MedicalFacilityUnitFields
      }
    }
  }
  ${MedicalFacilityUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityUnitByIdGQL extends Apollo.Query<
  FetchMedicalFacilityUnitByIdQuery,
  FetchMedicalFacilityUnitByIdQueryVariables
> {
  document = FetchMedicalFacilityUnitByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalFacilityUnitByIdsDocument = gql`
  query FetchMedicalFacilityUnitByIds($ids: [ID!]!) {
    medicalFacilityUnit: entities {
      byIds(ids: $ids, type: MedicalFacilityUnit) {
        __typename
        ...MedicalFacilityUnitFields
      }
    }
  }
  ${MedicalFacilityUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalFacilityUnitByIdsGQL extends Apollo.Query<
  FetchMedicalFacilityUnitByIdsQuery,
  FetchMedicalFacilityUnitByIdsQueryVariables
> {
  document = FetchMedicalFacilityUnitByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalUnitByIdDocument = gql`
  query FetchMedicalUnitById($id: ID!) {
    medicalUnit: entities {
      byId(id: $id, type: MedicalUnit) {
        __typename
        ...MedicalUnitFields
      }
    }
  }
  ${MedicalUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalUnitByIdGQL extends Apollo.Query<
  FetchMedicalUnitByIdQuery,
  FetchMedicalUnitByIdQueryVariables
> {
  document = FetchMedicalUnitByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchMedicalUnitByIdsDocument = gql`
  query FetchMedicalUnitByIds($ids: [ID!]!) {
    medicalUnit: entities {
      byIds(ids: $ids, type: MedicalUnit) {
        __typename
        ...MedicalUnitFields
      }
    }
  }
  ${MedicalUnitFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchMedicalUnitByIdsGQL extends Apollo.Query<
  FetchMedicalUnitByIdsQuery,
  FetchMedicalUnitByIdsQueryVariables
> {
  document = FetchMedicalUnitByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceQARReasonByIdDocument = gql`
  query FetchOutOfServiceQARReasonById($id: ID!) {
    outOfServiceQARReason: entities {
      byId(id: $id, type: OutOfServiceQARReason) {
        __typename
        ...OutOfServiceQARReasonFields
      }
    }
  }
  ${OutOfServiceQARReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceQARReasonByIdGQL extends Apollo.Query<
  FetchOutOfServiceQARReasonByIdQuery,
  FetchOutOfServiceQARReasonByIdQueryVariables
> {
  document = FetchOutOfServiceQARReasonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOutOfServiceQARReasonByIdsDocument = gql`
  query FetchOutOfServiceQARReasonByIds($ids: [ID!]!) {
    outOfServiceQARReason: entities {
      byIds(ids: $ids, type: OutOfServiceQARReason) {
        __typename
        ...OutOfServiceQARReasonFields
      }
    }
  }
  ${OutOfServiceQARReasonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOutOfServiceQARReasonByIdsGQL extends Apollo.Query<
  FetchOutOfServiceQARReasonByIdsQuery,
  FetchOutOfServiceQARReasonByIdsQueryVariables
> {
  document = FetchOutOfServiceQARReasonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPersonByIdDocument = gql`
  query FetchPersonById($id: ID!) {
    person: entities {
      byId(id: $id, type: Person) {
        __typename
        ...PersonFields
      }
    }
  }
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPersonByIdGQL extends Apollo.Query<
  FetchPersonByIdQuery,
  FetchPersonByIdQueryVariables
> {
  document = FetchPersonByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPersonByIdsDocument = gql`
  query FetchPersonByIds($ids: [ID!]!) {
    person: entities {
      byIds(ids: $ids, type: Person) {
        __typename
        ...PersonFields
      }
    }
  }
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPersonByIdsGQL extends Apollo.Query<
  FetchPersonByIdsQuery,
  FetchPersonByIdsQueryVariables
> {
  document = FetchPersonByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPhysicianByIdDocument = gql`
  query FetchPhysicianById($id: ID!) {
    physician: entities {
      byId(id: $id, type: Physician) {
        __typename
        ...PhysicianFields
      }
    }
  }
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPhysicianByIdGQL extends Apollo.Query<
  FetchPhysicianByIdQuery,
  FetchPhysicianByIdQueryVariables
> {
  document = FetchPhysicianByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPhysicianByIdsDocument = gql`
  query FetchPhysicianByIds($ids: [ID!]!) {
    physician: entities {
      byIds(ids: $ids, type: Physician) {
        __typename
        ...PhysicianFields
      }
    }
  }
  ${PhysicianFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchPhysicianByIdsGQL extends Apollo.Query<
  FetchPhysicianByIdsQuery,
  FetchPhysicianByIdsQueryVariables
> {
  document = FetchPhysicianByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchProgramBaseByIdDocument = gql`
  query FetchProgramBaseById($id: ID!) {
    programBase: entities {
      byId(id: $id, type: ProgramBase) {
        __typename
        ...ProgramBaseFields
      }
    }
  }
  ${ProgramBaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchProgramBaseByIdGQL extends Apollo.Query<
  FetchProgramBaseByIdQuery,
  FetchProgramBaseByIdQueryVariables
> {
  document = FetchProgramBaseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchProgramBaseByIdsDocument = gql`
  query FetchProgramBaseByIds($ids: [ID!]!) {
    programBase: entities {
      byIds(ids: $ids, type: ProgramBase) {
        __typename
        ...ProgramBaseFields
      }
    }
  }
  ${ProgramBaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchProgramBaseByIdsGQL extends Apollo.Query<
  FetchProgramBaseByIdsQuery,
  FetchProgramBaseByIdsQueryVariables
> {
  document = FetchProgramBaseByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchProgramByIdDocument = gql`
  query FetchProgramById($id: ID!) {
    program: entities {
      byId(id: $id, type: Program) {
        __typename
        ...ProgramFields
      }
    }
  }
  ${ProgramFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchProgramByIdGQL extends Apollo.Query<
  FetchProgramByIdQuery,
  FetchProgramByIdQueryVariables
> {
  document = FetchProgramByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchProgramByIdsDocument = gql`
  query FetchProgramByIds($ids: [ID!]!) {
    program: entities {
      byIds(ids: $ids, type: Program) {
        __typename
        ...ProgramFields
      }
    }
  }
  ${ProgramFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchProgramByIdsGQL extends Apollo.Query<
  FetchProgramByIdsQuery,
  FetchProgramByIdsQueryVariables
> {
  document = FetchProgramByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRamcoVehicleConfigurationByIdDocument = gql`
  query FetchRamcoVehicleConfigurationById($id: ID!) {
    ramcoVehicleConfiguration: entities {
      byId(id: $id, type: RamcoVehicleConfiguration) {
        __typename
        ...RamcoVehicleConfigurationFields
      }
    }
  }
  ${RamcoVehicleConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRamcoVehicleConfigurationByIdGQL extends Apollo.Query<
  FetchRamcoVehicleConfigurationByIdQuery,
  FetchRamcoVehicleConfigurationByIdQueryVariables
> {
  document = FetchRamcoVehicleConfigurationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRamcoVehicleConfigurationByIdsDocument = gql`
  query FetchRamcoVehicleConfigurationByIds($ids: [ID!]!) {
    ramcoVehicleConfiguration: entities {
      byIds(ids: $ids, type: RamcoVehicleConfiguration) {
        __typename
        ...RamcoVehicleConfigurationFields
      }
    }
  }
  ${RamcoVehicleConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRamcoVehicleConfigurationByIdsGQL extends Apollo.Query<
  FetchRamcoVehicleConfigurationByIdsQuery,
  FetchRamcoVehicleConfigurationByIdsQueryVariables
> {
  document = FetchRamcoVehicleConfigurationByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRegionBaseByIdDocument = gql`
  query FetchRegionBaseById($id: ID!) {
    regionBase: entities {
      byId(id: $id, type: RegionBase) {
        __typename
        ...RegionBaseFields
      }
    }
  }
  ${RegionBaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRegionBaseByIdGQL extends Apollo.Query<
  FetchRegionBaseByIdQuery,
  FetchRegionBaseByIdQueryVariables
> {
  document = FetchRegionBaseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRegionBaseByIdsDocument = gql`
  query FetchRegionBaseByIds($ids: [ID!]!) {
    regionBase: entities {
      byIds(ids: $ids, type: RegionBase) {
        __typename
        ...RegionBaseFields
      }
    }
  }
  ${RegionBaseFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRegionBaseByIdsGQL extends Apollo.Query<
  FetchRegionBaseByIdsQuery,
  FetchRegionBaseByIdsQueryVariables
> {
  document = FetchRegionBaseByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRegionByIdDocument = gql`
  query FetchRegionById($id: ID!) {
    region: entities {
      byId(id: $id, type: Region) {
        __typename
        ...RegionFields
      }
    }
  }
  ${RegionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRegionByIdGQL extends Apollo.Query<
  FetchRegionByIdQuery,
  FetchRegionByIdQueryVariables
> {
  document = FetchRegionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRegionByIdsDocument = gql`
  query FetchRegionByIds($ids: [ID!]!) {
    region: entities {
      byIds(ids: $ids, type: Region) {
        __typename
        ...RegionFields
      }
    }
  }
  ${RegionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRegionByIdsGQL extends Apollo.Query<
  FetchRegionByIdsQuery,
  FetchRegionByIdsQueryVariables
> {
  document = FetchRegionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRegionGroupByIdDocument = gql`
  query FetchRegionGroupById($id: ID!) {
    regionGroup: entities {
      byId(id: $id, type: RegionGroup) {
        __typename
        ...RegionGroupFields
      }
    }
  }
  ${RegionGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRegionGroupByIdGQL extends Apollo.Query<
  FetchRegionGroupByIdQuery,
  FetchRegionGroupByIdQueryVariables
> {
  document = FetchRegionGroupByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchRegionGroupByIdsDocument = gql`
  query FetchRegionGroupByIds($ids: [ID!]!) {
    regionGroup: entities {
      byIds(ids: $ids, type: RegionGroup) {
        __typename
        ...RegionGroupFields
      }
    }
  }
  ${RegionGroupFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchRegionGroupByIdsGQL extends Apollo.Query<
  FetchRegionGroupByIdsQuery,
  FetchRegionGroupByIdsQueryVariables
> {
  document = FetchRegionGroupByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchReleaseNoteByIdDocument = gql`
  query FetchReleaseNoteById($id: ID!) {
    releaseNote: entities {
      byId(id: $id, type: ReleaseNote) {
        __typename
        ...ReleaseNoteFields
      }
    }
  }
  ${ReleaseNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchReleaseNoteByIdGQL extends Apollo.Query<
  FetchReleaseNoteByIdQuery,
  FetchReleaseNoteByIdQueryVariables
> {
  document = FetchReleaseNoteByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchReleaseNoteByIdsDocument = gql`
  query FetchReleaseNoteByIds($ids: [ID!]!) {
    releaseNote: entities {
      byIds(ids: $ids, type: ReleaseNote) {
        __typename
        ...ReleaseNoteFields
      }
    }
  }
  ${ReleaseNoteFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchReleaseNoteByIdsGQL extends Apollo.Query<
  FetchReleaseNoteByIdsQuery,
  FetchReleaseNoteByIdsQueryVariables
> {
  document = FetchReleaseNoteByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSpecialtyTeamByIdDocument = gql`
  query FetchSpecialtyTeamById($id: ID!) {
    specialtyTeam: entities {
      byId(id: $id, type: SpecialtyTeam) {
        __typename
        ...SpecialtyTeamFields
      }
    }
  }
  ${SpecialtyTeamFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSpecialtyTeamByIdGQL extends Apollo.Query<
  FetchSpecialtyTeamByIdQuery,
  FetchSpecialtyTeamByIdQueryVariables
> {
  document = FetchSpecialtyTeamByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSpecialtyTeamByIdsDocument = gql`
  query FetchSpecialtyTeamByIds($ids: [ID!]!) {
    specialtyTeam: entities {
      byIds(ids: $ids, type: SpecialtyTeam) {
        __typename
        ...SpecialtyTeamFields
      }
    }
  }
  ${SpecialtyTeamFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSpecialtyTeamByIdsGQL extends Apollo.Query<
  FetchSpecialtyTeamByIdsQuery,
  FetchSpecialtyTeamByIdsQueryVariables
> {
  document = FetchSpecialtyTeamByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSpecialtyTeamMemberByIdDocument = gql`
  query FetchSpecialtyTeamMemberById($id: ID!) {
    specialtyTeamMember: entities {
      byId(id: $id, type: SpecialtyTeamMember) {
        __typename
        ...SpecialtyTeamMemberFields
      }
    }
  }
  ${SpecialtyTeamMemberFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSpecialtyTeamMemberByIdGQL extends Apollo.Query<
  FetchSpecialtyTeamMemberByIdQuery,
  FetchSpecialtyTeamMemberByIdQueryVariables
> {
  document = FetchSpecialtyTeamMemberByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSpecialtyTeamMemberByIdsDocument = gql`
  query FetchSpecialtyTeamMemberByIds($ids: [ID!]!) {
    specialtyTeamMember: entities {
      byIds(ids: $ids, type: SpecialtyTeamMember) {
        __typename
        ...SpecialtyTeamMemberFields
      }
    }
  }
  ${SpecialtyTeamMemberFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSpecialtyTeamMemberByIdsGQL extends Apollo.Query<
  FetchSpecialtyTeamMemberByIdsQuery,
  FetchSpecialtyTeamMemberByIdsQueryVariables
> {
  document = FetchSpecialtyTeamMemberByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchStateByIdDocument = gql`
  query FetchStateById($id: ID!) {
    state: entities {
      byId(id: $id, type: State) {
        __typename
        ...StateFields
      }
    }
  }
  ${StateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchStateByIdGQL extends Apollo.Query<
  FetchStateByIdQuery,
  FetchStateByIdQueryVariables
> {
  document = FetchStateByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchStateByIdsDocument = gql`
  query FetchStateByIds($ids: [ID!]!) {
    state: entities {
      byIds(ids: $ids, type: State) {
        __typename
        ...StateFields
      }
    }
  }
  ${StateFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchStateByIdsGQL extends Apollo.Query<
  FetchStateByIdsQuery,
  FetchStateByIdsQueryVariables
> {
  document = FetchStateByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSupportRequestByIdDocument = gql`
  query FetchSupportRequestById($id: ID!) {
    supportRequest: entities {
      byId(id: $id, type: SupportRequest) {
        __typename
        ...SupportRequestFields
      }
    }
  }
  ${SupportRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSupportRequestByIdGQL extends Apollo.Query<
  FetchSupportRequestByIdQuery,
  FetchSupportRequestByIdQueryVariables
> {
  document = FetchSupportRequestByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchSupportRequestByIdsDocument = gql`
  query FetchSupportRequestByIds($ids: [ID!]!) {
    supportRequest: entities {
      byIds(ids: $ids, type: SupportRequest) {
        __typename
        ...SupportRequestFields
      }
    }
  }
  ${SupportRequestFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchSupportRequestByIdsGQL extends Apollo.Query<
  FetchSupportRequestByIdsQuery,
  FetchSupportRequestByIdsQueryVariables
> {
  document = FetchSupportRequestByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimezoneByIdDocument = gql`
  query FetchTimezoneById($id: ID!) {
    timezone: entities {
      byId(id: $id, type: Timezone) {
        __typename
        ...TimezoneFields
      }
    }
  }
  ${TimezoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimezoneByIdGQL extends Apollo.Query<
  FetchTimezoneByIdQuery,
  FetchTimezoneByIdQueryVariables
> {
  document = FetchTimezoneByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTimezoneByIdsDocument = gql`
  query FetchTimezoneByIds($ids: [ID!]!) {
    timezone: entities {
      byIds(ids: $ids, type: Timezone) {
        __typename
        ...TimezoneFields
      }
    }
  }
  ${TimezoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTimezoneByIdsGQL extends Apollo.Query<
  FetchTimezoneByIdsQuery,
  FetchTimezoneByIdsQueryVariables
> {
  document = FetchTimezoneByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransferCenterByIdDocument = gql`
  query FetchTransferCenterById($id: ID!) {
    transferCenter: entities {
      byId(id: $id, type: TransferCenter) {
        __typename
        ...TransferCenterFields
      }
    }
  }
  ${TransferCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransferCenterByIdGQL extends Apollo.Query<
  FetchTransferCenterByIdQuery,
  FetchTransferCenterByIdQueryVariables
> {
  document = FetchTransferCenterByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTransferCenterByIdsDocument = gql`
  query FetchTransferCenterByIds($ids: [ID!]!) {
    transferCenter: entities {
      byIds(ids: $ids, type: TransferCenter) {
        __typename
        ...TransferCenterFields
      }
    }
  }
  ${TransferCenterFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTransferCenterByIdsGQL extends Apollo.Query<
  FetchTransferCenterByIdsQuery,
  FetchTransferCenterByIdsQueryVariables
> {
  document = FetchTransferCenterByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserAgencyByIdDocument = gql`
  query FetchTrmUserAgencyById($id: ID!) {
    trmUserAgency: entities {
      byId(id: $id, type: TrmUserAgency) {
        __typename
        ...TrmUserAgencyFields
      }
    }
  }
  ${TrmUserAgencyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserAgencyByIdGQL extends Apollo.Query<
  FetchTrmUserAgencyByIdQuery,
  FetchTrmUserAgencyByIdQueryVariables
> {
  document = FetchTrmUserAgencyByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserAgencyByIdsDocument = gql`
  query FetchTrmUserAgencyByIds($ids: [ID!]!) {
    trmUserAgency: entities {
      byIds(ids: $ids, type: TrmUserAgency) {
        __typename
        ...TrmUserAgencyFields
      }
    }
  }
  ${TrmUserAgencyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserAgencyByIdsGQL extends Apollo.Query<
  FetchTrmUserAgencyByIdsQuery,
  FetchTrmUserAgencyByIdsQueryVariables
> {
  document = FetchTrmUserAgencyByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserByIdDocument = gql`
  query FetchTrmUserById($id: ID!) {
    trmUser: entities {
      byId(id: $id, type: TrmUser) {
        __typename
        ...TrmUserFields
      }
    }
  }
  ${TrmUserFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserByIdGQL extends Apollo.Query<
  FetchTrmUserByIdQuery,
  FetchTrmUserByIdQueryVariables
> {
  document = FetchTrmUserByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserByIdsDocument = gql`
  query FetchTrmUserByIds($ids: [ID!]!) {
    trmUser: entities {
      byIds(ids: $ids, type: TrmUser) {
        __typename
        ...TrmUserFields
      }
    }
  }
  ${TrmUserFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserByIdsGQL extends Apollo.Query<
  FetchTrmUserByIdsQuery,
  FetchTrmUserByIdsQueryVariables
> {
  document = FetchTrmUserByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserMedicalFacilityByIdDocument = gql`
  query FetchTrmUserMedicalFacilityById($id: ID!) {
    trmUserMedicalFacility: entities {
      byId(id: $id, type: TrmUserMedicalFacility) {
        __typename
        ...TrmUserMedicalFacilityFields
      }
    }
  }
  ${TrmUserMedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserMedicalFacilityByIdGQL extends Apollo.Query<
  FetchTrmUserMedicalFacilityByIdQuery,
  FetchTrmUserMedicalFacilityByIdQueryVariables
> {
  document = FetchTrmUserMedicalFacilityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserMedicalFacilityByIdsDocument = gql`
  query FetchTrmUserMedicalFacilityByIds($ids: [ID!]!) {
    trmUserMedicalFacility: entities {
      byIds(ids: $ids, type: TrmUserMedicalFacility) {
        __typename
        ...TrmUserMedicalFacilityFields
      }
    }
  }
  ${TrmUserMedicalFacilityFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserMedicalFacilityByIdsGQL extends Apollo.Query<
  FetchTrmUserMedicalFacilityByIdsQuery,
  FetchTrmUserMedicalFacilityByIdsQueryVariables
> {
  document = FetchTrmUserMedicalFacilityByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserProgramByIdDocument = gql`
  query FetchTrmUserProgramById($id: ID!) {
    trmUserProgram: entities {
      byId(id: $id, type: TrmUserProgram) {
        __typename
        ...TrmUserProgramFields
      }
    }
  }
  ${TrmUserProgramFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserProgramByIdGQL extends Apollo.Query<
  FetchTrmUserProgramByIdQuery,
  FetchTrmUserProgramByIdQueryVariables
> {
  document = FetchTrmUserProgramByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchTrmUserProgramByIdsDocument = gql`
  query FetchTrmUserProgramByIds($ids: [ID!]!) {
    trmUserProgram: entities {
      byIds(ids: $ids, type: TrmUserProgram) {
        __typename
        ...TrmUserProgramFields
      }
    }
  }
  ${TrmUserProgramFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchTrmUserProgramByIdsGQL extends Apollo.Query<
  FetchTrmUserProgramByIdsQuery,
  FetchTrmUserProgramByIdsQueryVariables
> {
  document = FetchTrmUserProgramByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleConfigurationClassByIdDocument = gql`
  query FetchVehicleConfigurationClassById($id: ID!) {
    vehicleConfigurationClass: entities {
      byId(id: $id, type: VehicleConfigurationClass) {
        __typename
        ...VehicleConfigurationClassFields
      }
    }
  }
  ${VehicleConfigurationClassFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleConfigurationClassByIdGQL extends Apollo.Query<
  FetchVehicleConfigurationClassByIdQuery,
  FetchVehicleConfigurationClassByIdQueryVariables
> {
  document = FetchVehicleConfigurationClassByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleConfigurationClassByIdsDocument = gql`
  query FetchVehicleConfigurationClassByIds($ids: [ID!]!) {
    vehicleConfigurationClass: entities {
      byIds(ids: $ids, type: VehicleConfigurationClass) {
        __typename
        ...VehicleConfigurationClassFields
      }
    }
  }
  ${VehicleConfigurationClassFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleConfigurationClassByIdsGQL extends Apollo.Query<
  FetchVehicleConfigurationClassByIdsQuery,
  FetchVehicleConfigurationClassByIdsQueryVariables
> {
  document = FetchVehicleConfigurationClassByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleControlZoneByIdDocument = gql`
  query FetchVehicleControlZoneById($id: ID!) {
    vehicleControlZone: entities {
      byId(id: $id, type: VehicleControlZone) {
        __typename
        ...VehicleControlZoneFields
      }
    }
  }
  ${VehicleControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleControlZoneByIdGQL extends Apollo.Query<
  FetchVehicleControlZoneByIdQuery,
  FetchVehicleControlZoneByIdQueryVariables
> {
  document = FetchVehicleControlZoneByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleControlZoneByIdsDocument = gql`
  query FetchVehicleControlZoneByIds($ids: [ID!]!) {
    vehicleControlZone: entities {
      byIds(ids: $ids, type: VehicleControlZone) {
        __typename
        ...VehicleControlZoneFields
      }
    }
  }
  ${VehicleControlZoneFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleControlZoneByIdsGQL extends Apollo.Query<
  FetchVehicleControlZoneByIdsQuery,
  FetchVehicleControlZoneByIdsQueryVariables
> {
  document = FetchVehicleControlZoneByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleByIdDocument = gql`
  query FetchVehicleById($id: ID!) {
    vehicle: entities {
      byId(id: $id, type: Vehicle) {
        __typename
        ...VehicleFields
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleByIdGQL extends Apollo.Query<
  FetchVehicleByIdQuery,
  FetchVehicleByIdQueryVariables
> {
  document = FetchVehicleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleByIdsDocument = gql`
  query FetchVehicleByIds($ids: [ID!]!) {
    vehicle: entities {
      byIds(ids: $ids, type: Vehicle) {
        __typename
        ...VehicleFields
      }
    }
  }
  ${VehicleFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleByIdsGQL extends Apollo.Query<
  FetchVehicleByIdsQuery,
  FetchVehicleByIdsQueryVariables
> {
  document = FetchVehicleByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleMaintenanceByIdDocument = gql`
  query FetchVehicleMaintenanceById($id: ID!) {
    vehicleMaintenance: entities {
      byId(id: $id, type: VehicleMaintenance) {
        __typename
        ...VehicleMaintenanceFields
      }
    }
  }
  ${VehicleMaintenanceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleMaintenanceByIdGQL extends Apollo.Query<
  FetchVehicleMaintenanceByIdQuery,
  FetchVehicleMaintenanceByIdQueryVariables
> {
  document = FetchVehicleMaintenanceByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleMaintenanceByIdsDocument = gql`
  query FetchVehicleMaintenanceByIds($ids: [ID!]!) {
    vehicleMaintenance: entities {
      byIds(ids: $ids, type: VehicleMaintenance) {
        __typename
        ...VehicleMaintenanceFields
      }
    }
  }
  ${VehicleMaintenanceFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleMaintenanceByIdsGQL extends Apollo.Query<
  FetchVehicleMaintenanceByIdsQuery,
  FetchVehicleMaintenanceByIdsQueryVariables
> {
  document = FetchVehicleMaintenanceByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleMakeByIdDocument = gql`
  query FetchVehicleMakeById($id: ID!) {
    vehicleMake: entities {
      byId(id: $id, type: VehicleMake) {
        __typename
        ...VehicleMakeFields
      }
    }
  }
  ${VehicleMakeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleMakeByIdGQL extends Apollo.Query<
  FetchVehicleMakeByIdQuery,
  FetchVehicleMakeByIdQueryVariables
> {
  document = FetchVehicleMakeByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleMakeByIdsDocument = gql`
  query FetchVehicleMakeByIds($ids: [ID!]!) {
    vehicleMake: entities {
      byIds(ids: $ids, type: VehicleMake) {
        __typename
        ...VehicleMakeFields
      }
    }
  }
  ${VehicleMakeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleMakeByIdsGQL extends Apollo.Query<
  FetchVehicleMakeByIdsQuery,
  FetchVehicleMakeByIdsQueryVariables
> {
  document = FetchVehicleMakeByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleModelByIdDocument = gql`
  query FetchVehicleModelById($id: ID!) {
    vehicleModel: entities {
      byId(id: $id, type: VehicleModel) {
        __typename
        ...VehicleModelFields
      }
    }
  }
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleModelByIdGQL extends Apollo.Query<
  FetchVehicleModelByIdQuery,
  FetchVehicleModelByIdQueryVariables
> {
  document = FetchVehicleModelByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleModelByIdsDocument = gql`
  query FetchVehicleModelByIds($ids: [ID!]!) {
    vehicleModel: entities {
      byIds(ids: $ids, type: VehicleModel) {
        __typename
        ...VehicleModelFields
      }
    }
  }
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleModelByIdsGQL extends Apollo.Query<
  FetchVehicleModelByIdsQuery,
  FetchVehicleModelByIdsQueryVariables
> {
  document = FetchVehicleModelByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleStateInspectionByIdDocument = gql`
  query FetchVehicleStateInspectionById($id: ID!) {
    vehicleStateInspection: entities {
      byId(id: $id, type: VehicleStateInspection) {
        __typename
        ...VehicleStateInspectionFields
      }
    }
  }
  ${VehicleStateInspectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleStateInspectionByIdGQL extends Apollo.Query<
  FetchVehicleStateInspectionByIdQuery,
  FetchVehicleStateInspectionByIdQueryVariables
> {
  document = FetchVehicleStateInspectionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchVehicleStateInspectionByIdsDocument = gql`
  query FetchVehicleStateInspectionByIds($ids: [ID!]!) {
    vehicleStateInspection: entities {
      byIds(ids: $ids, type: VehicleStateInspection) {
        __typename
        ...VehicleStateInspectionFields
      }
    }
  }
  ${VehicleStateInspectionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchVehicleStateInspectionByIdsGQL extends Apollo.Query<
  FetchVehicleStateInspectionByIdsQuery,
  FetchVehicleStateInspectionByIdsQueryVariables
> {
  document = FetchVehicleStateInspectionByIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsightsCardActivityDocument = gql`
  query InsightsCardActivity($personId: ID!) {
    people {
      byId(id: $personId) {
        accessibleItems {
          ...AccessibleItemFields
        }
      }
    }
  }
  ${AccessibleItemFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class InsightsCardActivityGQL extends Apollo.Query<
  InsightsCardActivityQuery,
  InsightsCardActivityQueryVariables
> {
  document = InsightsCardActivityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAllNotificationsDocument = gql`
  query GetAllNotifications($filter: NotificationFilter, $first: Int, $skip: Int) {
    notifications {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...NotificationFields
        }
        meta {
          total
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllNotificationsGQL extends Apollo.Query<
  GetAllNotificationsQuery,
  GetAllNotificationsQueryVariables
> {
  document = GetAllNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRamcoVehicleConfigurationByTailNumberDocument = gql`
  query GetRamcoVehicleConfigurationByTailNumber($tailNumber: String!) {
    ramcoVehicleConfigurations {
      byTailNumber(tailNumber: $tailNumber) {
        ...RamcoVehicleConfigurationFields
      }
    }
  }
  ${RamcoVehicleConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetRamcoVehicleConfigurationByTailNumberGQL extends Apollo.Query<
  GetRamcoVehicleConfigurationByTailNumberQuery,
  GetRamcoVehicleConfigurationByTailNumberQueryVariables
> {
  document = GetRamcoVehicleConfigurationByTailNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRamcoVehicleConfigurationByVehicleIdDocument = gql`
  query GetRamcoVehicleConfigurationByVehicleId($vehicleId: ID!) {
    vehicles {
      byId(id: $vehicleId) {
        ramco {
          ...RamcoVehicleConfigurationFields
        }
      }
    }
  }
  ${RamcoVehicleConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetRamcoVehicleConfigurationByVehicleIdGQL extends Apollo.Query<
  GetRamcoVehicleConfigurationByVehicleIdQuery,
  GetRamcoVehicleConfigurationByVehicleIdQueryVariables
> {
  document = GetRamcoVehicleConfigurationByVehicleIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUnitNotesByUnitDocument = gql`
  query GetUnitNotesByUnit($unitId: ID!) {
    units {
      byId(id: $unitId) {
        notes {
          ...UnitNoteFields
          author {
            ...PersonFields
          }
        }
      }
    }
  }
  ${UnitNoteFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUnitNotesByUnitGQL extends Apollo.Query<
  GetUnitNotesByUnitQuery,
  GetUnitNotesByUnitQueryVariables
> {
  document = GetUnitNotesByUnitDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserContextResolverDocument = gql`
  query UserContextResolver($baseFilter: BaseFilter, $programFilter: ProgramFilter) {
    bases {
      all(filter: $baseFilter) {
        items {
          ...BaseFields
        }
      }
    }
    programs {
      all(filter: $programFilter) {
        items {
          ...ProgramFields
        }
      }
    }
  }
  ${BaseFieldsFragmentDoc}
  ${ProgramFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserContextResolverGQL extends Apollo.Query<
  UserContextResolverQuery,
  UserContextResolverQueryVariables
> {
  document = UserContextResolverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserByEmailDocument = gql`
  query GetUserByEmail($email: String!) {
    people {
      byEmail(email: $email) {
        ...PersonFields
        company {
          ...CompanyFields
        }
      }
    }
  }
  ${PersonFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserByEmailGQL extends Apollo.Query<
  GetUserByEmailQuery,
  GetUserByEmailQueryVariables
> {
  document = GetUserByEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetVehicleConfigurationClassesDocument = gql`
  query GetVehicleConfigurationClasses(
    $filter: VehicleConfigurationClassFilter
    $skip: Int
    $first: Int
  ) {
    vehicleConfigurationClasses {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...VehicleConfigurationClassFields
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleConfigurationClassFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetVehicleConfigurationClassesGQL extends Apollo.Query<
  GetVehicleConfigurationClassesQuery,
  GetVehicleConfigurationClassesQueryVariables
> {
  document = GetVehicleConfigurationClassesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetVehicleModelsDocument = gql`
  query GetVehicleModels($filter: VehicleModelFilter, $first: Int, $skip: Int) {
    vehicleModels {
      all(filter: $filter, first: $first, skip: $skip) {
        items {
          ...VehicleModelFields
        }
        meta {
          total
        }
      }
    }
  }
  ${VehicleModelFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetVehicleModelsGQL extends Apollo.Query<
  GetVehicleModelsQuery,
  GetVehicleModelsQueryVariables
> {
  document = GetVehicleModelsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardByCardNumberDocument = gql`
  query FetchCardByCardNumber($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        ...CardFields
      }
    }
  }
  ${CardFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardByCardNumberGQL extends Apollo.Query<
  FetchCardByCardNumberQuery,
  FetchCardByCardNumberQueryVariables
> {
  document = FetchCardByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardEntitiesDocument = gql`
  query FetchCardEntities($cardNumber: ID!) {
    cards {
      byCardNumber(cardNumber: $cardNumber) {
        ...CardFields
        activeAlerts {
          ...ActiveAlertFields
        }
        request {
          ...RequestFields
          transportOfferOptions {
            ...TransportOfferOptionFields
          }
          requester {
            ...RequesterFields
          }
          locations {
            ...RequestLocationFields
            rendezvousRequests {
              ...RendezvousRequestFields
              agencyLocation {
                ...AgencyLocationFields
              }
              cardLinks {
                ...CardLinkFields
              }
            }
            diversionReason {
              ...DiversionReasonFields
            }
          }
          patients {
            ...RequestPatientFields
            transferReason {
              ...TransferReasonFields
            }
          }
          receivingFacilityRequests {
            ...ReceivingFacilityRequestFields
          }
        }
        operation {
          ...OperationFields
          unit {
            ...UnitContext
          }
          trips {
            ...TripFields
            estimatedDurations {
              ...EstimatedDurationFields
            }
            vehicle {
              ...VehicleFields
              vehicleDispositions {
                ...VehicleDispositionFields
              }
            }
            agency {
              ...AgencyFields
            }
            etas {
              ...EtaFields
            }
            positionReports {
              ...PositionReportFields
            }
            flightFollowingReports {
              ...FlightFollowingReportFields
            }
            passengers {
              ...TripPassengerFields
              manifestEntries {
                ...ManifestEntryFields
              }
            }
            legs {
              ...TripLegFields
            }
          }
        }
        questionnaireResponses {
          ...QuestionnaireResponseFields
          questionnaireQuestionResponses {
            ...QuestionnaireQuestionResponseFields
            questionnaireQuestionResponseNotes {
              ...QuestionnaireQuestionResponseNoteFields
            }
          }
          questionnaire {
            ...QuestionnaireFields
          }
        }
        medicalControlContactLogEntries {
          ...MedicalControlContactLogEntryFields
          person {
            ...PersonFields
          }
        }
      }
    }
  }
  ${CardFieldsFragmentDoc}
  ${ActiveAlertFieldsFragmentDoc}
  ${RequestFieldsFragmentDoc}
  ${TransportOfferOptionFieldsFragmentDoc}
  ${RequesterFieldsFragmentDoc}
  ${RequestLocationFieldsFragmentDoc}
  ${RendezvousRequestFieldsFragmentDoc}
  ${AgencyLocationFieldsFragmentDoc}
  ${CardLinkFieldsFragmentDoc}
  ${DiversionReasonFieldsFragmentDoc}
  ${RequestPatientFieldsFragmentDoc}
  ${TransferReasonFieldsFragmentDoc}
  ${ReceivingFacilityRequestFieldsFragmentDoc}
  ${OperationFieldsFragmentDoc}
  ${UnitContextFragmentDoc}
  ${TripFieldsFragmentDoc}
  ${EstimatedDurationFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${AgencyFieldsFragmentDoc}
  ${EtaFieldsFragmentDoc}
  ${PositionReportFieldsFragmentDoc}
  ${FlightFollowingReportFieldsFragmentDoc}
  ${TripPassengerFieldsFragmentDoc}
  ${ManifestEntryFieldsFragmentDoc}
  ${TripLegFieldsFragmentDoc}
  ${QuestionnaireResponseFieldsFragmentDoc}
  ${QuestionnaireQuestionResponseFieldsFragmentDoc}
  ${QuestionnaireQuestionResponseNoteFieldsFragmentDoc}
  ${QuestionnaireFieldsFragmentDoc}
  ${MedicalControlContactLogEntryFieldsFragmentDoc}
  ${PersonFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardEntitiesGQL extends Apollo.Query<
  FetchCardEntitiesQuery,
  FetchCardEntitiesQueryVariables
> {
  document = FetchCardEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchOpsSummaryDataDocument = gql`
  query FetchOpsSummaryData(
    $dispatchCompanyId: ID
    $communicationCenterId: ID
    $regionId: ID
    $controlZoneId: ID
    $controlZoneCompanyId: ID
    $includeVehicleSummaries: Boolean! = true
    $includeVehicles: Boolean! = false
    $includeCards: Boolean! = true
    $includeUnits: Boolean! = true
    $includeHiddenUnits: Boolean! = true
    $includeSpareUnits: Boolean! = true
    $includeThirdPartyUnits: Boolean! = true
    $includeExternalSystemUnits: Boolean! = true
    $includeTcsManagedUnits: Boolean! = true
    $fetchNested: Boolean! = true
    $fetchDeep: Boolean! = false
    $excludeCurrentDispatchCompany: Boolean! = false
    $summariesFetchAfterDate: DateTime = null
    $oosEventsFetchAfterDate: DateTime = null
  ) {
    outOfServiceEvents @skip(if: $excludeCurrentDispatchCompany) {
      all(filter: { active: true, afterDate: $oosEventsFetchAfterDate }) {
        meta {
          total
        }
        items {
          ...OutOfServiceEventFields
        }
      }
    }
    paipEvents {
      all(filter: { active: true, companyId: $dispatchCompanyId }) {
        items {
          ...PaipEventFields
        }
      }
    }
    vehicles {
      all(filter: { controlZoneId: $controlZoneId, controlZoneCompanyId: $controlZoneCompanyId })
        @include(if: $includeVehicles) {
        items {
          ...VehicleFields
        }
      }
      summaries(
        filter: {
          controlZoneId: $controlZoneId
          controlZoneCompanyId: $controlZoneCompanyId
          companyId: $dispatchCompanyId
          communicationCenterId: $communicationCenterId
          regionId: $regionId
          excludeCurrentDispatchCompany: $excludeCurrentDispatchCompany
          afterDate: $summariesFetchAfterDate
        }
      ) @include(if: $includeVehicleSummaries) {
        items {
          ...VehicleSummaryFields
          currentCardSummary @include(if: $fetchNested) {
            ...CardSummaryFields
          }
        }
        meta {
          total
        }
      }
    }
    cards @include(if: $includeCards) {
      summaries(
        filter: {
          controlZoneId: $controlZoneId
          controlZoneCompanyId: $controlZoneCompanyId
          companyId: $dispatchCompanyId
          communicationCenterId: $communicationCenterId
          regionId: $regionId
          afterDate: $summariesFetchAfterDate
        }
      ) {
        items {
          ...CardSummaryFields
          unitSummary @include(if: $fetchNested) {
            ...UnitSummaryFields
          }
        }
        meta {
          total
        }
      }
    }
    units @include(if: $includeUnits) {
      summaries(
        filter: {
          controlZoneId: $controlZoneId
          controlZoneCompanyId: $controlZoneCompanyId
          companyId: $dispatchCompanyId
          communicationCenterId: $communicationCenterId
          regionId: $regionId
          includeHidden: $includeHiddenUnits
          includeSpare: $includeSpareUnits
          includeThirdParty: $includeThirdPartyUnits
          includeExternalSystem: $includeExternalSystemUnits
          tcsManagedUnits: $includeTcsManagedUnits
          afterDate: $summariesFetchAfterDate
        }
      ) {
        items {
          ...UnitSummaryFields
          vehicleSummary @include(if: $fetchNested) {
            ...VehicleSummaryFields
            currentCardSummary @include(if: $fetchDeep) {
              ...CardSummaryFields
            }
          }
        }
        meta {
          total
        }
      }
    }
  }
  ${OutOfServiceEventFieldsFragmentDoc}
  ${PaipEventFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleSummaryFieldsFragmentDoc}
  ${CardSummaryFieldsFragmentDoc}
  ${UnitSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchOpsSummaryDataGQL extends Apollo.Query<
  FetchOpsSummaryDataQuery,
  FetchOpsSummaryDataQueryVariables
> {
  document = FetchOpsSummaryDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardLinksDocument = gql`
  query FetchCardLinks($filter: CardLinkFilter, $skip: Int, $first: Int) {
    cardLinks {
      all(filter: $filter, skip: $skip, first: $first) {
        items {
          ...CardLinkFields
        }
        meta {
          total
        }
      }
    }
  }
  ${CardLinkFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardLinksGQL extends Apollo.Query<
  FetchCardLinksQuery,
  FetchCardLinksQueryVariables
> {
  document = FetchCardLinksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardSummaryByCardNumberDocument = gql`
  query FetchCardSummaryByCardNumber($cardNumber: ID!) {
    cards {
      summaryByCardNumber(cardNumber: $cardNumber) {
        ...CardSummaryFields
      }
    }
  }
  ${CardSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardSummaryByCardNumberGQL extends Apollo.Query<
  FetchCardSummaryByCardNumberQuery,
  FetchCardSummaryByCardNumberQueryVariables
> {
  document = FetchCardSummaryByCardNumberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCardSummaryByCardIdDocument = gql`
  query FetchCardSummaryByCardId($cardId: ID!) {
    cards {
      summaryById(id: $cardId) {
        ...CardSummaryFields
      }
    }
  }
  ${CardSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FetchCardSummaryByCardIdGQL extends Apollo.Query<
  FetchCardSummaryByCardIdQuery,
  FetchCardSummaryByCardIdQueryVariables
> {
  document = FetchCardSummaryByCardIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CardUnitOverviewComponent_FetchCardEntitiesByCardIdDocument = gql`
  query CardUnitOverviewComponent_FetchCardEntitiesByCardId($cardId: ID!) {
    cards {
      byId(id: $cardId) {
        ...CardFields
        request {
          ...RequestFields
          locations {
            ...RequestLocationFields
          }
          patients {
            ...RequestPatientFields
          }
        }
        operation {
          ...OperationFields
          unit {
            ...UnitFields
          }
          trips {
            ...TripFields
            estimatedDurations {
              ...EstimatedDurationFields
            }
            vehicle {
              ...VehicleFields
              vehicleDispositions {
                ...VehicleDispositionFields
              }
            }
            passengers {
              ...TripPassengerFields
              manifestEntries {
                ...ManifestEntryFields
              }
            }
            legs {
              ...TripLegFields
            }
          }
        }
      }
    }
  }
  ${CardFieldsFragmentDoc}
  ${RequestFieldsFragmentDoc}
  ${RequestLocationFieldsFragmentDoc}
  ${RequestPatientFieldsFragmentDoc}
  ${OperationFieldsFragmentDoc}
  ${UnitFieldsFragmentDoc}
  ${TripFieldsFragmentDoc}
  ${EstimatedDurationFieldsFragmentDoc}
  ${VehicleFieldsFragmentDoc}
  ${VehicleDispositionFieldsFragmentDoc}
  ${TripPassengerFieldsFragmentDoc}
  ${ManifestEntryFieldsFragmentDoc}
  ${TripLegFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CardUnitOverviewComponent_FetchCardEntitiesByCardIdGQL extends Apollo.Query<
  CardUnitOverviewComponent_FetchCardEntitiesByCardIdQuery,
  CardUnitOverviewComponent_FetchCardEntitiesByCardIdQueryVariables
> {
  document = CardUnitOverviewComponent_FetchCardEntitiesByCardIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AttachmentsComponent_FetchAttachmentsDocument = gql`
  query AttachmentsComponent_FetchAttachments($entityId: ID!, $entityType: AttachmentEntityType!) {
    attachments {
      all(filter: { entityId: $entityId, entityType: $entityType }) {
        items {
          ...AttachmentFields
        }
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class AttachmentsComponent_FetchAttachmentsGQL extends Apollo.Query<
  AttachmentsComponent_FetchAttachmentsQuery,
  AttachmentsComponent_FetchAttachmentsQueryVariables
> {
  document = AttachmentsComponent_FetchAttachmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserDataContextService_FetchDocument = gql`
  query UserDataContextService_Fetch {
    ...UserDataContext
  }
  ${UserDataContextFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UserDataContextService_FetchGQL extends Apollo.Query<
  UserDataContextService_FetchQuery,
  UserDataContextService_FetchQueryVariables
> {
  document = UserDataContextService_FetchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LocationHazardsComponent_FetchLocationHazardsByLocationIdDocument = gql`
  query LocationHazardsComponent_FetchLocationHazardsByLocationId($locationId: ID!) {
    locationHazards {
      byLocationId(locationId: $locationId) {
        items {
          ...LocationHazardFields
          locationHazardAttachments {
            ...LocationHazardAttachmentFields
          }
        }
      }
    }
  }
  ${LocationHazardFieldsFragmentDoc}
  ${LocationHazardAttachmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class LocationHazardsComponent_FetchLocationHazardsByLocationIdGQL extends Apollo.Query<
  LocationHazardsComponent_FetchLocationHazardsByLocationIdQuery,
  LocationHazardsComponent_FetchLocationHazardsByLocationIdQueryVariables
> {
  document = LocationHazardsComponent_FetchLocationHazardsByLocationIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PollingService_FetchEntitiesDocument = gql`
  query PollingService_FetchEntities(
    $companyId: ID
    $companyIds: [ID!]
    $regionId: ID
    $userRoles: [UserRole!]
    $includeQuestionnaireResponses: Boolean! = true
    $includePassdownLogs: Boolean! = true
    $includeNotifications: Boolean! = true
    $includeSummaries: Boolean! = true
    $includeVehiclePositionSummaries: Boolean! = true
    $vehiclesFetchAfterDate: DateTime = null
    $unitsFetchAfterDate: DateTime = null
    $cardsFetchAfterDate: DateTime = null
    $vehiclePositionSummariesFetchAfterDate: DateTime = null
    $summariesFetchPolicy: FetchPolicy = Cache
  ) {
    questionnaireResponses @include(if: $includeQuestionnaireResponses) {
      all(
        filter: {
          companyId: $companyId
          questionnaireResponseStatuses: [AwaitingReview, Draft]
          userRoles: $userRoles
        }
      ) {
        meta {
          total
        }
      }
    }
    passdownLogs @include(if: $includePassdownLogs) {
      all(filter: { regionId: $regionId, unacknowledgedOnly: true }) {
        meta {
          total
        }
      }
    }
    notifications @include(if: $includeNotifications) {
      all(
        filter: {
          companyId: $companyId
          regionId: $regionId
          notificationStatuses: [AwaitingApproval, Failed]
          exceptCardStatuses: [Closed]
        }
      ) {
        items {
          ...NotificationFields
        }
        meta {
          total
        }
      }
    }
    units @include(if: $includeSummaries) {
      summaries(
        filter: {
          controlZoneId: null
          controlZoneCompanyId: null
          companyId: $companyId
          communicationCenterId: null
          regionId: $regionId
          includeHidden: null
          includeThirdParty: null
          includeExternalSystem: null
          tcsManagedUnits: null
          afterDate: $unitsFetchAfterDate
        }
        fetchpolicy: $summariesFetchPolicy
      ) {
        items {
          ...UnitSummaryFields
        }
        meta {
          total
        }
      }
    }
    vehicles @include(if: $includeSummaries) {
      summaries(
        filter: {
          controlZoneId: null
          controlZoneCompanyId: null
          companyId: $companyId
          communicationCenterId: null
          regionId: $regionId
          excludeCurrentDispatchCompany: null
          afterDate: $vehiclesFetchAfterDate
        }
        fetchpolicy: $summariesFetchPolicy
      ) {
        items {
          ...VehicleSummaryFields
        }
        meta {
          total
        }
      }
    }
    cards @include(if: $includeSummaries) {
      summaries(
        filter: {
          controlZoneId: null
          controlZoneCompanyId: null
          companyId: $companyId
          communicationCenterId: null
          regionId: $regionId
          afterDate: $cardsFetchAfterDate
        }
        fetchpolicy: $summariesFetchPolicy
      ) {
        items {
          ...CardSummaryFields
        }
        meta {
          total
        }
      }
    }
    vehiclePositionSummary @include(if: $includeVehiclePositionSummaries) {
      all(
        filter: {
          companyIdList: $companyIds
          positionReportSource: null
          afterDate: $vehiclePositionSummariesFetchAfterDate
        }
      ) {
        items {
          ...VehiclePositionSummaryFields
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
  ${UnitSummaryFieldsFragmentDoc}
  ${VehicleSummaryFieldsFragmentDoc}
  ${CardSummaryFieldsFragmentDoc}
  ${VehiclePositionSummaryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PollingService_FetchEntitiesGQL extends Apollo.Query<
  PollingService_FetchEntitiesQuery,
  PollingService_FetchEntitiesQueryVariables
> {
  document = PollingService_FetchEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
